const sD = [
  "result",
  "markdown",
  "table",
  "progress",
  "image",
  "rich",
  "unknown"
], l1 = {
  markdown: "ArtifactMarkdown",
  table: "ArtifactTable",
  result: "ArtifactResult",
  image: "ArtifactImage",
  progress: "ArtifactProgress",
  rich: "Artifact",
  unknown: "Artifact"
}, Eg = ["flow-run", "task-run"];
function oD(n) {
  return Eg.includes(n);
}
function Uu(n) {
  return Eg.includes(n.kind);
}
function u1(n) {
  return n.kind === "artifact";
}
function c1(n) {
  return n.kind === "artifacts";
}
function d1(n) {
  return n.kind === "state";
}
function f1(n) {
  return n.kind === "event";
}
function p1(n) {
  return n.kind === "events";
}
const aD = [
  "COMPLETED",
  "RUNNING",
  "SCHEDULED",
  "PENDING",
  "FAILED",
  "CANCELLED",
  "CANCELLING",
  "CRASHED",
  "PAUSED"
];
function hD(n) {
  return ["waterfall", "nearest-parent", "duration-sorted"].includes(n);
}
function lD(n) {
  return ["temporal", "dependency", "left-aligned"].includes(n);
}
const Sg = "nodes-container", m1 = "node-container", g1 = "edge-container", y1 = 1, Cg = 20, _1 = 200, v1 = 0.2, x1 = 0.2, w1 = 0.2, b1 = 0.1, Mg = 10, Ig = 4, Pg = 20, lf = 64, uD = 0.25, cD = 1, uf = 30, T1 = 260, Rg = 250, A1 = 1, E1 = 2, S1 = 3, C1 = 4, Dg = 0, Fg = 2, M1 = 1, I1 = 2, P1 = 3, Og = 4, za = 5;
var Ri = /* @__PURE__ */ ((n) => (n[n.WEBGL_LEGACY = 0] = "WEBGL_LEGACY", n[n.WEBGL = 1] = "WEBGL", n[n.WEBGL2 = 2] = "WEBGL2", n))(Ri || {}), Ng = /* @__PURE__ */ ((n) => (n[n.UNKNOWN = 0] = "UNKNOWN", n[n.WEBGL = 1] = "WEBGL", n[n.CANVAS = 2] = "CANVAS", n))(Ng || {}), Hu = /* @__PURE__ */ ((n) => (n[n.COLOR = 16384] = "COLOR", n[n.DEPTH = 256] = "DEPTH", n[n.STENCIL = 1024] = "STENCIL", n))(Hu || {}), gt = /* @__PURE__ */ ((n) => (n[n.NORMAL = 0] = "NORMAL", n[n.ADD = 1] = "ADD", n[n.MULTIPLY = 2] = "MULTIPLY", n[n.SCREEN = 3] = "SCREEN", n[n.OVERLAY = 4] = "OVERLAY", n[n.DARKEN = 5] = "DARKEN", n[n.LIGHTEN = 6] = "LIGHTEN", n[n.COLOR_DODGE = 7] = "COLOR_DODGE", n[n.COLOR_BURN = 8] = "COLOR_BURN", n[n.HARD_LIGHT = 9] = "HARD_LIGHT", n[n.SOFT_LIGHT = 10] = "SOFT_LIGHT", n[n.DIFFERENCE = 11] = "DIFFERENCE", n[n.EXCLUSION = 12] = "EXCLUSION", n[n.HUE = 13] = "HUE", n[n.SATURATION = 14] = "SATURATION", n[n.COLOR = 15] = "COLOR", n[n.LUMINOSITY = 16] = "LUMINOSITY", n[n.NORMAL_NPM = 17] = "NORMAL_NPM", n[n.ADD_NPM = 18] = "ADD_NPM", n[n.SCREEN_NPM = 19] = "SCREEN_NPM", n[n.NONE = 20] = "NONE", n[n.SRC_OVER = 0] = "SRC_OVER", n[n.SRC_IN = 21] = "SRC_IN", n[n.SRC_OUT = 22] = "SRC_OUT", n[n.SRC_ATOP = 23] = "SRC_ATOP", n[n.DST_OVER = 24] = "DST_OVER", n[n.DST_IN = 25] = "DST_IN", n[n.DST_OUT = 26] = "DST_OUT", n[n.DST_ATOP = 27] = "DST_ATOP", n[n.ERASE = 26] = "ERASE", n[n.SUBTRACT = 28] = "SUBTRACT", n[n.XOR = 29] = "XOR", n))(gt || {}), Pr = /* @__PURE__ */ ((n) => (n[n.POINTS = 0] = "POINTS", n[n.LINES = 1] = "LINES", n[n.LINE_LOOP = 2] = "LINE_LOOP", n[n.LINE_STRIP = 3] = "LINE_STRIP", n[n.TRIANGLES = 4] = "TRIANGLES", n[n.TRIANGLE_STRIP = 5] = "TRIANGLE_STRIP", n[n.TRIANGLE_FAN = 6] = "TRIANGLE_FAN", n))(Pr || {}), Q = /* @__PURE__ */ ((n) => (n[n.RGBA = 6408] = "RGBA", n[n.RGB = 6407] = "RGB", n[n.RG = 33319] = "RG", n[n.RED = 6403] = "RED", n[n.RGBA_INTEGER = 36249] = "RGBA_INTEGER", n[n.RGB_INTEGER = 36248] = "RGB_INTEGER", n[n.RG_INTEGER = 33320] = "RG_INTEGER", n[n.RED_INTEGER = 36244] = "RED_INTEGER", n[n.ALPHA = 6406] = "ALPHA", n[n.LUMINANCE = 6409] = "LUMINANCE", n[n.LUMINANCE_ALPHA = 6410] = "LUMINANCE_ALPHA", n[n.DEPTH_COMPONENT = 6402] = "DEPTH_COMPONENT", n[n.DEPTH_STENCIL = 34041] = "DEPTH_STENCIL", n))(Q || {}), ts = /* @__PURE__ */ ((n) => (n[n.TEXTURE_2D = 3553] = "TEXTURE_2D", n[n.TEXTURE_CUBE_MAP = 34067] = "TEXTURE_CUBE_MAP", n[n.TEXTURE_2D_ARRAY = 35866] = "TEXTURE_2D_ARRAY", n[n.TEXTURE_CUBE_MAP_POSITIVE_X = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X", n[n.TEXTURE_CUBE_MAP_NEGATIVE_X = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X", n[n.TEXTURE_CUBE_MAP_POSITIVE_Y = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y", n[n.TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y", n[n.TEXTURE_CUBE_MAP_POSITIVE_Z = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z", n[n.TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z", n))(ts || {}), pt = /* @__PURE__ */ ((n) => (n[n.UNSIGNED_BYTE = 5121] = "UNSIGNED_BYTE", n[n.UNSIGNED_SHORT = 5123] = "UNSIGNED_SHORT", n[n.UNSIGNED_SHORT_5_6_5 = 33635] = "UNSIGNED_SHORT_5_6_5", n[n.UNSIGNED_SHORT_4_4_4_4 = 32819] = "UNSIGNED_SHORT_4_4_4_4", n[n.UNSIGNED_SHORT_5_5_5_1 = 32820] = "UNSIGNED_SHORT_5_5_5_1", n[n.UNSIGNED_INT = 5125] = "UNSIGNED_INT", n[n.UNSIGNED_INT_10F_11F_11F_REV = 35899] = "UNSIGNED_INT_10F_11F_11F_REV", n[n.UNSIGNED_INT_2_10_10_10_REV = 33640] = "UNSIGNED_INT_2_10_10_10_REV", n[n.UNSIGNED_INT_24_8 = 34042] = "UNSIGNED_INT_24_8", n[n.UNSIGNED_INT_5_9_9_9_REV = 35902] = "UNSIGNED_INT_5_9_9_9_REV", n[n.BYTE = 5120] = "BYTE", n[n.SHORT = 5122] = "SHORT", n[n.INT = 5124] = "INT", n[n.FLOAT = 5126] = "FLOAT", n[n.FLOAT_32_UNSIGNED_INT_24_8_REV = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV", n[n.HALF_FLOAT = 36193] = "HALF_FLOAT", n))(pt || {}), at = /* @__PURE__ */ ((n) => (n[n.FLOAT = 0] = "FLOAT", n[n.INT = 1] = "INT", n[n.UINT = 2] = "UINT", n))(at || {}), Qr = /* @__PURE__ */ ((n) => (n[n.NEAREST = 0] = "NEAREST", n[n.LINEAR = 1] = "LINEAR", n))(Qr || {}), Dr = /* @__PURE__ */ ((n) => (n[n.CLAMP = 33071] = "CLAMP", n[n.REPEAT = 10497] = "REPEAT", n[n.MIRRORED_REPEAT = 33648] = "MIRRORED_REPEAT", n))(Dr || {}), Lr = /* @__PURE__ */ ((n) => (n[n.OFF = 0] = "OFF", n[n.POW2 = 1] = "POW2", n[n.ON = 2] = "ON", n[n.ON_MANUAL = 3] = "ON_MANUAL", n))(Lr || {}), Ae = /* @__PURE__ */ ((n) => (n[n.NPM = 0] = "NPM", n[n.UNPACK = 1] = "UNPACK", n[n.PMA = 2] = "PMA", n[n.NO_PREMULTIPLIED_ALPHA = 0] = "NO_PREMULTIPLIED_ALPHA", n[n.PREMULTIPLY_ON_UPLOAD = 1] = "PREMULTIPLY_ON_UPLOAD", n[n.PREMULTIPLIED_ALPHA = 2] = "PREMULTIPLIED_ALPHA", n))(Ae || {}), Mr = /* @__PURE__ */ ((n) => (n[n.NO = 0] = "NO", n[n.YES = 1] = "YES", n[n.AUTO = 2] = "AUTO", n[n.BLEND = 0] = "BLEND", n[n.CLEAR = 1] = "CLEAR", n[n.BLIT = 2] = "BLIT", n))(Mr || {}), nd = /* @__PURE__ */ ((n) => (n[n.AUTO = 0] = "AUTO", n[n.MANUAL = 1] = "MANUAL", n))(nd || {}), qe = /* @__PURE__ */ ((n) => (n.LOW = "lowp", n.MEDIUM = "mediump", n.HIGH = "highp", n))(qe || {}), re = /* @__PURE__ */ ((n) => (n[n.NONE = 0] = "NONE", n[n.SCISSOR = 1] = "SCISSOR", n[n.STENCIL = 2] = "STENCIL", n[n.SPRITE = 3] = "SPRITE", n[n.COLOR = 4] = "COLOR", n))(re || {}), Zt = /* @__PURE__ */ ((n) => (n[n.NONE = 0] = "NONE", n[n.LOW = 2] = "LOW", n[n.MEDIUM = 4] = "MEDIUM", n[n.HIGH = 8] = "HIGH", n))(Zt || {}), Fr = /* @__PURE__ */ ((n) => (n[n.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER", n[n.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", n[n.UNIFORM_BUFFER = 35345] = "UNIFORM_BUFFER", n))(Fr || {});
const R1 = {
  /**
   * Creates a canvas element of the given size.
   * This canvas is created using the browser's native canvas element.
   * @param width - width of the canvas
   * @param height - height of the canvas
   */
  createCanvas: (n, t) => {
    const e = document.createElement("canvas");
    return e.width = n, e.height = t, e;
  },
  getCanvasRenderingContext2D: () => CanvasRenderingContext2D,
  getWebGLRenderingContext: () => WebGLRenderingContext,
  getNavigator: () => navigator,
  getBaseUrl: () => document.baseURI ?? window.location.href,
  getFontFaceSet: () => document.fonts,
  fetch: (n, t) => fetch(n, t),
  parseXML: (n) => new DOMParser().parseFromString(n, "text/xml")
}, ht = {
  /**
   * This adapter is used to call methods that are platform dependent.
   * For example `document.createElement` only runs on the web but fails in node environments.
   * This allows us to support more platforms by abstracting away specific implementations per platform.
   *
   * By default the adapter is set to work in the browser. However you can create your own
   * by implementing the `IAdapter` interface. See `IAdapter` for more information.
   * @name ADAPTER
   * @memberof PIXI.settings
   * @type {PIXI.IAdapter}
   * @default PIXI.BrowserAdapter
   */
  ADAPTER: R1,
  /**
   * Default resolution / device pixel ratio of the renderer.
   * @static
   * @name RESOLUTION
   * @memberof PIXI.settings
   * @type {number}
   * @default 1
   */
  RESOLUTION: 1,
  /**
   * Enables bitmap creation before image load. This feature is experimental.
   * @static
   * @name CREATE_IMAGE_BITMAP
   * @memberof PIXI.settings
   * @type {boolean}
   * @default false
   */
  CREATE_IMAGE_BITMAP: !1,
  /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * @static
   * @memberof PIXI.settings
   * @type {boolean}
   * @default false
   */
  ROUND_PIXELS: !1
};
var Qh = /iPhone/i, cf = /iPod/i, df = /iPad/i, ff = /\biOS-universal(?:.+)Mac\b/i, Jh = /\bAndroid(?:.+)Mobile\b/i, pf = /Android/i, Ui = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i, qo = /Silk/i, Vr = /Windows Phone/i, mf = /\bWindows(?:.+)ARM\b/i, gf = /BlackBerry/i, yf = /BB10/i, _f = /Opera Mini/i, vf = /\b(CriOS|Chrome)(?:.+)Mobile/i, xf = /Mobile(?:.+)Firefox\b/i, wf = function(n) {
  return typeof n < "u" && n.platform === "MacIntel" && typeof n.maxTouchPoints == "number" && n.maxTouchPoints > 1 && typeof MSStream > "u";
};
function D1(n) {
  return function(t) {
    return t.test(n);
  };
}
function bf(n) {
  var t = {
    userAgent: "",
    platform: "",
    maxTouchPoints: 0
  };
  !n && typeof navigator < "u" ? t = {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints || 0
  } : typeof n == "string" ? t.userAgent = n : n && n.userAgent && (t = {
    userAgent: n.userAgent,
    platform: n.platform,
    maxTouchPoints: n.maxTouchPoints || 0
  });
  var e = t.userAgent, r = e.split("[FBAN");
  typeof r[1] < "u" && (e = r[0]), r = e.split("Twitter"), typeof r[1] < "u" && (e = r[0]);
  var i = D1(e), s = {
    apple: {
      phone: i(Qh) && !i(Vr),
      ipod: i(cf),
      tablet: !i(Qh) && (i(df) || wf(t)) && !i(Vr),
      universal: i(ff),
      device: (i(Qh) || i(cf) || i(df) || i(ff) || wf(t)) && !i(Vr)
    },
    amazon: {
      phone: i(Ui),
      tablet: !i(Ui) && i(qo),
      device: i(Ui) || i(qo)
    },
    android: {
      phone: !i(Vr) && i(Ui) || !i(Vr) && i(Jh),
      tablet: !i(Vr) && !i(Ui) && !i(Jh) && (i(qo) || i(pf)),
      device: !i(Vr) && (i(Ui) || i(qo) || i(Jh) || i(pf)) || i(/\bokhttp\b/i)
    },
    windows: {
      phone: i(Vr),
      tablet: i(mf),
      device: i(Vr) || i(mf)
    },
    other: {
      blackberry: i(gf),
      blackberry10: i(yf),
      opera: i(_f),
      firefox: i(xf),
      chrome: i(vf),
      device: i(gf) || i(yf) || i(_f) || i(xf) || i(vf)
    },
    any: !1,
    phone: !1,
    tablet: !1
  };
  return s.any = s.apple.device || s.android.device || s.windows.device || s.other.device, s.phone = s.apple.phone || s.android.phone || s.windows.phone, s.tablet = s.apple.tablet || s.android.tablet || s.windows.tablet, s;
}
const F1 = bf.default ?? bf, Jr = F1(globalThis.navigator);
ht.RETINA_PREFIX = /@([0-9\.]+)x/;
ht.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = !1;
var Ze = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function So(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function O1(n) {
  if (Object.prototype.hasOwnProperty.call(n, "__esModule")) return n;
  var t = n.default;
  if (typeof t == "function") {
    var e = function r() {
      var i = !1;
      try {
        i = this instanceof r;
      } catch {
      }
      return i ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    e.prototype = t.prototype;
  } else e = {};
  return Object.defineProperty(e, "__esModule", { value: !0 }), Object.keys(n).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(n, r);
    Object.defineProperty(e, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return n[r];
      }
    });
  }), e;
}
var tl = { exports: {} }, Tf;
function N1() {
  return Tf || (Tf = 1, (function(n) {
    var t = Object.prototype.hasOwnProperty, e = "~";
    function r() {
    }
    Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (e = !1));
    function i(h, l, u) {
      this.fn = h, this.context = l, this.once = u || !1;
    }
    function s(h, l, u, c, d) {
      if (typeof u != "function")
        throw new TypeError("The listener must be a function");
      var f = new i(u, c || h, d), p = e ? e + l : l;
      return h._events[p] ? h._events[p].fn ? h._events[p] = [h._events[p], f] : h._events[p].push(f) : (h._events[p] = f, h._eventsCount++), h;
    }
    function o(h, l) {
      --h._eventsCount === 0 ? h._events = new r() : delete h._events[l];
    }
    function a() {
      this._events = new r(), this._eventsCount = 0;
    }
    a.prototype.eventNames = function() {
      var l = [], u, c;
      if (this._eventsCount === 0) return l;
      for (c in u = this._events)
        t.call(u, c) && l.push(e ? c.slice(1) : c);
      return Object.getOwnPropertySymbols ? l.concat(Object.getOwnPropertySymbols(u)) : l;
    }, a.prototype.listeners = function(l) {
      var u = e ? e + l : l, c = this._events[u];
      if (!c) return [];
      if (c.fn) return [c.fn];
      for (var d = 0, f = c.length, p = new Array(f); d < f; d++)
        p[d] = c[d].fn;
      return p;
    }, a.prototype.listenerCount = function(l) {
      var u = e ? e + l : l, c = this._events[u];
      return c ? c.fn ? 1 : c.length : 0;
    }, a.prototype.emit = function(l, u, c, d, f, p) {
      var m = e ? e + l : l;
      if (!this._events[m]) return !1;
      var g = this._events[m], _ = arguments.length, w, v;
      if (g.fn) {
        switch (g.once && this.removeListener(l, g.fn, void 0, !0), _) {
          case 1:
            return g.fn.call(g.context), !0;
          case 2:
            return g.fn.call(g.context, u), !0;
          case 3:
            return g.fn.call(g.context, u, c), !0;
          case 4:
            return g.fn.call(g.context, u, c, d), !0;
          case 5:
            return g.fn.call(g.context, u, c, d, f), !0;
          case 6:
            return g.fn.call(g.context, u, c, d, f, p), !0;
        }
        for (v = 1, w = new Array(_ - 1); v < _; v++)
          w[v - 1] = arguments[v];
        g.fn.apply(g.context, w);
      } else {
        var E = g.length, x;
        for (v = 0; v < E; v++)
          switch (g[v].once && this.removeListener(l, g[v].fn, void 0, !0), _) {
            case 1:
              g[v].fn.call(g[v].context);
              break;
            case 2:
              g[v].fn.call(g[v].context, u);
              break;
            case 3:
              g[v].fn.call(g[v].context, u, c);
              break;
            case 4:
              g[v].fn.call(g[v].context, u, c, d);
              break;
            default:
              if (!w) for (x = 1, w = new Array(_ - 1); x < _; x++)
                w[x - 1] = arguments[x];
              g[v].fn.apply(g[v].context, w);
          }
      }
      return !0;
    }, a.prototype.on = function(l, u, c) {
      return s(this, l, u, c, !1);
    }, a.prototype.once = function(l, u, c) {
      return s(this, l, u, c, !0);
    }, a.prototype.removeListener = function(l, u, c, d) {
      var f = e ? e + l : l;
      if (!this._events[f]) return this;
      if (!u)
        return o(this, f), this;
      var p = this._events[f];
      if (p.fn)
        p.fn === u && (!d || p.once) && (!c || p.context === c) && o(this, f);
      else {
        for (var m = 0, g = [], _ = p.length; m < _; m++)
          (p[m].fn !== u || d && !p[m].once || c && p[m].context !== c) && g.push(p[m]);
        g.length ? this._events[f] = g.length === 1 ? g[0] : g : o(this, f);
      }
      return this;
    }, a.prototype.removeAllListeners = function(l) {
      var u;
      return l ? (u = e ? e + l : l, this._events[u] && o(this, u)) : (this._events = new r(), this._eventsCount = 0), this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = e, a.EventEmitter = a, n.exports = a;
  })(tl)), tl.exports;
}
var k1 = N1();
const Co = /* @__PURE__ */ So(k1);
var Zo = { exports: {} }, Af;
function B1() {
  if (Af) return Zo.exports;
  Af = 1, Zo.exports = n, Zo.exports.default = n;
  function n(T, S, A) {
    A = A || 2;
    var L = S && S.length, D = L ? S[0] * A : T.length, P = t(T, 0, D, A, !0), N = [];
    if (!P || P.next === P.prev) return N;
    var B, X, V, J, tt, K, G;
    if (L && (P = h(T, S, P, A)), T.length > 80 * A) {
      B = V = T[0], X = J = T[1];
      for (var W = A; W < D; W += A)
        tt = T[W], K = T[W + 1], tt < B && (B = tt), K < X && (X = K), tt > V && (V = tt), K > J && (J = K);
      G = Math.max(V - B, J - X), G = G !== 0 ? 32767 / G : 0;
    }
    return r(P, N, A, B, X, G, 0), N;
  }
  function t(T, S, A, L, D) {
    var P, N;
    if (D === j(T, S, A, L) > 0)
      for (P = S; P < A; P += L) N = O(P, T[P], T[P + 1], N);
    else
      for (P = A - L; P >= S; P -= L) N = O(P, T[P], T[P + 1], N);
    return N && E(N, N.next) && (R(N), N = N.next), N;
  }
  function e(T, S) {
    if (!T) return T;
    S || (S = T);
    var A = T, L;
    do
      if (L = !1, !A.steiner && (E(A, A.next) || v(A.prev, A, A.next) === 0)) {
        if (R(A), A = S = A.prev, A === A.next) break;
        L = !0;
      } else
        A = A.next;
    while (L || A !== S);
    return S;
  }
  function r(T, S, A, L, D, P, N) {
    if (T) {
      !N && P && f(T, L, D, P);
      for (var B = T, X, V; T.prev !== T.next; ) {
        if (X = T.prev, V = T.next, P ? s(T, L, D, P) : i(T)) {
          S.push(X.i / A | 0), S.push(T.i / A | 0), S.push(V.i / A | 0), R(T), T = V.next, B = V.next;
          continue;
        }
        if (T = V, T === B) {
          N ? N === 1 ? (T = o(e(T), S, A), r(T, S, A, L, D, P, 2)) : N === 2 && a(T, S, A, L, D, P) : r(e(T), S, A, L, D, P, 1);
          break;
        }
      }
    }
  }
  function i(T) {
    var S = T.prev, A = T, L = T.next;
    if (v(S, A, L) >= 0) return !1;
    for (var D = S.x, P = A.x, N = L.x, B = S.y, X = A.y, V = L.y, J = D < P ? D < N ? D : N : P < N ? P : N, tt = B < X ? B < V ? B : V : X < V ? X : V, K = D > P ? D > N ? D : N : P > N ? P : N, G = B > X ? B > V ? B : V : X > V ? X : V, W = L.next; W !== S; ) {
      if (W.x >= J && W.x <= K && W.y >= tt && W.y <= G && _(D, B, P, X, N, V, W.x, W.y) && v(W.prev, W, W.next) >= 0) return !1;
      W = W.next;
    }
    return !0;
  }
  function s(T, S, A, L) {
    var D = T.prev, P = T, N = T.next;
    if (v(D, P, N) >= 0) return !1;
    for (var B = D.x, X = P.x, V = N.x, J = D.y, tt = P.y, K = N.y, G = B < X ? B < V ? B : V : X < V ? X : V, W = J < tt ? J < K ? J : K : tt < K ? tt : K, q = B > X ? B > V ? B : V : X > V ? X : V, z = J > tt ? J > K ? J : K : tt > K ? tt : K, ot = m(G, W, S, A, L), rt = m(q, z, S, A, L), et = T.prevZ, nt = T.nextZ; et && et.z >= ot && nt && nt.z <= rt; ) {
      if (et.x >= G && et.x <= q && et.y >= W && et.y <= z && et !== D && et !== N && _(B, J, X, tt, V, K, et.x, et.y) && v(et.prev, et, et.next) >= 0 || (et = et.prevZ, nt.x >= G && nt.x <= q && nt.y >= W && nt.y <= z && nt !== D && nt !== N && _(B, J, X, tt, V, K, nt.x, nt.y) && v(nt.prev, nt, nt.next) >= 0)) return !1;
      nt = nt.nextZ;
    }
    for (; et && et.z >= ot; ) {
      if (et.x >= G && et.x <= q && et.y >= W && et.y <= z && et !== D && et !== N && _(B, J, X, tt, V, K, et.x, et.y) && v(et.prev, et, et.next) >= 0) return !1;
      et = et.prevZ;
    }
    for (; nt && nt.z <= rt; ) {
      if (nt.x >= G && nt.x <= q && nt.y >= W && nt.y <= z && nt !== D && nt !== N && _(B, J, X, tt, V, K, nt.x, nt.y) && v(nt.prev, nt, nt.next) >= 0) return !1;
      nt = nt.nextZ;
    }
    return !0;
  }
  function o(T, S, A) {
    var L = T;
    do {
      var D = L.prev, P = L.next.next;
      !E(D, P) && x(D, L, L.next, P) && M(D, P) && M(P, D) && (S.push(D.i / A | 0), S.push(L.i / A | 0), S.push(P.i / A | 0), R(L), R(L.next), L = T = P), L = L.next;
    } while (L !== T);
    return e(L);
  }
  function a(T, S, A, L, D, P) {
    var N = T;
    do {
      for (var B = N.next.next; B !== N.prev; ) {
        if (N.i !== B.i && w(N, B)) {
          var X = F(N, B);
          N = e(N, N.next), X = e(X, X.next), r(N, S, A, L, D, P, 0), r(X, S, A, L, D, P, 0);
          return;
        }
        B = B.next;
      }
      N = N.next;
    } while (N !== T);
  }
  function h(T, S, A, L) {
    var D = [], P, N, B, X, V;
    for (P = 0, N = S.length; P < N; P++)
      B = S[P] * L, X = P < N - 1 ? S[P + 1] * L : T.length, V = t(T, B, X, L, !1), V === V.next && (V.steiner = !0), D.push(g(V));
    for (D.sort(l), P = 0; P < D.length; P++)
      A = u(D[P], A);
    return A;
  }
  function l(T, S) {
    return T.x - S.x;
  }
  function u(T, S) {
    var A = c(T, S);
    if (!A)
      return S;
    var L = F(A, T);
    return e(L, L.next), e(A, A.next);
  }
  function c(T, S) {
    var A = S, L = T.x, D = T.y, P = -1 / 0, N;
    do {
      if (D <= A.y && D >= A.next.y && A.next.y !== A.y) {
        var B = A.x + (D - A.y) * (A.next.x - A.x) / (A.next.y - A.y);
        if (B <= L && B > P && (P = B, N = A.x < A.next.x ? A : A.next, B === L))
          return N;
      }
      A = A.next;
    } while (A !== S);
    if (!N) return null;
    var X = N, V = N.x, J = N.y, tt = 1 / 0, K;
    A = N;
    do
      L >= A.x && A.x >= V && L !== A.x && _(D < J ? L : P, D, V, J, D < J ? P : L, D, A.x, A.y) && (K = Math.abs(D - A.y) / (L - A.x), M(A, T) && (K < tt || K === tt && (A.x > N.x || A.x === N.x && d(N, A))) && (N = A, tt = K)), A = A.next;
    while (A !== X);
    return N;
  }
  function d(T, S) {
    return v(T.prev, T, S.prev) < 0 && v(S.next, T, T.next) < 0;
  }
  function f(T, S, A, L) {
    var D = T;
    do
      D.z === 0 && (D.z = m(D.x, D.y, S, A, L)), D.prevZ = D.prev, D.nextZ = D.next, D = D.next;
    while (D !== T);
    D.prevZ.nextZ = null, D.prevZ = null, p(D);
  }
  function p(T) {
    var S, A, L, D, P, N, B, X, V = 1;
    do {
      for (A = T, T = null, P = null, N = 0; A; ) {
        for (N++, L = A, B = 0, S = 0; S < V && (B++, L = L.nextZ, !!L); S++)
          ;
        for (X = V; B > 0 || X > 0 && L; )
          B !== 0 && (X === 0 || !L || A.z <= L.z) ? (D = A, A = A.nextZ, B--) : (D = L, L = L.nextZ, X--), P ? P.nextZ = D : T = D, D.prevZ = P, P = D;
        A = L;
      }
      P.nextZ = null, V *= 2;
    } while (N > 1);
    return T;
  }
  function m(T, S, A, L, D) {
    return T = (T - A) * D | 0, S = (S - L) * D | 0, T = (T | T << 8) & 16711935, T = (T | T << 4) & 252645135, T = (T | T << 2) & 858993459, T = (T | T << 1) & 1431655765, S = (S | S << 8) & 16711935, S = (S | S << 4) & 252645135, S = (S | S << 2) & 858993459, S = (S | S << 1) & 1431655765, T | S << 1;
  }
  function g(T) {
    var S = T, A = T;
    do
      (S.x < A.x || S.x === A.x && S.y < A.y) && (A = S), S = S.next;
    while (S !== T);
    return A;
  }
  function _(T, S, A, L, D, P, N, B) {
    return (D - N) * (S - B) >= (T - N) * (P - B) && (T - N) * (L - B) >= (A - N) * (S - B) && (A - N) * (P - B) >= (D - N) * (L - B);
  }
  function w(T, S) {
    return T.next.i !== S.i && T.prev.i !== S.i && !C(T, S) && // dones't intersect other edges
    (M(T, S) && M(S, T) && U(T, S) && // locally visible
    (v(T.prev, T, S.prev) || v(T, S.prev, S)) || // does not create opposite-facing sectors
    E(T, S) && v(T.prev, T, T.next) > 0 && v(S.prev, S, S.next) > 0);
  }
  function v(T, S, A) {
    return (S.y - T.y) * (A.x - S.x) - (S.x - T.x) * (A.y - S.y);
  }
  function E(T, S) {
    return T.x === S.x && T.y === S.y;
  }
  function x(T, S, A, L) {
    var D = y(v(T, S, A)), P = y(v(T, S, L)), N = y(v(A, L, T)), B = y(v(A, L, S));
    return !!(D !== P && N !== B || D === 0 && b(T, A, S) || P === 0 && b(T, L, S) || N === 0 && b(A, T, L) || B === 0 && b(A, S, L));
  }
  function b(T, S, A) {
    return S.x <= Math.max(T.x, A.x) && S.x >= Math.min(T.x, A.x) && S.y <= Math.max(T.y, A.y) && S.y >= Math.min(T.y, A.y);
  }
  function y(T) {
    return T > 0 ? 1 : T < 0 ? -1 : 0;
  }
  function C(T, S) {
    var A = T;
    do {
      if (A.i !== T.i && A.next.i !== T.i && A.i !== S.i && A.next.i !== S.i && x(A, A.next, T, S)) return !0;
      A = A.next;
    } while (A !== T);
    return !1;
  }
  function M(T, S) {
    return v(T.prev, T, T.next) < 0 ? v(T, S, T.next) >= 0 && v(T, T.prev, S) >= 0 : v(T, S, T.prev) < 0 || v(T, T.next, S) < 0;
  }
  function U(T, S) {
    var A = T, L = !1, D = (T.x + S.x) / 2, P = (T.y + S.y) / 2;
    do
      A.y > P != A.next.y > P && A.next.y !== A.y && D < (A.next.x - A.x) * (P - A.y) / (A.next.y - A.y) + A.x && (L = !L), A = A.next;
    while (A !== T);
    return L;
  }
  function F(T, S) {
    var A = new k(T.i, T.x, T.y), L = new k(S.i, S.x, S.y), D = T.next, P = S.prev;
    return T.next = S, S.prev = T, A.next = D, D.prev = A, L.next = A, A.prev = L, P.next = L, L.prev = P, L;
  }
  function O(T, S, A, L) {
    var D = new k(T, S, A);
    return L ? (D.next = L.next, D.prev = L, L.next.prev = D, L.next = D) : (D.prev = D, D.next = D), D;
  }
  function R(T) {
    T.next.prev = T.prev, T.prev.next = T.next, T.prevZ && (T.prevZ.nextZ = T.nextZ), T.nextZ && (T.nextZ.prevZ = T.prevZ);
  }
  function k(T, S, A) {
    this.i = T, this.x = S, this.y = A, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
  }
  n.deviation = function(T, S, A, L) {
    var D = S && S.length, P = D ? S[0] * A : T.length, N = Math.abs(j(T, 0, P, A));
    if (D)
      for (var B = 0, X = S.length; B < X; B++) {
        var V = S[B] * A, J = B < X - 1 ? S[B + 1] * A : T.length;
        N -= Math.abs(j(T, V, J, A));
      }
    var tt = 0;
    for (B = 0; B < L.length; B += 3) {
      var K = L[B] * A, G = L[B + 1] * A, W = L[B + 2] * A;
      tt += Math.abs(
        (T[K] - T[W]) * (T[G + 1] - T[K + 1]) - (T[K] - T[G]) * (T[W + 1] - T[K + 1])
      );
    }
    return N === 0 && tt === 0 ? 0 : Math.abs((tt - N) / N);
  };
  function j(T, S, A, L) {
    for (var D = 0, P = S, N = A - L; P < A; P += L)
      D += (T[N] - T[P]) * (T[P + 1] + T[N + 1]), N = P;
    return D;
  }
  return n.flatten = function(T) {
    for (var S = T[0][0].length, A = { vertices: [], holes: [], dimensions: S }, L = 0, D = 0; D < T.length; D++) {
      for (var P = 0; P < T[D].length; P++)
        for (var N = 0; N < S; N++) A.vertices.push(T[D][P][N]);
      D > 0 && (L += T[D - 1].length, A.holes.push(L));
    }
    return A;
  }, Zo.exports;
}
var L1 = B1();
const U1 = /* @__PURE__ */ So(L1);
var Qn = {}, Vs = { exports: {} };
var H1 = Vs.exports, Ef;
function G1() {
  return Ef || (Ef = 1, (function(n, t) {
    (function(e) {
      var r = t && !t.nodeType && t, i = n && !n.nodeType && n, s = typeof Ze == "object" && Ze;
      (s.global === s || s.window === s || s.self === s) && (e = s);
      var o, a = 2147483647, h = 36, l = 1, u = 26, c = 38, d = 700, f = 72, p = 128, m = "-", g = /^xn--/, _ = /[^\x20-\x7E]/, w = /[\x2E\u3002\uFF0E\uFF61]/g, v = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      }, E = h - l, x = Math.floor, b = String.fromCharCode, y;
      function C(D) {
        throw new RangeError(v[D]);
      }
      function M(D, P) {
        for (var N = D.length, B = []; N--; )
          B[N] = P(D[N]);
        return B;
      }
      function U(D, P) {
        var N = D.split("@"), B = "";
        N.length > 1 && (B = N[0] + "@", D = N[1]), D = D.replace(w, ".");
        var X = D.split("."), V = M(X, P).join(".");
        return B + V;
      }
      function F(D) {
        for (var P = [], N = 0, B = D.length, X, V; N < B; )
          X = D.charCodeAt(N++), X >= 55296 && X <= 56319 && N < B ? (V = D.charCodeAt(N++), (V & 64512) == 56320 ? P.push(((X & 1023) << 10) + (V & 1023) + 65536) : (P.push(X), N--)) : P.push(X);
        return P;
      }
      function O(D) {
        return M(D, function(P) {
          var N = "";
          return P > 65535 && (P -= 65536, N += b(P >>> 10 & 1023 | 55296), P = 56320 | P & 1023), N += b(P), N;
        }).join("");
      }
      function R(D) {
        return D - 48 < 10 ? D - 22 : D - 65 < 26 ? D - 65 : D - 97 < 26 ? D - 97 : h;
      }
      function k(D, P) {
        return D + 22 + 75 * (D < 26) - ((P != 0) << 5);
      }
      function j(D, P, N) {
        var B = 0;
        for (D = N ? x(D / d) : D >> 1, D += x(D / P); D > E * u >> 1; B += h)
          D = x(D / E);
        return x(B + (E + 1) * D / (D + c));
      }
      function T(D) {
        var P = [], N = D.length, B, X = 0, V = p, J = f, tt, K, G, W, q, z, ot, rt, et;
        for (tt = D.lastIndexOf(m), tt < 0 && (tt = 0), K = 0; K < tt; ++K)
          D.charCodeAt(K) >= 128 && C("not-basic"), P.push(D.charCodeAt(K));
        for (G = tt > 0 ? tt + 1 : 0; G < N; ) {
          for (W = X, q = 1, z = h; G >= N && C("invalid-input"), ot = R(D.charCodeAt(G++)), (ot >= h || ot > x((a - X) / q)) && C("overflow"), X += ot * q, rt = z <= J ? l : z >= J + u ? u : z - J, !(ot < rt); z += h)
            et = h - rt, q > x(a / et) && C("overflow"), q *= et;
          B = P.length + 1, J = j(X - W, B, W == 0), x(X / B) > a - V && C("overflow"), V += x(X / B), X %= B, P.splice(X++, 0, V);
        }
        return O(P);
      }
      function S(D) {
        var P, N, B, X, V, J, tt, K, G, W, q, z = [], ot, rt, et, nt;
        for (D = F(D), ot = D.length, P = p, N = 0, V = f, J = 0; J < ot; ++J)
          q = D[J], q < 128 && z.push(b(q));
        for (B = X = z.length, X && z.push(m); B < ot; ) {
          for (tt = a, J = 0; J < ot; ++J)
            q = D[J], q >= P && q < tt && (tt = q);
          for (rt = B + 1, tt - P > x((a - N) / rt) && C("overflow"), N += (tt - P) * rt, P = tt, J = 0; J < ot; ++J)
            if (q = D[J], q < P && ++N > a && C("overflow"), q == P) {
              for (K = N, G = h; W = G <= V ? l : G >= V + u ? u : G - V, !(K < W); G += h)
                nt = K - W, et = h - W, z.push(
                  b(k(W + nt % et, 0))
                ), K = x(nt / et);
              z.push(b(k(K, 0))), V = j(N, rt, B == X), N = 0, ++B;
            }
          ++N, ++P;
        }
        return z.join("");
      }
      function A(D) {
        return U(D, function(P) {
          return g.test(P) ? T(P.slice(4).toLowerCase()) : P;
        });
      }
      function L(D) {
        return U(D, function(P) {
          return _.test(P) ? "xn--" + S(P) : P;
        });
      }
      if (o = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        version: "1.4.1",
        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        ucs2: {
          decode: F,
          encode: O
        },
        decode: T,
        encode: S,
        toASCII: L,
        toUnicode: A
      }, r && i)
        if (n.exports == r)
          i.exports = o;
        else
          for (y in o)
            o.hasOwnProperty(y) && (r[y] = o[y]);
      else
        e.punycode = o;
    })(H1);
  })(Vs, Vs.exports)), Vs.exports;
}
var el, Sf;
function Ts() {
  return Sf || (Sf = 1, el = TypeError), el;
}
const z1 = {}, W1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z1
}, Symbol.toStringTag, { value: "Module" })), $1 = /* @__PURE__ */ O1(W1);
var rl, Cf;
function Eh() {
  if (Cf) return rl;
  Cf = 1;
  var n = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && n ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, e = n && t && typeof t.get == "function" ? t.get : null, r = n && Map.prototype.forEach, i = typeof Set == "function" && Set.prototype, s = Object.getOwnPropertyDescriptor && i ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, o = i && s && typeof s.get == "function" ? s.get : null, a = i && Set.prototype.forEach, h = typeof WeakMap == "function" && WeakMap.prototype, l = h ? WeakMap.prototype.has : null, u = typeof WeakSet == "function" && WeakSet.prototype, c = u ? WeakSet.prototype.has : null, d = typeof WeakRef == "function" && WeakRef.prototype, f = d ? WeakRef.prototype.deref : null, p = Boolean.prototype.valueOf, m = Object.prototype.toString, g = Function.prototype.toString, _ = String.prototype.match, w = String.prototype.slice, v = String.prototype.replace, E = String.prototype.toUpperCase, x = String.prototype.toLowerCase, b = RegExp.prototype.test, y = Array.prototype.concat, C = Array.prototype.join, M = Array.prototype.slice, U = Math.floor, F = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, O = Object.getOwnPropertySymbols, R = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, k = typeof Symbol == "function" && typeof Symbol.iterator == "object", j = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === k || !0) ? Symbol.toStringTag : null, T = Object.prototype.propertyIsEnumerable, S = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function($) {
    return $.__proto__;
  } : null);
  function A($, Y) {
    if ($ === 1 / 0 || $ === -1 / 0 || $ !== $ || $ && $ > -1e3 && $ < 1e3 || b.call(/e/, Y))
      return Y;
    var St = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof $ == "number") {
      var At = $ < 0 ? -U(-$) : U($);
      if (At !== $) {
        var It = String(At), vt = w.call(Y, It.length + 1);
        return v.call(It, St, "$&_") + "." + v.call(v.call(vt, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return v.call(Y, St, "$&_");
  }
  var L = $1, D = L.custom, P = rt(D) ? D : null, N = {
    __proto__: null,
    double: '"',
    single: "'"
  }, B = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  rl = function $(Y, St, At, It) {
    var vt = St || {};
    if (Et(vt, "quoteStyle") && !Et(N, vt.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (Et(vt, "maxStringLength") && (typeof vt.maxStringLength == "number" ? vt.maxStringLength < 0 && vt.maxStringLength !== 1 / 0 : vt.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var xr = Et(vt, "customInspect") ? vt.customInspect : !0;
    if (typeof xr != "boolean" && xr !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (Et(vt, "indent") && vt.indent !== null && vt.indent !== "	" && !(parseInt(vt.indent, 10) === vt.indent && vt.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (Et(vt, "numericSeparator") && typeof vt.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var ir = vt.numericSeparator;
    if (typeof Y > "u")
      return "undefined";
    if (Y === null)
      return "null";
    if (typeof Y == "boolean")
      return Y ? "true" : "false";
    if (typeof Y == "string")
      return Xn(Y, vt);
    if (typeof Y == "number") {
      if (Y === 0)
        return 1 / 0 / Y > 0 ? "0" : "-0";
      var te = String(Y);
      return ir ? A(Y, te) : te;
    }
    if (typeof Y == "bigint") {
      var ze = String(Y) + "n";
      return ir ? A(Y, ze) : ze;
    }
    var Vn = typeof vt.depth > "u" ? 5 : vt.depth;
    if (typeof At > "u" && (At = 0), At >= Vn && Vn > 0 && typeof Y == "object")
      return tt(Y) ? "[Array]" : "[Object]";
    var wr = jh(vt, At);
    if (typeof It > "u")
      It = [];
    else if (Ge(It, Y) >= 0)
      return "[Circular]";
    function ue(yn, Bi, Zh) {
      if (Bi && (It = M.call(It), It.push(Bi)), Zh) {
        var br = {
          depth: vt.depth
        };
        return Et(vt, "quoteStyle") && (br.quoteStyle = vt.quoteStyle), $(yn, br, At + 1, It);
      }
      return $(yn, vt, At + 1, It);
    }
    if (typeof Y == "function" && !G(Y)) {
      var Bo = vr(Y), Lo = $r(Y, ue);
      return "[Function" + (Bo ? ": " + Bo : " (anonymous)") + "]" + (Lo.length > 0 ? " { " + C.call(Lo, ", ") + " }" : "");
    }
    if (rt(Y)) {
      var Uo = k ? v.call(String(Y), /^(Symbol\(.*\))_[^)]*$/, "$1") : R.call(Y);
      return typeof Y == "object" && !k ? gn(Uo) : Uo;
    }
    if (Yh(Y)) {
      for (var Yn = "<" + x.call(String(Y.nodeName)), Ms = Y.attributes || [], jn = 0; jn < Ms.length; jn++)
        Yn += " " + Ms[jn].name + "=" + X(V(Ms[jn].value), "double", vt);
      return Yn += ">", Y.childNodes && Y.childNodes.length && (Yn += "..."), Yn += "</" + x.call(String(Y.nodeName)) + ">", Yn;
    }
    if (tt(Y)) {
      if (Y.length === 0)
        return "[]";
      var qn = $r(Y, ue);
      return wr && !ko(qn) ? "[" + ki(qn, wr) + "]" : "[ " + C.call(qn, ", ") + " ]";
    }
    if (W(Y)) {
      var sr = $r(Y, ue);
      return !("cause" in Error.prototype) && "cause" in Y && !T.call(Y, "cause") ? "{ [" + String(Y) + "] " + C.call(y.call("[cause]: " + ue(Y.cause), sr), ", ") + " }" : sr.length === 0 ? "[" + String(Y) + "]" : "{ [" + String(Y) + "] " + C.call(sr, ", ") + " }";
    }
    if (typeof Y == "object" && xr) {
      if (P && typeof Y[P] == "function" && L)
        return L(Y, { depth: Vn - At });
      if (xr !== "symbol" && typeof Y.inspect == "function")
        return Y.inspect();
    }
    if (ye(Y)) {
      var Ho = [];
      return r && r.call(Y, function(yn, Bi) {
        Ho.push(ue(Bi, Y, !0) + " => " + ue(yn, Y));
      }), Cs("Map", e.call(Y), Ho, wr);
    }
    if (mn(Y)) {
      var Go = [];
      return a && a.call(Y, function(yn) {
        Go.push(ue(yn, Y));
      }), Cs("Set", o.call(Y), Go, wr);
    }
    if (Wr(Y))
      return we("WeakMap");
    if (Vh(Y))
      return we("WeakSet");
    if (pn(Y))
      return we("WeakRef");
    if (z(Y))
      return gn(ue(Number(Y)));
    if (et(Y))
      return gn(ue(F.call(Y)));
    if (ot(Y))
      return gn(p.call(Y));
    if (q(Y))
      return gn(ue(String(Y)));
    if (typeof window < "u" && Y === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && Y === globalThis || typeof Ze < "u" && Y === Ze)
      return "{ [object globalThis] }";
    if (!K(Y) && !G(Y)) {
      var Is = $r(Y, ue), zo = S ? S(Y) === Object.prototype : Y instanceof Object || Y.constructor === Object, Ps = Y instanceof Object ? "" : "null prototype", We = !zo && j && Object(Y) === Y && j in Y ? w.call(Dt(Y), 8, -1) : Ps ? "Object" : "", qh = zo || typeof Y.constructor != "function" ? "" : Y.constructor.name ? Y.constructor.name + " " : "", Rs = qh + (We || Ps ? "[" + C.call(y.call([], We || [], Ps || []), ": ") + "] " : "");
      return Is.length === 0 ? Rs + "{}" : wr ? Rs + "{" + ki(Is, wr) + "}" : Rs + "{ " + C.call(Is, ", ") + " }";
    }
    return String(Y);
  };
  function X($, Y, St) {
    var At = St.quoteStyle || Y, It = N[At];
    return It + $ + It;
  }
  function V($) {
    return v.call(String($), /"/g, "&quot;");
  }
  function J($) {
    return !j || !(typeof $ == "object" && (j in $ || typeof $[j] < "u"));
  }
  function tt($) {
    return Dt($) === "[object Array]" && J($);
  }
  function K($) {
    return Dt($) === "[object Date]" && J($);
  }
  function G($) {
    return Dt($) === "[object RegExp]" && J($);
  }
  function W($) {
    return Dt($) === "[object Error]" && J($);
  }
  function q($) {
    return Dt($) === "[object String]" && J($);
  }
  function z($) {
    return Dt($) === "[object Number]" && J($);
  }
  function ot($) {
    return Dt($) === "[object Boolean]" && J($);
  }
  function rt($) {
    if (k)
      return $ && typeof $ == "object" && $ instanceof Symbol;
    if (typeof $ == "symbol")
      return !0;
    if (!$ || typeof $ != "object" || !R)
      return !1;
    try {
      return R.call($), !0;
    } catch {
    }
    return !1;
  }
  function et($) {
    if (!$ || typeof $ != "object" || !F)
      return !1;
    try {
      return F.call($), !0;
    } catch {
    }
    return !1;
  }
  var nt = Object.prototype.hasOwnProperty || function($) {
    return $ in this;
  };
  function Et($, Y) {
    return nt.call($, Y);
  }
  function Dt($) {
    return m.call($);
  }
  function vr($) {
    if ($.name)
      return $.name;
    var Y = _.call(g.call($), /^function\s*([\w$]+)/);
    return Y ? Y[1] : null;
  }
  function Ge($, Y) {
    if ($.indexOf)
      return $.indexOf(Y);
    for (var St = 0, At = $.length; St < At; St++)
      if ($[St] === Y)
        return St;
    return -1;
  }
  function ye($) {
    if (!e || !$ || typeof $ != "object")
      return !1;
    try {
      e.call($);
      try {
        o.call($);
      } catch {
        return !0;
      }
      return $ instanceof Map;
    } catch {
    }
    return !1;
  }
  function Wr($) {
    if (!l || !$ || typeof $ != "object")
      return !1;
    try {
      l.call($, l);
      try {
        c.call($, c);
      } catch {
        return !0;
      }
      return $ instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function pn($) {
    if (!f || !$ || typeof $ != "object")
      return !1;
    try {
      return f.call($), !0;
    } catch {
    }
    return !1;
  }
  function mn($) {
    if (!o || !$ || typeof $ != "object")
      return !1;
    try {
      o.call($);
      try {
        e.call($);
      } catch {
        return !0;
      }
      return $ instanceof Set;
    } catch {
    }
    return !1;
  }
  function Vh($) {
    if (!c || !$ || typeof $ != "object")
      return !1;
    try {
      c.call($, c);
      try {
        l.call($, l);
      } catch {
        return !0;
      }
      return $ instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Yh($) {
    return !$ || typeof $ != "object" ? !1 : typeof HTMLElement < "u" && $ instanceof HTMLElement ? !0 : typeof $.nodeName == "string" && typeof $.getAttribute == "function";
  }
  function Xn($, Y) {
    if ($.length > Y.maxStringLength) {
      var St = $.length - Y.maxStringLength, At = "... " + St + " more character" + (St > 1 ? "s" : "");
      return Xn(w.call($, 0, Y.maxStringLength), Y) + At;
    }
    var It = B[Y.quoteStyle || "single"];
    It.lastIndex = 0;
    var vt = v.call(v.call($, It, "\\$1"), /[\x00-\x1f]/g, Ss);
    return X(vt, "single", Y);
  }
  function Ss($) {
    var Y = $.charCodeAt(0), St = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[Y];
    return St ? "\\" + St : "\\x" + (Y < 16 ? "0" : "") + E.call(Y.toString(16));
  }
  function gn($) {
    return "Object(" + $ + ")";
  }
  function we($) {
    return $ + " { ? }";
  }
  function Cs($, Y, St, At) {
    var It = At ? ki(St, At) : C.call(St, ", ");
    return $ + " (" + Y + ") {" + It + "}";
  }
  function ko($) {
    for (var Y = 0; Y < $.length; Y++)
      if (Ge($[Y], `
`) >= 0)
        return !1;
    return !0;
  }
  function jh($, Y) {
    var St;
    if ($.indent === "	")
      St = "	";
    else if (typeof $.indent == "number" && $.indent > 0)
      St = C.call(Array($.indent + 1), " ");
    else
      return null;
    return {
      base: St,
      prev: C.call(Array(Y + 1), St)
    };
  }
  function ki($, Y) {
    if ($.length === 0)
      return "";
    var St = `
` + Y.prev + Y.base;
    return St + C.call($, "," + St) + `
` + Y.prev;
  }
  function $r($, Y) {
    var St = tt($), At = [];
    if (St) {
      At.length = $.length;
      for (var It = 0; It < $.length; It++)
        At[It] = Et($, It) ? Y($[It], $) : "";
    }
    var vt = typeof O == "function" ? O($) : [], xr;
    if (k) {
      xr = {};
      for (var ir = 0; ir < vt.length; ir++)
        xr["$" + vt[ir]] = vt[ir];
    }
    for (var te in $)
      Et($, te) && (St && String(Number(te)) === te && te < $.length || k && xr["$" + te] instanceof Symbol || (b.call(/[^\w$]/, te) ? At.push(Y(te, $) + ": " + Y($[te], $)) : At.push(te + ": " + Y($[te], $))));
    if (typeof O == "function")
      for (var ze = 0; ze < vt.length; ze++)
        T.call($, vt[ze]) && At.push("[" + Y(vt[ze]) + "]: " + Y($[vt[ze]], $));
    return At;
  }
  return rl;
}
var nl, Mf;
function X1() {
  if (Mf) return nl;
  Mf = 1;
  var n = /* @__PURE__ */ Eh(), t = /* @__PURE__ */ Ts(), e = function(a, h, l) {
    for (var u = a, c; (c = u.next) != null; u = c)
      if (c.key === h)
        return u.next = c.next, l || (c.next = /** @type {NonNullable<typeof list.next>} */
        a.next, a.next = c), c;
  }, r = function(a, h) {
    if (a) {
      var l = e(a, h);
      return l && l.value;
    }
  }, i = function(a, h, l) {
    var u = e(a, h);
    u ? u.value = l : a.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: h,
      next: a.next,
      value: l
    };
  }, s = function(a, h) {
    return a ? !!e(a, h) : !1;
  }, o = function(a, h) {
    if (a)
      return e(a, h, !0);
  };
  return nl = function() {
    var h, l = {
      assert: function(u) {
        if (!l.has(u))
          throw new t("Side channel does not contain " + n(u));
      },
      delete: function(u) {
        var c = h && h.next, d = o(h, u);
        return d && c && c === d && (h = void 0), !!d;
      },
      get: function(u) {
        return r(h, u);
      },
      has: function(u) {
        return s(h, u);
      },
      set: function(u, c) {
        h || (h = {
          next: void 0
        }), i(
          /** @type {NonNullable<typeof $o>} */
          h,
          u,
          c
        );
      }
    };
    return l;
  }, nl;
}
var il, If;
function kg() {
  return If || (If = 1, il = Object), il;
}
var sl, Pf;
function V1() {
  return Pf || (Pf = 1, sl = Error), sl;
}
var ol, Rf;
function Y1() {
  return Rf || (Rf = 1, ol = EvalError), ol;
}
var al, Df;
function j1() {
  return Df || (Df = 1, al = RangeError), al;
}
var hl, Ff;
function q1() {
  return Ff || (Ff = 1, hl = ReferenceError), hl;
}
var ll, Of;
function Z1() {
  return Of || (Of = 1, ll = SyntaxError), ll;
}
var ul, Nf;
function K1() {
  return Nf || (Nf = 1, ul = URIError), ul;
}
var cl, kf;
function Q1() {
  return kf || (kf = 1, cl = Math.abs), cl;
}
var dl, Bf;
function J1() {
  return Bf || (Bf = 1, dl = Math.floor), dl;
}
var fl, Lf;
function tx() {
  return Lf || (Lf = 1, fl = Math.max), fl;
}
var pl, Uf;
function ex() {
  return Uf || (Uf = 1, pl = Math.min), pl;
}
var ml, Hf;
function rx() {
  return Hf || (Hf = 1, ml = Math.pow), ml;
}
var gl, Gf;
function nx() {
  return Gf || (Gf = 1, gl = Math.round), gl;
}
var yl, zf;
function ix() {
  return zf || (zf = 1, yl = Number.isNaN || function(t) {
    return t !== t;
  }), yl;
}
var _l, Wf;
function sx() {
  if (Wf) return _l;
  Wf = 1;
  var n = /* @__PURE__ */ ix();
  return _l = function(e) {
    return n(e) || e === 0 ? e : e < 0 ? -1 : 1;
  }, _l;
}
var vl, $f;
function ox() {
  return $f || ($f = 1, vl = Object.getOwnPropertyDescriptor), vl;
}
var xl, Xf;
function Bg() {
  if (Xf) return xl;
  Xf = 1;
  var n = /* @__PURE__ */ ox();
  if (n)
    try {
      n([], "length");
    } catch {
      n = null;
    }
  return xl = n, xl;
}
var wl, Vf;
function ax() {
  if (Vf) return wl;
  Vf = 1;
  var n = Object.defineProperty || !1;
  if (n)
    try {
      n({}, "a", { value: 1 });
    } catch {
      n = !1;
    }
  return wl = n, wl;
}
var bl, Yf;
function hx() {
  return Yf || (Yf = 1, bl = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, e = /* @__PURE__ */ Symbol("test"), r = Object(e);
    if (typeof e == "string" || Object.prototype.toString.call(e) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
      return !1;
    var i = 42;
    t[e] = i;
    for (var s in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var o = Object.getOwnPropertySymbols(t);
    if (o.length !== 1 || o[0] !== e || !Object.prototype.propertyIsEnumerable.call(t, e))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var a = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, e)
      );
      if (a.value !== i || a.enumerable !== !0)
        return !1;
    }
    return !0;
  }), bl;
}
var Tl, jf;
function lx() {
  if (jf) return Tl;
  jf = 1;
  var n = typeof Symbol < "u" && Symbol, t = hx();
  return Tl = function() {
    return typeof n != "function" || typeof Symbol != "function" || typeof n("foo") != "symbol" || typeof /* @__PURE__ */ Symbol("bar") != "symbol" ? !1 : t();
  }, Tl;
}
var Al, qf;
function Lg() {
  return qf || (qf = 1, Al = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Al;
}
var El, Zf;
function Ug() {
  if (Zf) return El;
  Zf = 1;
  var n = /* @__PURE__ */ kg();
  return El = n.getPrototypeOf || null, El;
}
var Sl, Kf;
function ux() {
  if (Kf) return Sl;
  Kf = 1;
  var n = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, e = Math.max, r = "[object Function]", i = function(h, l) {
    for (var u = [], c = 0; c < h.length; c += 1)
      u[c] = h[c];
    for (var d = 0; d < l.length; d += 1)
      u[d + h.length] = l[d];
    return u;
  }, s = function(h, l) {
    for (var u = [], c = l, d = 0; c < h.length; c += 1, d += 1)
      u[d] = h[c];
    return u;
  }, o = function(a, h) {
    for (var l = "", u = 0; u < a.length; u += 1)
      l += a[u], u + 1 < a.length && (l += h);
    return l;
  };
  return Sl = function(h) {
    var l = this;
    if (typeof l != "function" || t.apply(l) !== r)
      throw new TypeError(n + l);
    for (var u = s(arguments, 1), c, d = function() {
      if (this instanceof c) {
        var _ = l.apply(
          this,
          i(u, arguments)
        );
        return Object(_) === _ ? _ : this;
      }
      return l.apply(
        h,
        i(u, arguments)
      );
    }, f = e(0, l.length - u.length), p = [], m = 0; m < f; m++)
      p[m] = "$" + m;
    if (c = Function("binder", "return function (" + o(p, ",") + "){ return binder.apply(this,arguments); }")(d), l.prototype) {
      var g = function() {
      };
      g.prototype = l.prototype, c.prototype = new g(), g.prototype = null;
    }
    return c;
  }, Sl;
}
var Cl, Qf;
function Sh() {
  if (Qf) return Cl;
  Qf = 1;
  var n = ux();
  return Cl = Function.prototype.bind || n, Cl;
}
var Ml, Jf;
function id() {
  return Jf || (Jf = 1, Ml = Function.prototype.call), Ml;
}
var Il, tp;
function Hg() {
  return tp || (tp = 1, Il = Function.prototype.apply), Il;
}
var Pl, ep;
function cx() {
  return ep || (ep = 1, Pl = typeof Reflect < "u" && Reflect && Reflect.apply), Pl;
}
var Rl, rp;
function dx() {
  if (rp) return Rl;
  rp = 1;
  var n = Sh(), t = Hg(), e = id(), r = cx();
  return Rl = r || n.call(e, t), Rl;
}
var Dl, np;
function Gg() {
  if (np) return Dl;
  np = 1;
  var n = Sh(), t = /* @__PURE__ */ Ts(), e = id(), r = dx();
  return Dl = function(s) {
    if (s.length < 1 || typeof s[0] != "function")
      throw new t("a function is required");
    return r(n, e, s);
  }, Dl;
}
var Fl, ip;
function fx() {
  if (ip) return Fl;
  ip = 1;
  var n = Gg(), t = /* @__PURE__ */ Bg(), e;
  try {
    e = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (o) {
    if (!o || typeof o != "object" || !("code" in o) || o.code !== "ERR_PROTO_ACCESS")
      throw o;
  }
  var r = !!e && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), i = Object, s = i.getPrototypeOf;
  return Fl = r && typeof r.get == "function" ? n([r.get]) : typeof s == "function" ? (
    /** @type {import('./get')} */
    function(a) {
      return s(a == null ? a : i(a));
    }
  ) : !1, Fl;
}
var Ol, sp;
function px() {
  if (sp) return Ol;
  sp = 1;
  var n = Lg(), t = Ug(), e = /* @__PURE__ */ fx();
  return Ol = n ? function(i) {
    return n(i);
  } : t ? function(i) {
    if (!i || typeof i != "object" && typeof i != "function")
      throw new TypeError("getProto: not an object");
    return t(i);
  } : e ? function(i) {
    return e(i);
  } : null, Ol;
}
var Nl, op;
function mx() {
  if (op) return Nl;
  op = 1;
  var n = Function.prototype.call, t = Object.prototype.hasOwnProperty, e = Sh();
  return Nl = e.call(n, t), Nl;
}
var kl, ap;
function sd() {
  if (ap) return kl;
  ap = 1;
  var n, t = /* @__PURE__ */ kg(), e = /* @__PURE__ */ V1(), r = /* @__PURE__ */ Y1(), i = /* @__PURE__ */ j1(), s = /* @__PURE__ */ q1(), o = /* @__PURE__ */ Z1(), a = /* @__PURE__ */ Ts(), h = /* @__PURE__ */ K1(), l = /* @__PURE__ */ Q1(), u = /* @__PURE__ */ J1(), c = /* @__PURE__ */ tx(), d = /* @__PURE__ */ ex(), f = /* @__PURE__ */ rx(), p = /* @__PURE__ */ nx(), m = /* @__PURE__ */ sx(), g = Function, _ = function(G) {
    try {
      return g('"use strict"; return (' + G + ").constructor;")();
    } catch {
    }
  }, w = /* @__PURE__ */ Bg(), v = /* @__PURE__ */ ax(), E = function() {
    throw new a();
  }, x = w ? (function() {
    try {
      return arguments.callee, E;
    } catch {
      try {
        return w(arguments, "callee").get;
      } catch {
        return E;
      }
    }
  })() : E, b = lx()(), y = px(), C = Ug(), M = Lg(), U = Hg(), F = id(), O = {}, R = typeof Uint8Array > "u" || !y ? n : y(Uint8Array), k = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? n : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? n : ArrayBuffer,
    "%ArrayIteratorPrototype%": b && y ? y([][Symbol.iterator]()) : n,
    "%AsyncFromSyncIteratorPrototype%": n,
    "%AsyncFunction%": O,
    "%AsyncGenerator%": O,
    "%AsyncGeneratorFunction%": O,
    "%AsyncIteratorPrototype%": O,
    "%Atomics%": typeof Atomics > "u" ? n : Atomics,
    "%BigInt%": typeof BigInt > "u" ? n : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? n : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? n : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? n : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": e,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": r,
    "%Float16Array%": typeof Float16Array > "u" ? n : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? n : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? n : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? n : FinalizationRegistry,
    "%Function%": g,
    "%GeneratorFunction%": O,
    "%Int8Array%": typeof Int8Array > "u" ? n : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? n : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? n : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": b && y ? y(y([][Symbol.iterator]())) : n,
    "%JSON%": typeof JSON == "object" ? JSON : n,
    "%Map%": typeof Map > "u" ? n : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !b || !y ? n : y((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": w,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? n : Promise,
    "%Proxy%": typeof Proxy > "u" ? n : Proxy,
    "%RangeError%": i,
    "%ReferenceError%": s,
    "%Reflect%": typeof Reflect > "u" ? n : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? n : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !b || !y ? n : y((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? n : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": b && y ? y(""[Symbol.iterator]()) : n,
    "%Symbol%": b ? Symbol : n,
    "%SyntaxError%": o,
    "%ThrowTypeError%": x,
    "%TypedArray%": R,
    "%TypeError%": a,
    "%Uint8Array%": typeof Uint8Array > "u" ? n : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? n : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? n : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? n : Uint32Array,
    "%URIError%": h,
    "%WeakMap%": typeof WeakMap > "u" ? n : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? n : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? n : WeakSet,
    "%Function.prototype.call%": F,
    "%Function.prototype.apply%": U,
    "%Object.defineProperty%": v,
    "%Object.getPrototypeOf%": C,
    "%Math.abs%": l,
    "%Math.floor%": u,
    "%Math.max%": c,
    "%Math.min%": d,
    "%Math.pow%": f,
    "%Math.round%": p,
    "%Math.sign%": m,
    "%Reflect.getPrototypeOf%": M
  };
  if (y)
    try {
      null.error;
    } catch (G) {
      var j = y(y(G));
      k["%Error.prototype%"] = j;
    }
  var T = function G(W) {
    var q;
    if (W === "%AsyncFunction%")
      q = _("async function () {}");
    else if (W === "%GeneratorFunction%")
      q = _("function* () {}");
    else if (W === "%AsyncGeneratorFunction%")
      q = _("async function* () {}");
    else if (W === "%AsyncGenerator%") {
      var z = G("%AsyncGeneratorFunction%");
      z && (q = z.prototype);
    } else if (W === "%AsyncIteratorPrototype%") {
      var ot = G("%AsyncGenerator%");
      ot && y && (q = y(ot.prototype));
    }
    return k[W] = q, q;
  }, S = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, A = Sh(), L = /* @__PURE__ */ mx(), D = A.call(F, Array.prototype.concat), P = A.call(U, Array.prototype.splice), N = A.call(F, String.prototype.replace), B = A.call(F, String.prototype.slice), X = A.call(F, RegExp.prototype.exec), V = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, J = /\\(\\)?/g, tt = function(W) {
    var q = B(W, 0, 1), z = B(W, -1);
    if (q === "%" && z !== "%")
      throw new o("invalid intrinsic syntax, expected closing `%`");
    if (z === "%" && q !== "%")
      throw new o("invalid intrinsic syntax, expected opening `%`");
    var ot = [];
    return N(W, V, function(rt, et, nt, Et) {
      ot[ot.length] = nt ? N(Et, J, "$1") : et || rt;
    }), ot;
  }, K = function(W, q) {
    var z = W, ot;
    if (L(S, z) && (ot = S[z], z = "%" + ot[0] + "%"), L(k, z)) {
      var rt = k[z];
      if (rt === O && (rt = T(z)), typeof rt > "u" && !q)
        throw new a("intrinsic " + W + " exists, but is not available. Please file an issue!");
      return {
        alias: ot,
        name: z,
        value: rt
      };
    }
    throw new o("intrinsic " + W + " does not exist!");
  };
  return kl = function(W, q) {
    if (typeof W != "string" || W.length === 0)
      throw new a("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof q != "boolean")
      throw new a('"allowMissing" argument must be a boolean');
    if (X(/^%?[^%]*%?$/, W) === null)
      throw new o("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var z = tt(W), ot = z.length > 0 ? z[0] : "", rt = K("%" + ot + "%", q), et = rt.name, nt = rt.value, Et = !1, Dt = rt.alias;
    Dt && (ot = Dt[0], P(z, D([0, 1], Dt)));
    for (var vr = 1, Ge = !0; vr < z.length; vr += 1) {
      var ye = z[vr], Wr = B(ye, 0, 1), pn = B(ye, -1);
      if ((Wr === '"' || Wr === "'" || Wr === "`" || pn === '"' || pn === "'" || pn === "`") && Wr !== pn)
        throw new o("property names with quotes must have matching quotes");
      if ((ye === "constructor" || !Ge) && (Et = !0), ot += "." + ye, et = "%" + ot + "%", L(k, et))
        nt = k[et];
      else if (nt != null) {
        if (!(ye in nt)) {
          if (!q)
            throw new a("base intrinsic for " + W + " exists, but the property is not available.");
          return;
        }
        if (w && vr + 1 >= z.length) {
          var mn = w(nt, ye);
          Ge = !!mn, Ge && "get" in mn && !("originalValue" in mn.get) ? nt = mn.get : nt = nt[ye];
        } else
          Ge = L(nt, ye), nt = nt[ye];
        Ge && !Et && (k[et] = nt);
      }
    }
    return nt;
  }, kl;
}
var Bl, hp;
function zg() {
  if (hp) return Bl;
  hp = 1;
  var n = /* @__PURE__ */ sd(), t = Gg(), e = t([n("%String.prototype.indexOf%")]);
  return Bl = function(i, s) {
    var o = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      n(i, !!s)
    );
    return typeof o == "function" && e(i, ".prototype.") > -1 ? t(
      /** @type {const} */
      [o]
    ) : o;
  }, Bl;
}
var Ll, lp;
function Wg() {
  if (lp) return Ll;
  lp = 1;
  var n = /* @__PURE__ */ sd(), t = /* @__PURE__ */ zg(), e = /* @__PURE__ */ Eh(), r = /* @__PURE__ */ Ts(), i = n("%Map%", !0), s = t("Map.prototype.get", !0), o = t("Map.prototype.set", !0), a = t("Map.prototype.has", !0), h = t("Map.prototype.delete", !0), l = t("Map.prototype.size", !0);
  return Ll = !!i && /** @type {Exclude<import('.'), false>} */
  function() {
    var c, d = {
      assert: function(f) {
        if (!d.has(f))
          throw new r("Side channel does not contain " + e(f));
      },
      delete: function(f) {
        if (c) {
          var p = h(c, f);
          return l(c) === 0 && (c = void 0), p;
        }
        return !1;
      },
      get: function(f) {
        if (c)
          return s(c, f);
      },
      has: function(f) {
        return c ? a(c, f) : !1;
      },
      set: function(f, p) {
        c || (c = new i()), o(c, f, p);
      }
    };
    return d;
  }, Ll;
}
var Ul, up;
function gx() {
  if (up) return Ul;
  up = 1;
  var n = /* @__PURE__ */ sd(), t = /* @__PURE__ */ zg(), e = /* @__PURE__ */ Eh(), r = Wg(), i = /* @__PURE__ */ Ts(), s = n("%WeakMap%", !0), o = t("WeakMap.prototype.get", !0), a = t("WeakMap.prototype.set", !0), h = t("WeakMap.prototype.has", !0), l = t("WeakMap.prototype.delete", !0);
  return Ul = s ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var c, d, f = {
        assert: function(p) {
          if (!f.has(p))
            throw new i("Side channel does not contain " + e(p));
        },
        delete: function(p) {
          if (s && p && (typeof p == "object" || typeof p == "function")) {
            if (c)
              return l(c, p);
          } else if (r && d)
            return d.delete(p);
          return !1;
        },
        get: function(p) {
          return s && p && (typeof p == "object" || typeof p == "function") && c ? o(c, p) : d && d.get(p);
        },
        has: function(p) {
          return s && p && (typeof p == "object" || typeof p == "function") && c ? h(c, p) : !!d && d.has(p);
        },
        set: function(p, m) {
          s && p && (typeof p == "object" || typeof p == "function") ? (c || (c = new s()), a(c, p, m)) : r && (d || (d = r()), d.set(p, m));
        }
      };
      return f;
    }
  ) : r, Ul;
}
var Hl, cp;
function $g() {
  if (cp) return Hl;
  cp = 1;
  var n = /* @__PURE__ */ Ts(), t = /* @__PURE__ */ Eh(), e = X1(), r = Wg(), i = gx(), s = i || r || e;
  return Hl = function() {
    var a, h = {
      assert: function(l) {
        if (!h.has(l))
          throw new n("Side channel does not contain " + t(l));
      },
      delete: function(l) {
        return !!a && a.delete(l);
      },
      get: function(l) {
        return a && a.get(l);
      },
      has: function(l) {
        return !!a && a.has(l);
      },
      set: function(l, u) {
        a || (a = s()), a.set(l, u);
      }
    };
    return h;
  }, Hl;
}
var Gl, dp;
function od() {
  if (dp) return Gl;
  dp = 1;
  var n = String.prototype.replace, t = /%20/g, e = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Gl = {
    default: e.RFC3986,
    formatters: {
      RFC1738: function(r) {
        return n.call(r, t, "+");
      },
      RFC3986: function(r) {
        return String(r);
      }
    },
    RFC1738: e.RFC1738,
    RFC3986: e.RFC3986
  }, Gl;
}
var zl, fp;
function Xg() {
  if (fp) return zl;
  fp = 1;
  var n = /* @__PURE__ */ od(), t = $g(), e = Object.prototype.hasOwnProperty, r = Array.isArray, i = t(), s = function(y, C) {
    return i.set(y, C), y;
  }, o = function(y) {
    return i.has(y);
  }, a = function(y) {
    return i.get(y);
  }, h = function(y, C) {
    i.set(y, C);
  }, l = (function() {
    for (var b = [], y = 0; y < 256; ++y)
      b.push("%" + ((y < 16 ? "0" : "") + y.toString(16)).toUpperCase());
    return b;
  })(), u = function(y) {
    for (; y.length > 1; ) {
      var C = y.pop(), M = C.obj[C.prop];
      if (r(M)) {
        for (var U = [], F = 0; F < M.length; ++F)
          typeof M[F] < "u" && U.push(M[F]);
        C.obj[C.prop] = U;
      }
    }
  }, c = function(y, C) {
    for (var M = C && C.plainObjects ? { __proto__: null } : {}, U = 0; U < y.length; ++U)
      typeof y[U] < "u" && (M[U] = y[U]);
    return M;
  }, d = function b(y, C, M) {
    if (!C)
      return y;
    if (typeof C != "object" && typeof C != "function") {
      if (r(y))
        y.push(C);
      else if (y && typeof y == "object")
        if (o(y)) {
          var U = a(y) + 1;
          y[U] = C, h(y, U);
        } else (M && (M.plainObjects || M.allowPrototypes) || !e.call(Object.prototype, C)) && (y[C] = !0);
      else
        return [y, C];
      return y;
    }
    if (!y || typeof y != "object") {
      if (o(C)) {
        for (var F = Object.keys(C), O = M && M.plainObjects ? { __proto__: null, 0: y } : { 0: y }, R = 0; R < F.length; R++) {
          var k = parseInt(F[R], 10);
          O[k + 1] = C[F[R]];
        }
        return s(O, a(C) + 1);
      }
      return [y].concat(C);
    }
    var j = y;
    return r(y) && !r(C) && (j = c(y, M)), r(y) && r(C) ? (C.forEach(function(T, S) {
      if (e.call(y, S)) {
        var A = y[S];
        A && typeof A == "object" && T && typeof T == "object" ? y[S] = b(A, T, M) : y.push(T);
      } else
        y[S] = T;
    }), y) : Object.keys(C).reduce(function(T, S) {
      var A = C[S];
      return e.call(T, S) ? T[S] = b(T[S], A, M) : T[S] = A, T;
    }, j);
  }, f = function(y, C) {
    return Object.keys(C).reduce(function(M, U) {
      return M[U] = C[U], M;
    }, y);
  }, p = function(b, y, C) {
    var M = b.replace(/\+/g, " ");
    if (C === "iso-8859-1")
      return M.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(M);
    } catch {
      return M;
    }
  }, m = 1024, g = function(y, C, M, U, F) {
    if (y.length === 0)
      return y;
    var O = y;
    if (typeof y == "symbol" ? O = Symbol.prototype.toString.call(y) : typeof y != "string" && (O = String(y)), M === "iso-8859-1")
      return escape(O).replace(/%u[0-9a-f]{4}/gi, function(L) {
        return "%26%23" + parseInt(L.slice(2), 16) + "%3B";
      });
    for (var R = "", k = 0; k < O.length; k += m) {
      for (var j = O.length >= m ? O.slice(k, k + m) : O, T = [], S = 0; S < j.length; ++S) {
        var A = j.charCodeAt(S);
        if (A === 45 || A === 46 || A === 95 || A === 126 || A >= 48 && A <= 57 || A >= 65 && A <= 90 || A >= 97 && A <= 122 || F === n.RFC1738 && (A === 40 || A === 41)) {
          T[T.length] = j.charAt(S);
          continue;
        }
        if (A < 128) {
          T[T.length] = l[A];
          continue;
        }
        if (A < 2048) {
          T[T.length] = l[192 | A >> 6] + l[128 | A & 63];
          continue;
        }
        if (A < 55296 || A >= 57344) {
          T[T.length] = l[224 | A >> 12] + l[128 | A >> 6 & 63] + l[128 | A & 63];
          continue;
        }
        S += 1, A = 65536 + ((A & 1023) << 10 | j.charCodeAt(S) & 1023), T[T.length] = l[240 | A >> 18] + l[128 | A >> 12 & 63] + l[128 | A >> 6 & 63] + l[128 | A & 63];
      }
      R += T.join("");
    }
    return R;
  }, _ = function(y) {
    for (var C = [{ obj: { o: y }, prop: "o" }], M = [], U = 0; U < C.length; ++U)
      for (var F = C[U], O = F.obj[F.prop], R = Object.keys(O), k = 0; k < R.length; ++k) {
        var j = R[k], T = O[j];
        typeof T == "object" && T !== null && M.indexOf(T) === -1 && (C.push({ obj: O, prop: j }), M.push(T));
      }
    return u(C), y;
  }, w = function(y) {
    return Object.prototype.toString.call(y) === "[object RegExp]";
  }, v = function(y) {
    return !y || typeof y != "object" ? !1 : !!(y.constructor && y.constructor.isBuffer && y.constructor.isBuffer(y));
  }, E = function(y, C, M, U) {
    if (o(y)) {
      var F = a(y) + 1;
      return y[F] = C, h(y, F), y;
    }
    var O = [].concat(y, C);
    return O.length > M ? s(c(O, { plainObjects: U }), O.length - 1) : O;
  }, x = function(y, C) {
    if (r(y)) {
      for (var M = [], U = 0; U < y.length; U += 1)
        M.push(C(y[U]));
      return M;
    }
    return C(y);
  };
  return zl = {
    arrayToObject: c,
    assign: f,
    combine: E,
    compact: _,
    decode: p,
    encode: g,
    isBuffer: v,
    isOverflow: o,
    isRegExp: w,
    maybeMap: x,
    merge: d
  }, zl;
}
var Wl, pp;
function yx() {
  if (pp) return Wl;
  pp = 1;
  var n = $g(), t = /* @__PURE__ */ Xg(), e = /* @__PURE__ */ od(), r = Object.prototype.hasOwnProperty, i = {
    brackets: function(g) {
      return g + "[]";
    },
    comma: "comma",
    indices: function(g, _) {
      return g + "[" + _ + "]";
    },
    repeat: function(g) {
      return g;
    }
  }, s = Array.isArray, o = Array.prototype.push, a = function(m, g) {
    o.apply(m, s(g) ? g : [g]);
  }, h = Date.prototype.toISOString, l = e.default, u = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: l,
    formatter: e.formatters[l],
    // deprecated
    indices: !1,
    serializeDate: function(g) {
      return h.call(g);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, c = function(g) {
    return typeof g == "string" || typeof g == "number" || typeof g == "boolean" || typeof g == "symbol" || typeof g == "bigint";
  }, d = {}, f = function m(g, _, w, v, E, x, b, y, C, M, U, F, O, R, k, j, T, S) {
    for (var A = g, L = S, D = 0, P = !1; (L = L.get(d)) !== void 0 && !P; ) {
      var N = L.get(g);
      if (D += 1, typeof N < "u") {
        if (N === D)
          throw new RangeError("Cyclic object value");
        P = !0;
      }
      typeof L.get(d) > "u" && (D = 0);
    }
    if (typeof M == "function" ? A = M(_, A) : A instanceof Date ? A = O(A) : w === "comma" && s(A) && (A = t.maybeMap(A, function(et) {
      return et instanceof Date ? O(et) : et;
    })), A === null) {
      if (x)
        return C && !j ? C(_, u.encoder, T, "key", R) : _;
      A = "";
    }
    if (c(A) || t.isBuffer(A)) {
      if (C) {
        var B = j ? _ : C(_, u.encoder, T, "key", R);
        return [k(B) + "=" + k(C(A, u.encoder, T, "value", R))];
      }
      return [k(_) + "=" + k(String(A))];
    }
    var X = [];
    if (typeof A > "u")
      return X;
    var V;
    if (w === "comma" && s(A))
      j && C && (A = t.maybeMap(A, C)), V = [{ value: A.length > 0 ? A.join(",") || null : void 0 }];
    else if (s(M))
      V = M;
    else {
      var J = Object.keys(A);
      V = U ? J.sort(U) : J;
    }
    var tt = y ? String(_).replace(/\./g, "%2E") : String(_), K = v && s(A) && A.length === 1 ? tt + "[]" : tt;
    if (E && s(A) && A.length === 0)
      return K + "[]";
    for (var G = 0; G < V.length; ++G) {
      var W = V[G], q = typeof W == "object" && W && typeof W.value < "u" ? W.value : A[W];
      if (!(b && q === null)) {
        var z = F && y ? String(W).replace(/\./g, "%2E") : String(W), ot = s(A) ? typeof w == "function" ? w(K, z) : K : K + (F ? "." + z : "[" + z + "]");
        S.set(g, D);
        var rt = n();
        rt.set(d, S), a(X, m(
          q,
          ot,
          w,
          v,
          E,
          x,
          b,
          y,
          w === "comma" && j && s(A) ? null : C,
          M,
          U,
          F,
          O,
          R,
          k,
          j,
          T,
          rt
        ));
      }
    }
    return X;
  }, p = function(g) {
    if (!g)
      return u;
    if (typeof g.allowEmptyArrays < "u" && typeof g.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof g.encodeDotInKeys < "u" && typeof g.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (g.encoder !== null && typeof g.encoder < "u" && typeof g.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var _ = g.charset || u.charset;
    if (typeof g.charset < "u" && g.charset !== "utf-8" && g.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var w = e.default;
    if (typeof g.format < "u") {
      if (!r.call(e.formatters, g.format))
        throw new TypeError("Unknown format option provided.");
      w = g.format;
    }
    var v = e.formatters[w], E = u.filter;
    (typeof g.filter == "function" || s(g.filter)) && (E = g.filter);
    var x;
    if (g.arrayFormat in i ? x = g.arrayFormat : "indices" in g ? x = g.indices ? "indices" : "repeat" : x = u.arrayFormat, "commaRoundTrip" in g && typeof g.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var b = typeof g.allowDots > "u" ? g.encodeDotInKeys === !0 ? !0 : u.allowDots : !!g.allowDots;
    return {
      addQueryPrefix: typeof g.addQueryPrefix == "boolean" ? g.addQueryPrefix : u.addQueryPrefix,
      allowDots: b,
      allowEmptyArrays: typeof g.allowEmptyArrays == "boolean" ? !!g.allowEmptyArrays : u.allowEmptyArrays,
      arrayFormat: x,
      charset: _,
      charsetSentinel: typeof g.charsetSentinel == "boolean" ? g.charsetSentinel : u.charsetSentinel,
      commaRoundTrip: !!g.commaRoundTrip,
      delimiter: typeof g.delimiter > "u" ? u.delimiter : g.delimiter,
      encode: typeof g.encode == "boolean" ? g.encode : u.encode,
      encodeDotInKeys: typeof g.encodeDotInKeys == "boolean" ? g.encodeDotInKeys : u.encodeDotInKeys,
      encoder: typeof g.encoder == "function" ? g.encoder : u.encoder,
      encodeValuesOnly: typeof g.encodeValuesOnly == "boolean" ? g.encodeValuesOnly : u.encodeValuesOnly,
      filter: E,
      format: w,
      formatter: v,
      serializeDate: typeof g.serializeDate == "function" ? g.serializeDate : u.serializeDate,
      skipNulls: typeof g.skipNulls == "boolean" ? g.skipNulls : u.skipNulls,
      sort: typeof g.sort == "function" ? g.sort : null,
      strictNullHandling: typeof g.strictNullHandling == "boolean" ? g.strictNullHandling : u.strictNullHandling
    };
  };
  return Wl = function(m, g) {
    var _ = m, w = p(g), v, E;
    typeof w.filter == "function" ? (E = w.filter, _ = E("", _)) : s(w.filter) && (E = w.filter, v = E);
    var x = [];
    if (typeof _ != "object" || _ === null)
      return "";
    var b = i[w.arrayFormat], y = b === "comma" && w.commaRoundTrip;
    v || (v = Object.keys(_)), w.sort && v.sort(w.sort);
    for (var C = n(), M = 0; M < v.length; ++M) {
      var U = v[M], F = _[U];
      w.skipNulls && F === null || a(x, f(
        F,
        U,
        b,
        y,
        w.allowEmptyArrays,
        w.strictNullHandling,
        w.skipNulls,
        w.encodeDotInKeys,
        w.encode ? w.encoder : null,
        w.filter,
        w.sort,
        w.allowDots,
        w.serializeDate,
        w.format,
        w.formatter,
        w.encodeValuesOnly,
        w.charset,
        C
      ));
    }
    var O = x.join(w.delimiter), R = w.addQueryPrefix === !0 ? "?" : "";
    return w.charsetSentinel && (w.charset === "iso-8859-1" ? R += "utf8=%26%2310003%3B&" : R += "utf8=%E2%9C%93&"), O.length > 0 ? R + O : "";
  }, Wl;
}
var $l, mp;
function _x() {
  if (mp) return $l;
  mp = 1;
  var n = /* @__PURE__ */ Xg(), t = Object.prototype.hasOwnProperty, e = Array.isArray, r = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: n.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, i = function(f) {
    return f.replace(/&#(\d+);/g, function(p, m) {
      return String.fromCharCode(parseInt(m, 10));
    });
  }, s = function(f, p, m) {
    if (f && typeof f == "string" && p.comma && f.indexOf(",") > -1)
      return f.split(",");
    if (p.throwOnLimitExceeded && m >= p.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + p.arrayLimit + " element" + (p.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return f;
  }, o = "utf8=%26%2310003%3B", a = "utf8=%E2%9C%93", h = function(p, m) {
    var g = { __proto__: null }, _ = m.ignoreQueryPrefix ? p.replace(/^\?/, "") : p;
    _ = _.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var w = m.parameterLimit === 1 / 0 ? void 0 : m.parameterLimit, v = _.split(
      m.delimiter,
      m.throwOnLimitExceeded ? w + 1 : w
    );
    if (m.throwOnLimitExceeded && v.length > w)
      throw new RangeError("Parameter limit exceeded. Only " + w + " parameter" + (w === 1 ? "" : "s") + " allowed.");
    var E = -1, x, b = m.charset;
    if (m.charsetSentinel)
      for (x = 0; x < v.length; ++x)
        v[x].indexOf("utf8=") === 0 && (v[x] === a ? b = "utf-8" : v[x] === o && (b = "iso-8859-1"), E = x, x = v.length);
    for (x = 0; x < v.length; ++x)
      if (x !== E) {
        var y = v[x], C = y.indexOf("]="), M = C === -1 ? y.indexOf("=") : C + 1, U, F;
        if (M === -1 ? (U = m.decoder(y, r.decoder, b, "key"), F = m.strictNullHandling ? null : "") : (U = m.decoder(y.slice(0, M), r.decoder, b, "key"), U !== null && (F = n.maybeMap(
          s(
            y.slice(M + 1),
            m,
            e(g[U]) ? g[U].length : 0
          ),
          function(R) {
            return m.decoder(R, r.decoder, b, "value");
          }
        ))), F && m.interpretNumericEntities && b === "iso-8859-1" && (F = i(String(F))), y.indexOf("[]=") > -1 && (F = e(F) ? [F] : F), U !== null) {
          var O = t.call(g, U);
          O && m.duplicates === "combine" ? g[U] = n.combine(
            g[U],
            F,
            m.arrayLimit,
            m.plainObjects
          ) : (!O || m.duplicates === "last") && (g[U] = F);
        }
      }
    return g;
  }, l = function(f, p, m, g) {
    var _ = 0;
    if (f.length > 0 && f[f.length - 1] === "[]") {
      var w = f.slice(0, -1).join("");
      _ = Array.isArray(p) && p[w] ? p[w].length : 0;
    }
    for (var v = g ? p : s(p, m, _), E = f.length - 1; E >= 0; --E) {
      var x, b = f[E];
      if (b === "[]" && m.parseArrays)
        n.isOverflow(v) ? x = v : x = m.allowEmptyArrays && (v === "" || m.strictNullHandling && v === null) ? [] : n.combine(
          [],
          v,
          m.arrayLimit,
          m.plainObjects
        );
      else {
        x = m.plainObjects ? { __proto__: null } : {};
        var y = b.charAt(0) === "[" && b.charAt(b.length - 1) === "]" ? b.slice(1, -1) : b, C = m.decodeDotInKeys ? y.replace(/%2E/g, ".") : y, M = parseInt(C, 10);
        !m.parseArrays && C === "" ? x = { 0: v } : !isNaN(M) && b !== C && String(M) === C && M >= 0 && m.parseArrays && M <= m.arrayLimit ? (x = [], x[M] = v) : C !== "__proto__" && (x[C] = v);
      }
      v = x;
    }
    return v;
  }, u = function(p, m) {
    var g = m.allowDots ? p.replace(/\.([^.[]+)/g, "[$1]") : p;
    if (m.depth <= 0)
      return !m.plainObjects && t.call(Object.prototype, g) && !m.allowPrototypes ? void 0 : [g];
    var _ = /(\[[^[\]]*])/, w = /(\[[^[\]]*])/g, v = _.exec(g), E = v ? g.slice(0, v.index) : g, x = [];
    if (E) {
      if (!m.plainObjects && t.call(Object.prototype, E) && !m.allowPrototypes)
        return;
      x.push(E);
    }
    for (var b = 0; (v = w.exec(g)) !== null && b < m.depth; ) {
      b += 1;
      var y = v[1].slice(1, -1);
      if (!m.plainObjects && t.call(Object.prototype, y) && !m.allowPrototypes)
        return;
      x.push(v[1]);
    }
    if (v) {
      if (m.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + m.depth + " and strictDepth is true");
      x.push("[" + g.slice(v.index) + "]");
    }
    return x;
  }, c = function(p, m, g, _) {
    if (p) {
      var w = u(p, g);
      if (w)
        return l(w, m, g, _);
    }
  }, d = function(p) {
    if (!p)
      return r;
    if (typeof p.allowEmptyArrays < "u" && typeof p.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof p.decodeDotInKeys < "u" && typeof p.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (p.decoder !== null && typeof p.decoder < "u" && typeof p.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof p.charset < "u" && p.charset !== "utf-8" && p.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof p.throwOnLimitExceeded < "u" && typeof p.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var m = typeof p.charset > "u" ? r.charset : p.charset, g = typeof p.duplicates > "u" ? r.duplicates : p.duplicates;
    if (g !== "combine" && g !== "first" && g !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var _ = typeof p.allowDots > "u" ? p.decodeDotInKeys === !0 ? !0 : r.allowDots : !!p.allowDots;
    return {
      allowDots: _,
      allowEmptyArrays: typeof p.allowEmptyArrays == "boolean" ? !!p.allowEmptyArrays : r.allowEmptyArrays,
      allowPrototypes: typeof p.allowPrototypes == "boolean" ? p.allowPrototypes : r.allowPrototypes,
      allowSparse: typeof p.allowSparse == "boolean" ? p.allowSparse : r.allowSparse,
      arrayLimit: typeof p.arrayLimit == "number" ? p.arrayLimit : r.arrayLimit,
      charset: m,
      charsetSentinel: typeof p.charsetSentinel == "boolean" ? p.charsetSentinel : r.charsetSentinel,
      comma: typeof p.comma == "boolean" ? p.comma : r.comma,
      decodeDotInKeys: typeof p.decodeDotInKeys == "boolean" ? p.decodeDotInKeys : r.decodeDotInKeys,
      decoder: typeof p.decoder == "function" ? p.decoder : r.decoder,
      delimiter: typeof p.delimiter == "string" || n.isRegExp(p.delimiter) ? p.delimiter : r.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof p.depth == "number" || p.depth === !1 ? +p.depth : r.depth,
      duplicates: g,
      ignoreQueryPrefix: p.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof p.interpretNumericEntities == "boolean" ? p.interpretNumericEntities : r.interpretNumericEntities,
      parameterLimit: typeof p.parameterLimit == "number" ? p.parameterLimit : r.parameterLimit,
      parseArrays: p.parseArrays !== !1,
      plainObjects: typeof p.plainObjects == "boolean" ? p.plainObjects : r.plainObjects,
      strictDepth: typeof p.strictDepth == "boolean" ? !!p.strictDepth : r.strictDepth,
      strictNullHandling: typeof p.strictNullHandling == "boolean" ? p.strictNullHandling : r.strictNullHandling,
      throwOnLimitExceeded: typeof p.throwOnLimitExceeded == "boolean" ? p.throwOnLimitExceeded : !1
    };
  };
  return $l = function(f, p) {
    var m = d(p);
    if (f === "" || f === null || typeof f > "u")
      return m.plainObjects ? { __proto__: null } : {};
    for (var g = typeof f == "string" ? h(f, m) : f, _ = m.plainObjects ? { __proto__: null } : {}, w = Object.keys(g), v = 0; v < w.length; ++v) {
      var E = w[v], x = c(E, g[E], m, typeof f == "string");
      _ = n.merge(_, x, m);
    }
    return m.allowSparse === !0 ? _ : n.compact(_);
  }, $l;
}
var Xl, gp;
function vx() {
  if (gp) return Xl;
  gp = 1;
  var n = /* @__PURE__ */ yx(), t = /* @__PURE__ */ _x(), e = /* @__PURE__ */ od();
  return Xl = {
    formats: e,
    parse: t,
    stringify: n
  }, Xl;
}
var yp;
function xx() {
  if (yp) return Qn;
  yp = 1;
  var n = G1();
  function t() {
    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
  }
  var e = /^([a-z0-9.+-]+:)/i, r = /:[0-9]*$/, i = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, s = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    `
`,
    "	"
  ], o = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
  ].concat(s), a = ["'"].concat(o), h = [
    "%",
    "/",
    "?",
    ";",
    "#"
  ].concat(a), l = [
    "/",
    "?",
    "#"
  ], u = 255, c = /^[+a-z0-9A-Z_-]{0,63}$/, d = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, f = {
    javascript: !0,
    "javascript:": !0
  }, p = {
    javascript: !0,
    "javascript:": !0
  }, m = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0
  }, g = /* @__PURE__ */ vx();
  function _(x, b, y) {
    if (x && typeof x == "object" && x instanceof t)
      return x;
    var C = new t();
    return C.parse(x, b, y), C;
  }
  t.prototype.parse = function(x, b, y) {
    if (typeof x != "string")
      throw new TypeError("Parameter 'url' must be a string, not " + typeof x);
    var C = x.indexOf("?"), M = C !== -1 && C < x.indexOf("#") ? "?" : "#", U = x.split(M), F = /\\/g;
    U[0] = U[0].replace(F, "/"), x = U.join(M);
    var O = x;
    if (O = O.trim(), !y && x.split("#").length === 1) {
      var R = i.exec(O);
      if (R)
        return this.path = O, this.href = O, this.pathname = R[1], R[2] ? (this.search = R[2], b ? this.query = g.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : b && (this.search = "", this.query = {}), this;
    }
    var k = e.exec(O);
    if (k) {
      k = k[0];
      var j = k.toLowerCase();
      this.protocol = j, O = O.substr(k.length);
    }
    if (y || k || O.match(/^\/\/[^@/]+@[^@/]+/)) {
      var T = O.substr(0, 2) === "//";
      T && !(k && p[k]) && (O = O.substr(2), this.slashes = !0);
    }
    if (!p[k] && (T || k && !m[k])) {
      for (var S = -1, A = 0; A < l.length; A++) {
        var L = O.indexOf(l[A]);
        L !== -1 && (S === -1 || L < S) && (S = L);
      }
      var D, P;
      S === -1 ? P = O.lastIndexOf("@") : P = O.lastIndexOf("@", S), P !== -1 && (D = O.slice(0, P), O = O.slice(P + 1), this.auth = decodeURIComponent(D)), S = -1;
      for (var A = 0; A < h.length; A++) {
        var L = O.indexOf(h[A]);
        L !== -1 && (S === -1 || L < S) && (S = L);
      }
      S === -1 && (S = O.length), this.host = O.slice(0, S), O = O.slice(S), this.parseHost(), this.hostname = this.hostname || "";
      var N = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
      if (!N)
        for (var B = this.hostname.split(/\./), A = 0, X = B.length; A < X; A++) {
          var V = B[A];
          if (V && !V.match(c)) {
            for (var J = "", tt = 0, K = V.length; tt < K; tt++)
              V.charCodeAt(tt) > 127 ? J += "x" : J += V[tt];
            if (!J.match(c)) {
              var G = B.slice(0, A), W = B.slice(A + 1), q = V.match(d);
              q && (G.push(q[1]), W.unshift(q[2])), W.length && (O = "/" + W.join(".") + O), this.hostname = G.join(".");
              break;
            }
          }
        }
      this.hostname.length > u ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), N || (this.hostname = n.toASCII(this.hostname));
      var z = this.port ? ":" + this.port : "", ot = this.hostname || "";
      this.host = ot + z, this.href += this.host, N && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), O[0] !== "/" && (O = "/" + O));
    }
    if (!f[j])
      for (var A = 0, X = a.length; A < X; A++) {
        var rt = a[A];
        if (O.indexOf(rt) !== -1) {
          var et = encodeURIComponent(rt);
          et === rt && (et = escape(rt)), O = O.split(rt).join(et);
        }
      }
    var nt = O.indexOf("#");
    nt !== -1 && (this.hash = O.substr(nt), O = O.slice(0, nt));
    var Et = O.indexOf("?");
    if (Et !== -1 ? (this.search = O.substr(Et), this.query = O.substr(Et + 1), b && (this.query = g.parse(this.query)), O = O.slice(0, Et)) : b && (this.search = "", this.query = {}), O && (this.pathname = O), m[j] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
      var z = this.pathname || "", Dt = this.search || "";
      this.path = z + Dt;
    }
    return this.href = this.format(), this;
  };
  function w(x) {
    return typeof x == "string" && (x = _(x)), x instanceof t ? x.format() : t.prototype.format.call(x);
  }
  t.prototype.format = function() {
    var x = this.auth || "";
    x && (x = encodeURIComponent(x), x = x.replace(/%3A/i, ":"), x += "@");
    var b = this.protocol || "", y = this.pathname || "", C = this.hash || "", M = !1, U = "";
    this.host ? M = x + this.host : this.hostname && (M = x + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (M += ":" + this.port)), this.query && typeof this.query == "object" && Object.keys(this.query).length && (U = g.stringify(this.query, {
      arrayFormat: "repeat",
      addQueryPrefix: !1
    }));
    var F = this.search || U && "?" + U || "";
    return b && b.substr(-1) !== ":" && (b += ":"), this.slashes || (!b || m[b]) && M !== !1 ? (M = "//" + (M || ""), y && y.charAt(0) !== "/" && (y = "/" + y)) : M || (M = ""), C && C.charAt(0) !== "#" && (C = "#" + C), F && F.charAt(0) !== "?" && (F = "?" + F), y = y.replace(/[?#]/g, function(O) {
      return encodeURIComponent(O);
    }), F = F.replace("#", "%23"), b + M + y + F + C;
  };
  function v(x, b) {
    return _(x, !1, !0).resolve(b);
  }
  t.prototype.resolve = function(x) {
    return this.resolveObject(_(x, !1, !0)).format();
  };
  function E(x, b) {
    return x ? _(x, !1, !0).resolveObject(b) : b;
  }
  return t.prototype.resolveObject = function(x) {
    if (typeof x == "string") {
      var b = new t();
      b.parse(x, !1, !0), x = b;
    }
    for (var y = new t(), C = Object.keys(this), M = 0; M < C.length; M++) {
      var U = C[M];
      y[U] = this[U];
    }
    if (y.hash = x.hash, x.href === "")
      return y.href = y.format(), y;
    if (x.slashes && !x.protocol) {
      for (var F = Object.keys(x), O = 0; O < F.length; O++) {
        var R = F[O];
        R !== "protocol" && (y[R] = x[R]);
      }
      return m[y.protocol] && y.hostname && !y.pathname && (y.pathname = "/", y.path = y.pathname), y.href = y.format(), y;
    }
    if (x.protocol && x.protocol !== y.protocol) {
      if (!m[x.protocol]) {
        for (var k = Object.keys(x), j = 0; j < k.length; j++) {
          var T = k[j];
          y[T] = x[T];
        }
        return y.href = y.format(), y;
      }
      if (y.protocol = x.protocol, !x.host && !p[x.protocol]) {
        for (var X = (x.pathname || "").split("/"); X.length && !(x.host = X.shift()); )
          ;
        x.host || (x.host = ""), x.hostname || (x.hostname = ""), X[0] !== "" && X.unshift(""), X.length < 2 && X.unshift(""), y.pathname = X.join("/");
      } else
        y.pathname = x.pathname;
      if (y.search = x.search, y.query = x.query, y.host = x.host || "", y.auth = x.auth, y.hostname = x.hostname || x.host, y.port = x.port, y.pathname || y.search) {
        var S = y.pathname || "", A = y.search || "";
        y.path = S + A;
      }
      return y.slashes = y.slashes || x.slashes, y.href = y.format(), y;
    }
    var L = y.pathname && y.pathname.charAt(0) === "/", D = x.host || x.pathname && x.pathname.charAt(0) === "/", P = D || L || y.host && x.pathname, N = P, B = y.pathname && y.pathname.split("/") || [], X = x.pathname && x.pathname.split("/") || [], V = y.protocol && !m[y.protocol];
    if (V && (y.hostname = "", y.port = null, y.host && (B[0] === "" ? B[0] = y.host : B.unshift(y.host)), y.host = "", x.protocol && (x.hostname = null, x.port = null, x.host && (X[0] === "" ? X[0] = x.host : X.unshift(x.host)), x.host = null), P = P && (X[0] === "" || B[0] === "")), D)
      y.host = x.host || x.host === "" ? x.host : y.host, y.hostname = x.hostname || x.hostname === "" ? x.hostname : y.hostname, y.search = x.search, y.query = x.query, B = X;
    else if (X.length)
      B || (B = []), B.pop(), B = B.concat(X), y.search = x.search, y.query = x.query;
    else if (x.search != null) {
      if (V) {
        y.host = B.shift(), y.hostname = y.host;
        var J = y.host && y.host.indexOf("@") > 0 ? y.host.split("@") : !1;
        J && (y.auth = J.shift(), y.hostname = J.shift(), y.host = y.hostname);
      }
      return y.search = x.search, y.query = x.query, (y.pathname !== null || y.search !== null) && (y.path = (y.pathname ? y.pathname : "") + (y.search ? y.search : "")), y.href = y.format(), y;
    }
    if (!B.length)
      return y.pathname = null, y.search ? y.path = "/" + y.search : y.path = null, y.href = y.format(), y;
    for (var tt = B.slice(-1)[0], K = (y.host || x.host || B.length > 1) && (tt === "." || tt === "..") || tt === "", G = 0, W = B.length; W >= 0; W--)
      tt = B[W], tt === "." ? B.splice(W, 1) : tt === ".." ? (B.splice(W, 1), G++) : G && (B.splice(W, 1), G--);
    if (!P && !N)
      for (; G--; G)
        B.unshift("..");
    P && B[0] !== "" && (!B[0] || B[0].charAt(0) !== "/") && B.unshift(""), K && B.join("/").substr(-1) !== "/" && B.push("");
    var q = B[0] === "" || B[0] && B[0].charAt(0) === "/";
    if (V) {
      y.hostname = q ? "" : B.length ? B.shift() : "", y.host = y.hostname;
      var J = y.host && y.host.indexOf("@") > 0 ? y.host.split("@") : !1;
      J && (y.auth = J.shift(), y.hostname = J.shift(), y.host = y.hostname);
    }
    return P = P || y.host && B.length, P && !q && B.unshift(""), B.length > 0 ? y.pathname = B.join("/") : (y.pathname = null, y.path = null), (y.pathname !== null || y.search !== null) && (y.path = (y.pathname ? y.pathname : "") + (y.search ? y.search : "")), y.auth = x.auth || y.auth, y.slashes = y.slashes || x.slashes, y.href = y.format(), y;
  }, t.prototype.parseHost = function() {
    var x = this.host, b = r.exec(x);
    b && (b = b[0], b !== ":" && (this.port = b.substr(1)), x = x.substr(0, x.length - b.length)), x && (this.hostname = x);
  }, Qn.parse = _, Qn.resolve = v, Qn.resolveObject = E, Qn.format = w, Qn.Url = t, Qn;
}
xx();
const _p = {};
function wt(n, t, e = 3) {
  if (_p[t])
    return;
  let r = new Error().stack;
  typeof r > "u" ? console.warn("PixiJS Deprecation Warning: ", `${t}
Deprecated since v${n}`) : (r = r.split(`
`).splice(e).join(`
`), console.groupCollapsed ? (console.groupCollapsed(
    "%cPixiJS Deprecation Warning: %c%s",
    "color:#614108;background:#fffbe6",
    "font-weight:normal;color:#614108;background:#fffbe6",
    `${t}
Deprecated since v${n}`
  ), console.warn(r), console.groupEnd()) : (console.warn("PixiJS Deprecation Warning: ", `${t}
Deprecated since v${n}`), console.warn(r))), _p[t] = !0;
}
function ar(n) {
  if (typeof n != "string")
    throw new TypeError(`Path must be a string. Received ${JSON.stringify(n)}`);
}
function Os(n) {
  return n.split("?")[0].split("#")[0];
}
function wx(n) {
  return n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function bx(n, t, e) {
  return n.replace(new RegExp(wx(t), "g"), e);
}
function Tx(n, t) {
  let e = "", r = 0, i = -1, s = 0, o = -1;
  for (let a = 0; a <= n.length; ++a) {
    if (a < n.length)
      o = n.charCodeAt(a);
    else {
      if (o === 47)
        break;
      o = 47;
    }
    if (o === 47) {
      if (!(i === a - 1 || s === 1))
        if (i !== a - 1 && s === 2) {
          if (e.length < 2 || r !== 2 || e.charCodeAt(e.length - 1) !== 46 || e.charCodeAt(e.length - 2) !== 46) {
            if (e.length > 2) {
              const h = e.lastIndexOf("/");
              if (h !== e.length - 1) {
                h === -1 ? (e = "", r = 0) : (e = e.slice(0, h), r = e.length - 1 - e.lastIndexOf("/")), i = a, s = 0;
                continue;
              }
            } else if (e.length === 2 || e.length === 1) {
              e = "", r = 0, i = a, s = 0;
              continue;
            }
          }
        } else
          e.length > 0 ? e += `/${n.slice(i + 1, a)}` : e = n.slice(i + 1, a), r = a - i - 1;
      i = a, s = 0;
    } else
      o === 46 && s !== -1 ? ++s : s = -1;
  }
  return e;
}
const ne = {
  /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   */
  toPosix(n) {
    return bx(n, "\\", "/");
  },
  /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   */
  isUrl(n) {
    return /^https?:/.test(this.toPosix(n));
  },
  /**
   * Checks if the path is a data URL
   * @param path - The path to check
   */
  isDataUrl(n) {
    return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(n);
  },
  /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   */
  isBlobUrl(n) {
    return n.startsWith("blob:");
  },
  /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   */
  hasProtocol(n) {
    return /^[^/:]+:/.test(this.toPosix(n));
  },
  /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   */
  getProtocol(n) {
    ar(n), n = this.toPosix(n);
    const t = /^file:\/\/\//.exec(n);
    if (t)
      return t[0];
    const e = /^[^/:]+:\/{0,2}/.exec(n);
    return e ? e[0] : "";
  },
  /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   */
  toAbsolute(n, t, e) {
    if (ar(n), this.isDataUrl(n) || this.isBlobUrl(n))
      return n;
    const r = Os(this.toPosix(t ?? ht.ADAPTER.getBaseUrl())), i = Os(this.toPosix(e ?? this.rootname(r)));
    return n = this.toPosix(n), n.startsWith("/") ? ne.join(i, n.slice(1)) : this.isAbsolute(n) ? n : this.join(r, n);
  },
  /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   */
  normalize(n) {
    if (ar(n), n.length === 0)
      return ".";
    if (this.isDataUrl(n) || this.isBlobUrl(n))
      return n;
    n = this.toPosix(n);
    let t = "";
    const e = n.startsWith("/");
    this.hasProtocol(n) && (t = this.rootname(n), n = n.slice(t.length));
    const r = n.endsWith("/");
    return n = Tx(n), n.length > 0 && r && (n += "/"), e ? `/${n}` : t + n;
  },
  /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   */
  isAbsolute(n) {
    return ar(n), n = this.toPosix(n), this.hasProtocol(n) ? !0 : n.startsWith("/");
  },
  /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   */
  join(...n) {
    if (n.length === 0)
      return ".";
    let t;
    for (let e = 0; e < n.length; ++e) {
      const r = n[e];
      if (ar(r), r.length > 0)
        if (t === void 0)
          t = r;
        else {
          const i = n[e - 1] ?? "";
          this.extname(i) ? t += `/../${r}` : t += `/${r}`;
        }
    }
    return t === void 0 ? "." : this.normalize(t);
  },
  /**
   * Returns the directory name of a path
   * @param path - The path to parse
   */
  dirname(n) {
    if (ar(n), n.length === 0)
      return ".";
    n = this.toPosix(n);
    let t = n.charCodeAt(0);
    const e = t === 47;
    let r = -1, i = !0;
    const s = this.getProtocol(n), o = n;
    n = n.slice(s.length);
    for (let a = n.length - 1; a >= 1; --a)
      if (t = n.charCodeAt(a), t === 47) {
        if (!i) {
          r = a;
          break;
        }
      } else
        i = !1;
    return r === -1 ? e ? "/" : this.isUrl(o) ? s + n : s : e && r === 1 ? "//" : s + n.slice(0, r);
  },
  /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   */
  rootname(n) {
    ar(n), n = this.toPosix(n);
    let t = "";
    if (n.startsWith("/") ? t = "/" : t = this.getProtocol(n), this.isUrl(n)) {
      const e = n.indexOf("/", t.length);
      e !== -1 ? t = n.slice(0, e) : t = n, t.endsWith("/") || (t += "/");
    }
    return t;
  },
  /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   */
  basename(n, t) {
    ar(n), t && ar(t), n = Os(this.toPosix(n));
    let e = 0, r = -1, i = !0, s;
    if (t !== void 0 && t.length > 0 && t.length <= n.length) {
      if (t.length === n.length && t === n)
        return "";
      let o = t.length - 1, a = -1;
      for (s = n.length - 1; s >= 0; --s) {
        const h = n.charCodeAt(s);
        if (h === 47) {
          if (!i) {
            e = s + 1;
            break;
          }
        } else
          a === -1 && (i = !1, a = s + 1), o >= 0 && (h === t.charCodeAt(o) ? --o === -1 && (r = s) : (o = -1, r = a));
      }
      return e === r ? r = a : r === -1 && (r = n.length), n.slice(e, r);
    }
    for (s = n.length - 1; s >= 0; --s)
      if (n.charCodeAt(s) === 47) {
        if (!i) {
          e = s + 1;
          break;
        }
      } else
        r === -1 && (i = !1, r = s + 1);
    return r === -1 ? "" : n.slice(e, r);
  },
  /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   */
  extname(n) {
    ar(n), n = Os(this.toPosix(n));
    let t = -1, e = 0, r = -1, i = !0, s = 0;
    for (let o = n.length - 1; o >= 0; --o) {
      const a = n.charCodeAt(o);
      if (a === 47) {
        if (!i) {
          e = o + 1;
          break;
        }
        continue;
      }
      r === -1 && (i = !1, r = o + 1), a === 46 ? t === -1 ? t = o : s !== 1 && (s = 1) : t !== -1 && (s = -1);
    }
    return t === -1 || r === -1 || s === 0 || s === 1 && t === r - 1 && t === e + 1 ? "" : n.slice(t, r);
  },
  /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   */
  parse(n) {
    ar(n);
    const t = { root: "", dir: "", base: "", ext: "", name: "" };
    if (n.length === 0)
      return t;
    n = Os(this.toPosix(n));
    let e = n.charCodeAt(0);
    const r = this.isAbsolute(n);
    let i;
    t.root = this.rootname(n), r || this.hasProtocol(n) ? i = 1 : i = 0;
    let s = -1, o = 0, a = -1, h = !0, l = n.length - 1, u = 0;
    for (; l >= i; --l) {
      if (e = n.charCodeAt(l), e === 47) {
        if (!h) {
          o = l + 1;
          break;
        }
        continue;
      }
      a === -1 && (h = !1, a = l + 1), e === 46 ? s === -1 ? s = l : u !== 1 && (u = 1) : s !== -1 && (u = -1);
    }
    return s === -1 || a === -1 || u === 0 || u === 1 && s === a - 1 && s === o + 1 ? a !== -1 && (o === 0 && r ? t.base = t.name = n.slice(1, a) : t.base = t.name = n.slice(o, a)) : (o === 0 && r ? (t.name = n.slice(1, s), t.base = n.slice(1, a)) : (t.name = n.slice(o, s), t.base = n.slice(o, a)), t.ext = n.slice(s, a)), t.dir = this.dirname(n), t;
  },
  sep: "/",
  delimiter: ":"
};
let Vl;
async function Ax() {
  return Vl ?? (Vl = (async () => {
    const n = document.createElement("canvas").getContext("webgl");
    if (!n)
      return Ae.UNPACK;
    const t = await new Promise((s) => {
      const o = document.createElement("video");
      o.onloadeddata = () => s(o), o.onerror = () => s(null), o.autoplay = !1, o.crossOrigin = "anonymous", o.preload = "auto", o.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=", o.load();
    });
    if (!t)
      return Ae.UNPACK;
    const e = n.createTexture();
    n.bindTexture(n.TEXTURE_2D, e);
    const r = n.createFramebuffer();
    n.bindFramebuffer(n.FRAMEBUFFER, r), n.framebufferTexture2D(
      n.FRAMEBUFFER,
      n.COLOR_ATTACHMENT0,
      n.TEXTURE_2D,
      e,
      0
    ), n.pixelStorei(n.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), n.pixelStorei(n.UNPACK_COLORSPACE_CONVERSION_WEBGL, n.NONE), n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, n.RGBA, n.UNSIGNED_BYTE, t);
    const i = new Uint8Array(4);
    return n.readPixels(0, 0, 1, 1, n.RGBA, n.UNSIGNED_BYTE, i), n.deleteFramebuffer(r), n.deleteTexture(e), n.getExtension("WEBGL_lose_context")?.loseContext(), i[0] <= i[3] ? Ae.PMA : Ae.UNPACK;
  })()), Vl;
}
let Yl;
function Ex() {
  return typeof Yl > "u" && (Yl = (function() {
    const n = {
      stencil: !0,
      failIfMajorPerformanceCaveat: ht.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT
    };
    try {
      if (!ht.ADAPTER.getWebGLRenderingContext())
        return !1;
      const t = ht.ADAPTER.createCanvas();
      let e = t.getContext("webgl", n) || t.getContext("experimental-webgl", n);
      const r = !!e?.getContextAttributes()?.stencil;
      if (e) {
        const i = e.getExtension("WEBGL_lose_context");
        i && i.loseContext();
      }
      return e = null, r;
    } catch {
      return !1;
    }
  })()), Yl;
}
var Sx = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, Yr = function(n) {
  return typeof n == "string" ? n.length > 0 : typeof n == "number";
}, oe = function(n, t, e) {
  return t === void 0 && (t = 0), e === void 0 && (e = Math.pow(10, t)), Math.round(e * n) / e + 0;
}, Ke = function(n, t, e) {
  return t === void 0 && (t = 0), e === void 0 && (e = 1), n > e ? e : n > t ? n : t;
}, Vg = function(n) {
  return (n = isFinite(n) ? n % 360 : 0) > 0 ? n : n + 360;
}, vp = function(n) {
  return { r: Ke(n.r, 0, 255), g: Ke(n.g, 0, 255), b: Ke(n.b, 0, 255), a: Ke(n.a) };
}, jl = function(n) {
  return { r: oe(n.r), g: oe(n.g), b: oe(n.b), a: oe(n.a, 3) };
}, Cx = /^#([0-9a-f]{3,8})$/i, Ko = function(n) {
  var t = n.toString(16);
  return t.length < 2 ? "0" + t : t;
}, Yg = function(n) {
  var t = n.r, e = n.g, r = n.b, i = n.a, s = Math.max(t, e, r), o = s - Math.min(t, e, r), a = o ? s === t ? (e - r) / o : s === e ? 2 + (r - t) / o : 4 + (t - e) / o : 0;
  return { h: 60 * (a < 0 ? a + 6 : a), s: s ? o / s * 100 : 0, v: s / 255 * 100, a: i };
}, jg = function(n) {
  var t = n.h, e = n.s, r = n.v, i = n.a;
  t = t / 360 * 6, e /= 100, r /= 100;
  var s = Math.floor(t), o = r * (1 - e), a = r * (1 - (t - s) * e), h = r * (1 - (1 - t + s) * e), l = s % 6;
  return { r: 255 * [r, a, o, o, h, r][l], g: 255 * [h, r, r, a, o, o][l], b: 255 * [o, o, h, r, r, a][l], a: i };
}, xp = function(n) {
  return { h: Vg(n.h), s: Ke(n.s, 0, 100), l: Ke(n.l, 0, 100), a: Ke(n.a) };
}, wp = function(n) {
  return { h: oe(n.h), s: oe(n.s), l: oe(n.l), a: oe(n.a, 3) };
}, bp = function(n) {
  return jg((e = (t = n).s, { h: t.h, s: (e *= ((r = t.l) < 50 ? r : 100 - r) / 100) > 0 ? 2 * e / (r + e) * 100 : 0, v: r + e, a: t.a }));
  var t, e, r;
}, ao = function(n) {
  return { h: (t = Yg(n)).h, s: (i = (200 - (e = t.s)) * (r = t.v) / 100) > 0 && i < 200 ? e * r / 100 / (i <= 100 ? i : 200 - i) * 100 : 0, l: i / 2, a: t.a };
  var t, e, r, i;
}, Mx = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Ix = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Px = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Rx = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Gu = { string: [[function(n) {
  var t = Cx.exec(n);
  return t ? (n = t[1]).length <= 4 ? { r: parseInt(n[0] + n[0], 16), g: parseInt(n[1] + n[1], 16), b: parseInt(n[2] + n[2], 16), a: n.length === 4 ? oe(parseInt(n[3] + n[3], 16) / 255, 2) : 1 } : n.length === 6 || n.length === 8 ? { r: parseInt(n.substr(0, 2), 16), g: parseInt(n.substr(2, 2), 16), b: parseInt(n.substr(4, 2), 16), a: n.length === 8 ? oe(parseInt(n.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(n) {
  var t = Px.exec(n) || Rx.exec(n);
  return t ? t[2] !== t[4] || t[4] !== t[6] ? null : vp({ r: Number(t[1]) / (t[2] ? 100 / 255 : 1), g: Number(t[3]) / (t[4] ? 100 / 255 : 1), b: Number(t[5]) / (t[6] ? 100 / 255 : 1), a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1) }) : null;
}, "rgb"], [function(n) {
  var t = Mx.exec(n) || Ix.exec(n);
  if (!t) return null;
  var e, r, i = xp({ h: (e = t[1], r = t[2], r === void 0 && (r = "deg"), Number(e) * (Sx[r] || 1)), s: Number(t[3]), l: Number(t[4]), a: t[5] === void 0 ? 1 : Number(t[5]) / (t[6] ? 100 : 1) });
  return bp(i);
}, "hsl"]], object: [[function(n) {
  var t = n.r, e = n.g, r = n.b, i = n.a, s = i === void 0 ? 1 : i;
  return Yr(t) && Yr(e) && Yr(r) ? vp({ r: Number(t), g: Number(e), b: Number(r), a: Number(s) }) : null;
}, "rgb"], [function(n) {
  var t = n.h, e = n.s, r = n.l, i = n.a, s = i === void 0 ? 1 : i;
  if (!Yr(t) || !Yr(e) || !Yr(r)) return null;
  var o = xp({ h: Number(t), s: Number(e), l: Number(r), a: Number(s) });
  return bp(o);
}, "hsl"], [function(n) {
  var t = n.h, e = n.s, r = n.v, i = n.a, s = i === void 0 ? 1 : i;
  if (!Yr(t) || !Yr(e) || !Yr(r)) return null;
  var o = (function(a) {
    return { h: Vg(a.h), s: Ke(a.s, 0, 100), v: Ke(a.v, 0, 100), a: Ke(a.a) };
  })({ h: Number(t), s: Number(e), v: Number(r), a: Number(s) });
  return jg(o);
}, "hsv"]] }, Tp = function(n, t) {
  for (var e = 0; e < t.length; e++) {
    var r = t[e][0](n);
    if (r) return [r, t[e][1]];
  }
  return [null, void 0];
}, Dx = function(n) {
  return typeof n == "string" ? Tp(n.trim(), Gu.string) : typeof n == "object" && n !== null ? Tp(n, Gu.object) : [null, void 0];
}, ql = function(n, t) {
  var e = ao(n);
  return { h: e.h, s: Ke(e.s + 100 * t, 0, 100), l: e.l, a: e.a };
}, Zl = function(n) {
  return (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 / 255;
}, Ap = function(n, t) {
  var e = ao(n);
  return { h: e.h, s: e.s, l: Ke(e.l + 100 * t, 0, 100), a: e.a };
}, zu = (function() {
  function n(t) {
    this.parsed = Dx(t)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return n.prototype.isValid = function() {
    return this.parsed !== null;
  }, n.prototype.brightness = function() {
    return oe(Zl(this.rgba), 2);
  }, n.prototype.isDark = function() {
    return Zl(this.rgba) < 0.5;
  }, n.prototype.isLight = function() {
    return Zl(this.rgba) >= 0.5;
  }, n.prototype.toHex = function() {
    return t = jl(this.rgba), e = t.r, r = t.g, i = t.b, o = (s = t.a) < 1 ? Ko(oe(255 * s)) : "", "#" + Ko(e) + Ko(r) + Ko(i) + o;
    var t, e, r, i, s, o;
  }, n.prototype.toRgb = function() {
    return jl(this.rgba);
  }, n.prototype.toRgbString = function() {
    return t = jl(this.rgba), e = t.r, r = t.g, i = t.b, (s = t.a) < 1 ? "rgba(" + e + ", " + r + ", " + i + ", " + s + ")" : "rgb(" + e + ", " + r + ", " + i + ")";
    var t, e, r, i, s;
  }, n.prototype.toHsl = function() {
    return wp(ao(this.rgba));
  }, n.prototype.toHslString = function() {
    return t = wp(ao(this.rgba)), e = t.h, r = t.s, i = t.l, (s = t.a) < 1 ? "hsla(" + e + ", " + r + "%, " + i + "%, " + s + ")" : "hsl(" + e + ", " + r + "%, " + i + "%)";
    var t, e, r, i, s;
  }, n.prototype.toHsv = function() {
    return t = Yg(this.rgba), { h: oe(t.h), s: oe(t.s), v: oe(t.v), a: oe(t.a, 3) };
    var t;
  }, n.prototype.invert = function() {
    return Tr({ r: 255 - (t = this.rgba).r, g: 255 - t.g, b: 255 - t.b, a: t.a });
    var t;
  }, n.prototype.saturate = function(t) {
    return t === void 0 && (t = 0.1), Tr(ql(this.rgba, t));
  }, n.prototype.desaturate = function(t) {
    return t === void 0 && (t = 0.1), Tr(ql(this.rgba, -t));
  }, n.prototype.grayscale = function() {
    return Tr(ql(this.rgba, -1));
  }, n.prototype.lighten = function(t) {
    return t === void 0 && (t = 0.1), Tr(Ap(this.rgba, t));
  }, n.prototype.darken = function(t) {
    return t === void 0 && (t = 0.1), Tr(Ap(this.rgba, -t));
  }, n.prototype.rotate = function(t) {
    return t === void 0 && (t = 15), this.hue(this.hue() + t);
  }, n.prototype.alpha = function(t) {
    return typeof t == "number" ? Tr({ r: (e = this.rgba).r, g: e.g, b: e.b, a: t }) : oe(this.rgba.a, 3);
    var e;
  }, n.prototype.hue = function(t) {
    var e = ao(this.rgba);
    return typeof t == "number" ? Tr({ h: t, s: e.s, l: e.l, a: e.a }) : oe(e.h);
  }, n.prototype.isEqual = function(t) {
    return this.toHex() === Tr(t).toHex();
  }, n;
})(), Tr = function(n) {
  return n instanceof zu ? n : new zu(n);
}, Ep = [], Fx = function(n) {
  n.forEach(function(t) {
    Ep.indexOf(t) < 0 && (t(zu, Gu), Ep.push(t));
  });
};
function Ox(n, t) {
  var e = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, r = {};
  for (var i in e) r[e[i]] = i;
  var s = {};
  n.prototype.toName = function(o) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
    var a, h, l = r[this.toHex()];
    if (l) return l;
    if (o?.closest) {
      var u = this.toRgb(), c = 1 / 0, d = "black";
      if (!s.length) for (var f in e) s[f] = new n(e[f]).toRgb();
      for (var p in e) {
        var m = (a = u, h = s[p], Math.pow(a.r - h.r, 2) + Math.pow(a.g - h.g, 2) + Math.pow(a.b - h.b, 2));
        m < c && (c = m, d = p);
      }
      return d;
    }
  }, t.string.push([function(o) {
    var a = o.toLowerCase(), h = a === "transparent" ? "#0000" : e[a];
    return h ? new n(h).toRgb() : null;
  }, "name"]);
}
Fx([Ox]);
const Wi = class Ta {
  /**
   * @param {PIXI.ColorSource} value - Optional value to use, if not provided, white is used.
   */
  constructor(t = 16777215) {
    this._value = null, this._components = new Float32Array(4), this._components.fill(1), this._int = 16777215, this.value = t;
  }
  /** Get red component (0 - 1) */
  get red() {
    return this._components[0];
  }
  /** Get green component (0 - 1) */
  get green() {
    return this._components[1];
  }
  /** Get blue component (0 - 1) */
  get blue() {
    return this._components[2];
  }
  /** Get alpha component (0 - 1) */
  get alpha() {
    return this._components[3];
  }
  /**
   * Set the value, suitable for chaining
   * @param value
   * @see PIXI.Color.value
   */
  setValue(t) {
    return this.value = t, this;
  }
  /**
   * The current color source.
   *
   * When setting:
   * - Setting to an instance of `Color` will copy its color source and components.
   * - Otherwise, `Color` will try to normalize the color source and set the components.
   *   If the color source is invalid, an `Error` will be thrown and the `Color` will left unchanged.
   *
   * Note: The `null` in the setter's parameter type is added to match the TypeScript rule: return type of getter
   * must be assignable to its setter's parameter type. Setting `value` to `null` will throw an `Error`.
   *
   * When getting:
   * - A return value of `null` means the previous value was overridden (e.g., {@link PIXI.Color.multiply multiply},
   *   {@link PIXI.Color.premultiply premultiply} or {@link PIXI.Color.round round}).
   * - Otherwise, the color source used when setting is returned.
   * @type {PIXI.ColorSource}
   */
  set value(t) {
    if (t instanceof Ta)
      this._value = this.cloneSource(t._value), this._int = t._int, this._components.set(t._components);
    else {
      if (t === null)
        throw new Error("Cannot set PIXI.Color#value to null");
      (this._value === null || !this.isSourceEqual(this._value, t)) && (this.normalize(t), this._value = this.cloneSource(t));
    }
  }
  get value() {
    return this._value;
  }
  /**
   * Copy a color source internally.
   * @param value - Color source
   */
  cloneSource(t) {
    return typeof t == "string" || typeof t == "number" || t instanceof Number || t === null ? t : Array.isArray(t) || ArrayBuffer.isView(t) ? t.slice(0) : typeof t == "object" && t !== null ? { ...t } : t;
  }
  /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */
  isSourceEqual(t, e) {
    const r = typeof t;
    if (r !== typeof e)
      return !1;
    if (r === "number" || r === "string" || t instanceof Number)
      return t === e;
    if (Array.isArray(t) && Array.isArray(e) || ArrayBuffer.isView(t) && ArrayBuffer.isView(e))
      return t.length !== e.length ? !1 : t.every((i, s) => i === e[s]);
    if (t !== null && e !== null) {
      const i = Object.keys(t), s = Object.keys(e);
      return i.length !== s.length ? !1 : i.every((o) => t[o] === e[o]);
    }
    return t === e;
  }
  /**
   * Convert to a RGBA color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1, a: 1 }
   */
  toRgba() {
    const [t, e, r, i] = this._components;
    return { r: t, g: e, b: r, a: i };
  }
  /**
   * Convert to a RGB color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1 }
   */
  toRgb() {
    const [t, e, r] = this._components;
    return { r: t, g: e, b: r };
  }
  /** Convert to a CSS-style rgba string: `rgba(255,255,255,1.0)`. */
  toRgbaString() {
    const [t, e, r] = this.toUint8RgbArray();
    return `rgba(${t},${e},${r},${this.alpha})`;
  }
  toUint8RgbArray(t) {
    const [e, r, i] = this._components;
    return t = t ?? [], t[0] = Math.round(e * 255), t[1] = Math.round(r * 255), t[2] = Math.round(i * 255), t;
  }
  toRgbArray(t) {
    t = t ?? [];
    const [e, r, i] = this._components;
    return t[0] = e, t[1] = r, t[2] = i, t;
  }
  /**
   * Convert to a hexadecimal number.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toNumber(); // returns 16777215
   */
  toNumber() {
    return this._int;
  }
  /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   * @returns {number} - The color as a number in little endian format.
   */
  toLittleEndianNumber() {
    const t = this._int;
    return (t >> 16) + (t & 65280) + ((t & 255) << 16);
  }
  /**
   * Multiply with another color. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param {PIXI.ColorSource} value - The color to multiply by.
   */
  multiply(t) {
    const [e, r, i, s] = Ta.temp.setValue(t)._components;
    return this._components[0] *= e, this._components[1] *= r, this._components[2] *= i, this._components[3] *= s, this.refreshInt(), this._value = null, this;
  }
  /**
   * Converts color to a premultiplied alpha format. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {PIXI.Color} - Itself.
   */
  premultiply(t, e = !0) {
    return e && (this._components[0] *= t, this._components[1] *= t, this._components[2] *= t), this._components[3] = t, this.refreshInt(), this._value = null, this;
  }
  /**
   * Premultiplies alpha with current color.
   * @param {number} alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {number} tint multiplied by alpha
   */
  toPremultiplied(t, e = !0) {
    if (t === 1)
      return (255 << 24) + this._int;
    if (t === 0)
      return e ? 0 : this._int;
    let r = this._int >> 16 & 255, i = this._int >> 8 & 255, s = this._int & 255;
    return e && (r = r * t + 0.5 | 0, i = i * t + 0.5 | 0, s = s * t + 0.5 | 0), (t * 255 << 24) + (r << 16) + (i << 8) + s;
  }
  /**
   * Convert to a hexidecimal string.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHex(); // returns "#ffffff"
   */
  toHex() {
    const t = this._int.toString(16);
    return `#${"000000".substring(0, 6 - t.length) + t}`;
  }
  /**
   * Convert to a hexidecimal string with alpha.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHexa(); // returns "#ffffffff"
   */
  toHexa() {
    const t = Math.round(this._components[3] * 255).toString(16);
    return this.toHex() + "00".substring(0, 2 - t.length) + t;
  }
  /**
   * Set alpha, suitable for chaining.
   * @param alpha
   */
  setAlpha(t) {
    return this._components[3] = this._clamp(t), this;
  }
  /**
   * Rounds the specified color according to the step. This action is destructive, and will
   * override the previous `value` property to be `null`. The alpha component is not rounded.
   * @param steps - Number of steps which will be used as a cap when rounding colors
   * @deprecated since 7.3.0
   */
  round(t) {
    const [e, r, i] = this._components;
    return this._components[0] = Math.round(e * t) / t, this._components[1] = Math.round(r * t) / t, this._components[2] = Math.round(i * t) / t, this.refreshInt(), this._value = null, this;
  }
  toArray(t) {
    t = t ?? [];
    const [e, r, i, s] = this._components;
    return t[0] = e, t[1] = r, t[2] = i, t[3] = s, t;
  }
  /**
   * Normalize the input value into rgba
   * @param value - Input value
   */
  normalize(t) {
    let e, r, i, s;
    if ((typeof t == "number" || t instanceof Number) && t >= 0 && t <= 16777215) {
      const o = t;
      e = (o >> 16 & 255) / 255, r = (o >> 8 & 255) / 255, i = (o & 255) / 255, s = 1;
    } else if ((Array.isArray(t) || t instanceof Float32Array) && t.length >= 3 && t.length <= 4)
      t = this._clamp(t), [e, r, i, s = 1] = t;
    else if ((t instanceof Uint8Array || t instanceof Uint8ClampedArray) && t.length >= 3 && t.length <= 4)
      t = this._clamp(t, 0, 255), [e, r, i, s = 255] = t, e /= 255, r /= 255, i /= 255, s /= 255;
    else if (typeof t == "string" || typeof t == "object") {
      if (typeof t == "string") {
        const a = Ta.HEX_PATTERN.exec(t);
        a && (t = `#${a[2]}`);
      }
      const o = Tr(t);
      o.isValid() && ({ r: e, g: r, b: i, a: s } = o.rgba, e /= 255, r /= 255, i /= 255);
    }
    if (e !== void 0)
      this._components[0] = e, this._components[1] = r, this._components[2] = i, this._components[3] = s, this.refreshInt();
    else
      throw new Error(`Unable to convert color ${t}`);
  }
  /** Refresh the internal color rgb number */
  refreshInt() {
    this._clamp(this._components);
    const [t, e, r] = this._components;
    this._int = (t * 255 << 16) + (e * 255 << 8) + (r * 255 | 0);
  }
  /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */
  _clamp(t, e = 0, r = 1) {
    return typeof t == "number" ? Math.min(Math.max(t, e), r) : (t.forEach((i, s) => {
      t[s] = Math.min(Math.max(i, e), r);
    }), t);
  }
};
Wi.shared = new Wi(), /**
* Temporary Color object for static uses internally.
* As to not conflict with Color.shared.
* @ignore
*/
Wi.temp = new Wi(), /** Pattern for hex strings */
Wi.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let Ot = Wi;
function Nx(n) {
  return wt("7.2.0", "utils.hex2string is deprecated, use Color#toHex instead"), Ot.shared.setValue(n).toHex();
}
function kx(n) {
  return wt("7.2.0", "utils.rgb2hex is deprecated, use Color#toNumber instead"), Ot.shared.setValue(n).toNumber();
}
function Bx() {
  const n = [], t = [];
  for (let r = 0; r < 32; r++)
    n[r] = r, t[r] = r;
  n[gt.NORMAL_NPM] = gt.NORMAL, n[gt.ADD_NPM] = gt.ADD, n[gt.SCREEN_NPM] = gt.SCREEN, t[gt.NORMAL] = gt.NORMAL_NPM, t[gt.ADD] = gt.ADD_NPM, t[gt.SCREEN] = gt.SCREEN_NPM;
  const e = [];
  return e.push(t), e.push(n), e;
}
const qg = Bx();
function Zg(n, t) {
  return qg[t ? 1 : 0][n];
}
function Lx(n, t = null) {
  const e = n * 6;
  if (t = t || new Uint16Array(e), t.length !== e)
    throw new Error(`Out buffer length is incorrect, got ${t.length} and expected ${e}`);
  for (let r = 0, i = 0; r < e; r += 6, i += 4)
    t[r + 0] = i + 0, t[r + 1] = i + 1, t[r + 2] = i + 2, t[r + 3] = i + 0, t[r + 4] = i + 2, t[r + 5] = i + 3;
  return t;
}
function Kg(n) {
  if (n.BYTES_PER_ELEMENT === 4)
    return n instanceof Float32Array ? "Float32Array" : n instanceof Uint32Array ? "Uint32Array" : "Int32Array";
  if (n.BYTES_PER_ELEMENT === 2) {
    if (n instanceof Uint16Array)
      return "Uint16Array";
  } else if (n.BYTES_PER_ELEMENT === 1 && n instanceof Uint8Array)
    return "Uint8Array";
  return null;
}
function Wa(n) {
  return n += n === 0 ? 1 : 0, --n, n |= n >>> 1, n |= n >>> 2, n |= n >>> 4, n |= n >>> 8, n |= n >>> 16, n + 1;
}
function Sp(n) {
  return !(n & n - 1) && !!n;
}
function Cp(n) {
  let t = (n > 65535 ? 1 : 0) << 4;
  n >>>= t;
  let e = (n > 255 ? 1 : 0) << 3;
  return n >>>= e, t |= e, e = (n > 15 ? 1 : 0) << 2, n >>>= e, t |= e, e = (n > 3 ? 1 : 0) << 1, n >>>= e, t |= e, t | n >> 1;
}
function es(n, t, e) {
  const r = n.length;
  let i;
  if (t >= r || e === 0)
    return;
  e = t + e > r ? r - t : e;
  const s = r - e;
  for (i = t; i < s; ++i)
    n[i] = n[i + e];
  n.length = s;
}
function Cn(n) {
  return n === 0 ? 0 : n < 0 ? -1 : 1;
}
let Ux = 0;
function Ti() {
  return ++Ux;
}
const Wu = class {
  /**
   * @param left - The left coordinate value of the bounding box.
   * @param top - The top coordinate value of the bounding box.
   * @param right - The right coordinate value of the bounding box.
   * @param bottom - The bottom coordinate value of the bounding box.
   */
  constructor(n, t, e, r) {
    this.left = n, this.top = t, this.right = e, this.bottom = r;
  }
  /** The width of the bounding box. */
  get width() {
    return this.right - this.left;
  }
  /** The height of the bounding box. */
  get height() {
    return this.bottom - this.top;
  }
  /** Determines whether the BoundingBox is empty. */
  isEmpty() {
    return this.left === this.right || this.top === this.bottom;
  }
};
Wu.EMPTY = new Wu(0, 0, 0, 0);
let Mp = Wu;
const Ip = {}, Ar = /* @__PURE__ */ Object.create(null), wn = /* @__PURE__ */ Object.create(null);
class Hx {
  /**
   * @param width - the width for the newly created canvas
   * @param height - the height for the newly created canvas
   * @param {number} [resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the canvas
   */
  constructor(t, e, r) {
    this._canvas = ht.ADAPTER.createCanvas(), this._context = this._canvas.getContext("2d"), this.resolution = r || ht.RESOLUTION, this.resize(t, e);
  }
  /**
   * Clears the canvas that was created by the CanvasRenderTarget class.
   * @private
   */
  clear() {
    this._checkDestroyed(), this._context.setTransform(1, 0, 0, 1, 0, 0), this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
  }
  /**
   * Resizes the canvas to the specified width and height.
   * @param desiredWidth - the desired width of the canvas
   * @param desiredHeight - the desired height of the canvas
   */
  resize(t, e) {
    this._checkDestroyed(), this._canvas.width = Math.round(t * this.resolution), this._canvas.height = Math.round(e * this.resolution);
  }
  /** Destroys this canvas. */
  destroy() {
    this._context = null, this._canvas = null;
  }
  /**
   * The width of the canvas buffer in pixels.
   * @member {number}
   */
  get width() {
    return this._checkDestroyed(), this._canvas.width;
  }
  set width(t) {
    this._checkDestroyed(), this._canvas.width = Math.round(t);
  }
  /**
   * The height of the canvas buffer in pixels.
   * @member {number}
   */
  get height() {
    return this._checkDestroyed(), this._canvas.height;
  }
  set height(t) {
    this._checkDestroyed(), this._canvas.height = Math.round(t);
  }
  /** The Canvas object that belongs to this CanvasRenderTarget. */
  get canvas() {
    return this._checkDestroyed(), this._canvas;
  }
  /** A CanvasRenderingContext2D object representing a two-dimensional rendering context. */
  get context() {
    return this._checkDestroyed(), this._context;
  }
  _checkDestroyed() {
    if (this._canvas === null)
      throw new TypeError("The CanvasRenderTarget has already been destroyed");
  }
}
function Pp(n, t, e) {
  for (let r = 0, i = 4 * e * t; r < t; ++r, i += 4)
    if (n[i + 3] !== 0)
      return !1;
  return !0;
}
function Rp(n, t, e, r, i) {
  const s = 4 * t;
  for (let o = r, a = r * s + 4 * e; o <= i; ++o, a += s)
    if (n[a + 3] !== 0)
      return !1;
  return !0;
}
function Gx(n) {
  const { width: t, height: e } = n, r = n.getContext("2d", {
    willReadFrequently: !0
  });
  if (r === null)
    throw new TypeError("Failed to get canvas 2D context");
  const i = r.getImageData(0, 0, t, e).data;
  let s = 0, o = 0, a = t - 1, h = e - 1;
  for (; o < e && Pp(i, t, o); )
    ++o;
  if (o === e)
    return Mp.EMPTY;
  for (; Pp(i, t, h); )
    --h;
  for (; Rp(i, t, s, o, h); )
    ++s;
  for (; Rp(i, t, a, o, h); )
    --a;
  return ++a, ++h, new Mp(s, o, a, h);
}
function zx(n) {
  const t = Gx(n), { width: e, height: r } = t;
  let i = null;
  if (!t.isEmpty()) {
    const s = n.getContext("2d");
    if (s === null)
      throw new TypeError("Failed to get canvas 2D context");
    i = s.getImageData(
      t.left,
      t.top,
      e,
      r
    );
  }
  return { width: e, height: r, data: i };
}
function Wx(n, t = globalThis.location) {
  if (n.startsWith("data:"))
    return "";
  t = t || globalThis.location;
  const e = new URL(n, document.baseURI);
  return e.hostname !== t.hostname || e.port !== t.port || e.protocol !== t.protocol ? "anonymous" : "";
}
function sn(n, t = 1) {
  const e = ht.RETINA_PREFIX?.exec(n);
  return e ? parseFloat(e[1]) : t;
}
var st = /* @__PURE__ */ ((n) => (n.Renderer = "renderer", n.Application = "application", n.RendererSystem = "renderer-webgl-system", n.RendererPlugin = "renderer-webgl-plugin", n.CanvasRendererSystem = "renderer-canvas-system", n.CanvasRendererPlugin = "renderer-canvas-plugin", n.Asset = "asset", n.LoadParser = "load-parser", n.ResolveParser = "resolve-parser", n.CacheParser = "cache-parser", n.DetectionParser = "detection-parser", n))(st || {});
const $u = (n) => {
  if (typeof n == "function" || typeof n == "object" && n.extension) {
    if (!n.extension)
      throw new Error("Extension class must have an extension object");
    n = { ...typeof n.extension != "object" ? { type: n.extension } : n.extension, ref: n };
  }
  if (typeof n == "object")
    n = { ...n };
  else
    throw new Error("Invalid extension type");
  return typeof n.type == "string" && (n.type = [n.type]), n;
}, Dp = (n, t) => $u(n).priority ?? t, dt = {
  /** @ignore */
  _addHandlers: {},
  /** @ignore */
  _removeHandlers: {},
  /** @ignore */
  _queue: {},
  /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed.
   * @returns {PIXI.extensions} For chaining.
   */
  remove(...n) {
    return n.map($u).forEach((t) => {
      t.type.forEach((e) => this._removeHandlers[e]?.(t));
    }), this;
  },
  /**
   * Register new extensions with PixiJS.
   * @param extensions - The spread of extensions to add to PixiJS.
   * @returns {PIXI.extensions} For chaining.
   */
  add(...n) {
    return n.map($u).forEach((t) => {
      t.type.forEach((e) => {
        const r = this._addHandlers, i = this._queue;
        r[e] ? r[e](t) : (i[e] = i[e] || [], i[e].push(t));
      });
    }), this;
  },
  /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function for handling when extensions are added/registered passes {@link PIXI.ExtensionFormat}.
   * @param onRemove  - Function for handling when extensions are removed/unregistered passes {@link PIXI.ExtensionFormat}.
   * @returns {PIXI.extensions} For chaining.
   */
  handle(n, t, e) {
    const r = this._addHandlers, i = this._removeHandlers;
    if (r[n] || i[n])
      throw new Error(`Extension type ${n} already has a handler`);
    r[n] = t, i[n] = e;
    const s = this._queue;
    return s[n] && (s[n].forEach((o) => t(o)), delete s[n]), this;
  },
  /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns {PIXI.extensions} For chaining.
   */
  handleByMap(n, t) {
    return this.handle(
      n,
      (e) => {
        t[e.name] = e.ref;
      },
      (e) => {
        delete t[e.name];
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns {PIXI.extensions} For chaining.
   */
  handleByList(n, t, e = -1) {
    return this.handle(
      n,
      (r) => {
        t.includes(r.ref) || (t.push(r.ref), t.sort((i, s) => Dp(s, e) - Dp(i, e)));
      },
      (r) => {
        const i = t.indexOf(r.ref);
        i !== -1 && t.splice(i, 1);
      }
    );
  }
};
class Xu {
  constructor(t) {
    typeof t == "number" ? this.rawBinaryData = new ArrayBuffer(t) : t instanceof Uint8Array ? this.rawBinaryData = t.buffer : this.rawBinaryData = t, this.uint32View = new Uint32Array(this.rawBinaryData), this.float32View = new Float32Array(this.rawBinaryData);
  }
  /** View on the raw binary data as a `Int8Array`. */
  get int8View() {
    return this._int8View || (this._int8View = new Int8Array(this.rawBinaryData)), this._int8View;
  }
  /** View on the raw binary data as a `Uint8Array`. */
  get uint8View() {
    return this._uint8View || (this._uint8View = new Uint8Array(this.rawBinaryData)), this._uint8View;
  }
  /**  View on the raw binary data as a `Int16Array`. */
  get int16View() {
    return this._int16View || (this._int16View = new Int16Array(this.rawBinaryData)), this._int16View;
  }
  /** View on the raw binary data as a `Uint16Array`. */
  get uint16View() {
    return this._uint16View || (this._uint16View = new Uint16Array(this.rawBinaryData)), this._uint16View;
  }
  /** View on the raw binary data as a `Int32Array`. */
  get int32View() {
    return this._int32View || (this._int32View = new Int32Array(this.rawBinaryData)), this._int32View;
  }
  /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */
  view(t) {
    return this[`${t}View`];
  }
  /** Destroys all buffer references. Do not use after calling this. */
  destroy() {
    this.rawBinaryData = null, this._int8View = null, this._uint8View = null, this._int16View = null, this._uint16View = null, this._int32View = null, this.uint32View = null, this.float32View = null;
  }
  static sizeOf(t) {
    switch (t) {
      case "int8":
      case "uint8":
        return 1;
      case "int16":
      case "uint16":
        return 2;
      case "int32":
      case "uint32":
      case "float32":
        return 4;
      default:
        throw new Error(`${t} isn't a valid view type`);
    }
  }
}
const $x = [
  "precision mediump float;",
  "void main(void){",
  "float test = 0.1;",
  "%forloop%",
  "gl_FragColor = vec4(0.0);",
  "}"
].join(`
`);
function Xx(n) {
  let t = "";
  for (let e = 0; e < n; ++e)
    e > 0 && (t += `
else `), e < n - 1 && (t += `if(test == ${e}.0){}`);
  return t;
}
function Vx(n, t) {
  if (n === 0)
    throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
  const e = t.createShader(t.FRAGMENT_SHADER);
  for (; ; ) {
    const r = $x.replace(/%forloop%/gi, Xx(n));
    if (t.shaderSource(e, r), t.compileShader(e), !t.getShaderParameter(e, t.COMPILE_STATUS))
      n = n / 2 | 0;
    else
      break;
  }
  return n;
}
const Kl = 0, Ql = 1, Jl = 2, tu = 3, eu = 4, ru = 5;
class Hr {
  constructor() {
    this.data = 0, this.blendMode = gt.NORMAL, this.polygonOffset = 0, this.blend = !0, this.depthMask = !0;
  }
  /**
   * Activates blending of the computed fragment color values.
   * @default true
   */
  get blend() {
    return !!(this.data & 1 << Kl);
  }
  set blend(t) {
    !!(this.data & 1 << Kl) !== t && (this.data ^= 1 << Kl);
  }
  /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */
  get offsets() {
    return !!(this.data & 1 << Ql);
  }
  set offsets(t) {
    !!(this.data & 1 << Ql) !== t && (this.data ^= 1 << Ql);
  }
  /**
   * Activates culling of polygons.
   * @default false
   */
  get culling() {
    return !!(this.data & 1 << Jl);
  }
  set culling(t) {
    !!(this.data & 1 << Jl) !== t && (this.data ^= 1 << Jl);
  }
  /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */
  get depthTest() {
    return !!(this.data & 1 << tu);
  }
  set depthTest(t) {
    !!(this.data & 1 << tu) !== t && (this.data ^= 1 << tu);
  }
  /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */
  get depthMask() {
    return !!(this.data & 1 << ru);
  }
  set depthMask(t) {
    !!(this.data & 1 << ru) !== t && (this.data ^= 1 << ru);
  }
  /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */
  get clockwiseFrontFace() {
    return !!(this.data & 1 << eu);
  }
  set clockwiseFrontFace(t) {
    !!(this.data & 1 << eu) !== t && (this.data ^= 1 << eu);
  }
  /**
   * The blend mode to be applied when this state is set. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default PIXI.BLEND_MODES.NORMAL
   */
  get blendMode() {
    return this._blendMode;
  }
  set blendMode(t) {
    this.blend = t !== gt.NONE, this._blendMode = t;
  }
  /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */
  get polygonOffset() {
    return this._polygonOffset;
  }
  set polygonOffset(t) {
    this.offsets = !!t, this._polygonOffset = t;
  }
  static for2d() {
    const t = new Hr();
    return t.depthTest = !1, t.blend = !0, t;
  }
}
Hr.prototype.toString = function() {
  return `[@pixi/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
};
const Vu = [];
function Qg(n, t) {
  if (!n)
    return null;
  let e = "";
  if (typeof n == "string") {
    const r = /\.(\w{3,4})(?:$|\?|#)/i.exec(n);
    r && (e = r[1].toLowerCase());
  }
  for (let r = Vu.length - 1; r >= 0; --r) {
    const i = Vu[r];
    if (i.test && i.test(n, e))
      return new i(n, t);
  }
  throw new Error("Unrecognized source type to auto-detect Resource");
}
class pr {
  /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */
  constructor(t) {
    this.items = [], this._name = t, this._aliasCount = 0;
  }
  /* eslint-disable jsdoc/require-param, jsdoc/check-param-names */
  /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */
  /*  eslint-enable jsdoc/require-param, jsdoc/check-param-names */
  emit(t, e, r, i, s, o, a, h) {
    if (arguments.length > 8)
      throw new Error("max arguments reached");
    const { name: l, items: u } = this;
    this._aliasCount++;
    for (let c = 0, d = u.length; c < d; c++)
      u[c][l](t, e, r, i, s, o, a, h);
    return u === this.items && this._aliasCount--, this;
  }
  ensureNonAliasedItems() {
    this._aliasCount > 0 && this.items.length > 1 && (this._aliasCount = 0, this.items = this.items.slice(0));
  }
  /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * E.g. A listener passed to this Runner will require a 'complete' function.
   *
   * ```js
   * import { Runner } from '@pixi/runner';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */
  add(t) {
    return t[this._name] && (this.ensureNonAliasedItems(), this.remove(t), this.items.push(t)), this;
  }
  /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */
  remove(t) {
    const e = this.items.indexOf(t);
    return e !== -1 && (this.ensureNonAliasedItems(), this.items.splice(e, 1)), this;
  }
  /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */
  contains(t) {
    return this.items.includes(t);
  }
  /** Remove all listeners from the Runner */
  removeAll() {
    return this.ensureNonAliasedItems(), this.items.length = 0, this;
  }
  /** Remove all references, don't use after this. */
  destroy() {
    this.removeAll(), this.items = null, this._name = null;
  }
  /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */
  get empty() {
    return this.items.length === 0;
  }
  /**
   * The name of the runner.
   * @readonly
   */
  get name() {
    return this._name;
  }
}
Object.defineProperties(pr.prototype, {
  /**
   * Alias for `emit`
   * @memberof PIXI.Runner#
   * @method dispatch
   * @see PIXI.Runner#emit
   */
  dispatch: { value: pr.prototype.emit },
  /**
   * Alias for `emit`
   * @memberof PIXI.Runner#
   * @method run
   * @see PIXI.Runner#emit
   */
  run: { value: pr.prototype.emit }
});
class fo {
  /**
   * @param width - Width of the resource
   * @param height - Height of the resource
   */
  constructor(t = 0, e = 0) {
    this._width = t, this._height = e, this.destroyed = !1, this.internal = !1, this.onResize = new pr("setRealSize"), this.onUpdate = new pr("update"), this.onError = new pr("onError");
  }
  /**
   * Bind to a parent BaseTexture
   * @param baseTexture - Parent texture
   */
  bind(t) {
    this.onResize.add(t), this.onUpdate.add(t), this.onError.add(t), (this._width || this._height) && this.onResize.emit(this._width, this._height);
  }
  /**
   * Unbind to a parent BaseTexture
   * @param baseTexture - Parent texture
   */
  unbind(t) {
    this.onResize.remove(t), this.onUpdate.remove(t), this.onError.remove(t);
  }
  /**
   * Trigger a resize event
   * @param width - X dimension
   * @param height - Y dimension
   */
  resize(t, e) {
    (t !== this._width || e !== this._height) && (this._width = t, this._height = e, this.onResize.emit(t, e));
  }
  /**
   * Has been validated
   * @readonly
   */
  get valid() {
    return !!this._width && !!this._height;
  }
  /** Has been updated trigger event. */
  update() {
    this.destroyed || this.onUpdate.emit();
  }
  /**
   * This can be overridden to start preloading a resource
   * or do any other prepare step.
   * @protected
   * @returns Handle the validate event
   */
  load() {
    return Promise.resolve(this);
  }
  /**
   * The width of the resource.
   * @readonly
   */
  get width() {
    return this._width;
  }
  /**
   * The height of the resource.
   * @readonly
   */
  get height() {
    return this._height;
  }
  /**
   * Set the style, optional to override
   * @param _renderer - yeah, renderer!
   * @param _baseTexture - the texture
   * @param _glTexture - texture instance for this webgl context
   * @returns - `true` is success
   */
  style(t, e, r) {
    return !1;
  }
  /** Clean up anything, this happens when destroying is ready. */
  dispose() {
  }
  /**
   * Call when destroying resource, unbind any BaseTexture object
   * before calling this method, as reference counts are maintained
   * internally.
   */
  destroy() {
    this.destroyed || (this.destroyed = !0, this.dispose(), this.onError.removeAll(), this.onError = null, this.onResize.removeAll(), this.onResize = null, this.onUpdate.removeAll(), this.onUpdate = null);
  }
  /**
   * Abstract, used to auto-detect resource type.
   * @param {*} _source - The source object
   * @param {string} _extension - The extension of source, if set
   */
  static test(t, e) {
    return !1;
  }
}
class Ch extends fo {
  /**
   * @param source - Source buffer
   * @param options - Options
   * @param {number} options.width - Width of the texture
   * @param {number} options.height - Height of the texture
   * @param {1|2|4|8} [options.unpackAlignment=4] - The alignment of the pixel rows.
   */
  constructor(t, e) {
    const { width: r, height: i } = e || {};
    if (!r || !i)
      throw new Error("BufferResource width or height invalid");
    super(r, i), this.data = t, this.unpackAlignment = e.unpackAlignment ?? 4;
  }
  /**
   * Upload the texture to the GPU.
   * @param renderer - Upload to the renderer
   * @param baseTexture - Reference to parent texture
   * @param glTexture - glTexture
   * @returns - true is success
   */
  upload(t, e, r) {
    const i = t.gl;
    i.pixelStorei(i.UNPACK_ALIGNMENT, this.unpackAlignment), i.pixelStorei(i.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e.alphaMode === Ae.UNPACK);
    const s = e.realWidth, o = e.realHeight;
    return r.width === s && r.height === o ? i.texSubImage2D(
      e.target,
      0,
      0,
      0,
      s,
      o,
      e.format,
      r.type,
      this.data
    ) : (r.width = s, r.height = o, i.texImage2D(
      e.target,
      0,
      r.internalFormat,
      s,
      o,
      0,
      e.format,
      r.type,
      this.data
    )), !0;
  }
  /** Destroy and don't use after this. */
  dispose() {
    this.data = null;
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if buffer source
   */
  static test(t) {
    return t === null || t instanceof Int8Array || t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array;
  }
}
const Yx = {
  scaleMode: Qr.NEAREST,
  alphaMode: Ae.NPM
}, Yu = class $i extends Co {
  /**
   * @param {PIXI.Resource|HTMLImageElement|HTMLVideoElement|ImageBitmap|ICanvas|string} [resource=null] -
   *        The current resource to use, for things that aren't Resource objects, will be converted
   *        into a Resource.
   * @param options - Collection of options, default options inherited from {@link PIXI.BaseTexture.defaultOptions}.
   * @param {PIXI.MIPMAP_MODES} [options.mipmap] - If mipmapping is enabled for texture
   * @param {number} [options.anisotropicLevel] - Anisotropic filtering level of texture
   * @param {PIXI.WRAP_MODES} [options.wrapMode] - Wrap mode for textures
   * @param {PIXI.SCALE_MODES} [options.scaleMode] - Default scale mode, linear, nearest
   * @param {PIXI.FORMATS} [options.format] - GL format type
   * @param {PIXI.TYPES} [options.type] - GL data type
   * @param {PIXI.TARGETS} [options.target] - GL texture target
   * @param {PIXI.ALPHA_MODES} [options.alphaMode] - Pre multiply the image alpha
   * @param {number} [options.width=0] - Width of the texture
   * @param {number} [options.height=0] - Height of the texture
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - Resolution of the base texture
   * @param {object} [options.resourceOptions] - Optional resource options,
   *        see {@link PIXI.autoDetectResource autoDetectResource}
   */
  constructor(t = null, e = null) {
    super(), e = Object.assign({}, $i.defaultOptions, e);
    const {
      alphaMode: r,
      mipmap: i,
      anisotropicLevel: s,
      scaleMode: o,
      width: a,
      height: h,
      wrapMode: l,
      format: u,
      type: c,
      target: d,
      resolution: f,
      resourceOptions: p
    } = e;
    t && !(t instanceof fo) && (t = Qg(t, p), t.internal = !0), this.resolution = f || ht.RESOLUTION, this.width = Math.round((a || 0) * this.resolution) / this.resolution, this.height = Math.round((h || 0) * this.resolution) / this.resolution, this._mipmap = i, this.anisotropicLevel = s, this._wrapMode = l, this._scaleMode = o, this.format = u, this.type = c, this.target = d, this.alphaMode = r, this.uid = Ti(), this.touched = 0, this.isPowerOfTwo = !1, this._refreshPOT(), this._glTextures = {}, this.dirtyId = 0, this.dirtyStyleId = 0, this.cacheId = null, this.valid = a > 0 && h > 0, this.textureCacheIds = [], this.destroyed = !1, this.resource = null, this._batchEnabled = 0, this._batchLocation = 0, this.parentTextureArray = null, this.setResource(t);
  }
  /**
   * Pixel width of the source of this texture
   * @readonly
   */
  get realWidth() {
    return Math.round(this.width * this.resolution);
  }
  /**
   * Pixel height of the source of this texture
   * @readonly
   */
  get realHeight() {
    return Math.round(this.height * this.resolution);
  }
  /**
   * Mipmap mode of the texture, affects downscaled images
   * @default PIXI.MIPMAP_MODES.POW2
   */
  get mipmap() {
    return this._mipmap;
  }
  set mipmap(t) {
    this._mipmap !== t && (this._mipmap = t, this.dirtyStyleId++);
  }
  /**
   * The scale mode to apply when scaling this texture
   * @default PIXI.SCALE_MODES.LINEAR
   */
  get scaleMode() {
    return this._scaleMode;
  }
  set scaleMode(t) {
    this._scaleMode !== t && (this._scaleMode = t, this.dirtyStyleId++);
  }
  /**
   * How the texture wraps
   * @default PIXI.WRAP_MODES.CLAMP
   */
  get wrapMode() {
    return this._wrapMode;
  }
  set wrapMode(t) {
    this._wrapMode !== t && (this._wrapMode = t, this.dirtyStyleId++);
  }
  /**
   * Changes style options of BaseTexture
   * @param scaleMode - Pixi scalemode
   * @param mipmap - enable mipmaps
   * @returns - this
   */
  setStyle(t, e) {
    let r;
    return t !== void 0 && t !== this.scaleMode && (this.scaleMode = t, r = !0), e !== void 0 && e !== this.mipmap && (this.mipmap = e, r = !0), r && this.dirtyStyleId++, this;
  }
  /**
   * Changes w/h/resolution. Texture becomes valid if width and height are greater than zero.
   * @param desiredWidth - Desired visual width
   * @param desiredHeight - Desired visual height
   * @param resolution - Optionally set resolution
   * @returns - this
   */
  setSize(t, e, r) {
    return r = r || this.resolution, this.setRealSize(t * r, e * r, r);
  }
  /**
   * Sets real size of baseTexture, preserves current resolution.
   * @param realWidth - Full rendered width
   * @param realHeight - Full rendered height
   * @param resolution - Optionally set resolution
   * @returns - this
   */
  setRealSize(t, e, r) {
    return this.resolution = r || this.resolution, this.width = Math.round(t) / this.resolution, this.height = Math.round(e) / this.resolution, this._refreshPOT(), this.update(), this;
  }
  /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */
  _refreshPOT() {
    this.isPowerOfTwo = Sp(this.realWidth) && Sp(this.realHeight);
  }
  /**
   * Changes resolution
   * @param resolution - res
   * @returns - this
   */
  setResolution(t) {
    const e = this.resolution;
    return e === t ? this : (this.resolution = t, this.valid && (this.width = Math.round(this.width * e) / t, this.height = Math.round(this.height * e) / t, this.emit("update", this)), this._refreshPOT(), this);
  }
  /**
   * Sets the resource if it wasn't set. Throws error if resource already present
   * @param resource - that is managing this BaseTexture
   * @returns - this
   */
  setResource(t) {
    if (this.resource === t)
      return this;
    if (this.resource)
      throw new Error("Resource can be set only once");
    return t.bind(this), this.resource = t, this;
  }
  /** Invalidates the object. Texture becomes valid if width and height are greater than zero. */
  update() {
    this.valid ? (this.dirtyId++, this.dirtyStyleId++, this.emit("update", this)) : this.width > 0 && this.height > 0 && (this.valid = !0, this.emit("loaded", this), this.emit("update", this));
  }
  /**
   * Handle errors with resources.
   * @private
   * @param event - Error event emitted.
   */
  onError(t) {
    this.emit("error", this, t);
  }
  /**
   * Destroys this base texture.
   * The method stops if resource doesn't want this texture to be destroyed.
   * Removes texture from all caches.
   * @fires PIXI.BaseTexture#destroyed
   */
  destroy() {
    this.resource && (this.resource.unbind(this), this.resource.internal && this.resource.destroy(), this.resource = null), this.cacheId && (delete wn[this.cacheId], delete Ar[this.cacheId], this.cacheId = null), this.valid = !1, this.dispose(), $i.removeFromCache(this), this.textureCacheIds = null, this.destroyed = !0, this.emit("destroyed", this), this.removeAllListeners();
  }
  /**
   * Frees the texture from WebGL memory without destroying this texture object.
   * This means you can still use the texture later which will upload it to GPU
   * memory again.
   * @fires PIXI.BaseTexture#dispose
   */
  dispose() {
    this.emit("dispose", this);
  }
  /** Utility function for BaseTexture|Texture cast. */
  castToBaseTexture() {
    return this;
  }
  /**
   * Helper function that creates a base texture based on the source you provide.
   * The source can be - image url, image element, canvas element. If the
   * source is an image url or an image element and not in the base texture
   * cache, it will be created and loaded.
   * @static
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas|string|string[]} source - The
   *        source to create base texture from.
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
   * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
   * @returns {PIXI.BaseTexture} The new base texture.
   */
  static from(t, e, r = ht.STRICT_TEXTURE_CACHE) {
    const i = typeof t == "string";
    let s = null;
    if (i)
      s = t;
    else {
      if (!t._pixiId) {
        const a = e?.pixiIdPrefix || "pixiid";
        t._pixiId = `${a}_${Ti()}`;
      }
      s = t._pixiId;
    }
    let o = wn[s];
    if (i && r && !o)
      throw new Error(`The cacheId "${s}" does not exist in BaseTextureCache.`);
    return o || (o = new $i(t, e), o.cacheId = s, $i.addToCache(o, s)), o;
  }
  /**
   * Create a new Texture with a BufferResource from a typed array.
   * @param buffer - The optional array to use. If no data is provided, a new Float32Array is created.
   * @param width - Width of the resource
   * @param height - Height of the resource
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   *        Default properties are different from the constructor's defaults.
   * @param {PIXI.FORMATS} [options.format] - The format is not given, the type is inferred from the
   *        type of the buffer: `RGBA` if Float32Array, Int8Array, Uint8Array, or Uint8ClampedArray,
   *        otherwise `RGBA_INTEGER`.
   * @param {PIXI.TYPES} [options.type] - The type is not given, the type is inferred from the
   *        type of the buffer. Maps Float32Array to `FLOAT`, Int32Array to `INT`, Uint32Array to
   *        `UNSIGNED_INT`, Int16Array to `SHORT`, Uint16Array to `UNSIGNED_SHORT`, Int8Array to `BYTE`,
   *        Uint8Array/Uint8ClampedArray to `UNSIGNED_BYTE`.
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.NPM]
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.SCALE_MODES.NEAREST]
   * @returns - The resulting new BaseTexture
   */
  static fromBuffer(t, e, r, i) {
    t = t || new Float32Array(e * r * 4);
    const s = new Ch(t, { width: e, height: r, ...i?.resourceOptions });
    let o, a;
    return t instanceof Float32Array ? (o = Q.RGBA, a = pt.FLOAT) : t instanceof Int32Array ? (o = Q.RGBA_INTEGER, a = pt.INT) : t instanceof Uint32Array ? (o = Q.RGBA_INTEGER, a = pt.UNSIGNED_INT) : t instanceof Int16Array ? (o = Q.RGBA_INTEGER, a = pt.SHORT) : t instanceof Uint16Array ? (o = Q.RGBA_INTEGER, a = pt.UNSIGNED_SHORT) : t instanceof Int8Array ? (o = Q.RGBA, a = pt.BYTE) : (o = Q.RGBA, a = pt.UNSIGNED_BYTE), s.internal = !0, new $i(s, Object.assign({}, Yx, { type: a, format: o }, i));
  }
  /**
   * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
   * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
   * @param {string} id - The id that the BaseTexture will be stored against.
   */
  static addToCache(t, e) {
    e && (t.textureCacheIds.includes(e) || t.textureCacheIds.push(e), wn[e] && wn[e] !== t && console.warn(`BaseTexture added to the cache with an id [${e}] that already had an entry`), wn[e] = t);
  }
  /**
   * Remove a BaseTexture from the global BaseTextureCache.
   * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
   * @returns {PIXI.BaseTexture|null} The BaseTexture that was removed.
   */
  static removeFromCache(t) {
    if (typeof t == "string") {
      const e = wn[t];
      if (e) {
        const r = e.textureCacheIds.indexOf(t);
        return r > -1 && e.textureCacheIds.splice(r, 1), delete wn[t], e;
      }
    } else if (t?.textureCacheIds) {
      for (let e = 0; e < t.textureCacheIds.length; ++e)
        delete wn[t.textureCacheIds[e]];
      return t.textureCacheIds.length = 0, t;
    }
    return null;
  }
};
Yu.defaultOptions = {
  /**
   * If mipmapping is enabled for texture.
   * @type {PIXI.MIPMAP_MODES}
   * @default PIXI.MIPMAP_MODES.POW2
   */
  mipmap: Lr.POW2,
  /** Anisotropic filtering level of texture */
  anisotropicLevel: 0,
  /**
   * Default scale mode, linear, nearest.
   * @type {PIXI.SCALE_MODES}
   * @default PIXI.SCALE_MODES.LINEAR
   */
  scaleMode: Qr.LINEAR,
  /**
   * Wrap mode for textures.
   * @type {PIXI.WRAP_MODES}
   * @default PIXI.WRAP_MODES.CLAMP
   */
  wrapMode: Dr.CLAMP,
  /**
   * Pre multiply the image alpha
   * @type {PIXI.ALPHA_MODES}
   * @default PIXI.ALPHA_MODES.UNPACK
   */
  alphaMode: Ae.UNPACK,
  /**
   * GL texture target
   * @type {PIXI.TARGETS}
   * @default PIXI.TARGETS.TEXTURE_2D
   */
  target: ts.TEXTURE_2D,
  /**
   * GL format type
   * @type {PIXI.FORMATS}
   * @default PIXI.FORMATS.RGBA
   */
  format: Q.RGBA,
  /**
   * GL data type
   * @type {PIXI.TYPES}
   * @default PIXI.TYPES.UNSIGNED_BYTE
   */
  type: pt.UNSIGNED_BYTE
}, /** Global number of the texture batch, used by multi-texture renderers. */
Yu._globalBatch = 0;
let _t = Yu;
class ju {
  constructor() {
    this.texArray = null, this.blend = 0, this.type = Pr.TRIANGLES, this.start = 0, this.size = 0, this.data = null;
  }
}
let jx = 0;
class Yt {
  /**
   * @param {PIXI.IArrayBuffer} data - the data to store in the buffer.
   * @param _static - `true` for static buffer
   * @param index - `true` for index buffer
   */
  constructor(t, e = !0, r = !1) {
    this.data = t || new Float32Array(1), this._glBuffers = {}, this._updateID = 0, this.index = r, this.static = e, this.id = jx++, this.disposeRunner = new pr("disposeBuffer");
  }
  // TODO could explore flagging only a partial upload?
  /**
   * Flags this buffer as requiring an upload to the GPU.
   * @param {PIXI.IArrayBuffer|number[]} [data] - the data to update in the buffer.
   */
  update(t) {
    t instanceof Array && (t = new Float32Array(t)), this.data = t || this.data, this._updateID++;
  }
  /** Disposes WebGL resources that are connected to this geometry. */
  dispose() {
    this.disposeRunner.emit(this, !1);
  }
  /** Destroys the buffer. */
  destroy() {
    this.dispose(), this.data = null;
  }
  /**
   * Flags whether this is an index buffer.
   *
   * Index buffers are of type `ELEMENT_ARRAY_BUFFER`. Note that setting this property to false will make
   * the buffer of type `ARRAY_BUFFER`.
   *
   * For backwards compatibility.
   */
  set index(t) {
    this.type = t ? Fr.ELEMENT_ARRAY_BUFFER : Fr.ARRAY_BUFFER;
  }
  get index() {
    return this.type === Fr.ELEMENT_ARRAY_BUFFER;
  }
  /**
   * Helper function that creates a buffer based on an array or TypedArray
   * @param {ArrayBufferView | number[]} data - the TypedArray that the buffer will store. If this is a regular Array it will be converted to a Float32Array.
   * @returns - A new Buffer based on the data provided.
   */
  static from(t) {
    return t instanceof Array && (t = new Float32Array(t)), new Yt(t);
  }
}
class $a {
  /**
   * @param buffer - the id of the buffer that this attribute will look for
   * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2.
   * @param normalized - should the data be normalized.
   * @param {PIXI.TYPES} [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @param [start=0] - How far into the array to start reading values (used for interleaving data)
   * @param [instance=false] - Whether the geometry is instanced.
   * @param [divisor=1] - Divisor to use when doing instanced rendering
   */
  constructor(t, e = 0, r = !1, i = pt.FLOAT, s, o, a, h = 1) {
    this.buffer = t, this.size = e, this.normalized = r, this.type = i, this.stride = s, this.start = o, this.instance = a, this.divisor = h;
  }
  /** Destroys the Attribute. */
  destroy() {
    this.buffer = null;
  }
  /**
   * Helper function that creates an Attribute based on the information provided
   * @param buffer - the id of the buffer that this attribute will look for
   * @param [size=0] - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
   * @param [normalized=false] - should the data be normalized.
   * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @returns - A new {@link PIXI.Attribute} based on the information provided
   */
  static from(t, e, r, i, s) {
    return new $a(t, e, r, i, s);
  }
}
const qx = {
  Float32Array,
  Uint32Array,
  Int32Array,
  Uint8Array
};
function Zx(n, t) {
  let e = 0, r = 0;
  const i = {};
  for (let h = 0; h < n.length; h++)
    r += t[h], e += n[h].length;
  const s = new ArrayBuffer(e * 4);
  let o = null, a = 0;
  for (let h = 0; h < n.length; h++) {
    const l = t[h], u = n[h], c = Kg(u);
    i[c] || (i[c] = new qx[c](s)), o = i[c];
    for (let d = 0; d < u.length; d++) {
      const f = (d / l | 0) * r + a, p = d % l;
      o[f + p] = u[d];
    }
    a += l;
  }
  return new Float32Array(s);
}
const Fp = { 5126: 4, 5123: 2, 5121: 1 };
let Kx = 0;
const Qx = {
  Float32Array,
  Uint32Array,
  Int32Array,
  Uint8Array,
  Uint16Array
};
class Bn {
  /**
   * @param buffers - An array of buffers. optional.
   * @param attributes - Of the geometry, optional structure of the attributes layout
   */
  constructor(t = [], e = {}) {
    this.buffers = t, this.indexBuffer = null, this.attributes = e, this.glVertexArrayObjects = {}, this.id = Kx++, this.instanced = !1, this.instanceCount = 1, this.disposeRunner = new pr("disposeGeometry"), this.refCount = 0;
  }
  /**
   *
   * Adds an attribute to the geometry
   * Note: `stride` and `start` should be `undefined` if you dont know them, not 0!
   * @param id - the name of the attribute (matching up to a shader)
   * @param {PIXI.Buffer|number[]} buffer - the buffer that holds the data of the attribute . You can also provide an Array and a buffer will be created from it.
   * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
   * @param normalized - should the data be normalized.
   * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @param [start=0] - How far into the array to start reading values (used for interleaving data)
   * @param instance - Instancing flag
   * @returns - Returns self, useful for chaining.
   */
  addAttribute(t, e, r = 0, i = !1, s, o, a, h = !1) {
    if (!e)
      throw new Error("You must pass a buffer when creating an attribute");
    e instanceof Yt || (e instanceof Array && (e = new Float32Array(e)), e = new Yt(e));
    const l = t.split("|");
    if (l.length > 1) {
      for (let c = 0; c < l.length; c++)
        this.addAttribute(l[c], e, r, i, s);
      return this;
    }
    let u = this.buffers.indexOf(e);
    return u === -1 && (this.buffers.push(e), u = this.buffers.length - 1), this.attributes[t] = new $a(u, r, i, s, o, a, h), this.instanced = this.instanced || h, this;
  }
  /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */
  getAttribute(t) {
    return this.attributes[t];
  }
  /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */
  getBuffer(t) {
    return this.buffers[this.getAttribute(t).buffer];
  }
  /**
   *
   * Adds an index buffer to the geometry
   * The index buffer contains integers, three for each triangle in the geometry, which reference the various attribute buffers (position, colour, UV coordinates, other UV coordinates, normal, …). There is only ONE index buffer.
   * @param {PIXI.Buffer|number[]} [buffer] - The buffer that holds the data of the index buffer. You can also provide an Array and a buffer will be created from it.
   * @returns - Returns self, useful for chaining.
   */
  addIndex(t) {
    return t instanceof Yt || (t instanceof Array && (t = new Uint16Array(t)), t = new Yt(t)), t.type = Fr.ELEMENT_ARRAY_BUFFER, this.indexBuffer = t, this.buffers.includes(t) || this.buffers.push(t), this;
  }
  /**
   * Returns the index buffer
   * @returns - The index buffer.
   */
  getIndex() {
    return this.indexBuffer;
  }
  /**
   * This function modifies the structure so that all current attributes become interleaved into a single buffer
   * This can be useful if your model remains static as it offers a little performance boost
   * @returns - Returns self, useful for chaining.
   */
  interleave() {
    if (this.buffers.length === 1 || this.buffers.length === 2 && this.indexBuffer)
      return this;
    const t = [], e = [], r = new Yt();
    let i;
    for (i in this.attributes) {
      const s = this.attributes[i], o = this.buffers[s.buffer];
      t.push(o.data), e.push(s.size * Fp[s.type] / 4), s.buffer = 0;
    }
    for (r.data = Zx(t, e), i = 0; i < this.buffers.length; i++)
      this.buffers[i] !== this.indexBuffer && this.buffers[i].destroy();
    return this.buffers = [r], this.indexBuffer && this.buffers.push(this.indexBuffer), this;
  }
  /** Get the size of the geometries, in vertices. */
  getSize() {
    for (const t in this.attributes) {
      const e = this.attributes[t];
      return this.buffers[e.buffer].data.length / (e.stride / 4 || e.size);
    }
    return 0;
  }
  /** Disposes WebGL resources that are connected to this geometry. */
  dispose() {
    this.disposeRunner.emit(this, !1);
  }
  /** Destroys the geometry. */
  destroy() {
    this.dispose(), this.buffers = null, this.indexBuffer = null, this.attributes = null;
  }
  /**
   * Returns a clone of the geometry.
   * @returns - A new clone of this geometry.
   */
  clone() {
    const t = new Bn();
    for (let e = 0; e < this.buffers.length; e++)
      t.buffers[e] = new Yt(this.buffers[e].data.slice(0));
    for (const e in this.attributes) {
      const r = this.attributes[e];
      t.attributes[e] = new $a(
        r.buffer,
        r.size,
        r.normalized,
        r.type,
        r.stride,
        r.start,
        r.instance
      );
    }
    return this.indexBuffer && (t.indexBuffer = t.buffers[this.buffers.indexOf(this.indexBuffer)], t.indexBuffer.type = Fr.ELEMENT_ARRAY_BUFFER), t;
  }
  /**
   * Merges an array of geometries into a new single one.
   *
   * Geometry attribute styles must match for this operation to work.
   * @param geometries - array of geometries to merge
   * @returns - Shiny new geometry!
   */
  static merge(t) {
    const e = new Bn(), r = [], i = [], s = [];
    let o;
    for (let a = 0; a < t.length; a++) {
      o = t[a];
      for (let h = 0; h < o.buffers.length; h++)
        i[h] = i[h] || 0, i[h] += o.buffers[h].data.length, s[h] = 0;
    }
    for (let a = 0; a < o.buffers.length; a++)
      r[a] = new Qx[Kg(o.buffers[a].data)](i[a]), e.buffers[a] = new Yt(r[a]);
    for (let a = 0; a < t.length; a++) {
      o = t[a];
      for (let h = 0; h < o.buffers.length; h++)
        r[h].set(o.buffers[h].data, s[h]), s[h] += o.buffers[h].data.length;
    }
    if (e.attributes = o.attributes, o.indexBuffer) {
      e.indexBuffer = e.buffers[o.buffers.indexOf(o.indexBuffer)], e.indexBuffer.type = Fr.ELEMENT_ARRAY_BUFFER;
      let a = 0, h = 0, l = 0, u = 0;
      for (let c = 0; c < o.buffers.length; c++)
        if (o.buffers[c] !== o.indexBuffer) {
          u = c;
          break;
        }
      for (const c in o.attributes) {
        const d = o.attributes[c];
        (d.buffer | 0) === u && (h += d.size * Fp[d.type] / 4);
      }
      for (let c = 0; c < t.length; c++) {
        const d = t[c].indexBuffer.data;
        for (let f = 0; f < d.length; f++)
          e.indexBuffer.data[f + l] += a;
        a += t[c].buffers[u].data.length / h, l += d.length;
      }
    }
    return e;
  }
}
class Jg extends Bn {
  /**
   * @param {boolean} [_static=false] - Optimization flag, where `false`
   *        is updated every frame, `true` doesn't change frame-to-frame.
   */
  constructor(t = !1) {
    super(), this._buffer = new Yt(null, t, !1), this._indexBuffer = new Yt(null, t, !0), this.addAttribute("aVertexPosition", this._buffer, 2, !1, pt.FLOAT).addAttribute("aTextureCoord", this._buffer, 2, !1, pt.FLOAT).addAttribute("aColor", this._buffer, 4, !0, pt.UNSIGNED_BYTE).addAttribute("aTextureId", this._buffer, 1, !0, pt.FLOAT).addIndex(this._indexBuffer);
  }
}
const Xa = Math.PI * 2, Jx = 180 / Math.PI, qu = Math.PI / 180;
var de = /* @__PURE__ */ ((n) => (n[n.POLY = 0] = "POLY", n[n.RECT = 1] = "RECT", n[n.CIRC = 2] = "CIRC", n[n.ELIP = 3] = "ELIP", n[n.RREC = 4] = "RREC", n))(de || {});
class mt {
  /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(t = 0, e = 0) {
    this.x = 0, this.y = 0, this.x = t, this.y = e;
  }
  /**
   * Creates a clone of this point
   * @returns A clone of this point
   */
  clone() {
    return new mt(this.x, this.y);
  }
  /**
   * Copies `x` and `y` from the given point into this point
   * @param p - The point to copy from
   * @returns The point instance itself
   */
  copyFrom(t) {
    return this.set(t.x, t.y), this;
  }
  /**
   * Copies this point's x and y into the given point (`p`).
   * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
   * @returns The point (`p`) with values updated
   */
  copyTo(t) {
    return t.set(this.x, this.y), t;
  }
  /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */
  equals(t) {
    return t.x === this.x && t.y === this.y;
  }
  /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the `x` axis
   * @param {number} [y=x] - position of the point on the `y` axis
   * @returns The point instance itself
   */
  set(t = 0, e = t) {
    return this.x = t, this.y = e, this;
  }
}
mt.prototype.toString = function() {
  return `[@pixi/math:Point x=${this.x} y=${this.y}]`;
};
const Qo = [new mt(), new mt(), new mt(), new mt()];
class yt {
  /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */
  constructor(t = 0, e = 0, r = 0, i = 0) {
    this.x = Number(t), this.y = Number(e), this.width = Number(r), this.height = Number(i), this.type = de.RECT;
  }
  /** Returns the left edge of the rectangle. */
  get left() {
    return this.x;
  }
  /** Returns the right edge of the rectangle. */
  get right() {
    return this.x + this.width;
  }
  /** Returns the top edge of the rectangle. */
  get top() {
    return this.y;
  }
  /** Returns the bottom edge of the rectangle. */
  get bottom() {
    return this.y + this.height;
  }
  /** A constant empty rectangle. */
  static get EMPTY() {
    return new yt(0, 0, 0, 0);
  }
  /**
   * Creates a clone of this Rectangle
   * @returns a copy of the rectangle
   */
  clone() {
    return new yt(this.x, this.y, this.width, this.height);
  }
  /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */
  copyFrom(t) {
    return this.x = t.x, this.y = t.y, this.width = t.width, this.height = t.height, this;
  }
  /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */
  copyTo(t) {
    return t.x = this.x, t.y = this.y, t.width = this.width, t.height = this.height, t;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   */
  contains(t, e) {
    return this.width <= 0 || this.height <= 0 ? !1 : t >= this.x && t < this.x + this.width && e >= this.y && e < this.y + this.height;
  }
  /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */
  intersects(t, e) {
    if (!e) {
      const C = this.x < t.x ? t.x : this.x;
      if ((this.right > t.right ? t.right : this.right) <= C)
        return !1;
      const M = this.y < t.y ? t.y : this.y;
      return (this.bottom > t.bottom ? t.bottom : this.bottom) > M;
    }
    const r = this.left, i = this.right, s = this.top, o = this.bottom;
    if (i <= r || o <= s)
      return !1;
    const a = Qo[0].set(t.left, t.top), h = Qo[1].set(t.left, t.bottom), l = Qo[2].set(t.right, t.top), u = Qo[3].set(t.right, t.bottom);
    if (l.x <= a.x || h.y <= a.y)
      return !1;
    const c = Math.sign(e.a * e.d - e.b * e.c);
    if (c === 0 || (e.apply(a, a), e.apply(h, h), e.apply(l, l), e.apply(u, u), Math.max(a.x, h.x, l.x, u.x) <= r || Math.min(a.x, h.x, l.x, u.x) >= i || Math.max(a.y, h.y, l.y, u.y) <= s || Math.min(a.y, h.y, l.y, u.y) >= o))
      return !1;
    const d = c * (h.y - a.y), f = c * (a.x - h.x), p = d * r + f * s, m = d * i + f * s, g = d * r + f * o, _ = d * i + f * o;
    if (Math.max(p, m, g, _) <= d * a.x + f * a.y || Math.min(p, m, g, _) >= d * u.x + f * u.y)
      return !1;
    const w = c * (a.y - l.y), v = c * (l.x - a.x), E = w * r + v * s, x = w * i + v * s, b = w * r + v * o, y = w * i + v * o;
    return !(Math.max(E, x, b, y) <= w * a.x + v * a.y || Math.min(E, x, b, y) >= w * u.x + v * u.y);
  }
  /**
   * Pads the rectangle making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   * @returns Returns itself.
   */
  pad(t = 0, e = t) {
    return this.x -= t, this.y -= e, this.width += t * 2, this.height += e * 2, this;
  }
  /**
   * Fits this rectangle around the passed one.
   * @param rectangle - The rectangle to fit.
   * @returns Returns itself.
   */
  fit(t) {
    const e = Math.max(this.x, t.x), r = Math.min(this.x + this.width, t.x + t.width), i = Math.max(this.y, t.y), s = Math.min(this.y + this.height, t.y + t.height);
    return this.x = e, this.width = Math.max(r - e, 0), this.y = i, this.height = Math.max(s - i, 0), this;
  }
  /**
   * Enlarges rectangle that way its corners lie on grid
   * @param resolution - resolution
   * @param eps - precision
   * @returns Returns itself.
   */
  ceil(t = 1, e = 1e-3) {
    const r = Math.ceil((this.x + this.width - e) * t) / t, i = Math.ceil((this.y + this.height - e) * t) / t;
    return this.x = Math.floor((this.x + e) * t) / t, this.y = Math.floor((this.y + e) * t) / t, this.width = r - this.x, this.height = i - this.y, this;
  }
  /**
   * Enlarges this rectangle to include the passed rectangle.
   * @param rectangle - The rectangle to include.
   * @returns Returns itself.
   */
  enlarge(t) {
    const e = Math.min(this.x, t.x), r = Math.max(this.x + this.width, t.x + t.width), i = Math.min(this.y, t.y), s = Math.max(this.y + this.height, t.y + t.height);
    return this.x = e, this.width = r - e, this.y = i, this.height = s - i, this;
  }
}
yt.prototype.toString = function() {
  return `[@pixi/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
};
class Mh {
  /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */
  constructor(t = 0, e = 0, r = 0) {
    this.x = t, this.y = e, this.radius = r, this.type = de.CIRC;
  }
  /**
   * Creates a clone of this Circle instance
   * @returns A copy of the Circle
   */
  clone() {
    return new Mh(this.x, this.y, this.radius);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   */
  contains(t, e) {
    if (this.radius <= 0)
      return !1;
    const r = this.radius * this.radius;
    let i = this.x - t, s = this.y - e;
    return i *= i, s *= s, i + s <= r;
  }
  /**
   * Returns the framing rectangle of the circle as a Rectangle object
   * @returns The framing rectangle
   */
  getBounds() {
    return new yt(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
  }
}
Mh.prototype.toString = function() {
  return `[@pixi/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
};
class Ih {
  /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */
  constructor(t = 0, e = 0, r = 0, i = 0) {
    this.x = t, this.y = e, this.width = r, this.height = i, this.type = de.ELIP;
  }
  /**
   * Creates a clone of this Ellipse instance
   * @returns {PIXI.Ellipse} A copy of the ellipse
   */
  clone() {
    return new Ih(this.x, this.y, this.width, this.height);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   */
  contains(t, e) {
    if (this.width <= 0 || this.height <= 0)
      return !1;
    let r = (t - this.x) / this.width, i = (e - this.y) / this.height;
    return r *= r, i *= i, r + i <= 1;
  }
  /**
   * Returns the framing rectangle of the ellipse as a Rectangle object
   * @returns The framing rectangle
   */
  getBounds() {
    return new yt(this.x - this.width, this.y - this.height, this.width, this.height);
  }
}
Ih.prototype.toString = function() {
  return `[@pixi/math:Ellipse x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
};
class mi {
  /**
   * @param {PIXI.IPointData[]|number[]} points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */
  constructor(...t) {
    let e = Array.isArray(t[0]) ? t[0] : t;
    if (typeof e[0] != "number") {
      const r = [];
      for (let i = 0, s = e.length; i < s; i++)
        r.push(e[i].x, e[i].y);
      e = r;
    }
    this.points = e, this.type = de.POLY, this.closeStroke = !0;
  }
  /**
   * Creates a clone of this polygon.
   * @returns - A copy of the polygon.
   */
  clone() {
    const t = this.points.slice(), e = new mi(t);
    return e.closeStroke = this.closeStroke, e;
  }
  /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this polygon.
   */
  contains(t, e) {
    let r = !1;
    const i = this.points.length / 2;
    for (let s = 0, o = i - 1; s < i; o = s++) {
      const a = this.points[s * 2], h = this.points[s * 2 + 1], l = this.points[o * 2], u = this.points[o * 2 + 1];
      h > e != u > e && t < (l - a) * ((e - h) / (u - h)) + a && (r = !r);
    }
    return r;
  }
}
mi.prototype.toString = function() {
  return `[@pixi/math:PolygoncloseStroke=${this.closeStroke}points=${this.points.reduce((n, t) => `${n}, ${t}`, "")}]`;
};
class Ph {
  /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */
  constructor(t = 0, e = 0, r = 0, i = 0, s = 20) {
    this.x = t, this.y = e, this.width = r, this.height = i, this.radius = s, this.type = de.RREC;
  }
  /**
   * Creates a clone of this Rounded Rectangle.
   * @returns - A copy of the rounded rectangle.
   */
  clone() {
    return new Ph(this.x, this.y, this.width, this.height, this.radius);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this Rounded Rectangle.
   */
  contains(t, e) {
    if (this.width <= 0 || this.height <= 0)
      return !1;
    if (t >= this.x && t <= this.x + this.width && e >= this.y && e <= this.y + this.height) {
      const r = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
      if (e >= this.y + r && e <= this.y + this.height - r || t >= this.x + r && t <= this.x + this.width - r)
        return !0;
      let i = t - (this.x + r), s = e - (this.y + r);
      const o = r * r;
      if (i * i + s * s <= o || (i = t - (this.x + this.width - r), i * i + s * s <= o) || (s = e - (this.y + this.height - r), i * i + s * s <= o) || (i = t - (this.x + r), i * i + s * s <= o))
        return !0;
    }
    return !1;
  }
}
Ph.prototype.toString = function() {
  return `[@pixi/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
};
class Nt {
  /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */
  constructor(t = 1, e = 0, r = 0, i = 1, s = 0, o = 0) {
    this.array = null, this.a = t, this.b = e, this.c = r, this.d = i, this.tx = s, this.ty = o;
  }
  /**
   * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
   *
   * a = array[0]
   * b = array[1]
   * c = array[3]
   * d = array[4]
   * tx = array[2]
   * ty = array[5]
   * @param array - The array that the matrix will be populated from.
   */
  fromArray(t) {
    this.a = t[0], this.b = t[1], this.c = t[3], this.d = t[4], this.tx = t[2], this.ty = t[5];
  }
  /**
   * Sets the matrix properties.
   * @param a - Matrix component
   * @param b - Matrix component
   * @param c - Matrix component
   * @param d - Matrix component
   * @param tx - Matrix component
   * @param ty - Matrix component
   * @returns This matrix. Good for chaining method calls.
   */
  set(t, e, r, i, s, o) {
    return this.a = t, this.b = e, this.c = r, this.d = i, this.tx = s, this.ty = o, this;
  }
  /**
   * Creates an array from the current Matrix object.
   * @param transpose - Whether we need to transpose the matrix or not
   * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
   * @returns The newly created array which contains the matrix
   */
  toArray(t, e) {
    this.array || (this.array = new Float32Array(9));
    const r = e || this.array;
    return t ? (r[0] = this.a, r[1] = this.b, r[2] = 0, r[3] = this.c, r[4] = this.d, r[5] = 0, r[6] = this.tx, r[7] = this.ty, r[8] = 1) : (r[0] = this.a, r[1] = this.c, r[2] = this.tx, r[3] = this.b, r[4] = this.d, r[5] = this.ty, r[6] = 0, r[7] = 0, r[8] = 1), r;
  }
  /**
   * Get a new position with the current transformation applied.
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @param pos - The origin
   * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {PIXI.Point} The new point, transformed through this matrix
   */
  apply(t, e) {
    e = e || new mt();
    const r = t.x, i = t.y;
    return e.x = this.a * r + this.c * i + this.tx, e.y = this.b * r + this.d * i + this.ty, e;
  }
  /**
   * Get a new position with the inverse of the current transformation applied.
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @param pos - The origin
   * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {PIXI.Point} The new point, inverse-transformed through this matrix
   */
  applyInverse(t, e) {
    e = e || new mt();
    const r = 1 / (this.a * this.d + this.c * -this.b), i = t.x, s = t.y;
    return e.x = this.d * r * i + -this.c * r * s + (this.ty * this.c - this.tx * this.d) * r, e.y = this.a * r * s + -this.b * r * i + (-this.ty * this.a + this.tx * this.b) * r, e;
  }
  /**
   * Translates the matrix on the x and y.
   * @param x - How much to translate x by
   * @param y - How much to translate y by
   * @returns This matrix. Good for chaining method calls.
   */
  translate(t, e) {
    return this.tx += t, this.ty += e, this;
  }
  /**
   * Applies a scale transformation to the matrix.
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   */
  scale(t, e) {
    return this.a *= t, this.d *= e, this.c *= t, this.b *= e, this.tx *= t, this.ty *= e, this;
  }
  /**
   * Applies a rotation transformation to the matrix.
   * @param angle - The angle in radians.
   * @returns This matrix. Good for chaining method calls.
   */
  rotate(t) {
    const e = Math.cos(t), r = Math.sin(t), i = this.a, s = this.c, o = this.tx;
    return this.a = i * e - this.b * r, this.b = i * r + this.b * e, this.c = s * e - this.d * r, this.d = s * r + this.d * e, this.tx = o * e - this.ty * r, this.ty = o * r + this.ty * e, this;
  }
  /**
   * Appends the given Matrix to this Matrix.
   * @param matrix - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */
  append(t) {
    const e = this.a, r = this.b, i = this.c, s = this.d;
    return this.a = t.a * e + t.b * i, this.b = t.a * r + t.b * s, this.c = t.c * e + t.d * i, this.d = t.c * r + t.d * s, this.tx = t.tx * e + t.ty * i + this.tx, this.ty = t.tx * r + t.ty * s + this.ty, this;
  }
  /**
   * Sets the matrix based on all the available properties
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   */
  setTransform(t, e, r, i, s, o, a, h, l) {
    return this.a = Math.cos(a + l) * s, this.b = Math.sin(a + l) * s, this.c = -Math.sin(a - h) * o, this.d = Math.cos(a - h) * o, this.tx = t - (r * this.a + i * this.c), this.ty = e - (r * this.b + i * this.d), this;
  }
  /**
   * Prepends the given Matrix to this Matrix.
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   */
  prepend(t) {
    const e = this.tx;
    if (t.a !== 1 || t.b !== 0 || t.c !== 0 || t.d !== 1) {
      const r = this.a, i = this.c;
      this.a = r * t.a + this.b * t.c, this.b = r * t.b + this.b * t.d, this.c = i * t.a + this.d * t.c, this.d = i * t.b + this.d * t.d;
    }
    return this.tx = e * t.a + this.ty * t.c + t.tx, this.ty = e * t.b + this.ty * t.d + t.ty, this;
  }
  /**
   * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
   * @param transform - The transform to apply the properties to.
   * @returns The transform with the newly applied properties
   */
  decompose(t) {
    const e = this.a, r = this.b, i = this.c, s = this.d, o = t.pivot, a = -Math.atan2(-i, s), h = Math.atan2(r, e), l = Math.abs(a + h);
    return l < 1e-5 || Math.abs(Xa - l) < 1e-5 ? (t.rotation = h, t.skew.x = t.skew.y = 0) : (t.rotation = 0, t.skew.x = a, t.skew.y = h), t.scale.x = Math.sqrt(e * e + r * r), t.scale.y = Math.sqrt(i * i + s * s), t.position.x = this.tx + (o.x * e + o.y * i), t.position.y = this.ty + (o.x * r + o.y * s), t;
  }
  /**
   * Inverts this matrix
   * @returns This matrix. Good for chaining method calls.
   */
  invert() {
    const t = this.a, e = this.b, r = this.c, i = this.d, s = this.tx, o = t * i - e * r;
    return this.a = i / o, this.b = -e / o, this.c = -r / o, this.d = t / o, this.tx = (r * this.ty - i * s) / o, this.ty = -(t * this.ty - e * s) / o, this;
  }
  /**
   * Resets this Matrix to an identity (default) matrix.
   * @returns This matrix. Good for chaining method calls.
   */
  identity() {
    return this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0, this;
  }
  /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */
  clone() {
    const t = new Nt();
    return t.a = this.a, t.b = this.b, t.c = this.c, t.d = this.d, t.tx = this.tx, t.ty = this.ty, t;
  }
  /**
   * Changes the values of the given matrix to be the same as the ones in this matrix
   * @param matrix - The matrix to copy to.
   * @returns The matrix given in parameter with its values updated.
   */
  copyTo(t) {
    return t.a = this.a, t.b = this.b, t.c = this.c, t.d = this.d, t.tx = this.tx, t.ty = this.ty, t;
  }
  /**
   * Changes the values of the matrix to be the same as the ones in given matrix
   * @param {PIXI.Matrix} matrix - The matrix to copy from.
   * @returns {PIXI.Matrix} this
   */
  copyFrom(t) {
    return this.a = t.a, this.b = t.b, this.c = t.c, this.d = t.d, this.tx = t.tx, this.ty = t.ty, this;
  }
  /**
   * A default (identity) matrix
   * @readonly
   */
  static get IDENTITY() {
    return new Nt();
  }
  /**
   * A temp matrix
   * @readonly
   */
  static get TEMP_MATRIX() {
    return new Nt();
  }
}
Nt.prototype.toString = function() {
  return `[@pixi/math:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
};
const ii = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1], si = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1], oi = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1], ai = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1], Zu = [], t0 = [], Jo = Math.sign;
function tw() {
  for (let n = 0; n < 16; n++) {
    const t = [];
    Zu.push(t);
    for (let e = 0; e < 16; e++) {
      const r = Jo(ii[n] * ii[e] + oi[n] * si[e]), i = Jo(si[n] * ii[e] + ai[n] * si[e]), s = Jo(ii[n] * oi[e] + oi[n] * ai[e]), o = Jo(si[n] * oi[e] + ai[n] * ai[e]);
      for (let a = 0; a < 16; a++)
        if (ii[a] === r && si[a] === i && oi[a] === s && ai[a] === o) {
          t.push(a);
          break;
        }
    }
  }
  for (let n = 0; n < 16; n++) {
    const t = new Nt();
    t.set(ii[n], si[n], oi[n], ai[n], 0, 0), t0.push(t);
  }
}
tw();
const Ut = {
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @readonly
   */
  E: 0,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @readonly
   */
  SE: 1,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @readonly
   */
  S: 2,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @readonly
   */
  SW: 3,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @readonly
   */
  W: 4,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @readonly
   */
  NW: 5,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @readonly
   */
  N: 6,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @readonly
   */
  NE: 7,
  /**
   * Reflection about Y-axis.
   * @readonly
   */
  MIRROR_VERTICAL: 8,
  /**
   * Reflection about the main diagonal.
   * @readonly
   */
  MAIN_DIAGONAL: 10,
  /**
   * Reflection about X-axis.
   * @readonly
   */
  MIRROR_HORIZONTAL: 12,
  /**
   * Reflection about reverse diagonal.
   * @readonly
   */
  REVERSE_DIAGONAL: 14,
  /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */
  uX: (n) => ii[n],
  /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */
  uY: (n) => si[n],
  /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */
  vX: (n) => oi[n],
  /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */
  vY: (n) => ai[n],
  /**
   * @param {PIXI.GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {PIXI.GD8Symmetry} The opposite symmetry of `rotation`
   */
  inv: (n) => n & 8 ? n & 15 : -n & 7,
  /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @param {PIXI.GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {PIXI.GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {PIXI.GD8Symmetry} Composed operation
   */
  add: (n, t) => Zu[n][t],
  /**
   * Reverse of `add`.
   * @param {PIXI.GD8Symmetry} rotationSecond - Second operation
   * @param {PIXI.GD8Symmetry} rotationFirst - First operation
   * @returns {PIXI.GD8Symmetry} Result
   */
  sub: (n, t) => Zu[n][Ut.inv(t)],
  /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */
  rotate180: (n) => n ^ 4,
  /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @param {PIXI.GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */
  isVertical: (n) => (n & 3) === 2,
  // rotation % 4 === 2
  /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {PIXI.GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */
  byDirection: (n, t) => Math.abs(n) * 2 <= Math.abs(t) ? t >= 0 ? Ut.S : Ut.N : Math.abs(t) * 2 <= Math.abs(n) ? n > 0 ? Ut.E : Ut.W : t > 0 ? n > 0 ? Ut.SE : Ut.SW : n > 0 ? Ut.NE : Ut.NW,
  /**
   * Helps sprite to compensate texture packer rotation.
   * @param {PIXI.Matrix} matrix - sprite world matrix
   * @param {PIXI.GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */
  matrixAppendRotationInv: (n, t, e = 0, r = 0) => {
    const i = t0[Ut.inv(t)];
    i.tx = e, i.ty = r, n.append(i);
  }
};
class tn {
  /**
   * Creates a new `ObservablePoint`
   * @param cb - callback function triggered when `x` and/or `y` are changed
   * @param scope - owner of callback
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(t, e, r = 0, i = 0) {
    this._x = r, this._y = i, this.cb = t, this.scope = e;
  }
  /**
   * Creates a clone of this point.
   * The callback and scope params can be overridden otherwise they will default
   * to the clone object's values.
   * @override
   * @param cb - The callback function triggered when `x` and/or `y` are changed
   * @param scope - The owner of the callback
   * @returns a copy of this observable point
   */
  clone(t = this.cb, e = this.scope) {
    return new tn(t, e, this._x, this._y);
  }
  /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=x] - position of the point on the y axis
   * @returns The observable point instance itself
   */
  set(t = 0, e = t) {
    return (this._x !== t || this._y !== e) && (this._x = t, this._y = e, this.cb.call(this.scope)), this;
  }
  /**
   * Copies x and y from the given point (`p`)
   * @param p - The point to copy from. Can be any of type that is or extends `IPointData`
   * @returns The observable point instance itself
   */
  copyFrom(t) {
    return (this._x !== t.x || this._y !== t.y) && (this._x = t.x, this._y = t.y, this.cb.call(this.scope)), this;
  }
  /**
   * Copies this point's x and y into that of the given point (`p`)
   * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
   * @returns The point (`p`) with values updated
   */
  copyTo(t) {
    return t.set(this._x, this._y), t;
  }
  /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */
  equals(t) {
    return t.x === this._x && t.y === this._y;
  }
  /** Position of the observable point on the x axis. */
  get x() {
    return this._x;
  }
  set x(t) {
    this._x !== t && (this._x = t, this.cb.call(this.scope));
  }
  /** Position of the observable point on the y axis. */
  get y() {
    return this._y;
  }
  set y(t) {
    this._y !== t && (this._y = t, this.cb.call(this.scope));
  }
}
tn.prototype.toString = function() {
  return `[@pixi/math:ObservablePoint x=${this.x} y=${this.y} scope=${this.scope}]`;
};
const Ku = class {
  constructor() {
    this.worldTransform = new Nt(), this.localTransform = new Nt(), this.position = new tn(this.onChange, this, 0, 0), this.scale = new tn(this.onChange, this, 1, 1), this.pivot = new tn(this.onChange, this, 0, 0), this.skew = new tn(this.updateSkew, this, 0, 0), this._rotation = 0, this._cx = 1, this._sx = 0, this._cy = 0, this._sy = 1, this._localID = 0, this._currentLocalID = 0, this._worldID = 0, this._parentID = 0;
  }
  /** Called when a value changes. */
  onChange() {
    this._localID++;
  }
  /** Called when the skew or the rotation changes. */
  updateSkew() {
    this._cx = Math.cos(this._rotation + this.skew.y), this._sx = Math.sin(this._rotation + this.skew.y), this._cy = -Math.sin(this._rotation - this.skew.x), this._sy = Math.cos(this._rotation - this.skew.x), this._localID++;
  }
  /** Updates the local transformation matrix. */
  updateLocalTransform() {
    const n = this.localTransform;
    this._localID !== this._currentLocalID && (n.a = this._cx * this.scale.x, n.b = this._sx * this.scale.x, n.c = this._cy * this.scale.y, n.d = this._sy * this.scale.y, n.tx = this.position.x - (this.pivot.x * n.a + this.pivot.y * n.c), n.ty = this.position.y - (this.pivot.x * n.b + this.pivot.y * n.d), this._currentLocalID = this._localID, this._parentID = -1);
  }
  /**
   * Updates the local and the world transformation matrices.
   * @param parentTransform - The parent transform
   */
  updateTransform(n) {
    const t = this.localTransform;
    if (this._localID !== this._currentLocalID && (t.a = this._cx * this.scale.x, t.b = this._sx * this.scale.x, t.c = this._cy * this.scale.y, t.d = this._sy * this.scale.y, t.tx = this.position.x - (this.pivot.x * t.a + this.pivot.y * t.c), t.ty = this.position.y - (this.pivot.x * t.b + this.pivot.y * t.d), this._currentLocalID = this._localID, this._parentID = -1), this._parentID !== n._worldID) {
      const e = n.worldTransform, r = this.worldTransform;
      r.a = t.a * e.a + t.b * e.c, r.b = t.a * e.b + t.b * e.d, r.c = t.c * e.a + t.d * e.c, r.d = t.c * e.b + t.d * e.d, r.tx = t.tx * e.a + t.ty * e.c + e.tx, r.ty = t.tx * e.b + t.ty * e.d + e.ty, this._parentID = n._worldID, this._worldID++;
    }
  }
  /**
   * Decomposes a matrix and sets the transforms properties based on it.
   * @param matrix - The matrix to decompose
   */
  setFromMatrix(n) {
    n.decompose(this), this._localID++;
  }
  /** The rotation of the object in radians. */
  get rotation() {
    return this._rotation;
  }
  set rotation(n) {
    this._rotation !== n && (this._rotation = n, this.updateSkew());
  }
};
Ku.IDENTITY = new Ku();
let ad = Ku;
ad.prototype.toString = function() {
  return `[@pixi/math:Transform position=(${this.position.x}, ${this.position.y}) rotation=${this.rotation} scale=(${this.scale.x}, ${this.scale.y}) skew=(${this.skew.x}, ${this.skew.y}) ]`;
};
var ew = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
   gl_FragColor *= texture2D(uSampler, vTextureCoord);
}`, rw = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void){
   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
   vTextureCoord = aTextureCoord;
}
`;
function Op(n, t, e) {
  const r = n.createShader(t);
  return n.shaderSource(r, e), n.compileShader(r), r;
}
function nu(n) {
  const t = new Array(n);
  for (let e = 0; e < t.length; e++)
    t[e] = !1;
  return t;
}
function e0(n, t) {
  switch (n) {
    case "float":
      return 0;
    case "vec2":
      return new Float32Array(2 * t);
    case "vec3":
      return new Float32Array(3 * t);
    case "vec4":
      return new Float32Array(4 * t);
    case "int":
    case "uint":
    case "sampler2D":
    case "sampler2DArray":
      return 0;
    case "ivec2":
      return new Int32Array(2 * t);
    case "ivec3":
      return new Int32Array(3 * t);
    case "ivec4":
      return new Int32Array(4 * t);
    case "uvec2":
      return new Uint32Array(2 * t);
    case "uvec3":
      return new Uint32Array(3 * t);
    case "uvec4":
      return new Uint32Array(4 * t);
    case "bool":
      return !1;
    case "bvec2":
      return nu(2 * t);
    case "bvec3":
      return nu(3 * t);
    case "bvec4":
      return nu(4 * t);
    case "mat2":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
const rs = [
  // a float cache layer
  {
    test: (n) => n.type === "float" && n.size === 1 && !n.isArray,
    code: (n) => `
            if(uv["${n}"] !== ud["${n}"].value)
            {
                ud["${n}"].value = uv["${n}"]
                gl.uniform1f(ud["${n}"].location, uv["${n}"])
            }
            `
  },
  // handling samplers
  {
    test: (n, t) => (
      // eslint-disable-next-line max-len,no-eq-null,eqeqeq
      (n.type === "sampler2D" || n.type === "samplerCube" || n.type === "sampler2DArray") && n.size === 1 && !n.isArray && (t == null || t.castToBaseTexture !== void 0)
    ),
    code: (n) => `t = syncData.textureCount++;

            renderer.texture.bind(uv["${n}"], t);

            if(ud["${n}"].value !== t)
            {
                ud["${n}"].value = t;
                gl.uniform1i(ud["${n}"].location, t);
; // eslint-disable-line max-len
            }`
  },
  // uploading pixi matrix object to mat3
  {
    test: (n, t) => n.type === "mat3" && n.size === 1 && !n.isArray && t.a !== void 0,
    code: (n) => (
      // TODO and some smart caching dirty ids here!
      `
            gl.uniformMatrix3fv(ud["${n}"].location, false, uv["${n}"].toArray(true));
            `
    ),
    codeUbo: (n) => `
                var ${n}_matrix = uv.${n}.toArray(true);

                data[offset] = ${n}_matrix[0];
                data[offset+1] = ${n}_matrix[1];
                data[offset+2] = ${n}_matrix[2];
        
                data[offset + 4] = ${n}_matrix[3];
                data[offset + 5] = ${n}_matrix[4];
                data[offset + 6] = ${n}_matrix[5];
        
                data[offset + 8] = ${n}_matrix[6];
                data[offset + 9] = ${n}_matrix[7];
                data[offset + 10] = ${n}_matrix[8];
            `
  },
  // uploading a pixi point as a vec2 with caching layer
  {
    test: (n, t) => n.type === "vec2" && n.size === 1 && !n.isArray && t.x !== void 0,
    code: (n) => `
                cv = ud["${n}"].value;
                v = uv["${n}"];

                if(cv[0] !== v.x || cv[1] !== v.y)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    gl.uniform2f(ud["${n}"].location, v.x, v.y);
                }`,
    codeUbo: (n) => `
                v = uv.${n};

                data[offset] = v.x;
                data[offset+1] = v.y;
            `
  },
  // caching layer for a vec2
  {
    test: (n) => n.type === "vec2" && n.size === 1 && !n.isArray,
    code: (n) => `
                cv = ud["${n}"].value;
                v = uv["${n}"];

                if(cv[0] !== v[0] || cv[1] !== v[1])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    gl.uniform2f(ud["${n}"].location, v[0], v[1]);
                }
            `
  },
  // upload a pixi rectangle as a vec4 with caching layer
  {
    test: (n, t) => n.type === "vec4" && n.size === 1 && !n.isArray && t.width !== void 0,
    code: (n) => `
                cv = ud["${n}"].value;
                v = uv["${n}"];

                if(cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    cv[2] = v.width;
                    cv[3] = v.height;
                    gl.uniform4f(ud["${n}"].location, v.x, v.y, v.width, v.height)
                }`,
    codeUbo: (n) => `
                    v = uv.${n};

                    data[offset] = v.x;
                    data[offset+1] = v.y;
                    data[offset+2] = v.width;
                    data[offset+3] = v.height;
                `
  },
  // upload a pixi color as vec4 with caching layer
  {
    test: (n, t) => n.type === "vec4" && n.size === 1 && !n.isArray && t.red !== void 0,
    code: (n) => `
                cv = ud["${n}"].value;
                v = uv["${n}"];

                if(cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.alpha)
                {
                    cv[0] = v.red;
                    cv[1] = v.green;
                    cv[2] = v.blue;
                    cv[3] = v.alpha;
                    gl.uniform4f(ud["${n}"].location, v.red, v.green, v.blue, v.alpha)
                }`,
    codeUbo: (n) => `
                    v = uv.${n};

                    data[offset] = v.red;
                    data[offset+1] = v.green;
                    data[offset+2] = v.blue;
                    data[offset+3] = v.alpha;
                `
  },
  // upload a pixi color as a vec3 with caching layer
  {
    test: (n, t) => n.type === "vec3" && n.size === 1 && !n.isArray && t.red !== void 0,
    code: (n) => `
                cv = ud["${n}"].value;
                v = uv["${n}"];

                if(cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.a)
                {
                    cv[0] = v.red;
                    cv[1] = v.green;
                    cv[2] = v.blue;
    
                    gl.uniform3f(ud["${n}"].location, v.red, v.green, v.blue)
                }`,
    codeUbo: (n) => `
                    v = uv.${n};

                    data[offset] = v.red;
                    data[offset+1] = v.green;
                    data[offset+2] = v.blue;
                `
  },
  // a caching layer for vec4 uploading
  {
    test: (n) => n.type === "vec4" && n.size === 1 && !n.isArray,
    code: (n) => `
                cv = ud["${n}"].value;
                v = uv["${n}"];

                if(cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    cv[2] = v[2];
                    cv[3] = v[3];

                    gl.uniform4f(ud["${n}"].location, v[0], v[1], v[2], v[3])
                }`
  }
], nw = {
  float: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1f(location, v);
    }`,
  vec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2f(location, v[0], v[1])
    }`,
  vec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3f(location, v[0], v[1], v[2])
    }`,
  vec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4f(location, v[0], v[1], v[2], v[3]);
    }`,
  int: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
  ivec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
  ivec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
  ivec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
  uint: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1ui(location, v);
    }`,
  uvec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2ui(location, v[0], v[1]);
    }`,
  uvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3ui(location, v[0], v[1], v[2]);
    }`,
  uvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
    }`,
  bool: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1i(location, v);
    }`,
  bvec2: `
    if (cv[0] != v[0] || cv[1] != v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
  bvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
  bvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
  mat2: "gl.uniformMatrix2fv(location, false, v)",
  mat3: "gl.uniformMatrix3fv(location, false, v)",
  mat4: "gl.uniformMatrix4fv(location, false, v)",
  sampler2D: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
  samplerCube: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
  sampler2DArray: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`
}, iw = {
  float: "gl.uniform1fv(location, v)",
  vec2: "gl.uniform2fv(location, v)",
  vec3: "gl.uniform3fv(location, v)",
  vec4: "gl.uniform4fv(location, v)",
  mat4: "gl.uniformMatrix4fv(location, false, v)",
  mat3: "gl.uniformMatrix3fv(location, false, v)",
  mat2: "gl.uniformMatrix2fv(location, false, v)",
  int: "gl.uniform1iv(location, v)",
  ivec2: "gl.uniform2iv(location, v)",
  ivec3: "gl.uniform3iv(location, v)",
  ivec4: "gl.uniform4iv(location, v)",
  uint: "gl.uniform1uiv(location, v)",
  uvec2: "gl.uniform2uiv(location, v)",
  uvec3: "gl.uniform3uiv(location, v)",
  uvec4: "gl.uniform4uiv(location, v)",
  bool: "gl.uniform1iv(location, v)",
  bvec2: "gl.uniform2iv(location, v)",
  bvec3: "gl.uniform3iv(location, v)",
  bvec4: "gl.uniform4iv(location, v)",
  sampler2D: "gl.uniform1iv(location, v)",
  samplerCube: "gl.uniform1iv(location, v)",
  sampler2DArray: "gl.uniform1iv(location, v)"
};
function sw(n, t) {
  const e = [`
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
    `];
  for (const r in n.uniforms) {
    const i = t[r];
    if (!i) {
      n.uniforms[r]?.group === !0 && (n.uniforms[r].ubo ? e.push(`
                        renderer.shader.syncUniformBufferGroup(uv.${r}, '${r}');
                    `) : e.push(`
                        renderer.shader.syncUniformGroup(uv.${r}, syncData);
                    `));
      continue;
    }
    const s = n.uniforms[r];
    let o = !1;
    for (let a = 0; a < rs.length; a++)
      if (rs[a].test(i, s)) {
        e.push(rs[a].code(r, s)), o = !0;
        break;
      }
    if (!o) {
      const a = (i.size === 1 && !i.isArray ? nw : iw)[i.type].replace("location", `ud["${r}"].location`);
      e.push(`
            cu = ud["${r}"];
            cv = cu.value;
            v = uv["${r}"];
            ${a};`);
    }
  }
  return new Function("ud", "uv", "renderer", "syncData", e.join(`
`));
}
const r0 = {};
let ta = r0;
function ow() {
  if (ta === r0 || ta?.isContextLost()) {
    const n = ht.ADAPTER.createCanvas();
    let t;
    ht.PREFER_ENV >= Ri.WEBGL2 && (t = n.getContext("webgl2", {})), t || (t = n.getContext("webgl", {}) || n.getContext("experimental-webgl", {}), t ? t.getExtension("WEBGL_draw_buffers") : t = null), ta = t;
  }
  return ta;
}
let ea;
function aw() {
  if (!ea) {
    ea = qe.MEDIUM;
    const n = ow();
    if (n && n.getShaderPrecisionFormat) {
      const t = n.getShaderPrecisionFormat(n.FRAGMENT_SHADER, n.HIGH_FLOAT);
      t && (ea = t.precision ? qe.HIGH : qe.MEDIUM);
    }
  }
  return ea;
}
function Np(n, t) {
  const e = n.getShaderSource(t).split(`
`).map((l, u) => `${u}: ${l}`), r = n.getShaderInfoLog(t), i = r.split(`
`), s = {}, o = i.map((l) => parseFloat(l.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"))).filter((l) => l && !s[l] ? (s[l] = !0, !0) : !1), a = [""];
  o.forEach((l) => {
    e[l - 1] = `%c${e[l - 1]}%c`, a.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
  });
  const h = e.join(`
`);
  a[0] = h, console.error(r), console.groupCollapsed("click to view full shader code"), console.warn(...a), console.groupEnd();
}
function hw(n, t, e, r) {
  n.getProgramParameter(t, n.LINK_STATUS) || (n.getShaderParameter(e, n.COMPILE_STATUS) || Np(n, e), n.getShaderParameter(r, n.COMPILE_STATUS) || Np(n, r), console.error("PixiJS Error: Could not initialize shader."), n.getProgramInfoLog(t) !== "" && console.warn("PixiJS Warning: gl.getProgramInfoLog()", n.getProgramInfoLog(t)));
}
const lw = {
  float: 1,
  vec2: 2,
  vec3: 3,
  vec4: 4,
  int: 1,
  ivec2: 2,
  ivec3: 3,
  ivec4: 4,
  uint: 1,
  uvec2: 2,
  uvec3: 3,
  uvec4: 4,
  bool: 1,
  bvec2: 2,
  bvec3: 3,
  bvec4: 4,
  mat2: 4,
  mat3: 9,
  mat4: 16,
  sampler2D: 1
};
function n0(n) {
  return lw[n];
}
let ra = null;
const kp = {
  FLOAT: "float",
  FLOAT_VEC2: "vec2",
  FLOAT_VEC3: "vec3",
  FLOAT_VEC4: "vec4",
  INT: "int",
  INT_VEC2: "ivec2",
  INT_VEC3: "ivec3",
  INT_VEC4: "ivec4",
  UNSIGNED_INT: "uint",
  UNSIGNED_INT_VEC2: "uvec2",
  UNSIGNED_INT_VEC3: "uvec3",
  UNSIGNED_INT_VEC4: "uvec4",
  BOOL: "bool",
  BOOL_VEC2: "bvec2",
  BOOL_VEC3: "bvec3",
  BOOL_VEC4: "bvec4",
  FLOAT_MAT2: "mat2",
  FLOAT_MAT3: "mat3",
  FLOAT_MAT4: "mat4",
  SAMPLER_2D: "sampler2D",
  INT_SAMPLER_2D: "sampler2D",
  UNSIGNED_INT_SAMPLER_2D: "sampler2D",
  SAMPLER_CUBE: "samplerCube",
  INT_SAMPLER_CUBE: "samplerCube",
  UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
  SAMPLER_2D_ARRAY: "sampler2DArray",
  INT_SAMPLER_2D_ARRAY: "sampler2DArray",
  UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray"
};
function i0(n, t) {
  if (!ra) {
    const e = Object.keys(kp);
    ra = {};
    for (let r = 0; r < e.length; ++r) {
      const i = e[r];
      ra[n[i]] = kp[i];
    }
  }
  return ra[t];
}
function Bp(n, t, e) {
  if (n.substring(0, 9) !== "precision") {
    let r = t;
    return t === qe.HIGH && e !== qe.HIGH && (r = qe.MEDIUM), `precision ${r} float;
${n}`;
  } else if (e !== qe.HIGH && n.substring(0, 15) === "precision highp")
    return n.replace("precision highp", "precision mediump");
  return n;
}
let Ns;
function uw() {
  if (typeof Ns == "boolean")
    return Ns;
  try {
    Ns = new Function("param1", "param2", "param3", "return param1[param2] === param3;")({ a: "b" }, "a", "b") === !0;
  } catch {
    Ns = !1;
  }
  return Ns;
}
let cw = 0;
const na = {}, Qu = class Xi {
  /**
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param name - Name for shader
   * @param extra - Extra data for shader
   */
  constructor(t, e, r = "pixi-shader", i = {}) {
    this.extra = {}, this.id = cw++, this.vertexSrc = t || Xi.defaultVertexSrc, this.fragmentSrc = e || Xi.defaultFragmentSrc, this.vertexSrc = this.vertexSrc.trim(), this.fragmentSrc = this.fragmentSrc.trim(), this.extra = i, this.vertexSrc.substring(0, 8) !== "#version" && (r = r.replace(/\s+/g, "-"), na[r] ? (na[r]++, r += `-${na[r]}`) : na[r] = 1, this.vertexSrc = `#define SHADER_NAME ${r}
${this.vertexSrc}`, this.fragmentSrc = `#define SHADER_NAME ${r}
${this.fragmentSrc}`, this.vertexSrc = Bp(
      this.vertexSrc,
      Xi.defaultVertexPrecision,
      qe.HIGH
    ), this.fragmentSrc = Bp(
      this.fragmentSrc,
      Xi.defaultFragmentPrecision,
      aw()
    )), this.glPrograms = {}, this.syncUniforms = null;
  }
  /**
   * The default vertex shader source.
   * @readonly
   */
  static get defaultVertexSrc() {
    return rw;
  }
  /**
   * The default fragment shader source.
   * @readonly
   */
  static get defaultFragmentSrc() {
    return ew;
  }
  /**
   * A short hand function to create a program based of a vertex and fragment shader.
   *
   * This method will also check to see if there is a cached program.
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param name - Name for shader
   * @returns A shiny new PixiJS shader program!
   */
  static from(t, e, r) {
    const i = t + e;
    let s = Ip[i];
    return s || (Ip[i] = s = new Xi(t, e, r)), s;
  }
};
Qu.defaultVertexPrecision = qe.HIGH, /**
* Default specify float precision in fragment shader.
* iOS is best set at highp due to https://github.com/pixijs/pixijs/issues/3742
* @static
* @type {PIXI.PRECISION}
* @default PIXI.PRECISION.MEDIUM
*/
Qu.defaultFragmentPrecision = Jr.apple.device ? qe.HIGH : qe.MEDIUM;
let en = Qu, dw = 0;
class mr {
  /**
   * @param {object | Buffer} [uniforms] - Custom uniforms to use to augment the built-in ones. Or a pixi buffer.
   * @param isStatic - Uniforms wont be changed after creation.
   * @param isUbo - If true, will treat this uniform group as a uniform buffer object.
   */
  constructor(t, e, r) {
    this.group = !0, this.syncUniforms = {}, this.dirtyId = 0, this.id = dw++, this.static = !!e, this.ubo = !!r, t instanceof Yt ? (this.buffer = t, this.buffer.type = Fr.UNIFORM_BUFFER, this.autoManage = !1, this.ubo = !0) : (this.uniforms = t, this.ubo && (this.buffer = new Yt(new Float32Array(1)), this.buffer.type = Fr.UNIFORM_BUFFER, this.autoManage = !0));
  }
  update() {
    this.dirtyId++, !this.autoManage && this.buffer && this.buffer.update();
  }
  add(t, e, r) {
    if (!this.ubo)
      this.uniforms[t] = new mr(e, r);
    else
      throw new Error("[UniformGroup] uniform groups in ubo mode cannot be modified, or have uniform groups nested in them");
  }
  static from(t, e, r) {
    return new mr(t, e, r);
  }
  /**
   * A short hand function for creating a static UBO UniformGroup.
   * @param uniforms - the ubo item
   * @param _static - should this be updated each time it is used? defaults to true here!
   */
  static uboFrom(t, e) {
    return new mr(t, e ?? !0, !0);
  }
}
class Or {
  /**
   * @param program - The program the shader will use.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   */
  constructor(t, e) {
    this.uniformBindCount = 0, this.program = t, e ? e instanceof mr ? this.uniformGroup = e : this.uniformGroup = new mr(e) : this.uniformGroup = new mr({}), this.disposeRunner = new pr("disposeShader");
  }
  // TODO move to shader system..
  checkUniformExists(t, e) {
    if (e.uniforms[t])
      return !0;
    for (const r in e.uniforms) {
      const i = e.uniforms[r];
      if (i.group === !0 && this.checkUniformExists(t, i))
        return !0;
    }
    return !1;
  }
  destroy() {
    this.uniformGroup = null, this.disposeRunner.emit(this), this.disposeRunner.destroy();
  }
  /**
   * Shader uniform values, shortcut for `uniformGroup.uniforms`.
   * @readonly
   */
  get uniforms() {
    return this.uniformGroup.uniforms;
  }
  /**
   * A short hand function to create a shader based of a vertex and fragment shader.
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   * @returns A shiny new PixiJS shader!
   */
  static from(t, e, r) {
    const i = en.from(t, e);
    return new Or(i, r);
  }
}
class fw {
  /**
   * @param vertexSrc - Vertex shader
   * @param fragTemplate - Fragment shader template
   */
  constructor(t, e) {
    if (this.vertexSrc = t, this.fragTemplate = e, this.programCache = {}, this.defaultGroupCache = {}, !e.includes("%count%"))
      throw new Error('Fragment template must contain "%count%".');
    if (!e.includes("%forloop%"))
      throw new Error('Fragment template must contain "%forloop%".');
  }
  generateShader(t) {
    if (!this.programCache[t]) {
      const r = new Int32Array(t);
      for (let s = 0; s < t; s++)
        r[s] = s;
      this.defaultGroupCache[t] = mr.from({ uSamplers: r }, !0);
      let i = this.fragTemplate;
      i = i.replace(/%count%/gi, `${t}`), i = i.replace(/%forloop%/gi, this.generateSampleSrc(t)), this.programCache[t] = new en(this.vertexSrc, i);
    }
    const e = {
      tint: new Float32Array([1, 1, 1, 1]),
      translationMatrix: new Nt(),
      default: this.defaultGroupCache[t]
    };
    return new Or(this.programCache[t], e);
  }
  generateSampleSrc(t) {
    let e = "";
    e += `
`, e += `
`;
    for (let r = 0; r < t; r++)
      r > 0 && (e += `
else `), r < t - 1 && (e += `if(vTextureId < ${r}.5)`), e += `
{`, e += `
	color = texture2D(uSamplers[${r}], vTextureCoord);`, e += `
}`;
    return e += `
`, e += `
`, e;
  }
}
class Ju {
  constructor() {
    this.elements = [], this.ids = [], this.count = 0;
  }
  clear() {
    for (let t = 0; t < this.count; t++)
      this.elements[t] = null;
    this.count = 0;
  }
}
function pw() {
  return !Jr.apple.device;
}
function mw(n) {
  let t = !0;
  const e = ht.ADAPTER.getNavigator();
  if (Jr.tablet || Jr.phone) {
    if (Jr.apple.device) {
      const r = e.userAgent.match(/OS (\d+)_(\d+)?/);
      r && parseInt(r[1], 10) < 11 && (t = !1);
    }
    if (Jr.android.device) {
      const r = e.userAgent.match(/Android\s([0-9.]*)/);
      r && parseInt(r[1], 10) < 7 && (t = !1);
    }
  }
  return t ? n : 4;
}
class Rh {
  /**
   * @param renderer - The renderer this manager works for.
   */
  constructor(t) {
    this.renderer = t;
  }
  /** Stub method that should be used to empty the current batch by rendering objects now. */
  flush() {
  }
  /** Generic destruction method that frees all resources. This should be called by subclasses. */
  destroy() {
    this.renderer = null;
  }
  /**
   * Stub method that initializes any state required before
   * rendering starts. It is different from the `prerender`
   * signal, which occurs every frame, in that it is called
   * whenever an object requests _this_ renderer specifically.
   */
  start() {
  }
  /** Stops the renderer. It should free up any state and become dormant. */
  stop() {
    this.flush();
  }
  /**
   * Keeps the object to render. It doesn't have to be
   * rendered immediately.
   * @param {PIXI.DisplayObject} _object - The object to render.
   */
  render(t) {
  }
}
var gw = `varying vec2 vTextureCoord;
varying vec4 vColor;
varying float vTextureId;
uniform sampler2D uSamplers[%count%];

void main(void){
    vec4 color;
    %forloop%
    gl_FragColor = color * vColor;
}
`, yw = `precision highp float;
attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColor;
attribute float aTextureId;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform vec4 tint;

varying vec2 vTextureCoord;
varying vec4 vColor;
varying float vTextureId;

void main(void){
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vTextureId = aTextureId;
    vColor = aColor * tint;
}
`;
const Ys = class lr extends Rh {
  /**
   * This will hook onto the renderer's `contextChange`
   * and `prerender` signals.
   * @param {PIXI.Renderer} renderer - The renderer this works for.
   */
  constructor(t) {
    super(t), this.setShaderGenerator(), this.geometryClass = Jg, this.vertexSize = 6, this.state = Hr.for2d(), this.size = lr.defaultBatchSize * 4, this._vertexCount = 0, this._indexCount = 0, this._bufferedElements = [], this._bufferedTextures = [], this._bufferSize = 0, this._shader = null, this._packedGeometries = [], this._packedGeometryPoolSize = 2, this._flushId = 0, this._aBuffers = {}, this._iBuffers = {}, this.maxTextures = 1, this.renderer.on("prerender", this.onPrerender, this), t.runners.contextChange.add(this), this._dcIndex = 0, this._aIndex = 0, this._iIndex = 0, this._attributeBuffer = null, this._indexBuffer = null, this._tempBoundTextures = [];
  }
  /**
   * The maximum textures that this device supports.
   * @static
   * @default 32
   */
  static get defaultMaxTextures() {
    return this._defaultMaxTextures = this._defaultMaxTextures ?? mw(32), this._defaultMaxTextures;
  }
  static set defaultMaxTextures(t) {
    this._defaultMaxTextures = t;
  }
  /**
   * Can we upload the same buffer in a single frame?
   * @static
   */
  static get canUploadSameBuffer() {
    return this._canUploadSameBuffer = this._canUploadSameBuffer ?? pw(), this._canUploadSameBuffer;
  }
  static set canUploadSameBuffer(t) {
    this._canUploadSameBuffer = t;
  }
  /**
   * @see PIXI.BatchRenderer#maxTextures
   * @deprecated since 7.1.0
   * @readonly
   */
  get MAX_TEXTURES() {
    return wt("7.1.0", "BatchRenderer#MAX_TEXTURES renamed to BatchRenderer#maxTextures"), this.maxTextures;
  }
  /**
   * The default vertex shader source
   * @readonly
   */
  static get defaultVertexSrc() {
    return yw;
  }
  /**
   * The default fragment shader source
   * @readonly
   */
  static get defaultFragmentTemplate() {
    return gw;
  }
  /**
   * Set the shader generator.
   * @param {object} [options]
   * @param {string} [options.vertex=PIXI.BatchRenderer.defaultVertexSrc] - Vertex shader source
   * @param {string} [options.fragment=PIXI.BatchRenderer.defaultFragmentTemplate] - Fragment shader template
   */
  setShaderGenerator({
    vertex: t = lr.defaultVertexSrc,
    fragment: e = lr.defaultFragmentTemplate
  } = {}) {
    this.shaderGenerator = new fw(t, e);
  }
  /**
   * Handles the `contextChange` signal.
   *
   * It calculates `this.maxTextures` and allocating the packed-geometry object pool.
   */
  contextChange() {
    const t = this.renderer.gl;
    ht.PREFER_ENV === Ri.WEBGL_LEGACY ? this.maxTextures = 1 : (this.maxTextures = Math.min(
      t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS),
      lr.defaultMaxTextures
    ), this.maxTextures = Vx(
      this.maxTextures,
      t
    )), this._shader = this.shaderGenerator.generateShader(this.maxTextures);
    for (let e = 0; e < this._packedGeometryPoolSize; e++)
      this._packedGeometries[e] = new this.geometryClass();
    this.initFlushBuffers();
  }
  /** Makes sure that static and dynamic flush pooled objects have correct dimensions. */
  initFlushBuffers() {
    const {
      _drawCallPool: t,
      _textureArrayPool: e
    } = lr, r = this.size / 4, i = Math.floor(r / this.maxTextures) + 1;
    for (; t.length < r; )
      t.push(new ju());
    for (; e.length < i; )
      e.push(new Ju());
    for (let s = 0; s < this.maxTextures; s++)
      this._tempBoundTextures[s] = null;
  }
  /** Handles the `prerender` signal. It ensures that flushes start from the first geometry object again. */
  onPrerender() {
    this._flushId = 0;
  }
  /**
   * Buffers the "batchable" object. It need not be rendered immediately.
   * @param {PIXI.DisplayObject} element - the element to render when
   *    using this renderer
   */
  render(t) {
    t._texture.valid && (this._vertexCount + t.vertexData.length / 2 > this.size && this.flush(), this._vertexCount += t.vertexData.length / 2, this._indexCount += t.indices.length, this._bufferedTextures[this._bufferSize] = t._texture.baseTexture, this._bufferedElements[this._bufferSize++] = t);
  }
  buildTexturesAndDrawCalls() {
    const {
      _bufferedTextures: t,
      maxTextures: e
    } = this, r = lr._textureArrayPool, i = this.renderer.batch, s = this._tempBoundTextures, o = this.renderer.textureGC.count;
    let a = ++_t._globalBatch, h = 0, l = r[0], u = 0;
    i.copyBoundTextures(s, e);
    for (let c = 0; c < this._bufferSize; ++c) {
      const d = t[c];
      t[c] = null, d._batchEnabled !== a && (l.count >= e && (i.boundArray(l, s, a, e), this.buildDrawCalls(l, u, c), u = c, l = r[++h], ++a), d._batchEnabled = a, d.touched = o, l.elements[l.count++] = d);
    }
    l.count > 0 && (i.boundArray(l, s, a, e), this.buildDrawCalls(l, u, this._bufferSize), ++h, ++a);
    for (let c = 0; c < s.length; c++)
      s[c] = null;
    _t._globalBatch = a;
  }
  /**
   * Populating drawcalls for rendering
   * @param texArray
   * @param start
   * @param finish
   */
  buildDrawCalls(t, e, r) {
    const {
      _bufferedElements: i,
      _attributeBuffer: s,
      _indexBuffer: o,
      vertexSize: a
    } = this, h = lr._drawCallPool;
    let l = this._dcIndex, u = this._aIndex, c = this._iIndex, d = h[l];
    d.start = this._iIndex, d.texArray = t;
    for (let f = e; f < r; ++f) {
      const p = i[f], m = p._texture.baseTexture, g = qg[m.alphaMode ? 1 : 0][p.blendMode];
      i[f] = null, e < f && d.blend !== g && (d.size = c - d.start, e = f, d = h[++l], d.texArray = t, d.start = c), this.packInterleavedGeometry(p, s, o, u, c), u += p.vertexData.length / 2 * a, c += p.indices.length, d.blend = g;
    }
    e < r && (d.size = c - d.start, ++l), this._dcIndex = l, this._aIndex = u, this._iIndex = c;
  }
  /**
   * Bind textures for current rendering
   * @param texArray
   */
  bindAndClearTexArray(t) {
    const e = this.renderer.texture;
    for (let r = 0; r < t.count; r++)
      e.bind(t.elements[r], t.ids[r]), t.elements[r] = null;
    t.count = 0;
  }
  updateGeometry() {
    const {
      _packedGeometries: t,
      _attributeBuffer: e,
      _indexBuffer: r
    } = this;
    lr.canUploadSameBuffer ? (t[this._flushId]._buffer.update(e.rawBinaryData), t[this._flushId]._indexBuffer.update(r), this.renderer.geometry.updateBuffers()) : (this._packedGeometryPoolSize <= this._flushId && (this._packedGeometryPoolSize++, t[this._flushId] = new this.geometryClass()), t[this._flushId]._buffer.update(e.rawBinaryData), t[this._flushId]._indexBuffer.update(r), this.renderer.geometry.bind(t[this._flushId]), this.renderer.geometry.updateBuffers(), this._flushId++);
  }
  drawBatches() {
    const t = this._dcIndex, { gl: e, state: r } = this.renderer, i = lr._drawCallPool;
    let s = null;
    for (let o = 0; o < t; o++) {
      const { texArray: a, type: h, size: l, start: u, blend: c } = i[o];
      s !== a && (s = a, this.bindAndClearTexArray(a)), this.state.blendMode = c, r.set(this.state), e.drawElements(h, l, e.UNSIGNED_SHORT, u * 2);
    }
  }
  /** Renders the content _now_ and empties the current batch. */
  flush() {
    this._vertexCount !== 0 && (this._attributeBuffer = this.getAttributeBuffer(this._vertexCount), this._indexBuffer = this.getIndexBuffer(this._indexCount), this._aIndex = 0, this._iIndex = 0, this._dcIndex = 0, this.buildTexturesAndDrawCalls(), this.updateGeometry(), this.drawBatches(), this._bufferSize = 0, this._vertexCount = 0, this._indexCount = 0);
  }
  /** Starts a new sprite batch. */
  start() {
    this.renderer.state.set(this.state), this.renderer.texture.ensureSamplerType(this.maxTextures), this.renderer.shader.bind(this._shader), lr.canUploadSameBuffer && this.renderer.geometry.bind(this._packedGeometries[this._flushId]);
  }
  /** Stops and flushes the current batch. */
  stop() {
    this.flush();
  }
  /** Destroys this `BatchRenderer`. It cannot be used again. */
  destroy() {
    for (let t = 0; t < this._packedGeometryPoolSize; t++)
      this._packedGeometries[t] && this._packedGeometries[t].destroy();
    this.renderer.off("prerender", this.onPrerender, this), this._aBuffers = null, this._iBuffers = null, this._packedGeometries = null, this._attributeBuffer = null, this._indexBuffer = null, this._shader && (this._shader.destroy(), this._shader = null), super.destroy();
  }
  /**
   * Fetches an attribute buffer from `this._aBuffers` that can hold atleast `size` floats.
   * @param size - minimum capacity required
   * @returns - buffer than can hold atleast `size` floats
   */
  getAttributeBuffer(t) {
    const e = Wa(Math.ceil(t / 8)), r = Cp(e), i = e * 8;
    this._aBuffers.length <= r && (this._iBuffers.length = r + 1);
    let s = this._aBuffers[i];
    return s || (this._aBuffers[i] = s = new Xu(i * this.vertexSize * 4)), s;
  }
  /**
   * Fetches an index buffer from `this._iBuffers` that can
   * have at least `size` capacity.
   * @param size - minimum required capacity
   * @returns - buffer that can fit `size` indices.
   */
  getIndexBuffer(t) {
    const e = Wa(Math.ceil(t / 12)), r = Cp(e), i = e * 12;
    this._iBuffers.length <= r && (this._iBuffers.length = r + 1);
    let s = this._iBuffers[r];
    return s || (this._iBuffers[r] = s = new Uint16Array(i)), s;
  }
  /**
   * Takes the four batching parameters of `element`, interleaves
   * and pushes them into the batching attribute/index buffers given.
   *
   * It uses these properties: `vertexData` `uvs`, `textureId` and
   * `indicies`. It also uses the "tint" of the base-texture, if
   * present.
   * @param {PIXI.DisplayObject} element - element being rendered
   * @param attributeBuffer - attribute buffer.
   * @param indexBuffer - index buffer
   * @param aIndex - number of floats already in the attribute buffer
   * @param iIndex - number of indices already in `indexBuffer`
   */
  packInterleavedGeometry(t, e, r, i, s) {
    const {
      uint32View: o,
      float32View: a
    } = e, h = i / this.vertexSize, l = t.uvs, u = t.indices, c = t.vertexData, d = t._texture.baseTexture._batchLocation, f = Math.min(t.worldAlpha, 1), p = Ot.shared.setValue(t._tintRGB).toPremultiplied(f, t._texture.baseTexture.alphaMode > 0);
    for (let m = 0; m < c.length; m += 2)
      a[i++] = c[m], a[i++] = c[m + 1], a[i++] = l[m], a[i++] = l[m + 1], o[i++] = p, a[i++] = d;
    for (let m = 0; m < u.length; m++)
      r[s++] = h + u[m];
  }
};
Ys.defaultBatchSize = 4096, /** @ignore */
Ys.extension = {
  name: "batch",
  type: st.RendererPlugin
}, /**
* Pool of `BatchDrawCall` objects that `flush` used
* to create "batches" of the objects being rendered.
*
* These are never re-allocated again.
* Shared between all batch renderers because it can be only one "flush" working at the moment.
* @member {PIXI.BatchDrawCall[]}
*/
Ys._drawCallPool = [], /**
* Pool of `BatchDrawCall` objects that `flush` used
* to create "batches" of the objects being rendered.
*
* These are never re-allocated again.
* Shared between all batch renderers because it can be only one "flush" working at the moment.
* @member {PIXI.BatchTextureArray[]}
*/
Ys._textureArrayPool = [];
let hi = Ys;
dt.add(hi);
var _w = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
   gl_FragColor = texture2D(uSampler, vTextureCoord);
}
`, vw = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`;
const tc = class js extends Or {
  /**
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   */
  constructor(t, e, r) {
    const i = en.from(
      t || js.defaultVertexSrc,
      e || js.defaultFragmentSrc
    );
    super(i, r), this.padding = 0, this.resolution = js.defaultResolution, this.multisample = js.defaultMultisample, this.enabled = !0, this.autoFit = !0, this.state = new Hr();
  }
  /**
   * Applies the filter
   * @param {PIXI.FilterSystem} filterManager - The renderer to retrieve the filter from
   * @param {PIXI.RenderTexture} input - The input render target.
   * @param {PIXI.RenderTexture} output - The target to output to.
   * @param {PIXI.CLEAR_MODES} [clearMode] - Should the output be cleared before rendering to it.
   * @param {object} [_currentState] - It's current state of filter.
   *        There are some useful properties in the currentState :
   *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
   */
  apply(t, e, r, i, s) {
    t.applyFilter(this, e, r, i);
  }
  /**
   * Sets the blend mode of the filter.
   * @default PIXI.BLEND_MODES.NORMAL
   */
  get blendMode() {
    return this.state.blendMode;
  }
  set blendMode(t) {
    this.state.blendMode = t;
  }
  /**
   * The resolution of the filter. Setting this to be lower will lower the quality but
   * increase the performance of the filter.
   * If set to `null` or `0`, the resolution of the current render target is used.
   * @default PIXI.Filter.defaultResolution
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(t) {
    this._resolution = t;
  }
  /**
   * The default vertex shader source
   * @readonly
   */
  static get defaultVertexSrc() {
    return vw;
  }
  /**
   * The default fragment shader source
   * @readonly
   */
  static get defaultFragmentSrc() {
    return _w;
  }
};
tc.defaultResolution = 1, /**
* Default filter samples for any filter.
* @static
* @type {PIXI.MSAA_QUALITY|null}
* @default PIXI.MSAA_QUALITY.NONE
*/
tc.defaultMultisample = Zt.NONE;
let ve = tc;
class Va {
  constructor() {
    this.clearBeforeRender = !0, this._backgroundColor = new Ot(0), this.alpha = 1;
  }
  /**
   * initiates the background system
   * @param {PIXI.IRendererOptions} options - the options for the background colors
   */
  init(t) {
    this.clearBeforeRender = t.clearBeforeRender;
    const { backgroundColor: e, background: r, backgroundAlpha: i } = t, s = r ?? e;
    s !== void 0 && (this.color = s), this.alpha = i;
  }
  /**
   * The background color to fill if not transparent.
   * @member {PIXI.ColorSource}
   */
  get color() {
    return this._backgroundColor.value;
  }
  set color(t) {
    this._backgroundColor.setValue(t);
  }
  /**
   * The background color alpha. Setting this to 0 will make the canvas transparent.
   * @member {number}
   */
  get alpha() {
    return this._backgroundColor.alpha;
  }
  set alpha(t) {
    this._backgroundColor.setAlpha(t);
  }
  /** The background color object. */
  get backgroundColor() {
    return this._backgroundColor;
  }
  destroy() {
  }
}
Va.defaultOptions = {
  /**
   * {@link PIXI.IRendererOptions.backgroundAlpha}
   * @default 1
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  backgroundAlpha: 1,
  /**
   * {@link PIXI.IRendererOptions.backgroundColor}
   * @default 0x000000
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  backgroundColor: 0,
  /**
   * {@link PIXI.IRendererOptions.clearBeforeRender}
   * @default true
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  clearBeforeRender: !0
}, /** @ignore */
Va.extension = {
  type: [
    st.RendererSystem,
    st.CanvasRendererSystem
  ],
  name: "background"
};
dt.add(Va);
class s0 {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(t) {
    this.renderer = t, this.emptyRenderer = new Rh(t), this.currentRenderer = this.emptyRenderer;
  }
  /**
   * Changes the current renderer to the one given in parameter
   * @param objectRenderer - The object renderer to use.
   */
  setObjectRenderer(t) {
    this.currentRenderer !== t && (this.currentRenderer.stop(), this.currentRenderer = t, this.currentRenderer.start());
  }
  /**
   * This should be called if you wish to do some custom rendering
   * It will basically render anything that may be batched up such as sprites
   */
  flush() {
    this.setObjectRenderer(this.emptyRenderer);
  }
  /** Reset the system to an empty renderer */
  reset() {
    this.setObjectRenderer(this.emptyRenderer);
  }
  /**
   * Handy function for batch renderers: copies bound textures in first maxTextures locations to array
   * sets actual _batchLocation for them
   * @param arr - arr copy destination
   * @param maxTextures - number of copied elements
   */
  copyBoundTextures(t, e) {
    const { boundTextures: r } = this.renderer.texture;
    for (let i = e - 1; i >= 0; --i)
      t[i] = r[i] || null, t[i] && (t[i]._batchLocation = i);
  }
  /**
   * Assigns batch locations to textures in array based on boundTextures state.
   * All textures in texArray should have `_batchEnabled = _batchId`,
   * and their count should be less than `maxTextures`.
   * @param texArray - textures to bound
   * @param boundTextures - current state of bound textures
   * @param batchId - marker for _batchEnabled param of textures in texArray
   * @param maxTextures - number of texture locations to manipulate
   */
  boundArray(t, e, r, i) {
    const { elements: s, ids: o, count: a } = t;
    let h = 0;
    for (let l = 0; l < a; l++) {
      const u = s[l], c = u._batchLocation;
      if (c >= 0 && c < i && e[c] === u) {
        o[l] = c;
        continue;
      }
      for (; h < i; ) {
        const d = e[h];
        if (d && d._batchEnabled === r && d._batchLocation === h) {
          h++;
          continue;
        }
        o[l] = h, u._batchLocation = h, e[h] = u;
        break;
      }
    }
  }
  /**
   * @ignore
   */
  destroy() {
    this.renderer = null;
  }
}
s0.extension = {
  type: st.RendererSystem,
  name: "batch"
};
dt.add(s0);
let Lp = 0;
class Ya {
  /** @param renderer - The renderer this System works for. */
  constructor(t) {
    this.renderer = t, this.webGLVersion = 1, this.extensions = {}, this.supports = {
      uint32Indices: !1
    }, this.handleContextLost = this.handleContextLost.bind(this), this.handleContextRestored = this.handleContextRestored.bind(this);
  }
  /**
   * `true` if the context is lost
   * @readonly
   */
  get isLost() {
    return !this.gl || this.gl.isContextLost();
  }
  /**
   * Handles the context change event.
   * @param {WebGLRenderingContext} gl - New WebGL context.
   */
  contextChange(t) {
    this.gl = t, this.renderer.gl = t, this.renderer.CONTEXT_UID = Lp++;
  }
  init(t) {
    if (t.context)
      this.initFromContext(t.context);
    else {
      const e = this.renderer.background.alpha < 1, r = t.premultipliedAlpha;
      this.preserveDrawingBuffer = t.preserveDrawingBuffer, this.useContextAlpha = t.useContextAlpha, this.powerPreference = t.powerPreference, this.initFromOptions({
        alpha: e,
        premultipliedAlpha: r,
        antialias: t.antialias,
        stencil: !0,
        preserveDrawingBuffer: t.preserveDrawingBuffer,
        powerPreference: t.powerPreference
      });
    }
  }
  /**
   * Initializes the context.
   * @protected
   * @param {WebGLRenderingContext} gl - WebGL context
   */
  initFromContext(t) {
    this.gl = t, this.validateContext(t), this.renderer.gl = t, this.renderer.CONTEXT_UID = Lp++, this.renderer.runners.contextChange.emit(t);
    const e = this.renderer.view;
    e.addEventListener !== void 0 && (e.addEventListener("webglcontextlost", this.handleContextLost, !1), e.addEventListener("webglcontextrestored", this.handleContextRestored, !1));
  }
  /**
   * Initialize from context options
   * @protected
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
   * @param {object} options - context attributes
   */
  initFromOptions(t) {
    const e = this.createContext(this.renderer.view, t);
    this.initFromContext(e);
  }
  /**
   * Helper class to create a WebGL Context
   * @param canvas - the canvas element that we will get the context from
   * @param options - An options object that gets passed in to the canvas element containing the
   *    context attributes
   * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
   * @returns {WebGLRenderingContext} the WebGL context
   */
  createContext(t, e) {
    let r;
    if (ht.PREFER_ENV >= Ri.WEBGL2 && (r = t.getContext("webgl2", e)), r)
      this.webGLVersion = 2;
    else if (this.webGLVersion = 1, r = t.getContext("webgl", e) || t.getContext("experimental-webgl", e), !r)
      throw new Error("This browser does not support WebGL. Try using the canvas renderer");
    return this.gl = r, this.getExtensions(), this.gl;
  }
  /** Auto-populate the {@link PIXI.ContextSystem.extensions extensions}. */
  getExtensions() {
    const { gl: t } = this, e = {
      loseContext: t.getExtension("WEBGL_lose_context"),
      anisotropicFiltering: t.getExtension("EXT_texture_filter_anisotropic"),
      floatTextureLinear: t.getExtension("OES_texture_float_linear"),
      s3tc: t.getExtension("WEBGL_compressed_texture_s3tc"),
      s3tc_sRGB: t.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
      // eslint-disable-line camelcase
      etc: t.getExtension("WEBGL_compressed_texture_etc"),
      etc1: t.getExtension("WEBGL_compressed_texture_etc1"),
      pvrtc: t.getExtension("WEBGL_compressed_texture_pvrtc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
      atc: t.getExtension("WEBGL_compressed_texture_atc"),
      astc: t.getExtension("WEBGL_compressed_texture_astc")
    };
    this.webGLVersion === 1 ? Object.assign(this.extensions, e, {
      drawBuffers: t.getExtension("WEBGL_draw_buffers"),
      depthTexture: t.getExtension("WEBGL_depth_texture"),
      vertexArrayObject: t.getExtension("OES_vertex_array_object") || t.getExtension("MOZ_OES_vertex_array_object") || t.getExtension("WEBKIT_OES_vertex_array_object"),
      uint32ElementIndex: t.getExtension("OES_element_index_uint"),
      // Floats and half-floats
      floatTexture: t.getExtension("OES_texture_float"),
      floatTextureLinear: t.getExtension("OES_texture_float_linear"),
      textureHalfFloat: t.getExtension("OES_texture_half_float"),
      textureHalfFloatLinear: t.getExtension("OES_texture_half_float_linear")
    }) : this.webGLVersion === 2 && Object.assign(this.extensions, e, {
      // Floats and half-floats
      colorBufferFloat: t.getExtension("EXT_color_buffer_float")
    });
  }
  /**
   * Handles a lost webgl context
   * @param {WebGLContextEvent} event - The context lost event.
   */
  handleContextLost(t) {
    t.preventDefault(), setTimeout(() => {
      this.gl.isContextLost() && this.extensions.loseContext && this.extensions.loseContext.restoreContext();
    }, 0);
  }
  /** Handles a restored webgl context. */
  handleContextRestored() {
    this.renderer.runners.contextChange.emit(this.gl);
  }
  destroy() {
    const t = this.renderer.view;
    this.renderer = null, t.removeEventListener !== void 0 && (t.removeEventListener("webglcontextlost", this.handleContextLost), t.removeEventListener("webglcontextrestored", this.handleContextRestored)), this.gl.useProgram(null), this.extensions.loseContext && this.extensions.loseContext.loseContext();
  }
  /** Handle the post-render runner event. */
  postrender() {
    this.renderer.objectRenderer.renderingToScreen && this.gl.flush();
  }
  /**
   * Validate context.
   * @param {WebGLRenderingContext} gl - Render context.
   */
  validateContext(t) {
    const e = t.getContextAttributes(), r = "WebGL2RenderingContext" in globalThis && t instanceof globalThis.WebGL2RenderingContext;
    r && (this.webGLVersion = 2), e && !e.stencil && console.warn("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
    const i = r || !!t.getExtension("OES_element_index_uint");
    this.supports.uint32Indices = i, i || console.warn("Provided WebGL context does not support 32 index buffer, complex graphics may not render correctly");
  }
}
Ya.defaultOptions = {
  /**
   * {@link PIXI.IRendererOptions.context}
   * @default null
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  context: null,
  /**
   * {@link PIXI.IRendererOptions.antialias}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  antialias: !1,
  /**
   * {@link PIXI.IRendererOptions.premultipliedAlpha}
   * @default true
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  premultipliedAlpha: !0,
  /**
   * {@link PIXI.IRendererOptions.preserveDrawingBuffer}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  preserveDrawingBuffer: !1,
  /**
   * {@link PIXI.IRendererOptions.powerPreference}
   * @default default
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  powerPreference: "default"
}, /** @ignore */
Ya.extension = {
  type: st.RendererSystem,
  name: "context"
};
dt.add(Ya);
class ec {
  /**
   * @param width - Width of the frame buffer
   * @param height - Height of the frame buffer
   */
  constructor(t, e) {
    if (this.width = Math.round(t), this.height = Math.round(e), !this.width || !this.height)
      throw new Error("Framebuffer width or height is zero");
    this.stencil = !1, this.depth = !1, this.dirtyId = 0, this.dirtyFormat = 0, this.dirtySize = 0, this.depthTexture = null, this.colorTextures = [], this.glFramebuffers = {}, this.disposeRunner = new pr("disposeFramebuffer"), this.multisample = Zt.NONE;
  }
  /**
   * Reference to the colorTexture.
   * @readonly
   */
  get colorTexture() {
    return this.colorTextures[0];
  }
  /**
   * Add texture to the colorTexture array.
   * @param index - Index of the array to add the texture to
   * @param texture - Texture to add to the array
   */
  addColorTexture(t = 0, e) {
    return this.colorTextures[t] = e || new _t(null, {
      scaleMode: Qr.NEAREST,
      resolution: 1,
      mipmap: Lr.OFF,
      width: this.width,
      height: this.height
    }), this.dirtyId++, this.dirtyFormat++, this;
  }
  /**
   * Add a depth texture to the frame buffer.
   * @param texture - Texture to add.
   */
  addDepthTexture(t) {
    return this.depthTexture = t || new _t(null, {
      scaleMode: Qr.NEAREST,
      resolution: 1,
      width: this.width,
      height: this.height,
      mipmap: Lr.OFF,
      format: Q.DEPTH_COMPONENT,
      type: pt.UNSIGNED_SHORT
    }), this.dirtyId++, this.dirtyFormat++, this;
  }
  /** Enable depth on the frame buffer. */
  enableDepth() {
    return this.depth = !0, this.dirtyId++, this.dirtyFormat++, this;
  }
  /** Enable stencil on the frame buffer. */
  enableStencil() {
    return this.stencil = !0, this.dirtyId++, this.dirtyFormat++, this;
  }
  /**
   * Resize the frame buffer
   * @param width - Width of the frame buffer to resize to
   * @param height - Height of the frame buffer to resize to
   */
  resize(t, e) {
    if (t = Math.round(t), e = Math.round(e), !t || !e)
      throw new Error("Framebuffer width and height must not be zero");
    if (!(t === this.width && e === this.height)) {
      this.width = t, this.height = e, this.dirtyId++, this.dirtySize++;
      for (let r = 0; r < this.colorTextures.length; r++) {
        const i = this.colorTextures[r], s = i.resolution;
        i.setSize(t / s, e / s);
      }
      if (this.depthTexture) {
        const r = this.depthTexture.resolution;
        this.depthTexture.setSize(t / r, e / r);
      }
    }
  }
  /** Disposes WebGL resources that are connected to this geometry. */
  dispose() {
    this.disposeRunner.emit(this, !1);
  }
  /** Destroys and removes the depth texture added to this framebuffer. */
  destroyDepthTexture() {
    this.depthTexture && (this.depthTexture.destroy(), this.depthTexture = null, ++this.dirtyId, ++this.dirtyFormat);
  }
}
class o0 extends _t {
  /**
   * @param options
   * @param {number} [options.width=100] - The width of the base render texture.
   * @param {number} [options.height=100] - The height of the base render texture.
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.BaseTexture.defaultOptions.scaleMode] - See {@link PIXI.SCALE_MODES}
   *   for possible values.
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio
   *   of the texture being generated.
   * @param {PIXI.MSAA_QUALITY} [options.multisample=PIXI.MSAA_QUALITY.NONE] - The number of samples of the frame buffer.
   */
  constructor(t = {}) {
    if (typeof t == "number") {
      const e = arguments[0], r = arguments[1], i = arguments[2], s = arguments[3];
      t = { width: e, height: r, scaleMode: i, resolution: s };
    }
    t.width = t.width ?? 100, t.height = t.height ?? 100, t.multisample ?? (t.multisample = Zt.NONE), super(null, t), this.mipmap = Lr.OFF, this.valid = !0, this._clear = new Ot([0, 0, 0, 0]), this.framebuffer = new ec(this.realWidth, this.realHeight).addColorTexture(0, this), this.framebuffer.multisample = t.multisample, this.maskStack = [], this.filterStack = [{}];
  }
  /** Color when clearning the texture. */
  set clearColor(t) {
    this._clear.setValue(t);
  }
  get clearColor() {
    return this._clear.value;
  }
  /**
   * Color object when clearning the texture.
   * @readonly
   * @since 7.2.0
   */
  get clear() {
    return this._clear;
  }
  /**
   * Shortcut to `this.framebuffer.multisample`.
   * @default PIXI.MSAA_QUALITY.NONE
   */
  get multisample() {
    return this.framebuffer.multisample;
  }
  set multisample(t) {
    this.framebuffer.multisample = t;
  }
  /**
   * Resizes the BaseRenderTexture.
   * @param desiredWidth - The desired width to resize to.
   * @param desiredHeight - The desired height to resize to.
   */
  resize(t, e) {
    this.framebuffer.resize(t * this.resolution, e * this.resolution), this.setRealSize(this.framebuffer.width, this.framebuffer.height);
  }
  /**
   * Frees the texture and framebuffer from WebGL memory without destroying this texture object.
   * This means you can still use the texture later which will upload it to GPU
   * memory again.
   * @fires PIXI.BaseTexture#dispose
   */
  dispose() {
    this.framebuffer.dispose(), super.dispose();
  }
  /** Destroys this texture. */
  destroy() {
    super.destroy(), this.framebuffer.destroyDepthTexture(), this.framebuffer = null;
  }
}
class Ln extends fo {
  /**
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source
   */
  constructor(t) {
    const e = t, r = e.naturalWidth || e.videoWidth || e.width, i = e.naturalHeight || e.videoHeight || e.height;
    super(r, i), this.source = t, this.noSubImage = !1;
  }
  /**
   * Set cross origin based detecting the url and the crossorigin
   * @param element - Element to apply crossOrigin
   * @param url - URL to check
   * @param crossorigin - Cross origin value to use
   */
  static crossOrigin(t, e, r) {
    r === void 0 && !e.startsWith("data:") ? t.crossOrigin = Wx(e) : r !== !1 && (t.crossOrigin = typeof r == "string" ? r : "anonymous");
  }
  /**
   * Upload the texture to the GPU.
   * @param renderer - Upload to the renderer
   * @param baseTexture - Reference to parent texture
   * @param glTexture
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} [source] - (optional)
   * @returns - true is success
   */
  upload(t, e, r, i) {
    const s = t.gl, o = e.realWidth, a = e.realHeight;
    if (i = i || this.source, typeof HTMLImageElement < "u" && i instanceof HTMLImageElement) {
      if (!i.complete || i.naturalWidth === 0)
        return !1;
    } else if (typeof HTMLVideoElement < "u" && i instanceof HTMLVideoElement && i.readyState <= 1)
      return !1;
    return s.pixelStorei(s.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e.alphaMode === Ae.UNPACK), !this.noSubImage && e.target === s.TEXTURE_2D && r.width === o && r.height === a ? s.texSubImage2D(s.TEXTURE_2D, 0, 0, 0, e.format, r.type, i) : (r.width = o, r.height = a, s.texImage2D(e.target, 0, r.internalFormat, e.format, r.type, i)), !0;
  }
  /**
   * Checks if source width/height was changed, resize can cause extra baseTexture update.
   * Triggers one update in any case.
   */
  update() {
    if (this.destroyed)
      return;
    const t = this.source, e = t.naturalWidth || t.videoWidth || t.width, r = t.naturalHeight || t.videoHeight || t.height;
    this.resize(e, r), super.update();
  }
  /** Destroy this {@link PIXI.BaseImageResource} */
  dispose() {
    this.source = null;
  }
}
class a0 extends Ln {
  /**
   * @param source - image source or URL
   * @param options
   * @param {boolean} [options.autoLoad=true] - start loading process
   * @param {boolean} [options.createBitmap=PIXI.settings.CREATE_IMAGE_BITMAP] - whether its required to create
   *        a bitmap before upload
   * @param {boolean} [options.crossorigin=true] - Load image using cross origin
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.UNPACK] - Premultiply image alpha in bitmap
   */
  constructor(t, e) {
    if (e = e || {}, typeof t == "string") {
      const r = new Image();
      Ln.crossOrigin(r, t, e.crossorigin), r.src = t, t = r;
    }
    super(t), !t.complete && this._width && this._height && (this._width = 0, this._height = 0), this.url = t.src, this._process = null, this.preserveBitmap = !1, this.createBitmap = (e.createBitmap ?? ht.CREATE_IMAGE_BITMAP) && !!globalThis.createImageBitmap, this.alphaMode = typeof e.alphaMode == "number" ? e.alphaMode : null, this.bitmap = null, this._load = null, e.autoLoad !== !1 && this.load();
  }
  /**
   * Returns a promise when image will be loaded and processed.
   * @param createBitmap - whether process image into bitmap
   */
  load(t) {
    return this._load ? this._load : (t !== void 0 && (this.createBitmap = t), this._load = new Promise((e, r) => {
      const i = this.source;
      this.url = i.src;
      const s = () => {
        this.destroyed || (i.onload = null, i.onerror = null, this.update(), this._load = null, this.createBitmap ? e(this.process()) : e(this));
      };
      i.complete && i.src ? s() : (i.onload = s, i.onerror = (o) => {
        r(o), this.onError.emit(o);
      });
    }), this._load);
  }
  /**
   * Called when we need to convert image into BitmapImage.
   * Can be called multiple times, real promise is cached inside.
   * @returns - Cached promise to fill that bitmap
   */
  process() {
    const t = this.source;
    if (this._process !== null)
      return this._process;
    if (this.bitmap !== null || !globalThis.createImageBitmap)
      return Promise.resolve(this);
    const e = globalThis.createImageBitmap, r = !t.crossOrigin || t.crossOrigin === "anonymous";
    return this._process = fetch(
      t.src,
      {
        mode: r ? "cors" : "no-cors"
      }
    ).then((i) => i.blob()).then((i) => e(
      i,
      0,
      0,
      t.width,
      t.height,
      {
        premultiplyAlpha: this.alphaMode === null || this.alphaMode === Ae.UNPACK ? "premultiply" : "none"
      }
    )).then((i) => this.destroyed ? Promise.reject() : (this.bitmap = i, this.update(), this._process = null, Promise.resolve(this))), this._process;
  }
  /**
   * Upload the image resource to GPU.
   * @param renderer - Renderer to upload to
   * @param baseTexture - BaseTexture for this resource
   * @param glTexture - GLTexture to use
   * @returns {boolean} true is success
   */
  upload(t, e, r) {
    if (typeof this.alphaMode == "number" && (e.alphaMode = this.alphaMode), !this.createBitmap)
      return super.upload(t, e, r);
    if (!this.bitmap && (this.process(), !this.bitmap))
      return !1;
    if (super.upload(t, e, r, this.bitmap), !this.preserveBitmap) {
      let i = !0;
      const s = e._glTextures;
      for (const o in s) {
        const a = s[o];
        if (a !== r && a.dirtyId !== e.dirtyId) {
          i = !1;
          break;
        }
      }
      i && (this.bitmap.close && this.bitmap.close(), this.bitmap = null);
    }
    return !0;
  }
  /** Destroys this resource. */
  dispose() {
    this.source.onload = null, this.source.onerror = null, super.dispose(), this.bitmap && (this.bitmap.close(), this.bitmap = null), this._process = null, this._load = null;
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if current environment support HTMLImageElement, and source is string or HTMLImageElement
   */
  static test(t) {
    return typeof HTMLImageElement < "u" && (typeof t == "string" || t instanceof HTMLImageElement);
  }
}
class hd {
  constructor() {
    this.x0 = 0, this.y0 = 0, this.x1 = 1, this.y1 = 0, this.x2 = 1, this.y2 = 1, this.x3 = 0, this.y3 = 1, this.uvsFloat32 = new Float32Array(8);
  }
  /**
   * Sets the texture Uvs based on the given frame information.
   * @protected
   * @param frame - The frame of the texture
   * @param baseFrame - The base frame of the texture
   * @param rotate - Rotation of frame, see {@link PIXI.groupD8}
   */
  set(t, e, r) {
    const i = e.width, s = e.height;
    if (r) {
      const o = t.width / 2 / i, a = t.height / 2 / s, h = t.x / i + o, l = t.y / s + a;
      r = Ut.add(r, Ut.NW), this.x0 = h + o * Ut.uX(r), this.y0 = l + a * Ut.uY(r), r = Ut.add(r, 2), this.x1 = h + o * Ut.uX(r), this.y1 = l + a * Ut.uY(r), r = Ut.add(r, 2), this.x2 = h + o * Ut.uX(r), this.y2 = l + a * Ut.uY(r), r = Ut.add(r, 2), this.x3 = h + o * Ut.uX(r), this.y3 = l + a * Ut.uY(r);
    } else
      this.x0 = t.x / i, this.y0 = t.y / s, this.x1 = (t.x + t.width) / i, this.y1 = t.y / s, this.x2 = (t.x + t.width) / i, this.y2 = (t.y + t.height) / s, this.x3 = t.x / i, this.y3 = (t.y + t.height) / s;
    this.uvsFloat32[0] = this.x0, this.uvsFloat32[1] = this.y0, this.uvsFloat32[2] = this.x1, this.uvsFloat32[3] = this.y1, this.uvsFloat32[4] = this.x2, this.uvsFloat32[5] = this.y2, this.uvsFloat32[6] = this.x3, this.uvsFloat32[7] = this.y3;
  }
}
hd.prototype.toString = function() {
  return `[@pixi/core:TextureUvs x0=${this.x0} y0=${this.y0} x1=${this.x1} y1=${this.y1} x2=${this.x2} y2=${this.y2} x3=${this.x3} y3=${this.y3}]`;
};
const Up = new hd();
function ia(n) {
  n.destroy = function() {
  }, n.on = function() {
  }, n.once = function() {
  }, n.emit = function() {
  };
}
class ct extends Co {
  /**
   * @param baseTexture - The base texture source to create the texture from
   * @param frame - The rectangle frame of the texture to show
   * @param orig - The area of original texture
   * @param trim - Trimmed rectangle of original texture
   * @param rotate - indicates how the texture was rotated by texture packer. See {@link PIXI.groupD8}
   * @param anchor - Default anchor point used for sprite placement / rotation
   * @param borders - Default borders used for 9-slice scaling. See {@link PIXI.NineSlicePlane}
   */
  constructor(t, e, r, i, s, o, a) {
    if (super(), this.noFrame = !1, e || (this.noFrame = !0, e = new yt(0, 0, 1, 1)), t instanceof ct && (t = t.baseTexture), this.baseTexture = t, this._frame = e, this.trim = i, this.valid = !1, this.destroyed = !1, this._uvs = Up, this.uvMatrix = null, this.orig = r || e, this._rotate = Number(s || 0), s === !0)
      this._rotate = 2;
    else if (this._rotate % 2 !== 0)
      throw new Error("attempt to use diamond-shaped UVs. If you are sure, set rotation manually");
    this.defaultAnchor = o ? new mt(o.x, o.y) : new mt(0, 0), this.defaultBorders = a, this._updateID = 0, this.textureCacheIds = [], t.valid ? this.noFrame ? t.valid && this.onBaseTextureUpdated(t) : this.frame = e : t.once("loaded", this.onBaseTextureUpdated, this), this.noFrame && t.on("update", this.onBaseTextureUpdated, this);
  }
  /**
   * Updates this texture on the gpu.
   *
   * Calls the TextureResource update.
   *
   * If you adjusted `frame` manually, please call `updateUvs()` instead.
   */
  update() {
    this.baseTexture.resource && this.baseTexture.resource.update();
  }
  /**
   * Called when the base texture is updated
   * @protected
   * @param baseTexture - The base texture.
   */
  onBaseTextureUpdated(t) {
    if (this.noFrame) {
      if (!this.baseTexture.valid)
        return;
      this._frame.width = t.width, this._frame.height = t.height, this.valid = !0, this.updateUvs();
    } else
      this.frame = this._frame;
    this.emit("update", this);
  }
  /**
   * Destroys this texture
   * @param [destroyBase=false] - Whether to destroy the base texture as well
   * @fires PIXI.Texture#destroyed
   */
  destroy(t) {
    if (this.baseTexture) {
      if (t) {
        const { resource: e } = this.baseTexture;
        e?.url && Ar[e.url] && ct.removeFromCache(e.url), this.baseTexture.destroy();
      }
      this.baseTexture.off("loaded", this.onBaseTextureUpdated, this), this.baseTexture.off("update", this.onBaseTextureUpdated, this), this.baseTexture = null;
    }
    this._frame = null, this._uvs = null, this.trim = null, this.orig = null, this.valid = !1, ct.removeFromCache(this), this.textureCacheIds = null, this.destroyed = !0, this.emit("destroyed", this), this.removeAllListeners();
  }
  /**
   * Creates a new texture object that acts the same as this one.
   * @returns - The new texture
   */
  clone() {
    const t = this._frame.clone(), e = this._frame === this.orig ? t : this.orig.clone(), r = new ct(
      this.baseTexture,
      !this.noFrame && t,
      e,
      this.trim?.clone(),
      this.rotate,
      this.defaultAnchor,
      this.defaultBorders
    );
    return this.noFrame && (r._frame = t), r;
  }
  /**
   * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
   * Call it after changing the frame
   */
  updateUvs() {
    this._uvs === Up && (this._uvs = new hd()), this._uvs.set(this._frame, this.baseTexture, this.rotate), this._updateID++;
  }
  /**
   * Helper function that creates a new Texture based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @param {string|PIXI.BaseTexture|HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source -
   *        Source or array of sources to create texture from
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
   * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
   * @returns {PIXI.Texture} The newly created texture
   */
  static from(t, e = {}, r = ht.STRICT_TEXTURE_CACHE) {
    const i = typeof t == "string";
    let s = null;
    if (i)
      s = t;
    else if (t instanceof _t) {
      if (!t.cacheId) {
        const a = e?.pixiIdPrefix || "pixiid";
        t.cacheId = `${a}-${Ti()}`, _t.addToCache(t, t.cacheId);
      }
      s = t.cacheId;
    } else {
      if (!t._pixiId) {
        const a = e?.pixiIdPrefix || "pixiid";
        t._pixiId = `${a}_${Ti()}`;
      }
      s = t._pixiId;
    }
    let o = Ar[s];
    if (i && r && !o)
      throw new Error(`The cacheId "${s}" does not exist in TextureCache.`);
    return !o && !(t instanceof _t) ? (e.resolution || (e.resolution = sn(t)), o = new ct(new _t(t, e)), o.baseTexture.cacheId = s, _t.addToCache(o.baseTexture, s), ct.addToCache(o, s)) : !o && t instanceof _t && (o = new ct(t), ct.addToCache(o, s)), o;
  }
  /**
   * Useful for loading textures via URLs. Use instead of `Texture.from` because
   * it does a better job of handling failed URLs more effectively. This also ignores
   * `PIXI.settings.STRICT_TEXTURE_CACHE`. Works for Videos, SVGs, Images.
   * @param url - The remote URL or array of URLs to load.
   * @param options - Optional options to include
   * @returns - A Promise that resolves to a Texture.
   */
  static fromURL(t, e) {
    const r = Object.assign({ autoLoad: !1 }, e?.resourceOptions), i = ct.from(t, Object.assign({ resourceOptions: r }, e), !1), s = i.baseTexture.resource;
    return i.baseTexture.valid ? Promise.resolve(i) : s.load().then(() => Promise.resolve(i));
  }
  /**
   * Create a new Texture with a BufferResource from a typed array.
   * @param buffer - The optional array to use. If no data is provided, a new Float32Array is created.
   * @param width - Width of the resource
   * @param height - Height of the resource
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   *        Default properties are different from the constructor's defaults.
   * @param {PIXI.FORMATS} [options.format] - The format is not given, the type is inferred from the
   *        type of the buffer: `RGBA` if Float32Array, Int8Array, Uint8Array, or Uint8ClampedArray,
   *        otherwise `RGBA_INTEGER`.
   * @param {PIXI.TYPES} [options.type] - The type is not given, the type is inferred from the
   *        type of the buffer. Maps Float32Array to `FLOAT`, Int32Array to `INT`, Uint32Array to
   *        `UNSIGNED_INT`, Int16Array to `SHORT`, Uint16Array to `UNSIGNED_SHORT`, Int8Array to `BYTE`,
   *        Uint8Array/Uint8ClampedArray to `UNSIGNED_BYTE`.
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.NPM]
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.SCALE_MODES.NEAREST]
   * @returns - The resulting new BaseTexture
   */
  static fromBuffer(t, e, r, i) {
    return new ct(_t.fromBuffer(t, e, r, i));
  }
  /**
   * Create a texture from a source and add to the cache.
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas|string} source - The input source.
   * @param imageUrl - File name of texture, for cache and resolving resolution.
   * @param name - Human readable name for the texture cache. If no name is
   *        specified, only `imageUrl` will be used as the cache ID.
   * @param options
   * @returns - Output texture
   */
  static fromLoader(t, e, r, i) {
    const s = new _t(t, Object.assign({
      scaleMode: _t.defaultOptions.scaleMode,
      resolution: sn(e)
    }, i)), { resource: o } = s;
    o instanceof a0 && (o.url = e);
    const a = new ct(s);
    return r || (r = e), _t.addToCache(a.baseTexture, r), ct.addToCache(a, r), r !== e && (_t.addToCache(a.baseTexture, e), ct.addToCache(a, e)), a.baseTexture.valid ? Promise.resolve(a) : new Promise((h) => {
      a.baseTexture.once("loaded", () => h(a));
    });
  }
  /**
   * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
   * @param texture - The Texture to add to the cache.
   * @param id - The id that the Texture will be stored against.
   */
  static addToCache(t, e) {
    e && (t.textureCacheIds.includes(e) || t.textureCacheIds.push(e), Ar[e] && Ar[e] !== t && console.warn(`Texture added to the cache with an id [${e}] that already had an entry`), Ar[e] = t);
  }
  /**
   * Remove a Texture from the global TextureCache.
   * @param texture - id of a Texture to be removed, or a Texture instance itself
   * @returns - The Texture that was removed
   */
  static removeFromCache(t) {
    if (typeof t == "string") {
      const e = Ar[t];
      if (e) {
        const r = e.textureCacheIds.indexOf(t);
        return r > -1 && e.textureCacheIds.splice(r, 1), delete Ar[t], e;
      }
    } else if (t?.textureCacheIds) {
      for (let e = 0; e < t.textureCacheIds.length; ++e)
        Ar[t.textureCacheIds[e]] === t && delete Ar[t.textureCacheIds[e]];
      return t.textureCacheIds.length = 0, t;
    }
    return null;
  }
  /**
   * Returns resolution of baseTexture
   * @readonly
   */
  get resolution() {
    return this.baseTexture.resolution;
  }
  /**
   * The frame specifies the region of the base texture that this texture uses.
   * Please call `updateUvs()` after you change coordinates of `frame` manually.
   */
  get frame() {
    return this._frame;
  }
  set frame(t) {
    this._frame = t, this.noFrame = !1;
    const { x: e, y: r, width: i, height: s } = t, o = e + i > this.baseTexture.width, a = r + s > this.baseTexture.height;
    if (o || a) {
      const h = o && a ? "and" : "or", l = `X: ${e} + ${i} = ${e + i} > ${this.baseTexture.width}`, u = `Y: ${r} + ${s} = ${r + s} > ${this.baseTexture.height}`;
      throw new Error(`Texture Error: frame does not fit inside the base Texture dimensions: ${l} ${h} ${u}`);
    }
    this.valid = i && s && this.baseTexture.valid, !this.trim && !this.rotate && (this.orig = t), this.valid && this.updateUvs();
  }
  /**
   * Indicates whether the texture is rotated inside the atlas
   * set to 2 to compensate for texture packer rotation
   * set to 6 to compensate for spine packer rotation
   * can be used to rotate or mirror sprites
   * See {@link PIXI.groupD8} for explanation
   */
  get rotate() {
    return this._rotate;
  }
  set rotate(t) {
    this._rotate = t, this.valid && this.updateUvs();
  }
  /** The width of the Texture in pixels. */
  get width() {
    return this.orig.width;
  }
  /** The height of the Texture in pixels. */
  get height() {
    return this.orig.height;
  }
  /** Utility function for BaseTexture|Texture cast. */
  castToBaseTexture() {
    return this.baseTexture;
  }
  /** An empty texture, used often to not have to create multiple empty textures. Can not be destroyed. */
  static get EMPTY() {
    return ct._EMPTY || (ct._EMPTY = new ct(new _t()), ia(ct._EMPTY), ia(ct._EMPTY.baseTexture)), ct._EMPTY;
  }
  /** A white texture of 16x16 size, used for graphics and other things Can not be destroyed. */
  static get WHITE() {
    if (!ct._WHITE) {
      const t = ht.ADAPTER.createCanvas(16, 16), e = t.getContext("2d");
      t.width = 16, t.height = 16, e.fillStyle = "white", e.fillRect(0, 0, 16, 16), ct._WHITE = new ct(_t.from(t)), ia(ct._WHITE), ia(ct._WHITE.baseTexture);
    }
    return ct._WHITE;
  }
}
class Di extends ct {
  /**
   * @param baseRenderTexture - The base texture object that this texture uses.
   * @param frame - The rectangle frame of the texture to show.
   */
  constructor(t, e) {
    super(t, e), this.valid = !0, this.filterFrame = null, this.filterPoolKey = null, this.updateUvs();
  }
  /**
   * Shortcut to `this.baseTexture.framebuffer`, saves baseTexture cast.
   * @readonly
   */
  get framebuffer() {
    return this.baseTexture.framebuffer;
  }
  /**
   * Shortcut to `this.framebuffer.multisample`.
   * @default PIXI.MSAA_QUALITY.NONE
   */
  get multisample() {
    return this.framebuffer.multisample;
  }
  set multisample(t) {
    this.framebuffer.multisample = t;
  }
  /**
   * Resizes the RenderTexture.
   * @param desiredWidth - The desired width to resize to.
   * @param desiredHeight - The desired height to resize to.
   * @param resizeBaseTexture - Should the baseTexture.width and height values be resized as well?
   */
  resize(t, e, r = !0) {
    const i = this.baseTexture.resolution, s = Math.round(t * i) / i, o = Math.round(e * i) / i;
    this.valid = s > 0 && o > 0, this._frame.width = this.orig.width = s, this._frame.height = this.orig.height = o, r && this.baseTexture.resize(s, o), this.updateUvs();
  }
  /**
   * Changes the resolution of baseTexture, but does not change framebuffer size.
   * @param resolution - The new resolution to apply to RenderTexture
   */
  setResolution(t) {
    const { baseTexture: e } = this;
    e.resolution !== t && (e.setResolution(t), this.resize(e.width, e.height, !1));
  }
  /**
   * A short hand way of creating a render texture.
   * @param options - Options
   * @param {number} [options.width=100] - The width of the render texture
   * @param {number} [options.height=100] - The height of the render texture
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.BaseTexture.defaultOptions.scaleMode] - See {@link PIXI.SCALE_MODES}
   *    for possible values
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the texture
   *    being generated
   * @param {PIXI.MSAA_QUALITY} [options.multisample=PIXI.MSAA_QUALITY.NONE] - The number of samples of the frame buffer
   * @returns The new render texture
   */
  static create(t) {
    return new Di(new o0(t));
  }
}
class h0 {
  /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {PIXI.SCALE_MODES} [textureOptions.scaleMode] - See {@link PIXI.SCALE_MODES} for possible values.
   */
  constructor(t) {
    this.texturePool = {}, this.textureOptions = t || {}, this.enableFullScreen = !1, this._pixelsWidth = 0, this._pixelsHeight = 0;
  }
  /**
   * Creates texture with params that were specified in pool constructor.
   * @param realWidth - Width of texture in pixels.
   * @param realHeight - Height of texture in pixels.
   * @param multisample - Number of samples of the framebuffer.
   */
  createTexture(t, e, r = Zt.NONE) {
    const i = new o0(Object.assign({
      width: t,
      height: e,
      resolution: 1,
      multisample: r
    }, this.textureOptions));
    return new Di(i);
  }
  /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param multisample - Number of samples of the render texture.
   * @returns The new render texture.
   */
  getOptimalTexture(t, e, r = 1, i = Zt.NONE) {
    let s;
    t = Math.max(Math.ceil(t * r - 1e-6), 1), e = Math.max(Math.ceil(e * r - 1e-6), 1), !this.enableFullScreen || t !== this._pixelsWidth || e !== this._pixelsHeight ? (t = Wa(t), e = Wa(e), s = ((t & 65535) << 16 | e & 65535) >>> 0, i > 1 && (s += i * 4294967296)) : s = i > 1 ? -i : -1, this.texturePool[s] || (this.texturePool[s] = []);
    let o = this.texturePool[s].pop();
    return o || (o = this.createTexture(t, e, i)), o.filterPoolKey = s, o.setResolution(r), o;
  }
  /**
   * Gets extra texture of the same size as input renderTexture
   *
   * `getFilterTexture(input, 0.5)` or `getFilterTexture(0.5, input)`
   * @param input - renderTexture from which size and resolution will be copied
   * @param resolution - override resolution of the renderTexture
   *  It overrides, it does not multiply
   * @param multisample - number of samples of the renderTexture
   */
  getFilterTexture(t, e, r) {
    const i = this.getOptimalTexture(
      t.width,
      t.height,
      e || t.resolution,
      r || Zt.NONE
    );
    return i.filterFrame = t.filterFrame, i;
  }
  /**
   * Place a render texture back into the pool.
   * @param renderTexture - The renderTexture to free
   */
  returnTexture(t) {
    const e = t.filterPoolKey;
    t.filterFrame = null, this.texturePool[e].push(t);
  }
  /**
   * Alias for returnTexture, to be compliant with FilterSystem interface.
   * @param renderTexture - The renderTexture to free
   */
  returnFilterTexture(t) {
    this.returnTexture(t);
  }
  /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */
  clear(t) {
    if (t = t !== !1, t)
      for (const e in this.texturePool) {
        const r = this.texturePool[e];
        if (r)
          for (let i = 0; i < r.length; i++)
            r[i].destroy(!0);
      }
    this.texturePool = {};
  }
  /**
   * If screen size was changed, drops all screen-sized textures,
   * sets new screen size, sets `enableFullScreen` to true
   *
   * Size is measured in pixels, `renderer.view` can be passed here, not `renderer.screen`
   * @param size - Initial size of screen.
   */
  setScreenSize(t) {
    if (!(t.width === this._pixelsWidth && t.height === this._pixelsHeight)) {
      this.enableFullScreen = t.width > 0 && t.height > 0;
      for (const e in this.texturePool) {
        if (!(Number(e) < 0))
          continue;
        const r = this.texturePool[e];
        if (r)
          for (let i = 0; i < r.length; i++)
            r[i].destroy(!0);
        this.texturePool[e] = [];
      }
      this._pixelsWidth = t.width, this._pixelsHeight = t.height;
    }
  }
}
h0.SCREEN_KEY = -1;
class xw extends Bn {
  constructor() {
    super(), this.addAttribute("aVertexPosition", new Float32Array([
      0,
      0,
      1,
      0,
      1,
      1,
      0,
      1
    ])).addIndex([0, 1, 3, 2]);
  }
}
class l0 extends Bn {
  constructor() {
    super(), this.vertices = new Float32Array([
      -1,
      -1,
      1,
      -1,
      1,
      1,
      -1,
      1
    ]), this.uvs = new Float32Array([
      0,
      0,
      1,
      0,
      1,
      1,
      0,
      1
    ]), this.vertexBuffer = new Yt(this.vertices), this.uvBuffer = new Yt(this.uvs), this.addAttribute("aVertexPosition", this.vertexBuffer).addAttribute("aTextureCoord", this.uvBuffer).addIndex([0, 1, 2, 0, 2, 3]);
  }
  /**
   * Maps two Rectangle to the quad.
   * @param targetTextureFrame - The first rectangle
   * @param destinationFrame - The second rectangle
   * @returns - Returns itself.
   */
  map(t, e) {
    let r = 0, i = 0;
    return this.uvs[0] = r, this.uvs[1] = i, this.uvs[2] = r + e.width / t.width, this.uvs[3] = i, this.uvs[4] = r + e.width / t.width, this.uvs[5] = i + e.height / t.height, this.uvs[6] = r, this.uvs[7] = i + e.height / t.height, r = e.x, i = e.y, this.vertices[0] = r, this.vertices[1] = i, this.vertices[2] = r + e.width, this.vertices[3] = i, this.vertices[4] = r + e.width, this.vertices[5] = i + e.height, this.vertices[6] = r, this.vertices[7] = i + e.height, this.invalidate(), this;
  }
  /**
   * Legacy upload method, just marks buffers dirty.
   * @returns - Returns itself.
   */
  invalidate() {
    return this.vertexBuffer._updateID++, this.uvBuffer._updateID++, this;
  }
}
class ww {
  constructor() {
    this.renderTexture = null, this.target = null, this.legacy = !1, this.resolution = 1, this.multisample = Zt.NONE, this.sourceFrame = new yt(), this.destinationFrame = new yt(), this.bindingSourceFrame = new yt(), this.bindingDestinationFrame = new yt(), this.filters = [], this.transform = null;
  }
  /** Clears the state */
  clear() {
    this.target = null, this.filters = null, this.renderTexture = null;
  }
}
const sa = [new mt(), new mt(), new mt(), new mt()], iu = new Nt();
class u0 {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(t) {
    this.renderer = t, this.defaultFilterStack = [{}], this.texturePool = new h0(), this.statePool = [], this.quad = new xw(), this.quadUv = new l0(), this.tempRect = new yt(), this.activeState = {}, this.globalUniforms = new mr({
      outputFrame: new yt(),
      inputSize: new Float32Array(4),
      inputPixel: new Float32Array(4),
      inputClamp: new Float32Array(4),
      resolution: 1,
      // legacy variables
      filterArea: new Float32Array(4),
      filterClamp: new Float32Array(4)
    }, !0), this.forceClear = !1, this.useMaxPadding = !1;
  }
  init() {
    this.texturePool.setScreenSize(this.renderer.view);
  }
  /**
   * Pushes a set of filters to be applied later to the system. This will redirect further rendering into an
   * input render-texture for the rest of the filtering pipeline.
   * @param {PIXI.DisplayObject} target - The target of the filter to render.
   * @param filters - The filters to apply.
   */
  push(t, e) {
    const r = this.renderer, i = this.defaultFilterStack, s = this.statePool.pop() || new ww(), o = r.renderTexture;
    let a, h;
    if (o.current) {
      const g = o.current;
      a = g.resolution, h = g.multisample;
    } else
      a = r.resolution, h = r.multisample;
    let l = e[0].resolution || a, u = e[0].multisample ?? h, c = e[0].padding, d = e[0].autoFit, f = e[0].legacy ?? !0;
    for (let g = 1; g < e.length; g++) {
      const _ = e[g];
      l = Math.min(l, _.resolution || a), u = Math.min(u, _.multisample ?? h), c = this.useMaxPadding ? Math.max(c, _.padding) : c + _.padding, d = d && _.autoFit, f = f || (_.legacy ?? !0);
    }
    i.length === 1 && (this.defaultFilterStack[0].renderTexture = o.current), i.push(s), s.resolution = l, s.multisample = u, s.legacy = f, s.target = t, s.sourceFrame.copyFrom(t.filterArea || t.getBounds(!0)), s.sourceFrame.pad(c);
    const p = this.tempRect.copyFrom(o.sourceFrame);
    r.projection.transform && this.transformAABB(
      iu.copyFrom(r.projection.transform).invert(),
      p
    ), d ? (s.sourceFrame.fit(p), (s.sourceFrame.width <= 0 || s.sourceFrame.height <= 0) && (s.sourceFrame.width = 0, s.sourceFrame.height = 0)) : s.sourceFrame.intersects(p) || (s.sourceFrame.width = 0, s.sourceFrame.height = 0), this.roundFrame(
      s.sourceFrame,
      o.current ? o.current.resolution : r.resolution,
      o.sourceFrame,
      o.destinationFrame,
      r.projection.transform
    ), s.renderTexture = this.getOptimalFilterTexture(
      s.sourceFrame.width,
      s.sourceFrame.height,
      l,
      u
    ), s.filters = e, s.destinationFrame.width = s.renderTexture.width, s.destinationFrame.height = s.renderTexture.height;
    const m = this.tempRect;
    m.x = 0, m.y = 0, m.width = s.sourceFrame.width, m.height = s.sourceFrame.height, s.renderTexture.filterFrame = s.sourceFrame, s.bindingSourceFrame.copyFrom(o.sourceFrame), s.bindingDestinationFrame.copyFrom(o.destinationFrame), s.transform = r.projection.transform, r.projection.transform = null, o.bind(s.renderTexture, s.sourceFrame, m), r.framebuffer.clear(0, 0, 0, 0);
  }
  /** Pops off the filter and applies it. */
  pop() {
    const t = this.defaultFilterStack, e = t.pop(), r = e.filters;
    this.activeState = e;
    const i = this.globalUniforms.uniforms;
    i.outputFrame = e.sourceFrame, i.resolution = e.resolution;
    const s = i.inputSize, o = i.inputPixel, a = i.inputClamp;
    if (s[0] = e.destinationFrame.width, s[1] = e.destinationFrame.height, s[2] = 1 / s[0], s[3] = 1 / s[1], o[0] = Math.round(s[0] * e.resolution), o[1] = Math.round(s[1] * e.resolution), o[2] = 1 / o[0], o[3] = 1 / o[1], a[0] = 0.5 * o[2], a[1] = 0.5 * o[3], a[2] = e.sourceFrame.width * s[2] - 0.5 * o[2], a[3] = e.sourceFrame.height * s[3] - 0.5 * o[3], e.legacy) {
      const l = i.filterArea;
      l[0] = e.destinationFrame.width, l[1] = e.destinationFrame.height, l[2] = e.sourceFrame.x, l[3] = e.sourceFrame.y, i.filterClamp = i.inputClamp;
    }
    this.globalUniforms.update();
    const h = t[t.length - 1];
    if (this.renderer.framebuffer.blit(), r.length === 1)
      r[0].apply(this, e.renderTexture, h.renderTexture, Mr.BLEND, e), this.returnFilterTexture(e.renderTexture);
    else {
      let l = e.renderTexture, u = this.getOptimalFilterTexture(
        l.width,
        l.height,
        e.resolution
      );
      u.filterFrame = l.filterFrame;
      let c = 0;
      for (c = 0; c < r.length - 1; ++c) {
        c === 1 && e.multisample > 1 && (u = this.getOptimalFilterTexture(
          l.width,
          l.height,
          e.resolution
        ), u.filterFrame = l.filterFrame), r[c].apply(this, l, u, Mr.CLEAR, e);
        const d = l;
        l = u, u = d;
      }
      r[c].apply(this, l, h.renderTexture, Mr.BLEND, e), c > 1 && e.multisample > 1 && this.returnFilterTexture(e.renderTexture), this.returnFilterTexture(l), this.returnFilterTexture(u);
    }
    e.clear(), this.statePool.push(e);
  }
  /**
   * Binds a renderTexture with corresponding `filterFrame`, clears it if mode corresponds.
   * @param filterTexture - renderTexture to bind, should belong to filter pool or filter stack
   * @param clearMode - clearMode, by default its CLEAR/YES. See {@link PIXI.CLEAR_MODES}
   */
  bindAndClear(t, e = Mr.CLEAR) {
    const {
      renderTexture: r,
      state: i
    } = this.renderer;
    if (t === this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture ? this.renderer.projection.transform = this.activeState.transform : this.renderer.projection.transform = null, t?.filterFrame) {
      const o = this.tempRect;
      o.x = 0, o.y = 0, o.width = t.filterFrame.width, o.height = t.filterFrame.height, r.bind(t, t.filterFrame, o);
    } else
      t !== this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture ? r.bind(t) : this.renderer.renderTexture.bind(
        t,
        this.activeState.bindingSourceFrame,
        this.activeState.bindingDestinationFrame
      );
    const s = i.stateId & 1 || this.forceClear;
    (e === Mr.CLEAR || e === Mr.BLIT && s) && this.renderer.framebuffer.clear(0, 0, 0, 0);
  }
  /**
   * Draws a filter using the default rendering process.
   *
   * This should be called only by {@link PIXI.Filter#apply}.
   * @param filter - The filter to draw.
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */
  applyFilter(t, e, r, i) {
    const s = this.renderer;
    s.state.set(t.state), this.bindAndClear(r, i), t.uniforms.uSampler = e, t.uniforms.filterGlobals = this.globalUniforms, s.shader.bind(t), t.legacy = !!t.program.attributeData.aTextureCoord, t.legacy ? (this.quadUv.map(e._frame, e.filterFrame), s.geometry.bind(this.quadUv), s.geometry.draw(Pr.TRIANGLES)) : (s.geometry.bind(this.quad), s.geometry.draw(Pr.TRIANGLE_STRIP));
  }
  /**
   * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
   *
   * Use `outputMatrix * vTextureCoord` in the shader.
   * @param outputMatrix - The matrix to output to.
   * @param {PIXI.Sprite} sprite - The sprite to map to.
   * @returns The mapped matrix.
   */
  calculateSpriteMatrix(t, e) {
    const { sourceFrame: r, destinationFrame: i } = this.activeState, { orig: s } = e._texture, o = t.set(
      i.width,
      0,
      0,
      i.height,
      r.x,
      r.y
    ), a = e.worldTransform.copyTo(Nt.TEMP_MATRIX);
    return a.invert(), o.prepend(a), o.scale(1 / s.width, 1 / s.height), o.translate(e.anchor.x, e.anchor.y), o;
  }
  /** Destroys this Filter System. */
  destroy() {
    this.renderer = null, this.texturePool.clear(!1);
  }
  /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture in real pixels.
   * @param minHeight - The minimum height of the render texture in real pixels.
   * @param resolution - The resolution of the render texture.
   * @param multisample - Number of samples of the render texture.
   * @returns - The new render texture.
   */
  getOptimalFilterTexture(t, e, r = 1, i = Zt.NONE) {
    return this.texturePool.getOptimalTexture(t, e, r, i);
  }
  /**
   * Gets extra render texture to use inside current filter
   * To be compliant with older filters, you can use params in any order
   * @param input - renderTexture from which size and resolution will be copied
   * @param resolution - override resolution of the renderTexture
   * @param multisample - number of samples of the renderTexture
   */
  getFilterTexture(t, e, r) {
    if (typeof t == "number") {
      const s = t;
      t = e, e = s;
    }
    t = t || this.activeState.renderTexture;
    const i = this.texturePool.getOptimalTexture(
      t.width,
      t.height,
      e || t.resolution,
      r || Zt.NONE
    );
    return i.filterFrame = t.filterFrame, i;
  }
  /**
   * Frees a render texture back into the pool.
   * @param renderTexture - The renderTarget to free
   */
  returnFilterTexture(t) {
    this.texturePool.returnTexture(t);
  }
  /** Empties the texture pool. */
  emptyPool() {
    this.texturePool.clear(!0);
  }
  /** Calls `texturePool.resize()`, affects fullScreen renderTextures. */
  resize() {
    this.texturePool.setScreenSize(this.renderer.view);
  }
  /**
   * @param matrix - first param
   * @param rect - second param
   */
  transformAABB(t, e) {
    const r = sa[0], i = sa[1], s = sa[2], o = sa[3];
    r.set(e.left, e.top), i.set(e.left, e.bottom), s.set(e.right, e.top), o.set(e.right, e.bottom), t.apply(r, r), t.apply(i, i), t.apply(s, s), t.apply(o, o);
    const a = Math.min(r.x, i.x, s.x, o.x), h = Math.min(r.y, i.y, s.y, o.y), l = Math.max(r.x, i.x, s.x, o.x), u = Math.max(r.y, i.y, s.y, o.y);
    e.x = a, e.y = h, e.width = l - a, e.height = u - h;
  }
  roundFrame(t, e, r, i, s) {
    if (!(t.width <= 0 || t.height <= 0 || r.width <= 0 || r.height <= 0)) {
      if (s) {
        const { a: o, b: a, c: h, d: l } = s;
        if ((Math.abs(a) > 1e-4 || Math.abs(h) > 1e-4) && (Math.abs(o) > 1e-4 || Math.abs(l) > 1e-4))
          return;
      }
      s = s ? iu.copyFrom(s) : iu.identity(), s.translate(-r.x, -r.y).scale(
        i.width / r.width,
        i.height / r.height
      ).translate(i.x, i.y), this.transformAABB(s, t), t.ceil(e), this.transformAABB(s.invert(), t);
    }
  }
}
u0.extension = {
  type: st.RendererSystem,
  name: "filter"
};
dt.add(u0);
class bw {
  constructor(t) {
    this.framebuffer = t, this.stencil = null, this.dirtyId = -1, this.dirtyFormat = -1, this.dirtySize = -1, this.multisample = Zt.NONE, this.msaaBuffer = null, this.blitFramebuffer = null, this.mipLevel = 0;
  }
}
const Tw = new yt();
class c0 {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(t) {
    this.renderer = t, this.managedFramebuffers = [], this.unknownFramebuffer = new ec(10, 10), this.msaaSamples = null;
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    this.disposeAll(!0);
    const t = this.gl = this.renderer.gl;
    if (this.CONTEXT_UID = this.renderer.CONTEXT_UID, this.current = this.unknownFramebuffer, this.viewport = new yt(), this.hasMRT = !0, this.writeDepthTexture = !0, this.renderer.context.webGLVersion === 1) {
      let e = this.renderer.context.extensions.drawBuffers, r = this.renderer.context.extensions.depthTexture;
      ht.PREFER_ENV === Ri.WEBGL_LEGACY && (e = null, r = null), e ? t.drawBuffers = (i) => e.drawBuffersWEBGL(i) : (this.hasMRT = !1, t.drawBuffers = () => {
      }), r || (this.writeDepthTexture = !1);
    } else
      this.msaaSamples = t.getInternalformatParameter(t.RENDERBUFFER, t.RGBA8, t.SAMPLES);
  }
  /**
   * Bind a framebuffer.
   * @param framebuffer
   * @param frame - frame, default is framebuffer size
   * @param mipLevel - optional mip level to set on the framebuffer - defaults to 0
   */
  bind(t, e, r = 0) {
    const { gl: i } = this;
    if (t) {
      const s = t.glFramebuffers[this.CONTEXT_UID] || this.initFramebuffer(t);
      this.current !== t && (this.current = t, i.bindFramebuffer(i.FRAMEBUFFER, s.framebuffer)), s.mipLevel !== r && (t.dirtyId++, t.dirtyFormat++, s.mipLevel = r), s.dirtyId !== t.dirtyId && (s.dirtyId = t.dirtyId, s.dirtyFormat !== t.dirtyFormat ? (s.dirtyFormat = t.dirtyFormat, s.dirtySize = t.dirtySize, this.updateFramebuffer(t, r)) : s.dirtySize !== t.dirtySize && (s.dirtySize = t.dirtySize, this.resizeFramebuffer(t)));
      for (let o = 0; o < t.colorTextures.length; o++) {
        const a = t.colorTextures[o];
        this.renderer.texture.unbind(a.parentTextureArray || a);
      }
      if (t.depthTexture && this.renderer.texture.unbind(t.depthTexture), e) {
        const o = e.width >> r, a = e.height >> r, h = o / e.width;
        this.setViewport(
          e.x * h,
          e.y * h,
          o,
          a
        );
      } else {
        const o = t.width >> r, a = t.height >> r;
        this.setViewport(0, 0, o, a);
      }
    } else
      this.current && (this.current = null, i.bindFramebuffer(i.FRAMEBUFFER, null)), e ? this.setViewport(e.x, e.y, e.width, e.height) : this.setViewport(0, 0, this.renderer.width, this.renderer.height);
  }
  /**
   * Set the WebGLRenderingContext's viewport.
   * @param x - X position of viewport
   * @param y - Y position of viewport
   * @param width - Width of viewport
   * @param height - Height of viewport
   */
  setViewport(t, e, r, i) {
    const s = this.viewport;
    t = Math.round(t), e = Math.round(e), r = Math.round(r), i = Math.round(i), (s.width !== r || s.height !== i || s.x !== t || s.y !== e) && (s.x = t, s.y = e, s.width = r, s.height = i, this.gl.viewport(t, e, r, i));
  }
  /**
   * Get the size of the current width and height. Returns object with `width` and `height` values.
   * @readonly
   */
  get size() {
    return this.current ? { x: 0, y: 0, width: this.current.width, height: this.current.height } : { x: 0, y: 0, width: this.renderer.width, height: this.renderer.height };
  }
  /**
   * Clear the color of the context
   * @param r - Red value from 0 to 1
   * @param g - Green value from 0 to 1
   * @param b - Blue value from 0 to 1
   * @param a - Alpha value from 0 to 1
   * @param {PIXI.BUFFER_BITS} [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
   *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
   */
  clear(t, e, r, i, s = Hu.COLOR | Hu.DEPTH) {
    const { gl: o } = this;
    o.clearColor(t, e, r, i), o.clear(s);
  }
  /**
   * Initialize framebuffer for this context
   * @protected
   * @param framebuffer
   * @returns - created GLFramebuffer
   */
  initFramebuffer(t) {
    const { gl: e } = this, r = new bw(e.createFramebuffer());
    return r.multisample = this.detectSamples(t.multisample), t.glFramebuffers[this.CONTEXT_UID] = r, this.managedFramebuffers.push(t), t.disposeRunner.add(this), r;
  }
  /**
   * Resize the framebuffer
   * @param framebuffer
   * @protected
   */
  resizeFramebuffer(t) {
    const { gl: e } = this, r = t.glFramebuffers[this.CONTEXT_UID];
    if (r.stencil) {
      e.bindRenderbuffer(e.RENDERBUFFER, r.stencil);
      let o;
      this.renderer.context.webGLVersion === 1 ? o = e.DEPTH_STENCIL : t.depth && t.stencil ? o = e.DEPTH24_STENCIL8 : t.depth ? o = e.DEPTH_COMPONENT24 : o = e.STENCIL_INDEX8, r.msaaBuffer ? e.renderbufferStorageMultisample(
        e.RENDERBUFFER,
        r.multisample,
        o,
        t.width,
        t.height
      ) : e.renderbufferStorage(e.RENDERBUFFER, o, t.width, t.height);
    }
    const i = t.colorTextures;
    let s = i.length;
    e.drawBuffers || (s = Math.min(s, 1));
    for (let o = 0; o < s; o++) {
      const a = i[o], h = a.parentTextureArray || a;
      this.renderer.texture.bind(h, 0), o === 0 && r.msaaBuffer && (e.bindRenderbuffer(e.RENDERBUFFER, r.msaaBuffer), e.renderbufferStorageMultisample(
        e.RENDERBUFFER,
        r.multisample,
        h._glTextures[this.CONTEXT_UID].internalFormat,
        t.width,
        t.height
      ));
    }
    t.depthTexture && this.writeDepthTexture && this.renderer.texture.bind(t.depthTexture, 0);
  }
  /**
   * Update the framebuffer
   * @param framebuffer
   * @param mipLevel
   * @protected
   */
  updateFramebuffer(t, e) {
    const { gl: r } = this, i = t.glFramebuffers[this.CONTEXT_UID], s = t.colorTextures;
    let o = s.length;
    r.drawBuffers || (o = Math.min(o, 1)), i.multisample > 1 && this.canMultisampleFramebuffer(t) ? i.msaaBuffer = i.msaaBuffer || r.createRenderbuffer() : i.msaaBuffer && (r.deleteRenderbuffer(i.msaaBuffer), i.msaaBuffer = null, i.blitFramebuffer && (i.blitFramebuffer.dispose(), i.blitFramebuffer = null));
    const a = [];
    for (let h = 0; h < o; h++) {
      const l = s[h], u = l.parentTextureArray || l;
      this.renderer.texture.bind(u, 0), h === 0 && i.msaaBuffer ? (r.bindRenderbuffer(r.RENDERBUFFER, i.msaaBuffer), r.renderbufferStorageMultisample(
        r.RENDERBUFFER,
        i.multisample,
        u._glTextures[this.CONTEXT_UID].internalFormat,
        t.width,
        t.height
      ), r.framebufferRenderbuffer(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0, r.RENDERBUFFER, i.msaaBuffer)) : (r.framebufferTexture2D(
        r.FRAMEBUFFER,
        r.COLOR_ATTACHMENT0 + h,
        l.target,
        u._glTextures[this.CONTEXT_UID].texture,
        e
      ), a.push(r.COLOR_ATTACHMENT0 + h));
    }
    if (a.length > 1 && r.drawBuffers(a), t.depthTexture && this.writeDepthTexture) {
      const h = t.depthTexture;
      this.renderer.texture.bind(h, 0), r.framebufferTexture2D(
        r.FRAMEBUFFER,
        r.DEPTH_ATTACHMENT,
        r.TEXTURE_2D,
        h._glTextures[this.CONTEXT_UID].texture,
        e
      );
    }
    if ((t.stencil || t.depth) && !(t.depthTexture && this.writeDepthTexture)) {
      i.stencil = i.stencil || r.createRenderbuffer();
      let h, l;
      this.renderer.context.webGLVersion === 1 ? (h = r.DEPTH_STENCIL_ATTACHMENT, l = r.DEPTH_STENCIL) : t.depth && t.stencil ? (h = r.DEPTH_STENCIL_ATTACHMENT, l = r.DEPTH24_STENCIL8) : t.depth ? (h = r.DEPTH_ATTACHMENT, l = r.DEPTH_COMPONENT24) : (h = r.STENCIL_ATTACHMENT, l = r.STENCIL_INDEX8), r.bindRenderbuffer(r.RENDERBUFFER, i.stencil), i.msaaBuffer ? r.renderbufferStorageMultisample(
        r.RENDERBUFFER,
        i.multisample,
        l,
        t.width,
        t.height
      ) : r.renderbufferStorage(r.RENDERBUFFER, l, t.width, t.height), r.framebufferRenderbuffer(r.FRAMEBUFFER, h, r.RENDERBUFFER, i.stencil);
    } else
      i.stencil && (r.deleteRenderbuffer(i.stencil), i.stencil = null);
  }
  /**
   * Returns true if the frame buffer can be multisampled.
   * @param framebuffer
   */
  canMultisampleFramebuffer(t) {
    return this.renderer.context.webGLVersion !== 1 && t.colorTextures.length <= 1 && !t.depthTexture;
  }
  /**
   * Detects number of samples that is not more than a param but as close to it as possible
   * @param samples - number of samples
   * @returns - recommended number of samples
   */
  detectSamples(t) {
    const { msaaSamples: e } = this;
    let r = Zt.NONE;
    if (t <= 1 || e === null)
      return r;
    for (let i = 0; i < e.length; i++)
      if (e[i] <= t) {
        r = e[i];
        break;
      }
    return r === 1 && (r = Zt.NONE), r;
  }
  /**
   * Only works with WebGL2
   *
   * blits framebuffer to another of the same or bigger size
   * after that target framebuffer is bound
   *
   * Fails with WebGL warning if blits multisample framebuffer to different size
   * @param framebuffer - by default it blits "into itself", from renderBuffer to texture.
   * @param sourcePixels - source rectangle in pixels
   * @param destPixels - dest rectangle in pixels, assumed to be the same as sourcePixels
   */
  blit(t, e, r) {
    const { current: i, renderer: s, gl: o, CONTEXT_UID: a } = this;
    if (s.context.webGLVersion !== 2 || !i)
      return;
    const h = i.glFramebuffers[a];
    if (!h)
      return;
    if (!t) {
      if (!h.msaaBuffer)
        return;
      const u = i.colorTextures[0];
      if (!u)
        return;
      h.blitFramebuffer || (h.blitFramebuffer = new ec(i.width, i.height), h.blitFramebuffer.addColorTexture(0, u)), t = h.blitFramebuffer, t.colorTextures[0] !== u && (t.colorTextures[0] = u, t.dirtyId++, t.dirtyFormat++), (t.width !== i.width || t.height !== i.height) && (t.width = i.width, t.height = i.height, t.dirtyId++, t.dirtySize++);
    }
    e || (e = Tw, e.width = i.width, e.height = i.height), r || (r = e);
    const l = e.width === r.width && e.height === r.height;
    this.bind(t), o.bindFramebuffer(o.READ_FRAMEBUFFER, h.framebuffer), o.blitFramebuffer(
      e.left,
      e.top,
      e.right,
      e.bottom,
      r.left,
      r.top,
      r.right,
      r.bottom,
      o.COLOR_BUFFER_BIT,
      l ? o.NEAREST : o.LINEAR
    ), o.bindFramebuffer(o.READ_FRAMEBUFFER, t.glFramebuffers[this.CONTEXT_UID].framebuffer);
  }
  /**
   * Disposes framebuffer.
   * @param framebuffer - framebuffer that has to be disposed of
   * @param contextLost - If context was lost, we suppress all delete function calls
   */
  disposeFramebuffer(t, e) {
    const r = t.glFramebuffers[this.CONTEXT_UID], i = this.gl;
    if (!r)
      return;
    delete t.glFramebuffers[this.CONTEXT_UID];
    const s = this.managedFramebuffers.indexOf(t);
    s >= 0 && this.managedFramebuffers.splice(s, 1), t.disposeRunner.remove(this), e || (i.deleteFramebuffer(r.framebuffer), r.msaaBuffer && i.deleteRenderbuffer(r.msaaBuffer), r.stencil && i.deleteRenderbuffer(r.stencil)), r.blitFramebuffer && this.disposeFramebuffer(r.blitFramebuffer, e);
  }
  /**
   * Disposes all framebuffers, but not textures bound to them.
   * @param [contextLost=false] - If context was lost, we suppress all delete function calls
   */
  disposeAll(t) {
    const e = this.managedFramebuffers;
    this.managedFramebuffers = [];
    for (let r = 0; r < e.length; r++)
      this.disposeFramebuffer(e[r], t);
  }
  /**
   * Forcing creation of stencil buffer for current framebuffer, if it wasn't done before.
   * Used by MaskSystem, when its time to use stencil mask for Graphics element.
   *
   * Its an alternative for public lazy `framebuffer.enableStencil`, in case we need stencil without rebind.
   * @private
   */
  forceStencil() {
    const t = this.current;
    if (!t)
      return;
    const e = t.glFramebuffers[this.CONTEXT_UID];
    if (!e || e.stencil && t.stencil)
      return;
    t.stencil = !0;
    const r = t.width, i = t.height, s = this.gl, o = e.stencil = s.createRenderbuffer();
    s.bindRenderbuffer(s.RENDERBUFFER, o);
    let a, h;
    this.renderer.context.webGLVersion === 1 ? (a = s.DEPTH_STENCIL_ATTACHMENT, h = s.DEPTH_STENCIL) : t.depth ? (a = s.DEPTH_STENCIL_ATTACHMENT, h = s.DEPTH24_STENCIL8) : (a = s.STENCIL_ATTACHMENT, h = s.STENCIL_INDEX8), e.msaaBuffer ? s.renderbufferStorageMultisample(s.RENDERBUFFER, e.multisample, h, r, i) : s.renderbufferStorage(s.RENDERBUFFER, h, r, i), s.framebufferRenderbuffer(s.FRAMEBUFFER, a, s.RENDERBUFFER, o);
  }
  /** Resets framebuffer stored state, binds screen framebuffer. Should be called before renderTexture reset(). */
  reset() {
    this.current = this.unknownFramebuffer, this.viewport = new yt();
  }
  destroy() {
    this.renderer = null;
  }
}
c0.extension = {
  type: st.RendererSystem,
  name: "framebuffer"
};
dt.add(c0);
const su = { 5126: 4, 5123: 2, 5121: 1 };
class d0 {
  /** @param renderer - The renderer this System works for. */
  constructor(t) {
    this.renderer = t, this._activeGeometry = null, this._activeVao = null, this.hasVao = !0, this.hasInstance = !0, this.canUseUInt32ElementIndex = !1, this.managedGeometries = {};
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    this.disposeAll(!0);
    const t = this.gl = this.renderer.gl, e = this.renderer.context;
    if (this.CONTEXT_UID = this.renderer.CONTEXT_UID, e.webGLVersion !== 2) {
      let r = this.renderer.context.extensions.vertexArrayObject;
      ht.PREFER_ENV === Ri.WEBGL_LEGACY && (r = null), r ? (t.createVertexArray = () => r.createVertexArrayOES(), t.bindVertexArray = (i) => r.bindVertexArrayOES(i), t.deleteVertexArray = (i) => r.deleteVertexArrayOES(i)) : (this.hasVao = !1, t.createVertexArray = () => null, t.bindVertexArray = () => null, t.deleteVertexArray = () => null);
    }
    if (e.webGLVersion !== 2) {
      const r = t.getExtension("ANGLE_instanced_arrays");
      r ? (t.vertexAttribDivisor = (i, s) => r.vertexAttribDivisorANGLE(i, s), t.drawElementsInstanced = (i, s, o, a, h) => r.drawElementsInstancedANGLE(i, s, o, a, h), t.drawArraysInstanced = (i, s, o, a) => r.drawArraysInstancedANGLE(i, s, o, a)) : this.hasInstance = !1;
    }
    this.canUseUInt32ElementIndex = e.webGLVersion === 2 || !!e.extensions.uint32ElementIndex;
  }
  /**
   * Binds geometry so that is can be drawn. Creating a Vao if required
   * @param geometry - Instance of geometry to bind.
   * @param shader - Instance of shader to use vao for.
   */
  bind(t, e) {
    e = e || this.renderer.shader.shader;
    const { gl: r } = this;
    let i = t.glVertexArrayObjects[this.CONTEXT_UID], s = !1;
    i || (this.managedGeometries[t.id] = t, t.disposeRunner.add(this), t.glVertexArrayObjects[this.CONTEXT_UID] = i = {}, s = !0);
    const o = i[e.program.id] || this.initGeometryVao(t, e, s);
    this._activeGeometry = t, this._activeVao !== o && (this._activeVao = o, this.hasVao ? r.bindVertexArray(o) : this.activateVao(t, e.program)), this.updateBuffers();
  }
  /** Reset and unbind any active VAO and geometry. */
  reset() {
    this.unbind();
  }
  /** Update buffers of the currently bound geometry. */
  updateBuffers() {
    const t = this._activeGeometry, e = this.renderer.buffer;
    for (let r = 0; r < t.buffers.length; r++) {
      const i = t.buffers[r];
      e.update(i);
    }
  }
  /**
   * Check compatibility between a geometry and a program
   * @param geometry - Geometry instance.
   * @param program - Program instance.
   */
  checkCompatibility(t, e) {
    const r = t.attributes, i = e.attributeData;
    for (const s in i)
      if (!r[s])
        throw new Error(`shader and geometry incompatible, geometry missing the "${s}" attribute`);
  }
  /**
   * Takes a geometry and program and generates a unique signature for them.
   * @param geometry - To get signature from.
   * @param program - To test geometry against.
   * @returns - Unique signature of the geometry and program
   */
  getSignature(t, e) {
    const r = t.attributes, i = e.attributeData, s = ["g", t.id];
    for (const o in r)
      i[o] && s.push(o, i[o].location);
    return s.join("-");
  }
  /**
   * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
   * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
   * attribute locations.
   * @param geometry - Instance of geometry to to generate Vao for.
   * @param shader - Instance of the shader.
   * @param incRefCount - Increment refCount of all geometry buffers.
   */
  initGeometryVao(t, e, r = !0) {
    const i = this.gl, s = this.CONTEXT_UID, o = this.renderer.buffer, a = e.program;
    a.glPrograms[s] || this.renderer.shader.generateProgram(e), this.checkCompatibility(t, a);
    const h = this.getSignature(t, a), l = t.glVertexArrayObjects[this.CONTEXT_UID];
    let u = l[h];
    if (u)
      return l[a.id] = u, u;
    const c = t.buffers, d = t.attributes, f = {}, p = {};
    for (const m in c)
      f[m] = 0, p[m] = 0;
    for (const m in d)
      !d[m].size && a.attributeData[m] ? d[m].size = a.attributeData[m].size : d[m].size || console.warn(`PIXI Geometry attribute '${m}' size cannot be determined (likely the bound shader does not have the attribute)`), f[d[m].buffer] += d[m].size * su[d[m].type];
    for (const m in d) {
      const g = d[m], _ = g.size;
      g.stride === void 0 && (f[g.buffer] === _ * su[g.type] ? g.stride = 0 : g.stride = f[g.buffer]), g.start === void 0 && (g.start = p[g.buffer], p[g.buffer] += _ * su[g.type]);
    }
    u = i.createVertexArray(), i.bindVertexArray(u);
    for (let m = 0; m < c.length; m++) {
      const g = c[m];
      o.bind(g), r && g._glBuffers[s].refCount++;
    }
    return this.activateVao(t, a), l[a.id] = u, l[h] = u, i.bindVertexArray(null), o.unbind(Fr.ARRAY_BUFFER), u;
  }
  /**
   * Disposes geometry.
   * @param geometry - Geometry with buffers. Only VAO will be disposed
   * @param [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */
  disposeGeometry(t, e) {
    if (!this.managedGeometries[t.id])
      return;
    delete this.managedGeometries[t.id];
    const r = t.glVertexArrayObjects[this.CONTEXT_UID], i = this.gl, s = t.buffers, o = this.renderer?.buffer;
    if (t.disposeRunner.remove(this), !!r) {
      if (o)
        for (let a = 0; a < s.length; a++) {
          const h = s[a]._glBuffers[this.CONTEXT_UID];
          h && (h.refCount--, h.refCount === 0 && !e && o.dispose(s[a], e));
        }
      if (!e) {
        for (const a in r)
          if (a[0] === "g") {
            const h = r[a];
            this._activeVao === h && this.unbind(), i.deleteVertexArray(h);
          }
      }
      delete t.glVertexArrayObjects[this.CONTEXT_UID];
    }
  }
  /**
   * Dispose all WebGL resources of all managed geometries.
   * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */
  disposeAll(t) {
    const e = Object.keys(this.managedGeometries);
    for (let r = 0; r < e.length; r++)
      this.disposeGeometry(this.managedGeometries[e[r]], t);
  }
  /**
   * Activate vertex array object.
   * @param geometry - Geometry instance.
   * @param program - Shader program instance.
   */
  activateVao(t, e) {
    const r = this.gl, i = this.CONTEXT_UID, s = this.renderer.buffer, o = t.buffers, a = t.attributes;
    t.indexBuffer && s.bind(t.indexBuffer);
    let h = null;
    for (const l in a) {
      const u = a[l], c = o[u.buffer], d = c._glBuffers[i];
      if (e.attributeData[l]) {
        h !== d && (s.bind(c), h = d);
        const f = e.attributeData[l].location;
        if (r.enableVertexAttribArray(f), r.vertexAttribPointer(
          f,
          u.size,
          u.type || r.FLOAT,
          u.normalized,
          u.stride,
          u.start
        ), u.instance)
          if (this.hasInstance)
            r.vertexAttribDivisor(f, u.divisor);
          else
            throw new Error("geometry error, GPU Instancing is not supported on this device");
      }
    }
  }
  /**
   * Draws the currently bound geometry.
   * @param type - The type primitive to render.
   * @param size - The number of elements to be rendered. If not specified, all vertices after the
   *  starting vertex will be drawn.
   * @param start - The starting vertex in the geometry to start drawing from. If not specified,
   *  drawing will start from the first vertex.
   * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
   *  all instances will be drawn.
   */
  draw(t, e, r, i) {
    const { gl: s } = this, o = this._activeGeometry;
    if (o.indexBuffer) {
      const a = o.indexBuffer.data.BYTES_PER_ELEMENT, h = a === 2 ? s.UNSIGNED_SHORT : s.UNSIGNED_INT;
      a === 2 || a === 4 && this.canUseUInt32ElementIndex ? o.instanced ? s.drawElementsInstanced(t, e || o.indexBuffer.data.length, h, (r || 0) * a, i || 1) : s.drawElements(t, e || o.indexBuffer.data.length, h, (r || 0) * a) : console.warn("unsupported index buffer type: uint32");
    } else
      o.instanced ? s.drawArraysInstanced(t, r, e || o.getSize(), i || 1) : s.drawArrays(t, r, e || o.getSize());
    return this;
  }
  /** Unbind/reset everything. */
  unbind() {
    this.gl.bindVertexArray(null), this._activeVao = null, this._activeGeometry = null;
  }
  destroy() {
    this.renderer = null;
  }
}
d0.extension = {
  type: st.RendererSystem,
  name: "geometry"
};
dt.add(d0);
const Hp = new Nt();
class f0 {
  /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */
  constructor(t, e) {
    this._texture = t, this.mapCoord = new Nt(), this.uClampFrame = new Float32Array(4), this.uClampOffset = new Float32Array(2), this._textureID = -1, this._updateID = 0, this.clampOffset = 0, this.clampMargin = typeof e > "u" ? 0.5 : e, this.isSimple = !1;
  }
  /** Texture property. */
  get texture() {
    return this._texture;
  }
  set texture(t) {
    this._texture = t, this._textureID = -1;
  }
  /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */
  multiplyUvs(t, e) {
    e === void 0 && (e = t);
    const r = this.mapCoord;
    for (let i = 0; i < t.length; i += 2) {
      const s = t[i], o = t[i + 1];
      e[i] = s * r.a + o * r.c + r.tx, e[i + 1] = s * r.b + o * r.d + r.ty;
    }
    return e;
  }
  /**
   * Updates matrices if texture was changed.
   * @param [forceUpdate=false] - if true, matrices will be updated any case
   * @returns - Whether or not it was updated
   */
  update(t) {
    const e = this._texture;
    if (!e || !e.valid || !t && this._textureID === e._updateID)
      return !1;
    this._textureID = e._updateID, this._updateID++;
    const r = e._uvs;
    this.mapCoord.set(r.x1 - r.x0, r.y1 - r.y0, r.x3 - r.x0, r.y3 - r.y0, r.x0, r.y0);
    const i = e.orig, s = e.trim;
    s && (Hp.set(
      i.width / s.width,
      0,
      0,
      i.height / s.height,
      -s.x / s.width,
      -s.y / s.height
    ), this.mapCoord.append(Hp));
    const o = e.baseTexture, a = this.uClampFrame, h = this.clampMargin / o.resolution, l = this.clampOffset;
    return a[0] = (e._frame.x + h + l) / o.width, a[1] = (e._frame.y + h + l) / o.height, a[2] = (e._frame.x + e._frame.width - h + l) / o.width, a[3] = (e._frame.y + e._frame.height - h + l) / o.height, this.uClampOffset[0] = l / o.realWidth, this.uClampOffset[1] = l / o.realHeight, this.isSimple = e._frame.width === o.width && e._frame.height === o.height && e.rotate === 0, !0;
  }
}
var Aw = `varying vec2 vMaskCoord;
varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform sampler2D mask;
uniform float alpha;
uniform float npmAlpha;
uniform vec4 maskClamp;

void main(void)
{
    float clip = step(3.5,
        step(maskClamp.x, vMaskCoord.x) +
        step(maskClamp.y, vMaskCoord.y) +
        step(vMaskCoord.x, maskClamp.z) +
        step(vMaskCoord.y, maskClamp.w));

    vec4 original = texture2D(uSampler, vTextureCoord);
    vec4 masky = texture2D(mask, vMaskCoord);
    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);

    original *= (alphaMul * masky.r * alpha * clip);

    gl_FragColor = original;
}
`, Ew = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 otherMatrix;

varying vec2 vMaskCoord;
varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;
}
`;
class Sw extends ve {
  /** @ignore */
  constructor(t, e, r) {
    let i = null;
    typeof t != "string" && e === void 0 && r === void 0 && (i = t, t = void 0, e = void 0, r = void 0), super(t || Ew, e || Aw, r), this.maskSprite = i, this.maskMatrix = new Nt();
  }
  /**
   * Sprite mask
   * @type {PIXI.DisplayObject}
   */
  get maskSprite() {
    return this._maskSprite;
  }
  set maskSprite(t) {
    this._maskSprite = t, this._maskSprite && (this._maskSprite.renderable = !1);
  }
  /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it.
   */
  apply(t, e, r, i) {
    const s = this._maskSprite, o = s._texture;
    o.valid && (o.uvMatrix || (o.uvMatrix = new f0(o, 0)), o.uvMatrix.update(), this.uniforms.npmAlpha = o.baseTexture.alphaMode ? 0 : 1, this.uniforms.mask = o, this.uniforms.otherMatrix = t.calculateSpriteMatrix(this.maskMatrix, s).prepend(o.uvMatrix.mapCoord), this.uniforms.alpha = s.worldAlpha, this.uniforms.maskClamp = o.uvMatrix.uClampFrame, t.applyFilter(this, e, r, i));
  }
}
class Cw {
  /**
   * Create MaskData
   * @param {PIXI.DisplayObject} [maskObject=null] - object that describes the mask
   */
  constructor(t = null) {
    this.type = re.NONE, this.autoDetect = !0, this.maskObject = t || null, this.pooled = !1, this.isMaskData = !0, this.resolution = null, this.multisample = ve.defaultMultisample, this.enabled = !0, this.colorMask = 15, this._filters = null, this._stencilCounter = 0, this._scissorCounter = 0, this._scissorRect = null, this._scissorRectLocal = null, this._colorMask = 15, this._target = null;
  }
  /**
   * The sprite mask filter.
   * If set to `null`, the default sprite mask filter is used.
   * @default null
   */
  get filter() {
    return this._filters ? this._filters[0] : null;
  }
  set filter(t) {
    t ? this._filters ? this._filters[0] = t : this._filters = [t] : this._filters = null;
  }
  /** Resets the mask data after popMask(). */
  reset() {
    this.pooled && (this.maskObject = null, this.type = re.NONE, this.autoDetect = !0), this._target = null, this._scissorRectLocal = null;
  }
  /**
   * Copies counters from maskData above, called from pushMask().
   * @param maskAbove
   */
  copyCountersOrReset(t) {
    t ? (this._stencilCounter = t._stencilCounter, this._scissorCounter = t._scissorCounter, this._scissorRect = t._scissorRect) : (this._stencilCounter = 0, this._scissorCounter = 0, this._scissorRect = null);
  }
}
class p0 {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(t) {
    this.renderer = t, this.enableScissor = !0, this.alphaMaskPool = [], this.maskDataPool = [], this.maskStack = [], this.alphaMaskIndex = 0;
  }
  /**
   * Changes the mask stack that is used by this System.
   * @param maskStack - The mask stack
   */
  setMaskStack(t) {
    this.maskStack = t, this.renderer.scissor.setMaskStack(t), this.renderer.stencil.setMaskStack(t);
  }
  /**
   * Enables the mask and appends it to the current mask stack.
   *
   * NOTE: The batch renderer should be flushed beforehand to prevent pending renders from being masked.
   * @param {PIXI.DisplayObject} target - Display Object to push the mask to
   * @param {PIXI.MaskData|PIXI.Sprite|PIXI.Graphics|PIXI.DisplayObject} maskDataOrTarget - The masking data.
   */
  push(t, e) {
    let r = e;
    if (!r.isMaskData) {
      const s = this.maskDataPool.pop() || new Cw();
      s.pooled = !0, s.maskObject = e, r = s;
    }
    const i = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null;
    if (r.copyCountersOrReset(i), r._colorMask = i ? i._colorMask : 15, r.autoDetect && this.detect(r), r._target = t, r.type !== re.SPRITE && this.maskStack.push(r), r.enabled)
      switch (r.type) {
        case re.SCISSOR:
          this.renderer.scissor.push(r);
          break;
        case re.STENCIL:
          this.renderer.stencil.push(r);
          break;
        case re.SPRITE:
          r.copyCountersOrReset(null), this.pushSpriteMask(r);
          break;
        case re.COLOR:
          this.pushColorMask(r);
          break;
      }
    r.type === re.SPRITE && this.maskStack.push(r);
  }
  /**
   * Removes the last mask from the mask stack and doesn't return it.
   *
   * NOTE: The batch renderer should be flushed beforehand to render the masked contents before the mask is removed.
   * @param {PIXI.IMaskTarget} target - Display Object to pop the mask from
   */
  pop(t) {
    const e = this.maskStack.pop();
    if (!(!e || e._target !== t)) {
      if (e.enabled)
        switch (e.type) {
          case re.SCISSOR:
            this.renderer.scissor.pop(e);
            break;
          case re.STENCIL:
            this.renderer.stencil.pop(e.maskObject);
            break;
          case re.SPRITE:
            this.popSpriteMask(e);
            break;
          case re.COLOR:
            this.popColorMask(e);
            break;
        }
      if (e.reset(), e.pooled && this.maskDataPool.push(e), this.maskStack.length !== 0) {
        const r = this.maskStack[this.maskStack.length - 1];
        r.type === re.SPRITE && r._filters && (r._filters[0].maskSprite = r.maskObject);
      }
    }
  }
  /**
   * Sets type of MaskData based on its maskObject.
   * @param maskData
   */
  detect(t) {
    const e = t.maskObject;
    e ? e.isSprite ? t.type = re.SPRITE : this.enableScissor && this.renderer.scissor.testScissor(t) ? t.type = re.SCISSOR : t.type = re.STENCIL : t.type = re.COLOR;
  }
  /**
   * Applies the Mask and adds it to the current filter stack.
   * @param maskData - Sprite to be used as the mask.
   */
  pushSpriteMask(t) {
    const { maskObject: e } = t, r = t._target;
    let i = t._filters;
    i || (i = this.alphaMaskPool[this.alphaMaskIndex], i || (i = this.alphaMaskPool[this.alphaMaskIndex] = [new Sw()])), i[0].resolution = t.resolution, i[0].multisample = t.multisample, i[0].maskSprite = e;
    const s = r.filterArea;
    r.filterArea = e.getBounds(!0), this.renderer.filter.push(r, i), r.filterArea = s, t._filters || this.alphaMaskIndex++;
  }
  /**
   * Removes the last filter from the filter stack and doesn't return it.
   * @param maskData - Sprite to be used as the mask.
   */
  popSpriteMask(t) {
    this.renderer.filter.pop(), t._filters ? t._filters[0].maskSprite = null : (this.alphaMaskIndex--, this.alphaMaskPool[this.alphaMaskIndex][0].maskSprite = null);
  }
  /**
   * Pushes the color mask.
   * @param maskData - The mask data
   */
  pushColorMask(t) {
    const e = t._colorMask, r = t._colorMask = e & t.colorMask;
    r !== e && this.renderer.gl.colorMask(
      (r & 1) !== 0,
      (r & 2) !== 0,
      (r & 4) !== 0,
      (r & 8) !== 0
    );
  }
  /**
   * Pops the color mask.
   * @param maskData - The mask data
   */
  popColorMask(t) {
    const e = t._colorMask, r = this.maskStack.length > 0 ? this.maskStack[this.maskStack.length - 1]._colorMask : 15;
    r !== e && this.renderer.gl.colorMask(
      (r & 1) !== 0,
      (r & 2) !== 0,
      (r & 4) !== 0,
      (r & 8) !== 0
    );
  }
  destroy() {
    this.renderer = null;
  }
}
p0.extension = {
  type: st.RendererSystem,
  name: "mask"
};
dt.add(p0);
class m0 {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(t) {
    this.renderer = t, this.maskStack = [], this.glConst = 0;
  }
  /** Gets count of masks of certain type. */
  getStackLength() {
    return this.maskStack.length;
  }
  /**
   * Changes the mask stack that is used by this System.
   * @param {PIXI.MaskData[]} maskStack - The mask stack
   */
  setMaskStack(t) {
    const { gl: e } = this.renderer, r = this.getStackLength();
    this.maskStack = t;
    const i = this.getStackLength();
    i !== r && (i === 0 ? e.disable(this.glConst) : (e.enable(this.glConst), this._useCurrent()));
  }
  /**
   * Setup renderer to use the current mask data.
   * @private
   */
  _useCurrent() {
  }
  /** Destroys the mask stack. */
  destroy() {
    this.renderer = null, this.maskStack = null;
  }
}
const Gp = new Nt(), zp = [], g0 = class Aa extends m0 {
  /**
   * @param {PIXI.Renderer} renderer - The renderer this System works for.
   */
  constructor(t) {
    super(t), this.glConst = ht.ADAPTER.getWebGLRenderingContext().SCISSOR_TEST;
  }
  getStackLength() {
    const t = this.maskStack[this.maskStack.length - 1];
    return t ? t._scissorCounter : 0;
  }
  /**
   * evaluates _boundsTransformed, _scissorRect for MaskData
   * @param maskData
   */
  calcScissorRect(t) {
    if (t._scissorRectLocal)
      return;
    const e = t._scissorRect, { maskObject: r } = t, { renderer: i } = this, s = i.renderTexture, o = r.getBounds(!0, zp.pop() ?? new yt());
    this.roundFrameToPixels(
      o,
      s.current ? s.current.resolution : i.resolution,
      s.sourceFrame,
      s.destinationFrame,
      i.projection.transform
    ), e && o.fit(e), t._scissorRectLocal = o;
  }
  static isMatrixRotated(t) {
    if (!t)
      return !1;
    const { a: e, b: r, c: i, d: s } = t;
    return (Math.abs(r) > 1e-4 || Math.abs(i) > 1e-4) && (Math.abs(e) > 1e-4 || Math.abs(s) > 1e-4);
  }
  /**
   * Test, whether the object can be scissor mask with current renderer projection.
   * Calls "calcScissorRect()" if its true.
   * @param maskData - mask data
   * @returns whether Whether the object can be scissor mask
   */
  testScissor(t) {
    const { maskObject: e } = t;
    if (!e.isFastRect || !e.isFastRect() || Aa.isMatrixRotated(e.worldTransform) || Aa.isMatrixRotated(this.renderer.projection.transform))
      return !1;
    this.calcScissorRect(t);
    const r = t._scissorRectLocal;
    return r.width > 0 && r.height > 0;
  }
  roundFrameToPixels(t, e, r, i, s) {
    Aa.isMatrixRotated(s) || (s = s ? Gp.copyFrom(s) : Gp.identity(), s.translate(-r.x, -r.y).scale(
      i.width / r.width,
      i.height / r.height
    ).translate(i.x, i.y), this.renderer.filter.transformAABB(s, t), t.fit(i), t.x = Math.round(t.x * e), t.y = Math.round(t.y * e), t.width = Math.round(t.width * e), t.height = Math.round(t.height * e));
  }
  /**
   * Applies the Mask and adds it to the current stencil stack.
   * @author alvin
   * @param maskData - The mask data.
   */
  push(t) {
    t._scissorRectLocal || this.calcScissorRect(t);
    const { gl: e } = this.renderer;
    t._scissorRect || e.enable(e.SCISSOR_TEST), t._scissorCounter++, t._scissorRect = t._scissorRectLocal, this._useCurrent();
  }
  /**
   * This should be called after a mask is popped off the mask stack. It will rebind the scissor box to be latest with the
   * last mask in the stack.
   *
   * This can also be called when you directly modify the scissor box and want to restore PixiJS state.
   * @param maskData - The mask data.
   */
  pop(t) {
    const { gl: e } = this.renderer;
    t && zp.push(t._scissorRectLocal), this.getStackLength() > 0 ? this._useCurrent() : e.disable(e.SCISSOR_TEST);
  }
  /**
   * Setup renderer to use the current scissor data.
   * @private
   */
  _useCurrent() {
    const t = this.maskStack[this.maskStack.length - 1]._scissorRect;
    let e;
    this.renderer.renderTexture.current ? e = t.y : e = this.renderer.height - t.height - t.y, this.renderer.gl.scissor(t.x, e, t.width, t.height);
  }
};
g0.extension = {
  type: st.RendererSystem,
  name: "scissor"
};
let Mw = g0;
dt.add(Mw);
class y0 extends m0 {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(t) {
    super(t), this.glConst = ht.ADAPTER.getWebGLRenderingContext().STENCIL_TEST;
  }
  getStackLength() {
    const t = this.maskStack[this.maskStack.length - 1];
    return t ? t._stencilCounter : 0;
  }
  /**
   * Applies the Mask and adds it to the current stencil stack.
   * @param maskData - The mask data
   */
  push(t) {
    const e = t.maskObject, { gl: r } = this.renderer, i = t._stencilCounter;
    i === 0 && (this.renderer.framebuffer.forceStencil(), r.clearStencil(0), r.clear(r.STENCIL_BUFFER_BIT), r.enable(r.STENCIL_TEST)), t._stencilCounter++;
    const s = t._colorMask;
    s !== 0 && (t._colorMask = 0, r.colorMask(!1, !1, !1, !1)), r.stencilFunc(r.EQUAL, i, 4294967295), r.stencilOp(r.KEEP, r.KEEP, r.INCR), e.renderable = !0, e.render(this.renderer), this.renderer.batch.flush(), e.renderable = !1, s !== 0 && (t._colorMask = s, r.colorMask(
      (s & 1) !== 0,
      (s & 2) !== 0,
      (s & 4) !== 0,
      (s & 8) !== 0
    )), this._useCurrent();
  }
  /**
   * Pops stencil mask. MaskData is already removed from stack
   * @param {PIXI.DisplayObject} maskObject - object of popped mask data
   */
  pop(t) {
    const e = this.renderer.gl;
    if (this.getStackLength() === 0)
      e.disable(e.STENCIL_TEST);
    else {
      const r = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null, i = r ? r._colorMask : 15;
      i !== 0 && (r._colorMask = 0, e.colorMask(!1, !1, !1, !1)), e.stencilOp(e.KEEP, e.KEEP, e.DECR), t.renderable = !0, t.render(this.renderer), this.renderer.batch.flush(), t.renderable = !1, i !== 0 && (r._colorMask = i, e.colorMask(
        (i & 1) !== 0,
        (i & 2) !== 0,
        (i & 4) !== 0,
        (i & 8) !== 0
      )), this._useCurrent();
    }
  }
  /**
   * Setup renderer to use the current stencil data.
   * @private
   */
  _useCurrent() {
    const t = this.renderer.gl;
    t.stencilFunc(t.EQUAL, this.getStackLength(), 4294967295), t.stencilOp(t.KEEP, t.KEEP, t.KEEP);
  }
}
y0.extension = {
  type: st.RendererSystem,
  name: "stencil"
};
dt.add(y0);
class _0 {
  constructor(t) {
    this.renderer = t, this.plugins = {}, Object.defineProperties(this.plugins, {
      extract: {
        enumerable: !1,
        get() {
          return wt("7.0.0", "renderer.plugins.extract has moved to renderer.extract"), t.extract;
        }
      },
      prepare: {
        enumerable: !1,
        get() {
          return wt("7.0.0", "renderer.plugins.prepare has moved to renderer.prepare"), t.prepare;
        }
      },
      interaction: {
        enumerable: !1,
        get() {
          return wt("7.0.0", "renderer.plugins.interaction has been deprecated, use renderer.events"), t.events;
        }
      }
    });
  }
  /**
   * Initialize the plugins.
   * @protected
   */
  init() {
    const t = this.rendererPlugins;
    for (const e in t)
      this.plugins[e] = new t[e](this.renderer);
  }
  destroy() {
    for (const t in this.plugins)
      this.plugins[t].destroy(), this.plugins[t] = null;
  }
}
_0.extension = {
  type: [
    st.RendererSystem,
    st.CanvasRendererSystem
  ],
  name: "_plugin"
};
dt.add(_0);
class v0 {
  /** @param renderer - The renderer this System works for. */
  constructor(t) {
    this.renderer = t, this.destinationFrame = null, this.sourceFrame = null, this.defaultFrame = null, this.projectionMatrix = new Nt(), this.transform = null;
  }
  /**
   * Updates the projection-matrix based on the sourceFrame → destinationFrame mapping provided.
   *
   * NOTE: It is expected you call `renderer.framebuffer.setViewport(destinationFrame)` after this. This is because
   * the framebuffer viewport converts shader vertex output in normalized device coordinates to window coordinates.
   *
   * NOTE-2: {@link PIXI.RenderTextureSystem#bind} updates the projection-matrix when you bind a render-texture.
   * It is expected
   * that you dirty the current bindings when calling this manually.
   * @param destinationFrame - The rectangle in the render-target to render the contents into. If rendering to the canvas,
   *  the origin is on the top-left; if rendering to a render-texture, the origin is on the bottom-left.
   * @param sourceFrame - The rectangle in world space that contains the contents being rendered.
   * @param resolution - The resolution of the render-target, which is the ratio of
   *  world-space (or CSS) pixels to physical pixels.
   * @param root - Whether the render-target is the screen. This is required because rendering to textures
   *  is y-flipped (i.e. upside down relative to the screen).
   */
  update(t, e, r, i) {
    this.destinationFrame = t || this.destinationFrame || this.defaultFrame, this.sourceFrame = e || this.sourceFrame || t, this.calculateProjection(this.destinationFrame, this.sourceFrame, r, i), this.transform && this.projectionMatrix.append(this.transform);
    const s = this.renderer;
    s.globalUniforms.uniforms.projectionMatrix = this.projectionMatrix, s.globalUniforms.update(), s.shader.shader && s.shader.syncUniformGroup(s.shader.shader.uniforms.globals);
  }
  /**
   * Calculates the `projectionMatrix` to map points inside `sourceFrame` to inside `destinationFrame`.
   * @param _destinationFrame - The destination frame in the render-target.
   * @param sourceFrame - The source frame in world space.
   * @param _resolution - The render-target's resolution, i.e. ratio of CSS to physical pixels.
   * @param root - Whether rendering into the screen. Otherwise, if rendering to a framebuffer, the projection
   *  is y-flipped.
   */
  calculateProjection(t, e, r, i) {
    const s = this.projectionMatrix, o = i ? -1 : 1;
    s.identity(), s.a = 1 / e.width * 2, s.d = o * (1 / e.height * 2), s.tx = -1 - e.x * s.a, s.ty = -o - e.y * s.d;
  }
  /**
   * Sets the transform of the active render target to the given matrix.
   * @param _matrix - The transformation matrix
   */
  setTransform(t) {
  }
  destroy() {
    this.renderer = null;
  }
}
v0.extension = {
  type: st.RendererSystem,
  name: "projection"
};
dt.add(v0);
const Iw = new ad(), Wp = new yt();
class x0 {
  constructor(t) {
    this.renderer = t, this._tempMatrix = new Nt();
  }
  /**
   * A Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
   * @param displayObject - The displayObject the object will be generated from.
   * @param {IGenerateTextureOptions} options - Generate texture options.
   * @param {PIXI.Rectangle} options.region - The region of the displayObject, that shall be rendered,
   *        if no region is specified, defaults to the local bounds of the displayObject.
   * @param {number} [options.resolution] - If not given, the renderer's resolution is used.
   * @param {PIXI.MSAA_QUALITY} [options.multisample] - If not given, the renderer's multisample is used.
   * @returns a shiny new texture of the display object passed in
   */
  generateTexture(t, e) {
    const { region: r, ...i } = e || {}, s = r?.copyTo(Wp) || t.getLocalBounds(Wp, !0), o = i.resolution || this.renderer.resolution;
    s.width = Math.max(s.width, 1 / o), s.height = Math.max(s.height, 1 / o), i.width = s.width, i.height = s.height, i.resolution = o, i.multisample ?? (i.multisample = this.renderer.multisample);
    const a = Di.create(i);
    this._tempMatrix.tx = -s.x, this._tempMatrix.ty = -s.y;
    const h = t.transform;
    return t.transform = Iw, this.renderer.render(t, {
      renderTexture: a,
      transform: this._tempMatrix,
      skipUpdateTransform: !!t.parent,
      blit: !0
    }), t.transform = h, a;
  }
  destroy() {
  }
}
x0.extension = {
  type: [
    st.RendererSystem,
    st.CanvasRendererSystem
  ],
  name: "textureGenerator"
};
dt.add(x0);
const Jn = new yt(), ks = new yt();
class w0 {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(t) {
    this.renderer = t, this.defaultMaskStack = [], this.current = null, this.sourceFrame = new yt(), this.destinationFrame = new yt(), this.viewportFrame = new yt();
  }
  contextChange() {
    const t = this.renderer?.gl.getContextAttributes();
    this._rendererPremultipliedAlpha = !!(t && t.alpha && t.premultipliedAlpha);
  }
  /**
   * Bind the current render texture.
   * @param renderTexture - RenderTexture to bind, by default its `null` - the screen.
   * @param sourceFrame - Part of world that is mapped to the renderTexture.
   * @param destinationFrame - Part of renderTexture, by default it has the same size as sourceFrame.
   */
  bind(t = null, e, r) {
    const i = this.renderer;
    this.current = t;
    let s, o, a;
    t ? (s = t.baseTexture, a = s.resolution, e || (Jn.width = t.frame.width, Jn.height = t.frame.height, e = Jn), r || (ks.x = t.frame.x, ks.y = t.frame.y, ks.width = e.width, ks.height = e.height, r = ks), o = s.framebuffer) : (a = i.resolution, e || (Jn.width = i._view.screen.width, Jn.height = i._view.screen.height, e = Jn), r || (r = Jn, r.width = e.width, r.height = e.height));
    const h = this.viewportFrame;
    h.x = r.x * a, h.y = r.y * a, h.width = r.width * a, h.height = r.height * a, t || (h.y = i.view.height - (h.y + h.height)), h.ceil(), this.renderer.framebuffer.bind(o, h), this.renderer.projection.update(r, e, a, !o), t ? this.renderer.mask.setMaskStack(s.maskStack) : this.renderer.mask.setMaskStack(this.defaultMaskStack), this.sourceFrame.copyFrom(e), this.destinationFrame.copyFrom(r);
  }
  /**
   * Erases the render texture and fills the drawing area with a colour.
   * @param clearColor - The color as rgba, default to use the renderer backgroundColor
   * @param [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
   *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
   */
  clear(t, e) {
    const r = this.current ? this.current.baseTexture.clear : this.renderer.background.backgroundColor, i = Ot.shared.setValue(t || r);
    (this.current && this.current.baseTexture.alphaMode > 0 || !this.current && this._rendererPremultipliedAlpha) && i.premultiply(i.alpha);
    const s = this.destinationFrame, o = this.current ? this.current.baseTexture : this.renderer._view.screen, a = s.width !== o.width || s.height !== o.height;
    if (a) {
      let { x: h, y: l, width: u, height: c } = this.viewportFrame;
      h = Math.round(h), l = Math.round(l), u = Math.round(u), c = Math.round(c), this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST), this.renderer.gl.scissor(h, l, u, c);
    }
    this.renderer.framebuffer.clear(i.red, i.green, i.blue, i.alpha, e), a && this.renderer.scissor.pop();
  }
  resize() {
    this.bind(null);
  }
  /** Resets render-texture state. */
  reset() {
    this.bind(null);
  }
  destroy() {
    this.renderer = null;
  }
}
w0.extension = {
  type: st.RendererSystem,
  name: "renderTexture"
};
dt.add(w0);
class Pw {
  /**
   * Makes a new Pixi program.
   * @param program - webgl program
   * @param uniformData - uniforms
   */
  constructor(t, e) {
    this.program = t, this.uniformData = e, this.uniformGroups = {}, this.uniformDirtyGroups = {}, this.uniformBufferBindings = {};
  }
  /** Destroys this program. */
  destroy() {
    this.uniformData = null, this.uniformGroups = null, this.uniformDirtyGroups = null, this.uniformBufferBindings = null, this.program = null;
  }
}
function Rw(n, t) {
  const e = {}, r = t.getProgramParameter(n, t.ACTIVE_ATTRIBUTES);
  for (let i = 0; i < r; i++) {
    const s = t.getActiveAttrib(n, i);
    if (s.name.startsWith("gl_"))
      continue;
    const o = i0(t, s.type), a = {
      type: o,
      name: s.name,
      size: n0(o),
      location: t.getAttribLocation(n, s.name)
    };
    e[s.name] = a;
  }
  return e;
}
function Dw(n, t) {
  const e = {}, r = t.getProgramParameter(n, t.ACTIVE_UNIFORMS);
  for (let i = 0; i < r; i++) {
    const s = t.getActiveUniform(n, i), o = s.name.replace(/\[.*?\]$/, ""), a = !!s.name.match(/\[.*?\]$/), h = i0(t, s.type);
    e[o] = {
      name: o,
      index: i,
      type: h,
      size: s.size,
      isArray: a,
      value: e0(h, s.size)
    };
  }
  return e;
}
function Fw(n, t) {
  const e = Op(n, n.VERTEX_SHADER, t.vertexSrc), r = Op(n, n.FRAGMENT_SHADER, t.fragmentSrc), i = n.createProgram();
  n.attachShader(i, e), n.attachShader(i, r);
  const s = t.extra?.transformFeedbackVaryings;
  if (s && (typeof n.transformFeedbackVaryings != "function" ? console.warn("TransformFeedback is not supported but TransformFeedbackVaryings are given.") : n.transformFeedbackVaryings(
    i,
    s.names,
    s.bufferMode === "separate" ? n.SEPARATE_ATTRIBS : n.INTERLEAVED_ATTRIBS
  )), n.linkProgram(i), n.getProgramParameter(i, n.LINK_STATUS) || hw(n, i, e, r), t.attributeData = Rw(i, n), t.uniformData = Dw(i, n), !/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(t.vertexSrc)) {
    const a = Object.keys(t.attributeData);
    a.sort((h, l) => h > l ? 1 : -1);
    for (let h = 0; h < a.length; h++)
      t.attributeData[a[h]].location = h, n.bindAttribLocation(i, h, a[h]);
    n.linkProgram(i);
  }
  n.deleteShader(e), n.deleteShader(r);
  const o = {};
  for (const a in t.uniformData) {
    const h = t.uniformData[a];
    o[a] = {
      location: n.getUniformLocation(i, a),
      value: e0(h.type, h.size)
    };
  }
  return new Pw(i, o);
}
function Ow(n, t, e, r, i) {
  e.buffer.update(i);
}
const Nw = {
  float: `
        data[offset] = v;
    `,
  vec2: `
        data[offset] = v[0];
        data[offset+1] = v[1];
    `,
  vec3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

    `,
  vec4: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];
        data[offset+3] = v[3];
    `,
  mat2: `
        data[offset] = v[0];
        data[offset+1] = v[1];

        data[offset+4] = v[2];
        data[offset+5] = v[3];
    `,
  mat3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];

        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];
    `,
  mat4: `
        for(var i = 0; i < 16; i++)
        {
            data[offset + i] = v[i];
        }
    `
}, b0 = {
  float: 4,
  vec2: 8,
  vec3: 12,
  vec4: 16,
  int: 4,
  ivec2: 8,
  ivec3: 12,
  ivec4: 16,
  uint: 4,
  uvec2: 8,
  uvec3: 12,
  uvec4: 16,
  bool: 4,
  bvec2: 8,
  bvec3: 12,
  bvec4: 16,
  mat2: 32,
  mat3: 48,
  mat4: 64
};
function kw(n) {
  const t = n.map((s) => ({
    data: s,
    offset: 0,
    dataLen: 0,
    dirty: 0
  }));
  let e = 0, r = 0, i = 0;
  for (let s = 0; s < t.length; s++) {
    const o = t[s];
    if (e = b0[o.data.type], o.data.size > 1 && (e = Math.max(e, 16) * o.data.size), o.dataLen = e, r % e !== 0 && r < 16) {
      const a = r % e % 16;
      r += a, i += a;
    }
    r + e > 16 ? (i = Math.ceil(i / 16) * 16, o.offset = i, i += e, r = e) : (o.offset = i, r += e, i += e);
  }
  return i = Math.ceil(i / 16) * 16, { uboElements: t, size: i };
}
function Bw(n, t) {
  const e = [];
  for (const r in n)
    t[r] && e.push(t[r]);
  return e.sort((r, i) => r.index - i.index), e;
}
function Lw(n, t) {
  if (!n.autoManage)
    return { size: 0, syncFunc: Ow };
  const e = Bw(n.uniforms, t), { uboElements: r, size: i } = kw(e), s = [`
    var v = null;
    var v2 = null;
    var cv = null;
    var t = 0;
    var gl = renderer.gl
    var index = 0;
    var data = buffer.data;
    `];
  for (let o = 0; o < r.length; o++) {
    const a = r[o], h = n.uniforms[a.data.name], l = a.data.name;
    let u = !1;
    for (let c = 0; c < rs.length; c++) {
      const d = rs[c];
      if (d.codeUbo && d.test(a.data, h)) {
        s.push(
          `offset = ${a.offset / 4};`,
          rs[c].codeUbo(a.data.name, h)
        ), u = !0;
        break;
      }
    }
    if (!u)
      if (a.data.size > 1) {
        const c = n0(a.data.type), d = Math.max(b0[a.data.type] / 16, 1), f = c / d, p = (4 - f % 4) % 4;
        s.push(`
                cv = ud.${l}.value;
                v = uv.${l};
                offset = ${a.offset / 4};

                t = 0;

                for(var i=0; i < ${a.data.size * d}; i++)
                {
                    for(var j = 0; j < ${f}; j++)
                    {
                        data[offset++] = v[t++];
                    }
                    offset += ${p};
                }

                `);
      } else {
        const c = Nw[a.data.type];
        s.push(`
                cv = ud.${l}.value;
                v = uv.${l};
                offset = ${a.offset / 4};
                ${c};
                `);
      }
  }
  return s.push(`
       renderer.buffer.update(buffer);
    `), {
    size: i,
    // eslint-disable-next-line no-new-func
    syncFunc: new Function(
      "ud",
      "uv",
      "renderer",
      "syncData",
      "buffer",
      s.join(`
`)
    )
  };
}
let Uw = 0;
const oa = { textureCount: 0, uboCount: 0 };
class T0 {
  /** @param renderer - The renderer this System works for. */
  constructor(t) {
    this.destroyed = !1, this.renderer = t, this.systemCheck(), this.gl = null, this.shader = null, this.program = null, this.cache = {}, this._uboCache = {}, this.id = Uw++;
  }
  /**
   * Overrideable function by `@pixi/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   */
  systemCheck() {
    if (!uw())
      throw new Error("Current environment does not allow unsafe-eval, please use @pixi/unsafe-eval module to enable support.");
  }
  contextChange(t) {
    this.gl = t, this.reset();
  }
  /**
   * Changes the current shader to the one given in parameter.
   * @param shader - the new shader
   * @param dontSync - false if the shader should automatically sync its uniforms.
   * @returns the glProgram that belongs to the shader.
   */
  bind(t, e) {
    t.disposeRunner.add(this), t.uniforms.globals = this.renderer.globalUniforms;
    const r = t.program, i = r.glPrograms[this.renderer.CONTEXT_UID] || this.generateProgram(t);
    return this.shader = t, this.program !== r && (this.program = r, this.gl.useProgram(i.program)), e || (oa.textureCount = 0, oa.uboCount = 0, this.syncUniformGroup(t.uniformGroup, oa)), i;
  }
  /**
   * Uploads the uniforms values to the currently bound shader.
   * @param uniforms - the uniforms values that be applied to the current shader
   */
  setUniforms(t) {
    const e = this.shader.program, r = e.glPrograms[this.renderer.CONTEXT_UID];
    e.syncUniforms(r.uniformData, t, this.renderer);
  }
  /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
  /**
   * Syncs uniforms on the group
   * @param group - the uniform group to sync
   * @param syncData - this is data that is passed to the sync function and any nested sync functions
   */
  syncUniformGroup(t, e) {
    const r = this.getGlProgram();
    (!t.static || t.dirtyId !== r.uniformDirtyGroups[t.id]) && (r.uniformDirtyGroups[t.id] = t.dirtyId, this.syncUniforms(t, r, e));
  }
  /**
   * Overrideable by the @pixi/unsafe-eval package to use static syncUniforms instead.
   * @param group
   * @param glProgram
   * @param syncData
   */
  syncUniforms(t, e, r) {
    (t.syncUniforms[this.shader.program.id] || this.createSyncGroups(t))(e.uniformData, t.uniforms, this.renderer, r);
  }
  createSyncGroups(t) {
    const e = this.getSignature(t, this.shader.program.uniformData, "u");
    return this.cache[e] || (this.cache[e] = sw(t, this.shader.program.uniformData)), t.syncUniforms[this.shader.program.id] = this.cache[e], t.syncUniforms[this.shader.program.id];
  }
  /**
   * Syncs uniform buffers
   * @param group - the uniform buffer group to sync
   * @param name - the name of the uniform buffer
   */
  syncUniformBufferGroup(t, e) {
    const r = this.getGlProgram();
    if (!t.static || t.dirtyId !== 0 || !r.uniformGroups[t.id]) {
      t.dirtyId = 0;
      const i = r.uniformGroups[t.id] || this.createSyncBufferGroup(t, r, e);
      t.buffer.update(), i(
        r.uniformData,
        t.uniforms,
        this.renderer,
        oa,
        t.buffer
      );
    }
    this.renderer.buffer.bindBufferBase(t.buffer, r.uniformBufferBindings[e]);
  }
  /**
   * Will create a function that uploads a uniform buffer using the STD140 standard.
   * The upload function will then be cached for future calls
   * If a group is manually managed, then a simple upload function is generated
   * @param group - the uniform buffer group to sync
   * @param glProgram - the gl program to attach the uniform bindings to
   * @param name - the name of the uniform buffer (must exist on the shader)
   */
  createSyncBufferGroup(t, e, r) {
    const { gl: i } = this.renderer;
    this.renderer.buffer.bind(t.buffer);
    const s = this.gl.getUniformBlockIndex(e.program, r);
    e.uniformBufferBindings[r] = this.shader.uniformBindCount, i.uniformBlockBinding(e.program, s, this.shader.uniformBindCount), this.shader.uniformBindCount++;
    const o = this.getSignature(t, this.shader.program.uniformData, "ubo");
    let a = this._uboCache[o];
    if (a || (a = this._uboCache[o] = Lw(t, this.shader.program.uniformData)), t.autoManage) {
      const h = new Float32Array(a.size / 4);
      t.buffer.update(h);
    }
    return e.uniformGroups[t.id] = a.syncFunc, e.uniformGroups[t.id];
  }
  /**
   * Takes a uniform group and data and generates a unique signature for them.
   * @param group - The uniform group to get signature of
   * @param group.uniforms
   * @param uniformData - Uniform information generated by the shader
   * @param preFix
   * @returns Unique signature of the uniform group
   */
  getSignature(t, e, r) {
    const i = t.uniforms, s = [`${r}-`];
    for (const o in i)
      s.push(o), e[o] && s.push(e[o].type);
    return s.join("-");
  }
  /**
   * Returns the underlying GLShade rof the currently bound shader.
   *
   * This can be handy for when you to have a little more control over the setting of your uniforms.
   * @returns The glProgram for the currently bound Shader for this context
   */
  getGlProgram() {
    return this.shader ? this.shader.program.glPrograms[this.renderer.CONTEXT_UID] : null;
  }
  /**
   * Generates a glProgram version of the Shader provided.
   * @param shader - The shader that the glProgram will be based on.
   * @returns A shiny new glProgram!
   */
  generateProgram(t) {
    const e = this.gl, r = t.program, i = Fw(e, r);
    return r.glPrograms[this.renderer.CONTEXT_UID] = i, i;
  }
  /** Resets ShaderSystem state, does not affect WebGL state. */
  reset() {
    this.program = null, this.shader = null;
  }
  /**
   * Disposes shader.
   * If disposing one equals with current shader, set current as null.
   * @param shader - Shader object
   */
  disposeShader(t) {
    this.shader === t && (this.shader = null);
  }
  /** Destroys this System and removes all its textures. */
  destroy() {
    this.renderer = null, this.destroyed = !0;
  }
}
T0.extension = {
  type: st.RendererSystem,
  name: "shader"
};
dt.add(T0);
class ja {
  constructor(t) {
    this.renderer = t;
  }
  /**
   * It all starts here! This initiates every system, passing in the options for any system by name.
   * @param options - the config for the renderer and all its systems
   */
  run(t) {
    const { renderer: e } = this;
    e.runners.init.emit(e.options), t.hello && console.log(`PixiJS 7.3.2 - ${e.rendererLogId} - https://pixijs.com`), e.resize(e.screen.width, e.screen.height);
  }
  destroy() {
  }
}
ja.defaultOptions = {
  /**
   * {@link PIXI.IRendererOptions.hello}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  hello: !1
}, /** @ignore */
ja.extension = {
  type: [
    st.RendererSystem,
    st.CanvasRendererSystem
  ],
  name: "startup"
};
dt.add(ja);
function Hw(n, t = []) {
  return t[gt.NORMAL] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.ADD] = [n.ONE, n.ONE], t[gt.MULTIPLY] = [n.DST_COLOR, n.ONE_MINUS_SRC_ALPHA, n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.SCREEN] = [n.ONE, n.ONE_MINUS_SRC_COLOR, n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.OVERLAY] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.DARKEN] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.LIGHTEN] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.COLOR_DODGE] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.COLOR_BURN] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.HARD_LIGHT] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.SOFT_LIGHT] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.DIFFERENCE] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.EXCLUSION] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.HUE] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.SATURATION] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.COLOR] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.LUMINOSITY] = [n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.NONE] = [0, 0], t[gt.NORMAL_NPM] = [n.SRC_ALPHA, n.ONE_MINUS_SRC_ALPHA, n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.ADD_NPM] = [n.SRC_ALPHA, n.ONE, n.ONE, n.ONE], t[gt.SCREEN_NPM] = [n.SRC_ALPHA, n.ONE_MINUS_SRC_COLOR, n.ONE, n.ONE_MINUS_SRC_ALPHA], t[gt.SRC_IN] = [n.DST_ALPHA, n.ZERO], t[gt.SRC_OUT] = [n.ONE_MINUS_DST_ALPHA, n.ZERO], t[gt.SRC_ATOP] = [n.DST_ALPHA, n.ONE_MINUS_SRC_ALPHA], t[gt.DST_OVER] = [n.ONE_MINUS_DST_ALPHA, n.ONE], t[gt.DST_IN] = [n.ZERO, n.SRC_ALPHA], t[gt.DST_OUT] = [n.ZERO, n.ONE_MINUS_SRC_ALPHA], t[gt.DST_ATOP] = [n.ONE_MINUS_DST_ALPHA, n.SRC_ALPHA], t[gt.XOR] = [n.ONE_MINUS_DST_ALPHA, n.ONE_MINUS_SRC_ALPHA], t[gt.SUBTRACT] = [n.ONE, n.ONE, n.ONE, n.ONE, n.FUNC_REVERSE_SUBTRACT, n.FUNC_ADD], t;
}
const Gw = 0, zw = 1, Ww = 2, $w = 3, Xw = 4, Vw = 5, A0 = class rc {
  constructor() {
    this.gl = null, this.stateId = 0, this.polygonOffset = 0, this.blendMode = gt.NONE, this._blendEq = !1, this.map = [], this.map[Gw] = this.setBlend, this.map[zw] = this.setOffset, this.map[Ww] = this.setCullFace, this.map[$w] = this.setDepthTest, this.map[Xw] = this.setFrontFace, this.map[Vw] = this.setDepthMask, this.checks = [], this.defaultState = new Hr(), this.defaultState.blend = !0;
  }
  contextChange(t) {
    this.gl = t, this.blendModes = Hw(t), this.set(this.defaultState), this.reset();
  }
  /**
   * Sets the current state
   * @param {*} state - The state to set.
   */
  set(t) {
    if (t = t || this.defaultState, this.stateId !== t.data) {
      let e = this.stateId ^ t.data, r = 0;
      for (; e; )
        e & 1 && this.map[r].call(this, !!(t.data & 1 << r)), e = e >> 1, r++;
      this.stateId = t.data;
    }
    for (let e = 0; e < this.checks.length; e++)
      this.checks[e](this, t);
  }
  /**
   * Sets the state, when previous state is unknown.
   * @param {*} state - The state to set
   */
  forceState(t) {
    t = t || this.defaultState;
    for (let e = 0; e < this.map.length; e++)
      this.map[e].call(this, !!(t.data & 1 << e));
    for (let e = 0; e < this.checks.length; e++)
      this.checks[e](this, t);
    this.stateId = t.data;
  }
  /**
   * Sets whether to enable or disable blending.
   * @param value - Turn on or off WebGl blending.
   */
  setBlend(t) {
    this.updateCheck(rc.checkBlendMode, t), this.gl[t ? "enable" : "disable"](this.gl.BLEND);
  }
  /**
   * Sets whether to enable or disable polygon offset fill.
   * @param value - Turn on or off webgl polygon offset testing.
   */
  setOffset(t) {
    this.updateCheck(rc.checkPolygonOffset, t), this.gl[t ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
  }
  /**
   * Sets whether to enable or disable depth test.
   * @param value - Turn on or off webgl depth testing.
   */
  setDepthTest(t) {
    this.gl[t ? "enable" : "disable"](this.gl.DEPTH_TEST);
  }
  /**
   * Sets whether to enable or disable depth mask.
   * @param value - Turn on or off webgl depth mask.
   */
  setDepthMask(t) {
    this.gl.depthMask(t);
  }
  /**
   * Sets whether to enable or disable cull face.
   * @param {boolean} value - Turn on or off webgl cull face.
   */
  setCullFace(t) {
    this.gl[t ? "enable" : "disable"](this.gl.CULL_FACE);
  }
  /**
   * Sets the gl front face.
   * @param {boolean} value - true is clockwise and false is counter-clockwise
   */
  setFrontFace(t) {
    this.gl.frontFace(this.gl[t ? "CW" : "CCW"]);
  }
  /**
   * Sets the blend mode.
   * @param {number} value - The blend mode to set to.
   */
  setBlendMode(t) {
    if (t === this.blendMode)
      return;
    this.blendMode = t;
    const e = this.blendModes[t], r = this.gl;
    e.length === 2 ? r.blendFunc(e[0], e[1]) : r.blendFuncSeparate(e[0], e[1], e[2], e[3]), e.length === 6 ? (this._blendEq = !0, r.blendEquationSeparate(e[4], e[5])) : this._blendEq && (this._blendEq = !1, r.blendEquationSeparate(r.FUNC_ADD, r.FUNC_ADD));
  }
  /**
   * Sets the polygon offset.
   * @param {number} value - the polygon offset
   * @param {number} scale - the polygon offset scale
   */
  setPolygonOffset(t, e) {
    this.gl.polygonOffset(t, e);
  }
  // used
  /** Resets all the logic and disables the VAOs. */
  reset() {
    this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, !1), this.forceState(this.defaultState), this._blendEq = !0, this.blendMode = -1, this.setBlendMode(0);
  }
  /**
   * Checks to see which updates should be checked based on which settings have been activated.
   *
   * For example, if blend is enabled then we should check the blend modes each time the state is changed
   * or if polygon fill is activated then we need to check if the polygon offset changes.
   * The idea is that we only check what we have too.
   * @param func - the checking function to add or remove
   * @param value - should the check function be added or removed.
   */
  updateCheck(t, e) {
    const r = this.checks.indexOf(t);
    e && r === -1 ? this.checks.push(t) : !e && r !== -1 && this.checks.splice(r, 1);
  }
  /**
   * A private little wrapper function that we call to check the blend mode.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static checkBlendMode(t, e) {
    t.setBlendMode(e.blendMode);
  }
  /**
   * A private little wrapper function that we call to check the polygon offset.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static checkPolygonOffset(t, e) {
    t.setPolygonOffset(1, e.polygonOffset);
  }
  /**
   * @ignore
   */
  destroy() {
    this.gl = null;
  }
};
A0.extension = {
  type: st.RendererSystem,
  name: "state"
};
let Yw = A0;
dt.add(Yw);
class jw extends Co {
  constructor() {
    super(...arguments), this.runners = {}, this._systemsHash = {};
  }
  /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */
  setup(t) {
    this.addRunners(...t.runners);
    const e = (t.priority ?? []).filter((i) => t.systems[i]), r = [
      ...e,
      ...Object.keys(t.systems).filter((i) => !e.includes(i))
    ];
    for (const i of r)
      this.addSystem(t.systems[i], i);
  }
  /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */
  addRunners(...t) {
    t.forEach((e) => {
      this.runners[e] = new pr(e);
    });
  }
  /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */
  addSystem(t, e) {
    const r = new t(this);
    if (this[e])
      throw new Error(`Whoops! The name "${e}" is already in use`);
    this[e] = r, this._systemsHash[e] = r;
    for (const i in this.runners)
      this.runners[i].add(r);
    return this;
  }
  /**
   * A function that will run a runner and call the runners function but pass in different options
   * to each system based on there name.
   *
   * E.g. If you have two systems added called `systemA` and `systemB` you could call do the following:
   *
   * ```js
   * system.emitWithCustomOptions(init, {
   *     systemA: {...optionsForA},
   *     systemB: {...optionsForB},
   * });
   * ```
   *
   * `init` would be called on system A passing `optionsForA` and on system B passing `optionsForB`.
   * @param runner - the runner to target
   * @param options - key value options for each system
   */
  emitWithCustomOptions(t, e) {
    const r = Object.keys(this._systemsHash);
    t.items.forEach((i) => {
      const s = r.find((o) => this._systemsHash[o] === i);
      i[t.name](e[s]);
    });
  }
  /** destroy the all runners and systems. Its apps job to */
  destroy() {
    Object.values(this.runners).forEach((t) => {
      t.destroy();
    }), this._systemsHash = {};
  }
  // TODO implement!
  // removeSystem(ClassRef: ISystemConstructor, name: string): void
  // {
  // }
}
const qs = class Ea {
  /** @param renderer - The renderer this System works for. */
  constructor(t) {
    this.renderer = t, this.count = 0, this.checkCount = 0, this.maxIdle = Ea.defaultMaxIdle, this.checkCountMax = Ea.defaultCheckCountMax, this.mode = Ea.defaultMode;
  }
  /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */
  postrender() {
    this.renderer.objectRenderer.renderingToScreen && (this.count++, this.mode !== nd.MANUAL && (this.checkCount++, this.checkCount > this.checkCountMax && (this.checkCount = 0, this.run())));
  }
  /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */
  run() {
    const t = this.renderer.texture, e = t.managedTextures;
    let r = !1;
    for (let i = 0; i < e.length; i++) {
      const s = e[i];
      s.resource && this.count - s.touched > this.maxIdle && (t.destroyTexture(s, !0), e[i] = null, r = !0);
    }
    if (r) {
      let i = 0;
      for (let s = 0; s < e.length; s++)
        e[s] !== null && (e[i++] = e[s]);
      e.length = i;
    }
  }
  /**
   * Removes all the textures within the specified displayObject and its children from the GPU.
   * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
   */
  unload(t) {
    const e = this.renderer.texture, r = t._texture;
    r && !r.framebuffer && e.destroyTexture(r);
    for (let i = t.children.length - 1; i >= 0; i--)
      this.unload(t.children[i]);
  }
  destroy() {
    this.renderer = null;
  }
};
qs.defaultMode = nd.AUTO, /**
* Default maximum idle frames before a texture is destroyed by garbage collection.
* @static
* @default 3600
* @see PIXI.TextureGCSystem#maxIdle
*/
qs.defaultMaxIdle = 3600, /**
* Default frames between two garbage collections.
* @static
* @default 600
* @see PIXI.TextureGCSystem#checkCountMax
*/
qs.defaultCheckCountMax = 600, /** @ignore */
qs.extension = {
  type: st.RendererSystem,
  name: "textureGC"
};
let li = qs;
dt.add(li);
class ou {
  constructor(t) {
    this.texture = t, this.width = -1, this.height = -1, this.dirtyId = -1, this.dirtyStyleId = -1, this.mipmap = !1, this.wrapMode = 33071, this.type = pt.UNSIGNED_BYTE, this.internalFormat = Q.RGBA, this.samplerType = 0;
  }
}
function qw(n) {
  let t;
  return "WebGL2RenderingContext" in globalThis && n instanceof globalThis.WebGL2RenderingContext ? t = {
    [n.RGB]: at.FLOAT,
    [n.RGBA]: at.FLOAT,
    [n.ALPHA]: at.FLOAT,
    [n.LUMINANCE]: at.FLOAT,
    [n.LUMINANCE_ALPHA]: at.FLOAT,
    [n.R8]: at.FLOAT,
    [n.R8_SNORM]: at.FLOAT,
    [n.RG8]: at.FLOAT,
    [n.RG8_SNORM]: at.FLOAT,
    [n.RGB8]: at.FLOAT,
    [n.RGB8_SNORM]: at.FLOAT,
    [n.RGB565]: at.FLOAT,
    [n.RGBA4]: at.FLOAT,
    [n.RGB5_A1]: at.FLOAT,
    [n.RGBA8]: at.FLOAT,
    [n.RGBA8_SNORM]: at.FLOAT,
    [n.RGB10_A2]: at.FLOAT,
    [n.RGB10_A2UI]: at.FLOAT,
    [n.SRGB8]: at.FLOAT,
    [n.SRGB8_ALPHA8]: at.FLOAT,
    [n.R16F]: at.FLOAT,
    [n.RG16F]: at.FLOAT,
    [n.RGB16F]: at.FLOAT,
    [n.RGBA16F]: at.FLOAT,
    [n.R32F]: at.FLOAT,
    [n.RG32F]: at.FLOAT,
    [n.RGB32F]: at.FLOAT,
    [n.RGBA32F]: at.FLOAT,
    [n.R11F_G11F_B10F]: at.FLOAT,
    [n.RGB9_E5]: at.FLOAT,
    [n.R8I]: at.INT,
    [n.R8UI]: at.UINT,
    [n.R16I]: at.INT,
    [n.R16UI]: at.UINT,
    [n.R32I]: at.INT,
    [n.R32UI]: at.UINT,
    [n.RG8I]: at.INT,
    [n.RG8UI]: at.UINT,
    [n.RG16I]: at.INT,
    [n.RG16UI]: at.UINT,
    [n.RG32I]: at.INT,
    [n.RG32UI]: at.UINT,
    [n.RGB8I]: at.INT,
    [n.RGB8UI]: at.UINT,
    [n.RGB16I]: at.INT,
    [n.RGB16UI]: at.UINT,
    [n.RGB32I]: at.INT,
    [n.RGB32UI]: at.UINT,
    [n.RGBA8I]: at.INT,
    [n.RGBA8UI]: at.UINT,
    [n.RGBA16I]: at.INT,
    [n.RGBA16UI]: at.UINT,
    [n.RGBA32I]: at.INT,
    [n.RGBA32UI]: at.UINT,
    [n.DEPTH_COMPONENT16]: at.FLOAT,
    [n.DEPTH_COMPONENT24]: at.FLOAT,
    [n.DEPTH_COMPONENT32F]: at.FLOAT,
    [n.DEPTH_STENCIL]: at.FLOAT,
    [n.DEPTH24_STENCIL8]: at.FLOAT,
    [n.DEPTH32F_STENCIL8]: at.FLOAT
  } : t = {
    [n.RGB]: at.FLOAT,
    [n.RGBA]: at.FLOAT,
    [n.ALPHA]: at.FLOAT,
    [n.LUMINANCE]: at.FLOAT,
    [n.LUMINANCE_ALPHA]: at.FLOAT,
    [n.DEPTH_STENCIL]: at.FLOAT
  }, t;
}
function Zw(n) {
  let t;
  return "WebGL2RenderingContext" in globalThis && n instanceof globalThis.WebGL2RenderingContext ? t = {
    [pt.UNSIGNED_BYTE]: {
      [Q.RGBA]: n.RGBA8,
      [Q.RGB]: n.RGB8,
      [Q.RG]: n.RG8,
      [Q.RED]: n.R8,
      [Q.RGBA_INTEGER]: n.RGBA8UI,
      [Q.RGB_INTEGER]: n.RGB8UI,
      [Q.RG_INTEGER]: n.RG8UI,
      [Q.RED_INTEGER]: n.R8UI,
      [Q.ALPHA]: n.ALPHA,
      [Q.LUMINANCE]: n.LUMINANCE,
      [Q.LUMINANCE_ALPHA]: n.LUMINANCE_ALPHA
    },
    [pt.BYTE]: {
      [Q.RGBA]: n.RGBA8_SNORM,
      [Q.RGB]: n.RGB8_SNORM,
      [Q.RG]: n.RG8_SNORM,
      [Q.RED]: n.R8_SNORM,
      [Q.RGBA_INTEGER]: n.RGBA8I,
      [Q.RGB_INTEGER]: n.RGB8I,
      [Q.RG_INTEGER]: n.RG8I,
      [Q.RED_INTEGER]: n.R8I
    },
    [pt.UNSIGNED_SHORT]: {
      [Q.RGBA_INTEGER]: n.RGBA16UI,
      [Q.RGB_INTEGER]: n.RGB16UI,
      [Q.RG_INTEGER]: n.RG16UI,
      [Q.RED_INTEGER]: n.R16UI,
      [Q.DEPTH_COMPONENT]: n.DEPTH_COMPONENT16
    },
    [pt.SHORT]: {
      [Q.RGBA_INTEGER]: n.RGBA16I,
      [Q.RGB_INTEGER]: n.RGB16I,
      [Q.RG_INTEGER]: n.RG16I,
      [Q.RED_INTEGER]: n.R16I
    },
    [pt.UNSIGNED_INT]: {
      [Q.RGBA_INTEGER]: n.RGBA32UI,
      [Q.RGB_INTEGER]: n.RGB32UI,
      [Q.RG_INTEGER]: n.RG32UI,
      [Q.RED_INTEGER]: n.R32UI,
      [Q.DEPTH_COMPONENT]: n.DEPTH_COMPONENT24
    },
    [pt.INT]: {
      [Q.RGBA_INTEGER]: n.RGBA32I,
      [Q.RGB_INTEGER]: n.RGB32I,
      [Q.RG_INTEGER]: n.RG32I,
      [Q.RED_INTEGER]: n.R32I
    },
    [pt.FLOAT]: {
      [Q.RGBA]: n.RGBA32F,
      [Q.RGB]: n.RGB32F,
      [Q.RG]: n.RG32F,
      [Q.RED]: n.R32F,
      [Q.DEPTH_COMPONENT]: n.DEPTH_COMPONENT32F
    },
    [pt.HALF_FLOAT]: {
      [Q.RGBA]: n.RGBA16F,
      [Q.RGB]: n.RGB16F,
      [Q.RG]: n.RG16F,
      [Q.RED]: n.R16F
    },
    [pt.UNSIGNED_SHORT_5_6_5]: {
      [Q.RGB]: n.RGB565
    },
    [pt.UNSIGNED_SHORT_4_4_4_4]: {
      [Q.RGBA]: n.RGBA4
    },
    [pt.UNSIGNED_SHORT_5_5_5_1]: {
      [Q.RGBA]: n.RGB5_A1
    },
    [pt.UNSIGNED_INT_2_10_10_10_REV]: {
      [Q.RGBA]: n.RGB10_A2,
      [Q.RGBA_INTEGER]: n.RGB10_A2UI
    },
    [pt.UNSIGNED_INT_10F_11F_11F_REV]: {
      [Q.RGB]: n.R11F_G11F_B10F
    },
    [pt.UNSIGNED_INT_5_9_9_9_REV]: {
      [Q.RGB]: n.RGB9_E5
    },
    [pt.UNSIGNED_INT_24_8]: {
      [Q.DEPTH_STENCIL]: n.DEPTH24_STENCIL8
    },
    [pt.FLOAT_32_UNSIGNED_INT_24_8_REV]: {
      [Q.DEPTH_STENCIL]: n.DEPTH32F_STENCIL8
    }
  } : t = {
    [pt.UNSIGNED_BYTE]: {
      [Q.RGBA]: n.RGBA,
      [Q.RGB]: n.RGB,
      [Q.ALPHA]: n.ALPHA,
      [Q.LUMINANCE]: n.LUMINANCE,
      [Q.LUMINANCE_ALPHA]: n.LUMINANCE_ALPHA
    },
    [pt.UNSIGNED_SHORT_5_6_5]: {
      [Q.RGB]: n.RGB
    },
    [pt.UNSIGNED_SHORT_4_4_4_4]: {
      [Q.RGBA]: n.RGBA
    },
    [pt.UNSIGNED_SHORT_5_5_5_1]: {
      [Q.RGBA]: n.RGBA
    }
  }, t;
}
class E0 {
  /**
   * @param renderer - The renderer this system works for.
   */
  constructor(t) {
    this.renderer = t, this.boundTextures = [], this.currentLocation = -1, this.managedTextures = [], this._unknownBoundTextures = !1, this.unknownTexture = new _t(), this.hasIntegerTextures = !1;
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    const t = this.gl = this.renderer.gl;
    this.CONTEXT_UID = this.renderer.CONTEXT_UID, this.webGLVersion = this.renderer.context.webGLVersion, this.internalFormats = Zw(t), this.samplerTypes = qw(t);
    const e = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);
    this.boundTextures.length = e;
    for (let i = 0; i < e; i++)
      this.boundTextures[i] = null;
    this.emptyTextures = {};
    const r = new ou(t.createTexture());
    t.bindTexture(t.TEXTURE_2D, r.texture), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, 1, 1, 0, t.RGBA, t.UNSIGNED_BYTE, new Uint8Array(4)), this.emptyTextures[t.TEXTURE_2D] = r, this.emptyTextures[t.TEXTURE_CUBE_MAP] = new ou(t.createTexture()), t.bindTexture(t.TEXTURE_CUBE_MAP, this.emptyTextures[t.TEXTURE_CUBE_MAP].texture);
    for (let i = 0; i < 6; i++)
      t.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, t.RGBA, 1, 1, 0, t.RGBA, t.UNSIGNED_BYTE, null);
    t.texParameteri(t.TEXTURE_CUBE_MAP, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_CUBE_MAP, t.TEXTURE_MIN_FILTER, t.LINEAR);
    for (let i = 0; i < this.boundTextures.length; i++)
      this.bind(null, i);
  }
  /**
   * Bind a texture to a specific location
   *
   * If you want to unbind something, please use `unbind(texture)` instead of `bind(null, textureLocation)`
   * @param texture - Texture to bind
   * @param [location=0] - Location to bind at
   */
  bind(t, e = 0) {
    const { gl: r } = this;
    if (t = t?.castToBaseTexture(), t?.valid && !t.parentTextureArray) {
      t.touched = this.renderer.textureGC.count;
      const i = t._glTextures[this.CONTEXT_UID] || this.initTexture(t);
      this.boundTextures[e] !== t && (this.currentLocation !== e && (this.currentLocation = e, r.activeTexture(r.TEXTURE0 + e)), r.bindTexture(t.target, i.texture)), i.dirtyId !== t.dirtyId ? (this.currentLocation !== e && (this.currentLocation = e, r.activeTexture(r.TEXTURE0 + e)), this.updateTexture(t)) : i.dirtyStyleId !== t.dirtyStyleId && this.updateTextureStyle(t), this.boundTextures[e] = t;
    } else
      this.currentLocation !== e && (this.currentLocation = e, r.activeTexture(r.TEXTURE0 + e)), r.bindTexture(r.TEXTURE_2D, this.emptyTextures[r.TEXTURE_2D].texture), this.boundTextures[e] = null;
  }
  /** Resets texture location and bound textures Actual `bind(null, i)` calls will be performed at next `unbind()` call */
  reset() {
    this._unknownBoundTextures = !0, this.hasIntegerTextures = !1, this.currentLocation = -1;
    for (let t = 0; t < this.boundTextures.length; t++)
      this.boundTextures[t] = this.unknownTexture;
  }
  /**
   * Unbind a texture.
   * @param texture - Texture to bind
   */
  unbind(t) {
    const { gl: e, boundTextures: r } = this;
    if (this._unknownBoundTextures) {
      this._unknownBoundTextures = !1;
      for (let i = 0; i < r.length; i++)
        r[i] === this.unknownTexture && this.bind(null, i);
    }
    for (let i = 0; i < r.length; i++)
      r[i] === t && (this.currentLocation !== i && (e.activeTexture(e.TEXTURE0 + i), this.currentLocation = i), e.bindTexture(t.target, this.emptyTextures[t.target].texture), r[i] = null);
  }
  /**
   * Ensures that current boundTextures all have FLOAT sampler type,
   * see {@link PIXI.SAMPLER_TYPES} for explanation.
   * @param maxTextures - number of locations to check
   */
  ensureSamplerType(t) {
    const { boundTextures: e, hasIntegerTextures: r, CONTEXT_UID: i } = this;
    if (r)
      for (let s = t - 1; s >= 0; --s) {
        const o = e[s];
        o && o._glTextures[i].samplerType !== at.FLOAT && this.renderer.texture.unbind(o);
      }
  }
  /**
   * Initialize a texture
   * @private
   * @param texture - Texture to initialize
   */
  initTexture(t) {
    const e = new ou(this.gl.createTexture());
    return e.dirtyId = -1, t._glTextures[this.CONTEXT_UID] = e, this.managedTextures.push(t), t.on("dispose", this.destroyTexture, this), e;
  }
  initTextureType(t, e) {
    e.internalFormat = this.internalFormats[t.type]?.[t.format] ?? t.format, e.samplerType = this.samplerTypes[e.internalFormat] ?? at.FLOAT, this.webGLVersion === 2 && t.type === pt.HALF_FLOAT ? e.type = this.gl.HALF_FLOAT : e.type = t.type;
  }
  /**
   * Update a texture
   * @private
   * @param {PIXI.BaseTexture} texture - Texture to initialize
   */
  updateTexture(t) {
    const e = t._glTextures[this.CONTEXT_UID];
    if (!e)
      return;
    const r = this.renderer;
    if (this.initTextureType(t, e), t.resource?.upload(r, t, e))
      e.samplerType !== at.FLOAT && (this.hasIntegerTextures = !0);
    else {
      const i = t.realWidth, s = t.realHeight, o = r.gl;
      (e.width !== i || e.height !== s || e.dirtyId < 0) && (e.width = i, e.height = s, o.texImage2D(
        t.target,
        0,
        e.internalFormat,
        i,
        s,
        0,
        t.format,
        e.type,
        null
      ));
    }
    t.dirtyStyleId !== e.dirtyStyleId && this.updateTextureStyle(t), e.dirtyId = t.dirtyId;
  }
  /**
   * Deletes the texture from WebGL
   * @private
   * @param texture - the texture to destroy
   * @param [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
   */
  destroyTexture(t, e) {
    const { gl: r } = this;
    if (t = t.castToBaseTexture(), t._glTextures[this.CONTEXT_UID] && (this.unbind(t), r.deleteTexture(t._glTextures[this.CONTEXT_UID].texture), t.off("dispose", this.destroyTexture, this), delete t._glTextures[this.CONTEXT_UID], !e)) {
      const i = this.managedTextures.indexOf(t);
      i !== -1 && es(this.managedTextures, i, 1);
    }
  }
  /**
   * Update texture style such as mipmap flag
   * @private
   * @param {PIXI.BaseTexture} texture - Texture to update
   */
  updateTextureStyle(t) {
    const e = t._glTextures[this.CONTEXT_UID];
    e && ((t.mipmap === Lr.POW2 || this.webGLVersion !== 2) && !t.isPowerOfTwo ? e.mipmap = !1 : e.mipmap = t.mipmap >= 1, this.webGLVersion !== 2 && !t.isPowerOfTwo ? e.wrapMode = Dr.CLAMP : e.wrapMode = t.wrapMode, t.resource?.style(this.renderer, t, e) || this.setStyle(t, e), e.dirtyStyleId = t.dirtyStyleId);
  }
  /**
   * Set style for texture
   * @private
   * @param texture - Texture to update
   * @param glTexture
   */
  setStyle(t, e) {
    const r = this.gl;
    if (e.mipmap && t.mipmap !== Lr.ON_MANUAL && r.generateMipmap(t.target), r.texParameteri(t.target, r.TEXTURE_WRAP_S, e.wrapMode), r.texParameteri(t.target, r.TEXTURE_WRAP_T, e.wrapMode), e.mipmap) {
      r.texParameteri(t.target, r.TEXTURE_MIN_FILTER, t.scaleMode === Qr.LINEAR ? r.LINEAR_MIPMAP_LINEAR : r.NEAREST_MIPMAP_NEAREST);
      const i = this.renderer.context.extensions.anisotropicFiltering;
      if (i && t.anisotropicLevel > 0 && t.scaleMode === Qr.LINEAR) {
        const s = Math.min(t.anisotropicLevel, r.getParameter(i.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
        r.texParameterf(t.target, i.TEXTURE_MAX_ANISOTROPY_EXT, s);
      }
    } else
      r.texParameteri(t.target, r.TEXTURE_MIN_FILTER, t.scaleMode === Qr.LINEAR ? r.LINEAR : r.NEAREST);
    r.texParameteri(t.target, r.TEXTURE_MAG_FILTER, t.scaleMode === Qr.LINEAR ? r.LINEAR : r.NEAREST);
  }
  destroy() {
    this.renderer = null;
  }
}
E0.extension = {
  type: st.RendererSystem,
  name: "texture"
};
dt.add(E0);
class S0 {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(t) {
    this.renderer = t;
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    this.gl = this.renderer.gl, this.CONTEXT_UID = this.renderer.CONTEXT_UID;
  }
  /**
   * Bind TransformFeedback and buffers
   * @param transformFeedback - TransformFeedback to bind
   */
  bind(t) {
    const { gl: e, CONTEXT_UID: r } = this, i = t._glTransformFeedbacks[r] || this.createGLTransformFeedback(t);
    e.bindTransformFeedback(e.TRANSFORM_FEEDBACK, i);
  }
  /** Unbind TransformFeedback */
  unbind() {
    const { gl: t } = this;
    t.bindTransformFeedback(t.TRANSFORM_FEEDBACK, null);
  }
  /**
   * Begin TransformFeedback
   * @param drawMode - DrawMode for TransformFeedback
   * @param shader - A Shader used by TransformFeedback. Current bound shader will be used if not provided.
   */
  beginTransformFeedback(t, e) {
    const { gl: r, renderer: i } = this;
    e && i.shader.bind(e), r.beginTransformFeedback(t);
  }
  /** End TransformFeedback */
  endTransformFeedback() {
    const { gl: t } = this;
    t.endTransformFeedback();
  }
  /**
   * Create TransformFeedback and bind buffers
   * @param tf - TransformFeedback
   * @returns WebGLTransformFeedback
   */
  createGLTransformFeedback(t) {
    const { gl: e, renderer: r, CONTEXT_UID: i } = this, s = e.createTransformFeedback();
    t._glTransformFeedbacks[i] = s, e.bindTransformFeedback(e.TRANSFORM_FEEDBACK, s);
    for (let o = 0; o < t.buffers.length; o++) {
      const a = t.buffers[o];
      a && (r.buffer.update(a), a._glBuffers[i].refCount++, e.bindBufferBase(e.TRANSFORM_FEEDBACK_BUFFER, o, a._glBuffers[i].buffer || null));
    }
    return e.bindTransformFeedback(e.TRANSFORM_FEEDBACK, null), t.disposeRunner.add(this), s;
  }
  /**
   * Disposes TransfromFeedback
   * @param {PIXI.TransformFeedback} tf - TransformFeedback
   * @param {boolean} [contextLost=false] - If context was lost, we suppress delete TransformFeedback
   */
  disposeTransformFeedback(t, e) {
    const r = t._glTransformFeedbacks[this.CONTEXT_UID], i = this.gl;
    t.disposeRunner.remove(this);
    const s = this.renderer.buffer;
    if (s)
      for (let o = 0; o < t.buffers.length; o++) {
        const a = t.buffers[o];
        if (!a)
          continue;
        const h = a._glBuffers[this.CONTEXT_UID];
        h && (h.refCount--, h.refCount === 0 && !e && s.dispose(a, e));
      }
    r && (e || i.deleteTransformFeedback(r), delete t._glTransformFeedbacks[this.CONTEXT_UID]);
  }
  destroy() {
    this.renderer = null;
  }
}
S0.extension = {
  type: st.RendererSystem,
  name: "transformFeedback"
};
dt.add(S0);
class qa {
  constructor(t) {
    this.renderer = t;
  }
  /**
   * initiates the view system
   * @param {PIXI.ViewOptions} options - the options for the view
   */
  init(t) {
    this.screen = new yt(0, 0, t.width, t.height), this.element = t.view || ht.ADAPTER.createCanvas(), this.resolution = t.resolution || ht.RESOLUTION, this.autoDensity = !!t.autoDensity;
  }
  /**
   * Resizes the screen and canvas to the specified dimensions.
   * @param desiredScreenWidth - The new width of the screen.
   * @param desiredScreenHeight - The new height of the screen.
   */
  resizeView(t, e) {
    this.element.width = Math.round(t * this.resolution), this.element.height = Math.round(e * this.resolution);
    const r = this.element.width / this.resolution, i = this.element.height / this.resolution;
    this.screen.width = r, this.screen.height = i, this.autoDensity && (this.element.style.width = `${r}px`, this.element.style.height = `${i}px`), this.renderer.emit("resize", r, i), this.renderer.runners.resize.emit(this.screen.width, this.screen.height);
  }
  /**
   * Destroys this System and optionally removes the canvas from the dom.
   * @param {boolean} [removeView=false] - Whether to remove the canvas from the DOM.
   */
  destroy(t) {
    t && this.element.parentNode?.removeChild(this.element), this.renderer = null, this.element = null, this.screen = null;
  }
}
qa.defaultOptions = {
  /**
   * {@link PIXI.IRendererOptions.width}
   * @default 800
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  width: 800,
  /**
   * {@link PIXI.IRendererOptions.height}
   * @default 600
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  height: 600,
  /**
   * {@link PIXI.IRendererOptions.resolution}
   * @type {number}
   * @default PIXI.settings.RESOLUTION
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  resolution: void 0,
  /**
   * {@link PIXI.IRendererOptions.autoDensity}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  autoDensity: !1
}, /** @ignore */
qa.extension = {
  type: [
    st.RendererSystem,
    st.CanvasRendererSystem
  ],
  name: "_view"
};
dt.add(qa);
ht.PREFER_ENV = Ri.WEBGL2;
ht.STRICT_TEXTURE_CACHE = !1;
ht.RENDER_OPTIONS = {
  ...Ya.defaultOptions,
  ...Va.defaultOptions,
  ...qa.defaultOptions,
  ...ja.defaultOptions
};
Object.defineProperties(ht, {
  /**
   * @static
   * @name WRAP_MODE
   * @memberof PIXI.settings
   * @type {PIXI.WRAP_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.wrapMode
   */
  WRAP_MODE: {
    get() {
      return _t.defaultOptions.wrapMode;
    },
    set(n) {
      wt("7.1.0", "settings.WRAP_MODE is deprecated, use BaseTexture.defaultOptions.wrapMode"), _t.defaultOptions.wrapMode = n;
    }
  },
  /**
   * @static
   * @name SCALE_MODE
   * @memberof PIXI.settings
   * @type {PIXI.SCALE_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.scaleMode
   */
  SCALE_MODE: {
    get() {
      return _t.defaultOptions.scaleMode;
    },
    set(n) {
      wt("7.1.0", "settings.SCALE_MODE is deprecated, use BaseTexture.defaultOptions.scaleMode"), _t.defaultOptions.scaleMode = n;
    }
  },
  /**
   * @static
   * @name MIPMAP_TEXTURES
   * @memberof PIXI.settings
   * @type {PIXI.MIPMAP_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.mipmap
   */
  MIPMAP_TEXTURES: {
    get() {
      return _t.defaultOptions.mipmap;
    },
    set(n) {
      wt("7.1.0", "settings.MIPMAP_TEXTURES is deprecated, use BaseTexture.defaultOptions.mipmap"), _t.defaultOptions.mipmap = n;
    }
    // MIPMAP_MODES.POW2,
  },
  /**
   * @static
   * @name ANISOTROPIC_LEVEL
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.anisotropicLevel
   */
  ANISOTROPIC_LEVEL: {
    get() {
      return _t.defaultOptions.anisotropicLevel;
    },
    set(n) {
      wt(
        "7.1.0",
        "settings.ANISOTROPIC_LEVEL is deprecated, use BaseTexture.defaultOptions.anisotropicLevel"
      ), _t.defaultOptions.anisotropicLevel = n;
    }
  },
  /**
   * Default filter resolution.
   * @static
   * @name FILTER_RESOLUTION
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {number|null}
   * @see PIXI.Filter.defaultResolution
   */
  FILTER_RESOLUTION: {
    get() {
      return wt("7.1.0", "settings.FILTER_RESOLUTION is deprecated, use Filter.defaultResolution"), ve.defaultResolution;
    },
    set(n) {
      ve.defaultResolution = n;
    }
  },
  /**
   * Default filter samples.
   * @static
   * @name FILTER_MULTISAMPLE
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {PIXI.MSAA_QUALITY}
   * @see PIXI.Filter.defaultMultisample
   */
  FILTER_MULTISAMPLE: {
    get() {
      return wt("7.1.0", "settings.FILTER_MULTISAMPLE is deprecated, use Filter.defaultMultisample"), ve.defaultMultisample;
    },
    set(n) {
      ve.defaultMultisample = n;
    }
  },
  /**
   * The maximum textures that this device supports.
   * @static
   * @name SPRITE_MAX_TEXTURES
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @see PIXI.BatchRenderer.defaultMaxTextures
   * @type {number}
   */
  SPRITE_MAX_TEXTURES: {
    get() {
      return hi.defaultMaxTextures;
    },
    set(n) {
      wt("7.1.0", "settings.SPRITE_MAX_TEXTURES is deprecated, use BatchRenderer.defaultMaxTextures"), hi.defaultMaxTextures = n;
    }
  },
  /**
   * The default sprite batch size.
   *
   * The default aims to balance desktop and mobile devices.
   * @static
   * @name SPRITE_BATCH_SIZE
   * @memberof PIXI.settings
   * @see PIXI.BatchRenderer.defaultBatchSize
   * @deprecated since 7.1.0
   * @type {number}
   */
  SPRITE_BATCH_SIZE: {
    get() {
      return hi.defaultBatchSize;
    },
    set(n) {
      wt("7.1.0", "settings.SPRITE_BATCH_SIZE is deprecated, use BatchRenderer.defaultBatchSize"), hi.defaultBatchSize = n;
    }
  },
  /**
   * Can we upload the same buffer in a single frame?
   * @static
   * @name CAN_UPLOAD_SAME_BUFFER
   * @memberof PIXI.settings
   * @see PIXI.BatchRenderer.canUploadSameBuffer
   * @deprecated since 7.1.0
   * @type {boolean}
   */
  CAN_UPLOAD_SAME_BUFFER: {
    get() {
      return hi.canUploadSameBuffer;
    },
    set(n) {
      wt("7.1.0", "settings.CAN_UPLOAD_SAME_BUFFER is deprecated, use BatchRenderer.canUploadSameBuffer"), hi.canUploadSameBuffer = n;
    }
  },
  /**
   * Default Garbage Collection mode.
   * @static
   * @name GC_MODE
   * @memberof PIXI.settings
   * @type {PIXI.GC_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultMode
   */
  GC_MODE: {
    get() {
      return li.defaultMode;
    },
    set(n) {
      wt("7.1.0", "settings.GC_MODE is deprecated, use TextureGCSystem.defaultMode"), li.defaultMode = n;
    }
  },
  /**
   * Default Garbage Collection max idle.
   * @static
   * @name GC_MAX_IDLE
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultMaxIdle
   */
  GC_MAX_IDLE: {
    get() {
      return li.defaultMaxIdle;
    },
    set(n) {
      wt("7.1.0", "settings.GC_MAX_IDLE is deprecated, use TextureGCSystem.defaultMaxIdle"), li.defaultMaxIdle = n;
    }
  },
  /**
   * Default Garbage Collection maximum check count.
   * @static
   * @name GC_MAX_CHECK_COUNT
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultCheckCountMax
   */
  GC_MAX_CHECK_COUNT: {
    get() {
      return li.defaultCheckCountMax;
    },
    set(n) {
      wt("7.1.0", "settings.GC_MAX_CHECK_COUNT is deprecated, use TextureGCSystem.defaultCheckCountMax"), li.defaultCheckCountMax = n;
    }
  },
  /**
   * Default specify float precision in vertex shader.
   * @static
   * @name PRECISION_VERTEX
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @deprecated since 7.1.0
   * @see PIXI.Program.defaultVertexPrecision
   */
  PRECISION_VERTEX: {
    get() {
      return en.defaultVertexPrecision;
    },
    set(n) {
      wt("7.1.0", "settings.PRECISION_VERTEX is deprecated, use Program.defaultVertexPrecision"), en.defaultVertexPrecision = n;
    }
  },
  /**
   * Default specify float precision in fragment shader.
   * @static
   * @name PRECISION_FRAGMENT
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @deprecated since 7.1.0
   * @see PIXI.Program.defaultFragmentPrecision
   */
  PRECISION_FRAGMENT: {
    get() {
      return en.defaultFragmentPrecision;
    },
    set(n) {
      wt("7.1.0", "settings.PRECISION_FRAGMENT is deprecated, use Program.defaultFragmentPrecision"), en.defaultFragmentPrecision = n;
    }
  }
});
var Ai = /* @__PURE__ */ ((n) => (n[n.INTERACTION = 50] = "INTERACTION", n[n.HIGH = 25] = "HIGH", n[n.NORMAL = 0] = "NORMAL", n[n.LOW = -25] = "LOW", n[n.UTILITY = -50] = "UTILITY", n))(Ai || {});
class au {
  /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */
  constructor(t, e = null, r = 0, i = !1) {
    this.next = null, this.previous = null, this._destroyed = !1, this.fn = t, this.context = e, this.priority = r, this.once = i;
  }
  /**
   * Simple compare function to figure out if a function and context match.
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */
  match(t, e = null) {
    return this.fn === t && this.context === e;
  }
  /**
   * Emit by calling the current function.
   * @private
   * @param deltaTime - time since the last emit.
   * @returns Next ticker
   */
  emit(t) {
    this.fn && (this.context ? this.fn.call(this.context, t) : this.fn(t));
    const e = this.next;
    return this.once && this.destroy(!0), this._destroyed && (this.next = null), e;
  }
  /**
   * Connect to the list.
   * @private
   * @param previous - Input node, previous listener
   */
  connect(t) {
    this.previous = t, t.next && (t.next.previous = this), this.next = t.next, t.next = this;
  }
  /**
   * Destroy and don't use after this.
   * @private
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */
  destroy(t = !1) {
    this._destroyed = !0, this.fn = null, this.context = null, this.previous && (this.previous.next = this.next), this.next && (this.next.previous = this.previous);
    const e = this.next;
    return this.next = t ? null : e, this.previous = null, e;
  }
}
const C0 = class Fe {
  constructor() {
    this.autoStart = !1, this.deltaTime = 1, this.lastTime = -1, this.speed = 1, this.started = !1, this._requestId = null, this._maxElapsedMS = 100, this._minElapsedMS = 0, this._protected = !1, this._lastFrame = -1, this._head = new au(null, null, 1 / 0), this.deltaMS = 1 / Fe.targetFPMS, this.elapsedMS = 1 / Fe.targetFPMS, this._tick = (t) => {
      this._requestId = null, this.started && (this.update(t), this.started && this._requestId === null && this._head.next && (this._requestId = requestAnimationFrame(this._tick)));
    };
  }
  /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   * @private
   */
  _requestIfNeeded() {
    this._requestId === null && this._head.next && (this.lastTime = performance.now(), this._lastFrame = this.lastTime, this._requestId = requestAnimationFrame(this._tick));
  }
  /**
   * Conditionally cancels a pending animation frame.
   * @private
   */
  _cancelIfNeeded() {
    this._requestId !== null && (cancelAnimationFrame(this._requestId), this._requestId = null);
  }
  /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   * @private
   */
  _startIfPossible() {
    this.started ? this._requestIfNeeded() : this.autoStart && this.start();
  }
  /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */
  add(t, e, r = Ai.NORMAL) {
    return this._addListener(new au(t, e, r));
  }
  /**
   * Add a handler for the tick event which is only execute once.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */
  addOnce(t, e, r = Ai.NORMAL) {
    return this._addListener(new au(t, e, r, !0));
  }
  /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */
  _addListener(t) {
    let e = this._head.next, r = this._head;
    if (!e)
      t.connect(r);
    else {
      for (; e; ) {
        if (t.priority > e.priority) {
          t.connect(r);
          break;
        }
        r = e, e = e.next;
      }
      t.previous || t.connect(r);
    }
    return this._startIfPossible(), this;
  }
  /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   */
  remove(t, e) {
    let r = this._head.next;
    for (; r; )
      r.match(t, e) ? r = r.destroy() : r = r.next;
    return this._head.next || this._cancelIfNeeded(), this;
  }
  /**
   * The number of listeners on this ticker, calculated by walking through linked list
   * @readonly
   * @member {number}
   */
  get count() {
    if (!this._head)
      return 0;
    let t = 0, e = this._head;
    for (; e = e.next; )
      t++;
    return t;
  }
  /** Starts the ticker. If the ticker has listeners a new animation frame is requested at this point. */
  start() {
    this.started || (this.started = !0, this._requestIfNeeded());
  }
  /** Stops the ticker. If the ticker has requested an animation frame it is canceled at this point. */
  stop() {
    this.started && (this.started = !1, this._cancelIfNeeded());
  }
  /** Destroy the ticker and don't use after this. Calling this method removes all references to internal events. */
  destroy() {
    if (!this._protected) {
      this.stop();
      let t = this._head.next;
      for (; t; )
        t = t.destroy(!0);
      this._head.destroy(), this._head = null;
    }
  }
  /**
   * Triggers an update. An update entails setting the
   * current {@link PIXI.Ticker#elapsedMS},
   * the current {@link PIXI.Ticker#deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link PIXI.Ticker#lastTime}
   * with the value of currentTime that was provided.
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @param {number} [currentTime=performance.now()] - the current time of execution
   */
  update(t = performance.now()) {
    let e;
    if (t > this.lastTime) {
      if (e = this.elapsedMS = t - this.lastTime, e > this._maxElapsedMS && (e = this._maxElapsedMS), e *= this.speed, this._minElapsedMS) {
        const s = t - this._lastFrame | 0;
        if (s < this._minElapsedMS)
          return;
        this._lastFrame = t - s % this._minElapsedMS;
      }
      this.deltaMS = e, this.deltaTime = this.deltaMS * Fe.targetFPMS;
      const r = this._head;
      let i = r.next;
      for (; i; )
        i = i.emit(this.deltaTime);
      r.next || this._cancelIfNeeded();
    } else
      this.deltaTime = this.deltaMS = this.elapsedMS = 0;
    this.lastTime = t;
  }
  /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * **Note:** This does not factor in the value of
   * {@link PIXI.Ticker#speed}, which is specific
   * to scaling {@link PIXI.Ticker#deltaTime}.
   * @member {number}
   * @readonly
   */
  get FPS() {
    return 1e3 / this.elapsedMS;
  }
  /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link PIXI.Ticker#update}.
   * This value is used to cap {@link PIXI.Ticker#deltaTime},
   * but does not effect the measured value of {@link PIXI.Ticker#FPS}.
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @member {number}
   * @default 10
   */
  get minFPS() {
    return 1e3 / this._maxElapsedMS;
  }
  set minFPS(t) {
    const e = Math.min(this.maxFPS, t), r = Math.min(Math.max(0, e) / 1e3, Fe.targetFPMS);
    this._maxElapsedMS = 1 / r;
  }
  /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link PIXI.Ticker#update}.
   * This will effect the measured value of {@link PIXI.Ticker#FPS}.
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @member {number}
   * @default 0
   */
  get maxFPS() {
    return this._minElapsedMS ? Math.round(1e3 / this._minElapsedMS) : 0;
  }
  set maxFPS(t) {
    if (t === 0)
      this._minElapsedMS = 0;
    else {
      const e = Math.max(this.minFPS, t);
      this._minElapsedMS = 1 / (e / 1e3);
    }
  }
  /**
   * The shared ticker instance used by {@link PIXI.AnimatedSprite} and by
   * {@link PIXI.VideoResource} to update animation frames / video textures.
   *
   * It may also be used by {@link PIXI.Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the PIXI.Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @member {PIXI.Ticker}
   * @static
   */
  static get shared() {
    if (!Fe._shared) {
      const t = Fe._shared = new Fe();
      t.autoStart = !0, t._protected = !0;
    }
    return Fe._shared;
  }
  /**
   * The system ticker instance used by {@link PIXI.BasePrepare} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
   * @member {PIXI.Ticker}
   * @static
   */
  static get system() {
    if (!Fe._system) {
      const t = Fe._system = new Fe();
      t.autoStart = !0, t._protected = !0;
    }
    return Fe._system;
  }
};
C0.targetFPMS = 0.06;
let xe = C0;
Object.defineProperties(ht, {
  /**
   * Target frames per millisecond.
   * @static
   * @name TARGET_FPMS
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.Ticker.targetFPMS
   */
  TARGET_FPMS: {
    get() {
      return xe.targetFPMS;
    },
    set(n) {
      wt("7.1.0", "settings.TARGET_FPMS is deprecated, use Ticker.targetFPMS"), xe.targetFPMS = n;
    }
  }
});
class M0 {
  /**
   * Initialize the plugin with scope of application instance
   * @static
   * @private
   * @param {object} [options] - See application options
   */
  static init(t) {
    t = Object.assign({
      autoStart: !0,
      sharedTicker: !1
    }, t), Object.defineProperty(
      this,
      "ticker",
      {
        set(e) {
          this._ticker && this._ticker.remove(this.render, this), this._ticker = e, e && e.add(this.render, this, Ai.LOW);
        },
        get() {
          return this._ticker;
        }
      }
    ), this.stop = () => {
      this._ticker.stop();
    }, this.start = () => {
      this._ticker.start();
    }, this._ticker = null, this.ticker = t.sharedTicker ? xe.shared : new xe(), t.autoStart && this.start();
  }
  /**
   * Clean up the ticker, scoped to application.
   * @static
   * @private
   */
  static destroy() {
    if (this._ticker) {
      const t = this._ticker;
      this.ticker = null, t.destroy();
    }
  }
}
M0.extension = st.Application;
dt.add(M0);
const I0 = [];
dt.handleByList(st.Renderer, I0);
function Kw(n) {
  for (const t of I0)
    if (t.test(n))
      return new t(n);
  throw new Error("Unable to auto-detect a suitable renderer.");
}
var Qw = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, Jw = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`;
const tb = Qw, P0 = Jw;
class R0 {
  constructor(t) {
    this.renderer = t;
  }
  contextChange(t) {
    let e;
    if (this.renderer.context.webGLVersion === 1) {
      const r = t.getParameter(t.FRAMEBUFFER_BINDING);
      t.bindFramebuffer(t.FRAMEBUFFER, null), e = t.getParameter(t.SAMPLES), t.bindFramebuffer(t.FRAMEBUFFER, r);
    } else {
      const r = t.getParameter(t.DRAW_FRAMEBUFFER_BINDING);
      t.bindFramebuffer(t.DRAW_FRAMEBUFFER, null), e = t.getParameter(t.SAMPLES), t.bindFramebuffer(t.DRAW_FRAMEBUFFER, r);
    }
    e >= Zt.HIGH ? this.multisample = Zt.HIGH : e >= Zt.MEDIUM ? this.multisample = Zt.MEDIUM : e >= Zt.LOW ? this.multisample = Zt.LOW : this.multisample = Zt.NONE;
  }
  destroy() {
  }
}
R0.extension = {
  type: st.RendererSystem,
  name: "_multisample"
};
dt.add(R0);
class eb {
  constructor(t) {
    this.buffer = t || null, this.updateID = -1, this.byteLength = -1, this.refCount = 0;
  }
}
class D0 {
  /**
   * @param {PIXI.Renderer} renderer - The renderer this System works for.
   */
  constructor(t) {
    this.renderer = t, this.managedBuffers = {}, this.boundBufferBases = {};
  }
  /**
   * @ignore
   */
  destroy() {
    this.renderer = null;
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    this.disposeAll(!0), this.gl = this.renderer.gl, this.CONTEXT_UID = this.renderer.CONTEXT_UID;
  }
  /**
   * This binds specified buffer. On first run, it will create the webGL buffers for the context too
   * @param buffer - the buffer to bind to the renderer
   */
  bind(t) {
    const { gl: e, CONTEXT_UID: r } = this, i = t._glBuffers[r] || this.createGLBuffer(t);
    e.bindBuffer(t.type, i.buffer);
  }
  unbind(t) {
    const { gl: e } = this;
    e.bindBuffer(t, null);
  }
  /**
   * Binds an uniform buffer to at the given index.
   *
   * A cache is used so a buffer will not be bound again if already bound.
   * @param buffer - the buffer to bind
   * @param index - the base index to bind it to.
   */
  bindBufferBase(t, e) {
    const { gl: r, CONTEXT_UID: i } = this;
    if (this.boundBufferBases[e] !== t) {
      const s = t._glBuffers[i] || this.createGLBuffer(t);
      this.boundBufferBases[e] = t, r.bindBufferBase(r.UNIFORM_BUFFER, e, s.buffer);
    }
  }
  /**
   * Binds a buffer whilst also binding its range.
   * This will make the buffer start from the offset supplied rather than 0 when it is read.
   * @param buffer - the buffer to bind
   * @param index - the base index to bind at, defaults to 0
   * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
   */
  bindBufferRange(t, e, r) {
    const { gl: i, CONTEXT_UID: s } = this;
    r = r || 0;
    const o = t._glBuffers[s] || this.createGLBuffer(t);
    i.bindBufferRange(i.UNIFORM_BUFFER, e || 0, o.buffer, r * 256, 256);
  }
  /**
   * Will ensure the data in the buffer is uploaded to the GPU.
   * @param {PIXI.Buffer} buffer - the buffer to update
   */
  update(t) {
    const { gl: e, CONTEXT_UID: r } = this, i = t._glBuffers[r] || this.createGLBuffer(t);
    if (t._updateID !== i.updateID)
      if (i.updateID = t._updateID, e.bindBuffer(t.type, i.buffer), i.byteLength >= t.data.byteLength)
        e.bufferSubData(t.type, 0, t.data);
      else {
        const s = t.static ? e.STATIC_DRAW : e.DYNAMIC_DRAW;
        i.byteLength = t.data.byteLength, e.bufferData(t.type, t.data, s);
      }
  }
  /**
   * Disposes buffer
   * @param {PIXI.Buffer} buffer - buffer with data
   * @param {boolean} [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */
  dispose(t, e) {
    if (!this.managedBuffers[t.id])
      return;
    delete this.managedBuffers[t.id];
    const r = t._glBuffers[this.CONTEXT_UID], i = this.gl;
    t.disposeRunner.remove(this), r && (e || i.deleteBuffer(r.buffer), delete t._glBuffers[this.CONTEXT_UID]);
  }
  /**
   * dispose all WebGL resources of all managed buffers
   * @param {boolean} [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */
  disposeAll(t) {
    const e = Object.keys(this.managedBuffers);
    for (let r = 0; r < e.length; r++)
      this.dispose(this.managedBuffers[e[r]], t);
  }
  /**
   * creates and attaches a GLBuffer object tied to the current context.
   * @param buffer
   * @protected
   */
  createGLBuffer(t) {
    const { CONTEXT_UID: e, gl: r } = this;
    return t._glBuffers[e] = new eb(r.createBuffer()), this.managedBuffers[t.id] = t, t.disposeRunner.add(this), t._glBuffers[e];
  }
}
D0.extension = {
  type: st.RendererSystem,
  name: "buffer"
};
dt.add(D0);
class F0 {
  // renderers scene graph!
  constructor(t) {
    this.renderer = t;
  }
  /**
   * Renders the object to its WebGL view.
   * @param displayObject - The object to be rendered.
   * @param options - the options to be passed to the renderer
   */
  render(t, e) {
    const r = this.renderer;
    let i, s, o, a;
    if (e && (i = e.renderTexture, s = e.clear, o = e.transform, a = e.skipUpdateTransform), this.renderingToScreen = !i, r.runners.prerender.emit(), r.emit("prerender"), r.projection.transform = o, !r.context.isLost) {
      if (i || (this.lastObjectRendered = t), !a) {
        const h = t.enableTempParent();
        t.updateTransform(), t.disableTempParent(h);
      }
      r.renderTexture.bind(i), r.batch.currentRenderer.start(), (s ?? r.background.clearBeforeRender) && r.renderTexture.clear(), t.render(r), r.batch.currentRenderer.flush(), i && (e.blit && r.framebuffer.blit(), i.baseTexture.update()), r.runners.postrender.emit(), r.projection.transform = null, r.emit("postrender");
    }
  }
  destroy() {
    this.renderer = null, this.lastObjectRendered = null;
  }
}
F0.extension = {
  type: st.RendererSystem,
  name: "objectRenderer"
};
dt.add(F0);
const Sa = class nc extends jw {
  /**
   * @param {PIXI.IRendererOptions} [options] - See {@link PIXI.settings.RENDER_OPTIONS} for defaults.
   */
  constructor(t) {
    super(), this.type = Ng.WEBGL, t = Object.assign({}, ht.RENDER_OPTIONS, t), this.gl = null, this.CONTEXT_UID = 0, this.globalUniforms = new mr({
      projectionMatrix: new Nt()
    }, !0);
    const e = {
      runners: [
        "init",
        "destroy",
        "contextChange",
        "resolutionChange",
        "reset",
        "update",
        "postrender",
        "prerender",
        "resize"
      ],
      systems: nc.__systems,
      priority: [
        "_view",
        "textureGenerator",
        "background",
        "_plugin",
        "startup",
        // low level WebGL systems
        "context",
        "state",
        "texture",
        "buffer",
        "geometry",
        "framebuffer",
        "transformFeedback",
        // high level pixi specific rendering
        "mask",
        "scissor",
        "stencil",
        "projection",
        "textureGC",
        "filter",
        "renderTexture",
        "batch",
        "objectRenderer",
        "_multisample"
      ]
    };
    this.setup(e), "useContextAlpha" in t && (wt("7.0.0", "options.useContextAlpha is deprecated, use options.premultipliedAlpha and options.backgroundAlpha instead"), t.premultipliedAlpha = t.useContextAlpha && t.useContextAlpha !== "notMultiplied", t.backgroundAlpha = t.useContextAlpha === !1 ? 1 : t.backgroundAlpha), this._plugin.rendererPlugins = nc.__plugins, this.options = t, this.startup.run(this.options);
  }
  /**
   * Create renderer if WebGL is available. Overrideable
   * by the **@pixi/canvas-renderer** package to allow fallback.
   * throws error if WebGL is not available.
   * @param options
   * @private
   */
  static test(t) {
    return t?.forceCanvas ? !1 : Ex();
  }
  /**
   * Renders the object to its WebGL view.
   * @param displayObject - The object to be rendered.
   * @param {object} [options] - Object to use for render options.
   * @param {PIXI.RenderTexture} [options.renderTexture] - The render texture to render to.
   * @param {boolean} [options.clear=true] - Should the canvas be cleared before the new render.
   * @param {PIXI.Matrix} [options.transform] - A transform to apply to the render texture before rendering.
   * @param {boolean} [options.skipUpdateTransform=false] - Should we skip the update transform pass?
   */
  render(t, e) {
    this.objectRenderer.render(t, e);
  }
  /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   */
  resize(t, e) {
    this._view.resizeView(t, e);
  }
  /**
   * Resets the WebGL state so you can render things however you fancy!
   * @returns Returns itself.
   */
  reset() {
    return this.runners.reset.emit(), this;
  }
  /** Clear the frame buffer. */
  clear() {
    this.renderTexture.bind(), this.renderTexture.clear();
  }
  /**
   * Removes everything from the renderer (event listeners, spritebatch, etc...)
   * @param [removeView=false] - Removes the Canvas element from the DOM.
   *  See: https://github.com/pixijs/pixijs/issues/2233
   */
  destroy(t = !1) {
    this.runners.destroy.items.reverse(), this.emitWithCustomOptions(this.runners.destroy, {
      _view: t
    }), super.destroy();
  }
  /** Collection of plugins */
  get plugins() {
    return this._plugin.plugins;
  }
  /** The number of msaa samples of the canvas. */
  get multisample() {
    return this._multisample.multisample;
  }
  /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @member {number}
   * @readonly
   * @default 800
   */
  get width() {
    return this._view.element.width;
  }
  /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */
  get height() {
    return this._view.element.height;
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this._view.resolution;
  }
  set resolution(t) {
    this._view.resolution = t, this.runners.resolutionChange.emit(t);
  }
  /** Whether CSS dimensions of canvas view should be resized to screen dimensions automatically. */
  get autoDensity() {
    return this._view.autoDensity;
  }
  /** The canvas element that everything is drawn to.*/
  get view() {
    return this._view.element;
  }
  /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   * @member {PIXI.Rectangle}
   */
  get screen() {
    return this._view.screen;
  }
  /** the last object rendered by the renderer. Useful for other plugins like interaction managers */
  get lastObjectRendered() {
    return this.objectRenderer.lastObjectRendered;
  }
  /** Flag if we are rendering to the screen vs renderTexture */
  get renderingToScreen() {
    return this.objectRenderer.renderingToScreen;
  }
  /** When logging Pixi to the console, this is the name we will show */
  get rendererLogId() {
    return `WebGL ${this.context.webGLVersion}`;
  }
  /**
   * This sets weather the screen is totally cleared between each frame withthe background color and alpha
   * @deprecated since 7.0.0
   */
  get clearBeforeRender() {
    return wt("7.0.0", "renderer.clearBeforeRender has been deprecated, please use renderer.background.clearBeforeRender instead."), this.background.clearBeforeRender;
  }
  /**
   * Pass-thru setting for the canvas' context `alpha` property. This is typically
   * not something you need to fiddle with. If you want transparency, use `backgroundAlpha`.
   * @deprecated since 7.0.0
   * @member {boolean}
   */
  get useContextAlpha() {
    return wt("7.0.0", "renderer.useContextAlpha has been deprecated, please use renderer.context.premultipliedAlpha instead."), this.context.useContextAlpha;
  }
  /**
   * readonly drawing buffer preservation
   * we can only know this if Pixi created the context
   * @deprecated since 7.0.0
   */
  get preserveDrawingBuffer() {
    return wt("7.0.0", "renderer.preserveDrawingBuffer has been deprecated, we cannot truly know this unless pixi created the context"), this.context.preserveDrawingBuffer;
  }
  /**
   * The background color to fill if not transparent
   * @member {number}
   * @deprecated since 7.0.0
   */
  get backgroundColor() {
    return wt("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead."), this.background.color;
  }
  set backgroundColor(t) {
    wt("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead."), this.background.color = t;
  }
  /**
   * The background color alpha. Setting this to 0 will make the canvas transparent.
   * @member {number}
   * @deprecated since 7.0.0
   */
  get backgroundAlpha() {
    return wt("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead."), this.background.alpha;
  }
  /**
   * @deprecated since 7.0.0
   */
  set backgroundAlpha(t) {
    wt("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead."), this.background.alpha = t;
  }
  /**
   * @deprecated since 7.0.0
   */
  get powerPreference() {
    return wt("7.0.0", "renderer.powerPreference has been deprecated, we can only know this if pixi creates the context"), this.context.powerPreference;
  }
  /**
   * Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
   * @param displayObject - The displayObject the object will be generated from.
   * @param {IGenerateTextureOptions} options - Generate texture options.
   * @param {PIXI.Rectangle} options.region - The region of the displayObject, that shall be rendered,
   *        if no region is specified, defaults to the local bounds of the displayObject.
   * @param {number} [options.resolution] - If not given, the renderer's resolution is used.
   * @param {PIXI.MSAA_QUALITY} [options.multisample] - If not given, the renderer's multisample is used.
   * @returns A texture of the graphics object.
   */
  generateTexture(t, e) {
    return this.textureGenerator.generateTexture(t, e);
  }
};
Sa.extension = {
  type: st.Renderer,
  priority: 1
}, /**
* Collection of installed plugins. These are included by default in PIXI, but can be excluded
* by creating a custom build. Consult the README for more information about creating custom
* builds and excluding plugins.
* @private
*/
Sa.__plugins = {}, /**
* The collection of installed systems.
* @private
*/
Sa.__systems = {};
let ld = Sa;
dt.handleByMap(st.RendererPlugin, ld.__plugins);
dt.handleByMap(st.RendererSystem, ld.__systems);
dt.add(ld);
class O0 extends fo {
  /**
   * @param length
   * @param options - Options to for Resource constructor
   * @param {number} [options.width] - Width of the resource
   * @param {number} [options.height] - Height of the resource
   */
  constructor(t, e) {
    const { width: r, height: i } = e || {};
    super(r, i), this.items = [], this.itemDirtyIds = [];
    for (let s = 0; s < t; s++) {
      const o = new _t();
      this.items.push(o), this.itemDirtyIds.push(-2);
    }
    this.length = t, this._load = null, this.baseTexture = null;
  }
  /**
   * Used from ArrayResource and CubeResource constructors.
   * @param resources - Can be resources, image elements, canvas, etc. ,
   *  length should be same as constructor length
   * @param options - Detect options for resources
   */
  initFromArray(t, e) {
    for (let r = 0; r < this.length; r++)
      t[r] && (t[r].castToBaseTexture ? this.addBaseTextureAt(t[r].castToBaseTexture(), r) : t[r] instanceof fo ? this.addResourceAt(t[r], r) : this.addResourceAt(Qg(t[r], e), r));
  }
  /** Destroy this BaseImageResource. */
  dispose() {
    for (let t = 0, e = this.length; t < e; t++)
      this.items[t].destroy();
    this.items = null, this.itemDirtyIds = null, this._load = null;
  }
  /**
   * Set a resource by ID
   * @param resource
   * @param index - Zero-based index of resource to set
   * @returns - Instance for chaining
   */
  addResourceAt(t, e) {
    if (!this.items[e])
      throw new Error(`Index ${e} is out of bounds`);
    return t.valid && !this.valid && this.resize(t.width, t.height), this.items[e].setResource(t), this;
  }
  /**
   * Set the parent base texture.
   * @param baseTexture
   */
  bind(t) {
    if (this.baseTexture !== null)
      throw new Error("Only one base texture per TextureArray is allowed");
    super.bind(t);
    for (let e = 0; e < this.length; e++)
      this.items[e].parentTextureArray = t, this.items[e].on("update", t.update, t);
  }
  /**
   * Unset the parent base texture.
   * @param baseTexture
   */
  unbind(t) {
    super.unbind(t);
    for (let e = 0; e < this.length; e++)
      this.items[e].parentTextureArray = null, this.items[e].off("update", t.update, t);
  }
  /**
   * Load all the resources simultaneously
   * @returns - When load is resolved
   */
  load() {
    if (this._load)
      return this._load;
    const t = this.items.map((e) => e.resource).filter((e) => e).map((e) => e.load());
    return this._load = Promise.all(t).then(
      () => {
        const { realWidth: e, realHeight: r } = this.items[0];
        return this.resize(e, r), this.update(), Promise.resolve(this);
      }
    ), this._load;
  }
}
class rb extends O0 {
  /**
   * @param source - Number of items in array or the collection
   *        of image URLs to use. Can also be resources, image elements, canvas, etc.
   * @param options - Options to apply to {@link PIXI.autoDetectResource}
   * @param {number} [options.width] - Width of the resource
   * @param {number} [options.height] - Height of the resource
   */
  constructor(t, e) {
    const { width: r, height: i } = e || {};
    let s, o;
    Array.isArray(t) ? (s = t, o = t.length) : o = t, super(o, { width: r, height: i }), s && this.initFromArray(s, e);
  }
  /**
   * Set a baseTexture by ID,
   * ArrayResource just takes resource from it, nothing more
   * @param baseTexture
   * @param index - Zero-based index of resource to set
   * @returns - Instance for chaining
   */
  addBaseTextureAt(t, e) {
    if (t.resource)
      this.addResourceAt(t.resource, e);
    else
      throw new Error("ArrayResource does not support RenderTexture");
    return this;
  }
  /**
   * Add binding
   * @param baseTexture
   */
  bind(t) {
    super.bind(t), t.target = ts.TEXTURE_2D_ARRAY;
  }
  /**
   * Upload the resources to the GPU.
   * @param renderer
   * @param texture
   * @param glTexture
   * @returns - whether texture was uploaded
   */
  upload(t, e, r) {
    const { length: i, itemDirtyIds: s, items: o } = this, { gl: a } = t;
    r.dirtyId < 0 && a.texImage3D(
      a.TEXTURE_2D_ARRAY,
      0,
      r.internalFormat,
      this._width,
      this._height,
      i,
      0,
      e.format,
      r.type,
      null
    );
    for (let h = 0; h < i; h++) {
      const l = o[h];
      s[h] < l.dirtyId && (s[h] = l.dirtyId, l.valid && a.texSubImage3D(
        a.TEXTURE_2D_ARRAY,
        0,
        0,
        // xoffset
        0,
        // yoffset
        h,
        // zoffset
        l.resource.width,
        l.resource.height,
        1,
        e.format,
        r.type,
        l.resource.source
      ));
    }
    return !0;
  }
}
class nb extends Ln {
  /**
   * @param source - Canvas element to use
   */
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(t) {
    super(t);
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if source is HTMLCanvasElement or OffscreenCanvas
   */
  static test(t) {
    const { OffscreenCanvas: e } = globalThis;
    return e && t instanceof e ? !0 : globalThis.HTMLCanvasElement && t instanceof HTMLCanvasElement;
  }
}
const N0 = class Zs extends O0 {
  /**
   * @param {Array<string|PIXI.Resource>} [source] - Collection of URLs or resources
   *        to use as the sides of the cube.
   * @param options - ImageResource options
   * @param {number} [options.width] - Width of resource
   * @param {number} [options.height] - Height of resource
   * @param {number} [options.autoLoad=true] - Whether to auto-load resources
   * @param {number} [options.linkBaseTexture=true] - In case BaseTextures are supplied,
   *   whether to copy them or use
   */
  constructor(t, e) {
    const { width: r, height: i, autoLoad: s, linkBaseTexture: o } = e || {};
    if (t && t.length !== Zs.SIDES)
      throw new Error(`Invalid length. Got ${t.length}, expected 6`);
    super(6, { width: r, height: i });
    for (let a = 0; a < Zs.SIDES; a++)
      this.items[a].target = ts.TEXTURE_CUBE_MAP_POSITIVE_X + a;
    this.linkBaseTexture = o !== !1, t && this.initFromArray(t, e), s !== !1 && this.load();
  }
  /**
   * Add binding.
   * @param baseTexture - parent base texture
   */
  bind(t) {
    super.bind(t), t.target = ts.TEXTURE_CUBE_MAP;
  }
  addBaseTextureAt(t, e, r) {
    if (r === void 0 && (r = this.linkBaseTexture), !this.items[e])
      throw new Error(`Index ${e} is out of bounds`);
    if (!this.linkBaseTexture || t.parentTextureArray || Object.keys(t._glTextures).length > 0)
      if (t.resource)
        this.addResourceAt(t.resource, e);
      else
        throw new Error("CubeResource does not support copying of renderTexture.");
    else
      t.target = ts.TEXTURE_CUBE_MAP_POSITIVE_X + e, t.parentTextureArray = this.baseTexture, this.items[e] = t;
    return t.valid && !this.valid && this.resize(t.realWidth, t.realHeight), this.items[e] = t, this;
  }
  /**
   * Upload the resource
   * @param renderer
   * @param _baseTexture
   * @param glTexture
   * @returns {boolean} true is success
   */
  upload(t, e, r) {
    const i = this.itemDirtyIds;
    for (let s = 0; s < Zs.SIDES; s++) {
      const o = this.items[s];
      (i[s] < o.dirtyId || r.dirtyId < e.dirtyId) && (o.valid && o.resource ? (o.resource.upload(t, o, r), i[s] = o.dirtyId) : i[s] < -1 && (t.gl.texImage2D(
        o.target,
        0,
        r.internalFormat,
        e.realWidth,
        e.realHeight,
        0,
        e.format,
        r.type,
        null
      ), i[s] = -1));
    }
    return !0;
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if source is an array of 6 elements
   */
  static test(t) {
    return Array.isArray(t) && t.length === Zs.SIDES;
  }
};
N0.SIDES = 6;
let ib = N0;
class qi extends Ln {
  /**
   * @param source - ImageBitmap or URL to use.
   * @param options - Options to use.
   */
  constructor(t, e) {
    e = e || {};
    let r, i, s;
    typeof t == "string" ? (r = qi.EMPTY, i = t, s = !0) : (r = t, i = null, s = !1), super(r), this.url = i, this.crossOrigin = e.crossOrigin ?? !0, this.alphaMode = typeof e.alphaMode == "number" ? e.alphaMode : null, this.ownsImageBitmap = e.ownsImageBitmap ?? s, this._load = null, e.autoLoad !== !1 && this.load();
  }
  load() {
    return this._load ? this._load : (this._load = new Promise(async (t, e) => {
      if (this.url === null) {
        t(this);
        return;
      }
      try {
        const r = await ht.ADAPTER.fetch(this.url, {
          mode: this.crossOrigin ? "cors" : "no-cors"
        });
        if (this.destroyed)
          return;
        const i = await r.blob();
        if (this.destroyed)
          return;
        const s = await createImageBitmap(i, {
          premultiplyAlpha: this.alphaMode === null || this.alphaMode === Ae.UNPACK ? "premultiply" : "none"
        });
        if (this.destroyed) {
          s.close();
          return;
        }
        this.source = s, this.update(), t(this);
      } catch (r) {
        if (this.destroyed)
          return;
        e(r), this.onError.emit(r);
      }
    }), this._load);
  }
  /**
   * Upload the image bitmap resource to GPU.
   * @param renderer - Renderer to upload to
   * @param baseTexture - BaseTexture for this resource
   * @param glTexture - GLTexture to use
   * @returns {boolean} true is success
   */
  upload(t, e, r) {
    return this.source instanceof ImageBitmap ? (typeof this.alphaMode == "number" && (e.alphaMode = this.alphaMode), super.upload(t, e, r)) : (this.load(), !1);
  }
  /** Destroys this resource. */
  dispose() {
    this.ownsImageBitmap && this.source instanceof ImageBitmap && this.source.close(), super.dispose(), this._load = null;
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if current environment support ImageBitmap, and source is string or ImageBitmap
   */
  static test(t) {
    return !!globalThis.createImageBitmap && typeof ImageBitmap < "u" && (typeof t == "string" || t instanceof ImageBitmap);
  }
  /**
   * ImageBitmap cannot be created synchronously, so a empty placeholder canvas is needed when loading from URLs.
   * Only for internal usage.
   * @returns The cached placeholder canvas.
   */
  static get EMPTY() {
    return qi._EMPTY = qi._EMPTY ?? ht.ADAPTER.createCanvas(0, 0), qi._EMPTY;
  }
}
const ic = class Ca extends Ln {
  /**
   * @param sourceBase64 - Base64 encoded SVG element or URL for SVG file.
   * @param {object} [options] - Options to use
   * @param {number} [options.scale=1] - Scale to apply to SVG. Overridden by...
   * @param {number} [options.width] - Rasterize SVG this wide. Aspect ratio preserved if height not specified.
   * @param {number} [options.height] - Rasterize SVG this high. Aspect ratio preserved if width not specified.
   * @param {boolean} [options.autoLoad=true] - Start loading right away.
   */
  constructor(t, e) {
    e = e || {}, super(ht.ADAPTER.createCanvas()), this._width = 0, this._height = 0, this.svg = t, this.scale = e.scale || 1, this._overrideWidth = e.width, this._overrideHeight = e.height, this._resolve = null, this._crossorigin = e.crossorigin, this._load = null, e.autoLoad !== !1 && this.load();
  }
  load() {
    return this._load ? this._load : (this._load = new Promise((t) => {
      if (this._resolve = () => {
        this.update(), t(this);
      }, Ca.SVG_XML.test(this.svg.trim())) {
        if (!btoa)
          throw new Error("Your browser doesn't support base64 conversions.");
        this.svg = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(this.svg)))}`;
      }
      this._loadSvg();
    }), this._load);
  }
  /** Loads an SVG image from `imageUrl` or `data URL`. */
  _loadSvg() {
    const t = new Image();
    Ln.crossOrigin(t, this.svg, this._crossorigin), t.src = this.svg, t.onerror = (e) => {
      this._resolve && (t.onerror = null, this.onError.emit(e));
    }, t.onload = () => {
      if (!this._resolve)
        return;
      const e = t.width, r = t.height;
      if (!e || !r)
        throw new Error("The SVG image must have width and height defined (in pixels), canvas API needs them.");
      let i = e * this.scale, s = r * this.scale;
      (this._overrideWidth || this._overrideHeight) && (i = this._overrideWidth || this._overrideHeight / r * e, s = this._overrideHeight || this._overrideWidth / e * r), i = Math.round(i), s = Math.round(s);
      const o = this.source;
      o.width = i, o.height = s, o._pixiId = `canvas_${Ti()}`, o.getContext("2d").drawImage(t, 0, 0, e, r, 0, 0, i, s), this._resolve(), this._resolve = null;
    };
  }
  /**
   * Get size from an svg string using a regular expression.
   * @param svgString - a serialized svg element
   * @returns - image extension
   */
  static getSize(t) {
    const e = Ca.SVG_SIZE.exec(t), r = {};
    return e && (r[e[1]] = Math.round(parseFloat(e[3])), r[e[5]] = Math.round(parseFloat(e[7]))), r;
  }
  /** Destroys this texture. */
  dispose() {
    super.dispose(), this._resolve = null, this._crossorigin = null;
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @param {string} extension - The extension of source, if set
   * @returns {boolean} - If the source is a SVG source or data file
   */
  static test(t, e) {
    return e === "svg" || typeof t == "string" && t.startsWith("data:image/svg+xml") || typeof t == "string" && Ca.SVG_XML.test(t);
  }
  // eslint-disable-line max-len
};
ic.SVG_XML = /^(<\?xml[^?]+\?>)?\s*(<!--[^(-->)]*-->)?\s*\<svg/m, /**
* Regular expression for SVG size.
* @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
* @readonly
*/
ic.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i;
let sc = ic;
const oc = class ac extends Ln {
  /**
   * @param {HTMLVideoElement|object|string|Array<string|object>} source - Video element to use.
   * @param {object} [options] - Options to use
   * @param {boolean} [options.autoLoad=true] - Start loading the video immediately
   * @param {boolean} [options.autoPlay=true] - Start playing video immediately
   * @param {number} [options.updateFPS=0] - How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * @param {boolean} [options.crossorigin=true] - Load image using cross origin
   * @param {boolean} [options.loop=false] - Loops the video
   * @param {boolean} [options.muted=false] - Mutes the video audio, useful for autoplay
   * @param {boolean} [options.playsinline=true] - Prevents opening the video on mobile devices
   */
  constructor(t, e) {
    if (e = e || {}, !(t instanceof HTMLVideoElement)) {
      const r = document.createElement("video");
      e.autoLoad !== !1 && r.setAttribute("preload", "auto"), e.playsinline !== !1 && (r.setAttribute("webkit-playsinline", ""), r.setAttribute("playsinline", "")), e.muted === !0 && (r.setAttribute("muted", ""), r.muted = !0), e.loop === !0 && r.setAttribute("loop", ""), e.autoPlay !== !1 && r.setAttribute("autoplay", ""), typeof t == "string" && (t = [t]);
      const i = t[0].src || t[0];
      Ln.crossOrigin(r, i, e.crossorigin);
      for (let s = 0; s < t.length; ++s) {
        const o = document.createElement("source");
        let { src: a, mime: h } = t[s];
        if (a = a || t[s], a.startsWith("data:"))
          h = a.slice(5, a.indexOf(";"));
        else if (!a.startsWith("blob:")) {
          const l = a.split("?").shift().toLowerCase(), u = l.slice(l.lastIndexOf(".") + 1);
          h = h || ac.MIME_TYPES[u] || `video/${u}`;
        }
        o.src = a, h && (o.type = h), r.appendChild(o);
      }
      t = r;
    }
    super(t), this.noSubImage = !0, this._autoUpdate = !0, this._isConnectedToTicker = !1, this._updateFPS = e.updateFPS || 0, this._msToNextUpdate = 0, this.autoPlay = e.autoPlay !== !1, this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this), this._videoFrameRequestCallbackHandle = null, this._load = null, this._resolve = null, this._reject = null, this._onCanPlay = this._onCanPlay.bind(this), this._onError = this._onError.bind(this), this._onPlayStart = this._onPlayStart.bind(this), this._onPlayStop = this._onPlayStop.bind(this), this._onSeeked = this._onSeeked.bind(this), e.autoLoad !== !1 && this.load();
  }
  /**
   * Trigger updating of the texture.
   * @param _deltaTime - time delta since last tick
   */
  update(t = 0) {
    if (!this.destroyed) {
      if (this._updateFPS) {
        const e = xe.shared.elapsedMS * this.source.playbackRate;
        this._msToNextUpdate = Math.floor(this._msToNextUpdate - e);
      }
      (!this._updateFPS || this._msToNextUpdate <= 0) && (super.update(
        /* deltaTime*/
      ), this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0);
    }
  }
  _videoFrameRequestCallback() {
    this.update(), this.destroyed ? this._videoFrameRequestCallbackHandle = null : this._videoFrameRequestCallbackHandle = this.source.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    );
  }
  /**
   * Start preloading the video resource.
   * @returns {Promise<void>} Handle the validate event
   */
  load() {
    if (this._load)
      return this._load;
    const t = this.source;
    return (t.readyState === t.HAVE_ENOUGH_DATA || t.readyState === t.HAVE_FUTURE_DATA) && t.width && t.height && (t.complete = !0), t.addEventListener("play", this._onPlayStart), t.addEventListener("pause", this._onPlayStop), t.addEventListener("seeked", this._onSeeked), this._isSourceReady() ? this._onCanPlay() : (t.addEventListener("canplay", this._onCanPlay), t.addEventListener("canplaythrough", this._onCanPlay), t.addEventListener("error", this._onError, !0)), this._load = new Promise((e, r) => {
      this.valid ? e(this) : (this._resolve = e, this._reject = r, t.load());
    }), this._load;
  }
  /**
   * Handle video error events.
   * @param event
   */
  _onError(t) {
    this.source.removeEventListener("error", this._onError, !0), this.onError.emit(t), this._reject && (this._reject(t), this._reject = null, this._resolve = null);
  }
  /**
   * Returns true if the underlying source is playing.
   * @returns - True if playing.
   */
  _isSourcePlaying() {
    const t = this.source;
    return !t.paused && !t.ended;
  }
  /**
   * Returns true if the underlying source is ready for playing.
   * @returns - True if ready.
   */
  _isSourceReady() {
    return this.source.readyState > 2;
  }
  /** Runs the update loop when the video is ready to play. */
  _onPlayStart() {
    this.valid || this._onCanPlay(), this._configureAutoUpdate();
  }
  /** Fired when a pause event is triggered, stops the update loop. */
  _onPlayStop() {
    this._configureAutoUpdate();
  }
  /** Fired when the video is completed seeking to the current playback position. */
  _onSeeked() {
    this._autoUpdate && !this._isSourcePlaying() && (this._msToNextUpdate = 0, this.update(), this._msToNextUpdate = 0);
  }
  /** Fired when the video is loaded and ready to play. */
  _onCanPlay() {
    const t = this.source;
    t.removeEventListener("canplay", this._onCanPlay), t.removeEventListener("canplaythrough", this._onCanPlay);
    const e = this.valid;
    this._msToNextUpdate = 0, this.update(), this._msToNextUpdate = 0, !e && this._resolve && (this._resolve(this), this._resolve = null, this._reject = null), this._isSourcePlaying() ? this._onPlayStart() : this.autoPlay && t.play();
  }
  /** Destroys this texture. */
  dispose() {
    this._configureAutoUpdate();
    const t = this.source;
    t && (t.removeEventListener("play", this._onPlayStart), t.removeEventListener("pause", this._onPlayStop), t.removeEventListener("seeked", this._onSeeked), t.removeEventListener("canplay", this._onCanPlay), t.removeEventListener("canplaythrough", this._onCanPlay), t.removeEventListener("error", this._onError, !0), t.pause(), t.src = "", t.load()), super.dispose();
  }
  /** Should the base texture automatically update itself, set to true by default. */
  get autoUpdate() {
    return this._autoUpdate;
  }
  set autoUpdate(t) {
    t !== this._autoUpdate && (this._autoUpdate = t, this._configureAutoUpdate());
  }
  /**
   * How many times a second to update the texture from the video. Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */
  get updateFPS() {
    return this._updateFPS;
  }
  set updateFPS(t) {
    t !== this._updateFPS && (this._updateFPS = t, this._configureAutoUpdate());
  }
  _configureAutoUpdate() {
    this._autoUpdate && this._isSourcePlaying() ? !this._updateFPS && this.source.requestVideoFrameCallback ? (this._isConnectedToTicker && (xe.shared.remove(this.update, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0), this._videoFrameRequestCallbackHandle === null && (this._videoFrameRequestCallbackHandle = this.source.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    ))) : (this._videoFrameRequestCallbackHandle !== null && (this.source.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker || (xe.shared.add(this.update, this), this._isConnectedToTicker = !0, this._msToNextUpdate = 0)) : (this._videoFrameRequestCallbackHandle !== null && (this.source.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker && (xe.shared.remove(this.update, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0));
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @param {string} extension - The extension of source, if set
   * @returns {boolean} `true` if video source
   */
  static test(t, e) {
    return globalThis.HTMLVideoElement && t instanceof HTMLVideoElement || ac.TYPES.includes(e);
  }
};
oc.TYPES = ["mp4", "m4v", "webm", "ogg", "ogv", "h264", "avi", "mov"], /**
* Map of video MIME types that can't be directly derived from file extensions.
* @readonly
*/
oc.MIME_TYPES = {
  ogv: "video/ogg",
  mov: "video/quicktime",
  m4v: "video/mp4"
};
let k0 = oc;
Vu.push(
  qi,
  a0,
  nb,
  k0,
  sc,
  Ch,
  ib,
  rb
);
class Za {
  constructor() {
    this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.rect = null, this.updateID = -1;
  }
  /**
   * Checks if bounds are empty.
   * @returns - True if empty.
   */
  isEmpty() {
    return this.minX > this.maxX || this.minY > this.maxY;
  }
  /** Clears the bounds and resets. */
  clear() {
    this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0;
  }
  /**
   * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
   * It is not guaranteed that it will return tempRect
   * @param rect - Temporary object will be used if AABB is not empty
   * @returns - A rectangle of the bounds
   */
  getRectangle(t) {
    return this.minX > this.maxX || this.minY > this.maxY ? yt.EMPTY : (t = t || new yt(0, 0, 1, 1), t.x = this.minX, t.y = this.minY, t.width = this.maxX - this.minX, t.height = this.maxY - this.minY, t);
  }
  /**
   * This function should be inlined when its possible.
   * @param point - The point to add.
   */
  addPoint(t) {
    this.minX = Math.min(this.minX, t.x), this.maxX = Math.max(this.maxX, t.x), this.minY = Math.min(this.minY, t.y), this.maxY = Math.max(this.maxY, t.y);
  }
  /**
   * Adds a point, after transformed. This should be inlined when its possible.
   * @param matrix
   * @param point
   */
  addPointMatrix(t, e) {
    const { a: r, b: i, c: s, d: o, tx: a, ty: h } = t, l = r * e.x + s * e.y + a, u = i * e.x + o * e.y + h;
    this.minX = Math.min(this.minX, l), this.maxX = Math.max(this.maxX, l), this.minY = Math.min(this.minY, u), this.maxY = Math.max(this.maxY, u);
  }
  /**
   * Adds a quad, not transformed
   * @param vertices - The verts to add.
   */
  addQuad(t) {
    let e = this.minX, r = this.minY, i = this.maxX, s = this.maxY, o = t[0], a = t[1];
    e = o < e ? o : e, r = a < r ? a : r, i = o > i ? o : i, s = a > s ? a : s, o = t[2], a = t[3], e = o < e ? o : e, r = a < r ? a : r, i = o > i ? o : i, s = a > s ? a : s, o = t[4], a = t[5], e = o < e ? o : e, r = a < r ? a : r, i = o > i ? o : i, s = a > s ? a : s, o = t[6], a = t[7], e = o < e ? o : e, r = a < r ? a : r, i = o > i ? o : i, s = a > s ? a : s, this.minX = e, this.minY = r, this.maxX = i, this.maxY = s;
  }
  /**
   * Adds sprite frame, transformed.
   * @param transform - transform to apply
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */
  addFrame(t, e, r, i, s) {
    this.addFrameMatrix(t.worldTransform, e, r, i, s);
  }
  /**
   * Adds sprite frame, multiplied by matrix
   * @param matrix - matrix to apply
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */
  addFrameMatrix(t, e, r, i, s) {
    const o = t.a, a = t.b, h = t.c, l = t.d, u = t.tx, c = t.ty;
    let d = this.minX, f = this.minY, p = this.maxX, m = this.maxY, g = o * e + h * r + u, _ = a * e + l * r + c;
    d = g < d ? g : d, f = _ < f ? _ : f, p = g > p ? g : p, m = _ > m ? _ : m, g = o * i + h * r + u, _ = a * i + l * r + c, d = g < d ? g : d, f = _ < f ? _ : f, p = g > p ? g : p, m = _ > m ? _ : m, g = o * e + h * s + u, _ = a * e + l * s + c, d = g < d ? g : d, f = _ < f ? _ : f, p = g > p ? g : p, m = _ > m ? _ : m, g = o * i + h * s + u, _ = a * i + l * s + c, d = g < d ? g : d, f = _ < f ? _ : f, p = g > p ? g : p, m = _ > m ? _ : m, this.minX = d, this.minY = f, this.maxX = p, this.maxY = m;
  }
  /**
   * Adds screen vertices from array
   * @param vertexData - calculated vertices
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   */
  addVertexData(t, e, r) {
    let i = this.minX, s = this.minY, o = this.maxX, a = this.maxY;
    for (let h = e; h < r; h += 2) {
      const l = t[h], u = t[h + 1];
      i = l < i ? l : i, s = u < s ? u : s, o = l > o ? l : o, a = u > a ? u : a;
    }
    this.minX = i, this.minY = s, this.maxX = o, this.maxY = a;
  }
  /**
   * Add an array of mesh vertices
   * @param transform - mesh transform
   * @param vertices - mesh coordinates in array
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   */
  addVertices(t, e, r, i) {
    this.addVerticesMatrix(t.worldTransform, e, r, i);
  }
  /**
   * Add an array of mesh vertices.
   * @param matrix - mesh matrix
   * @param vertices - mesh coordinates in array
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   * @param padX - x padding
   * @param padY - y padding
   */
  addVerticesMatrix(t, e, r, i, s = 0, o = s) {
    const a = t.a, h = t.b, l = t.c, u = t.d, c = t.tx, d = t.ty;
    let f = this.minX, p = this.minY, m = this.maxX, g = this.maxY;
    for (let _ = r; _ < i; _ += 2) {
      const w = e[_], v = e[_ + 1], E = a * w + l * v + c, x = u * v + h * w + d;
      f = Math.min(f, E - s), m = Math.max(m, E + s), p = Math.min(p, x - o), g = Math.max(g, x + o);
    }
    this.minX = f, this.minY = p, this.maxX = m, this.maxY = g;
  }
  /**
   * Adds other {@link PIXI.Bounds}.
   * @param bounds - The Bounds to be added
   */
  addBounds(t) {
    const e = this.minX, r = this.minY, i = this.maxX, s = this.maxY;
    this.minX = t.minX < e ? t.minX : e, this.minY = t.minY < r ? t.minY : r, this.maxX = t.maxX > i ? t.maxX : i, this.maxY = t.maxY > s ? t.maxY : s;
  }
  /**
   * Adds other Bounds, masked with Bounds.
   * @param bounds - The Bounds to be added.
   * @param mask - TODO
   */
  addBoundsMask(t, e) {
    const r = t.minX > e.minX ? t.minX : e.minX, i = t.minY > e.minY ? t.minY : e.minY, s = t.maxX < e.maxX ? t.maxX : e.maxX, o = t.maxY < e.maxY ? t.maxY : e.maxY;
    if (r <= s && i <= o) {
      const a = this.minX, h = this.minY, l = this.maxX, u = this.maxY;
      this.minX = r < a ? r : a, this.minY = i < h ? i : h, this.maxX = s > l ? s : l, this.maxY = o > u ? o : u;
    }
  }
  /**
   * Adds other Bounds, multiplied by matrix. Bounds shouldn't be empty.
   * @param bounds - other bounds
   * @param matrix - multiplicator
   */
  addBoundsMatrix(t, e) {
    this.addFrameMatrix(e, t.minX, t.minY, t.maxX, t.maxY);
  }
  /**
   * Adds other Bounds, masked with Rectangle.
   * @param bounds - TODO
   * @param area - TODO
   */
  addBoundsArea(t, e) {
    const r = t.minX > e.x ? t.minX : e.x, i = t.minY > e.y ? t.minY : e.y, s = t.maxX < e.x + e.width ? t.maxX : e.x + e.width, o = t.maxY < e.y + e.height ? t.maxY : e.y + e.height;
    if (r <= s && i <= o) {
      const a = this.minX, h = this.minY, l = this.maxX, u = this.maxY;
      this.minX = r < a ? r : a, this.minY = i < h ? i : h, this.maxX = s > l ? s : l, this.maxY = o > u ? o : u;
    }
  }
  /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   */
  pad(t = 0, e = t) {
    this.isEmpty() || (this.minX -= t, this.maxX += t, this.minY -= e, this.maxY += e);
  }
  /**
   * Adds padded frame. (x0, y0) should be strictly less than (x1, y1)
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   * @param padX - padding X
   * @param padY - padding Y
   */
  addFramePad(t, e, r, i, s, o) {
    t -= s, e -= o, r += s, i += o, this.minX = this.minX < t ? this.minX : t, this.maxX = this.maxX > r ? this.maxX : r, this.minY = this.minY < e ? this.minY : e, this.maxY = this.maxY > i ? this.maxY : i;
  }
}
class zt extends Co {
  constructor() {
    super(), this.tempDisplayObjectParent = null, this.transform = new ad(), this.alpha = 1, this.visible = !0, this.renderable = !0, this.cullable = !1, this.cullArea = null, this.parent = null, this.worldAlpha = 1, this._lastSortedIndex = 0, this._zIndex = 0, this.filterArea = null, this.filters = null, this._enabledFilters = null, this._bounds = new Za(), this._localBounds = null, this._boundsID = 0, this._boundsRect = null, this._localBoundsRect = null, this._mask = null, this._maskRefCount = 0, this._destroyed = !1, this.isSprite = !1, this.isMask = !1;
  }
  /**
   * Mixes all enumerable properties and methods from a source object to DisplayObject.
   * @param source - The source of properties and methods to mix in.
   */
  static mixin(t) {
    const e = Object.keys(t);
    for (let r = 0; r < e.length; ++r) {
      const i = e[r];
      Object.defineProperty(
        zt.prototype,
        i,
        Object.getOwnPropertyDescriptor(t, i)
      );
    }
  }
  /**
   * Fired when this DisplayObject is added to a Container.
   * @instance
   * @event added
   * @param {PIXI.Container} container - The container added to.
   */
  /**
   * Fired when this DisplayObject is removed from a Container.
   * @instance
   * @event removed
   * @param {PIXI.Container} container - The container removed from.
   */
  /**
   * Fired when this DisplayObject is destroyed. This event is emitted once
   * destroy is finished.
   * @instance
   * @event destroyed
   */
  /** Readonly flag for destroyed display objects. */
  get destroyed() {
    return this._destroyed;
  }
  /** Recursively updates transform of all objects from the root to this one internal function for toLocal() */
  _recursivePostUpdateTransform() {
    this.parent ? (this.parent._recursivePostUpdateTransform(), this.transform.updateTransform(this.parent.transform)) : this.transform.updateTransform(this._tempDisplayObjectParent.transform);
  }
  /** Updates the object transform for rendering. TODO - Optimization pass! */
  updateTransform() {
    this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
  }
  /**
   * Calculates and returns the (world) bounds of the display object as a [Rectangle]{@link PIXI.Rectangle}.
   *
   * This method is expensive on containers with a large subtree (like the stage). This is because the bounds
   * of a container depend on its children's bounds, which recursively causes all bounds in the subtree to
   * be recalculated. The upside, however, is that calling `getBounds` once on a container will indeed update
   * the bounds of all children (the whole subtree, in fact). This side effect should be exploited by using
   * `displayObject._bounds.getRectangle()` when traversing through all the bounds in a scene graph. Otherwise,
   * calling `getBounds` on each object in a subtree will cause the total cost to increase quadratically as
   * its height increases.
   *
   * The transforms of all objects in a container's **subtree** and of all **ancestors** are updated.
   * The world bounds of all display objects in a container's **subtree** will also be recalculated.
   *
   * The `_bounds` object stores the last calculation of the bounds. You can use to entirely skip bounds
   * calculation if needed.
   *
   * ```js
   * const lastCalculatedBounds = displayObject._bounds.getRectangle(optionalRect);
   * ```
   *
   * Do know that usage of `getLocalBounds` can corrupt the `_bounds` of children (the whole subtree, actually). This
   * is a known issue that has not been solved. See [getLocalBounds]{@link PIXI.DisplayObject#getLocalBounds} for more
   * details.
   *
   * `getBounds` should be called with `skipUpdate` equal to `true` in a render() call. This is because the transforms
   * are guaranteed to be update-to-date. In fact, recalculating inside a render() call may cause corruption in certain
   * cases.
   * @param skipUpdate - Setting to `true` will stop the transforms of the scene graph from
   *  being updated. This means the calculation returned MAY be out of date BUT will give you a
   *  nice performance boost.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @returns - The minimum axis-aligned rectangle in world space that fits around this object.
   */
  getBounds(t, e) {
    return t || (this.parent ? (this._recursivePostUpdateTransform(), this.updateTransform()) : (this.parent = this._tempDisplayObjectParent, this.updateTransform(), this.parent = null)), this._bounds.updateID !== this._boundsID && (this.calculateBounds(), this._bounds.updateID = this._boundsID), e || (this._boundsRect || (this._boundsRect = new yt()), e = this._boundsRect), this._bounds.getRectangle(e);
  }
  /**
   * Retrieves the local bounds of the displayObject as a rectangle object.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @returns - The rectangular bounding area.
   */
  getLocalBounds(t) {
    t || (this._localBoundsRect || (this._localBoundsRect = new yt()), t = this._localBoundsRect), this._localBounds || (this._localBounds = new Za());
    const e = this.transform, r = this.parent;
    this.parent = null, this._tempDisplayObjectParent.worldAlpha = r?.worldAlpha ?? 1, this.transform = this._tempDisplayObjectParent.transform;
    const i = this._bounds, s = this._boundsID;
    this._bounds = this._localBounds;
    const o = this.getBounds(!1, t);
    return this.parent = r, this.transform = e, this._bounds = i, this._bounds.updateID += this._boundsID - s, o;
  }
  /**
   * Calculates the global position of the display object.
   * @param position - The world origin to calculate from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform.
   * @returns - A point object representing the position of this object.
   */
  toGlobal(t, e, r = !1) {
    return r || (this._recursivePostUpdateTransform(), this.parent ? this.displayObjectUpdateTransform() : (this.parent = this._tempDisplayObjectParent, this.displayObjectUpdateTransform(), this.parent = null)), this.worldTransform.apply(t, e);
  }
  /**
   * Calculates the local position of the display object relative to another point.
   * @param position - The world origin to calculate from.
   * @param from - The DisplayObject to calculate the global position from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform
   * @returns - A point object representing the position of this object
   */
  toLocal(t, e, r, i) {
    return e && (t = e.toGlobal(t, r, i)), i || (this._recursivePostUpdateTransform(), this.parent ? this.displayObjectUpdateTransform() : (this.parent = this._tempDisplayObjectParent, this.displayObjectUpdateTransform(), this.parent = null)), this.worldTransform.applyInverse(t, r);
  }
  /**
   * Set the parent Container of this DisplayObject.
   * @param container - The Container to add this DisplayObject to.
   * @returns - The Container that this DisplayObject was added to.
   */
  setParent(t) {
    if (!t || !t.addChild)
      throw new Error("setParent: Argument must be a Container");
    return t.addChild(this), t;
  }
  /** Remove the DisplayObject from its parent Container. If the DisplayObject has no parent, do nothing. */
  removeFromParent() {
    this.parent?.removeChild(this);
  }
  /**
   * Convenience function to set the position, scale, skew and pivot at once.
   * @param x - The X position
   * @param y - The Y position
   * @param scaleX - The X scale value
   * @param scaleY - The Y scale value
   * @param rotation - The rotation
   * @param skewX - The X skew value
   * @param skewY - The Y skew value
   * @param pivotX - The X pivot value
   * @param pivotY - The Y pivot value
   * @returns - The DisplayObject instance
   */
  setTransform(t = 0, e = 0, r = 1, i = 1, s = 0, o = 0, a = 0, h = 0, l = 0) {
    return this.position.x = t, this.position.y = e, this.scale.x = r || 1, this.scale.y = i || 1, this.rotation = s, this.skew.x = o, this.skew.y = a, this.pivot.x = h, this.pivot.y = l, this;
  }
  /**
   * Base destroy method for generic display objects. This will automatically
   * remove the display object from its parent Container as well as remove
   * all current event listeners and internal references. Do not use a DisplayObject
   * after calling `destroy()`.
   * @param _options
   */
  destroy(t) {
    this.removeFromParent(), this._destroyed = !0, this.transform = null, this.parent = null, this._bounds = null, this.mask = null, this.cullArea = null, this.filters = null, this.filterArea = null, this.hitArea = null, this.eventMode = "auto", this.interactiveChildren = !1, this.emit("destroyed"), this.removeAllListeners();
  }
  /**
   * @protected
   * @member {PIXI.Container}
   */
  get _tempDisplayObjectParent() {
    return this.tempDisplayObjectParent === null && (this.tempDisplayObjectParent = new sb()), this.tempDisplayObjectParent;
  }
  /**
   * Used in Renderer, cacheAsBitmap and other places where you call an `updateTransform` on root.
   *
   * ```js
   * const cacheParent = elem.enableTempParent();
   * elem.updateTransform();
   * elem.disableTempParent(cacheParent);
   * ```
   * @returns - Current parent
   */
  enableTempParent() {
    const t = this.parent;
    return this.parent = this._tempDisplayObjectParent, t;
  }
  /**
   * Pair method for `enableTempParent`
   * @param cacheParent - Actual parent of element
   */
  disableTempParent(t) {
    this.parent = t;
  }
  /**
   * The position of the displayObject on the x axis relative to the local coordinates of the parent.
   * An alias to position.x
   */
  get x() {
    return this.position.x;
  }
  set x(t) {
    this.transform.position.x = t;
  }
  /**
   * The position of the displayObject on the y axis relative to the local coordinates of the parent.
   * An alias to position.y
   */
  get y() {
    return this.position.y;
  }
  set y(t) {
    this.transform.position.y = t;
  }
  /**
   * Current transform of the object based on world (parent) factors.
   * @readonly
   */
  get worldTransform() {
    return this.transform.worldTransform;
  }
  /**
   * Current transform of the object based on local factors: position, scale, other stuff.
   * @readonly
   */
  get localTransform() {
    return this.transform.localTransform;
  }
  /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @since 4.0.0
   */
  get position() {
    return this.transform.position;
  }
  set position(t) {
    this.transform.position.copyFrom(t);
  }
  /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @since 4.0.0
   */
  get scale() {
    return this.transform.scale;
  }
  set scale(t) {
    this.transform.scale.copyFrom(t);
  }
  /**
   * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
   * is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @since 4.0.0
   */
  get pivot() {
    return this.transform.pivot;
  }
  set pivot(t) {
    this.transform.pivot.copyFrom(t);
  }
  /**
   * The skew factor for the object in radians.
   * @since 4.0.0
   */
  get skew() {
    return this.transform.skew;
  }
  set skew(t) {
    this.transform.skew.copyFrom(t);
  }
  /**
   * The rotation of the object in radians.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */
  get rotation() {
    return this.transform.rotation;
  }
  set rotation(t) {
    this.transform.rotation = t;
  }
  /**
   * The angle of the object in degrees.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */
  get angle() {
    return this.transform.rotation * Jx;
  }
  set angle(t) {
    this.transform.rotation = t * qu;
  }
  /**
   * The zIndex of the displayObject.
   *
   * If a container has the sortableChildren property set to true, children will be automatically
   * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
   * and thus rendered on top of other display objects within the same container.
   * @see PIXI.Container#sortableChildren
   */
  get zIndex() {
    return this._zIndex;
  }
  set zIndex(t) {
    this._zIndex = t, this.parent && (this.parent.sortDirty = !0);
  }
  /**
   * Indicates if the object is globally visible.
   * @readonly
   */
  get worldVisible() {
    let t = this;
    do {
      if (!t.visible)
        return !1;
      t = t.parent;
    } while (t);
    return !0;
  }
  /**
   * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
   * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
   * {@link PIXI.Graphics} or a {@link PIXI.Sprite} object. This allows for much faster masking in canvas as it
   * utilities shape clipping. Furthermore, a mask of an object must be in the subtree of its parent.
   * Otherwise, `getLocalBounds` may calculate incorrect bounds, which makes the container's width and height wrong.
   * To remove a mask, set this property to `null`.
   *
   * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
   * @example
   * import { Graphics, Sprite } from 'pixi.js';
   *
   * const graphics = new Graphics();
   * graphics.beginFill(0xFF3300);
   * graphics.drawRect(50, 250, 100, 100);
   * graphics.endFill();
   *
   * const sprite = new Sprite(texture);
   * sprite.mask = graphics;
   * @todo At the moment, CanvasRenderer doesn't support Sprite as mask.
   */
  get mask() {
    return this._mask;
  }
  set mask(t) {
    if (this._mask !== t) {
      if (this._mask) {
        const e = this._mask.isMaskData ? this._mask.maskObject : this._mask;
        e && (e._maskRefCount--, e._maskRefCount === 0 && (e.renderable = !0, e.isMask = !1));
      }
      if (this._mask = t, this._mask) {
        const e = this._mask.isMaskData ? this._mask.maskObject : this._mask;
        e && (e._maskRefCount === 0 && (e.renderable = !1, e.isMask = !0), e._maskRefCount++);
      }
    }
  }
}
class sb extends zt {
  constructor() {
    super(...arguments), this.sortDirty = null;
  }
}
zt.prototype.displayObjectUpdateTransform = zt.prototype.updateTransform;
const ob = new Nt();
function ab(n, t) {
  return n.zIndex === t.zIndex ? n._lastSortedIndex - t._lastSortedIndex : n.zIndex - t.zIndex;
}
const B0 = class hc extends zt {
  constructor() {
    super(), this.children = [], this.sortableChildren = hc.defaultSortableChildren, this.sortDirty = !1;
  }
  /**
   * Overridable method that can be used by Container subclasses whenever the children array is modified.
   * @param _length
   */
  onChildrenChange(t) {
  }
  /**
   * Adds one or more children to the container.
   *
   * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
   * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to add to the container
   * @returns {PIXI.DisplayObject} - The first child that was added.
   */
  addChild(...t) {
    if (t.length > 1)
      for (let e = 0; e < t.length; e++)
        this.addChild(t[e]);
    else {
      const e = t[0];
      e.parent && e.parent.removeChild(e), e.parent = this, this.sortDirty = !0, e.transform._parentID = -1, this.children.push(e), this._boundsID++, this.onChildrenChange(this.children.length - 1), this.emit("childAdded", e, this, this.children.length - 1), e.emit("added", this);
    }
    return t[0];
  }
  /**
   * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the child is already in this container, it will be moved to the specified index.
   * @param {PIXI.DisplayObject} child - The child to add.
   * @param {number} index - The absolute index where the child will be positioned at the end of the operation.
   * @returns {PIXI.DisplayObject} The child that was added.
   */
  addChildAt(t, e) {
    if (e < 0 || e > this.children.length)
      throw new Error(`${t}addChildAt: The index ${e} supplied is out of bounds ${this.children.length}`);
    return t.parent && t.parent.removeChild(t), t.parent = this, this.sortDirty = !0, t.transform._parentID = -1, this.children.splice(e, 0, t), this._boundsID++, this.onChildrenChange(e), t.emit("added", this), this.emit("childAdded", t, this, e), t;
  }
  /**
   * Swaps the position of 2 Display Objects within this container.
   * @param child - First display object to swap
   * @param child2 - Second display object to swap
   */
  swapChildren(t, e) {
    if (t === e)
      return;
    const r = this.getChildIndex(t), i = this.getChildIndex(e);
    this.children[r] = e, this.children[i] = t, this.onChildrenChange(r < i ? r : i);
  }
  /**
   * Returns the index position of a child DisplayObject instance
   * @param child - The DisplayObject instance to identify
   * @returns - The index position of the child display object to identify
   */
  getChildIndex(t) {
    const e = this.children.indexOf(t);
    if (e === -1)
      throw new Error("The supplied DisplayObject must be a child of the caller");
    return e;
  }
  /**
   * Changes the position of an existing child in the display object container
   * @param child - The child DisplayObject instance for which you want to change the index number
   * @param index - The resulting index number for the child display object
   */
  setChildIndex(t, e) {
    if (e < 0 || e >= this.children.length)
      throw new Error(`The index ${e} supplied is out of bounds ${this.children.length}`);
    const r = this.getChildIndex(t);
    es(this.children, r, 1), this.children.splice(e, 0, t), this.onChildrenChange(e);
  }
  /**
   * Returns the child at the specified index
   * @param index - The index to get the child at
   * @returns - The child at the given index, if any.
   */
  getChildAt(t) {
    if (t < 0 || t >= this.children.length)
      throw new Error(`getChildAt: Index (${t}) does not exist.`);
    return this.children[t];
  }
  /**
   * Removes one or more children from the container.
   * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to remove
   * @returns {PIXI.DisplayObject} The first child that was removed.
   */
  removeChild(...t) {
    if (t.length > 1)
      for (let e = 0; e < t.length; e++)
        this.removeChild(t[e]);
    else {
      const e = t[0], r = this.children.indexOf(e);
      if (r === -1)
        return null;
      e.parent = null, e.transform._parentID = -1, es(this.children, r, 1), this._boundsID++, this.onChildrenChange(r), e.emit("removed", this), this.emit("childRemoved", e, this, r);
    }
    return t[0];
  }
  /**
   * Removes a child from the specified index position.
   * @param index - The index to get the child from
   * @returns The child that was removed.
   */
  removeChildAt(t) {
    const e = this.getChildAt(t);
    return e.parent = null, e.transform._parentID = -1, es(this.children, t, 1), this._boundsID++, this.onChildrenChange(t), e.emit("removed", this), this.emit("childRemoved", e, this, t), e;
  }
  /**
   * Removes all children from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed children
   */
  removeChildren(t = 0, e = this.children.length) {
    const r = t, i = e, s = i - r;
    let o;
    if (s > 0 && s <= i) {
      o = this.children.splice(r, s);
      for (let a = 0; a < o.length; ++a)
        o[a].parent = null, o[a].transform && (o[a].transform._parentID = -1);
      this._boundsID++, this.onChildrenChange(t);
      for (let a = 0; a < o.length; ++a)
        o[a].emit("removed", this), this.emit("childRemoved", o[a], this, a);
      return o;
    } else if (s === 0 && this.children.length === 0)
      return [];
    throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
  }
  /** Sorts children by zIndex. Previous order is maintained for 2 children with the same zIndex. */
  sortChildren() {
    let t = !1;
    for (let e = 0, r = this.children.length; e < r; ++e) {
      const i = this.children[e];
      i._lastSortedIndex = e, !t && i.zIndex !== 0 && (t = !0);
    }
    t && this.children.length > 1 && this.children.sort(ab), this.sortDirty = !1;
  }
  /** Updates the transform on all children of this container for rendering. */
  updateTransform() {
    this.sortableChildren && this.sortDirty && this.sortChildren(), this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
    for (let t = 0, e = this.children.length; t < e; ++t) {
      const r = this.children[t];
      r.visible && r.updateTransform();
    }
  }
  /**
   * Recalculates the bounds of the container.
   *
   * This implementation will automatically fit the children's bounds into the calculation. Each child's bounds
   * is limited to its mask's bounds or filterArea, if any is applied.
   */
  calculateBounds() {
    this._bounds.clear(), this._calculateBounds();
    for (let t = 0; t < this.children.length; t++) {
      const e = this.children[t];
      if (!(!e.visible || !e.renderable))
        if (e.calculateBounds(), e._mask) {
          const r = e._mask.isMaskData ? e._mask.maskObject : e._mask;
          r ? (r.calculateBounds(), this._bounds.addBoundsMask(e._bounds, r._bounds)) : this._bounds.addBounds(e._bounds);
        } else
          e.filterArea ? this._bounds.addBoundsArea(e._bounds, e.filterArea) : this._bounds.addBounds(e._bounds);
    }
    this._bounds.updateID = this._boundsID;
  }
  /**
   * Retrieves the local bounds of the displayObject as a rectangle object.
   *
   * Calling `getLocalBounds` may invalidate the `_bounds` of the whole subtree below. If using it inside a render()
   * call, it is advised to call `getBounds()` immediately after to recalculate the world bounds of the subtree.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @param skipChildrenUpdate - Setting to `true` will stop re-calculation of children transforms,
   *  it was default behaviour of pixi 4.0-5.2 and caused many problems to users.
   * @returns - The rectangular bounding area.
   */
  getLocalBounds(t, e = !1) {
    const r = super.getLocalBounds(t);
    if (!e)
      for (let i = 0, s = this.children.length; i < s; ++i) {
        const o = this.children[i];
        o.visible && o.updateTransform();
      }
    return r;
  }
  /**
   * Recalculates the content bounds of this object. This should be overriden to
   * calculate the bounds of this specific object (not including children).
   * @protected
   */
  _calculateBounds() {
  }
  /**
   * Renders this object and its children with culling.
   * @protected
   * @param {PIXI.Renderer} renderer - The renderer
   */
  _renderWithCulling(t) {
    const e = t.renderTexture.sourceFrame;
    if (!(e.width > 0 && e.height > 0))
      return;
    let r, i;
    this.cullArea ? (r = this.cullArea, i = this.worldTransform) : this._render !== hc.prototype._render && (r = this.getBounds(!0));
    const s = t.projection.transform;
    if (s && (i ? (i = ob.copyFrom(i), i.prepend(s)) : i = s), r && e.intersects(r, i))
      this._render(t);
    else if (this.cullArea)
      return;
    for (let o = 0, a = this.children.length; o < a; ++o) {
      const h = this.children[o], l = h.cullable;
      h.cullable = l || !this.cullArea, h.render(t), h.cullable = l;
    }
  }
  /**
   * Renders the object using the WebGL renderer.
   *
   * The [_render]{@link PIXI.Container#_render} method is be overriden for rendering the contents of the
   * container itself. This `render` method will invoke it, and also invoke the `render` methods of all
   * children afterward.
   *
   * If `renderable` or `visible` is false or if `worldAlpha` is not positive or if `cullable` is true and
   * the bounds of this object are out of frame, this implementation will entirely skip rendering.
   * See {@link PIXI.DisplayObject} for choosing between `renderable` or `visible`. Generally,
   * setting alpha to zero is not recommended for purely skipping rendering.
   *
   * When your scene becomes large (especially when it is larger than can be viewed in a single screen), it is
   * advised to employ **culling** to automatically skip rendering objects outside of the current screen.
   * See [cullable]{@link PIXI.DisplayObject#cullable} and [cullArea]{@link PIXI.DisplayObject#cullArea}.
   * Other culling methods might be better suited for a large number static objects; see
   * [@pixi-essentials/cull]{@link https://www.npmjs.com/package/@pixi-essentials/cull} and
   * [pixi-cull]{@link https://www.npmjs.com/package/pixi-cull}.
   *
   * The [renderAdvanced]{@link PIXI.Container#renderAdvanced} method is internally used when when masking or
   * filtering is applied on a container. This does, however, break batching and can affect performance when
   * masking and filtering is applied extensively throughout the scene graph.
   * @param renderer - The renderer
   */
  render(t) {
    if (!(!this.visible || this.worldAlpha <= 0 || !this.renderable))
      if (this._mask || this.filters?.length)
        this.renderAdvanced(t);
      else if (this.cullable)
        this._renderWithCulling(t);
      else {
        this._render(t);
        for (let e = 0, r = this.children.length; e < r; ++e)
          this.children[e].render(t);
      }
  }
  /**
   * Render the object using the WebGL renderer and advanced features.
   * @param renderer - The renderer
   */
  renderAdvanced(t) {
    const e = this.filters, r = this._mask;
    if (e) {
      this._enabledFilters || (this._enabledFilters = []), this._enabledFilters.length = 0;
      for (let s = 0; s < e.length; s++)
        e[s].enabled && this._enabledFilters.push(e[s]);
    }
    const i = e && this._enabledFilters?.length || r && (!r.isMaskData || r.enabled && (r.autoDetect || r.type !== re.NONE));
    if (i && t.batch.flush(), e && this._enabledFilters?.length && t.filter.push(this, this._enabledFilters), r && t.mask.push(this, this._mask), this.cullable)
      this._renderWithCulling(t);
    else {
      this._render(t);
      for (let s = 0, o = this.children.length; s < o; ++s)
        this.children[s].render(t);
    }
    i && t.batch.flush(), r && t.mask.pop(this), e && this._enabledFilters?.length && t.filter.pop();
  }
  /**
   * To be overridden by the subclasses.
   * @param _renderer - The renderer
   */
  _render(t) {
  }
  /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */
  destroy(t) {
    super.destroy(), this.sortDirty = !1;
    const e = typeof t == "boolean" ? t : t?.children, r = this.removeChildren(0, this.children.length);
    if (e)
      for (let i = 0; i < r.length; ++i)
        r[i].destroy(t);
  }
  /** The width of the Container, setting this will actually modify the scale to achieve the value set. */
  get width() {
    return this.scale.x * this.getLocalBounds().width;
  }
  set width(t) {
    const e = this.getLocalBounds().width;
    e !== 0 ? this.scale.x = t / e : this.scale.x = 1, this._width = t;
  }
  /** The height of the Container, setting this will actually modify the scale to achieve the value set. */
  get height() {
    return this.scale.y * this.getLocalBounds().height;
  }
  set height(t) {
    const e = this.getLocalBounds().height;
    e !== 0 ? this.scale.y = t / e : this.scale.y = 1, this._height = t;
  }
};
B0.defaultSortableChildren = !1;
let bt = B0;
bt.prototype.containerUpdateTransform = bt.prototype.updateTransform;
Object.defineProperties(ht, {
  /**
   * Sets the default value for the container property 'sortableChildren'.
   * @static
   * @name SORTABLE_CHILDREN
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {boolean}
   * @see PIXI.Container.defaultSortableChildren
   */
  SORTABLE_CHILDREN: {
    get() {
      return bt.defaultSortableChildren;
    },
    set(n) {
      wt("7.1.0", "settings.SORTABLE_CHILDREN is deprecated, use Container.defaultSortableChildren"), bt.defaultSortableChildren = n;
    }
  }
});
const Bs = new mt(), hb = new Uint16Array([0, 1, 2, 0, 2, 3]);
class jt extends bt {
  /** @param texture - The texture for this sprite. */
  constructor(t) {
    super(), this._anchor = new tn(
      this._onAnchorUpdate,
      this,
      t ? t.defaultAnchor.x : 0,
      t ? t.defaultAnchor.y : 0
    ), this._texture = null, this._width = 0, this._height = 0, this._tintColor = new Ot(16777215), this._tintRGB = null, this.tint = 16777215, this.blendMode = gt.NORMAL, this._cachedTint = 16777215, this.uvs = null, this.texture = t || ct.EMPTY, this.vertexData = new Float32Array(8), this.vertexTrimmedData = null, this._transformID = -1, this._textureID = -1, this._transformTrimmedID = -1, this._textureTrimmedID = -1, this.indices = hb, this.pluginName = "batch", this.isSprite = !0, this._roundPixels = ht.ROUND_PIXELS;
  }
  /** When the texture is updated, this event will fire to update the scale and frame. */
  _onTextureUpdate() {
    this._textureID = -1, this._textureTrimmedID = -1, this._cachedTint = 16777215, this._width && (this.scale.x = Cn(this.scale.x) * this._width / this._texture.orig.width), this._height && (this.scale.y = Cn(this.scale.y) * this._height / this._texture.orig.height);
  }
  /** Called when the anchor position updates. */
  _onAnchorUpdate() {
    this._transformID = -1, this._transformTrimmedID = -1;
  }
  /** Calculates worldTransform * vertices, store it in vertexData. */
  calculateVertices() {
    const t = this._texture;
    if (this._transformID === this.transform._worldID && this._textureID === t._updateID)
      return;
    this._textureID !== t._updateID && (this.uvs = this._texture._uvs.uvsFloat32), this._transformID = this.transform._worldID, this._textureID = t._updateID;
    const e = this.transform.worldTransform, r = e.a, i = e.b, s = e.c, o = e.d, a = e.tx, h = e.ty, l = this.vertexData, u = t.trim, c = t.orig, d = this._anchor;
    let f = 0, p = 0, m = 0, g = 0;
    if (u ? (p = u.x - d._x * c.width, f = p + u.width, g = u.y - d._y * c.height, m = g + u.height) : (p = -d._x * c.width, f = p + c.width, g = -d._y * c.height, m = g + c.height), l[0] = r * p + s * g + a, l[1] = o * g + i * p + h, l[2] = r * f + s * g + a, l[3] = o * g + i * f + h, l[4] = r * f + s * m + a, l[5] = o * m + i * f + h, l[6] = r * p + s * m + a, l[7] = o * m + i * p + h, this._roundPixels) {
      const _ = ht.RESOLUTION;
      for (let w = 0; w < l.length; ++w)
        l[w] = Math.round(l[w] * _) / _;
    }
  }
  /**
   * Calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData.
   *
   * This is used to ensure that the true width and height of a trimmed texture is respected.
   */
  calculateTrimmedVertices() {
    if (!this.vertexTrimmedData)
      this.vertexTrimmedData = new Float32Array(8);
    else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID)
      return;
    this._transformTrimmedID = this.transform._worldID, this._textureTrimmedID = this._texture._updateID;
    const t = this._texture, e = this.vertexTrimmedData, r = t.orig, i = this._anchor, s = this.transform.worldTransform, o = s.a, a = s.b, h = s.c, l = s.d, u = s.tx, c = s.ty, d = -i._x * r.width, f = d + r.width, p = -i._y * r.height, m = p + r.height;
    if (e[0] = o * d + h * p + u, e[1] = l * p + a * d + c, e[2] = o * f + h * p + u, e[3] = l * p + a * f + c, e[4] = o * f + h * m + u, e[5] = l * m + a * f + c, e[6] = o * d + h * m + u, e[7] = l * m + a * d + c, this._roundPixels) {
      const g = ht.RESOLUTION;
      for (let _ = 0; _ < e.length; ++_)
        e[_] = Math.round(e[_] * g) / g;
    }
  }
  /**
   *
   * Renders the object using the WebGL renderer
   * @param renderer - The webgl renderer to use.
   */
  _render(t) {
    this.calculateVertices(), t.batch.setObjectRenderer(t.plugins[this.pluginName]), t.plugins[this.pluginName].render(this);
  }
  /** Updates the bounds of the sprite. */
  _calculateBounds() {
    const t = this._texture.trim, e = this._texture.orig;
    !t || t.width === e.width && t.height === e.height ? (this.calculateVertices(), this._bounds.addQuad(this.vertexData)) : (this.calculateTrimmedVertices(), this._bounds.addQuad(this.vertexTrimmedData));
  }
  /**
   * Gets the local bounds of the sprite object.
   * @param rect - Optional output rectangle.
   * @returns The bounds.
   */
  getLocalBounds(t) {
    return this.children.length === 0 ? (this._localBounds || (this._localBounds = new Za()), this._localBounds.minX = this._texture.orig.width * -this._anchor._x, this._localBounds.minY = this._texture.orig.height * -this._anchor._y, this._localBounds.maxX = this._texture.orig.width * (1 - this._anchor._x), this._localBounds.maxY = this._texture.orig.height * (1 - this._anchor._y), t || (this._localBoundsRect || (this._localBoundsRect = new yt()), t = this._localBoundsRect), this._localBounds.getRectangle(t)) : super.getLocalBounds.call(this, t);
  }
  /**
   * Tests if a point is inside this sprite
   * @param point - the point to test
   * @returns The result of the test
   */
  containsPoint(t) {
    this.worldTransform.applyInverse(t, Bs);
    const e = this._texture.orig.width, r = this._texture.orig.height, i = -e * this.anchor.x;
    let s = 0;
    return Bs.x >= i && Bs.x < i + e && (s = -r * this.anchor.y, Bs.y >= s && Bs.y < s + r);
  }
  /**
   * Destroys this sprite and optionally its texture and children.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param [options.children=false] - if set to true, all the children will have their destroy
   *      method called as well. 'options' will be passed on to those calls.
   * @param [options.texture=false] - Should it destroy the current texture of the sprite as well
   * @param [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
   */
  destroy(t) {
    if (super.destroy(t), this._texture.off("update", this._onTextureUpdate, this), this._anchor = null, typeof t == "boolean" ? t : t?.texture) {
      const e = typeof t == "boolean" ? t : t?.baseTexture;
      this._texture.destroy(!!e);
    }
    this._texture = null;
  }
  // some helper functions..
  /**
   * Helper function that creates a new sprite based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @param {string|PIXI.Texture|HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source
   *     - Source to create texture from
   * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
   * @returns The newly created sprite
   */
  static from(t, e) {
    const r = t instanceof ct ? t : ct.from(t, e);
    return new jt(r);
  }
  /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   *
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   *
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}.
   * @default false
   */
  set roundPixels(t) {
    this._roundPixels !== t && (this._transformID = -1, this._transformTrimmedID = -1), this._roundPixels = t;
  }
  get roundPixels() {
    return this._roundPixels;
  }
  /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */
  get width() {
    return Math.abs(this.scale.x) * this._texture.orig.width;
  }
  set width(t) {
    const e = Cn(this.scale.x) || 1;
    this.scale.x = e * t / this._texture.orig.width, this._width = t;
  }
  /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */
  get height() {
    return Math.abs(this.scale.y) * this._texture.orig.height;
  }
  set height(t) {
    const e = Cn(this.scale.y) || 1;
    this.scale.y = e * t / this._texture.orig.height, this._height = t;
  }
  /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link PIXI.Texture|Texture}
   * and passed to the constructor.
   *
   * The default is `(0,0)`, this means the sprite's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(Texture.WHITE);
   * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(t) {
    this._anchor.copyFrom(t);
  }
  /**
   * The tint applied to the sprite. This is a hex value.
   *
   * A value of 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */
  get tint() {
    return this._tintColor.value;
  }
  set tint(t) {
    this._tintColor.setValue(t), this._tintRGB = this._tintColor.toLittleEndianNumber();
  }
  /**
   * Get the tint as a RGB integer.
   * @ignore
   */
  get tintValue() {
    return this._tintColor.toNumber();
  }
  /** The texture that the sprite is using. */
  get texture() {
    return this._texture;
  }
  set texture(t) {
    this._texture !== t && (this._texture && this._texture.off("update", this._onTextureUpdate, this), this._texture = t || ct.EMPTY, this._cachedTint = 16777215, this._textureID = -1, this._textureTrimmedID = -1, t && (t.baseTexture.valid ? this._onTextureUpdate() : t.once("update", this._onTextureUpdate, this)));
  }
}
const L0 = new Nt();
zt.prototype._cacheAsBitmap = !1;
zt.prototype._cacheData = null;
zt.prototype._cacheAsBitmapResolution = null;
zt.prototype._cacheAsBitmapMultisample = null;
class lb {
  constructor() {
    this.textureCacheId = null, this.originalRender = null, this.originalRenderCanvas = null, this.originalCalculateBounds = null, this.originalGetLocalBounds = null, this.originalUpdateTransform = null, this.originalDestroy = null, this.originalMask = null, this.originalFilterArea = null, this.originalContainsPoint = null, this.sprite = null;
  }
}
Object.defineProperties(zt.prototype, {
  /**
   * The resolution to use for cacheAsBitmap. By default this will use the renderer's resolution
   * but can be overriden for performance. Lower values will reduce memory usage at the expense
   * of render quality. A falsey value of `null` or `0` will default to the renderer's resolution.
   * If `cacheAsBitmap` is set to `true`, this will re-render with the new resolution.
   * @member {number|null} cacheAsBitmapResolution
   * @memberof PIXI.DisplayObject#
   * @default null
   */
  cacheAsBitmapResolution: {
    get() {
      return this._cacheAsBitmapResolution;
    },
    set(n) {
      n !== this._cacheAsBitmapResolution && (this._cacheAsBitmapResolution = n, this.cacheAsBitmap && (this.cacheAsBitmap = !1, this.cacheAsBitmap = !0));
    }
  },
  /**
   * The number of samples to use for cacheAsBitmap. If set to `null`, the renderer's
   * sample count is used.
   * If `cacheAsBitmap` is set to `true`, this will re-render with the new number of samples.
   * @member {number|null} cacheAsBitmapMultisample
   * @memberof PIXI.DisplayObject#
   * @default null
   */
  cacheAsBitmapMultisample: {
    get() {
      return this._cacheAsBitmapMultisample;
    },
    set(n) {
      n !== this._cacheAsBitmapMultisample && (this._cacheAsBitmapMultisample = n, this.cacheAsBitmap && (this.cacheAsBitmap = !1, this.cacheAsBitmap = !0));
    }
  },
  /**
   * Set this to true if you want this display object to be cached as a bitmap.
   * This basically takes a snapshot of the display object as it is at that moment. It can
   * provide a performance benefit for complex static displayObjects.
   * To remove simply set this property to `false`
   *
   * IMPORTANT GOTCHA - Make sure that all your textures are preloaded BEFORE setting this property to true
   * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */
  cacheAsBitmap: {
    get() {
      return this._cacheAsBitmap;
    },
    set(n) {
      if (this._cacheAsBitmap === n)
        return;
      this._cacheAsBitmap = n;
      let t;
      n ? (this._cacheData || (this._cacheData = new lb()), t = this._cacheData, t.originalRender = this.render, t.originalRenderCanvas = this.renderCanvas, t.originalUpdateTransform = this.updateTransform, t.originalCalculateBounds = this.calculateBounds, t.originalGetLocalBounds = this.getLocalBounds, t.originalDestroy = this.destroy, t.originalContainsPoint = this.containsPoint, t.originalMask = this._mask, t.originalFilterArea = this.filterArea, this.render = this._renderCached, this.renderCanvas = this._renderCachedCanvas, this.destroy = this._cacheAsBitmapDestroy) : (t = this._cacheData, t.sprite && this._destroyCachedDisplayObject(), this.render = t.originalRender, this.renderCanvas = t.originalRenderCanvas, this.calculateBounds = t.originalCalculateBounds, this.getLocalBounds = t.originalGetLocalBounds, this.destroy = t.originalDestroy, this.updateTransform = t.originalUpdateTransform, this.containsPoint = t.originalContainsPoint, this._mask = t.originalMask, this.filterArea = t.originalFilterArea);
    }
  }
});
zt.prototype._renderCached = function(n) {
  !this.visible || this.worldAlpha <= 0 || !this.renderable || (this._initCachedDisplayObject(n), this._cacheData.sprite.transform._worldID = this.transform._worldID, this._cacheData.sprite.worldAlpha = this.worldAlpha, this._cacheData.sprite._render(n));
};
zt.prototype._initCachedDisplayObject = function(n) {
  if (this._cacheData?.sprite)
    return;
  const t = this.alpha;
  this.alpha = 1, n.batch.flush();
  const e = this.getLocalBounds(new yt(), !0);
  if (this.filters?.length) {
    const d = this.filters[0].padding;
    e.pad(d);
  }
  const r = this.cacheAsBitmapResolution || n.resolution;
  e.ceil(r), e.width = Math.max(e.width, 1 / r), e.height = Math.max(e.height, 1 / r);
  const i = n.renderTexture.current, s = n.renderTexture.sourceFrame.clone(), o = n.renderTexture.destinationFrame.clone(), a = n.projection.transform, h = Di.create({
    width: e.width,
    height: e.height,
    resolution: r,
    multisample: this.cacheAsBitmapMultisample ?? n.multisample
  }), l = `cacheAsBitmap_${Ti()}`;
  this._cacheData.textureCacheId = l, _t.addToCache(h.baseTexture, l), ct.addToCache(h, l);
  const u = this.transform.localTransform.copyTo(L0).invert().translate(-e.x, -e.y);
  this.render = this._cacheData.originalRender, n.render(this, { renderTexture: h, clear: !0, transform: u, skipUpdateTransform: !1 }), n.framebuffer.blit(), n.projection.transform = a, n.renderTexture.bind(i, s, o), this.render = this._renderCached, this.updateTransform = this.displayObjectUpdateTransform, this.calculateBounds = this._calculateCachedBounds, this.getLocalBounds = this._getCachedLocalBounds, this._mask = null, this.filterArea = null, this.alpha = t;
  const c = new jt(h);
  c.transform.worldTransform = this.transform.worldTransform, c.anchor.x = -(e.x / e.width), c.anchor.y = -(e.y / e.height), c.alpha = t, c._bounds = this._bounds, this._cacheData.sprite = c, this.transform._parentID = -1, this.parent ? this.updateTransform() : (this.enableTempParent(), this.updateTransform(), this.disableTempParent(null)), this.containsPoint = c.containsPoint.bind(c);
};
zt.prototype._renderCachedCanvas = function(n) {
  !this.visible || this.worldAlpha <= 0 || !this.renderable || (this._initCachedDisplayObjectCanvas(n), this._cacheData.sprite.worldAlpha = this.worldAlpha, this._cacheData.sprite._renderCanvas(n));
};
zt.prototype._initCachedDisplayObjectCanvas = function(n) {
  if (this._cacheData?.sprite)
    return;
  const t = this.getLocalBounds(new yt(), !0), e = this.alpha;
  this.alpha = 1;
  const r = n.canvasContext.activeContext, i = n._projTransform, s = this.cacheAsBitmapResolution || n.resolution;
  t.ceil(s), t.width = Math.max(t.width, 1 / s), t.height = Math.max(t.height, 1 / s);
  const o = Di.create({
    width: t.width,
    height: t.height,
    resolution: s
  }), a = `cacheAsBitmap_${Ti()}`;
  this._cacheData.textureCacheId = a, _t.addToCache(o.baseTexture, a), ct.addToCache(o, a);
  const h = L0;
  this.transform.localTransform.copyTo(h), h.invert(), h.tx -= t.x, h.ty -= t.y, this.renderCanvas = this._cacheData.originalRenderCanvas, n.render(this, { renderTexture: o, clear: !0, transform: h, skipUpdateTransform: !1 }), n.canvasContext.activeContext = r, n._projTransform = i, this.renderCanvas = this._renderCachedCanvas, this.updateTransform = this.displayObjectUpdateTransform, this.calculateBounds = this._calculateCachedBounds, this.getLocalBounds = this._getCachedLocalBounds, this._mask = null, this.filterArea = null, this.alpha = e;
  const l = new jt(o);
  l.transform.worldTransform = this.transform.worldTransform, l.anchor.x = -(t.x / t.width), l.anchor.y = -(t.y / t.height), l.alpha = e, l._bounds = this._bounds, this._cacheData.sprite = l, this.transform._parentID = -1, this.parent ? this.updateTransform() : (this.parent = n._tempDisplayObjectParent, this.updateTransform(), this.parent = null), this.containsPoint = l.containsPoint.bind(l);
};
zt.prototype._calculateCachedBounds = function() {
  this._bounds.clear(), this._cacheData.sprite.transform._worldID = this.transform._worldID, this._cacheData.sprite._calculateBounds(), this._bounds.updateID = this._boundsID;
};
zt.prototype._getCachedLocalBounds = function() {
  return this._cacheData.sprite.getLocalBounds(null);
};
zt.prototype._destroyCachedDisplayObject = function() {
  this._cacheData.sprite._texture.destroy(!0), this._cacheData.sprite = null, _t.removeFromCache(this._cacheData.textureCacheId), ct.removeFromCache(this._cacheData.textureCacheId), this._cacheData.textureCacheId = null;
};
zt.prototype._cacheAsBitmapDestroy = function(n) {
  this.cacheAsBitmap = !1, this.destroy(n);
};
zt.prototype.name = null;
bt.prototype.getChildByName = function(n, t) {
  for (let e = 0, r = this.children.length; e < r; e++)
    if (this.children[e].name === n)
      return this.children[e];
  if (t)
    for (let e = 0, r = this.children.length; e < r; e++) {
      const i = this.children[e];
      if (!i.getChildByName)
        continue;
      const s = i.getChildByName(n, !0);
      if (s)
        return s;
    }
  return null;
};
zt.prototype.getGlobalPosition = function(n = new mt(), t = !1) {
  return this.parent ? this.parent.toGlobal(this.position, n, t) : (n.x = this.position.x, n.y = this.position.y), n;
};
var ub = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform float uAlpha;

void main(void)
{
   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;
}
`;
class cb extends ve {
  /**
   * @param alpha - Amount of alpha from 0 to 1, where 0 is transparent
   */
  constructor(t = 1) {
    super(tb, ub, { uAlpha: 1 }), this.alpha = t;
  }
  /**
   * Coefficient for alpha multiplication
   * @default 1
   */
  get alpha() {
    return this.uniforms.uAlpha;
  }
  set alpha(t) {
    this.uniforms.uAlpha = t;
  }
}
const db = {
  5: [0.153388, 0.221461, 0.250301],
  7: [0.071303, 0.131514, 0.189879, 0.214607],
  9: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
  11: [93e-4, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
  13: [2406e-6, 9255e-6, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
  15: [489e-6, 2403e-6, 9246e-6, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448]
}, fb = [
  "varying vec2 vBlurTexCoords[%size%];",
  "uniform sampler2D uSampler;",
  "void main(void)",
  "{",
  "    gl_FragColor = vec4(0.0);",
  "    %blur%",
  "}"
].join(`
`);
function pb(n) {
  const t = db[n], e = t.length;
  let r = fb, i = "";
  const s = "gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;";
  let o;
  for (let a = 0; a < n; a++) {
    let h = s.replace("%index%", a.toString());
    o = a, a >= e && (o = n - a - 1), h = h.replace("%value%", t[o].toString()), i += h, i += `
`;
  }
  return r = r.replace("%blur%", i), r = r.replace("%size%", n.toString()), r;
}
const mb = `
    attribute vec2 aVertexPosition;

    uniform mat3 projectionMatrix;

    uniform float strength;

    varying vec2 vBlurTexCoords[%size%];

    uniform vec4 inputSize;
    uniform vec4 outputFrame;

    vec4 filterVertexPosition( void )
    {
        vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

        return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
    }

    vec2 filterTextureCoord( void )
    {
        return aVertexPosition * (outputFrame.zw * inputSize.zw);
    }

    void main(void)
    {
        gl_Position = filterVertexPosition();

        vec2 textureCoord = filterTextureCoord();
        %blur%
    }`;
function gb(n, t) {
  const e = Math.ceil(n / 2);
  let r = mb, i = "", s;
  t ? s = "vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * strength, 0.0);" : s = "vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * strength);";
  for (let o = 0; o < n; o++) {
    let a = s.replace("%index%", o.toString());
    a = a.replace("%sampleIndex%", `${o - (e - 1)}.0`), i += a, i += `
`;
  }
  return r = r.replace("%blur%", i), r = r.replace("%size%", n.toString()), r;
}
class lc extends ve {
  /**
   * @param horizontal - Do pass along the x-axis (`true`) or y-axis (`false`).
   * @param strength - The strength of the blur filter.
   * @param quality - The quality of the blur filter.
   * @param {number|null} [resolution=PIXI.Filter.defaultResolution] - The resolution of the blur filter.
   * @param kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */
  constructor(t, e = 8, r = 4, i = ve.defaultResolution, s = 5) {
    const o = gb(s, t), a = pb(s);
    super(
      // vertex shader
      o,
      // fragment shader
      a
    ), this.horizontal = t, this.resolution = i, this._quality = 0, this.quality = r, this.blur = e;
  }
  /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */
  apply(t, e, r, i) {
    if (r ? this.horizontal ? this.uniforms.strength = 1 / r.width * (r.width / e.width) : this.uniforms.strength = 1 / r.height * (r.height / e.height) : this.horizontal ? this.uniforms.strength = 1 / t.renderer.width * (t.renderer.width / e.width) : this.uniforms.strength = 1 / t.renderer.height * (t.renderer.height / e.height), this.uniforms.strength *= this.strength, this.uniforms.strength /= this.passes, this.passes === 1)
      t.applyFilter(this, e, r, i);
    else {
      const s = t.getFilterTexture(), o = t.renderer;
      let a = e, h = s;
      this.state.blend = !1, t.applyFilter(this, a, h, Mr.CLEAR);
      for (let l = 1; l < this.passes - 1; l++) {
        t.bindAndClear(a, Mr.BLIT), this.uniforms.uSampler = h;
        const u = h;
        h = a, a = u, o.shader.bind(this), o.geometry.draw(5);
      }
      this.state.blend = !0, t.applyFilter(this, h, r, i), t.returnFilterTexture(s);
    }
  }
  /**
   * Sets the strength of both the blur.
   * @default 16
   */
  get blur() {
    return this.strength;
  }
  set blur(t) {
    this.padding = 1 + Math.abs(t) * 2, this.strength = t;
  }
  /**
   * Sets the quality of the blur by modifying the number of passes. More passes means higher
   * quality bluring but the lower the performance.
   * @default 4
   */
  get quality() {
    return this._quality;
  }
  set quality(t) {
    this._quality = t, this.passes = t;
  }
}
class yb extends ve {
  /**
   * @param strength - The strength of the blur filter.
   * @param quality - The quality of the blur filter.
   * @param {number|null} [resolution=PIXI.Filter.defaultResolution] - The resolution of the blur filter.
   * @param kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */
  constructor(t = 8, e = 4, r = ve.defaultResolution, i = 5) {
    super(), this._repeatEdgePixels = !1, this.blurXFilter = new lc(!0, t, e, r, i), this.blurYFilter = new lc(!1, t, e, r, i), this.resolution = r, this.quality = e, this.blur = t, this.repeatEdgePixels = !1;
  }
  /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */
  apply(t, e, r, i) {
    const s = Math.abs(this.blurXFilter.strength), o = Math.abs(this.blurYFilter.strength);
    if (s && o) {
      const a = t.getFilterTexture();
      this.blurXFilter.apply(t, e, a, Mr.CLEAR), this.blurYFilter.apply(t, a, r, i), t.returnFilterTexture(a);
    } else
      o ? this.blurYFilter.apply(t, e, r, i) : this.blurXFilter.apply(t, e, r, i);
  }
  updatePadding() {
    this._repeatEdgePixels ? this.padding = 0 : this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
  }
  /**
   * Sets the strength of both the blurX and blurY properties simultaneously
   * @default 2
   */
  get blur() {
    return this.blurXFilter.blur;
  }
  set blur(t) {
    this.blurXFilter.blur = this.blurYFilter.blur = t, this.updatePadding();
  }
  /**
   * Sets the number of passes for blur. More passes means higher quality bluring.
   * @default 1
   */
  get quality() {
    return this.blurXFilter.quality;
  }
  set quality(t) {
    this.blurXFilter.quality = this.blurYFilter.quality = t;
  }
  /**
   * Sets the strength of the blurX property
   * @default 2
   */
  get blurX() {
    return this.blurXFilter.blur;
  }
  set blurX(t) {
    this.blurXFilter.blur = t, this.updatePadding();
  }
  /**
   * Sets the strength of the blurY property
   * @default 2
   */
  get blurY() {
    return this.blurYFilter.blur;
  }
  set blurY(t) {
    this.blurYFilter.blur = t, this.updatePadding();
  }
  /**
   * Sets the blendmode of the filter
   * @default PIXI.BLEND_MODES.NORMAL
   */
  get blendMode() {
    return this.blurYFilter.blendMode;
  }
  set blendMode(t) {
    this.blurYFilter.blendMode = t;
  }
  /**
   * If set to true the edge of the target will be clamped
   * @default false
   */
  get repeatEdgePixels() {
    return this._repeatEdgePixels;
  }
  set repeatEdgePixels(t) {
    this._repeatEdgePixels = t, this.updatePadding();
  }
}
var _b = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float m[20];
uniform float uAlpha;

void main(void)
{
    vec4 c = texture2D(uSampler, vTextureCoord);

    if (uAlpha == 0.0) {
        gl_FragColor = c;
        return;
    }

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (c.a > 0.0) {
      c.rgb /= c.a;
    }

    vec4 result;

    result.r = (m[0] * c.r);
        result.r += (m[1] * c.g);
        result.r += (m[2] * c.b);
        result.r += (m[3] * c.a);
        result.r += m[4];

    result.g = (m[5] * c.r);
        result.g += (m[6] * c.g);
        result.g += (m[7] * c.b);
        result.g += (m[8] * c.a);
        result.g += m[9];

    result.b = (m[10] * c.r);
       result.b += (m[11] * c.g);
       result.b += (m[12] * c.b);
       result.b += (m[13] * c.a);
       result.b += m[14];

    result.a = (m[15] * c.r);
       result.a += (m[16] * c.g);
       result.a += (m[17] * c.b);
       result.a += (m[18] * c.a);
       result.a += m[19];

    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);

    // Premultiply alpha again.
    rgb *= result.a;

    gl_FragColor = vec4(rgb, result.a);
}
`;
class uc extends ve {
  constructor() {
    const t = {
      m: new Float32Array([
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ]),
      uAlpha: 1
    };
    super(P0, _b, t), this.alpha = 1;
  }
  /**
   * Transforms current matrix and set the new one
   * @param {number[]} matrix - 5x4 matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  _loadMatrix(t, e = !1) {
    let r = t;
    e && (this._multiply(r, this.uniforms.m, t), r = this._colorMatrix(r)), this.uniforms.m = r;
  }
  /**
   * Multiplies two mat5's
   * @private
   * @param out - 5x4 matrix the receiving matrix
   * @param a - 5x4 matrix the first operand
   * @param b - 5x4 matrix the second operand
   * @returns {number[]} 5x4 matrix
   */
  _multiply(t, e, r) {
    return t[0] = e[0] * r[0] + e[1] * r[5] + e[2] * r[10] + e[3] * r[15], t[1] = e[0] * r[1] + e[1] * r[6] + e[2] * r[11] + e[3] * r[16], t[2] = e[0] * r[2] + e[1] * r[7] + e[2] * r[12] + e[3] * r[17], t[3] = e[0] * r[3] + e[1] * r[8] + e[2] * r[13] + e[3] * r[18], t[4] = e[0] * r[4] + e[1] * r[9] + e[2] * r[14] + e[3] * r[19] + e[4], t[5] = e[5] * r[0] + e[6] * r[5] + e[7] * r[10] + e[8] * r[15], t[6] = e[5] * r[1] + e[6] * r[6] + e[7] * r[11] + e[8] * r[16], t[7] = e[5] * r[2] + e[6] * r[7] + e[7] * r[12] + e[8] * r[17], t[8] = e[5] * r[3] + e[6] * r[8] + e[7] * r[13] + e[8] * r[18], t[9] = e[5] * r[4] + e[6] * r[9] + e[7] * r[14] + e[8] * r[19] + e[9], t[10] = e[10] * r[0] + e[11] * r[5] + e[12] * r[10] + e[13] * r[15], t[11] = e[10] * r[1] + e[11] * r[6] + e[12] * r[11] + e[13] * r[16], t[12] = e[10] * r[2] + e[11] * r[7] + e[12] * r[12] + e[13] * r[17], t[13] = e[10] * r[3] + e[11] * r[8] + e[12] * r[13] + e[13] * r[18], t[14] = e[10] * r[4] + e[11] * r[9] + e[12] * r[14] + e[13] * r[19] + e[14], t[15] = e[15] * r[0] + e[16] * r[5] + e[17] * r[10] + e[18] * r[15], t[16] = e[15] * r[1] + e[16] * r[6] + e[17] * r[11] + e[18] * r[16], t[17] = e[15] * r[2] + e[16] * r[7] + e[17] * r[12] + e[18] * r[17], t[18] = e[15] * r[3] + e[16] * r[8] + e[17] * r[13] + e[18] * r[18], t[19] = e[15] * r[4] + e[16] * r[9] + e[17] * r[14] + e[18] * r[19] + e[19], t;
  }
  /**
   * Create a Float32 Array and normalize the offset component to 0-1
   * @param {number[]} matrix - 5x4 matrix
   * @returns {number[]} 5x4 matrix with all values between 0-1
   */
  _colorMatrix(t) {
    const e = new Float32Array(t);
    return e[4] /= 255, e[9] /= 255, e[14] /= 255, e[19] /= 255, e;
  }
  /**
   * Adjusts brightness
   * @param b - value of the brigthness (0-1, where 0 is black)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  brightness(t, e) {
    const r = [
      t,
      0,
      0,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(r, e);
  }
  /**
   * Sets each channel on the diagonal of the color matrix.
   * This can be used to achieve a tinting effect on Containers similar to the tint field of some
   * display objects like Sprite, Text, Graphics, and Mesh.
   * @param color - Color of the tint. This is a hex value.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  tint(t, e) {
    const [r, i, s] = Ot.shared.setValue(t).toArray(), o = [
      r,
      0,
      0,
      0,
      0,
      0,
      i,
      0,
      0,
      0,
      0,
      0,
      s,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(o, e);
  }
  /**
   * Set the matrices in grey scales
   * @param scale - value of the grey (0-1, where 0 is black)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  greyscale(t, e) {
    const r = [
      t,
      t,
      t,
      0,
      0,
      t,
      t,
      t,
      0,
      0,
      t,
      t,
      t,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(r, e);
  }
  /**
   * Set the black and white matrice.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  blackAndWhite(t) {
    const e = [
      0.3,
      0.6,
      0.1,
      0,
      0,
      0.3,
      0.6,
      0.1,
      0,
      0,
      0.3,
      0.6,
      0.1,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(e, t);
  }
  /**
   * Set the hue property of the color
   * @param rotation - in degrees
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  hue(t, e) {
    t = (t || 0) / 180 * Math.PI;
    const r = Math.cos(t), i = Math.sin(t), s = Math.sqrt, o = 1 / 3, a = s(o), h = r + (1 - r) * o, l = o * (1 - r) - a * i, u = o * (1 - r) + a * i, c = o * (1 - r) + a * i, d = r + o * (1 - r), f = o * (1 - r) - a * i, p = o * (1 - r) - a * i, m = o * (1 - r) + a * i, g = r + o * (1 - r), _ = [
      h,
      l,
      u,
      0,
      0,
      c,
      d,
      f,
      0,
      0,
      p,
      m,
      g,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(_, e);
  }
  /**
   * Set the contrast matrix, increase the separation between dark and bright
   * Increase contrast : shadows darker and highlights brighter
   * Decrease contrast : bring the shadows up and the highlights down
   * @param amount - value of the contrast (0-1)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  contrast(t, e) {
    const r = (t || 0) + 1, i = -0.5 * (r - 1), s = [
      r,
      0,
      0,
      0,
      i,
      0,
      r,
      0,
      0,
      i,
      0,
      0,
      r,
      0,
      i,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(s, e);
  }
  /**
   * Set the saturation matrix, increase the separation between colors
   * Increase saturation : increase contrast, brightness, and sharpness
   * @param amount - The saturation amount (0-1)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  saturate(t = 0, e) {
    const r = t * 2 / 3 + 1, i = (r - 1) * -0.5, s = [
      r,
      i,
      i,
      0,
      0,
      i,
      r,
      i,
      0,
      0,
      i,
      i,
      r,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(s, e);
  }
  /** Desaturate image (remove color) Call the saturate function */
  desaturate() {
    this.saturate(-1);
  }
  /**
   * Negative image (inverse of classic rgb matrix)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  negative(t) {
    const e = [
      -1,
      0,
      0,
      1,
      0,
      0,
      -1,
      0,
      1,
      0,
      0,
      0,
      -1,
      1,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(e, t);
  }
  /**
   * Sepia image
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  sepia(t) {
    const e = [
      0.393,
      0.7689999,
      0.18899999,
      0,
      0,
      0.349,
      0.6859999,
      0.16799999,
      0,
      0,
      0.272,
      0.5339999,
      0.13099999,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(e, t);
  }
  /**
   * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  technicolor(t) {
    const e = [
      1.9125277891456083,
      -0.8545344976951645,
      -0.09155508482755585,
      0,
      11.793603434377337,
      -0.3087833385928097,
      1.7658908555458428,
      -0.10601743074722245,
      0,
      -70.35205161461398,
      -0.231103377548616,
      -0.7501899197440212,
      1.847597816108189,
      0,
      30.950940869491138,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(e, t);
  }
  /**
   * Polaroid filter
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  polaroid(t) {
    const e = [
      1.438,
      -0.062,
      -0.062,
      0,
      0,
      -0.122,
      1.378,
      -0.122,
      0,
      0,
      -0.016,
      -0.016,
      1.483,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(e, t);
  }
  /**
   * Filter who transforms : Red -> Blue and Blue -> Red
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  toBGR(t) {
    const e = [
      0,
      0,
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(e, t);
  }
  /**
   * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  kodachrome(t) {
    const e = [
      1.1285582396593525,
      -0.3967382283601348,
      -0.03992559172921793,
      0,
      63.72958762196502,
      -0.16404339962244616,
      1.0835251566291304,
      -0.05498805115633132,
      0,
      24.732407896706203,
      -0.16786010706155763,
      -0.5603416277695248,
      1.6014850761964943,
      0,
      35.62982807460946,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(e, t);
  }
  /**
   * Brown delicious browni filter (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  browni(t) {
    const e = [
      0.5997023498159715,
      0.34553243048391263,
      -0.2708298674538042,
      0,
      47.43192855600873,
      -0.037703249837783157,
      0.8609577587992641,
      0.15059552388459913,
      0,
      -36.96841498319127,
      0.24113635128153335,
      -0.07441037908422492,
      0.44972182064877153,
      0,
      -7.562075277591283,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(e, t);
  }
  /**
   * Vintage filter (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  vintage(t) {
    const e = [
      0.6279345635605994,
      0.3202183420819367,
      -0.03965408211312453,
      0,
      9.651285835294123,
      0.02578397704808868,
      0.6441188644374771,
      0.03259127616149294,
      0,
      7.462829176470591,
      0.0466055556782719,
      -0.0851232987247891,
      0.5241648018700465,
      0,
      5.159190588235296,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(e, t);
  }
  /**
   * We don't know exactly what it does, kind of gradient map, but funny to play with!
   * @param desaturation - Tone values.
   * @param toned - Tone values.
   * @param lightColor - Tone values, example: `0xFFE580`
   * @param darkColor - Tone values, example: `0xFFE580`
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  colorTone(t, e, r, i, s) {
    t = t || 0.2, e = e || 0.15, r = r || 16770432, i = i || 3375104;
    const o = Ot.shared, [a, h, l] = o.setValue(r).toArray(), [u, c, d] = o.setValue(i).toArray(), f = [
      0.3,
      0.59,
      0.11,
      0,
      0,
      a,
      h,
      l,
      t,
      0,
      u,
      c,
      d,
      e,
      0,
      a - u,
      h - c,
      l - d,
      0,
      0
    ];
    this._loadMatrix(f, s);
  }
  /**
   * Night effect
   * @param intensity - The intensity of the night effect.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  night(t, e) {
    t = t || 0.1;
    const r = [
      t * -2,
      -t,
      0,
      0,
      0,
      -t,
      0,
      t,
      0,
      0,
      0,
      t,
      t * 2,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(r, e);
  }
  /**
   * Predator effect
   *
   * Erase the current matrix by setting a new indepent one
   * @param amount - how much the predator feels his future victim
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  predator(t, e) {
    const r = [
      // row 1
      11.224130630493164 * t,
      -4.794486999511719 * t,
      -2.8746118545532227 * t,
      0 * t,
      0.40342438220977783 * t,
      // row 2
      -3.6330697536468506 * t,
      9.193157196044922 * t,
      -2.951810836791992 * t,
      0 * t,
      -1.316135048866272 * t,
      // row 3
      -3.2184197902679443 * t,
      -4.2375030517578125 * t,
      7.476448059082031 * t,
      0 * t,
      0.8044459223747253 * t,
      // row 4
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(r, e);
  }
  /**
   * LSD effect
   *
   * Multiply the current matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  lsd(t) {
    const e = [
      2,
      -0.4,
      0.5,
      0,
      0,
      -0.5,
      2,
      -0.4,
      0,
      0,
      -0.4,
      -0.5,
      3,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(e, t);
  }
  /** Erase the current matrix by setting the default one. */
  reset() {
    const t = [
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(t, !1);
  }
  /**
   * The matrix of the color matrix filter
   * @member {number[]}
   * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
   */
  get matrix() {
    return this.uniforms.m;
  }
  set matrix(t) {
    this.uniforms.m = t;
  }
  /**
   * The opacity value to use when mixing the original and resultant colors.
   *
   * When the value is 0, the original color is used without modification.
   * When the value is 1, the result color is used.
   * When in the range (0, 1) the color is interpolated between the original and result by this amount.
   * @default 1
   */
  get alpha() {
    return this.uniforms.uAlpha;
  }
  set alpha(t) {
    this.uniforms.uAlpha = t;
  }
}
uc.prototype.grayscale = uc.prototype.greyscale;
var vb = `varying vec2 vFilterCoord;
varying vec2 vTextureCoord;

uniform vec2 scale;
uniform mat2 rotation;
uniform sampler2D uSampler;
uniform sampler2D mapSampler;

uniform highp vec4 inputSize;
uniform vec4 inputClamp;

void main(void)
{
  vec4 map =  texture2D(mapSampler, vFilterCoord);

  map -= 0.5;
  map.xy = scale * inputSize.zw * (rotation * map.xy);

  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), inputClamp.xy, inputClamp.zw));
}
`, xb = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;
uniform mat3 filterMatrix;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
	gl_Position = filterVertexPosition();
	vTextureCoord = filterTextureCoord();
	vFilterCoord = ( filterMatrix * vec3( vTextureCoord, 1.0)  ).xy;
}
`;
class wb extends ve {
  /**
   * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
   * @param scale - The scale of the displacement
   */
  constructor(t, e) {
    const r = new Nt();
    t.renderable = !1, super(xb, vb, {
      mapSampler: t._texture,
      filterMatrix: r,
      scale: { x: 1, y: 1 },
      rotation: new Float32Array([1, 0, 0, 1])
    }), this.maskSprite = t, this.maskMatrix = r, e == null && (e = 20), this.scale = new mt(e, e);
  }
  /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - clearMode.
   */
  apply(t, e, r, i) {
    this.uniforms.filterMatrix = t.calculateSpriteMatrix(this.maskMatrix, this.maskSprite), this.uniforms.scale.x = this.scale.x, this.uniforms.scale.y = this.scale.y;
    const s = this.maskSprite.worldTransform, o = Math.sqrt(s.a * s.a + s.b * s.b), a = Math.sqrt(s.c * s.c + s.d * s.d);
    o !== 0 && a !== 0 && (this.uniforms.rotation[0] = s.a / o, this.uniforms.rotation[1] = s.b / o, this.uniforms.rotation[2] = s.c / a, this.uniforms.rotation[3] = s.d / a), t.applyFilter(this, e, r, i);
  }
  /** The texture used for the displacement map. Must be power of 2 sized texture. */
  get map() {
    return this.uniforms.mapSampler;
  }
  set map(t) {
    this.uniforms.mapSampler = t;
  }
}
var bb = `varying vec2 v_rgbNW;
varying vec2 v_rgbNE;
varying vec2 v_rgbSW;
varying vec2 v_rgbSE;
varying vec2 v_rgbM;

varying vec2 vFragCoord;
uniform sampler2D uSampler;
uniform highp vec4 inputSize;


/**
 Basic FXAA implementation based on the code on geeks3d.com with the
 modification that the texture2DLod stuff was removed since it's
 unsupported by WebGL.

 --

 From:
 https://github.com/mitsuhiko/webgl-meincraft

 Copyright (c) 2011 by Armin Ronacher.

 Some rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are
 met:

 * Redistributions of source code must retain the above copyright
 notice, this list of conditions and the following disclaimer.

 * Redistributions in binary form must reproduce the above
 copyright notice, this list of conditions and the following
 disclaimer in the documentation and/or other materials provided
 with the distribution.

 * The names of the contributors may not be used to endorse or
 promote products derived from this software without specific
 prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

#ifndef FXAA_REDUCE_MIN
#define FXAA_REDUCE_MIN   (1.0/ 128.0)
#endif
#ifndef FXAA_REDUCE_MUL
#define FXAA_REDUCE_MUL   (1.0 / 8.0)
#endif
#ifndef FXAA_SPAN_MAX
#define FXAA_SPAN_MAX     8.0
#endif

//optimized version for mobile, where dependent
//texture reads can be a bottleneck
vec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 inverseVP,
          vec2 v_rgbNW, vec2 v_rgbNE,
          vec2 v_rgbSW, vec2 v_rgbSE,
          vec2 v_rgbM) {
    vec4 color;
    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;
    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;
    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;
    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;
    vec4 texColor = texture2D(tex, v_rgbM);
    vec3 rgbM  = texColor.xyz;
    vec3 luma = vec3(0.299, 0.587, 0.114);
    float lumaNW = dot(rgbNW, luma);
    float lumaNE = dot(rgbNE, luma);
    float lumaSW = dot(rgbSW, luma);
    float lumaSE = dot(rgbSE, luma);
    float lumaM  = dot(rgbM,  luma);
    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));
    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));

    mediump vec2 dir;
    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));
    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));

    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *
                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);

    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);
    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),
              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),
                  dir * rcpDirMin)) * inverseVP;

    vec3 rgbA = 0.5 * (
                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +
                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);
    vec3 rgbB = rgbA * 0.5 + 0.25 * (
                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +
                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);

    float lumaB = dot(rgbB, luma);
    if ((lumaB < lumaMin) || (lumaB > lumaMax))
        color = vec4(rgbA, texColor.a);
    else
        color = vec4(rgbB, texColor.a);
    return color;
}

void main() {

      vec4 color;

      color = fxaa(uSampler, vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);

      gl_FragColor = color;
}
`, Tb = `
attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 v_rgbNW;
varying vec2 v_rgbNE;
varying vec2 v_rgbSW;
varying vec2 v_rgbSE;
varying vec2 v_rgbM;

varying vec2 vFragCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

void texcoords(vec2 fragCoord, vec2 inverseVP,
               out vec2 v_rgbNW, out vec2 v_rgbNE,
               out vec2 v_rgbSW, out vec2 v_rgbSE,
               out vec2 v_rgbM) {
    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;
    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;
    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;
    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;
    v_rgbM = vec2(fragCoord * inverseVP);
}

void main(void) {

   gl_Position = filterVertexPosition();

   vFragCoord = aVertexPosition * outputFrame.zw;

   texcoords(vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);
}
`;
class Ab extends ve {
  constructor() {
    super(Tb, bb);
  }
}
var Eb = `precision highp float;

varying vec2 vTextureCoord;
varying vec4 vColor;

uniform float uNoise;
uniform float uSeed;
uniform sampler2D uSampler;

float rand(vec2 co)
{
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

void main()
{
    vec4 color = texture2D(uSampler, vTextureCoord);
    float randomValue = rand(gl_FragCoord.xy * uSeed);
    float diff = (randomValue - 0.5) * uNoise;

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (color.a > 0.0) {
        color.rgb /= color.a;
    }

    color.r += diff;
    color.g += diff;
    color.b += diff;

    // Premultiply alpha again.
    color.rgb *= color.a;

    gl_FragColor = color;
}
`;
class Sb extends ve {
  /**
   * @param {number} [noise=0.5] - The noise intensity, should be a normalized value in the range [0, 1].
   * @param {number} [seed] - A random seed for the noise generation. Default is `Math.random()`.
   */
  constructor(t = 0.5, e = Math.random()) {
    super(P0, Eb, {
      uNoise: 0,
      uSeed: 0
    }), this.noise = t, this.seed = e;
  }
  /**
   * The amount of noise to apply, this value should be in the range (0, 1].
   * @default 0.5
   */
  get noise() {
    return this.uniforms.uNoise;
  }
  set noise(t) {
    this.uniforms.uNoise = t;
  }
  /** A seed value to apply to the random noise generation. `Math.random()` is a good value to use. */
  get seed() {
    return this.uniforms.uSeed;
  }
  set seed(t) {
    this.uniforms.uSeed = t;
  }
}
const $p = {
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.AlphaFilter
   */
  AlphaFilter: cb,
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.BlurFilter
   */
  BlurFilter: yb,
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.BlurFilterPass
   */
  BlurFilterPass: lc,
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.ColorMatrixFilter
   */
  ColorMatrixFilter: uc,
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.DisplacementFilter
   */
  DisplacementFilter: wb,
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.FXAAFilter
   */
  FXAAFilter: Ab,
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.NoiseFilter
   */
  NoiseFilter: Sb
};
Object.entries($p).forEach(([n, t]) => {
  Object.defineProperty($p, n, {
    get() {
      return wt("7.1.0", `filters.${n} has moved to ${n}`), t;
    }
  });
});
class Cb {
  constructor() {
    this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this.tickerAdded = !1, this._pauseUpdate = !0;
  }
  /**
   * Initializes the event ticker.
   * @param events - The event system.
   */
  init(t) {
    this.removeTickerListener(), this.events = t, this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this.tickerAdded = !1, this._pauseUpdate = !0;
  }
  /** Whether to pause the update checks or not. */
  get pauseUpdate() {
    return this._pauseUpdate;
  }
  set pauseUpdate(t) {
    this._pauseUpdate = t;
  }
  /** Adds the ticker listener. */
  addTickerListener() {
    this.tickerAdded || !this.domElement || (xe.system.add(this.tickerUpdate, this, Ai.INTERACTION), this.tickerAdded = !0);
  }
  /** Removes the ticker listener. */
  removeTickerListener() {
    this.tickerAdded && (xe.system.remove(this.tickerUpdate, this), this.tickerAdded = !1);
  }
  /** Sets flag to not fire extra events when the user has already moved there mouse */
  pointerMoved() {
    this._didMove = !0;
  }
  /** Updates the state of interactive objects. */
  update() {
    if (!this.domElement || this._pauseUpdate)
      return;
    if (this._didMove) {
      this._didMove = !1;
      return;
    }
    const t = this.events.rootPointerEvent;
    this.events.supportsTouchEvents && t.pointerType === "touch" || globalThis.document.dispatchEvent(new PointerEvent("pointermove", {
      clientX: t.clientX,
      clientY: t.clientY
    }));
  }
  /**
   * Updates the state of interactive objects if at least {@link interactionFrequency}
   * milliseconds have passed since the last invocation.
   *
   * Invoked by a throttled ticker update from {@link PIXI.Ticker.system}.
   * @param deltaTime - time delta since the last call
   */
  tickerUpdate(t) {
    this._deltaTime += t, !(this._deltaTime < this.interactionFrequency) && (this._deltaTime = 0, this.update());
  }
}
const En = new Cb();
class Mo {
  /**
   * @param manager - The event boundary which manages this event. Propagation can only occur
   *  within the boundary's jurisdiction.
   */
  constructor(t) {
    this.bubbles = !0, this.cancelBubble = !0, this.cancelable = !1, this.composed = !1, this.defaultPrevented = !1, this.eventPhase = Mo.prototype.NONE, this.propagationStopped = !1, this.propagationImmediatelyStopped = !1, this.layer = new mt(), this.page = new mt(), this.NONE = 0, this.CAPTURING_PHASE = 1, this.AT_TARGET = 2, this.BUBBLING_PHASE = 3, this.manager = t;
  }
  /** @readonly */
  get layerX() {
    return this.layer.x;
  }
  /** @readonly */
  get layerY() {
    return this.layer.y;
  }
  /** @readonly */
  get pageX() {
    return this.page.x;
  }
  /** @readonly */
  get pageY() {
    return this.page.y;
  }
  /**
   * Fallback for the deprecated @code{PIXI.InteractionEvent.data}.
   * @deprecated since 7.0.0
   */
  get data() {
    return this;
  }
  /** The propagation path for this event. Alias for {@link PIXI.EventBoundary.propagationPath}. */
  composedPath() {
    return this.manager && (!this.path || this.path[this.path.length - 1] !== this.target) && (this.path = this.target ? this.manager.propagationPath(this.target) : []), this.path;
  }
  /**
   * Unimplemented method included for implementing the DOM interface {@code Event}. It will throw an {@code Error}.
   * @deprecated
   * @param _type
   * @param _bubbles
   * @param _cancelable
   */
  initEvent(t, e, r) {
    throw new Error("initEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /**
   * Unimplemented method included for implementing the DOM interface {@code UIEvent}. It will throw an {@code Error}.
   * @deprecated
   * @param _typeArg
   * @param _bubblesArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   */
  initUIEvent(t, e, r, i, s) {
    throw new Error("initUIEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /** Prevent default behavior of PixiJS and the user agent. */
  preventDefault() {
    this.nativeEvent instanceof Event && this.nativeEvent.cancelable && this.nativeEvent.preventDefault(), this.defaultPrevented = !0;
  }
  /**
   * Stop this event from propagating to any addition listeners, including on the
   * {@link PIXI.FederatedEventTarget.currentTarget currentTarget} and also the following
   * event targets on the propagation path.
   */
  stopImmediatePropagation() {
    this.propagationImmediatelyStopped = !0;
  }
  /**
   * Stop this event from propagating to the next {@link PIXI.FederatedEventTarget}. The rest of the listeners
   * on the {@link PIXI.FederatedEventTarget.currentTarget currentTarget} will still be notified.
   */
  stopPropagation() {
    this.propagationStopped = !0;
  }
}
class Ka extends Mo {
  constructor() {
    super(...arguments), this.client = new mt(), this.movement = new mt(), this.offset = new mt(), this.global = new mt(), this.screen = new mt();
  }
  /** @readonly */
  get clientX() {
    return this.client.x;
  }
  /** @readonly */
  get clientY() {
    return this.client.y;
  }
  /**
   * Alias for {@link PIXI.FederatedMouseEvent.clientX this.clientX}.
   * @readonly
   */
  get x() {
    return this.clientX;
  }
  /**
   * Alias for {@link PIXI.FederatedMouseEvent.clientY this.clientY}.
   * @readonly
   */
  get y() {
    return this.clientY;
  }
  /** @readonly */
  get movementX() {
    return this.movement.x;
  }
  /** @readonly */
  get movementY() {
    return this.movement.y;
  }
  /** @readonly */
  get offsetX() {
    return this.offset.x;
  }
  /** @readonly */
  get offsetY() {
    return this.offset.y;
  }
  /** @readonly */
  get globalX() {
    return this.global.x;
  }
  /** @readonly */
  get globalY() {
    return this.global.y;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for {@code screen.x}.
   * @readonly
   */
  get screenX() {
    return this.screen.x;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for {@code screen.y}.
   * @readonly
   */
  get screenY() {
    return this.screen.y;
  }
  /**
   * This will return the local coordinates of the specified displayObject for this InteractionData
   * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
   *  coords off
   * @param {PIXI.IPointData} point - A Point object in which to store the value, optional (otherwise
   *  will create a new point)
   * @param {PIXI.IPointData} globalPos - A Point object containing your custom global coords, optional
   *  (otherwise will use the current global coords)
   * @returns - A point containing the coordinates of the InteractionData position relative
   *  to the DisplayObject
   */
  getLocalPosition(t, e, r) {
    return t.worldTransform.applyInverse(r || this.global, e);
  }
  /**
   * Whether the modifier key was pressed when this event natively occurred.
   * @param key - The modifier key.
   */
  getModifierState(t) {
    return "getModifierState" in this.nativeEvent && this.nativeEvent.getModifierState(t);
  }
  /**
   * Not supported.
   * @param _typeArg
   * @param _canBubbleArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   * @param _screenXArg
   * @param _screenYArg
   * @param _clientXArg
   * @param _clientYArg
   * @param _ctrlKeyArg
   * @param _altKeyArg
   * @param _shiftKeyArg
   * @param _metaKeyArg
   * @param _buttonArg
   * @param _relatedTargetArg
   * @deprecated since 7.0.0
   */
  // eslint-disable-next-line max-params
  initMouseEvent(t, e, r, i, s, o, a, h, l, u, c, d, f, p, m) {
    throw new Error("Method not implemented.");
  }
}
class ur extends Ka {
  constructor() {
    super(...arguments), this.width = 0, this.height = 0, this.isPrimary = !1;
  }
  // Only included for completeness for now
  getCoalescedEvents() {
    return this.type === "pointermove" || this.type === "mousemove" || this.type === "touchmove" ? [this] : [];
  }
  // Only included for completeness for now
  getPredictedEvents() {
    throw new Error("getPredictedEvents is not supported!");
  }
}
class ns extends Ka {
  constructor() {
    super(...arguments), this.DOM_DELTA_PIXEL = 0, this.DOM_DELTA_LINE = 1, this.DOM_DELTA_PAGE = 2;
  }
}
ns.DOM_DELTA_PIXEL = 0, /** Units specified in lines. */
ns.DOM_DELTA_LINE = 1, /** Units specified in pages. */
ns.DOM_DELTA_PAGE = 2;
const Mb = 2048, Ib = new mt(), hu = new mt();
class Pb {
  /**
   * @param rootTarget - The holder of the event boundary.
   */
  constructor(t) {
    this.dispatch = new Co(), this.moveOnAll = !1, this.enableGlobalMoveEvents = !0, this.mappingState = {
      trackingData: {}
    }, this.eventPool = /* @__PURE__ */ new Map(), this._allInteractiveElements = [], this._hitElements = [], this._isPointerMoveEvent = !1, this.rootTarget = t, this.hitPruneFn = this.hitPruneFn.bind(this), this.hitTestFn = this.hitTestFn.bind(this), this.mapPointerDown = this.mapPointerDown.bind(this), this.mapPointerMove = this.mapPointerMove.bind(this), this.mapPointerOut = this.mapPointerOut.bind(this), this.mapPointerOver = this.mapPointerOver.bind(this), this.mapPointerUp = this.mapPointerUp.bind(this), this.mapPointerUpOutside = this.mapPointerUpOutside.bind(this), this.mapWheel = this.mapWheel.bind(this), this.mappingTable = {}, this.addEventMapping("pointerdown", this.mapPointerDown), this.addEventMapping("pointermove", this.mapPointerMove), this.addEventMapping("pointerout", this.mapPointerOut), this.addEventMapping("pointerleave", this.mapPointerOut), this.addEventMapping("pointerover", this.mapPointerOver), this.addEventMapping("pointerup", this.mapPointerUp), this.addEventMapping("pointerupoutside", this.mapPointerUpOutside), this.addEventMapping("wheel", this.mapWheel);
  }
  /**
   * Adds an event mapping for the event `type` handled by `fn`.
   *
   * Event mappings can be used to implement additional or custom events. They take an event
   * coming from the upstream scene (or directly from the {@link PIXI.EventSystem}) and dispatch new downstream events
   * generally trickling down and bubbling up to {@link PIXI.EventBoundary.rootTarget this.rootTarget}.
   *
   * To modify the semantics of existing events, the built-in mapping methods of EventBoundary should be overridden
   * instead.
   * @param type - The type of upstream event to map.
   * @param fn - The mapping method. The context of this function must be bound manually, if desired.
   */
  addEventMapping(t, e) {
    this.mappingTable[t] || (this.mappingTable[t] = []), this.mappingTable[t].push({
      fn: e,
      priority: 0
    }), this.mappingTable[t].sort((r, i) => r.priority - i.priority);
  }
  /**
   * Dispatches the given event
   * @param e
   * @param type
   */
  dispatchEvent(t, e) {
    t.propagationStopped = !1, t.propagationImmediatelyStopped = !1, this.propagate(t, e), this.dispatch.emit(e || t.type, t);
  }
  /**
   * Maps the given upstream event through the event boundary and propagates it downstream.
   * @param e
   */
  mapEvent(t) {
    if (!this.rootTarget)
      return;
    const e = this.mappingTable[t.type];
    if (e)
      for (let r = 0, i = e.length; r < i; r++)
        e[r].fn(t);
    else
      console.warn(`[EventBoundary]: Event mapping not defined for ${t.type}`);
  }
  /**
   * Finds the DisplayObject that is the target of a event at the given coordinates.
   *
   * The passed (x,y) coordinates are in the world space above this event boundary.
   * @param x
   * @param y
   */
  hitTest(t, e) {
    En.pauseUpdate = !0;
    const r = this._isPointerMoveEvent && this.enableGlobalMoveEvents ? "hitTestMoveRecursive" : "hitTestRecursive", i = this[r](
      this.rootTarget,
      this.rootTarget.eventMode,
      Ib.set(t, e),
      this.hitTestFn,
      this.hitPruneFn
    );
    return i && i[0];
  }
  /**
   * Propagate the passed event from from {@link PIXI.EventBoundary.rootTarget this.rootTarget} to its
   * target {@code e.target}.
   * @param e - The event to propagate.
   * @param type
   */
  propagate(t, e) {
    if (!t.target)
      return;
    const r = t.composedPath();
    t.eventPhase = t.CAPTURING_PHASE;
    for (let i = 0, s = r.length - 1; i < s; i++)
      if (t.currentTarget = r[i], this.notifyTarget(t, e), t.propagationStopped || t.propagationImmediatelyStopped)
        return;
    if (t.eventPhase = t.AT_TARGET, t.currentTarget = t.target, this.notifyTarget(t, e), !(t.propagationStopped || t.propagationImmediatelyStopped)) {
      t.eventPhase = t.BUBBLING_PHASE;
      for (let i = r.length - 2; i >= 0; i--)
        if (t.currentTarget = r[i], this.notifyTarget(t, e), t.propagationStopped || t.propagationImmediatelyStopped)
          return;
    }
  }
  /**
   * Emits the event {@code e} to all interactive display objects. The event is propagated in the bubbling phase always.
   *
   * This is used in the `globalpointermove` event.
   * @param e - The emitted event.
   * @param type - The listeners to notify.
   * @param targets - The targets to notify.
   */
  all(t, e, r = this._allInteractiveElements) {
    if (r.length === 0)
      return;
    t.eventPhase = t.BUBBLING_PHASE;
    const i = Array.isArray(e) ? e : [e];
    for (let s = r.length - 1; s >= 0; s--)
      i.forEach((o) => {
        t.currentTarget = r[s], this.notifyTarget(t, o);
      });
  }
  /**
   * Finds the propagation path from {@link PIXI.EventBoundary.rootTarget rootTarget} to the passed
   * {@code target}. The last element in the path is {@code target}.
   * @param target
   */
  propagationPath(t) {
    const e = [t];
    for (let r = 0; r < Mb && t !== this.rootTarget; r++) {
      if (!t.parent)
        throw new Error("Cannot find propagation path to disconnected target");
      e.push(t.parent), t = t.parent;
    }
    return e.reverse(), e;
  }
  hitTestMoveRecursive(t, e, r, i, s, o = !1) {
    let a = !1;
    if (this._interactivePrune(t))
      return null;
    if ((t.eventMode === "dynamic" || e === "dynamic") && (En.pauseUpdate = !1), t.interactiveChildren && t.children) {
      const u = t.children;
      for (let c = u.length - 1; c >= 0; c--) {
        const d = u[c], f = this.hitTestMoveRecursive(
          d,
          this._isInteractive(e) ? e : d.eventMode,
          r,
          i,
          s,
          o || s(t, r)
        );
        if (f) {
          if (f.length > 0 && !f[f.length - 1].parent)
            continue;
          const p = t.isInteractive();
          (f.length > 0 || p) && (p && this._allInteractiveElements.push(t), f.push(t)), this._hitElements.length === 0 && (this._hitElements = f), a = !0;
        }
      }
    }
    const h = this._isInteractive(e), l = t.isInteractive();
    return h && l && this._allInteractiveElements.push(t), o || this._hitElements.length > 0 ? null : a ? this._hitElements : h && !s(t, r) && i(t, r) ? l ? [t] : [] : null;
  }
  /**
   * Recursive implementation for {@link PIXI.EventBoundary.hitTest hitTest}.
   * @param currentTarget - The DisplayObject that is to be hit tested.
   * @param eventMode - The event mode for the `currentTarget` or one of its parents.
   * @param location - The location that is being tested for overlap.
   * @param testFn - Callback that determines whether the target passes hit testing. This callback
   *  can assume that `pruneFn` failed to prune the display object.
   * @param pruneFn - Callback that determiness whether the target and all of its children
   *  cannot pass the hit test. It is used as a preliminary optimization to prune entire subtrees
   *  of the scene graph.
   * @returns An array holding the hit testing target and all its ancestors in order. The first element
   *  is the target itself and the last is {@link PIXI.EventBoundary.rootTarget rootTarget}. This is the opposite
   *  order w.r.t. the propagation path. If no hit testing target is found, null is returned.
   */
  hitTestRecursive(t, e, r, i, s) {
    if (this._interactivePrune(t) || s(t, r))
      return null;
    if ((t.eventMode === "dynamic" || e === "dynamic") && (En.pauseUpdate = !1), t.interactiveChildren && t.children) {
      const h = t.children;
      for (let l = h.length - 1; l >= 0; l--) {
        const u = h[l], c = this.hitTestRecursive(
          u,
          this._isInteractive(e) ? e : u.eventMode,
          r,
          i,
          s
        );
        if (c) {
          if (c.length > 0 && !c[c.length - 1].parent)
            continue;
          const d = t.isInteractive();
          return (c.length > 0 || d) && c.push(t), c;
        }
      }
    }
    const o = this._isInteractive(e), a = t.isInteractive();
    return o && i(t, r) ? a ? [t] : [] : null;
  }
  _isInteractive(t) {
    return t === "static" || t === "dynamic";
  }
  _interactivePrune(t) {
    return !!(!t || t.isMask || !t.visible || !t.renderable || t.eventMode === "none" || t.eventMode === "passive" && !t.interactiveChildren || t.isMask);
  }
  /**
   * Checks whether the display object or any of its children cannot pass the hit test at all.
   *
   * {@link PIXI.EventBoundary}'s implementation uses the {@link PIXI.DisplayObject.hitArea hitArea}
   * and {@link PIXI.DisplayObject._mask} for pruning.
   * @param displayObject
   * @param location
   */
  hitPruneFn(t, e) {
    if (t.hitArea && (t.worldTransform.applyInverse(e, hu), !t.hitArea.contains(hu.x, hu.y)))
      return !0;
    if (t._mask) {
      const r = t._mask.isMaskData ? t._mask.maskObject : t._mask;
      if (r && !r.containsPoint?.(e))
        return !0;
    }
    return !1;
  }
  /**
   * Checks whether the display object passes hit testing for the given location.
   * @param displayObject
   * @param location
   * @returns - Whether `displayObject` passes hit testing for `location`.
   */
  hitTestFn(t, e) {
    return t.eventMode === "passive" ? !1 : t.hitArea ? !0 : t.containsPoint ? t.containsPoint(e) : !1;
  }
  /**
   * Notify all the listeners to the event's `currentTarget`.
   *
   * If the `currentTarget` contains the property `on<type>`, then it is called here,
   * simulating the behavior from version 6.x and prior.
   * @param e - The event passed to the target.
   * @param type
   */
  notifyTarget(t, e) {
    e = e ?? t.type;
    const r = `on${e}`;
    t.currentTarget[r]?.(t);
    const i = t.eventPhase === t.CAPTURING_PHASE || t.eventPhase === t.AT_TARGET ? `${e}capture` : e;
    this.notifyListeners(t, i), t.eventPhase === t.AT_TARGET && this.notifyListeners(t, e);
  }
  /**
   * Maps the upstream `pointerdown` events to a downstream `pointerdown` event.
   *
   * `touchstart`, `rightdown`, `mousedown` events are also dispatched for specific pointer types.
   * @param from
   */
  mapPointerDown(t) {
    if (!(t instanceof ur)) {
      console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const e = this.createPointerEvent(t);
    if (this.dispatchEvent(e, "pointerdown"), e.pointerType === "touch")
      this.dispatchEvent(e, "touchstart");
    else if (e.pointerType === "mouse" || e.pointerType === "pen") {
      const i = e.button === 2;
      this.dispatchEvent(e, i ? "rightdown" : "mousedown");
    }
    const r = this.trackingData(t.pointerId);
    r.pressTargetsByButton[t.button] = e.composedPath(), this.freeEvent(e);
  }
  /**
   * Maps the upstream `pointermove` to downstream `pointerout`, `pointerover`, and `pointermove` events, in that order.
   *
   * The tracking data for the specific pointer has an updated `overTarget`. `mouseout`, `mouseover`,
   * `mousemove`, and `touchmove` events are fired as well for specific pointer types.
   * @param from - The upstream `pointermove` event.
   */
  mapPointerMove(t) {
    if (!(t instanceof ur)) {
      console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    this._allInteractiveElements.length = 0, this._hitElements.length = 0, this._isPointerMoveEvent = !0;
    const e = this.createPointerEvent(t);
    this._isPointerMoveEvent = !1;
    const r = e.pointerType === "mouse" || e.pointerType === "pen", i = this.trackingData(t.pointerId), s = this.findMountedTarget(i.overTargets);
    if (i.overTargets?.length > 0 && s !== e.target) {
      const h = t.type === "mousemove" ? "mouseout" : "pointerout", l = this.createPointerEvent(t, h, s);
      if (this.dispatchEvent(l, "pointerout"), r && this.dispatchEvent(l, "mouseout"), !e.composedPath().includes(s)) {
        const u = this.createPointerEvent(t, "pointerleave", s);
        for (u.eventPhase = u.AT_TARGET; u.target && !e.composedPath().includes(u.target); )
          u.currentTarget = u.target, this.notifyTarget(u), r && this.notifyTarget(u, "mouseleave"), u.target = u.target.parent;
        this.freeEvent(u);
      }
      this.freeEvent(l);
    }
    if (s !== e.target) {
      const h = t.type === "mousemove" ? "mouseover" : "pointerover", l = this.clonePointerEvent(e, h);
      this.dispatchEvent(l, "pointerover"), r && this.dispatchEvent(l, "mouseover");
      let u = s?.parent;
      for (; u && u !== this.rootTarget.parent && u !== e.target; )
        u = u.parent;
      if (!u || u === this.rootTarget.parent) {
        const c = this.clonePointerEvent(e, "pointerenter");
        for (c.eventPhase = c.AT_TARGET; c.target && c.target !== s && c.target !== this.rootTarget.parent; )
          c.currentTarget = c.target, this.notifyTarget(c), r && this.notifyTarget(c, "mouseenter"), c.target = c.target.parent;
        this.freeEvent(c);
      }
      this.freeEvent(l);
    }
    const o = [], a = this.enableGlobalMoveEvents ?? !0;
    this.moveOnAll ? o.push("pointermove") : this.dispatchEvent(e, "pointermove"), a && o.push("globalpointermove"), e.pointerType === "touch" && (this.moveOnAll ? o.splice(1, 0, "touchmove") : this.dispatchEvent(e, "touchmove"), a && o.push("globaltouchmove")), r && (this.moveOnAll ? o.splice(1, 0, "mousemove") : this.dispatchEvent(e, "mousemove"), a && o.push("globalmousemove"), this.cursor = e.target?.cursor), o.length > 0 && this.all(e, o), this._allInteractiveElements.length = 0, this._hitElements.length = 0, i.overTargets = e.composedPath(), this.freeEvent(e);
  }
  /**
   * Maps the upstream `pointerover` to downstream `pointerover` and `pointerenter` events, in that order.
   *
   * The tracking data for the specific pointer gets a new `overTarget`.
   * @param from - The upstream `pointerover` event.
   */
  mapPointerOver(t) {
    if (!(t instanceof ur)) {
      console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const e = this.trackingData(t.pointerId), r = this.createPointerEvent(t), i = r.pointerType === "mouse" || r.pointerType === "pen";
    this.dispatchEvent(r, "pointerover"), i && this.dispatchEvent(r, "mouseover"), r.pointerType === "mouse" && (this.cursor = r.target?.cursor);
    const s = this.clonePointerEvent(r, "pointerenter");
    for (s.eventPhase = s.AT_TARGET; s.target && s.target !== this.rootTarget.parent; )
      s.currentTarget = s.target, this.notifyTarget(s), i && this.notifyTarget(s, "mouseenter"), s.target = s.target.parent;
    e.overTargets = r.composedPath(), this.freeEvent(r), this.freeEvent(s);
  }
  /**
   * Maps the upstream `pointerout` to downstream `pointerout`, `pointerleave` events, in that order.
   *
   * The tracking data for the specific pointer is cleared of a `overTarget`.
   * @param from - The upstream `pointerout` event.
   */
  mapPointerOut(t) {
    if (!(t instanceof ur)) {
      console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const e = this.trackingData(t.pointerId);
    if (e.overTargets) {
      const r = t.pointerType === "mouse" || t.pointerType === "pen", i = this.findMountedTarget(e.overTargets), s = this.createPointerEvent(t, "pointerout", i);
      this.dispatchEvent(s), r && this.dispatchEvent(s, "mouseout");
      const o = this.createPointerEvent(t, "pointerleave", i);
      for (o.eventPhase = o.AT_TARGET; o.target && o.target !== this.rootTarget.parent; )
        o.currentTarget = o.target, this.notifyTarget(o), r && this.notifyTarget(o, "mouseleave"), o.target = o.target.parent;
      e.overTargets = null, this.freeEvent(s), this.freeEvent(o);
    }
    this.cursor = null;
  }
  /**
   * Maps the upstream `pointerup` event to downstream `pointerup`, `pointerupoutside`,
   * and `click`/`rightclick`/`pointertap` events, in that order.
   *
   * The `pointerupoutside` event bubbles from the original `pointerdown` target to the most specific
   * ancestor of the `pointerdown` and `pointerup` targets, which is also the `click` event's target. `touchend`,
   * `rightup`, `mouseup`, `touchendoutside`, `rightupoutside`, `mouseupoutside`, and `tap` are fired as well for
   * specific pointer types.
   * @param from - The upstream `pointerup` event.
   */
  mapPointerUp(t) {
    if (!(t instanceof ur)) {
      console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const e = performance.now(), r = this.createPointerEvent(t);
    if (this.dispatchEvent(r, "pointerup"), r.pointerType === "touch")
      this.dispatchEvent(r, "touchend");
    else if (r.pointerType === "mouse" || r.pointerType === "pen") {
      const a = r.button === 2;
      this.dispatchEvent(r, a ? "rightup" : "mouseup");
    }
    const i = this.trackingData(t.pointerId), s = this.findMountedTarget(i.pressTargetsByButton[t.button]);
    let o = s;
    if (s && !r.composedPath().includes(s)) {
      let a = s;
      for (; a && !r.composedPath().includes(a); ) {
        if (r.currentTarget = a, this.notifyTarget(r, "pointerupoutside"), r.pointerType === "touch")
          this.notifyTarget(r, "touchendoutside");
        else if (r.pointerType === "mouse" || r.pointerType === "pen") {
          const h = r.button === 2;
          this.notifyTarget(r, h ? "rightupoutside" : "mouseupoutside");
        }
        a = a.parent;
      }
      delete i.pressTargetsByButton[t.button], o = a;
    }
    if (o) {
      const a = this.clonePointerEvent(r, "click");
      a.target = o, a.path = null, i.clicksByButton[t.button] || (i.clicksByButton[t.button] = {
        clickCount: 0,
        target: a.target,
        timeStamp: e
      });
      const h = i.clicksByButton[t.button];
      if (h.target === a.target && e - h.timeStamp < 200 ? ++h.clickCount : h.clickCount = 1, h.target = a.target, h.timeStamp = e, a.detail = h.clickCount, a.pointerType === "mouse") {
        const l = a.button === 2;
        this.dispatchEvent(a, l ? "rightclick" : "click");
      } else
        a.pointerType === "touch" && this.dispatchEvent(a, "tap");
      this.dispatchEvent(a, "pointertap"), this.freeEvent(a);
    }
    this.freeEvent(r);
  }
  /**
   * Maps the upstream `pointerupoutside` event to a downstream `pointerupoutside` event, bubbling from the original
   * `pointerdown` target to `rootTarget`.
   *
   * (The most specific ancestor of the `pointerdown` event and the `pointerup` event must the
   * `{@link PIXI.EventBoundary}'s root because the `pointerup` event occurred outside of the boundary.)
   *
   * `touchendoutside`, `mouseupoutside`, and `rightupoutside` events are fired as well for specific pointer
   * types. The tracking data for the specific pointer is cleared of a `pressTarget`.
   * @param from - The upstream `pointerupoutside` event.
   */
  mapPointerUpOutside(t) {
    if (!(t instanceof ur)) {
      console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const e = this.trackingData(t.pointerId), r = this.findMountedTarget(e.pressTargetsByButton[t.button]), i = this.createPointerEvent(t);
    if (r) {
      let s = r;
      for (; s; )
        i.currentTarget = s, this.notifyTarget(i, "pointerupoutside"), i.pointerType === "touch" ? this.notifyTarget(i, "touchendoutside") : (i.pointerType === "mouse" || i.pointerType === "pen") && this.notifyTarget(i, i.button === 2 ? "rightupoutside" : "mouseupoutside"), s = s.parent;
      delete e.pressTargetsByButton[t.button];
    }
    this.freeEvent(i);
  }
  /**
   * Maps the upstream `wheel` event to a downstream `wheel` event.
   * @param from - The upstream `wheel` event.
   */
  mapWheel(t) {
    if (!(t instanceof ns)) {
      console.warn("EventBoundary cannot map a non-wheel event as a wheel event");
      return;
    }
    const e = this.createWheelEvent(t);
    this.dispatchEvent(e), this.freeEvent(e);
  }
  /**
   * Finds the most specific event-target in the given propagation path that is still mounted in the scene graph.
   *
   * This is used to find the correct `pointerup` and `pointerout` target in the case that the original `pointerdown`
   * or `pointerover` target was unmounted from the scene graph.
   * @param propagationPath - The propagation path was valid in the past.
   * @returns - The most specific event-target still mounted at the same location in the scene graph.
   */
  findMountedTarget(t) {
    if (!t)
      return null;
    let e = t[0];
    for (let r = 1; r < t.length && t[r].parent === e; r++)
      e = t[r];
    return e;
  }
  /**
   * Creates an event whose {@code originalEvent} is {@code from}, with an optional `type` and `target` override.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The {@code originalEvent} for the returned event.
   * @param [type=from.type] - The type of the returned event.
   * @param target - The target of the returned event.
   */
  createPointerEvent(t, e, r) {
    const i = this.allocateEvent(ur);
    return this.copyPointerData(t, i), this.copyMouseData(t, i), this.copyData(t, i), i.nativeEvent = t.nativeEvent, i.originalEvent = t, i.target = r ?? this.hitTest(i.global.x, i.global.y) ?? this._hitElements[0], typeof e == "string" && (i.type = e), i;
  }
  /**
   * Creates a wheel event whose {@code originalEvent} is {@code from}.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The upstream wheel event.
   */
  createWheelEvent(t) {
    const e = this.allocateEvent(ns);
    return this.copyWheelData(t, e), this.copyMouseData(t, e), this.copyData(t, e), e.nativeEvent = t.nativeEvent, e.originalEvent = t, e.target = this.hitTest(e.global.x, e.global.y), e;
  }
  /**
   * Clones the event {@code from}, with an optional {@code type} override.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The event to clone.
   * @param [type=from.type] - The type of the returned event.
   */
  clonePointerEvent(t, e) {
    const r = this.allocateEvent(ur);
    return r.nativeEvent = t.nativeEvent, r.originalEvent = t.originalEvent, this.copyPointerData(t, r), this.copyMouseData(t, r), this.copyData(t, r), r.target = t.target, r.path = t.composedPath().slice(), r.type = e ?? r.type, r;
  }
  /**
   * Copies wheel {@link PIXI.FederatedWheelEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + deltaMode
   * + deltaX
   * + deltaY
   * + deltaZ
   * @param from
   * @param to
   */
  copyWheelData(t, e) {
    e.deltaMode = t.deltaMode, e.deltaX = t.deltaX, e.deltaY = t.deltaY, e.deltaZ = t.deltaZ;
  }
  /**
   * Copies pointer {@link PIXI.FederatedPointerEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + pointerId
   * + width
   * + height
   * + isPrimary
   * + pointerType
   * + pressure
   * + tangentialPressure
   * + tiltX
   * + tiltY
   * @param from
   * @param to
   */
  copyPointerData(t, e) {
    t instanceof ur && e instanceof ur && (e.pointerId = t.pointerId, e.width = t.width, e.height = t.height, e.isPrimary = t.isPrimary, e.pointerType = t.pointerType, e.pressure = t.pressure, e.tangentialPressure = t.tangentialPressure, e.tiltX = t.tiltX, e.tiltY = t.tiltY, e.twist = t.twist);
  }
  /**
   * Copies mouse {@link PIXI.FederatedMouseEvent} data from {@code from} to {@code to}.
   *
   * The following properties are copied:
   * + altKey
   * + button
   * + buttons
   * + clientX
   * + clientY
   * + metaKey
   * + movementX
   * + movementY
   * + pageX
   * + pageY
   * + x
   * + y
   * + screen
   * + shiftKey
   * + global
   * @param from
   * @param to
   */
  copyMouseData(t, e) {
    t instanceof Ka && e instanceof Ka && (e.altKey = t.altKey, e.button = t.button, e.buttons = t.buttons, e.client.copyFrom(t.client), e.ctrlKey = t.ctrlKey, e.metaKey = t.metaKey, e.movement.copyFrom(t.movement), e.screen.copyFrom(t.screen), e.shiftKey = t.shiftKey, e.global.copyFrom(t.global));
  }
  /**
   * Copies base {@link PIXI.FederatedEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + isTrusted
   * + srcElement
   * + timeStamp
   * + type
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyData(t, e) {
    e.isTrusted = t.isTrusted, e.srcElement = t.srcElement, e.timeStamp = performance.now(), e.type = t.type, e.detail = t.detail, e.view = t.view, e.which = t.which, e.layer.copyFrom(t.layer), e.page.copyFrom(t.page);
  }
  /**
   * @param id - The pointer ID.
   * @returns The tracking data stored for the given pointer. If no data exists, a blank
   *  state will be created.
   */
  trackingData(t) {
    return this.mappingState.trackingData[t] || (this.mappingState.trackingData[t] = {
      pressTargetsByButton: {},
      clicksByButton: {},
      overTarget: null
    }), this.mappingState.trackingData[t];
  }
  /**
   * Allocate a specific type of event from {@link PIXI.EventBoundary#eventPool this.eventPool}.
   *
   * This allocation is constructor-agnostic, as long as it only takes one argument - this event
   * boundary.
   * @param constructor - The event's constructor.
   */
  allocateEvent(t) {
    this.eventPool.has(t) || this.eventPool.set(t, []);
    const e = this.eventPool.get(t).pop() || new t(this);
    return e.eventPhase = e.NONE, e.currentTarget = null, e.path = null, e.target = null, e;
  }
  /**
   * Frees the event and puts it back into the event pool.
   *
   * It is illegal to reuse the event until it is allocated again, using `this.allocateEvent`.
   *
   * It is also advised that events not allocated from {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}
   * not be freed. This is because of the possibility that the same event is freed twice, which can cause
   * it to be allocated twice & result in overwriting.
   * @param event - The event to be freed.
   * @throws Error if the event is managed by another event boundary.
   */
  freeEvent(t) {
    if (t.manager !== this)
      throw new Error("It is illegal to free an event not managed by this EventBoundary!");
    const e = t.constructor;
    this.eventPool.has(e) || this.eventPool.set(e, []), this.eventPool.get(e).push(t);
  }
  /**
   * Similar to {@link PIXI.EventEmitter.emit}, except it stops if the `propagationImmediatelyStopped` flag
   * is set on the event.
   * @param e - The event to call each listener with.
   * @param type - The event key.
   */
  notifyListeners(t, e) {
    const r = t.currentTarget._events[e];
    if (r && t.currentTarget.isInteractive())
      if ("fn" in r)
        r.once && t.currentTarget.removeListener(e, r.fn, void 0, !0), r.fn.call(r.context, t);
      else
        for (let i = 0, s = r.length; i < s && !t.propagationImmediatelyStopped; i++)
          r[i].once && t.currentTarget.removeListener(e, r[i].fn, void 0, !0), r[i].fn.call(r[i].context, t);
  }
}
const Rb = 1, Db = {
  touchstart: "pointerdown",
  touchend: "pointerup",
  touchendoutside: "pointerupoutside",
  touchmove: "pointermove",
  touchcancel: "pointercancel"
}, cc = class dc {
  /**
   * @param {PIXI.Renderer} renderer
   */
  constructor(t) {
    this.supportsTouchEvents = "ontouchstart" in globalThis, this.supportsPointerEvents = !!globalThis.PointerEvent, this.domElement = null, this.resolution = 1, this.renderer = t, this.rootBoundary = new Pb(null), En.init(this), this.autoPreventDefault = !0, this.eventsAdded = !1, this.rootPointerEvent = new ur(null), this.rootWheelEvent = new ns(null), this.cursorStyles = {
      default: "inherit",
      pointer: "pointer"
    }, this.features = new Proxy({ ...dc.defaultEventFeatures }, {
      set: (e, r, i) => (r === "globalMove" && (this.rootBoundary.enableGlobalMoveEvents = i), e[r] = i, !0)
    }), this.onPointerDown = this.onPointerDown.bind(this), this.onPointerMove = this.onPointerMove.bind(this), this.onPointerUp = this.onPointerUp.bind(this), this.onPointerOverOut = this.onPointerOverOut.bind(this), this.onWheel = this.onWheel.bind(this);
  }
  /**
   * The default interaction mode for all display objects.
   * @see PIXI.DisplayObject.eventMode
   * @type {PIXI.EventMode}
   * @readonly
   * @since 7.2.0
   */
  static get defaultEventMode() {
    return this._defaultEventMode;
  }
  /**
   * Runner init called, view is available at this point.
   * @ignore
   */
  init(t) {
    const { view: e, resolution: r } = this.renderer;
    this.setTargetElement(e), this.resolution = r, dc._defaultEventMode = t.eventMode ?? "auto", Object.assign(this.features, t.eventFeatures ?? {}), this.rootBoundary.enableGlobalMoveEvents = this.features.globalMove;
  }
  /**
   * Handle changing resolution.
   * @ignore
   */
  resolutionChange(t) {
    this.resolution = t;
  }
  /** Destroys all event listeners and detaches the renderer. */
  destroy() {
    this.setTargetElement(null), this.renderer = null;
  }
  /**
   * Sets the current cursor mode, handling any callbacks or CSS style changes.
   * @param mode - cursor mode, a key from the cursorStyles dictionary
   */
  setCursor(t) {
    t = t || "default";
    let e = !0;
    if (globalThis.OffscreenCanvas && this.domElement instanceof OffscreenCanvas && (e = !1), this.currentCursor === t)
      return;
    this.currentCursor = t;
    const r = this.cursorStyles[t];
    if (r)
      switch (typeof r) {
        case "string":
          e && (this.domElement.style.cursor = r);
          break;
        case "function":
          r(t);
          break;
        case "object":
          e && Object.assign(this.domElement.style, r);
          break;
      }
    else
      e && typeof t == "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, t) && (this.domElement.style.cursor = t);
  }
  /**
   * The global pointer event.
   * Useful for getting the pointer position without listening to events.
   * @since 7.2.0
   */
  get pointer() {
    return this.rootPointerEvent;
  }
  /**
   * Event handler for pointer down events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  onPointerDown(t) {
    if (!this.features.click)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const e = this.normalizeToPointerData(t);
    this.autoPreventDefault && e[0].isNormalized && (t.cancelable || !("cancelable" in t)) && t.preventDefault();
    for (let r = 0, i = e.length; r < i; r++) {
      const s = e[r], o = this.bootstrapEvent(this.rootPointerEvent, s);
      this.rootBoundary.mapEvent(o);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer move events on on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch events.
   */
  onPointerMove(t) {
    if (!this.features.move)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, En.pointerMoved();
    const e = this.normalizeToPointerData(t);
    for (let r = 0, i = e.length; r < i; r++) {
      const s = this.bootstrapEvent(this.rootPointerEvent, e[r]);
      this.rootBoundary.mapEvent(s);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer up events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  onPointerUp(t) {
    if (!this.features.click)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    let e = t.target;
    t.composedPath && t.composedPath().length > 0 && (e = t.composedPath()[0]);
    const r = e !== this.domElement ? "outside" : "", i = this.normalizeToPointerData(t);
    for (let s = 0, o = i.length; s < o; s++) {
      const a = this.bootstrapEvent(this.rootPointerEvent, i[s]);
      a.type += r, this.rootBoundary.mapEvent(a);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer over & out events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  onPointerOverOut(t) {
    if (!this.features.click)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const e = this.normalizeToPointerData(t);
    for (let r = 0, i = e.length; r < i; r++) {
      const s = this.bootstrapEvent(this.rootPointerEvent, e[r]);
      this.rootBoundary.mapEvent(s);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Passive handler for `wheel` events on {@link PIXI.EventSystem.domElement this.domElement}.
   * @param nativeEvent - The native wheel event.
   */
  onWheel(t) {
    if (!this.features.wheel)
      return;
    const e = this.normalizeWheelEvent(t);
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, this.rootBoundary.mapEvent(e);
  }
  /**
   * Sets the {@link PIXI.EventSystem#domElement domElement} and binds event listeners.
   *
   * To deregister the current DOM element without setting a new one, pass {@code null}.
   * @param element - The new DOM element.
   */
  setTargetElement(t) {
    this.removeEvents(), this.domElement = t, En.domElement = t, this.addEvents();
  }
  /** Register event listeners on {@link PIXI.Renderer#domElement this.domElement}. */
  addEvents() {
    if (this.eventsAdded || !this.domElement)
      return;
    En.addTickerListener();
    const t = this.domElement.style;
    t && (globalThis.navigator.msPointerEnabled ? (t.msContentZooming = "none", t.msTouchAction = "none") : this.supportsPointerEvents && (t.touchAction = "none")), this.supportsPointerEvents ? (globalThis.document.addEventListener("pointermove", this.onPointerMove, !0), this.domElement.addEventListener("pointerdown", this.onPointerDown, !0), this.domElement.addEventListener("pointerleave", this.onPointerOverOut, !0), this.domElement.addEventListener("pointerover", this.onPointerOverOut, !0), globalThis.addEventListener("pointerup", this.onPointerUp, !0)) : (globalThis.document.addEventListener("mousemove", this.onPointerMove, !0), this.domElement.addEventListener("mousedown", this.onPointerDown, !0), this.domElement.addEventListener("mouseout", this.onPointerOverOut, !0), this.domElement.addEventListener("mouseover", this.onPointerOverOut, !0), globalThis.addEventListener("mouseup", this.onPointerUp, !0), this.supportsTouchEvents && (this.domElement.addEventListener("touchstart", this.onPointerDown, !0), this.domElement.addEventListener("touchend", this.onPointerUp, !0), this.domElement.addEventListener("touchmove", this.onPointerMove, !0))), this.domElement.addEventListener("wheel", this.onWheel, {
      passive: !0,
      capture: !0
    }), this.eventsAdded = !0;
  }
  /** Unregister event listeners on {@link PIXI.EventSystem#domElement this.domElement}. */
  removeEvents() {
    if (!this.eventsAdded || !this.domElement)
      return;
    En.removeTickerListener();
    const t = this.domElement.style;
    globalThis.navigator.msPointerEnabled ? (t.msContentZooming = "", t.msTouchAction = "") : this.supportsPointerEvents && (t.touchAction = ""), this.supportsPointerEvents ? (globalThis.document.removeEventListener("pointermove", this.onPointerMove, !0), this.domElement.removeEventListener("pointerdown", this.onPointerDown, !0), this.domElement.removeEventListener("pointerleave", this.onPointerOverOut, !0), this.domElement.removeEventListener("pointerover", this.onPointerOverOut, !0), globalThis.removeEventListener("pointerup", this.onPointerUp, !0)) : (globalThis.document.removeEventListener("mousemove", this.onPointerMove, !0), this.domElement.removeEventListener("mousedown", this.onPointerDown, !0), this.domElement.removeEventListener("mouseout", this.onPointerOverOut, !0), this.domElement.removeEventListener("mouseover", this.onPointerOverOut, !0), globalThis.removeEventListener("mouseup", this.onPointerUp, !0), this.supportsTouchEvents && (this.domElement.removeEventListener("touchstart", this.onPointerDown, !0), this.domElement.removeEventListener("touchend", this.onPointerUp, !0), this.domElement.removeEventListener("touchmove", this.onPointerMove, !0))), this.domElement.removeEventListener("wheel", this.onWheel, !0), this.domElement = null, this.eventsAdded = !1;
  }
  /**
   * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
   * resulting value is stored in the point. This takes into account the fact that the DOM
   * element could be scaled and positioned anywhere on the screen.
   * @param  {PIXI.IPointData} point - the point that the result will be stored in
   * @param  {number} x - the x coord of the position to map
   * @param  {number} y - the y coord of the position to map
   */
  mapPositionToPoint(t, e, r) {
    const i = this.domElement.isConnected ? this.domElement.getBoundingClientRect() : {
      width: this.domElement.width,
      height: this.domElement.height,
      left: 0,
      top: 0
    }, s = 1 / this.resolution;
    t.x = (e - i.left) * (this.domElement.width / i.width) * s, t.y = (r - i.top) * (this.domElement.height / i.height) * s;
  }
  /**
   * Ensures that the original event object contains all data that a regular pointer event would have
   * @param event - The original event data from a touch or mouse event
   * @returns An array containing a single normalized pointer event, in the case of a pointer
   *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
   */
  normalizeToPointerData(t) {
    const e = [];
    if (this.supportsTouchEvents && t instanceof TouchEvent)
      for (let r = 0, i = t.changedTouches.length; r < i; r++) {
        const s = t.changedTouches[r];
        typeof s.button > "u" && (s.button = 0), typeof s.buttons > "u" && (s.buttons = 1), typeof s.isPrimary > "u" && (s.isPrimary = t.touches.length === 1 && t.type === "touchstart"), typeof s.width > "u" && (s.width = s.radiusX || 1), typeof s.height > "u" && (s.height = s.radiusY || 1), typeof s.tiltX > "u" && (s.tiltX = 0), typeof s.tiltY > "u" && (s.tiltY = 0), typeof s.pointerType > "u" && (s.pointerType = "touch"), typeof s.pointerId > "u" && (s.pointerId = s.identifier || 0), typeof s.pressure > "u" && (s.pressure = s.force || 0.5), typeof s.twist > "u" && (s.twist = 0), typeof s.tangentialPressure > "u" && (s.tangentialPressure = 0), typeof s.layerX > "u" && (s.layerX = s.offsetX = s.clientX), typeof s.layerY > "u" && (s.layerY = s.offsetY = s.clientY), s.isNormalized = !0, s.type = t.type, e.push(s);
      }
    else if (!globalThis.MouseEvent || t instanceof MouseEvent && (!this.supportsPointerEvents || !(t instanceof globalThis.PointerEvent))) {
      const r = t;
      typeof r.isPrimary > "u" && (r.isPrimary = !0), typeof r.width > "u" && (r.width = 1), typeof r.height > "u" && (r.height = 1), typeof r.tiltX > "u" && (r.tiltX = 0), typeof r.tiltY > "u" && (r.tiltY = 0), typeof r.pointerType > "u" && (r.pointerType = "mouse"), typeof r.pointerId > "u" && (r.pointerId = Rb), typeof r.pressure > "u" && (r.pressure = 0.5), typeof r.twist > "u" && (r.twist = 0), typeof r.tangentialPressure > "u" && (r.tangentialPressure = 0), r.isNormalized = !0, e.push(r);
    } else
      e.push(t);
    return e;
  }
  /**
   * Normalizes the native {@link https://w3c.github.io/uievents/#interface-wheelevent WheelEvent}.
   *
   * The returned {@link PIXI.FederatedWheelEvent} is a shared instance. It will not persist across
   * multiple native wheel events.
   * @param nativeEvent - The native wheel event that occurred on the canvas.
   * @returns A federated wheel event.
   */
  normalizeWheelEvent(t) {
    const e = this.rootWheelEvent;
    return this.transferMouseData(e, t), e.deltaX = t.deltaX, e.deltaY = t.deltaY, e.deltaZ = t.deltaZ, e.deltaMode = t.deltaMode, this.mapPositionToPoint(e.screen, t.clientX, t.clientY), e.global.copyFrom(e.screen), e.offset.copyFrom(e.screen), e.nativeEvent = t, e.type = t.type, e;
  }
  /**
   * Normalizes the `nativeEvent` into a federateed {@link PIXI.FederatedPointerEvent}.
   * @param event
   * @param nativeEvent
   */
  bootstrapEvent(t, e) {
    return t.originalEvent = null, t.nativeEvent = e, t.pointerId = e.pointerId, t.width = e.width, t.height = e.height, t.isPrimary = e.isPrimary, t.pointerType = e.pointerType, t.pressure = e.pressure, t.tangentialPressure = e.tangentialPressure, t.tiltX = e.tiltX, t.tiltY = e.tiltY, t.twist = e.twist, this.transferMouseData(t, e), this.mapPositionToPoint(t.screen, e.clientX, e.clientY), t.global.copyFrom(t.screen), t.offset.copyFrom(t.screen), t.isTrusted = e.isTrusted, t.type === "pointerleave" && (t.type = "pointerout"), t.type.startsWith("mouse") && (t.type = t.type.replace("mouse", "pointer")), t.type.startsWith("touch") && (t.type = Db[t.type] || t.type), t;
  }
  /**
   * Transfers base & mouse event data from the {@code nativeEvent} to the federated event.
   * @param event
   * @param nativeEvent
   */
  transferMouseData(t, e) {
    t.isTrusted = e.isTrusted, t.srcElement = e.srcElement, t.timeStamp = performance.now(), t.type = e.type, t.altKey = e.altKey, t.button = e.button, t.buttons = e.buttons, t.client.x = e.clientX, t.client.y = e.clientY, t.ctrlKey = e.ctrlKey, t.metaKey = e.metaKey, t.movement.x = e.movementX, t.movement.y = e.movementY, t.page.x = e.pageX, t.page.y = e.pageY, t.relatedTarget = null, t.shiftKey = e.shiftKey;
  }
};
cc.extension = {
  name: "events",
  type: [
    st.RendererSystem,
    st.CanvasRendererSystem
  ]
}, /**
* The event features that are enabled by the EventSystem
* This option only is available when using **@pixi/events** package
* (included in the **pixi.js** and **pixi.js-legacy** bundle), otherwise it will be ignored.
* @since 7.2.0
*/
cc.defaultEventFeatures = {
  move: !0,
  globalMove: !0,
  click: !0,
  wheel: !0
};
let fc = cc;
dt.add(fc);
function Xp(n) {
  return n === "dynamic" || n === "static";
}
const Fb = {
  /**
   * Property-based event handler for the `click` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onclick = (event) => {
   *  //some function here that happens on click
   * }
   */
  onclick: null,
  /**
   * Property-based event handler for the `mousedown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmousedown = (event) => {
   *  //some function here that happens on mousedown
   * }
   */
  onmousedown: null,
  /**
   * Property-based event handler for the `mouseenter` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseenter = (event) => {
   *  //some function here that happens on mouseenter
   * }
   */
  onmouseenter: null,
  /**
   * Property-based event handler for the `mouseleave` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseleave = (event) => {
   *  //some function here that happens on mouseleave
   * }
   */
  onmouseleave: null,
  /**
   * Property-based event handler for the `mousemove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmousemove = (event) => {
   *  //some function here that happens on mousemove
   * }
   */
  onmousemove: null,
  /**
   * Property-based event handler for the `globalmousemove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobalmousemove = (event) => {
   *  //some function here that happens on globalmousemove
   * }
   */
  onglobalmousemove: null,
  /**
   * Property-based event handler for the `mouseout` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseout = (event) => {
   *  //some function here that happens on mouseout
   * }
   */
  onmouseout: null,
  /**
   * Property-based event handler for the `mouseover` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseover = (event) => {
   *  //some function here that happens on mouseover
   * }
   */
  onmouseover: null,
  /**
   * Property-based event handler for the `mouseup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseup = (event) => {
   *  //some function here that happens on mouseup
   * }
   */
  onmouseup: null,
  /**
   * Property-based event handler for the `mouseupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseupoutside = (event) => {
   *  //some function here that happens on mouseupoutside
   * }
   */
  onmouseupoutside: null,
  /**
   * Property-based event handler for the `pointercancel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointercancel = (event) => {
   *  //some function here that happens on pointercancel
   * }
   */
  onpointercancel: null,
  /**
   * Property-based event handler for the `pointerdown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerdown = (event) => {
   *  //some function here that happens on pointerdown
   * }
   */
  onpointerdown: null,
  /**
   * Property-based event handler for the `pointerenter` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerenter = (event) => {
   *  //some function here that happens on pointerenter
   * }
   */
  onpointerenter: null,
  /**
   * Property-based event handler for the `pointerleave` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerleave = (event) => {
   *  //some function here that happens on pointerleave
   * }
   */
  onpointerleave: null,
  /**
   * Property-based event handler for the `pointermove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointermove = (event) => {
   *  //some function here that happens on pointermove
   * }
   */
  onpointermove: null,
  /**
   * Property-based event handler for the `globalpointermove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobalpointermove = (event) => {
   *  //some function here that happens on globalpointermove
   * }
   */
  onglobalpointermove: null,
  /**
   * Property-based event handler for the `pointerout` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerout = (event) => {
   *  //some function here that happens on pointerout
   * }
   */
  onpointerout: null,
  /**
   * Property-based event handler for the `pointerover` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerover = (event) => {
   *  //some function here that happens on pointerover
   * }
   */
  onpointerover: null,
  /**
   * Property-based event handler for the `pointertap` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointertap = (event) => {
   *  //some function here that happens on pointertap
   * }
   */
  onpointertap: null,
  /**
   * Property-based event handler for the `pointerup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerup = (event) => {
   *  //some function here that happens on pointerup
   * }
   */
  onpointerup: null,
  /**
   * Property-based event handler for the `pointerupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerupoutside = (event) => {
   *  //some function here that happens on pointerupoutside
   * }
   */
  onpointerupoutside: null,
  /**
   * Property-based event handler for the `rightclick` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightclick = (event) => {
   *  //some function here that happens on rightclick
   * }
   */
  onrightclick: null,
  /**
   * Property-based event handler for the `rightdown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightdown = (event) => {
   *  //some function here that happens on rightdown
   * }
   */
  onrightdown: null,
  /**
   * Property-based event handler for the `rightup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightup = (event) => {
   *  //some function here that happens on rightup
   * }
   */
  onrightup: null,
  /**
   * Property-based event handler for the `rightupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightupoutside = (event) => {
   *  //some function here that happens on rightupoutside
   * }
   */
  onrightupoutside: null,
  /**
   * Property-based event handler for the `tap` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontap = (event) => {
   *  //some function here that happens on tap
   * }
   */
  ontap: null,
  /**
   * Property-based event handler for the `touchcancel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchcancel = (event) => {
   *  //some function here that happens on touchcancel
   * }
   */
  ontouchcancel: null,
  /**
   * Property-based event handler for the `touchend` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchend = (event) => {
   *  //some function here that happens on touchend
   * }
   */
  ontouchend: null,
  /**
   * Property-based event handler for the `touchendoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchendoutside = (event) => {
   *  //some function here that happens on touchendoutside
   * }
   */
  ontouchendoutside: null,
  /**
   * Property-based event handler for the `touchmove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchmove = (event) => {
   *  //some function here that happens on touchmove
   * }
   */
  ontouchmove: null,
  /**
   * Property-based event handler for the `globaltouchmove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobaltouchmove = (event) => {
   *  //some function here that happens on globaltouchmove
   * }
   */
  onglobaltouchmove: null,
  /**
   * Property-based event handler for the `touchstart` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchstart = (event) => {
   *  //some function here that happens on touchstart
   * }
   */
  ontouchstart: null,
  /**
   * Property-based event handler for the `wheel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onwheel = (event) => {
   *  //some function here that happens on wheel
   * }
   */
  onwheel: null,
  /**
   * @ignore
   */
  _internalInteractive: void 0,
  /**
   * Enable interaction events for the DisplayObject. Touch, pointer and mouse
   * @memberof PIXI.DisplayObject#
   */
  get interactive() {
    return this._internalInteractive ?? Xp(fc.defaultEventMode);
  },
  set interactive(n) {
    wt(
      "7.2.0",
      // eslint-disable-next-line max-len
      "Setting interactive is deprecated, use eventMode = 'none'/'passive'/'auto'/'static'/'dynamic' instead."
    ), this._internalInteractive = n, this.eventMode = n ? "static" : "auto";
  },
  /**
   * @ignore
   */
  _internalEventMode: void 0,
  /**
   * Enable interaction events for the DisplayObject. Touch, pointer and mouse.
   * This now replaces the `interactive` property.
   * There are 5 types of interaction settings:
   * - `'none'`: Ignores all interaction events, even on its children.
   * - `'passive'`: Does not emit events and ignores all hit testing on itself and non-interactive children.
   * Interactive children will still emit events.
   * - `'auto'`: Does not emit events but is hit tested if parent is interactive. Same as `interactive = false` in v7
   * - `'static'`: Emit events and is hit tested. Same as `interaction = true` in v7
   * - `'dynamic'`: Emits events and is hit tested but will also receive mock interaction events fired from a ticker to
   * allow for interaction when the mouse isn't moving
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.eventMode = 'static';
   * sprite.on('tap', (event) => {
   *     // Handle event
   * });
   * @memberof PIXI.DisplayObject#
   * @since 7.2.0
   */
  get eventMode() {
    return this._internalEventMode ?? fc.defaultEventMode;
  },
  set eventMode(n) {
    this._internalInteractive = Xp(n), this._internalEventMode = n;
  },
  /**
   * Determines if the displayObject is interactive or not
   * @returns {boolean} Whether the displayObject is interactive or not
   * @memberof PIXI.DisplayObject#
   * @since 7.2.0
   * @example
   * import { Sprite } from 'pixi.js';
   * const sprite = new Sprite(texture);
   * sprite.eventMode = 'static';
   * sprite.isInteractive(); // true
   *
   * sprite.eventMode = 'dynamic';
   * sprite.isInteractive(); // true
   *
   * sprite.eventMode = 'none';
   * sprite.isInteractive(); // false
   *
   * sprite.eventMode = 'passive';
   * sprite.isInteractive(); // false
   *
   * sprite.eventMode = 'auto';
   * sprite.isInteractive(); // false
   */
  isInteractive() {
    return this.eventMode === "static" || this.eventMode === "dynamic";
  },
  /**
   * Determines if the children to the displayObject can be clicked/touched
   * Setting this to false allows PixiJS to bypass a recursive `hitTest` function
   * @memberof PIXI.Container#
   */
  interactiveChildren: !0,
  /**
   * Interaction shape. Children will be hit first, then this shape will be checked.
   * Setting this will cause this shape to be checked in hit tests rather than the displayObject's bounds.
   * @example
   * import { Rectangle, Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.interactive = true;
   * sprite.hitArea = new Rectangle(0, 0, 100, 100);
   * @member {PIXI.IHitArea}
   * @memberof PIXI.DisplayObject#
   */
  hitArea: null,
  /**
   * Unlike `on` or `addListener` which are methods from EventEmitter, `addEventListener`
   * seeks to be compatible with the DOM's `addEventListener` with support for options.
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param type - The type of event to listen to.
   * @param listener - The listener callback or object.
   * @param options - Listener options, used for capture phase.
   * @example
   * // Tell the user whether they did a single, double, triple, or nth click.
   * button.addEventListener('click', {
   *     handleEvent(e): {
   *         let prefix;
   *
   *         switch (e.detail) {
   *             case 1: prefix = 'single'; break;
   *             case 2: prefix = 'double'; break;
   *             case 3: prefix = 'triple'; break;
   *             default: prefix = e.detail + 'th'; break;
   *         }
   *
   *         console.log('That was a ' + prefix + 'click');
   *     }
   * });
   *
   * // But skip the first click!
   * button.parent.addEventListener('click', function blockClickOnce(e) {
   *     e.stopImmediatePropagation();
   *     button.parent.removeEventListener('click', blockClickOnce, true);
   * }, {
   *     capture: true,
   * });
   */
  addEventListener(n, t, e) {
    const r = typeof e == "boolean" && e || typeof e == "object" && e.capture, i = typeof t == "function" ? void 0 : t;
    n = r ? `${n}capture` : n, t = typeof t == "function" ? t : t.handleEvent, this.on(n, t, i);
  },
  /**
   * Unlike `off` or `removeListener` which are methods from EventEmitter, `removeEventListener`
   * seeks to be compatible with the DOM's `removeEventListener` with support for options.
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param type - The type of event the listener is bound to.
   * @param listener - The listener callback or object.
   * @param options - The original listener options. This is required to deregister a capture phase listener.
   */
  removeEventListener(n, t, e) {
    const r = typeof e == "boolean" && e || typeof e == "object" && e.capture, i = typeof t == "function" ? void 0 : t;
    n = r ? `${n}capture` : n, t = typeof t == "function" ? t : t.handleEvent, this.off(n, t, i);
  },
  /**
   * Dispatch the event on this {@link PIXI.DisplayObject} using the event's {@link PIXI.EventBoundary}.
   *
   * The target of the event is set to `this` and the `defaultPrevented` flag is cleared before dispatch.
   *
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param e - The event to dispatch.
   * @returns Whether the {@link PIXI.FederatedEvent.preventDefault preventDefault}() method was not invoked.
   * @example
   * // Reuse a click event!
   * button.dispatchEvent(clickEvent);
   */
  dispatchEvent(n) {
    if (!(n instanceof Mo))
      throw new Error("DisplayObject cannot propagate events outside of the Federated Events API");
    return n.defaultPrevented = !1, n.path = null, n.target = this, n.manager.dispatchEvent(n), !n.defaultPrevented;
  }
};
zt.mixin(Fb);
const Ob = {
  /**
   *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
   *   shadow div with attributes set
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */
  accessible: !1,
  /**
   * Sets the title attribute of the shadow div
   * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
   * @member {?string}
   * @memberof PIXI.DisplayObject#
   */
  accessibleTitle: null,
  /**
   * Sets the aria-label attribute of the shadow div
   * @member {string}
   * @memberof PIXI.DisplayObject#
   */
  accessibleHint: null,
  /**
   * @member {number}
   * @memberof PIXI.DisplayObject#
   * @private
   * @todo Needs docs.
   */
  tabIndex: 0,
  /**
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @todo Needs docs.
   */
  _accessibleActive: !1,
  /**
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @todo Needs docs.
   */
  _accessibleDiv: null,
  /**
   * Specify the type of div the accessible layer is. Screen readers treat the element differently
   * depending on this type. Defaults to button.
   * @member {string}
   * @memberof PIXI.DisplayObject#
   * @default 'button'
   */
  accessibleType: "button",
  /**
   * Specify the pointer-events the accessible div will use
   * Defaults to auto.
   * @member {string}
   * @memberof PIXI.DisplayObject#
   * @default 'auto'
   */
  accessiblePointerEvents: "auto",
  /**
   * Setting to false will prevent any children inside this container to
   * be accessible. Defaults to true.
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @default true
   */
  accessibleChildren: !0,
  renderId: -1
};
zt.mixin(Ob);
const Nb = 9, aa = 100, kb = 0, Bb = 0, Vp = 2, Yp = 1, Lb = -1e3, Ub = -1e3, Hb = 2;
class U0 {
  // 2fps
  /**
   * @param {PIXI.CanvasRenderer|PIXI.Renderer} renderer - A reference to the current renderer
   */
  constructor(t) {
    this.debug = !1, this._isActive = !1, this._isMobileAccessibility = !1, this.pool = [], this.renderId = 0, this.children = [], this.androidUpdateCount = 0, this.androidUpdateFrequency = 500, this._hookDiv = null, (Jr.tablet || Jr.phone) && this.createTouchHook();
    const e = document.createElement("div");
    e.style.width = `${aa}px`, e.style.height = `${aa}px`, e.style.position = "absolute", e.style.top = `${kb}px`, e.style.left = `${Bb}px`, e.style.zIndex = Vp.toString(), this.div = e, this.renderer = t, this._onKeyDown = this._onKeyDown.bind(this), this._onMouseMove = this._onMouseMove.bind(this), globalThis.addEventListener("keydown", this._onKeyDown, !1);
  }
  /**
   * Value of `true` if accessibility is currently active and accessibility layers are showing.
   * @member {boolean}
   * @readonly
   */
  get isActive() {
    return this._isActive;
  }
  /**
   * Value of `true` if accessibility is enabled for touch devices.
   * @member {boolean}
   * @readonly
   */
  get isMobileAccessibility() {
    return this._isMobileAccessibility;
  }
  /**
   * Creates the touch hooks.
   * @private
   */
  createTouchHook() {
    const t = document.createElement("button");
    t.style.width = `${Yp}px`, t.style.height = `${Yp}px`, t.style.position = "absolute", t.style.top = `${Lb}px`, t.style.left = `${Ub}px`, t.style.zIndex = Hb.toString(), t.style.backgroundColor = "#FF0000", t.title = "select to enable accessibility for this content", t.addEventListener("focus", () => {
      this._isMobileAccessibility = !0, this.activate(), this.destroyTouchHook();
    }), document.body.appendChild(t), this._hookDiv = t;
  }
  /**
   * Destroys the touch hooks.
   * @private
   */
  destroyTouchHook() {
    this._hookDiv && (document.body.removeChild(this._hookDiv), this._hookDiv = null);
  }
  /**
   * Activating will cause the Accessibility layer to be shown.
   * This is called when a user presses the tab key.
   * @private
   */
  activate() {
    this._isActive || (this._isActive = !0, globalThis.document.addEventListener("mousemove", this._onMouseMove, !0), globalThis.removeEventListener("keydown", this._onKeyDown, !1), this.renderer.on("postrender", this.update, this), this.renderer.view.parentNode?.appendChild(this.div));
  }
  /**
   * Deactivating will cause the Accessibility layer to be hidden.
   * This is called when a user moves the mouse.
   * @private
   */
  deactivate() {
    !this._isActive || this._isMobileAccessibility || (this._isActive = !1, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), globalThis.addEventListener("keydown", this._onKeyDown, !1), this.renderer.off("postrender", this.update), this.div.parentNode?.removeChild(this.div));
  }
  /**
   * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
   * @private
   * @param {PIXI.Container} displayObject - The DisplayObject to check.
   */
  updateAccessibleObjects(t) {
    if (!t.visible || !t.accessibleChildren)
      return;
    t.accessible && t.isInteractive() && (t._accessibleActive || this.addChild(t), t.renderId = this.renderId);
    const e = t.children;
    if (e)
      for (let r = 0; r < e.length; r++)
        this.updateAccessibleObjects(e[r]);
  }
  /**
   * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
   * @private
   */
  update() {
    const t = performance.now();
    if (Jr.android.device && t < this.androidUpdateCount || (this.androidUpdateCount = t + this.androidUpdateFrequency, !this.renderer.renderingToScreen))
      return;
    this.renderer.lastObjectRendered && this.updateAccessibleObjects(this.renderer.lastObjectRendered);
    const { x: e, y: r, width: i, height: s } = this.renderer.view.getBoundingClientRect(), { width: o, height: a, resolution: h } = this.renderer, l = i / o * h, u = s / a * h;
    let c = this.div;
    c.style.left = `${e}px`, c.style.top = `${r}px`, c.style.width = `${o}px`, c.style.height = `${a}px`;
    for (let d = 0; d < this.children.length; d++) {
      const f = this.children[d];
      if (f.renderId !== this.renderId)
        f._accessibleActive = !1, es(this.children, d, 1), this.div.removeChild(f._accessibleDiv), this.pool.push(f._accessibleDiv), f._accessibleDiv = null, d--;
      else {
        c = f._accessibleDiv;
        let p = f.hitArea;
        const m = f.worldTransform;
        f.hitArea ? (c.style.left = `${(m.tx + p.x * m.a) * l}px`, c.style.top = `${(m.ty + p.y * m.d) * u}px`, c.style.width = `${p.width * m.a * l}px`, c.style.height = `${p.height * m.d * u}px`) : (p = f.getBounds(), this.capHitArea(p), c.style.left = `${p.x * l}px`, c.style.top = `${p.y * u}px`, c.style.width = `${p.width * l}px`, c.style.height = `${p.height * u}px`, c.title !== f.accessibleTitle && f.accessibleTitle !== null && (c.title = f.accessibleTitle), c.getAttribute("aria-label") !== f.accessibleHint && f.accessibleHint !== null && c.setAttribute("aria-label", f.accessibleHint)), (f.accessibleTitle !== c.title || f.tabIndex !== c.tabIndex) && (c.title = f.accessibleTitle, c.tabIndex = f.tabIndex, this.debug && this.updateDebugHTML(c));
      }
    }
    this.renderId++;
  }
  /**
   * private function that will visually add the information to the
   * accessability div
   * @param {HTMLElement} div -
   */
  updateDebugHTML(t) {
    t.innerHTML = `type: ${t.type}</br> title : ${t.title}</br> tabIndex: ${t.tabIndex}`;
  }
  /**
   * Adjust the hit area based on the bounds of a display object
   * @param {PIXI.Rectangle} hitArea - Bounds of the child
   */
  capHitArea(t) {
    t.x < 0 && (t.width += t.x, t.x = 0), t.y < 0 && (t.height += t.y, t.y = 0);
    const { width: e, height: r } = this.renderer;
    t.x + t.width > e && (t.width = e - t.x), t.y + t.height > r && (t.height = r - t.y);
  }
  /**
   * Adds a DisplayObject to the accessibility manager
   * @private
   * @param {PIXI.DisplayObject} displayObject - The child to make accessible.
   */
  addChild(t) {
    let e = this.pool.pop();
    e || (e = document.createElement("button"), e.style.width = `${aa}px`, e.style.height = `${aa}px`, e.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent", e.style.position = "absolute", e.style.zIndex = Vp.toString(), e.style.borderStyle = "none", navigator.userAgent.toLowerCase().includes("chrome") ? e.setAttribute("aria-live", "off") : e.setAttribute("aria-live", "polite"), navigator.userAgent.match(/rv:.*Gecko\//) ? e.setAttribute("aria-relevant", "additions") : e.setAttribute("aria-relevant", "text"), e.addEventListener("click", this._onClick.bind(this)), e.addEventListener("focus", this._onFocus.bind(this)), e.addEventListener("focusout", this._onFocusOut.bind(this))), e.style.pointerEvents = t.accessiblePointerEvents, e.type = t.accessibleType, t.accessibleTitle && t.accessibleTitle !== null ? e.title = t.accessibleTitle : (!t.accessibleHint || t.accessibleHint === null) && (e.title = `displayObject ${t.tabIndex}`), t.accessibleHint && t.accessibleHint !== null && e.setAttribute("aria-label", t.accessibleHint), this.debug && this.updateDebugHTML(e), t._accessibleActive = !0, t._accessibleDiv = e, e.displayObject = t, this.children.push(t), this.div.appendChild(t._accessibleDiv), t._accessibleDiv.tabIndex = t.tabIndex;
  }
  /**
   * Dispatch events with the EventSystem.
   * @param e
   * @param type
   * @private
   */
  _dispatchEvent(t, e) {
    const { displayObject: r } = t.target, i = this.renderer.events.rootBoundary, s = Object.assign(new Mo(i), { target: r });
    i.rootTarget = this.renderer.lastObjectRendered, e.forEach((o) => i.dispatchEvent(s, o));
  }
  /**
   * Maps the div button press to pixi's EventSystem (click)
   * @private
   * @param {MouseEvent} e - The click event.
   */
  _onClick(t) {
    this._dispatchEvent(t, ["click", "pointertap", "tap"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseover)
   * @private
   * @param {FocusEvent} e - The focus event.
   */
  _onFocus(t) {
    t.target.getAttribute("aria-live") || t.target.setAttribute("aria-live", "assertive"), this._dispatchEvent(t, ["mouseover"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseout)
   * @private
   * @param {FocusEvent} e - The focusout event.
   */
  _onFocusOut(t) {
    t.target.getAttribute("aria-live") || t.target.setAttribute("aria-live", "polite"), this._dispatchEvent(t, ["mouseout"]);
  }
  /**
   * Is called when a key is pressed
   * @private
   * @param {KeyboardEvent} e - The keydown event.
   */
  _onKeyDown(t) {
    t.keyCode === Nb && this.activate();
  }
  /**
   * Is called when the mouse moves across the renderer element
   * @private
   * @param {MouseEvent} e - The mouse event.
   */
  _onMouseMove(t) {
    t.movementX === 0 && t.movementY === 0 || this.deactivate();
  }
  /** Destroys the accessibility manager */
  destroy() {
    this.destroyTouchHook(), this.div = null, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), globalThis.removeEventListener("keydown", this._onKeyDown), this.pool = null, this.children = null, this.renderer = null;
  }
}
U0.extension = {
  name: "accessibility",
  type: [
    st.RendererPlugin,
    st.CanvasRendererPlugin
  ]
};
dt.add(U0);
const H0 = class pc {
  /**
   * @param options - The optional application and renderer parameters.
   */
  constructor(t) {
    this.stage = new bt(), t = Object.assign({
      forceCanvas: !1
    }, t), this.renderer = Kw(t), pc._plugins.forEach((e) => {
      e.init.call(this, t);
    });
  }
  /** Render the current stage. */
  render() {
    this.renderer.render(this.stage);
  }
  /**
   * Reference to the renderer's canvas element.
   * @member {PIXI.ICanvas}
   * @readonly
   */
  get view() {
    return this.renderer?.view;
  }
  /**
   * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
   * @member {PIXI.Rectangle}
   * @readonly
   */
  get screen() {
    return this.renderer?.screen;
  }
  /**
   * Destroy and don't use after this.
   * @param {boolean} [removeView=false] - Automatically remove canvas from DOM.
   * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'stageOptions' will be passed on to those calls.
   * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
   *  to true. Should it destroy the texture of the child sprite
   * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
   *  to true. Should it destroy the base texture of the child sprite
   */
  destroy(t, e) {
    const r = pc._plugins.slice(0);
    r.reverse(), r.forEach((i) => {
      i.destroy.call(this);
    }), this.stage.destroy(e), this.stage = null, this.renderer.destroy(t), this.renderer = null;
  }
};
H0._plugins = [];
let G0 = H0;
dt.handleByList(st.Application, G0._plugins);
class z0 {
  /**
   * Initialize the plugin with scope of application instance
   * @static
   * @private
   * @param {object} [options] - See application options
   */
  static init(t) {
    Object.defineProperty(
      this,
      "resizeTo",
      /**
       * The HTML element or window to automatically resize the
       * renderer's view element to match width and height.
       * @member {Window|HTMLElement}
       * @name resizeTo
       * @memberof PIXI.Application#
       */
      {
        set(e) {
          globalThis.removeEventListener("resize", this.queueResize), this._resizeTo = e, e && (globalThis.addEventListener("resize", this.queueResize), this.resize());
        },
        get() {
          return this._resizeTo;
        }
      }
    ), this.queueResize = () => {
      this._resizeTo && (this.cancelResize(), this._resizeId = requestAnimationFrame(() => this.resize()));
    }, this.cancelResize = () => {
      this._resizeId && (cancelAnimationFrame(this._resizeId), this._resizeId = null);
    }, this.resize = () => {
      if (!this._resizeTo)
        return;
      this.cancelResize();
      let e, r;
      if (this._resizeTo === globalThis.window)
        e = globalThis.innerWidth, r = globalThis.innerHeight;
      else {
        const { clientWidth: i, clientHeight: s } = this._resizeTo;
        e = i, r = s;
      }
      this.renderer.resize(e, r), this.render();
    }, this._resizeId = null, this._resizeTo = null, this.resizeTo = t.resizeTo || null;
  }
  /**
   * Clean up the ticker, scoped to application
   * @static
   * @private
   */
  static destroy() {
    globalThis.removeEventListener("resize", this.queueResize), this.cancelResize(), this.cancelResize = null, this.queueResize = null, this.resizeTo = null, this.resize = null;
  }
}
z0.extension = st.Application;
dt.add(z0);
const jp = {
  loader: st.LoadParser,
  resolver: st.ResolveParser,
  cache: st.CacheParser,
  detection: st.DetectionParser
};
dt.handle(st.Asset, (n) => {
  const t = n.ref;
  Object.entries(jp).filter(([e]) => !!t[e]).forEach(([e, r]) => dt.add(Object.assign(
    t[e],
    // Allow the function to optionally define it's own
    // ExtensionMetadata, the use cases here is priority for LoaderParsers
    { extension: t[e].extension ?? r }
  )));
}, (n) => {
  const t = n.ref;
  Object.keys(jp).filter((e) => !!t[e]).forEach((e) => dt.remove(t[e]));
});
class Gb {
  /**
   * @param loader
   * @param verbose - should the loader log to the console
   */
  constructor(t, e = !1) {
    this._loader = t, this._assetList = [], this._isLoading = !1, this._maxConcurrent = 1, this.verbose = e;
  }
  /**
   * Adds an array of assets to load.
   * @param assetUrls - assets to load
   */
  add(t) {
    t.forEach((e) => {
      this._assetList.push(e);
    }), this.verbose && console.log("[BackgroundLoader] assets: ", this._assetList), this._isActive && !this._isLoading && this._next();
  }
  /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */
  async _next() {
    if (this._assetList.length && this._isActive) {
      this._isLoading = !0;
      const t = [], e = Math.min(this._assetList.length, this._maxConcurrent);
      for (let r = 0; r < e; r++)
        t.push(this._assetList.pop());
      await this._loader.load(t), this._isLoading = !1, this._next();
    }
  }
  /**
   * Activate/Deactivate the loading. If set to true then it will immediately continue to load the next asset.
   * @returns whether the class is active
   */
  get active() {
    return this._isActive;
  }
  set active(t) {
    this._isActive !== t && (this._isActive = t, t && !this._isLoading && this._next());
  }
}
function As(n, t) {
  if (Array.isArray(t)) {
    for (const e of t)
      if (n.startsWith(`data:${e}`))
        return !0;
    return !1;
  }
  return n.startsWith(`data:${t}`);
}
function Wn(n, t) {
  const e = n.split("?")[0], r = ne.extname(e).toLowerCase();
  return Array.isArray(t) ? t.includes(r) : r === t;
}
const dr = (n, t, e = !1) => (Array.isArray(n) || (n = [n]), t ? n.map((r) => typeof r == "string" || e ? t(r) : r) : n), mc = (n, t) => {
  const e = t.split("?")[1];
  return e && (n += `?${e}`), n;
};
function W0(n, t, e, r, i) {
  const s = t[e];
  for (let o = 0; o < s.length; o++) {
    const a = s[o];
    e < t.length - 1 ? W0(n.replace(r[e], a), t, e + 1, r, i) : i.push(n.replace(r[e], a));
  }
}
function zb(n) {
  const t = /\{(.*?)\}/g, e = n.match(t), r = [];
  if (e) {
    const i = [];
    e.forEach((s) => {
      const o = s.substring(1, s.length - 1).split(",");
      i.push(o);
    }), W0(n, i, 0, e, r);
  } else
    r.push(n);
  return r;
}
const Qa = (n) => !Array.isArray(n);
class Wb {
  constructor() {
    this._parsers = [], this._cache = /* @__PURE__ */ new Map(), this._cacheMap = /* @__PURE__ */ new Map();
  }
  /** Clear all entries. */
  reset() {
    this._cacheMap.clear(), this._cache.clear();
  }
  /**
   * Check if the key exists
   * @param key - The key to check
   */
  has(t) {
    return this._cache.has(t);
  }
  /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */
  get(t) {
    const e = this._cache.get(t);
    return e || console.warn(`[Assets] Asset id ${t} was not found in the Cache`), e;
  }
  /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */
  set(t, e) {
    const r = dr(t);
    let i;
    for (let a = 0; a < this.parsers.length; a++) {
      const h = this.parsers[a];
      if (h.test(e)) {
        i = h.getCacheableAssets(r, e);
        break;
      }
    }
    i || (i = {}, r.forEach((a) => {
      i[a] = e;
    }));
    const s = Object.keys(i), o = {
      cacheKeys: s,
      keys: r
    };
    if (r.forEach((a) => {
      this._cacheMap.set(a, o);
    }), s.forEach((a) => {
      this._cache.has(a) && this._cache.get(a) !== e && console.warn("[Cache] already has key:", a), this._cache.set(a, i[a]);
    }), e instanceof ct) {
      const a = e;
      r.forEach((h) => {
        a.baseTexture !== ct.EMPTY.baseTexture && _t.addToCache(a.baseTexture, h), ct.addToCache(a, h);
      });
    }
  }
  /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */
  remove(t) {
    if (!this._cacheMap.has(t)) {
      console.warn(`[Assets] Asset id ${t} was not found in the Cache`);
      return;
    }
    const e = this._cacheMap.get(t);
    e.cacheKeys.forEach((r) => {
      this._cache.delete(r);
    }), e.keys.forEach((r) => {
      this._cacheMap.delete(r);
    });
  }
  /** All loader parsers registered */
  get parsers() {
    return this._parsers;
  }
}
const ci = new Wb();
class $b {
  constructor() {
    this._parsers = [], this._parsersValidated = !1, this.parsers = new Proxy(this._parsers, {
      set: (t, e, r) => (this._parsersValidated = !1, t[e] = r, !0)
    }), this.promiseCache = {};
  }
  /** function used for testing */
  reset() {
    this._parsersValidated = !1, this.promiseCache = {};
  }
  /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */
  _getLoadPromiseAndParser(t, e) {
    const r = {
      promise: null,
      parser: null
    };
    return r.promise = (async () => {
      let i = null, s = null;
      if (e.loadParser && (s = this._parserHash[e.loadParser], s || console.warn(`[Assets] specified load parser "${e.loadParser}" not found while loading ${t}`)), !s) {
        for (let o = 0; o < this.parsers.length; o++) {
          const a = this.parsers[o];
          if (a.load && a.test?.(t, e, this)) {
            s = a;
            break;
          }
        }
        if (!s)
          return console.warn(`[Assets] ${t} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`), null;
      }
      i = await s.load(t, e, this), r.parser = s;
      for (let o = 0; o < this.parsers.length; o++) {
        const a = this.parsers[o];
        a.parse && a.parse && await a.testParse?.(i, e, this) && (i = await a.parse(i, e, this) || i, r.parser = a);
      }
      return i;
    })(), r;
  }
  async load(t, e) {
    this._parsersValidated || this._validateParsers();
    let r = 0;
    const i = {}, s = Qa(t), o = dr(t, (l) => ({
      alias: [l],
      src: l
    })), a = o.length, h = o.map(async (l) => {
      const u = ne.toAbsolute(l.src);
      if (!i[l.src])
        try {
          this.promiseCache[u] || (this.promiseCache[u] = this._getLoadPromiseAndParser(u, l)), i[l.src] = await this.promiseCache[u].promise, e && e(++r / a);
        } catch (c) {
          throw delete this.promiseCache[u], delete i[l.src], new Error(`[Loader.load] Failed to load ${u}.
${c}`);
        }
    });
    return await Promise.all(h), s ? i[o[0].src] : i;
  }
  /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */
  async unload(t) {
    const e = dr(t, (r) => ({
      alias: [r],
      src: r
    })).map(async (r) => {
      const i = ne.toAbsolute(r.src), s = this.promiseCache[i];
      if (s) {
        const o = await s.promise;
        delete this.promiseCache[i], s.parser?.unload?.(o, r, this);
      }
    });
    await Promise.all(e);
  }
  /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */
  _validateParsers() {
    this._parsersValidated = !0, this._parserHash = this._parsers.filter((t) => t.name).reduce((t, e) => (t[e.name] && console.warn(`[Assets] loadParser name conflict "${e.name}"`), { ...t, [e.name]: e }), {});
  }
}
var yr = /* @__PURE__ */ ((n) => (n[n.Low = 0] = "Low", n[n.Normal = 1] = "Normal", n[n.High = 2] = "High", n))(yr || {});
const Xb = ".json", Vb = "application/json", Yb = {
  extension: {
    type: st.LoadParser,
    priority: yr.Low
  },
  name: "loadJson",
  test(n) {
    return As(n, Vb) || Wn(n, Xb);
  },
  async load(n) {
    return await (await ht.ADAPTER.fetch(n)).json();
  }
};
dt.add(Yb);
const jb = ".txt", qb = "text/plain", Zb = {
  name: "loadTxt",
  extension: {
    type: st.LoadParser,
    priority: yr.Low
  },
  test(n) {
    return As(n, qb) || Wn(n, jb);
  },
  async load(n) {
    return await (await ht.ADAPTER.fetch(n)).text();
  }
};
dt.add(Zb);
const Kb = [
  "normal",
  "bold",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900"
], Qb = [".ttf", ".otf", ".woff", ".woff2"], Jb = [
  "font/ttf",
  "font/otf",
  "font/woff",
  "font/woff2"
], t2 = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function e2(n) {
  const t = ne.extname(n), e = ne.basename(n, t).replace(/(-|_)/g, " ").toLowerCase().split(" ").map((s) => s.charAt(0).toUpperCase() + s.slice(1));
  let r = e.length > 0;
  for (const s of e)
    if (!s.match(t2)) {
      r = !1;
      break;
    }
  let i = e.join(" ");
  return r || (i = `"${i.replace(/[\\"]/g, "\\$&")}"`), i;
}
const r2 = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function n2(n) {
  return r2.test(n) ? n : encodeURI(n);
}
const i2 = {
  extension: {
    type: st.LoadParser,
    priority: yr.Low
  },
  name: "loadWebFont",
  test(n) {
    return As(n, Jb) || Wn(n, Qb);
  },
  async load(n, t) {
    const e = ht.ADAPTER.getFontFaceSet();
    if (e) {
      const r = [], i = t.data?.family ?? e2(n), s = t.data?.weights?.filter((a) => Kb.includes(a)) ?? ["normal"], o = t.data ?? {};
      for (let a = 0; a < s.length; a++) {
        const h = s[a], l = new FontFace(i, `url(${n2(n)})`, {
          ...o,
          weight: h
        });
        await l.load(), e.add(l), r.push(l);
      }
      return r.length === 1 ? r[0] : r;
    }
    return console.warn("[loadWebFont] FontFace API is not supported. Skipping loading font"), null;
  },
  unload(n) {
    (Array.isArray(n) ? n : [n]).forEach((t) => ht.ADAPTER.getFontFaceSet().delete(t));
  }
};
dt.add(i2);
let qp = 0, lu;
const s2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=", o2 = {
  code: `
    async function checkImageBitmap()
    {
        try
        {
            if (typeof createImageBitmap !== 'function') return false;

            const response = await fetch('${s2}');
            const imageBlob =  await response.blob();
            const imageBitmap = await createImageBitmap(imageBlob);

            return imageBitmap.width === 1 && imageBitmap.height === 1;
        }
        catch (e)
        {
            return false;
        }
    }
    checkImageBitmap().then((result) => { self.postMessage(result); });
    `
}, a2 = {
  code: `
    async function loadImageBitmap(url)
    {
        const response = await fetch(url);

        if (!response.ok)
        {
            throw new Error(\`[WorkerManager.loadImageBitmap] Failed to fetch \${url}: \`
                + \`\${response.status} \${response.statusText}\`);
        }

        const imageBlob =  await response.blob();
        const imageBitmap = await createImageBitmap(imageBlob);

        return imageBitmap;
    }
    self.onmessage = async (event) =>
    {
        try
        {
            const imageBitmap = await loadImageBitmap(event.data.data[0]);

            self.postMessage({
                data: imageBitmap,
                uuid: event.data.uuid,
                id: event.data.id,
            }, [imageBitmap]);
        }
        catch(e)
        {
            self.postMessage({
                error: e,
                uuid: event.data.uuid,
                id: event.data.id,
            });
        }
    };`
};
let uu;
class h2 {
  constructor() {
    this._initialized = !1, this._createdWorkers = 0, this.workerPool = [], this.queue = [], this.resolveHash = {};
  }
  isImageBitmapSupported() {
    return this._isImageBitmapSupported !== void 0 ? this._isImageBitmapSupported : (this._isImageBitmapSupported = new Promise((t) => {
      const e = URL.createObjectURL(new Blob(
        [o2.code],
        { type: "application/javascript" }
      )), r = new Worker(e);
      r.addEventListener("message", (i) => {
        r.terminate(), URL.revokeObjectURL(e), t(i.data);
      });
    }), this._isImageBitmapSupported);
  }
  loadImageBitmap(t) {
    return this._run("loadImageBitmap", [t]);
  }
  async _initWorkers() {
    this._initialized || (this._initialized = !0);
  }
  getWorker() {
    lu === void 0 && (lu = navigator.hardwareConcurrency || 4);
    let t = this.workerPool.pop();
    return !t && this._createdWorkers < lu && (uu || (uu = URL.createObjectURL(new Blob([a2.code], { type: "application/javascript" }))), this._createdWorkers++, t = new Worker(uu), t.addEventListener("message", (e) => {
      this.complete(e.data), this.returnWorker(e.target), this.next();
    })), t;
  }
  returnWorker(t) {
    this.workerPool.push(t);
  }
  complete(t) {
    t.error !== void 0 ? this.resolveHash[t.uuid].reject(t.error) : this.resolveHash[t.uuid].resolve(t.data), this.resolveHash[t.uuid] = null;
  }
  async _run(t, e) {
    await this._initWorkers();
    const r = new Promise((i, s) => {
      this.queue.push({ id: t, arguments: e, resolve: i, reject: s });
    });
    return this.next(), r;
  }
  next() {
    if (!this.queue.length)
      return;
    const t = this.getWorker();
    if (!t)
      return;
    const e = this.queue.pop(), r = e.id;
    this.resolveHash[qp] = { resolve: e.resolve, reject: e.reject }, t.postMessage({
      data: e.arguments,
      uuid: qp++,
      id: r
    });
  }
}
const Zp = new h2();
function Io(n, t, e) {
  n.resource.internal = !0;
  const r = new ct(n), i = () => {
    delete t.promiseCache[e], ci.has(e) && ci.remove(e);
  };
  return r.baseTexture.once("destroyed", () => {
    e in t.promiseCache && (console.warn("[Assets] A BaseTexture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the BaseTexture."), i());
  }), r.once("destroyed", () => {
    n.destroyed || (console.warn("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture."), i());
  }), r;
}
const l2 = [".jpeg", ".jpg", ".png", ".webp", ".avif"], u2 = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/avif"
];
async function c2(n) {
  const t = await ht.ADAPTER.fetch(n);
  if (!t.ok)
    throw new Error(`[loadImageBitmap] Failed to fetch ${n}: ${t.status} ${t.statusText}`);
  const e = await t.blob();
  return await createImageBitmap(e);
}
const Dh = {
  name: "loadTextures",
  extension: {
    type: st.LoadParser,
    priority: yr.High
  },
  config: {
    preferWorkers: !0,
    preferCreateImageBitmap: !0,
    crossOrigin: "anonymous"
  },
  test(n) {
    return As(n, u2) || Wn(n, l2);
  },
  async load(n, t, e) {
    const r = globalThis.createImageBitmap && this.config.preferCreateImageBitmap;
    let i;
    r ? this.config.preferWorkers && await Zp.isImageBitmapSupported() ? i = await Zp.loadImageBitmap(n) : i = await c2(n) : i = await new Promise((a, h) => {
      const l = new Image();
      l.crossOrigin = this.config.crossOrigin, l.src = n, l.complete ? a(l) : (l.onload = () => a(l), l.onerror = (u) => h(u));
    });
    const s = { ...t.data };
    s.resolution ?? (s.resolution = sn(n)), r && s.resourceOptions?.ownsImageBitmap === void 0 && (s.resourceOptions = { ...s.resourceOptions }, s.resourceOptions.ownsImageBitmap = !0);
    const o = new _t(i, s);
    return o.resource.src = n, Io(o, e, n);
  },
  unload(n) {
    n.destroy(!0);
  }
};
dt.add(Dh);
const d2 = ".svg", f2 = "image/svg+xml", p2 = {
  extension: {
    type: st.LoadParser,
    priority: yr.High
  },
  name: "loadSVG",
  test(n) {
    return As(n, f2) || Wn(n, d2);
  },
  async testParse(n) {
    return sc.test(n);
  },
  async parse(n, t, e) {
    const r = new sc(n, t?.data?.resourceOptions);
    await r.load();
    const i = new _t(r, {
      resolution: sn(n),
      ...t?.data
    });
    return i.resource.src = t.src, Io(i, e, t.src);
  },
  async load(n, t) {
    return (await ht.ADAPTER.fetch(n)).text();
  },
  unload: Dh.unload
};
dt.add(p2);
const m2 = [".mp4", ".m4v", ".webm", ".ogv"], g2 = [
  "video/mp4",
  "video/webm",
  "video/ogg"
], y2 = {
  name: "loadVideo",
  extension: {
    type: st.LoadParser,
    priority: yr.High
  },
  config: {
    defaultAutoPlay: !0
  },
  test(n) {
    return As(n, g2) || Wn(n, m2);
  },
  async load(n, t, e) {
    let r;
    const i = await (await ht.ADAPTER.fetch(n)).blob(), s = URL.createObjectURL(i);
    try {
      const o = {
        autoPlay: this.config.defaultAutoPlay,
        ...t?.data?.resourceOptions
      }, a = new k0(s, o);
      await a.load();
      const h = new _t(a, {
        alphaMode: await Ax(),
        resolution: sn(n),
        ...t?.data
      });
      h.resource.src = n, r = Io(h, e, n), r.baseTexture.once("destroyed", () => {
        URL.revokeObjectURL(s);
      });
    } catch (o) {
      throw URL.revokeObjectURL(s), o;
    }
    return r;
  },
  unload(n) {
    n.destroy(!0);
  }
};
dt.add(y2);
class _2 {
  constructor() {
    this._defaultBundleIdentifierOptions = {
      connector: "-",
      createBundleAssetId: (t, e) => `${t}${this._bundleIdConnector}${e}`,
      extractAssetIdFromBundle: (t, e) => e.replace(`${t}${this._bundleIdConnector}`, "")
    }, this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector, this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId, this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle, this._assetMap = {}, this._preferredOrder = [], this._parsers = [], this._resolverHash = {}, this._bundles = {};
  }
  /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */
  setBundleIdentifier(t) {
    if (this._bundleIdConnector = t.connector ?? this._bundleIdConnector, this._createBundleAssetId = t.createBundleAssetId ?? this._createBundleAssetId, this._extractAssetIdFromBundle = t.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle, this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar")
      throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
  }
  /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */
  prefer(...t) {
    t.forEach((e) => {
      this._preferredOrder.push(e), e.priority || (e.priority = Object.keys(e.params));
    }), this._resolverHash = {};
  }
  /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */
  set basePath(t) {
    this._basePath = t;
  }
  get basePath() {
    return this._basePath;
  }
  /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */
  set rootPath(t) {
    this._rootPath = t;
  }
  get rootPath() {
    return this._rootPath;
  }
  /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(settings.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */
  get parsers() {
    return this._parsers;
  }
  /** Used for testing, this resets the resolver to its initial state */
  reset() {
    this.setBundleIdentifier(this._defaultBundleIdentifierOptions), this._assetMap = {}, this._preferredOrder = [], this._resolverHash = {}, this._rootPath = null, this._basePath = null, this._manifest = null, this._bundles = {}, this._defaultSearchParams = null;
  }
  /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */
  setDefaultSearchParams(t) {
    if (typeof t == "string")
      this._defaultSearchParams = t;
    else {
      const e = t;
      this._defaultSearchParams = Object.keys(e).map((r) => `${encodeURIComponent(r)}=${encodeURIComponent(e[r])}`).join("&");
    }
  }
  /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */
  getAlias(t) {
    const { alias: e, name: r, src: i, srcs: s } = t;
    return dr(
      e || r || i || s,
      (o) => typeof o == "string" ? o : Array.isArray(o) ? o.map((a) => a?.src ?? a?.srcs ?? a) : o?.src || o?.srcs ? o.src ?? o.srcs : o,
      !0
    );
  }
  /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */
  addManifest(t) {
    this._manifest && console.warn("[Resolver] Manifest already exists, this will be overwritten"), this._manifest = t, t.bundles.forEach((e) => {
      this.addBundle(e.name, e.assets);
    });
  }
  /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */
  addBundle(t, e) {
    const r = [];
    Array.isArray(e) ? e.forEach((i) => {
      const s = i.src ?? i.srcs, o = i.alias ?? i.name;
      let a;
      if (typeof o == "string") {
        const h = this._createBundleAssetId(t, o);
        r.push(h), a = [o, h];
      } else {
        const h = o.map((l) => this._createBundleAssetId(t, l));
        r.push(...h), a = [...o, ...h];
      }
      this.add({
        ...i,
        alias: a,
        src: s
      });
    }) : Object.keys(e).forEach((i) => {
      const s = [i, this._createBundleAssetId(t, i)];
      if (typeof e[i] == "string")
        this.add({
          alias: s,
          src: e[i]
        });
      else if (Array.isArray(e[i]))
        this.add({
          alias: s,
          src: e[i]
        });
      else {
        const o = e[i], a = o.src ?? o.srcs;
        this.add({
          ...o,
          alias: s,
          src: Array.isArray(a) ? a : [a]
        });
      }
      r.push(...s);
    }), this._bundles[t] = r;
  }
  add(t, e, r, i, s) {
    const o = [];
    typeof t == "string" || Array.isArray(t) && typeof t[0] == "string" ? (wt("7.2.0", `Assets.add now uses an object instead of individual parameters.
Please use Assets.add({ alias, src, data, format, loadParser }) instead.`), o.push({ alias: t, src: e, data: r, format: i, loadParser: s })) : Array.isArray(t) ? o.push(...t) : o.push(t);
    let a;
    a = (h) => {
      this.hasKey(h) && console.warn(`[Resolver] already has key: ${h} overwriting`);
    }, dr(o).forEach((h) => {
      const { src: l, srcs: u } = h;
      let { data: c, format: d, loadParser: f } = h;
      const p = dr(l || u).map((_) => typeof _ == "string" ? zb(_) : Array.isArray(_) ? _ : [_]), m = this.getAlias(h);
      Array.isArray(m) ? m.forEach(a) : a(m);
      const g = [];
      p.forEach((_) => {
        _.forEach((w) => {
          let v = {};
          if (typeof w != "object") {
            v.src = w;
            for (let E = 0; E < this._parsers.length; E++) {
              const x = this._parsers[E];
              if (x.test(w)) {
                v = x.parse(w);
                break;
              }
            }
          } else
            c = w.data ?? c, d = w.format ?? d, f = w.loadParser ?? f, v = {
              ...v,
              ...w
            };
          if (!m)
            throw new Error(`[Resolver] alias is undefined for this asset: ${v.src}`);
          v = this.buildResolvedAsset(v, {
            aliases: m,
            data: c,
            format: d,
            loadParser: f
          }), g.push(v);
        });
      }), m.forEach((_) => {
        this._assetMap[_] = g;
      });
    });
  }
  // TODO: this needs an overload like load did in Assets
  /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */
  resolveBundle(t) {
    const e = Qa(t);
    t = dr(t);
    const r = {};
    return t.forEach((i) => {
      const s = this._bundles[i];
      if (s) {
        const o = this.resolve(s), a = {};
        for (const h in o) {
          const l = o[h];
          a[this._extractAssetIdFromBundle(i, h)] = l;
        }
        r[i] = a;
      }
    }), e ? r[t[0]] : r;
  }
  /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */
  resolveUrl(t) {
    const e = this.resolve(t);
    if (typeof t != "string") {
      const r = {};
      for (const i in e)
        r[i] = e[i].src;
      return r;
    }
    return e.src;
  }
  resolve(t) {
    const e = Qa(t);
    t = dr(t);
    const r = {};
    return t.forEach((i) => {
      if (!this._resolverHash[i])
        if (this._assetMap[i]) {
          let s = this._assetMap[i];
          const o = s[0], a = this._getPreferredOrder(s);
          a?.priority.forEach((h) => {
            a.params[h].forEach((l) => {
              const u = s.filter((c) => c[h] ? c[h] === l : !1);
              u.length && (s = u);
            });
          }), this._resolverHash[i] = s[0] ?? o;
        } else
          this._resolverHash[i] = this.buildResolvedAsset({
            alias: [i],
            src: i
          }, {});
      r[i] = this._resolverHash[i];
    }), e ? r[t[0]] : r;
  }
  /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */
  hasKey(t) {
    return !!this._assetMap[t];
  }
  /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */
  hasBundle(t) {
    return !!this._bundles[t];
  }
  /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */
  _getPreferredOrder(t) {
    for (let e = 0; e < t.length; e++) {
      const r = t[0], i = this._preferredOrder.find((s) => s.params.format.includes(r.format));
      if (i)
        return i;
    }
    return this._preferredOrder[0];
  }
  /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */
  _appendDefaultSearchParams(t) {
    if (!this._defaultSearchParams)
      return t;
    const e = /\?/.test(t) ? "&" : "?";
    return `${t}${e}${this._defaultSearchParams}`;
  }
  buildResolvedAsset(t, e) {
    const { aliases: r, data: i, loadParser: s, format: o } = e;
    return (this._basePath || this._rootPath) && (t.src = ne.toAbsolute(t.src, this._basePath, this._rootPath)), t.alias = r ?? t.alias ?? [t.src], t.src = this._appendDefaultSearchParams(t.src), t.data = { ...i || {}, ...t.data }, t.loadParser = s ?? t.loadParser, t.format = o ?? ne.extname(t.src).slice(1), t.srcs = t.src, t.name = t.alias, t;
  }
}
class v2 {
  constructor() {
    this._detections = [], this._initialized = !1, this.resolver = new _2(), this.loader = new $b(), this.cache = ci, this._backgroundLoader = new Gb(this.loader), this._backgroundLoader.active = !0, this.reset();
  }
  /**
   * Best practice is to call this function before any loading commences
   * Initiating is the best time to add any customization to the way things are loaded.
   *
   * you do not need to call this for the Asset class to work, only if you want to set any initial properties
   * @param options - options to initialize the Asset manager with
   */
  async init(t = {}) {
    if (this._initialized) {
      console.warn("[Assets]AssetManager already initialized, did you load before calling this Asset.init()?");
      return;
    }
    if (this._initialized = !0, t.defaultSearchParams && this.resolver.setDefaultSearchParams(t.defaultSearchParams), t.basePath && (this.resolver.basePath = t.basePath), t.bundleIdentifier && this.resolver.setBundleIdentifier(t.bundleIdentifier), t.manifest) {
      let s = t.manifest;
      typeof s == "string" && (s = await this.load(s)), this.resolver.addManifest(s);
    }
    const e = t.texturePreference?.resolution ?? 1, r = typeof e == "number" ? [e] : e, i = await this._detectFormats({
      preferredFormats: t.texturePreference?.format,
      skipDetections: t.skipDetections,
      detections: this._detections
    });
    this.resolver.prefer({
      params: {
        format: i,
        resolution: r
      }
    }), t.preferences && this.setPreferences(t.preferences);
  }
  add(t, e, r, i, s) {
    this.resolver.add(t, e, r, i, s);
  }
  async load(t, e) {
    this._initialized || await this.init();
    const r = Qa(t), i = dr(t).map((a) => {
      if (typeof a != "string") {
        const h = this.resolver.getAlias(a);
        return h.some((l) => !this.resolver.hasKey(l)) && this.add(a), Array.isArray(h) ? h[0] : h;
      }
      return this.resolver.hasKey(a) || this.add({ alias: a, src: a }), a;
    }), s = this.resolver.resolve(i), o = await this._mapLoadToResolve(s, e);
    return r ? o[i[0]] : o;
  }
  /**
   * This adds a bundle of assets in one go so that you can load them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const assets = await Assets.loadBundle('animals');
   * @param bundleId - the id of the bundle to add
   * @param assets - a record of the asset or assets that will be chosen from when loading via the specified key
   */
  addBundle(t, e) {
    this.resolver.addBundle(t, e);
  }
  /**
   * Bundles are a way to load multiple assets at once.
   * If a manifest has been provided to the init function then you can load a bundle, or bundles.
   * you can also add bundles via `addBundle`
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * await Asset.init({ manifest });
   *
   * // Load a bundle...
   * loadScreenAssets = await Assets.loadBundle('load-screen');
   * // Load another bundle...
   * gameScreenAssets = await Assets.loadBundle('game-screen');
   * @param bundleIds - the bundle id or ids to load
   * @param onProgress - Optional function that is called when progress on asset loading is made.
   * The function is passed a single parameter, `progress`, which represents the percentage (0.0 - 1.0)
   * of the assets loaded. Do not use this function to detect when assets are complete and available,
   * instead use the Promise returned by this function.
   * @returns all the bundles assets or a hash of assets for each bundle specified
   */
  async loadBundle(t, e) {
    this._initialized || await this.init();
    let r = !1;
    typeof t == "string" && (r = !0, t = [t]);
    const i = this.resolver.resolveBundle(t), s = {}, o = Object.keys(i);
    let a = 0, h = 0;
    const l = () => {
      e?.(++a / h);
    }, u = o.map((c) => {
      const d = i[c];
      return h += Object.keys(d).length, this._mapLoadToResolve(d, l).then((f) => {
        s[c] = f;
      });
    });
    return await Promise.all(u), r ? s[t[0]] : s;
  }
  /**
   * Initiate a background load of some assets. It will passively begin to load these assets in the background.
   * So when you actually come to loading them you will get a promise that resolves to the loaded assets immediately
   *
   * An example of this might be that you would background load game assets after your inital load.
   * then when you got to actually load your game screen assets when a player goes to the game - the loading
   * would already have stared or may even be complete, saving you having to show an interim load bar.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.backgroundLoad('bunny.png');
   *
   * // later on in your app...
   * await Assets.loadBundle('bunny.png'); // Will resolve quicker as loading may have completed!
   * @param urls - the url / urls you want to background load
   */
  async backgroundLoad(t) {
    this._initialized || await this.init(), typeof t == "string" && (t = [t]);
    const e = this.resolver.resolve(t);
    this._backgroundLoader.add(Object.values(e));
  }
  /**
   * Initiate a background of a bundle, works exactly like backgroundLoad but for bundles.
   * this can only be used if the loader has been initiated with a manifest
   * @example
   * import { Assets } from 'pixi.js';
   *
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *                 name: 'load-screen',
   *                 assets: [...],
   *             },
   *             ...
   *         ],
   *     },
   * });
   *
   * Assets.backgroundLoadBundle('load-screen');
   *
   * // Later on in your app...
   * await Assets.loadBundle('load-screen'); // Will resolve quicker as loading may have completed!
   * @param bundleIds - the bundleId / bundleIds you want to background load
   */
  async backgroundLoadBundle(t) {
    this._initialized || await this.init(), typeof t == "string" && (t = [t]);
    const e = this.resolver.resolveBundle(t);
    Object.values(e).forEach((r) => {
      this._backgroundLoader.add(Object.values(r));
    });
  }
  /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   */
  reset() {
    this.resolver.reset(), this.loader.reset(), this.cache.reset(), this._initialized = !1;
  }
  get(t) {
    if (typeof t == "string")
      return ci.get(t);
    const e = {};
    for (let r = 0; r < t.length; r++)
      e[r] = ci.get(t[r]);
    return e;
  }
  /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */
  async _mapLoadToResolve(t, e) {
    const r = Object.values(t), i = Object.keys(t);
    this._backgroundLoader.active = !1;
    const s = await this.loader.load(r, e);
    this._backgroundLoader.active = !0;
    const o = {};
    return r.forEach((a, h) => {
      const l = s[a.src], u = [a.src];
      a.alias && u.push(...a.alias), o[i[h]] = l, ci.set(u, l);
    }), o;
  }
  /**
   * Unload an asset or assets. As the Assets class is responsible for creating the assets via the `load` function
   * this will make sure to destroy any assets and release them from memory.
   * Once unloaded, you will need to load the asset again.
   *
   * Use this to help manage assets if you find that you have a large app and you want to free up memory.
   *
   * - it's up to you as the developer to make sure that textures are not actively being used when you unload them,
   * Pixi won't break but you will end up with missing assets. Not a good look for the user!
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Load a URL:
   * const myImageTexture = await Assets.load('http://some.url.com/image.png'); // => returns a texture
   *
   * await Assets.unload('http://some.url.com/image.png')
   *
   * // myImageTexture will be destroyed now.
   *
   * // Unload multiple assets:
   * const textures = await Assets.unload(['thumper', 'chicko']);
   * @param urls - the urls to unload
   */
  async unload(t) {
    this._initialized || await this.init();
    const e = dr(t).map((i) => typeof i != "string" ? i.src : i), r = this.resolver.resolve(e);
    await this._unloadFromResolved(r);
  }
  /**
   * Bundles are a way to manage multiple assets at once.
   * this will unload all files in a bundle.
   *
   * once a bundle has been unloaded, you need to load it again to have access to the assets.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle({
   *     'thumper': 'http://some.url.com/thumper.png',
   * })
   *
   * const assets = await Assets.loadBundle('thumper');
   *
   * // Now to unload...
   *
   * await Assets.unloadBundle('thumper');
   *
   * // All assets in the assets object will now have been destroyed and purged from the cache
   * @param bundleIds - the bundle id or ids to unload
   */
  async unloadBundle(t) {
    this._initialized || await this.init(), t = dr(t);
    const e = this.resolver.resolveBundle(t), r = Object.keys(e).map((i) => this._unloadFromResolved(e[i]));
    await Promise.all(r);
  }
  async _unloadFromResolved(t) {
    const e = Object.values(t);
    e.forEach((r) => {
      ci.remove(r.src);
    }), await this.loader.unload(e);
  }
  /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */
  async _detectFormats(t) {
    let e = [];
    t.preferredFormats && (e = Array.isArray(t.preferredFormats) ? t.preferredFormats : [t.preferredFormats]);
    for (const r of t.detections)
      t.skipDetections || await r.test() ? e = await r.add(e) : t.skipDetections || (e = await r.remove(e));
    return e = e.filter((r, i) => e.indexOf(r) === i), e;
  }
  /** All the detection parsers currently added to the Assets class. */
  get detections() {
    return this._detections;
  }
  /**
   * @deprecated since 7.2.0
   * @see {@link Assets.setPreferences}
   */
  get preferWorkers() {
    return Dh.config.preferWorkers;
  }
  set preferWorkers(t) {
    wt("7.2.0", "Assets.prefersWorkers is deprecated, use Assets.setPreferences({ preferWorkers: true }) instead."), this.setPreferences({ preferWorkers: t });
  }
  /**
   * General setter for preferences. This is a helper function to set preferences on all parsers.
   * @param preferences - the preferences to set
   */
  setPreferences(t) {
    this.loader.parsers.forEach((e) => {
      e.config && Object.keys(e.config).filter((r) => r in t).forEach((r) => {
        e.config[r] = t[r];
      });
    });
  }
}
const ha = new v2();
dt.handleByList(st.LoadParser, ha.loader.parsers).handleByList(st.ResolveParser, ha.resolver.parsers).handleByList(st.CacheParser, ha.cache.parsers).handleByList(st.DetectionParser, ha.detections);
const x2 = {
  extension: st.CacheParser,
  test: (n) => Array.isArray(n) && n.every((t) => t instanceof ct),
  getCacheableAssets: (n, t) => {
    const e = {};
    return n.forEach((r) => {
      t.forEach((i, s) => {
        e[r + (s === 0 ? "" : s + 1)] = i;
      });
    }), e;
  }
};
dt.add(x2);
async function $0(n) {
  if ("Image" in globalThis)
    return new Promise((t) => {
      const e = new Image();
      e.onload = () => {
        t(!0);
      }, e.onerror = () => {
        t(!1);
      }, e.src = n;
    });
  if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
    try {
      const t = await (await fetch(n)).blob();
      await createImageBitmap(t);
    } catch {
      return !1;
    }
    return !0;
  }
  return !1;
}
const w2 = {
  extension: {
    type: st.DetectionParser,
    priority: 1
  },
  test: async () => $0(
    // eslint-disable-next-line max-len
    "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="
  ),
  add: async (n) => [...n, "avif"],
  remove: async (n) => n.filter((t) => t !== "avif")
};
dt.add(w2);
const b2 = {
  extension: {
    type: st.DetectionParser,
    priority: 0
  },
  test: async () => $0(
    "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="
  ),
  add: async (n) => [...n, "webp"],
  remove: async (n) => n.filter((t) => t !== "webp")
};
dt.add(b2);
const Kp = ["png", "jpg", "jpeg"], T2 = {
  extension: {
    type: st.DetectionParser,
    priority: -1
  },
  test: () => Promise.resolve(!0),
  add: async (n) => [...n, ...Kp],
  remove: async (n) => n.filter((t) => !Kp.includes(t))
};
dt.add(T2);
const A2 = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function ud(n) {
  return A2 ? !1 : document.createElement("video").canPlayType(n) !== "";
}
const E2 = {
  extension: {
    type: st.DetectionParser,
    priority: 0
  },
  test: async () => ud("video/webm"),
  add: async (n) => [...n, "webm"],
  remove: async (n) => n.filter((t) => t !== "webm")
};
dt.add(E2);
const S2 = {
  extension: {
    type: st.DetectionParser,
    priority: 0
  },
  test: async () => ud("video/mp4"),
  add: async (n) => [...n, "mp4", "m4v"],
  remove: async (n) => n.filter((t) => t !== "mp4" && t !== "m4v")
};
dt.add(S2);
const C2 = {
  extension: {
    type: st.DetectionParser,
    priority: 0
  },
  test: async () => ud("video/ogg"),
  add: async (n) => [...n, "ogv"],
  remove: async (n) => n.filter((t) => t !== "ogv")
};
dt.add(C2);
const M2 = {
  extension: st.ResolveParser,
  test: Dh.test,
  parse: (n) => ({
    resolution: parseFloat(ht.RETINA_PREFIX.exec(n)?.[1] ?? "1"),
    format: ne.extname(n).slice(1),
    src: n
  })
};
dt.add(M2);
var Oe = /* @__PURE__ */ ((n) => (n[n.COMPRESSED_RGB_S3TC_DXT1_EXT = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT", n[n.COMPRESSED_RGBA_S3TC_DXT1_EXT = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT", n[n.COMPRESSED_RGBA_S3TC_DXT3_EXT = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT", n[n.COMPRESSED_RGBA_S3TC_DXT5_EXT = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT", n[n.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT", n[n.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT", n[n.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT", n[n.COMPRESSED_SRGB_S3TC_DXT1_EXT = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT", n[n.COMPRESSED_R11_EAC = 37488] = "COMPRESSED_R11_EAC", n[n.COMPRESSED_SIGNED_R11_EAC = 37489] = "COMPRESSED_SIGNED_R11_EAC", n[n.COMPRESSED_RG11_EAC = 37490] = "COMPRESSED_RG11_EAC", n[n.COMPRESSED_SIGNED_RG11_EAC = 37491] = "COMPRESSED_SIGNED_RG11_EAC", n[n.COMPRESSED_RGB8_ETC2 = 37492] = "COMPRESSED_RGB8_ETC2", n[n.COMPRESSED_RGBA8_ETC2_EAC = 37496] = "COMPRESSED_RGBA8_ETC2_EAC", n[n.COMPRESSED_SRGB8_ETC2 = 37493] = "COMPRESSED_SRGB8_ETC2", n[n.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = 37497] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC", n[n.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37494] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2", n[n.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37495] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2", n[n.COMPRESSED_RGB_PVRTC_4BPPV1_IMG = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG", n[n.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG", n[n.COMPRESSED_RGB_PVRTC_2BPPV1_IMG = 35841] = "COMPRESSED_RGB_PVRTC_2BPPV1_IMG", n[n.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG = 35843] = "COMPRESSED_RGBA_PVRTC_2BPPV1_IMG", n[n.COMPRESSED_RGB_ETC1_WEBGL = 36196] = "COMPRESSED_RGB_ETC1_WEBGL", n[n.COMPRESSED_RGB_ATC_WEBGL = 35986] = "COMPRESSED_RGB_ATC_WEBGL", n[n.COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL = 35986] = "COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL", n[n.COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL = 34798] = "COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL", n[n.COMPRESSED_RGBA_ASTC_4x4_KHR = 37808] = "COMPRESSED_RGBA_ASTC_4x4_KHR", n))(Oe || {});
const Ja = {
  // WEBGL_compressed_texture_s3tc
  33776: 0.5,
  33777: 0.5,
  33778: 1,
  33779: 1,
  // WEBGL_compressed_texture_s3tc
  35916: 0.5,
  35917: 0.5,
  35918: 1,
  35919: 1,
  // WEBGL_compressed_texture_etc
  37488: 0.5,
  37489: 0.5,
  37490: 1,
  37491: 1,
  37492: 0.5,
  37496: 1,
  37493: 0.5,
  37497: 1,
  37494: 0.5,
  // ~~
  37495: 0.5,
  // ~~
  // WEBGL_compressed_texture_pvrtc
  35840: 0.5,
  35842: 0.5,
  35841: 0.25,
  35843: 0.25,
  // WEBGL_compressed_texture_etc1
  36196: 0.5,
  // @see https://www.khronos.org/registry/OpenGL/extensions/AMD/AMD_compressed_ATC_texture.txt
  // WEBGL_compressed_texture_atc
  35986: 0.5,
  35986: 1,
  34798: 1,
  // @see https://registry.khronos.org/OpenGL/extensions/KHR/KHR_texture_compression_astc_hdr.txt
  // WEBGL_compressed_texture_astc
  /* eslint-disable-next-line camelcase */
  37808: 1
};
let qr, Vi;
function Qp() {
  Vi = {
    s3tc: qr.getExtension("WEBGL_compressed_texture_s3tc"),
    s3tc_sRGB: qr.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
    /* eslint-disable-line camelcase */
    etc: qr.getExtension("WEBGL_compressed_texture_etc"),
    etc1: qr.getExtension("WEBGL_compressed_texture_etc1"),
    pvrtc: qr.getExtension("WEBGL_compressed_texture_pvrtc") || qr.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
    atc: qr.getExtension("WEBGL_compressed_texture_atc"),
    astc: qr.getExtension("WEBGL_compressed_texture_astc")
  };
}
const I2 = {
  extension: {
    type: st.DetectionParser,
    priority: 2
  },
  test: async () => {
    const n = ht.ADAPTER.createCanvas().getContext("webgl");
    return n ? (qr = n, !0) : (console.warn("WebGL not available for compressed textures."), !1);
  },
  add: async (n) => {
    Vi || Qp();
    const t = [];
    for (const e in Vi)
      Vi[e] && t.push(e);
    return [...t, ...n];
  },
  remove: async (n) => (Vi || Qp(), n.filter((t) => !(t in Vi)))
};
dt.add(I2);
class P2 extends Ch {
  /**
   * @param source - The buffer/URL of the texture file.
   * @param {PIXI.IBlobResourceOptions} [options]
   * @param {boolean} [options.autoLoad=false] - Whether to fetch the data immediately;
   *  you can fetch it later via {@link PIXI.BlobResource#load}.
   * @param {number} [options.width=1] - The width in pixels.
   * @param {number} [options.height=1] - The height in pixels.
   * @param {1|2|4|8} [options.unpackAlignment=4] - The alignment of the pixel rows.
   */
  constructor(t, e = { width: 1, height: 1, autoLoad: !0 }) {
    let r, i;
    typeof t == "string" ? (r = t, i = new Uint8Array()) : (r = null, i = t), super(i, e), this.origin = r, this.buffer = i ? new Xu(i) : null, this._load = null, this.loaded = !1, this.origin !== null && e.autoLoad !== !1 && this.load(), this.origin === null && this.buffer && (this._load = Promise.resolve(this), this.loaded = !0, this.onBlobLoaded(this.buffer.rawBinaryData));
  }
  onBlobLoaded(t) {
  }
  /** Loads the blob */
  load() {
    return this._load ? this._load : (this._load = fetch(this.origin).then((t) => t.blob()).then((t) => t.arrayBuffer()).then((t) => (this.data = new Uint32Array(t), this.buffer = new Xu(t), this.loaded = !0, this.onBlobLoaded(t), this.update(), this)), this._load);
  }
}
class gi extends P2 {
  /**
   * @param source - the buffer/URL holding the compressed texture data
   * @param options
   * @param {PIXI.INTERNAL_FORMATS} options.format - the compression format
   * @param {number} options.width - the image width in pixels.
   * @param {number} options.height - the image height in pixels.
   * @param {number} [options.level=1] - the mipmap levels stored in the compressed texture, including level 0.
   * @param {number} [options.levelBuffers] - the buffers for each mipmap level. `CompressedTextureResource` can allows you
   *      to pass `null` for `source`, for cases where each level is stored in non-contiguous memory.
   */
  constructor(t, e) {
    super(t, e), this.format = e.format, this.levels = e.levels || 1, this._width = e.width, this._height = e.height, this._extension = gi._formatToExtension(this.format), (e.levelBuffers || this.buffer) && (this._levelBuffers = e.levelBuffers || gi._createLevelBuffers(
      t instanceof Uint8Array ? t : this.buffer.uint8View,
      this.format,
      this.levels,
      4,
      4,
      // PVRTC has 8x4 blocks in 2bpp mode
      this.width,
      this.height
    ));
  }
  /**
   * @override
   * @param renderer - A reference to the current renderer
   * @param _texture - the texture
   * @param _glTexture - texture instance for this webgl context
   */
  upload(t, e, r) {
    const i = t.gl;
    if (!t.context.extensions[this._extension])
      throw new Error(`${this._extension} textures are not supported on the current machine`);
    if (!this._levelBuffers)
      return !1;
    i.pixelStorei(i.UNPACK_ALIGNMENT, 4);
    for (let s = 0, o = this.levels; s < o; s++) {
      const { levelID: a, levelWidth: h, levelHeight: l, levelBuffer: u } = this._levelBuffers[s];
      i.compressedTexImage2D(i.TEXTURE_2D, a, this.format, h, l, 0, u);
    }
    return !0;
  }
  /** @protected */
  onBlobLoaded() {
    this._levelBuffers = gi._createLevelBuffers(
      this.buffer.uint8View,
      this.format,
      this.levels,
      4,
      4,
      // PVRTC has 8x4 blocks in 2bpp mode
      this.width,
      this.height
    );
  }
  /**
   * Returns the key (to ContextSystem#extensions) for the WebGL extension supporting the compression format
   * @private
   * @param format - the compression format to get the extension for.
   */
  static _formatToExtension(t) {
    if (t >= 33776 && t <= 33779)
      return "s3tc";
    if (t >= 37488 && t <= 37497)
      return "etc";
    if (t >= 35840 && t <= 35843)
      return "pvrtc";
    if (t >= 36196)
      return "etc1";
    if (t >= 35986 && t <= 34798)
      return "atc";
    throw new Error("Invalid (compressed) texture format given!");
  }
  /**
   * Pre-creates buffer views for each mipmap level
   * @private
   * @param buffer -
   * @param format - compression formats
   * @param levels - mipmap levels
   * @param blockWidth -
   * @param blockHeight -
   * @param imageWidth - width of the image in pixels
   * @param imageHeight - height of the image in pixels
   */
  static _createLevelBuffers(t, e, r, i, s, o, a) {
    const h = new Array(r);
    let l = t.byteOffset, u = o, c = a, d = u + i - 1 & ~(i - 1), f = c + s - 1 & ~(s - 1), p = d * f * Ja[e];
    for (let m = 0; m < r; m++)
      h[m] = {
        levelID: m,
        levelWidth: r > 1 ? u : d,
        levelHeight: r > 1 ? c : f,
        levelBuffer: new Uint8Array(t.buffer, l, p)
      }, l += p, u = u >> 1 || 1, c = c >> 1 || 1, d = u + i - 1 & ~(i - 1), f = c + s - 1 & ~(s - 1), p = d * f * Ja[e];
    return h;
  }
}
const cu = 4, la = 124, R2 = 32, Jp = 20, D2 = 542327876, ua = {
  HEIGHT: 3,
  WIDTH: 4,
  MIPMAP_COUNT: 7,
  PIXEL_FORMAT: 19
}, F2 = {
  FOURCC: 2
}, ca = {
  DXGI_FORMAT: 0,
  RESOURCE_DIMENSION: 1,
  MISC_FLAG: 2,
  ARRAY_SIZE: 3
}, O2 = 1, N2 = 2, k2 = 4, B2 = 64, L2 = 512, U2 = 131072, H2 = 827611204, G2 = 861165636, z2 = 894720068, W2 = 808540228, $2 = 4, X2 = {
  [H2]: Oe.COMPRESSED_RGBA_S3TC_DXT1_EXT,
  [G2]: Oe.COMPRESSED_RGBA_S3TC_DXT3_EXT,
  [z2]: Oe.COMPRESSED_RGBA_S3TC_DXT5_EXT
}, V2 = {
  // WEBGL_compressed_texture_s3tc
  70: Oe.COMPRESSED_RGBA_S3TC_DXT1_EXT,
  71: Oe.COMPRESSED_RGBA_S3TC_DXT1_EXT,
  73: Oe.COMPRESSED_RGBA_S3TC_DXT3_EXT,
  74: Oe.COMPRESSED_RGBA_S3TC_DXT3_EXT,
  76: Oe.COMPRESSED_RGBA_S3TC_DXT5_EXT,
  77: Oe.COMPRESSED_RGBA_S3TC_DXT5_EXT,
  // WEBGL_compressed_texture_s3tc_srgb
  72: Oe.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT,
  75: Oe.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT,
  78: Oe.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
};
function Y2(n) {
  const t = new Uint32Array(n);
  if (t[0] !== D2)
    throw new Error("Invalid DDS file magic word");
  const e = new Uint32Array(n, 0, la / Uint32Array.BYTES_PER_ELEMENT), r = e[ua.HEIGHT], i = e[ua.WIDTH], s = e[ua.MIPMAP_COUNT], o = new Uint32Array(
    n,
    ua.PIXEL_FORMAT * Uint32Array.BYTES_PER_ELEMENT,
    R2 / Uint32Array.BYTES_PER_ELEMENT
  ), a = o[O2];
  if (a & k2) {
    const h = o[F2.FOURCC];
    if (h !== W2) {
      const w = X2[h], v = cu + la, E = new Uint8Array(n, v);
      return [new gi(E, {
        format: w,
        width: i,
        height: r,
        levels: s
        // CompressedTextureResource will separate the levelBuffers for us!
      })];
    }
    const l = cu + la, u = new Uint32Array(
      t.buffer,
      l,
      Jp / Uint32Array.BYTES_PER_ELEMENT
    ), c = u[ca.DXGI_FORMAT], d = u[ca.RESOURCE_DIMENSION], f = u[ca.MISC_FLAG], p = u[ca.ARRAY_SIZE], m = V2[c];
    if (m === void 0)
      throw new Error(`DDSParser cannot parse texture data with DXGI format ${c}`);
    if (f === $2)
      throw new Error("DDSParser does not support cubemap textures");
    if (d === 6)
      throw new Error("DDSParser does not supported 3D texture data");
    const g = new Array(), _ = cu + la + Jp;
    if (p === 1)
      g.push(new Uint8Array(n, _));
    else {
      const w = Ja[m];
      let v = 0, E = i, x = r;
      for (let y = 0; y < s; y++) {
        const C = Math.max(1, E + 3 & -4), M = Math.max(1, x + 3 & -4), U = C * M * w;
        v += U, E = E >>> 1, x = x >>> 1;
      }
      let b = _;
      for (let y = 0; y < p; y++)
        g.push(new Uint8Array(n, b, v)), b += v;
    }
    return g.map((w) => new gi(w, {
      format: m,
      width: i,
      height: r,
      levels: s
    }));
  }
  throw a & B2 ? new Error("DDSParser does not support uncompressed texture data.") : a & L2 ? new Error("DDSParser does not supported YUV uncompressed texture data.") : a & U2 ? new Error("DDSParser does not support single-channel (lumninance) texture data!") : a & N2 ? new Error("DDSParser does not support single-channel (alpha) texture data!") : new Error("DDSParser failed to load a texture file due to an unknown reason!");
}
const tm = [171, 75, 84, 88, 32, 49, 49, 187, 13, 10, 26, 10], j2 = 67305985, hr = {
  ENDIANNESS: 12,
  GL_TYPE: 16,
  GL_FORMAT: 24,
  GL_INTERNAL_FORMAT: 28,
  PIXEL_WIDTH: 36,
  PIXEL_HEIGHT: 40,
  PIXEL_DEPTH: 44,
  NUMBER_OF_ARRAY_ELEMENTS: 48,
  NUMBER_OF_FACES: 52,
  NUMBER_OF_MIPMAP_LEVELS: 56,
  BYTES_OF_KEY_VALUE_DATA: 60
}, gc = 64, em = {
  [pt.UNSIGNED_BYTE]: 1,
  [pt.UNSIGNED_SHORT]: 2,
  [pt.INT]: 4,
  [pt.UNSIGNED_INT]: 4,
  [pt.FLOAT]: 4,
  [pt.HALF_FLOAT]: 8
}, q2 = {
  [Q.RGBA]: 4,
  [Q.RGB]: 3,
  [Q.RG]: 2,
  [Q.RED]: 1,
  [Q.LUMINANCE]: 1,
  [Q.LUMINANCE_ALPHA]: 2,
  [Q.ALPHA]: 1
}, Z2 = {
  [pt.UNSIGNED_SHORT_4_4_4_4]: 2,
  [pt.UNSIGNED_SHORT_5_5_5_1]: 2,
  [pt.UNSIGNED_SHORT_5_6_5]: 2
};
function K2(n, t, e = !1) {
  const r = new DataView(t);
  if (!Q2(n, r))
    return null;
  const i = r.getUint32(hr.ENDIANNESS, !0) === j2, s = r.getUint32(hr.GL_TYPE, i), o = r.getUint32(hr.GL_FORMAT, i), a = r.getUint32(hr.GL_INTERNAL_FORMAT, i), h = r.getUint32(hr.PIXEL_WIDTH, i), l = r.getUint32(hr.PIXEL_HEIGHT, i) || 1, u = r.getUint32(hr.PIXEL_DEPTH, i) || 1, c = r.getUint32(hr.NUMBER_OF_ARRAY_ELEMENTS, i) || 1, d = r.getUint32(hr.NUMBER_OF_FACES, i), f = r.getUint32(hr.NUMBER_OF_MIPMAP_LEVELS, i), p = r.getUint32(hr.BYTES_OF_KEY_VALUE_DATA, i);
  if (l === 0 || u !== 1)
    throw new Error("Only 2D textures are supported");
  if (d !== 1)
    throw new Error("CubeTextures are not supported by KTXLoader yet!");
  if (c !== 1)
    throw new Error("WebGL does not support array textures");
  const m = 4, g = 4, _ = h + 3 & -4, w = l + 3 & -4, v = new Array(c);
  let E = h * l;
  s === 0 && (E = _ * w);
  let x;
  if (s !== 0 ? em[s] ? x = em[s] * q2[o] : x = Z2[s] : x = Ja[a], x === void 0)
    throw new Error("Unable to resolve the pixel format stored in the *.ktx file!");
  const b = e ? tT(r, p, i) : null;
  let y = E * x, C = h, M = l, U = _, F = w, O = gc + p;
  for (let R = 0; R < f; R++) {
    const k = r.getUint32(O, i);
    let j = O + 4;
    for (let T = 0; T < c; T++) {
      let S = v[T];
      S || (S = v[T] = new Array(f)), S[R] = {
        levelID: R,
        // don't align mipWidth when texture not compressed! (glType not zero)
        levelWidth: f > 1 || s !== 0 ? C : U,
        levelHeight: f > 1 || s !== 0 ? M : F,
        levelBuffer: new Uint8Array(t, j, y)
      }, j += y;
    }
    O += k + 4, O = O % 4 !== 0 ? O + 4 - O % 4 : O, C = C >> 1 || 1, M = M >> 1 || 1, U = C + m - 1 & -4, F = M + g - 1 & -4, y = U * F * x;
  }
  return s !== 0 ? {
    uncompressed: v.map((R) => {
      let k = R[0].levelBuffer, j = !1;
      return s === pt.FLOAT ? k = new Float32Array(
        R[0].levelBuffer.buffer,
        R[0].levelBuffer.byteOffset,
        R[0].levelBuffer.byteLength / 4
      ) : s === pt.UNSIGNED_INT ? (j = !0, k = new Uint32Array(
        R[0].levelBuffer.buffer,
        R[0].levelBuffer.byteOffset,
        R[0].levelBuffer.byteLength / 4
      )) : s === pt.INT && (j = !0, k = new Int32Array(
        R[0].levelBuffer.buffer,
        R[0].levelBuffer.byteOffset,
        R[0].levelBuffer.byteLength / 4
      )), {
        resource: new Ch(
          k,
          {
            width: R[0].levelWidth,
            height: R[0].levelHeight
          }
        ),
        type: s,
        format: j ? J2(o) : o
      };
    }),
    kvData: b
  } : {
    compressed: v.map((R) => new gi(null, {
      format: a,
      width: h,
      height: l,
      levels: f,
      levelBuffers: R
    })),
    kvData: b
  };
}
function Q2(n, t) {
  for (let e = 0; e < tm.length; e++)
    if (t.getUint8(e) !== tm[e])
      return console.error(`${n} is not a valid *.ktx file!`), !1;
  return !0;
}
function J2(n) {
  switch (n) {
    case Q.RGBA:
      return Q.RGBA_INTEGER;
    case Q.RGB:
      return Q.RGB_INTEGER;
    case Q.RG:
      return Q.RG_INTEGER;
    case Q.RED:
      return Q.RED_INTEGER;
    default:
      return n;
  }
}
function tT(n, t, e) {
  const r = /* @__PURE__ */ new Map();
  let i = 0;
  for (; i < t; ) {
    const s = n.getUint32(gc + i, e), o = gc + i + 4, a = 3 - (s + 3) % 4;
    if (s === 0 || s > t - i) {
      console.error("KTXLoader: keyAndValueByteSize out of bounds");
      break;
    }
    let h = 0;
    for (; h < s && n.getUint8(o + h) !== 0; h++)
      ;
    if (h === -1) {
      console.error("KTXLoader: Failed to find null byte terminating kvData key");
      break;
    }
    const l = new TextDecoder().decode(
      new Uint8Array(n.buffer, o, h)
    ), u = new DataView(
      n.buffer,
      o + h + 1,
      s - h - 1
    );
    r.set(l, u), i += 4 + s + a;
  }
  return r;
}
const eT = {
  extension: {
    type: st.LoadParser,
    priority: yr.High
  },
  name: "loadDDS",
  test(n) {
    return Wn(n, ".dds");
  },
  async load(n, t, e) {
    const r = await (await ht.ADAPTER.fetch(n)).arrayBuffer(), i = Y2(r).map((s) => {
      const o = new _t(s, {
        mipmap: Lr.OFF,
        alphaMode: Ae.NO_PREMULTIPLIED_ALPHA,
        resolution: sn(n),
        ...t.data
      });
      return Io(o, e, n);
    });
    return i.length === 1 ? i[0] : i;
  },
  unload(n) {
    Array.isArray(n) ? n.forEach((t) => t.destroy(!0)) : n.destroy(!0);
  }
};
dt.add(eT);
const rT = {
  extension: {
    type: st.LoadParser,
    priority: yr.High
  },
  name: "loadKTX",
  test(n) {
    return Wn(n, ".ktx");
  },
  async load(n, t, e) {
    const r = await (await ht.ADAPTER.fetch(n)).arrayBuffer(), { compressed: i, uncompressed: s, kvData: o } = K2(n, r), a = i ?? s, h = {
      mipmap: Lr.OFF,
      alphaMode: Ae.NO_PREMULTIPLIED_ALPHA,
      resolution: sn(n),
      ...t.data
    }, l = a.map((u) => {
      a === s && Object.assign(h, {
        type: u.type,
        format: u.format
      });
      const c = u.resource ?? u, d = new _t(c, h);
      return d.ktxKeyValueData = o, Io(d, e, n);
    });
    return l.length === 1 ? l[0] : l;
  },
  unload(n) {
    Array.isArray(n) ? n.forEach((t) => t.destroy(!0)) : n.destroy(!0);
  }
};
dt.add(rT);
const nT = {
  extension: st.ResolveParser,
  test: (n) => {
    const t = ne.extname(n).slice(1);
    return ["basis", "ktx", "dds"].includes(t);
  },
  parse: (n) => {
    const t = ne.extname(n).slice(1);
    if (t === "ktx") {
      const e = [
        ".s3tc.ktx",
        ".s3tc_sRGB.ktx",
        ".etc.ktx",
        ".etc1.ktx",
        ".pvrt.ktx",
        ".atc.ktx",
        ".astc.ktx"
      ];
      if (e.some((r) => n.endsWith(r)))
        return {
          resolution: parseFloat(ht.RETINA_PREFIX.exec(n)?.[1] ?? "1"),
          format: e.find((r) => n.endsWith(r)),
          src: n
        };
    }
    return {
      resolution: parseFloat(ht.RETINA_PREFIX.exec(n)?.[1] ?? "1"),
      format: t,
      src: n
    };
  }
};
dt.add(nT);
const da = new yt(), iT = 4, X0 = class Ks {
  /**
   * @param renderer - A reference to the current renderer
   */
  constructor(t) {
    this.renderer = t, this._rendererPremultipliedAlpha = !1;
  }
  contextChange() {
    const t = this.renderer?.gl.getContextAttributes();
    this._rendererPremultipliedAlpha = !!(t && t.alpha && t.premultipliedAlpha);
  }
  /**
   * Will return a HTML Image of the target
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param format - Image format, e.g. "image/jpeg" or "image/webp".
   * @param quality - JPEG or Webp compression from 0 to 1. Default is 0.92.
   * @param frame - The frame the extraction is restricted to.
   * @returns - HTML Image of the target
   */
  async image(t, e, r, i) {
    const s = new Image();
    return s.src = await this.base64(t, e, r, i), s;
  }
  /**
   * Will return a base64 encoded string of this target. It works by calling
   *  `Extract.canvas` and then running toDataURL on that.
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param format - Image format, e.g. "image/jpeg" or "image/webp".
   * @param quality - JPEG or Webp compression from 0 to 1. Default is 0.92.
   * @param frame - The frame the extraction is restricted to.
   * @returns - A base64 encoded string of the texture.
   */
  async base64(t, e, r, i) {
    const s = this.canvas(t, i);
    if (s.toBlob !== void 0)
      return new Promise((o, a) => {
        s.toBlob((h) => {
          if (!h) {
            a(new Error("ICanvas.toBlob failed!"));
            return;
          }
          const l = new FileReader();
          l.onload = () => o(l.result), l.onerror = a, l.readAsDataURL(h);
        }, e, r);
      });
    if (s.toDataURL !== void 0)
      return s.toDataURL(e, r);
    if (s.convertToBlob !== void 0) {
      const o = await s.convertToBlob({ type: e, quality: r });
      return new Promise((a, h) => {
        const l = new FileReader();
        l.onload = () => a(l.result), l.onerror = h, l.readAsDataURL(o);
      });
    }
    throw new Error("Extract.base64() requires ICanvas.toDataURL, ICanvas.toBlob, or ICanvas.convertToBlob to be implemented");
  }
  /**
   * Creates a Canvas element, renders this target to it and then returns it.
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param frame - The frame the extraction is restricted to.
   * @returns - A Canvas element with the texture rendered on.
   */
  canvas(t, e) {
    const { pixels: r, width: i, height: s, flipY: o, premultipliedAlpha: a } = this._rawPixels(t, e);
    o && Ks._flipY(r, i, s), a && Ks._unpremultiplyAlpha(r);
    const h = new Hx(i, s, 1), l = new ImageData(new Uint8ClampedArray(r.buffer), i, s);
    return h.context.putImageData(l, 0, 0), h.canvas;
  }
  /**
   * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
   * order, with integer values between 0 and 255 (included).
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param frame - The frame the extraction is restricted to.
   * @returns - One-dimensional array containing the pixel data of the entire texture
   */
  pixels(t, e) {
    const { pixels: r, width: i, height: s, flipY: o, premultipliedAlpha: a } = this._rawPixels(t, e);
    return o && Ks._flipY(r, i, s), a && Ks._unpremultiplyAlpha(r), r;
  }
  _rawPixels(t, e) {
    const r = this.renderer;
    if (!r)
      throw new Error("The Extract has already been destroyed");
    let i, s = !1, o = !1, a, h = !1;
    t && (t instanceof Di ? a = t : (a = r.generateTexture(t, {
      region: e,
      resolution: r.resolution,
      multisample: r.multisample
    }), h = !0, e && (da.width = e.width, da.height = e.height, e = da)));
    const l = r.gl;
    if (a) {
      if (i = a.baseTexture.resolution, e = e ?? a.frame, s = !1, o = a.baseTexture.alphaMode > 0 && a.baseTexture.format === Q.RGBA, !h) {
        r.renderTexture.bind(a);
        const f = a.framebuffer.glFramebuffers[r.CONTEXT_UID];
        f.blitFramebuffer && r.framebuffer.bind(f.blitFramebuffer);
      }
    } else
      i = r.resolution, e || (e = da, e.width = r.width / i, e.height = r.height / i), s = !0, o = this._rendererPremultipliedAlpha, r.renderTexture.bind();
    const u = Math.max(Math.round(e.width * i), 1), c = Math.max(Math.round(e.height * i), 1), d = new Uint8Array(iT * u * c);
    return l.readPixels(
      Math.round(e.x * i),
      Math.round(e.y * i),
      u,
      c,
      l.RGBA,
      l.UNSIGNED_BYTE,
      d
    ), h && a?.destroy(!0), { pixels: d, width: u, height: c, flipY: s, premultipliedAlpha: o };
  }
  /** Destroys the extract. */
  destroy() {
    this.renderer = null;
  }
  static _flipY(t, e, r) {
    const i = e << 2, s = r >> 1, o = new Uint8Array(i);
    for (let a = 0; a < s; a++) {
      const h = a * i, l = (r - a - 1) * i;
      o.set(t.subarray(h, h + i)), t.copyWithin(h, l, l + i), t.set(o, l);
    }
  }
  static _unpremultiplyAlpha(t) {
    t instanceof Uint8ClampedArray && (t = new Uint8Array(t.buffer));
    const e = t.length;
    for (let r = 0; r < e; r += 4) {
      const i = t[r + 3];
      if (i !== 0) {
        const s = 255.001 / i;
        t[r] = t[r] * s + 0.5, t[r + 1] = t[r + 1] * s + 0.5, t[r + 2] = t[r + 2] * s + 0.5;
      }
    }
  }
};
X0.extension = {
  name: "extract",
  type: st.RendererSystem
};
let sT = X0;
dt.add(sT);
const th = {
  build(n) {
    const t = n.points;
    let e, r, i, s, o, a;
    if (n.type === de.CIRC) {
      const p = n.shape;
      e = p.x, r = p.y, o = a = p.radius, i = s = 0;
    } else if (n.type === de.ELIP) {
      const p = n.shape;
      e = p.x, r = p.y, o = p.width, a = p.height, i = s = 0;
    } else {
      const p = n.shape, m = p.width / 2, g = p.height / 2;
      e = p.x + m, r = p.y + g, o = a = Math.max(0, Math.min(p.radius, Math.min(m, g))), i = m - o, s = g - a;
    }
    if (!(o >= 0 && a >= 0 && i >= 0 && s >= 0)) {
      t.length = 0;
      return;
    }
    const h = Math.ceil(2.3 * Math.sqrt(o + a)), l = h * 8 + (i ? 4 : 0) + (s ? 4 : 0);
    if (t.length = l, l === 0)
      return;
    if (h === 0) {
      t.length = 8, t[0] = t[6] = e + i, t[1] = t[3] = r + s, t[2] = t[4] = e - i, t[5] = t[7] = r - s;
      return;
    }
    let u = 0, c = h * 4 + (i ? 2 : 0) + 2, d = c, f = l;
    {
      const p = i + o, m = s, g = e + p, _ = e - p, w = r + m;
      if (t[u++] = g, t[u++] = w, t[--c] = w, t[--c] = _, s) {
        const v = r - m;
        t[d++] = _, t[d++] = v, t[--f] = v, t[--f] = g;
      }
    }
    for (let p = 1; p < h; p++) {
      const m = Math.PI / 2 * (p / h), g = i + Math.cos(m) * o, _ = s + Math.sin(m) * a, w = e + g, v = e - g, E = r + _, x = r - _;
      t[u++] = w, t[u++] = E, t[--c] = E, t[--c] = v, t[d++] = v, t[d++] = x, t[--f] = x, t[--f] = w;
    }
    {
      const p = i, m = s + a, g = e + p, _ = e - p, w = r + m, v = r - m;
      t[u++] = g, t[u++] = w, t[--f] = v, t[--f] = g, i && (t[u++] = _, t[u++] = w, t[--f] = v, t[--f] = _);
    }
  },
  triangulate(n, t) {
    const e = n.points, r = t.points, i = t.indices;
    if (e.length === 0)
      return;
    let s = r.length / 2;
    const o = s;
    let a, h;
    if (n.type !== de.RREC) {
      const u = n.shape;
      a = u.x, h = u.y;
    } else {
      const u = n.shape;
      a = u.x + u.width / 2, h = u.y + u.height / 2;
    }
    const l = n.matrix;
    r.push(
      n.matrix ? l.a * a + l.c * h + l.tx : a,
      n.matrix ? l.b * a + l.d * h + l.ty : h
    ), s++, r.push(e[0], e[1]);
    for (let u = 2; u < e.length; u += 2)
      r.push(e[u], e[u + 1]), i.push(s++, o, s);
    i.push(o + 1, o, s);
  }
};
function rm(n, t = !1) {
  const e = n.length;
  if (e < 6)
    return;
  let r = 0;
  for (let i = 0, s = n[e - 2], o = n[e - 1]; i < e; i += 2) {
    const a = n[i], h = n[i + 1];
    r += (a - s) * (h + o), s = a, o = h;
  }
  if (!t && r > 0 || t && r <= 0) {
    const i = e / 2;
    for (let s = i + i % 2; s < e; s += 2) {
      const o = e - s - 2, a = e - s - 1, h = s, l = s + 1;
      [n[o], n[h]] = [n[h], n[o]], [n[a], n[l]] = [n[l], n[a]];
    }
  }
}
const V0 = {
  build(n) {
    n.points = n.shape.points.slice();
  },
  triangulate(n, t) {
    let e = n.points;
    const r = n.holes, i = t.points, s = t.indices;
    if (e.length >= 6) {
      rm(e, !1);
      const o = [];
      for (let l = 0; l < r.length; l++) {
        const u = r[l];
        rm(u.points, !0), o.push(e.length / 2), e = e.concat(u.points);
      }
      const a = U1(e, o, 2);
      if (!a)
        return;
      const h = i.length / 2;
      for (let l = 0; l < a.length; l += 3)
        s.push(a[l] + h), s.push(a[l + 1] + h), s.push(a[l + 2] + h);
      for (let l = 0; l < e.length; l++)
        i.push(e[l]);
    }
  }
}, oT = {
  build(n) {
    const t = n.shape, e = t.x, r = t.y, i = t.width, s = t.height, o = n.points;
    o.length = 0, i >= 0 && s >= 0 && o.push(
      e,
      r,
      e + i,
      r,
      e + i,
      r + s,
      e,
      r + s
    );
  },
  triangulate(n, t) {
    const e = n.points, r = t.points;
    if (e.length === 0)
      return;
    const i = r.length / 2;
    r.push(
      e[0],
      e[1],
      e[2],
      e[3],
      e[6],
      e[7],
      e[4],
      e[5]
    ), t.indices.push(
      i,
      i + 1,
      i + 2,
      i + 1,
      i + 2,
      i + 3
    );
  }
}, aT = {
  build(n) {
    th.build(n);
  },
  triangulate(n, t) {
    th.triangulate(n, t);
  }
};
var Ye = /* @__PURE__ */ ((n) => (n.MITER = "miter", n.BEVEL = "bevel", n.ROUND = "round", n))(Ye || {}), Mn = /* @__PURE__ */ ((n) => (n.BUTT = "butt", n.ROUND = "round", n.SQUARE = "square", n))(Mn || {});
const cs = {
  adaptive: !0,
  maxLength: 10,
  minSegments: 8,
  maxSegments: 2048,
  epsilon: 1e-4,
  _segmentsCount(n, t = 20) {
    if (!this.adaptive || !n || isNaN(n))
      return t;
    let e = Math.ceil(n / this.maxLength);
    return e < this.minSegments ? e = this.minSegments : e > this.maxSegments && (e = this.maxSegments), e;
  }
};
class nm {
  /**
   * Calculate information of the arc for {@link PIXI.Graphics.arcTo}.
   * @private
   * @param x1 - The x-coordinate of the first control point of the arc
   * @param y1 - The y-coordinate of the first control point of the arc
   * @param x2 - The x-coordinate of the second control point of the arc
   * @param y2 - The y-coordinate of the second control point of the arc
   * @param radius - The radius of the arc
   * @param points - Collection of points to add to
   * @returns - If the arc length is valid, return center of circle, radius and other info otherwise `null`.
   */
  static curveTo(t, e, r, i, s, o) {
    const a = o[o.length - 2], h = o[o.length - 1] - e, l = a - t, u = i - e, c = r - t, d = Math.abs(h * c - l * u);
    if (d < 1e-8 || s === 0)
      return (o[o.length - 2] !== t || o[o.length - 1] !== e) && o.push(t, e), null;
    const f = h * h + l * l, p = u * u + c * c, m = h * u + l * c, g = s * Math.sqrt(f) / d, _ = s * Math.sqrt(p) / d, w = g * m / f, v = _ * m / p, E = g * c + _ * l, x = g * u + _ * h, b = l * (_ + w), y = h * (_ + w), C = c * (g + v), M = u * (g + v), U = Math.atan2(y - x, b - E), F = Math.atan2(M - x, C - E);
    return {
      cx: E + t,
      cy: x + e,
      radius: s,
      startAngle: U,
      endAngle: F,
      anticlockwise: l * u > c * h
    };
  }
  /**
   * The arc method creates an arc/curve (used to create circles, or parts of circles).
   * @private
   * @param _startX - Start x location of arc
   * @param _startY - Start y location of arc
   * @param cx - The x-coordinate of the center of the circle
   * @param cy - The y-coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @param startAngle - The starting angle, in radians (0 is at the 3 o'clock position
   *  of the arc's circle)
   * @param endAngle - The ending angle, in radians
   * @param _anticlockwise - Specifies whether the drawing should be
   *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
   *  indicates counter-clockwise.
   * @param points - Collection of points to add to
   */
  static arc(t, e, r, i, s, o, a, h, l) {
    const u = a - o, c = cs._segmentsCount(
      Math.abs(u) * s,
      Math.ceil(Math.abs(u) / Xa) * 40
    ), d = u / (c * 2), f = d * 2, p = Math.cos(d), m = Math.sin(d), g = c - 1, _ = g % 1 / g;
    for (let w = 0; w <= g; ++w) {
      const v = w + _ * w, E = d + o + f * v, x = Math.cos(E), b = -Math.sin(E);
      l.push(
        (p * x + m * b) * s + r,
        (p * -b + m * x) * s + i
      );
    }
  }
}
class hT {
  constructor() {
    this.reset();
  }
  /**
   * Begin batch part.
   * @param style
   * @param startIndex
   * @param attribStart
   */
  begin(t, e, r) {
    this.reset(), this.style = t, this.start = e, this.attribStart = r;
  }
  /**
   * End batch part.
   * @param endIndex
   * @param endAttrib
   */
  end(t, e) {
    this.attribSize = e - this.attribStart, this.size = t - this.start;
  }
  reset() {
    this.style = null, this.size = 0, this.start = 0, this.attribStart = 0, this.attribSize = 0;
  }
}
class cd {
  /**
   * Calculate length of bezier curve.
   * Analytical solution is impossible, since it involves an integral that does not integrate in general.
   * Therefore numerical solution is used.
   * @private
   * @param fromX - Starting point x
   * @param fromY - Starting point y
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns - Length of bezier curve
   */
  static curveLength(t, e, r, i, s, o, a, h) {
    let l = 0, u = 0, c = 0, d = 0, f = 0, p = 0, m = 0, g = 0, _ = 0, w = 0, v = 0, E = t, x = e;
    for (let b = 1; b <= 10; ++b)
      u = b / 10, c = u * u, d = c * u, f = 1 - u, p = f * f, m = p * f, g = m * t + 3 * p * u * r + 3 * f * c * s + d * a, _ = m * e + 3 * p * u * i + 3 * f * c * o + d * h, w = E - g, v = x - _, E = g, x = _, l += Math.sqrt(w * w + v * v);
    return l;
  }
  /**
   * Calculate the points for a bezier curve and then draws it.
   *
   * Ignored from docs since it is not directly exposed.
   * @ignore
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @param points - Path array to push points into
   */
  static curveTo(t, e, r, i, s, o, a) {
    const h = a[a.length - 2], l = a[a.length - 1];
    a.length -= 2;
    const u = cs._segmentsCount(
      cd.curveLength(h, l, t, e, r, i, s, o)
    );
    let c = 0, d = 0, f = 0, p = 0, m = 0;
    a.push(h, l);
    for (let g = 1, _ = 0; g <= u; ++g)
      _ = g / u, c = 1 - _, d = c * c, f = d * c, p = _ * _, m = p * _, a.push(
        f * h + 3 * d * _ * t + 3 * c * p * r + m * s,
        f * l + 3 * d * _ * e + 3 * c * p * i + m * o
      );
  }
}
function im(n, t, e, r, i, s, o, a) {
  const h = n - e * i, l = t - r * i, u = n + e * s, c = t + r * s;
  let d, f;
  o ? (d = r, f = -e) : (d = -r, f = e);
  const p = h + d, m = l + f, g = u + d, _ = c + f;
  return a.push(
    p,
    m,
    g,
    _
  ), 2;
}
function ti(n, t, e, r, i, s, o, a) {
  const h = e - n, l = r - t;
  let u = Math.atan2(h, l), c = Math.atan2(i - n, s - t);
  a && u < c ? u += Math.PI * 2 : !a && u > c && (c += Math.PI * 2);
  let d = u;
  const f = c - u, p = Math.abs(f), m = Math.sqrt(h * h + l * l), g = (15 * p * Math.sqrt(m) / Math.PI >> 0) + 1, _ = f / g;
  if (d += _, a) {
    o.push(
      n,
      t,
      e,
      r
    );
    for (let w = 1, v = d; w < g; w++, v += _)
      o.push(
        n,
        t,
        n + Math.sin(v) * m,
        t + Math.cos(v) * m
      );
    o.push(
      n,
      t,
      i,
      s
    );
  } else {
    o.push(
      e,
      r,
      n,
      t
    );
    for (let w = 1, v = d; w < g; w++, v += _)
      o.push(
        n + Math.sin(v) * m,
        t + Math.cos(v) * m,
        n,
        t
      );
    o.push(
      i,
      s,
      n,
      t
    );
  }
  return g * 2;
}
function lT(n, t) {
  const e = n.shape;
  let r = n.points || e.points.slice();
  const i = t.closePointEps;
  if (r.length === 0)
    return;
  const s = n.lineStyle, o = new mt(r[0], r[1]), a = new mt(r[r.length - 2], r[r.length - 1]), h = e.type !== de.POLY || e.closeStroke, l = Math.abs(o.x - a.x) < i && Math.abs(o.y - a.y) < i;
  if (h) {
    r = r.slice(), l && (r.pop(), r.pop(), a.set(r[r.length - 2], r[r.length - 1]));
    const S = (o.x + a.x) * 0.5, A = (a.y + o.y) * 0.5;
    r.unshift(S, A), r.push(S, A);
  }
  const u = t.points, c = r.length / 2;
  let d = r.length;
  const f = u.length / 2, p = s.width / 2, m = p * p, g = s.miterLimit * s.miterLimit;
  let _ = r[0], w = r[1], v = r[2], E = r[3], x = 0, b = 0, y = -(w - E), C = _ - v, M = 0, U = 0, F = Math.sqrt(y * y + C * C);
  y /= F, C /= F, y *= p, C *= p;
  const O = s.alignment, R = (1 - O) * 2, k = O * 2;
  h || (s.cap === Mn.ROUND ? d += ti(
    _ - y * (R - k) * 0.5,
    w - C * (R - k) * 0.5,
    _ - y * R,
    w - C * R,
    _ + y * k,
    w + C * k,
    u,
    !0
  ) + 2 : s.cap === Mn.SQUARE && (d += im(_, w, y, C, R, k, !0, u))), u.push(
    _ - y * R,
    w - C * R,
    _ + y * k,
    w + C * k
  );
  for (let S = 1; S < c - 1; ++S) {
    _ = r[(S - 1) * 2], w = r[(S - 1) * 2 + 1], v = r[S * 2], E = r[S * 2 + 1], x = r[(S + 1) * 2], b = r[(S + 1) * 2 + 1], y = -(w - E), C = _ - v, F = Math.sqrt(y * y + C * C), y /= F, C /= F, y *= p, C *= p, M = -(E - b), U = v - x, F = Math.sqrt(M * M + U * U), M /= F, U /= F, M *= p, U *= p;
    const A = v - _, L = w - E, D = v - x, P = b - E, N = A * D + L * P, B = L * D - P * A, X = B < 0;
    if (Math.abs(B) < 1e-3 * Math.abs(N)) {
      u.push(
        v - y * R,
        E - C * R,
        v + y * k,
        E + C * k
      ), N >= 0 && (s.join === Ye.ROUND ? d += ti(
        v,
        E,
        v - y * R,
        E - C * R,
        v - M * R,
        E - U * R,
        u,
        !1
      ) + 4 : d += 2, u.push(
        v - M * k,
        E - U * k,
        v + M * R,
        E + U * R
      ));
      continue;
    }
    const V = (-y + _) * (-C + E) - (-y + v) * (-C + w), J = (-M + x) * (-U + E) - (-M + v) * (-U + b), tt = (A * J - D * V) / B, K = (P * V - L * J) / B, G = (tt - v) * (tt - v) + (K - E) * (K - E), W = v + (tt - v) * R, q = E + (K - E) * R, z = v - (tt - v) * k, ot = E - (K - E) * k, rt = Math.min(A * A + L * L, D * D + P * P), et = X ? R : k, nt = rt + et * et * m, Et = G <= nt;
    let Dt = s.join;
    if (Dt === Ye.MITER && G / m > g && (Dt = Ye.BEVEL), Et)
      switch (Dt) {
        case Ye.MITER: {
          u.push(
            W,
            q,
            z,
            ot
          );
          break;
        }
        case Ye.BEVEL: {
          X ? u.push(
            W,
            q,
            // inner miter point
            v + y * k,
            E + C * k,
            // first segment's outer vertex
            W,
            q,
            // inner miter point
            v + M * k,
            E + U * k
          ) : u.push(
            v - y * R,
            E - C * R,
            // first segment's inner vertex
            z,
            ot,
            // outer miter point
            v - M * R,
            E - U * R,
            // second segment's outer vertex
            z,
            ot
          ), d += 2;
          break;
        }
        case Ye.ROUND: {
          X ? (u.push(
            W,
            q,
            v + y * k,
            E + C * k
          ), d += ti(
            v,
            E,
            v + y * k,
            E + C * k,
            v + M * k,
            E + U * k,
            u,
            !0
          ) + 4, u.push(
            W,
            q,
            v + M * k,
            E + U * k
          )) : (u.push(
            v - y * R,
            E - C * R,
            z,
            ot
          ), d += ti(
            v,
            E,
            v - y * R,
            E - C * R,
            v - M * R,
            E - U * R,
            u,
            !1
          ) + 4, u.push(
            v - M * R,
            E - U * R,
            z,
            ot
          ));
          break;
        }
      }
    else {
      switch (u.push(
        v - y * R,
        E - C * R,
        // first segment's inner vertex
        v + y * k,
        E + C * k
      ), Dt) {
        case Ye.MITER: {
          X ? u.push(
            z,
            ot,
            // inner miter point
            z,
            ot
          ) : u.push(
            W,
            q,
            // outer miter point
            W,
            q
          ), d += 2;
          break;
        }
        case Ye.ROUND: {
          X ? d += ti(
            v,
            E,
            v + y * k,
            E + C * k,
            v + M * k,
            E + U * k,
            u,
            !0
          ) + 2 : d += ti(
            v,
            E,
            v - y * R,
            E - C * R,
            v - M * R,
            E - U * R,
            u,
            !1
          ) + 2;
          break;
        }
      }
      u.push(
        v - M * R,
        E - U * R,
        // second segment's inner vertex
        v + M * k,
        E + U * k
      ), d += 2;
    }
  }
  _ = r[(c - 2) * 2], w = r[(c - 2) * 2 + 1], v = r[(c - 1) * 2], E = r[(c - 1) * 2 + 1], y = -(w - E), C = _ - v, F = Math.sqrt(y * y + C * C), y /= F, C /= F, y *= p, C *= p, u.push(
    v - y * R,
    E - C * R,
    v + y * k,
    E + C * k
  ), h || (s.cap === Mn.ROUND ? d += ti(
    v - y * (R - k) * 0.5,
    E - C * (R - k) * 0.5,
    v - y * R,
    E - C * R,
    v + y * k,
    E + C * k,
    u,
    !1
  ) + 2 : s.cap === Mn.SQUARE && (d += im(v, E, y, C, R, k, !1, u)));
  const j = t.indices, T = cs.epsilon * cs.epsilon;
  for (let S = f; S < d + f - 2; ++S)
    _ = u[S * 2], w = u[S * 2 + 1], v = u[(S + 1) * 2], E = u[(S + 1) * 2 + 1], x = u[(S + 2) * 2], b = u[(S + 2) * 2 + 1], !(Math.abs(_ * (E - b) + v * (b - w) + x * (w - E)) < T) && j.push(S, S + 1, S + 2);
}
function uT(n, t) {
  let e = 0;
  const r = n.shape, i = n.points || r.points, s = r.type !== de.POLY || r.closeStroke;
  if (i.length === 0)
    return;
  const o = t.points, a = t.indices, h = i.length / 2, l = o.length / 2;
  let u = l;
  for (o.push(i[0], i[1]), e = 1; e < h; e++)
    o.push(i[e * 2], i[e * 2 + 1]), a.push(u, u + 1), u++;
  s && a.push(u, l);
}
function sm(n, t) {
  n.lineStyle.native ? uT(n, t) : lT(n, t);
}
class dd {
  /**
   * Calculate length of quadratic curve
   * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
   * for the detailed explanation of math behind this.
   * @private
   * @param fromX - x-coordinate of curve start point
   * @param fromY - y-coordinate of curve start point
   * @param cpX - x-coordinate of curve control point
   * @param cpY - y-coordinate of curve control point
   * @param toX - x-coordinate of curve end point
   * @param toY - y-coordinate of curve end point
   * @returns - Length of quadratic curve
   */
  static curveLength(t, e, r, i, s, o) {
    const a = t - 2 * r + s, h = e - 2 * i + o, l = 2 * r - 2 * t, u = 2 * i - 2 * e, c = 4 * (a * a + h * h), d = 4 * (a * l + h * u), f = l * l + u * u, p = 2 * Math.sqrt(c + d + f), m = Math.sqrt(c), g = 2 * c * m, _ = 2 * Math.sqrt(f), w = d / m;
    return (g * p + m * d * (p - _) + (4 * f * c - d * d) * Math.log((2 * m + w + p) / (w + _))) / (4 * g);
  }
  /**
   * Calculate the points for a quadratic bezier curve and then draws it.
   * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
   * @private
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @param points - Points to add segments to.
   */
  static curveTo(t, e, r, i, s) {
    const o = s[s.length - 2], a = s[s.length - 1], h = cs._segmentsCount(
      dd.curveLength(o, a, t, e, r, i)
    );
    let l = 0, u = 0;
    for (let c = 1; c <= h; ++c) {
      const d = c / h;
      l = o + (t - o) * d, u = a + (e - a) * d, s.push(
        l + (t + (r - t) * d - l) * d,
        u + (e + (i - e) * d - u) * d
      );
    }
  }
}
const du = {
  [de.POLY]: V0,
  [de.CIRC]: th,
  [de.ELIP]: th,
  [de.RECT]: oT,
  [de.RREC]: aT
}, om = [], fa = [];
class eh {
  /**
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param fillStyle - the width of the line to draw
   * @param lineStyle - the color of the line to draw
   * @param matrix - Transform matrix
   */
  constructor(t, e = null, r = null, i = null) {
    this.points = [], this.holes = [], this.shape = t, this.lineStyle = r, this.fillStyle = e, this.matrix = i, this.type = t.type;
  }
  /**
   * Creates a new GraphicsData object with the same values as this one.
   * @returns - Cloned GraphicsData object
   */
  clone() {
    return new eh(
      this.shape,
      this.fillStyle,
      this.lineStyle,
      this.matrix
    );
  }
  /** Destroys the Graphics data. */
  destroy() {
    this.shape = null, this.holes.length = 0, this.holes = null, this.points.length = 0, this.points = null, this.lineStyle = null, this.fillStyle = null;
  }
}
const Hi = new mt(), Y0 = class j0 extends Jg {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor() {
    super(), this.closePointEps = 1e-4, this.boundsPadding = 0, this.uvsFloat32 = null, this.indicesUint16 = null, this.batchable = !1, this.points = [], this.colors = [], this.uvs = [], this.indices = [], this.textureIds = [], this.graphicsData = [], this.drawCalls = [], this.batchDirty = -1, this.batches = [], this.dirty = 0, this.cacheDirty = -1, this.clearDirty = 0, this.shapeIndex = 0, this._bounds = new Za(), this.boundsDirty = -1;
  }
  /**
   * Get the current bounds of the graphic geometry.
   *
   * Since 6.5.0, bounds of the graphics geometry are calculated based on the vertices of generated geometry.
   * Since shapes or strokes with full transparency (`alpha: 0`) will not generate geometry, they are not considered
   * when calculating bounds for the graphics geometry. See PR [#8343]{@link https://github.com/pixijs/pixijs/pull/8343}
   * and issue [#8623]{@link https://github.com/pixijs/pixijs/pull/8623}.
   * @readonly
   */
  get bounds() {
    return this.updateBatches(), this.boundsDirty !== this.dirty && (this.boundsDirty = this.dirty, this.calculateBounds()), this._bounds;
  }
  /** Call if you changed graphicsData manually. Empties all batch buffers. */
  invalidate() {
    this.boundsDirty = -1, this.dirty++, this.batchDirty++, this.shapeIndex = 0, this.points.length = 0, this.colors.length = 0, this.uvs.length = 0, this.indices.length = 0, this.textureIds.length = 0;
    for (let t = 0; t < this.drawCalls.length; t++)
      this.drawCalls[t].texArray.clear(), fa.push(this.drawCalls[t]);
    this.drawCalls.length = 0;
    for (let t = 0; t < this.batches.length; t++) {
      const e = this.batches[t];
      e.reset(), om.push(e);
    }
    this.batches.length = 0;
  }
  /**
   * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
   * @returns - This GraphicsGeometry object. Good for chaining method calls
   */
  clear() {
    return this.graphicsData.length > 0 && (this.invalidate(), this.clearDirty++, this.graphicsData.length = 0), this;
  }
  /**
   * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param fillStyle - Defines style of the fill.
   * @param lineStyle - Defines style of the lines.
   * @param matrix - Transform applied to the points of the shape.
   * @returns - Returns geometry for chaining.
   */
  drawShape(t, e = null, r = null, i = null) {
    const s = new eh(t, e, r, i);
    return this.graphicsData.push(s), this.dirty++, this;
  }
  /**
   * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param matrix - Transform applied to the points of the shape.
   * @returns - Returns geometry for chaining.
   */
  drawHole(t, e = null) {
    if (!this.graphicsData.length)
      return null;
    const r = new eh(t, null, null, e), i = this.graphicsData[this.graphicsData.length - 1];
    return r.lineStyle = i.lineStyle, i.holes.push(r), this.dirty++, this;
  }
  /** Destroys the GraphicsGeometry object. */
  destroy() {
    super.destroy();
    for (let t = 0; t < this.graphicsData.length; ++t)
      this.graphicsData[t].destroy();
    this.points.length = 0, this.points = null, this.colors.length = 0, this.colors = null, this.uvs.length = 0, this.uvs = null, this.indices.length = 0, this.indices = null, this.indexBuffer.destroy(), this.indexBuffer = null, this.graphicsData.length = 0, this.graphicsData = null, this.drawCalls.length = 0, this.drawCalls = null, this.batches.length = 0, this.batches = null, this._bounds = null;
  }
  /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */
  containsPoint(t) {
    const e = this.graphicsData;
    for (let r = 0; r < e.length; ++r) {
      const i = e[r];
      if (i.fillStyle.visible && i.shape && (i.matrix ? i.matrix.applyInverse(t, Hi) : Hi.copyFrom(t), i.shape.contains(Hi.x, Hi.y))) {
        let s = !1;
        if (i.holes) {
          for (let o = 0; o < i.holes.length; o++)
            if (i.holes[o].shape.contains(Hi.x, Hi.y)) {
              s = !0;
              break;
            }
        }
        if (!s)
          return !0;
      }
    }
    return !1;
  }
  /**
   * Generates intermediate batch data. Either gets converted to drawCalls
   * or used to convert to batch objects directly by the Graphics object.
   */
  updateBatches() {
    if (!this.graphicsData.length) {
      this.batchable = !0;
      return;
    }
    if (!this.validateBatching())
      return;
    this.cacheDirty = this.dirty;
    const t = this.uvs, e = this.graphicsData;
    let r = null, i = null;
    this.batches.length > 0 && (r = this.batches[this.batches.length - 1], i = r.style);
    for (let h = this.shapeIndex; h < e.length; h++) {
      this.shapeIndex++;
      const l = e[h], u = l.fillStyle, c = l.lineStyle;
      du[l.type].build(l), l.matrix && this.transformPoints(l.points, l.matrix), (u.visible || c.visible) && this.processHoles(l.holes);
      for (let d = 0; d < 2; d++) {
        const f = d === 0 ? u : c;
        if (!f.visible)
          continue;
        const p = f.texture.baseTexture, m = this.indices.length, g = this.points.length / 2;
        p.wrapMode = Dr.REPEAT, d === 0 ? this.processFill(l) : this.processLine(l);
        const _ = this.points.length / 2 - g;
        _ !== 0 && (r && !this._compareStyles(i, f) && (r.end(m, g), r = null), r || (r = om.pop() || new hT(), r.begin(f, m, g), this.batches.push(r), i = f), this.addUvs(this.points, t, f.texture, g, _, f.matrix));
      }
    }
    const s = this.indices.length, o = this.points.length / 2;
    if (r && r.end(s, o), this.batches.length === 0) {
      this.batchable = !0;
      return;
    }
    const a = o > 65535;
    this.indicesUint16 && this.indices.length === this.indicesUint16.length && a === this.indicesUint16.BYTES_PER_ELEMENT > 2 ? this.indicesUint16.set(this.indices) : this.indicesUint16 = a ? new Uint32Array(this.indices) : new Uint16Array(this.indices), this.batchable = this.isBatchable(), this.batchable ? this.packBatches() : this.buildDrawCalls();
  }
  /**
   * Affinity check
   * @param styleA
   * @param styleB
   */
  _compareStyles(t, e) {
    return !(!t || !e || t.texture.baseTexture !== e.texture.baseTexture || t.color + t.alpha !== e.color + e.alpha || !!t.native != !!e.native);
  }
  /** Test geometry for batching process. */
  validateBatching() {
    if (this.dirty === this.cacheDirty || !this.graphicsData.length)
      return !1;
    for (let t = 0, e = this.graphicsData.length; t < e; t++) {
      const r = this.graphicsData[t], i = r.fillStyle, s = r.lineStyle;
      if (i && !i.texture.baseTexture.valid || s && !s.texture.baseTexture.valid)
        return !1;
    }
    return !0;
  }
  /** Offset the indices so that it works with the batcher. */
  packBatches() {
    this.batchDirty++, this.uvsFloat32 = new Float32Array(this.uvs);
    const t = this.batches;
    for (let e = 0, r = t.length; e < r; e++) {
      const i = t[e];
      for (let s = 0; s < i.size; s++) {
        const o = i.start + s;
        this.indicesUint16[o] = this.indicesUint16[o] - i.attribStart;
      }
    }
  }
  /**
   * Checks to see if this graphics geometry can be batched.
   * Currently it needs to be small enough and not contain any native lines.
   */
  isBatchable() {
    if (this.points.length > 65535 * 2)
      return !1;
    const t = this.batches;
    for (let e = 0; e < t.length; e++)
      if (t[e].style.native)
        return !1;
    return this.points.length < j0.BATCHABLE_SIZE * 2;
  }
  /** Converts intermediate batches data to drawCalls. */
  buildDrawCalls() {
    let t = ++_t._globalBatch;
    for (let c = 0; c < this.drawCalls.length; c++)
      this.drawCalls[c].texArray.clear(), fa.push(this.drawCalls[c]);
    this.drawCalls.length = 0;
    const e = this.colors, r = this.textureIds;
    let i = fa.pop();
    i || (i = new ju(), i.texArray = new Ju()), i.texArray.count = 0, i.start = 0, i.size = 0, i.type = Pr.TRIANGLES;
    let s = 0, o = null, a = 0, h = !1, l = Pr.TRIANGLES, u = 0;
    this.drawCalls.push(i);
    for (let c = 0; c < this.batches.length; c++) {
      const d = this.batches[c], f = 8, p = d.style, m = p.texture.baseTexture;
      h !== !!p.native && (h = !!p.native, l = h ? Pr.LINES : Pr.TRIANGLES, o = null, s = f, t++), o !== m && (o = m, m._batchEnabled !== t && (s === f && (t++, s = 0, i.size > 0 && (i = fa.pop(), i || (i = new ju(), i.texArray = new Ju()), this.drawCalls.push(i)), i.start = u, i.size = 0, i.texArray.count = 0, i.type = l), m.touched = 1, m._batchEnabled = t, m._batchLocation = s, m.wrapMode = Dr.REPEAT, i.texArray.elements[i.texArray.count++] = m, s++)), i.size += d.size, u += d.size, a = m._batchLocation, this.addColors(e, p.color, p.alpha, d.attribSize, d.attribStart), this.addTextureIds(r, a, d.attribSize, d.attribStart);
    }
    _t._globalBatch = t, this.packAttributes();
  }
  /** Packs attributes to single buffer. */
  packAttributes() {
    const t = this.points, e = this.uvs, r = this.colors, i = this.textureIds, s = new ArrayBuffer(t.length * 3 * 4), o = new Float32Array(s), a = new Uint32Array(s);
    let h = 0;
    for (let l = 0; l < t.length / 2; l++)
      o[h++] = t[l * 2], o[h++] = t[l * 2 + 1], o[h++] = e[l * 2], o[h++] = e[l * 2 + 1], a[h++] = r[l], o[h++] = i[l];
    this._buffer.update(s), this._indexBuffer.update(this.indicesUint16);
  }
  /**
   * Process fill part of Graphics.
   * @param data
   */
  processFill(t) {
    t.holes.length ? V0.triangulate(t, this) : du[t.type].triangulate(t, this);
  }
  /**
   * Process line part of Graphics.
   * @param data
   */
  processLine(t) {
    sm(t, this);
    for (let e = 0; e < t.holes.length; e++)
      sm(t.holes[e], this);
  }
  /**
   * Process the holes data.
   * @param holes
   */
  processHoles(t) {
    for (let e = 0; e < t.length; e++) {
      const r = t[e];
      du[r.type].build(r), r.matrix && this.transformPoints(r.points, r.matrix);
    }
  }
  /** Update the local bounds of the object. Expensive to use performance-wise. */
  calculateBounds() {
    const t = this._bounds;
    t.clear(), t.addVertexData(this.points, 0, this.points.length), t.pad(this.boundsPadding, this.boundsPadding);
  }
  /**
   * Transform points using matrix.
   * @param points - Points to transform
   * @param matrix - Transform matrix
   */
  transformPoints(t, e) {
    for (let r = 0; r < t.length / 2; r++) {
      const i = t[r * 2], s = t[r * 2 + 1];
      t[r * 2] = e.a * i + e.c * s + e.tx, t[r * 2 + 1] = e.b * i + e.d * s + e.ty;
    }
  }
  /**
   * Add colors.
   * @param colors - List of colors to add to
   * @param color - Color to add
   * @param alpha - Alpha to use
   * @param size - Number of colors to add
   * @param offset
   */
  addColors(t, e, r, i, s = 0) {
    const o = Ot.shared.setValue(e).toLittleEndianNumber(), a = Ot.shared.setValue(o).toPremultiplied(r);
    t.length = Math.max(t.length, s + i);
    for (let h = 0; h < i; h++)
      t[s + h] = a;
  }
  /**
   * Add texture id that the shader/fragment wants to use.
   * @param textureIds
   * @param id
   * @param size
   * @param offset
   */
  addTextureIds(t, e, r, i = 0) {
    t.length = Math.max(t.length, i + r);
    for (let s = 0; s < r; s++)
      t[i + s] = e;
  }
  /**
   * Generates the UVs for a shape.
   * @param verts - Vertices
   * @param uvs - UVs
   * @param texture - Reference to Texture
   * @param start - Index buffer start index.
   * @param size - The size/length for index buffer.
   * @param matrix - Optional transform for all points.
   */
  addUvs(t, e, r, i, s, o = null) {
    let a = 0;
    const h = e.length, l = r.frame;
    for (; a < s; ) {
      let c = t[(i + a) * 2], d = t[(i + a) * 2 + 1];
      if (o) {
        const f = o.a * c + o.c * d + o.tx;
        d = o.b * c + o.d * d + o.ty, c = f;
      }
      a++, e.push(c / l.width, d / l.height);
    }
    const u = r.baseTexture;
    (l.width < u.width || l.height < u.height) && this.adjustUvs(e, r, h, s);
  }
  /**
   * Modify uvs array according to position of texture region
   * Does not work with rotated or trimmed textures
   * @param uvs - array
   * @param texture - region
   * @param start - starting index for uvs
   * @param size - how many points to adjust
   */
  adjustUvs(t, e, r, i) {
    const s = e.baseTexture, o = 1e-6, a = r + i * 2, h = e.frame, l = h.width / s.width, u = h.height / s.height;
    let c = h.x / h.width, d = h.y / h.height, f = Math.floor(t[r] + o), p = Math.floor(t[r + 1] + o);
    for (let m = r + 2; m < a; m += 2)
      f = Math.min(f, Math.floor(t[m] + o)), p = Math.min(p, Math.floor(t[m + 1] + o));
    c -= f, d -= p;
    for (let m = r; m < a; m += 2)
      t[m] = (t[m] + c) * l, t[m + 1] = (t[m + 1] + d) * u;
  }
};
Y0.BATCHABLE_SIZE = 100;
let cT = Y0;
class Fh {
  constructor() {
    this.color = 16777215, this.alpha = 1, this.texture = ct.WHITE, this.matrix = null, this.visible = !1, this.reset();
  }
  /** Clones the object */
  clone() {
    const t = new Fh();
    return t.color = this.color, t.alpha = this.alpha, t.texture = this.texture, t.matrix = this.matrix, t.visible = this.visible, t;
  }
  /** Reset */
  reset() {
    this.color = 16777215, this.alpha = 1, this.texture = ct.WHITE, this.matrix = null, this.visible = !1;
  }
  /** Destroy and don't use after this. */
  destroy() {
    this.texture = null, this.matrix = null;
  }
}
class fd extends Fh {
  constructor() {
    super(...arguments), this.width = 0, this.alignment = 0.5, this.native = !1, this.cap = Mn.BUTT, this.join = Ye.MITER, this.miterLimit = 10;
  }
  /** Clones the object. */
  clone() {
    const t = new fd();
    return t.color = this.color, t.alpha = this.alpha, t.texture = this.texture, t.matrix = this.matrix, t.visible = this.visible, t.width = this.width, t.alignment = this.alignment, t.native = this.native, t.cap = this.cap, t.join = this.join, t.miterLimit = this.miterLimit, t;
  }
  /** Reset the line style to default. */
  reset() {
    super.reset(), this.color = 0, this.alignment = 0.5, this.width = 0, this.native = !1, this.cap = Mn.BUTT, this.join = Ye.MITER, this.miterLimit = 10;
  }
}
const fu = {}, yc = class Ma extends bt {
  /**
   * @param geometry - Geometry to use, if omitted will create a new GraphicsGeometry instance.
   */
  constructor(t = null) {
    super(), this.shader = null, this.pluginName = "batch", this.currentPath = null, this.batches = [], this.batchTint = -1, this.batchDirty = -1, this.vertexData = null, this._fillStyle = new Fh(), this._lineStyle = new fd(), this._matrix = null, this._holeMode = !1, this.state = Hr.for2d(), this._geometry = t || new cT(), this._geometry.refCount++, this._transformID = -1, this._tintColor = new Ot(16777215), this.blendMode = gt.NORMAL;
  }
  /**
   * Includes vertex positions, face indices, normals, colors, UVs, and
   * custom attributes within buffers, reducing the cost of passing all
   * this data to the GPU. Can be shared between multiple Mesh or Graphics objects.
   * @readonly
   */
  get geometry() {
    return this._geometry;
  }
  /**
   * Creates a new Graphics object with the same values as this one.
   * Note that only the geometry of the object is cloned, not its transform (position,scale,etc)
   * @returns - A clone of the graphics object
   */
  clone() {
    return this.finishPoly(), new Ma(this._geometry);
  }
  /**
   * The blend mode to be applied to the graphic shape. Apply a value of
   * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.  Note that, since each
   * primitive in the GraphicsGeometry list is rendered sequentially, modes
   * such as `PIXI.BLEND_MODES.ADD` and `PIXI.BLEND_MODES.MULTIPLY` will
   * be applied per-primitive.
   * @default PIXI.BLEND_MODES.NORMAL
   */
  set blendMode(t) {
    this.state.blendMode = t;
  }
  get blendMode() {
    return this.state.blendMode;
  }
  /**
   * The tint applied to each graphic shape. This is a hex value. A value of
   * 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */
  get tint() {
    return this._tintColor.value;
  }
  set tint(t) {
    this._tintColor.setValue(t);
  }
  /**
   * The current fill style.
   * @readonly
   */
  get fill() {
    return this._fillStyle;
  }
  /**
   * The current line style.
   * @readonly
   */
  get line() {
    return this._lineStyle;
  }
  lineStyle(t = null, e = 0, r, i = 0.5, s = !1) {
    return typeof t == "number" && (t = { width: t, color: e, alpha: r, alignment: i, native: s }), this.lineTextureStyle(t);
  }
  /**
   * Like line style but support texture for line fill.
   * @param [options] - Collection of options for setting line style.
   * @param {number} [options.width=0] - width of the line to draw, will update the objects stored style
   * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to use
   * @param {PIXI.ColorSource} [options.color=0x0] - color of the line to draw, will update the objects stored style.
   *  Default 0xFFFFFF if texture present.
   * @param {number} [options.alpha=1] - alpha of the line to draw, will update the objects stored style
   * @param {PIXI.Matrix} [options.matrix=null] - Texture matrix to transform texture
   * @param {number} [options.alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outer).
   *        WebGL only.
   * @param {boolean} [options.native=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
   * @param {PIXI.LINE_CAP}[options.cap=PIXI.LINE_CAP.BUTT] - line cap style
   * @param {PIXI.LINE_JOIN}[options.join=PIXI.LINE_JOIN.MITER] - line join style
   * @param {number}[options.miterLimit=10] - miter limit ratio
   * @returns {PIXI.Graphics} This Graphics object. Good for chaining method calls
   */
  lineTextureStyle(t) {
    const e = {
      width: 0,
      texture: ct.WHITE,
      color: t?.texture ? 16777215 : 0,
      matrix: null,
      alignment: 0.5,
      native: !1,
      cap: Mn.BUTT,
      join: Ye.MITER,
      miterLimit: 10
    };
    t = Object.assign(e, t), this.normalizeColor(t), this.currentPath && this.startPoly();
    const r = t.width > 0 && t.alpha > 0;
    return r ? (t.matrix && (t.matrix = t.matrix.clone(), t.matrix.invert()), Object.assign(this._lineStyle, { visible: r }, t)) : this._lineStyle.reset(), this;
  }
  /**
   * Start a polygon object internally.
   * @protected
   */
  startPoly() {
    if (this.currentPath) {
      const t = this.currentPath.points, e = this.currentPath.points.length;
      e > 2 && (this.drawShape(this.currentPath), this.currentPath = new mi(), this.currentPath.closeStroke = !1, this.currentPath.points.push(t[e - 2], t[e - 1]));
    } else
      this.currentPath = new mi(), this.currentPath.closeStroke = !1;
  }
  /**
   * Finish the polygon object.
   * @protected
   */
  finishPoly() {
    this.currentPath && (this.currentPath.points.length > 2 ? (this.drawShape(this.currentPath), this.currentPath = null) : this.currentPath.points.length = 0);
  }
  /**
   * Moves the current drawing position to x, y.
   * @param x - the X coordinate to move to
   * @param y - the Y coordinate to move to
   * @returns - This Graphics object. Good for chaining method calls
   */
  moveTo(t, e) {
    return this.startPoly(), this.currentPath.points[0] = t, this.currentPath.points[1] = e, this;
  }
  /**
   * Draws a line using the current line style from the current drawing position to (x, y);
   * The current drawing position is then set to (x, y).
   * @param x - the X coordinate to draw to
   * @param y - the Y coordinate to draw to
   * @returns - This Graphics object. Good for chaining method calls
   */
  lineTo(t, e) {
    this.currentPath || this.moveTo(0, 0);
    const r = this.currentPath.points, i = r[r.length - 2], s = r[r.length - 1];
    return (i !== t || s !== e) && r.push(t, e), this;
  }
  /**
   * Initialize the curve
   * @param x
   * @param y
   */
  _initCurve(t = 0, e = 0) {
    this.currentPath ? this.currentPath.points.length === 0 && (this.currentPath.points = [t, e]) : this.moveTo(t, e);
  }
  /**
   * Calculate the points for a quadratic bezier curve and then draws it.
   * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns - This Graphics object. Good for chaining method calls
   */
  quadraticCurveTo(t, e, r, i) {
    this._initCurve();
    const s = this.currentPath.points;
    return s.length === 0 && this.moveTo(0, 0), dd.curveTo(t, e, r, i, s), this;
  }
  /**
   * Calculate the points for a bezier curve and then draws it.
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns This Graphics object. Good for chaining method calls
   */
  bezierCurveTo(t, e, r, i, s, o) {
    return this._initCurve(), cd.curveTo(t, e, r, i, s, o, this.currentPath.points), this;
  }
  /**
   * The `arcTo` method creates an arc/curve between two tangents on the canvas.
   * The first tangent is from the start point to the first control point,
   * and the second tangent is from the first control point to the second control point.
   * Note that the second control point is not necessarily the end point of the arc.
   *
   * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
   * @param x1 - The x-coordinate of the first control point of the arc
   * @param y1 - The y-coordinate of the first control point of the arc
   * @param x2 - The x-coordinate of the second control point of the arc
   * @param y2 - The y-coordinate of the second control point of the arc
   * @param radius - The radius of the arc
   * @returns - This Graphics object. Good for chaining method calls
   */
  arcTo(t, e, r, i, s) {
    this._initCurve(t, e);
    const o = this.currentPath.points, a = nm.curveTo(t, e, r, i, s, o);
    if (a) {
      const { cx: h, cy: l, radius: u, startAngle: c, endAngle: d, anticlockwise: f } = a;
      this.arc(h, l, u, c, d, f);
    }
    return this;
  }
  /**
   * The arc method creates an arc/curve (used to create circles, or parts of circles).
   * @param cx - The x-coordinate of the center of the circle
   * @param cy - The y-coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @param startAngle - The starting angle, in radians (0 is at the 3 o'clock position
   *  of the arc's circle)
   * @param endAngle - The ending angle, in radians
   * @param anticlockwise - Specifies whether the drawing should be
   *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
   *  indicates counter-clockwise.
   * @returns - This Graphics object. Good for chaining method calls
   */
  arc(t, e, r, i, s, o = !1) {
    if (i === s)
      return this;
    if (!o && s <= i ? s += Xa : o && i <= s && (i += Xa), s - i === 0)
      return this;
    const a = t + Math.cos(i) * r, h = e + Math.sin(i) * r, l = this._geometry.closePointEps;
    let u = this.currentPath ? this.currentPath.points : null;
    if (u) {
      const c = Math.abs(u[u.length - 2] - a), d = Math.abs(u[u.length - 1] - h);
      c < l && d < l || u.push(a, h);
    } else
      this.moveTo(a, h), u = this.currentPath.points;
    return nm.arc(a, h, t, e, r, i, s, o, u), this;
  }
  /**
   * Specifies a simple one-color fill that subsequent calls to other Graphics methods
   * (such as lineTo() or drawCircle()) use when drawing.
   * @param {PIXI.ColorSource} color - the color of the fill
   * @param alpha - the alpha of the fill, will override the color's alpha
   * @returns - This Graphics object. Suitable for chaining method calls
   */
  beginFill(t = 0, e) {
    return this.beginTextureFill({ texture: ct.WHITE, color: t, alpha: e });
  }
  /**
   * Normalize the color input from options for line style or fill
   * @param {PIXI.IFillStyleOptions} options - Fill style object.
   */
  normalizeColor(t) {
    const e = Ot.shared.setValue(t.color ?? 0);
    t.color = e.toNumber(), t.alpha ?? (t.alpha = e.alpha);
  }
  /**
   * Begin the texture fill.
   * Note: The wrap mode of the texture is forced to REPEAT on render.
   * @param options - Fill style object.
   * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to fill
   * @param {PIXI.ColorSource} [options.color=0xffffff] - Background to fill behind texture
   * @param {number} [options.alpha] - Alpha of fill, overrides the color's alpha
   * @param {PIXI.Matrix} [options.matrix=null] - Transform matrix
   * @returns {PIXI.Graphics} This Graphics object. Good for chaining method calls
   */
  beginTextureFill(t) {
    const e = {
      texture: ct.WHITE,
      color: 16777215,
      matrix: null
    };
    t = Object.assign(e, t), this.normalizeColor(t), this.currentPath && this.startPoly();
    const r = t.alpha > 0;
    return r ? (t.matrix && (t.matrix = t.matrix.clone(), t.matrix.invert()), Object.assign(this._fillStyle, { visible: r }, t)) : this._fillStyle.reset(), this;
  }
  /**
   * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
   * @returns - This Graphics object. Good for chaining method calls
   */
  endFill() {
    return this.finishPoly(), this._fillStyle.reset(), this;
  }
  /**
   * Draws a rectangle shape.
   * @param x - The X coord of the top-left of the rectangle
   * @param y - The Y coord of the top-left of the rectangle
   * @param width - The width of the rectangle
   * @param height - The height of the rectangle
   * @returns - This Graphics object. Good for chaining method calls
   */
  drawRect(t, e, r, i) {
    return this.drawShape(new yt(t, e, r, i));
  }
  /**
   * Draw a rectangle shape with rounded/beveled corners.
   * @param x - The X coord of the top-left of the rectangle
   * @param y - The Y coord of the top-left of the rectangle
   * @param width - The width of the rectangle
   * @param height - The height of the rectangle
   * @param radius - Radius of the rectangle corners
   * @returns - This Graphics object. Good for chaining method calls
   */
  drawRoundedRect(t, e, r, i, s) {
    return this.drawShape(new Ph(t, e, r, i, s));
  }
  /**
   * Draws a circle.
   * @param x - The X coordinate of the center of the circle
   * @param y - The Y coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @returns - This Graphics object. Good for chaining method calls
   */
  drawCircle(t, e, r) {
    return this.drawShape(new Mh(t, e, r));
  }
  /**
   * Draws an ellipse.
   * @param x - The X coordinate of the center of the ellipse
   * @param y - The Y coordinate of the center of the ellipse
   * @param width - The half width of the ellipse
   * @param height - The half height of the ellipse
   * @returns - This Graphics object. Good for chaining method calls
   */
  drawEllipse(t, e, r, i) {
    return this.drawShape(new Ih(t, e, r, i));
  }
  /**
   * Draws a polygon using the given path.
   * @param {number[]|PIXI.IPointData[]|PIXI.Polygon} path - The path data used to construct the polygon.
   * @returns - This Graphics object. Good for chaining method calls
   */
  drawPolygon(...t) {
    let e, r = !0;
    const i = t[0];
    i.points ? (r = i.closeStroke, e = i.points) : Array.isArray(t[0]) ? e = t[0] : e = t;
    const s = new mi(e);
    return s.closeStroke = r, this.drawShape(s), this;
  }
  /**
   * Draw any shape.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - Shape to draw
   * @returns - This Graphics object. Good for chaining method calls
   */
  drawShape(t) {
    return this._holeMode ? this._geometry.drawHole(t, this._matrix) : this._geometry.drawShape(
      t,
      this._fillStyle.clone(),
      this._lineStyle.clone(),
      this._matrix
    ), this;
  }
  /**
   * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
   * @returns - This Graphics object. Good for chaining method calls
   */
  clear() {
    return this._geometry.clear(), this._lineStyle.reset(), this._fillStyle.reset(), this._boundsID++, this._matrix = null, this._holeMode = !1, this.currentPath = null, this;
  }
  /**
   * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
   * masked with gl.scissor.
   * @returns - True if only 1 rect.
   */
  isFastRect() {
    const t = this._geometry.graphicsData;
    return t.length === 1 && t[0].shape.type === de.RECT && !t[0].matrix && !t[0].holes.length && !(t[0].lineStyle.visible && t[0].lineStyle.width);
  }
  /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */
  _render(t) {
    this.finishPoly();
    const e = this._geometry;
    e.updateBatches(), e.batchable ? (this.batchDirty !== e.batchDirty && this._populateBatches(), this._renderBatched(t)) : (t.batch.flush(), this._renderDirect(t));
  }
  /** Populating batches for rendering. */
  _populateBatches() {
    const t = this._geometry, e = this.blendMode, r = t.batches.length;
    this.batchTint = -1, this._transformID = -1, this.batchDirty = t.batchDirty, this.batches.length = r, this.vertexData = new Float32Array(t.points);
    for (let i = 0; i < r; i++) {
      const s = t.batches[i], o = s.style.color, a = new Float32Array(
        this.vertexData.buffer,
        s.attribStart * 4 * 2,
        s.attribSize * 2
      ), h = new Float32Array(
        t.uvsFloat32.buffer,
        s.attribStart * 4 * 2,
        s.attribSize * 2
      ), l = new Uint16Array(
        t.indicesUint16.buffer,
        s.start * 2,
        s.size
      ), u = {
        vertexData: a,
        blendMode: e,
        indices: l,
        uvs: h,
        _batchRGB: Ot.shared.setValue(o).toRgbArray(),
        _tintRGB: o,
        _texture: s.style.texture,
        alpha: s.style.alpha,
        worldAlpha: 1
      };
      this.batches[i] = u;
    }
  }
  /**
   * Renders the batches using the BathedRenderer plugin
   * @param renderer - The renderer
   */
  _renderBatched(t) {
    if (this.batches.length) {
      t.batch.setObjectRenderer(t.plugins[this.pluginName]), this.calculateVertices(), this.calculateTints();
      for (let e = 0, r = this.batches.length; e < r; e++) {
        const i = this.batches[e];
        i.worldAlpha = this.worldAlpha * i.alpha, t.plugins[this.pluginName].render(i);
      }
    }
  }
  /**
   * Renders the graphics direct
   * @param renderer - The renderer
   */
  _renderDirect(t) {
    const e = this._resolveDirectShader(t), r = this._geometry, i = this.worldAlpha, s = e.uniforms, o = r.drawCalls;
    s.translationMatrix = this.transform.worldTransform, Ot.shared.setValue(this._tintColor).premultiply(i).toArray(s.tint), t.shader.bind(e), t.geometry.bind(r, e), t.state.set(this.state);
    for (let a = 0, h = o.length; a < h; a++)
      this._renderDrawCallDirect(t, r.drawCalls[a]);
  }
  /**
   * Renders specific DrawCall
   * @param renderer
   * @param drawCall
   */
  _renderDrawCallDirect(t, e) {
    const { texArray: r, type: i, size: s, start: o } = e, a = r.count;
    for (let h = 0; h < a; h++)
      t.texture.bind(r.elements[h], h);
    t.geometry.draw(i, s, o);
  }
  /**
   * Resolves shader for direct rendering
   * @param renderer - The renderer
   */
  _resolveDirectShader(t) {
    let e = this.shader;
    const r = this.pluginName;
    if (!e) {
      if (!fu[r]) {
        const { maxTextures: i } = t.plugins[r], s = new Int32Array(i);
        for (let h = 0; h < i; h++)
          s[h] = h;
        const o = {
          tint: new Float32Array([1, 1, 1, 1]),
          translationMatrix: new Nt(),
          default: mr.from({ uSamplers: s }, !0)
        }, a = t.plugins[r]._shader.program;
        fu[r] = new Or(a, o);
      }
      e = fu[r];
    }
    return e;
  }
  /**
   * Retrieves the bounds of the graphic shape as a rectangle object.
   * @see PIXI.GraphicsGeometry#bounds
   */
  _calculateBounds() {
    this.finishPoly();
    const t = this._geometry;
    if (!t.graphicsData.length)
      return;
    const { minX: e, minY: r, maxX: i, maxY: s } = t.bounds;
    this._bounds.addFrame(this.transform, e, r, i, s);
  }
  /**
   * Tests if a point is inside this graphics object
   * @param point - the point to test
   * @returns - the result of the test
   */
  containsPoint(t) {
    return this.worldTransform.applyInverse(t, Ma._TEMP_POINT), this._geometry.containsPoint(Ma._TEMP_POINT);
  }
  /** Recalculate the tint by applying tint to batches using Graphics tint. */
  calculateTints() {
    if (this.batchTint !== this.tint) {
      this.batchTint = this._tintColor.toNumber();
      for (let t = 0; t < this.batches.length; t++) {
        const e = this.batches[t];
        e._tintRGB = Ot.shared.setValue(this._tintColor).multiply(e._batchRGB).toLittleEndianNumber();
      }
    }
  }
  /** If there's a transform update or a change to the shape of the geometry, recalculate the vertices. */
  calculateVertices() {
    const t = this.transform._worldID;
    if (this._transformID === t)
      return;
    this._transformID = t;
    const e = this.transform.worldTransform, r = e.a, i = e.b, s = e.c, o = e.d, a = e.tx, h = e.ty, l = this._geometry.points, u = this.vertexData;
    let c = 0;
    for (let d = 0; d < l.length; d += 2) {
      const f = l[d], p = l[d + 1];
      u[c++] = r * f + s * p + a, u[c++] = o * p + i * f + h;
    }
  }
  /**
   * Closes the current path.
   * @returns - Returns itself.
   */
  closePath() {
    const t = this.currentPath;
    return t && (t.closeStroke = !0, this.finishPoly()), this;
  }
  /**
   * Apply a matrix to the positional data.
   * @param matrix - Matrix to use for transform current shape.
   * @returns - Returns itself.
   */
  setMatrix(t) {
    return this._matrix = t, this;
  }
  /**
   * Begin adding holes to the last draw shape
   * IMPORTANT: holes must be fully inside a shape to work
   * Also weirdness ensues if holes overlap!
   * Ellipses, Circles, Rectangles and Rounded Rectangles cannot be holes or host for holes in CanvasRenderer,
   * please use `moveTo` `lineTo`, `quadraticCurveTo` if you rely on pixi-legacy bundle.
   * @returns - Returns itself.
   */
  beginHole() {
    return this.finishPoly(), this._holeMode = !0, this;
  }
  /**
   * End adding holes to the last draw shape.
   * @returns - Returns itself.
   */
  endHole() {
    return this.finishPoly(), this._holeMode = !1, this;
  }
  /**
   * Destroys the Graphics object.
   * @param options - Options parameter. A boolean will act as if all
   *  options have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have
   *  their destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */
  destroy(t) {
    this._geometry.refCount--, this._geometry.refCount === 0 && this._geometry.dispose(), this._matrix = null, this.currentPath = null, this._lineStyle.destroy(), this._lineStyle = null, this._fillStyle.destroy(), this._fillStyle = null, this._geometry = null, this.shader = null, this.vertexData = null, this.batches.length = 0, this.batches = null, super.destroy(t);
  }
};
yc.curves = cs, /**
* Temporary point to use for containsPoint.
* @private
*/
yc._TEMP_POINT = new mt();
let Un = yc;
class dT {
  /**
   * @param uvBuffer - Buffer with normalized uv's
   * @param uvMatrix - Material UV matrix
   */
  constructor(t, e) {
    this.uvBuffer = t, this.uvMatrix = e, this.data = null, this._bufferUpdateId = -1, this._textureUpdateId = -1, this._updateID = 0;
  }
  /**
   * Updates
   * @param forceUpdate - force the update
   */
  update(t) {
    if (!t && this._bufferUpdateId === this.uvBuffer._updateID && this._textureUpdateId === this.uvMatrix._updateID)
      return;
    this._bufferUpdateId = this.uvBuffer._updateID, this._textureUpdateId = this.uvMatrix._updateID;
    const e = this.uvBuffer.data;
    (!this.data || this.data.length !== e.length) && (this.data = new Float32Array(e.length)), this.uvMatrix.multiplyUvs(e, this.data), this._updateID++;
  }
}
const pu = new mt(), am = new mi(), q0 = class Z0 extends bt {
  /**
   * @param geometry - The geometry the mesh will use.
   * @param {PIXI.MeshMaterial} shader - The shader the mesh will use.
   * @param state - The state that the WebGL context is required to be in to render the mesh
   *        if no state is provided, uses {@link PIXI.State.for2d} to create a 2D state for PixiJS.
   * @param drawMode - The drawMode, can be any of the {@link PIXI.DRAW_MODES} constants.
   */
  constructor(t, e, r, i = Pr.TRIANGLES) {
    super(), this.geometry = t, this.shader = e, this.state = r || Hr.for2d(), this.drawMode = i, this.start = 0, this.size = 0, this.uvs = null, this.indices = null, this.vertexData = new Float32Array(1), this.vertexDirty = -1, this._transformID = -1, this._roundPixels = ht.ROUND_PIXELS, this.batchUvs = null;
  }
  /**
   * Includes vertex positions, face indices, normals, colors, UVs, and
   * custom attributes within buffers, reducing the cost of passing all
   * this data to the GPU. Can be shared between multiple Mesh objects.
   */
  get geometry() {
    return this._geometry;
  }
  set geometry(t) {
    this._geometry !== t && (this._geometry && (this._geometry.refCount--, this._geometry.refCount === 0 && this._geometry.dispose()), this._geometry = t, this._geometry && this._geometry.refCount++, this.vertexDirty = -1);
  }
  /**
   * To change mesh uv's, change its uvBuffer data and increment its _updateID.
   * @readonly
   */
  get uvBuffer() {
    return this.geometry.buffers[1];
  }
  /**
   * To change mesh vertices, change its uvBuffer data and increment its _updateID.
   * Incrementing _updateID is optional because most of Mesh objects do it anyway.
   * @readonly
   */
  get verticesBuffer() {
    return this.geometry.buffers[0];
  }
  /** Alias for {@link PIXI.Mesh#shader}. */
  set material(t) {
    this.shader = t;
  }
  get material() {
    return this.shader;
  }
  /**
   * The blend mode to be applied to the Mesh. Apply a value of
   * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
   * @default PIXI.BLEND_MODES.NORMAL;
   */
  set blendMode(t) {
    this.state.blendMode = t;
  }
  get blendMode() {
    return this.state.blendMode;
  }
  /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
   * @default false
   */
  set roundPixels(t) {
    this._roundPixels !== t && (this._transformID = -1), this._roundPixels = t;
  }
  get roundPixels() {
    return this._roundPixels;
  }
  /**
   * The multiply tint applied to the Mesh. This is a hex value. A value of
   * `0xFFFFFF` will remove any tint effect.
   *
   * Null for non-MeshMaterial shaders
   * @default 0xFFFFFF
   */
  get tint() {
    return "tint" in this.shader ? this.shader.tint : null;
  }
  set tint(t) {
    this.shader.tint = t;
  }
  /**
   * The tint color as a RGB integer
   * @ignore
   */
  get tintValue() {
    return this.shader.tintValue;
  }
  /** The texture that the Mesh uses. Null for non-MeshMaterial shaders */
  get texture() {
    return "texture" in this.shader ? this.shader.texture : null;
  }
  set texture(t) {
    this.shader.texture = t;
  }
  /**
   * Standard renderer draw.
   * @param renderer - Instance to renderer.
   */
  _render(t) {
    const e = this.geometry.buffers[0].data;
    this.shader.batchable && this.drawMode === Pr.TRIANGLES && e.length < Z0.BATCHABLE_SIZE * 2 ? this._renderToBatch(t) : this._renderDefault(t);
  }
  /**
   * Standard non-batching way of rendering.
   * @param renderer - Instance to renderer.
   */
  _renderDefault(t) {
    const e = this.shader;
    e.alpha = this.worldAlpha, e.update && e.update(), t.batch.flush(), e.uniforms.translationMatrix = this.transform.worldTransform.toArray(!0), t.shader.bind(e), t.state.set(this.state), t.geometry.bind(this.geometry, e), t.geometry.draw(this.drawMode, this.size, this.start, this.geometry.instanceCount);
  }
  /**
   * Rendering by using the Batch system.
   * @param renderer - Instance to renderer.
   */
  _renderToBatch(t) {
    const e = this.geometry, r = this.shader;
    r.uvMatrix && (r.uvMatrix.update(), this.calculateUvs()), this.calculateVertices(), this.indices = e.indexBuffer.data, this._tintRGB = r._tintRGB, this._texture = r.texture;
    const i = this.material.pluginName;
    t.batch.setObjectRenderer(t.plugins[i]), t.plugins[i].render(this);
  }
  /** Updates vertexData field based on transform and vertices. */
  calculateVertices() {
    const t = this.geometry.buffers[0], e = t.data, r = t._updateID;
    if (r === this.vertexDirty && this._transformID === this.transform._worldID)
      return;
    this._transformID = this.transform._worldID, this.vertexData.length !== e.length && (this.vertexData = new Float32Array(e.length));
    const i = this.transform.worldTransform, s = i.a, o = i.b, a = i.c, h = i.d, l = i.tx, u = i.ty, c = this.vertexData;
    for (let d = 0; d < c.length / 2; d++) {
      const f = e[d * 2], p = e[d * 2 + 1];
      c[d * 2] = s * f + a * p + l, c[d * 2 + 1] = o * f + h * p + u;
    }
    if (this._roundPixels) {
      const d = ht.RESOLUTION;
      for (let f = 0; f < c.length; ++f)
        c[f] = Math.round(c[f] * d) / d;
    }
    this.vertexDirty = r;
  }
  /** Updates uv field based on from geometry uv's or batchUvs. */
  calculateUvs() {
    const t = this.geometry.buffers[1], e = this.shader;
    e.uvMatrix.isSimple ? this.uvs = t.data : (this.batchUvs || (this.batchUvs = new dT(t, e.uvMatrix)), this.batchUvs.update(), this.uvs = this.batchUvs.data);
  }
  /**
   * Updates the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
   * there must be a aVertexPosition attribute present in the geometry for bounds to be calculated correctly.
   */
  _calculateBounds() {
    this.calculateVertices(), this._bounds.addVertexData(this.vertexData, 0, this.vertexData.length);
  }
  /**
   * Tests if a point is inside this mesh. Works only for PIXI.DRAW_MODES.TRIANGLES.
   * @param point - The point to test.
   * @returns - The result of the test.
   */
  containsPoint(t) {
    if (!this.getBounds().contains(t.x, t.y))
      return !1;
    this.worldTransform.applyInverse(t, pu);
    const e = this.geometry.getBuffer("aVertexPosition").data, r = am.points, i = this.geometry.getIndex().data, s = i.length, o = this.drawMode === 4 ? 3 : 1;
    for (let a = 0; a + 2 < s; a += o) {
      const h = i[a] * 2, l = i[a + 1] * 2, u = i[a + 2] * 2;
      if (r[0] = e[h], r[1] = e[h + 1], r[2] = e[l], r[3] = e[l + 1], r[4] = e[u], r[5] = e[u + 1], am.contains(pu.x, pu.y))
        return !0;
    }
    return !1;
  }
  destroy(t) {
    super.destroy(t), this._cachedTexture && (this._cachedTexture.destroy(), this._cachedTexture = null), this.geometry = null, this.shader = null, this.state = null, this.uvs = null, this.indices = null, this.vertexData = null;
  }
};
q0.BATCHABLE_SIZE = 100;
let _c = q0;
class K0 extends Bn {
  /**
   * @param {Float32Array|number[]} [vertices] - Positional data on geometry.
   * @param {Float32Array|number[]} [uvs] - Texture UVs.
   * @param {Uint16Array|number[]} [index] - IndexBuffer
   */
  constructor(t, e, r) {
    super();
    const i = new Yt(t), s = new Yt(e, !0), o = new Yt(r, !0, !0);
    this.addAttribute("aVertexPosition", i, 2, !1, pt.FLOAT).addAttribute("aTextureCoord", s, 2, !1, pt.FLOAT).addIndex(o), this._updateId = -1;
  }
  /**
   * If the vertex position is updated.
   * @readonly
   * @private
   */
  get vertexDirtyId() {
    return this.buffers[0]._updateID;
  }
}
var fT = `varying vec2 vTextureCoord;
uniform vec4 uColor;

uniform sampler2D uSampler;

void main(void)
{
    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;
}
`, pT = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTextureMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;
}
`;
class vc extends Or {
  /**
   * @param uSampler - Texture that material uses to render.
   * @param options - Additional options
   * @param {number} [options.alpha=1] - Default alpha.
   * @param {PIXI.ColorSource} [options.tint=0xFFFFFF] - Default tint.
   * @param {string} [options.pluginName='batch'] - Renderer plugin for batching.
   * @param {PIXI.Program} [options.program=0xFFFFFF] - Custom program.
   * @param {object} [options.uniforms] - Custom uniforms.
   */
  constructor(t, e) {
    const r = {
      uSampler: t,
      alpha: 1,
      uTextureMatrix: Nt.IDENTITY,
      uColor: new Float32Array([1, 1, 1, 1])
    };
    e = Object.assign({
      tint: 16777215,
      alpha: 1,
      pluginName: "batch"
    }, e), e.uniforms && Object.assign(r, e.uniforms), super(e.program || en.from(pT, fT), r), this._colorDirty = !1, this.uvMatrix = new f0(t), this.batchable = e.program === void 0, this.pluginName = e.pluginName, this._tintColor = new Ot(e.tint), this._tintRGB = this._tintColor.toLittleEndianNumber(), this._colorDirty = !0, this.alpha = e.alpha;
  }
  /** Reference to the texture being rendered. */
  get texture() {
    return this.uniforms.uSampler;
  }
  set texture(t) {
    this.uniforms.uSampler !== t && (!this.uniforms.uSampler.baseTexture.alphaMode != !t.baseTexture.alphaMode && (this._colorDirty = !0), this.uniforms.uSampler = t, this.uvMatrix.texture = t);
  }
  /**
   * This gets automatically set by the object using this.
   * @default 1
   */
  set alpha(t) {
    t !== this._alpha && (this._alpha = t, this._colorDirty = !0);
  }
  get alpha() {
    return this._alpha;
  }
  /**
   * Multiply tint for the material.
   * @default 0xFFFFFF
   */
  set tint(t) {
    t !== this.tint && (this._tintColor.setValue(t), this._tintRGB = this._tintColor.toLittleEndianNumber(), this._colorDirty = !0);
  }
  get tint() {
    return this._tintColor.value;
  }
  /**
   * Get the internal number from tint color
   * @ignore
   */
  get tintValue() {
    return this._tintColor.toNumber();
  }
  /** Gets called automatically by the Mesh. Intended to be overridden for custom {@link PIXI.MeshMaterial} objects. */
  update() {
    if (this._colorDirty) {
      this._colorDirty = !1;
      const t = this.texture.baseTexture.alphaMode;
      Ot.shared.setValue(this._tintColor).premultiply(this._alpha, t).toArray(this.uniforms.uColor);
    }
    this.uvMatrix.update() && (this.uniforms.uTextureMatrix = this.uvMatrix.mapCoord);
  }
}
class mT extends K0 {
  /**
   * @param width - The width (i.e., thickness) of the rope.
   * @param points - An array of {@link PIXI.Point} objects to construct this rope.
   * @param textureScale - By default the rope texture will be stretched to match
   *     rope length. If textureScale is positive this value will be treated as a scaling
   *     factor and the texture will preserve its aspect ratio instead. To create a tiling rope
   *     set baseTexture.wrapMode to {@link PIXI.WRAP_MODES.REPEAT} and use a power of two texture,
   *     then set textureScale=1 to keep the original texture pixel size.
   *     In order to reduce alpha channel artifacts provide a larger texture and downsample -
   *     i.e. set textureScale=0.5 to scale it down twice.
   */
  constructor(t = 200, e, r = 0) {
    super(
      new Float32Array(e.length * 4),
      new Float32Array(e.length * 4),
      new Uint16Array((e.length - 1) * 6)
    ), this.points = e, this._width = t, this.textureScale = r, this.build();
  }
  /**
   * The width (i.e., thickness) of the rope.
   * @readonly
   */
  get width() {
    return this._width;
  }
  /** Refreshes Rope indices and uvs */
  build() {
    const t = this.points;
    if (!t)
      return;
    const e = this.getBuffer("aVertexPosition"), r = this.getBuffer("aTextureCoord"), i = this.getIndex();
    if (t.length < 1)
      return;
    e.data.length / 4 !== t.length && (e.data = new Float32Array(t.length * 4), r.data = new Float32Array(t.length * 4), i.data = new Uint16Array((t.length - 1) * 6));
    const s = r.data, o = i.data;
    s[0] = 0, s[1] = 0, s[2] = 0, s[3] = 1;
    let a = 0, h = t[0];
    const l = this._width * this.textureScale, u = t.length;
    for (let d = 0; d < u; d++) {
      const f = d * 4;
      if (this.textureScale > 0) {
        const p = h.x - t[d].x, m = h.y - t[d].y, g = Math.sqrt(p * p + m * m);
        h = t[d], a += g / l;
      } else
        a = d / (u - 1);
      s[f] = a, s[f + 1] = 0, s[f + 2] = a, s[f + 3] = 1;
    }
    let c = 0;
    for (let d = 0; d < u - 1; d++) {
      const f = d * 2;
      o[c++] = f, o[c++] = f + 1, o[c++] = f + 2, o[c++] = f + 2, o[c++] = f + 1, o[c++] = f + 3;
    }
    r.update(), i.update(), this.updateVertices();
  }
  /** refreshes vertices of Rope mesh */
  updateVertices() {
    const t = this.points;
    if (t.length < 1)
      return;
    let e = t[0], r, i = 0, s = 0;
    const o = this.buffers[0].data, a = t.length, h = this.textureScale > 0 ? this.textureScale * this._width / 2 : this._width / 2;
    for (let l = 0; l < a; l++) {
      const u = t[l], c = l * 4;
      l < t.length - 1 ? r = t[l + 1] : r = u, s = -(r.x - e.x), i = r.y - e.y;
      const d = Math.sqrt(i * i + s * s);
      d < 1e-6 ? (i = 0, s = 0) : (i /= d, s /= d, i *= h, s *= h), o[c] = u.x + i, o[c + 1] = u.y + s, o[c + 2] = u.x - i, o[c + 3] = u.y - s, e = u;
    }
    this.buffers[0].update();
  }
  update() {
    this.textureScale > 0 ? this.build() : this.updateVertices();
  }
}
class gT extends _c {
  /**
   * Note: The wrap mode of the texture is set to REPEAT if `textureScale` is positive.
   * @param texture - The texture to use on the rope.
   * @param points - An array of {@link PIXI.Point} objects to construct this rope.
   * @param {number} textureScale - Optional. Positive values scale rope texture
   * keeping its aspect ratio. You can reduce alpha channel artifacts by providing a larger texture
   * and downsampling here. If set to zero, texture will be stretched instead.
   */
  constructor(t, e, r = 0) {
    const i = new mT(t.height, e, r), s = new vc(t);
    r > 0 && (t.baseTexture.wrapMode = Dr.REPEAT), super(i, s), this.autoUpdate = !0;
  }
  _render(t) {
    const e = this.geometry;
    (this.autoUpdate || e._width !== this.shader.texture.height) && (e._width = this.shader.texture.height, e.update()), super._render(t);
  }
}
class hm {
  /**
   * @param {object} properties - The properties to upload.
   * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
   * @param {number} size - The size of the batch.
   */
  constructor(t, e, r) {
    this.geometry = new Bn(), this.indexBuffer = null, this.size = r, this.dynamicProperties = [], this.staticProperties = [];
    for (let i = 0; i < t.length; ++i) {
      let s = t[i];
      s = {
        attributeName: s.attributeName,
        size: s.size,
        uploadFunction: s.uploadFunction,
        type: s.type || pt.FLOAT,
        offset: s.offset
      }, e[i] ? this.dynamicProperties.push(s) : this.staticProperties.push(s);
    }
    this.staticStride = 0, this.staticBuffer = null, this.staticData = null, this.staticDataUint32 = null, this.dynamicStride = 0, this.dynamicBuffer = null, this.dynamicData = null, this.dynamicDataUint32 = null, this._updateID = 0, this.initBuffers();
  }
  /** Sets up the renderer context and necessary buffers. */
  initBuffers() {
    const t = this.geometry;
    let e = 0;
    this.indexBuffer = new Yt(Lx(this.size), !0, !0), t.addIndex(this.indexBuffer), this.dynamicStride = 0;
    for (let o = 0; o < this.dynamicProperties.length; ++o) {
      const a = this.dynamicProperties[o];
      a.offset = e, e += a.size, this.dynamicStride += a.size;
    }
    const r = new ArrayBuffer(this.size * this.dynamicStride * 4 * 4);
    this.dynamicData = new Float32Array(r), this.dynamicDataUint32 = new Uint32Array(r), this.dynamicBuffer = new Yt(this.dynamicData, !1, !1);
    let i = 0;
    this.staticStride = 0;
    for (let o = 0; o < this.staticProperties.length; ++o) {
      const a = this.staticProperties[o];
      a.offset = i, i += a.size, this.staticStride += a.size;
    }
    const s = new ArrayBuffer(this.size * this.staticStride * 4 * 4);
    this.staticData = new Float32Array(s), this.staticDataUint32 = new Uint32Array(s), this.staticBuffer = new Yt(this.staticData, !0, !1);
    for (let o = 0; o < this.dynamicProperties.length; ++o) {
      const a = this.dynamicProperties[o];
      t.addAttribute(
        a.attributeName,
        this.dynamicBuffer,
        0,
        a.type === pt.UNSIGNED_BYTE,
        a.type,
        this.dynamicStride * 4,
        a.offset * 4
      );
    }
    for (let o = 0; o < this.staticProperties.length; ++o) {
      const a = this.staticProperties[o];
      t.addAttribute(
        a.attributeName,
        this.staticBuffer,
        0,
        a.type === pt.UNSIGNED_BYTE,
        a.type,
        this.staticStride * 4,
        a.offset * 4
      );
    }
  }
  /**
   * Uploads the dynamic properties.
   * @param children - The children to upload.
   * @param startIndex - The index to start at.
   * @param amount - The number to upload.
   */
  uploadDynamic(t, e, r) {
    for (let i = 0; i < this.dynamicProperties.length; i++) {
      const s = this.dynamicProperties[i];
      s.uploadFunction(
        t,
        e,
        r,
        s.type === pt.UNSIGNED_BYTE ? this.dynamicDataUint32 : this.dynamicData,
        this.dynamicStride,
        s.offset
      );
    }
    this.dynamicBuffer._updateID++;
  }
  /**
   * Uploads the static properties.
   * @param children - The children to upload.
   * @param startIndex - The index to start at.
   * @param amount - The number to upload.
   */
  uploadStatic(t, e, r) {
    for (let i = 0; i < this.staticProperties.length; i++) {
      const s = this.staticProperties[i];
      s.uploadFunction(
        t,
        e,
        r,
        s.type === pt.UNSIGNED_BYTE ? this.staticDataUint32 : this.staticData,
        this.staticStride,
        s.offset
      );
    }
    this.staticBuffer._updateID++;
  }
  /** Destroys the ParticleBuffer. */
  destroy() {
    this.indexBuffer = null, this.dynamicProperties = null, this.dynamicBuffer = null, this.dynamicData = null, this.dynamicDataUint32 = null, this.staticProperties = null, this.staticBuffer = null, this.staticData = null, this.staticDataUint32 = null, this.geometry.destroy();
  }
}
var yT = `varying vec2 vTextureCoord;
varying vec4 vColor;

uniform sampler2D uSampler;

void main(void){
    vec4 color = texture2D(uSampler, vTextureCoord) * vColor;
    gl_FragColor = color;
}`, _T = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColor;

attribute vec2 aPositionCoord;
attribute float aRotation;

uniform mat3 translationMatrix;
uniform vec4 uColor;

varying vec2 vTextureCoord;
varying vec4 vColor;

void main(void){
    float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);
    float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);

    vec2 v = vec2(x, y);
    v = v + aPositionCoord;

    gl_Position = vec4((translationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vColor = aColor * uColor;
}
`;
class Q0 extends Rh {
  /**
   * @param renderer - The renderer this sprite batch works for.
   */
  constructor(t) {
    super(t), this.shader = null, this.properties = null, this.tempMatrix = new Nt(), this.properties = [
      // verticesData
      {
        attributeName: "aVertexPosition",
        size: 2,
        uploadFunction: this.uploadVertices,
        offset: 0
      },
      // positionData
      {
        attributeName: "aPositionCoord",
        size: 2,
        uploadFunction: this.uploadPosition,
        offset: 0
      },
      // rotationData
      {
        attributeName: "aRotation",
        size: 1,
        uploadFunction: this.uploadRotation,
        offset: 0
      },
      // uvsData
      {
        attributeName: "aTextureCoord",
        size: 2,
        uploadFunction: this.uploadUvs,
        offset: 0
      },
      // tintData
      {
        attributeName: "aColor",
        size: 1,
        type: pt.UNSIGNED_BYTE,
        uploadFunction: this.uploadTint,
        offset: 0
      }
    ], this.shader = Or.from(_T, yT, {}), this.state = Hr.for2d();
  }
  /**
   * Renders the particle container object.
   * @param container - The container to render using this ParticleRenderer.
   */
  render(t) {
    const e = t.children, r = t._maxSize, i = t._batchSize, s = this.renderer;
    let o = e.length;
    if (o === 0)
      return;
    o > r && !t.autoResize && (o = r);
    let a = t._buffers;
    a || (a = t._buffers = this.generateBuffers(t));
    const h = e[0]._texture.baseTexture, l = h.alphaMode > 0;
    this.state.blendMode = Zg(t.blendMode, l), s.state.set(this.state);
    const u = s.gl, c = t.worldTransform.copyTo(this.tempMatrix);
    c.prepend(s.globalUniforms.uniforms.projectionMatrix), this.shader.uniforms.translationMatrix = c.toArray(!0), this.shader.uniforms.uColor = Ot.shared.setValue(t.tintRgb).premultiply(t.worldAlpha, l).toArray(this.shader.uniforms.uColor), this.shader.uniforms.uSampler = h, this.renderer.shader.bind(this.shader);
    let d = !1;
    for (let f = 0, p = 0; f < o; f += i, p += 1) {
      let m = o - f;
      m > i && (m = i), p >= a.length && a.push(this._generateOneMoreBuffer(t));
      const g = a[p];
      g.uploadDynamic(e, f, m);
      const _ = t._bufferUpdateIDs[p] || 0;
      d = d || g._updateID < _, d && (g._updateID = t._updateID, g.uploadStatic(e, f, m)), s.geometry.bind(g.geometry), u.drawElements(u.TRIANGLES, m * 6, u.UNSIGNED_SHORT, 0);
    }
  }
  /**
   * Creates one particle buffer for each child in the container we want to render and updates internal properties.
   * @param container - The container to render using this ParticleRenderer
   * @returns - The buffers
   */
  generateBuffers(t) {
    const e = [], r = t._maxSize, i = t._batchSize, s = t._properties;
    for (let o = 0; o < r; o += i)
      e.push(new hm(this.properties, s, i));
    return e;
  }
  /**
   * Creates one more particle buffer, because container has autoResize feature.
   * @param container - The container to render using this ParticleRenderer
   * @returns - The generated buffer
   */
  _generateOneMoreBuffer(t) {
    const e = t._batchSize, r = t._properties;
    return new hm(this.properties, r, e);
  }
  /**
   * Uploads the vertices.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their vertices uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */
  uploadVertices(t, e, r, i, s, o) {
    let a = 0, h = 0, l = 0, u = 0;
    for (let c = 0; c < r; ++c) {
      const d = t[e + c], f = d._texture, p = d.scale.x, m = d.scale.y, g = f.trim, _ = f.orig;
      g ? (h = g.x - d.anchor.x * _.width, a = h + g.width, u = g.y - d.anchor.y * _.height, l = u + g.height) : (a = _.width * (1 - d.anchor.x), h = _.width * -d.anchor.x, l = _.height * (1 - d.anchor.y), u = _.height * -d.anchor.y), i[o] = h * p, i[o + 1] = u * m, i[o + s] = a * p, i[o + s + 1] = u * m, i[o + s * 2] = a * p, i[o + s * 2 + 1] = l * m, i[o + s * 3] = h * p, i[o + s * 3 + 1] = l * m, o += s * 4;
    }
  }
  /**
   * Uploads the position.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their positions uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */
  uploadPosition(t, e, r, i, s, o) {
    for (let a = 0; a < r; a++) {
      const h = t[e + a].position;
      i[o] = h.x, i[o + 1] = h.y, i[o + s] = h.x, i[o + s + 1] = h.y, i[o + s * 2] = h.x, i[o + s * 2 + 1] = h.y, i[o + s * 3] = h.x, i[o + s * 3 + 1] = h.y, o += s * 4;
    }
  }
  /**
   * Uploads the rotation.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */
  uploadRotation(t, e, r, i, s, o) {
    for (let a = 0; a < r; a++) {
      const h = t[e + a].rotation;
      i[o] = h, i[o + s] = h, i[o + s * 2] = h, i[o + s * 3] = h, o += s * 4;
    }
  }
  /**
   * Uploads the UVs.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */
  uploadUvs(t, e, r, i, s, o) {
    for (let a = 0; a < r; ++a) {
      const h = t[e + a]._texture._uvs;
      h ? (i[o] = h.x0, i[o + 1] = h.y0, i[o + s] = h.x1, i[o + s + 1] = h.y1, i[o + s * 2] = h.x2, i[o + s * 2 + 1] = h.y2, i[o + s * 3] = h.x3, i[o + s * 3 + 1] = h.y3, o += s * 4) : (i[o] = 0, i[o + 1] = 0, i[o + s] = 0, i[o + s + 1] = 0, i[o + s * 2] = 0, i[o + s * 2 + 1] = 0, i[o + s * 3] = 0, i[o + s * 3 + 1] = 0, o += s * 4);
    }
  }
  /**
   * Uploads the tint.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */
  uploadTint(t, e, r, i, s, o) {
    for (let a = 0; a < r; ++a) {
      const h = t[e + a], l = Ot.shared.setValue(h._tintRGB).toPremultiplied(h.alpha, h.texture.baseTexture.alphaMode > 0);
      i[o] = l, i[o + s] = l, i[o + s * 2] = l, i[o + s * 3] = l, o += s * 4;
    }
  }
  /** Destroys the ParticleRenderer. */
  destroy() {
    super.destroy(), this.shader && (this.shader.destroy(), this.shader = null), this.tempMatrix = null;
  }
}
Q0.extension = {
  name: "particle",
  type: st.RendererPlugin
};
dt.add(Q0);
var Oh = /* @__PURE__ */ ((n) => (n[n.LINEAR_VERTICAL = 0] = "LINEAR_VERTICAL", n[n.LINEAR_HORIZONTAL = 1] = "LINEAR_HORIZONTAL", n))(Oh || {});
const pa = {
  // TextMetrics requires getImageData readback for measuring fonts.
  willReadFrequently: !0
}, Er = class ft {
  /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see PIXI.TextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */
  static get experimentalLetterSpacingSupported() {
    let t = ft._experimentalLetterSpacingSupported;
    if (t !== void 0) {
      const e = ht.ADAPTER.getCanvasRenderingContext2D().prototype;
      t = ft._experimentalLetterSpacingSupported = "letterSpacing" in e || "textLetterSpacing" in e;
    }
    return t;
  }
  /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param {PIXI.IFontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
   */
  constructor(t, e, r, i, s, o, a, h, l) {
    this.text = t, this.style = e, this.width = r, this.height = i, this.lines = s, this.lineWidths = o, this.lineHeight = a, this.maxLineWidth = h, this.fontProperties = l;
  }
  /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param wordWrap - Override for if word-wrap should be applied to the text.
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns Measured width and height of the text.
   */
  static measureText(t, e, r, i = ft._canvas) {
    r = r ?? e.wordWrap;
    const s = e.toFontString(), o = ft.measureFont(s);
    o.fontSize === 0 && (o.fontSize = e.fontSize, o.ascent = e.fontSize);
    const a = i.getContext("2d", pa);
    a.font = s;
    const h = (r ? ft.wordWrap(t, e, i) : t).split(/(?:\r\n|\r|\n)/), l = new Array(h.length);
    let u = 0;
    for (let p = 0; p < h.length; p++) {
      const m = ft._measureText(h[p], e.letterSpacing, a);
      l[p] = m, u = Math.max(u, m);
    }
    let c = u + e.strokeThickness;
    e.dropShadow && (c += e.dropShadowDistance);
    const d = e.lineHeight || o.fontSize + e.strokeThickness;
    let f = Math.max(d, o.fontSize + e.strokeThickness * 2) + e.leading + (h.length - 1) * (d + e.leading);
    return e.dropShadow && (f += e.dropShadowDistance), new ft(
      t,
      e,
      c,
      f,
      h,
      l,
      d + e.leading,
      u,
      o
    );
  }
  static _measureText(t, e, r) {
    let i = !1;
    ft.experimentalLetterSpacingSupported && (ft.experimentalLetterSpacing ? (r.letterSpacing = `${e}px`, r.textLetterSpacing = `${e}px`, i = !0) : (r.letterSpacing = "0px", r.textLetterSpacing = "0px"));
    let s = r.measureText(t).width;
    return s > 0 && (i ? s -= e : s += (ft.graphemeSegmenter(t).length - 1) * e), s;
  }
  /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */
  static wordWrap(t, e, r = ft._canvas) {
    const i = r.getContext("2d", pa);
    let s = 0, o = "", a = "";
    const h = /* @__PURE__ */ Object.create(null), { letterSpacing: l, whiteSpace: u } = e, c = ft.collapseSpaces(u), d = ft.collapseNewlines(u);
    let f = !c;
    const p = e.wordWrapWidth + l, m = ft.tokenize(t);
    for (let g = 0; g < m.length; g++) {
      let _ = m[g];
      if (ft.isNewline(_)) {
        if (!d) {
          a += ft.addLine(o), f = !c, o = "", s = 0;
          continue;
        }
        _ = " ";
      }
      if (c) {
        const v = ft.isBreakingSpace(_), E = ft.isBreakingSpace(o[o.length - 1]);
        if (v && E)
          continue;
      }
      const w = ft.getFromCache(_, l, h, i);
      if (w > p)
        if (o !== "" && (a += ft.addLine(o), o = "", s = 0), ft.canBreakWords(_, e.breakWords)) {
          const v = ft.wordWrapSplit(_);
          for (let E = 0; E < v.length; E++) {
            let x = v[E], b = x, y = 1;
            for (; v[E + y]; ) {
              const M = v[E + y];
              if (!ft.canBreakChars(b, M, _, E, e.breakWords))
                x += M;
              else
                break;
              b = M, y++;
            }
            E += y - 1;
            const C = ft.getFromCache(x, l, h, i);
            C + s > p && (a += ft.addLine(o), f = !1, o = "", s = 0), o += x, s += C;
          }
        } else {
          o.length > 0 && (a += ft.addLine(o), o = "", s = 0);
          const v = g === m.length - 1;
          a += ft.addLine(_, !v), f = !1, o = "", s = 0;
        }
      else
        w + s > p && (f = !1, a += ft.addLine(o), o = "", s = 0), (o.length > 0 || !ft.isBreakingSpace(_) || f) && (o += _, s += w);
    }
    return a += ft.addLine(o, !1), a;
  }
  /**
   * Convienience function for logging each line added during the wordWrap method.
   * @param line    - The line of text to add
   * @param newLine - Add new line character to end
   * @returns A formatted line
   */
  static addLine(t, e = !0) {
    return t = ft.trimRight(t), t = e ? `${t}
` : t, t;
  }
  /**
   * Gets & sets the widths of calculated characters in a cache object
   * @param key            - The key
   * @param letterSpacing  - The letter spacing
   * @param cache          - The cache
   * @param context        - The canvas context
   * @returns The from cache.
   */
  static getFromCache(t, e, r, i) {
    let s = r[t];
    return typeof s != "number" && (s = ft._measureText(t, e, i) + e, r[t] = s), s;
  }
  /**
   * Determines whether we should collapse breaking spaces.
   * @param whiteSpace - The TextStyle property whiteSpace
   * @returns Should collapse
   */
  static collapseSpaces(t) {
    return t === "normal" || t === "pre-line";
  }
  /**
   * Determines whether we should collapse newLine chars.
   * @param whiteSpace - The white space
   * @returns should collapse
   */
  static collapseNewlines(t) {
    return t === "normal";
  }
  /**
   * Trims breaking whitespaces from string.
   * @param text - The text
   * @returns Trimmed string
   */
  static trimRight(t) {
    if (typeof t != "string")
      return "";
    for (let e = t.length - 1; e >= 0; e--) {
      const r = t[e];
      if (!ft.isBreakingSpace(r))
        break;
      t = t.slice(0, -1);
    }
    return t;
  }
  /**
   * Determines if char is a newline.
   * @param char - The character
   * @returns True if newline, False otherwise.
   */
  static isNewline(t) {
    return typeof t != "string" ? !1 : ft._newlines.includes(t.charCodeAt(0));
  }
  /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */
  static isBreakingSpace(t, e) {
    return typeof t != "string" ? !1 : ft._breakingSpaces.includes(t.charCodeAt(0));
  }
  /**
   * Splits a string into words, breaking-spaces and newLine characters
   * @param text - The text
   * @returns A tokenized array
   */
  static tokenize(t) {
    const e = [];
    let r = "";
    if (typeof t != "string")
      return e;
    for (let i = 0; i < t.length; i++) {
      const s = t[i], o = t[i + 1];
      if (ft.isBreakingSpace(s, o) || ft.isNewline(s)) {
        r !== "" && (e.push(r), r = ""), e.push(s);
        continue;
      }
      r += s;
    }
    return r !== "" && e.push(r), e;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */
  static canBreakWords(t, e) {
    return e;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */
  static canBreakChars(t, e, r, i, s) {
    return !0;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see TextMetrics.graphemeSegmenter
   */
  static wordWrapSplit(t) {
    return ft.graphemeSegmenter(t);
  }
  /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */
  static measureFont(t) {
    if (ft._fonts[t])
      return ft._fonts[t];
    const e = {
      ascent: 0,
      descent: 0,
      fontSize: 0
    }, r = ft._canvas, i = ft._context;
    i.font = t;
    const s = ft.METRICS_STRING + ft.BASELINE_SYMBOL, o = Math.ceil(i.measureText(s).width);
    let a = Math.ceil(i.measureText(ft.BASELINE_SYMBOL).width);
    const h = Math.ceil(ft.HEIGHT_MULTIPLIER * a);
    if (a = a * ft.BASELINE_MULTIPLIER | 0, o === 0 || h === 0)
      return ft._fonts[t] = e, e;
    r.width = o, r.height = h, i.fillStyle = "#f00", i.fillRect(0, 0, o, h), i.font = t, i.textBaseline = "alphabetic", i.fillStyle = "#000", i.fillText(s, 0, a);
    const l = i.getImageData(0, 0, o, h).data, u = l.length, c = o * 4;
    let d = 0, f = 0, p = !1;
    for (d = 0; d < a; ++d) {
      for (let m = 0; m < c; m += 4)
        if (l[f + m] !== 255) {
          p = !0;
          break;
        }
      if (!p)
        f += c;
      else
        break;
    }
    for (e.ascent = a - d, f = u - c, p = !1, d = h; d > a; --d) {
      for (let m = 0; m < c; m += 4)
        if (l[f + m] !== 255) {
          p = !0;
          break;
        }
      if (!p)
        f -= c;
      else
        break;
    }
    return e.descent = d - a, e.fontSize = e.ascent + e.descent, ft._fonts[t] = e, e;
  }
  /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */
  static clearMetrics(t = "") {
    t ? delete ft._fonts[t] : ft._fonts = {};
  }
  /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */
  static get _canvas() {
    if (!ft.__canvas) {
      let t;
      try {
        const e = new OffscreenCanvas(0, 0);
        if (e.getContext("2d", pa)?.measureText)
          return ft.__canvas = e, e;
        t = ht.ADAPTER.createCanvas();
      } catch {
        t = ht.ADAPTER.createCanvas();
      }
      t.width = t.height = 10, ft.__canvas = t;
    }
    return ft.__canvas;
  }
  /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */
  static get _context() {
    return ft.__context || (ft.__context = ft._canvas.getContext("2d", pa)), ft.__context;
  }
};
Er.METRICS_STRING = "|ÉqÅ", /** Baseline symbol for calculate font metrics. */
Er.BASELINE_SYMBOL = "M", /** Baseline multiplier for calculate font metrics. */
Er.BASELINE_MULTIPLIER = 1.4, /** Height multiplier for setting height of canvas to calculate font metrics. */
Er.HEIGHT_MULTIPLIER = 2, /**
* A Unicode "character", or "grapheme cluster", can be composed of multiple Unicode code points,
* such as letters with diacritical marks (e.g. `'\u0065\u0301'`, letter e with acute)
* or emojis with modifiers (e.g. `'\uD83E\uDDD1\u200D\uD83D\uDCBB'`, technologist).
* The new `Intl.Segmenter` API in ES2022 can split the string into grapheme clusters correctly. If it is not available,
* PixiJS will fallback to use the iterator of String, which can only spilt the string into code points.
* If you want to get full functionality in environments that don't support `Intl.Segmenter` (such as Firefox),
* you can use other libraries such as [grapheme-splitter]{@link https://www.npmjs.com/package/grapheme-splitter}
* or [graphemer]{@link https://www.npmjs.com/package/graphemer} to create a polyfill. Since these libraries can be
* relatively large in size to handle various Unicode grapheme clusters properly, PixiJS won't use them directly.
*/
Er.graphemeSegmenter = (() => {
  if (typeof Intl?.Segmenter == "function") {
    const n = new Intl.Segmenter();
    return (t) => [...n.segment(t)].map((e) => e.segment);
  }
  return (n) => [...n];
})(), /**
* New rendering behavior for letter-spacing which uses Chrome's new native API. This will
* lead to more accurate letter-spacing results because it does not try to manually draw
* each character. However, this Chrome API is experimental and may not serve all cases yet.
* @see PIXI.TextMetrics.experimentalLetterSpacingSupported
*/
Er.experimentalLetterSpacing = !1, /** Cache of {@see PIXI.TextMetrics.FontMetrics} objects. */
Er._fonts = {}, /** Cache of new line chars. */
Er._newlines = [
  10,
  // line feed
  13
  // carriage return
], /** Cache of breaking spaces. */
Er._breakingSpaces = [
  9,
  // character tabulation
  32,
  // space
  8192,
  // en quad
  8193,
  // em quad
  8194,
  // en space
  8195,
  // em space
  8196,
  // three-per-em space
  8197,
  // four-per-em space
  8198,
  // six-per-em space
  8200,
  // punctuation space
  8201,
  // thin space
  8202,
  // hair space
  8287,
  // medium mathematical space
  12288
  // ideographic space
];
let An = Er;
const vT = [
  "serif",
  "sans-serif",
  "monospace",
  "cursive",
  "fantasy",
  "system-ui"
], J0 = class Qs {
  /**
   * @param style - TextStyle properties to be set on the text. See {@link PIXI.TextStyle.defaultStyle}
   *       for the default values.
   */
  constructor(t) {
    this.styleID = 0, this.reset(), gu(this, t, t);
  }
  /**
   * Creates a new TextStyle object with the same values as this one.
   * Note that the only the properties of the object are cloned.
   *
   * @return New cloned TextStyle object
   */
  clone() {
    const t = {};
    return gu(t, this, Qs.defaultStyle), new Qs(t);
  }
  /** Resets all properties to the defaults specified in TextStyle.prototype._default */
  reset() {
    gu(this, Qs.defaultStyle, Qs.defaultStyle);
  }
  /**
   * Alignment for multiline text, does not affect single line text.
   *
   * @member {'left'|'center'|'right'|'justify'}
   */
  get align() {
    return this._align;
  }
  set align(t) {
    this._align !== t && (this._align = t, this.styleID++);
  }
  /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */
  get breakWords() {
    return this._breakWords;
  }
  set breakWords(t) {
    this._breakWords !== t && (this._breakWords = t, this.styleID++);
  }
  /** Set a drop shadow for the text. */
  get dropShadow() {
    return this._dropShadow;
  }
  set dropShadow(t) {
    this._dropShadow !== t && (this._dropShadow = t, this.styleID++);
  }
  /** Set alpha for the drop shadow. */
  get dropShadowAlpha() {
    return this._dropShadowAlpha;
  }
  set dropShadowAlpha(t) {
    this._dropShadowAlpha !== t && (this._dropShadowAlpha = t, this.styleID++);
  }
  /** Set a angle of the drop shadow. */
  get dropShadowAngle() {
    return this._dropShadowAngle;
  }
  set dropShadowAngle(t) {
    this._dropShadowAngle !== t && (this._dropShadowAngle = t, this.styleID++);
  }
  /** Set a shadow blur radius. */
  get dropShadowBlur() {
    return this._dropShadowBlur;
  }
  set dropShadowBlur(t) {
    this._dropShadowBlur !== t && (this._dropShadowBlur = t, this.styleID++);
  }
  /** A fill style to be used on the dropshadow e.g., 'red', '#00FF00'. */
  get dropShadowColor() {
    return this._dropShadowColor;
  }
  set dropShadowColor(t) {
    const e = mu(t);
    this._dropShadowColor !== e && (this._dropShadowColor = e, this.styleID++);
  }
  /** Set a distance of the drop shadow. */
  get dropShadowDistance() {
    return this._dropShadowDistance;
  }
  set dropShadowDistance(t) {
    this._dropShadowDistance !== t && (this._dropShadowDistance = t, this.styleID++);
  }
  /**
   * A canvas fillstyle that will be used on the text e.g., 'red', '#00FF00'.
   *
   * Can be an array to create a gradient e.g., `['#000000','#FFFFFF']`
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
   *
   * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */
  get fill() {
    return this._fill;
  }
  set fill(t) {
    const e = mu(t);
    this._fill !== e && (this._fill = e, this.styleID++);
  }
  /**
   * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
   *
   * @type {PIXI.TEXT_GRADIENT}
   */
  get fillGradientType() {
    return this._fillGradientType;
  }
  set fillGradientType(t) {
    this._fillGradientType !== t && (this._fillGradientType = t, this.styleID++);
  }
  /**
   * If fill is an array of colours to create a gradient, this array can set the stop points
   * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
   */
  get fillGradientStops() {
    return this._fillGradientStops;
  }
  set fillGradientStops(t) {
    xT(this._fillGradientStops, t) || (this._fillGradientStops = t, this.styleID++);
  }
  /**
   * The font family, can be a single font name, or a list of names where the first
   * is the preferred font.
   */
  get fontFamily() {
    return this._fontFamily;
  }
  set fontFamily(t) {
    this.fontFamily !== t && (this._fontFamily = t, this.styleID++);
  }
  /**
   * The font size
   * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
   */
  get fontSize() {
    return this._fontSize;
  }
  set fontSize(t) {
    this._fontSize !== t && (this._fontSize = t, this.styleID++);
  }
  /**
   * The font style.
   *
   * @member {'normal'|'italic'|'oblique'}
   */
  get fontStyle() {
    return this._fontStyle;
  }
  set fontStyle(t) {
    this._fontStyle !== t && (this._fontStyle = t, this.styleID++);
  }
  /**
   * The font variant.
   *
   * @member {'normal'|'small-caps'}
   */
  get fontVariant() {
    return this._fontVariant;
  }
  set fontVariant(t) {
    this._fontVariant !== t && (this._fontVariant = t, this.styleID++);
  }
  /**
   * The font weight.
   *
   * @member {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */
  get fontWeight() {
    return this._fontWeight;
  }
  set fontWeight(t) {
    this._fontWeight !== t && (this._fontWeight = t, this.styleID++);
  }
  /** The amount of spacing between letters, default is 0. */
  get letterSpacing() {
    return this._letterSpacing;
  }
  set letterSpacing(t) {
    this._letterSpacing !== t && (this._letterSpacing = t, this.styleID++);
  }
  /** The line height, a number that represents the vertical space that a letter uses. */
  get lineHeight() {
    return this._lineHeight;
  }
  set lineHeight(t) {
    this._lineHeight !== t && (this._lineHeight = t, this.styleID++);
  }
  /** The space between lines. */
  get leading() {
    return this._leading;
  }
  set leading(t) {
    this._leading !== t && (this._leading = t, this.styleID++);
  }
  /**
   * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
   * Default is 'miter' (creates a sharp corner).
   *
   * @member {'miter'|'round'|'bevel'}
   */
  get lineJoin() {
    return this._lineJoin;
  }
  set lineJoin(t) {
    this._lineJoin !== t && (this._lineJoin = t, this.styleID++);
  }
  /**
   * The miter limit to use when using the 'miter' lineJoin mode.
   *
   * This can reduce or increase the spikiness of rendered text.
   */
  get miterLimit() {
    return this._miterLimit;
  }
  set miterLimit(t) {
    this._miterLimit !== t && (this._miterLimit = t, this.styleID++);
  }
  /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   */
  get padding() {
    return this._padding;
  }
  set padding(t) {
    this._padding !== t && (this._padding = t, this.styleID++);
  }
  /**
   * A canvas fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'
   */
  get stroke() {
    return this._stroke;
  }
  set stroke(t) {
    const e = mu(t);
    this._stroke !== e && (this._stroke = e, this.styleID++);
  }
  /**
   * A number that represents the thickness of the stroke.
   *
   * @default 0
   */
  get strokeThickness() {
    return this._strokeThickness;
  }
  set strokeThickness(t) {
    this._strokeThickness !== t && (this._strokeThickness = t, this.styleID++);
  }
  /**
   * The baseline of the text that is rendered.
   *
   * @member {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */
  get textBaseline() {
    return this._textBaseline;
  }
  set textBaseline(t) {
    this._textBaseline !== t && (this._textBaseline = t, this.styleID++);
  }
  /** Trim transparent borders. */
  get trim() {
    return this._trim;
  }
  set trim(t) {
    this._trim !== t && (this._trim = t, this.styleID++);
  }
  /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   *
   * @member {'normal'|'pre'|'pre-line'}
   */
  get whiteSpace() {
    return this._whiteSpace;
  }
  set whiteSpace(t) {
    this._whiteSpace !== t && (this._whiteSpace = t, this.styleID++);
  }
  /** Indicates if word wrap should be used. */
  get wordWrap() {
    return this._wordWrap;
  }
  set wordWrap(t) {
    this._wordWrap !== t && (this._wordWrap = t, this.styleID++);
  }
  /** The width at which text will wrap, it needs wordWrap to be set to true. */
  get wordWrapWidth() {
    return this._wordWrapWidth;
  }
  set wordWrapWidth(t) {
    this._wordWrapWidth !== t && (this._wordWrapWidth = t, this.styleID++);
  }
  /**
   * Generates a font style string to use for `TextMetrics.measureFont()`.
   *
   * @return Font style string, for passing to `TextMetrics.measureFont()`
   */
  toFontString() {
    const t = typeof this.fontSize == "number" ? `${this.fontSize}px` : this.fontSize;
    let e = this.fontFamily;
    Array.isArray(this.fontFamily) || (e = this.fontFamily.split(","));
    for (let r = e.length - 1; r >= 0; r--) {
      let i = e[r].trim();
      !/([\"\'])[^\'\"]+\1/.test(i) && !vT.includes(i) && (i = `"${i}"`), e[r] = i;
    }
    return `${this.fontStyle} ${this.fontVariant} ${this.fontWeight} ${t} ${e.join(",")}`;
  }
};
J0.defaultStyle = {
  /**
   * See {@link PIXI.TextStyle.align}
   * @type {'left'|'center'|'right'|'justify'}
   */
  align: "left",
  /** See {@link PIXI.TextStyle.breakWords} */
  breakWords: !1,
  /** See {@link PIXI.TextStyle.dropShadow} */
  dropShadow: !1,
  /** See {@link PIXI.TextStyle.dropShadowAlpha} */
  dropShadowAlpha: 1,
  /**
   * See {@link PIXI.TextStyle.dropShadowAngle}
   * @type {number}
   * @default Math.PI / 6
   */
  dropShadowAngle: Math.PI / 6,
  /** See {@link PIXI.TextStyle.dropShadowBlur} */
  dropShadowBlur: 0,
  /**
   * See {@link PIXI.TextStyle.dropShadowColor}
   * @type {string|number}
   */
  dropShadowColor: "black",
  /** See {@link PIXI.TextStyle.dropShadowDistance} */
  dropShadowDistance: 5,
  /**
   * See {@link PIXI.TextStyle.fill}
   * @type {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */
  fill: "black",
  /**
   * See {@link PIXI.TextStyle.fillGradientType}
   * @type {PIXI.TEXT_GRADIENT}
   * @default PIXI.TEXT_GRADIENT.LINEAR_VERTICAL
   */
  fillGradientType: Oh.LINEAR_VERTICAL,
  /**
   * See {@link PIXI.TextStyle.fillGradientStops}
   * @type {number[]}
   * @default []
   */
  fillGradientStops: [],
  /**
   * See {@link PIXI.TextStyle.fontFamily}
   * @type {string|string[]}
   */
  fontFamily: "Arial",
  /**
   * See {@link PIXI.TextStyle.fontSize}
   * @type {number|string} 
   */
  fontSize: 26,
  /**
   * See {@link PIXI.TextStyle.fontStyle}
   * @type {'normal'|'italic'|'oblique'}
   */
  fontStyle: "normal",
  /**
   * See {@link PIXI.TextStyle.fontVariant}
   * @type {'normal'|'small-caps'}
   */
  fontVariant: "normal",
  /**
   * See {@link PIXI.TextStyle.fontWeight}
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */
  fontWeight: "normal",
  /** See {@link PIXI.TextStyle.leading} */
  leading: 0,
  /** See {@link PIXI.TextStyle.letterSpacing} */
  letterSpacing: 0,
  /** See {@link PIXI.TextStyle.lineHeight} */
  lineHeight: 0,
  /**
   * See {@link PIXI.TextStyle.lineJoin}
   * @type {'miter'|'round'|'bevel'}
   */
  lineJoin: "miter",
  /** See {@link PIXI.TextStyle.miterLimit} */
  miterLimit: 10,
  /** See {@link PIXI.TextStyle.padding} */
  padding: 0,
  /**
   * See {@link PIXI.TextStyle.stroke}
   * @type {string|number}
   */
  stroke: "black",
  /** See {@link PIXI.TextStyle.strokeThickness} */
  strokeThickness: 0,
  /**
   * See {@link PIXI.TextStyle.textBaseline} 
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */
  textBaseline: "alphabetic",
  /** See {@link PIXI.TextStyle.trim} */
  trim: !1,
  /**
   * See {@link PIXI.TextStyle.whiteSpace}
   * @type {'normal'|'pre'|'pre-line'}
   */
  whiteSpace: "pre",
  /** See {@link PIXI.TextStyle.wordWrap} */
  wordWrap: !1,
  /** See {@link PIXI.TextStyle.wordWrapWidth} */
  wordWrapWidth: 100
};
let Hn = J0;
function mu(n) {
  const t = Ot.shared, e = (r) => {
    const i = t.setValue(r);
    return i.alpha === 1 ? i.toHex() : i.toRgbaString();
  };
  return Array.isArray(n) ? n.map(e) : e(n);
}
function xT(n, t) {
  if (!Array.isArray(n) || !Array.isArray(t) || n.length !== t.length)
    return !1;
  for (let e = 0; e < n.length; ++e)
    if (n[e] !== t[e])
      return !1;
  return !0;
}
function gu(n, t, e) {
  for (const r in e)
    Array.isArray(t[r]) ? n[r] = t[r].slice() : n[r] = t[r];
}
const wT = {
  texture: !0,
  children: !1,
  baseTexture: !0
}, ty = class xc extends jt {
  /**
   * @param text - The string that you would like the text to display
   * @param style - The style parameters
   * @param canvas - The canvas element for drawing text
   */
  constructor(t, e, r) {
    let i = !1;
    r || (r = ht.ADAPTER.createCanvas(), i = !0), r.width = 3, r.height = 3;
    const s = ct.from(r);
    s.orig = new yt(), s.trim = new yt(), super(s), this._ownCanvas = i, this.canvas = r, this.context = r.getContext("2d", {
      // required for trimming to work without warnings
      willReadFrequently: !0
    }), this._resolution = xc.defaultResolution ?? ht.RESOLUTION, this._autoResolution = xc.defaultAutoResolution, this._text = null, this._style = null, this._styleListener = null, this._font = "", this.text = t, this.style = e, this.localStyleID = -1;
  }
  /**
   * @see PIXI.TextMetrics.experimentalLetterSpacing
   * @deprecated since 7.1.0
   */
  static get experimentalLetterSpacing() {
    return An.experimentalLetterSpacing;
  }
  static set experimentalLetterSpacing(t) {
    wt(
      "7.1.0",
      "Text.experimentalLetterSpacing is deprecated, use TextMetrics.experimentalLetterSpacing"
    ), An.experimentalLetterSpacing = t;
  }
  /**
   * Renders text to its canvas, and updates its texture.
   *
   * By default this is used internally to ensure the texture is correct before rendering,
   * but it can be used called externally, for example from this class to 'pre-generate' the texture from a piece of text,
   * and then shared across multiple Sprites.
   * @param respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
   */
  updateText(t) {
    const e = this._style;
    if (this.localStyleID !== e.styleID && (this.dirty = !0, this.localStyleID = e.styleID), !this.dirty && t)
      return;
    this._font = this._style.toFontString();
    const r = this.context, i = An.measureText(this._text || " ", this._style, this._style.wordWrap, this.canvas), s = i.width, o = i.height, a = i.lines, h = i.lineHeight, l = i.lineWidths, u = i.maxLineWidth, c = i.fontProperties;
    this.canvas.width = Math.ceil(Math.ceil(Math.max(1, s) + e.padding * 2) * this._resolution), this.canvas.height = Math.ceil(Math.ceil(Math.max(1, o) + e.padding * 2) * this._resolution), r.scale(this._resolution, this._resolution), r.clearRect(0, 0, this.canvas.width, this.canvas.height), r.font = this._font, r.lineWidth = e.strokeThickness, r.textBaseline = e.textBaseline, r.lineJoin = e.lineJoin, r.miterLimit = e.miterLimit;
    let d, f;
    const p = e.dropShadow ? 2 : 1;
    for (let m = 0; m < p; ++m) {
      const g = e.dropShadow && m === 0, _ = g ? Math.ceil(Math.max(1, o) + e.padding * 2) : 0, w = _ * this._resolution;
      if (g) {
        r.fillStyle = "black", r.strokeStyle = "black";
        const E = e.dropShadowColor, x = e.dropShadowBlur * this._resolution, b = e.dropShadowDistance * this._resolution;
        r.shadowColor = Ot.shared.setValue(E).setAlpha(e.dropShadowAlpha).toRgbaString(), r.shadowBlur = x, r.shadowOffsetX = Math.cos(e.dropShadowAngle) * b, r.shadowOffsetY = Math.sin(e.dropShadowAngle) * b + w;
      } else
        r.fillStyle = this._generateFillStyle(e, a, i), r.strokeStyle = e.stroke, r.shadowColor = "black", r.shadowBlur = 0, r.shadowOffsetX = 0, r.shadowOffsetY = 0;
      let v = (h - c.fontSize) / 2;
      h - c.fontSize < 0 && (v = 0);
      for (let E = 0; E < a.length; E++)
        d = e.strokeThickness / 2, f = e.strokeThickness / 2 + E * h + c.ascent + v, e.align === "right" ? d += u - l[E] : e.align === "center" && (d += (u - l[E]) / 2), e.stroke && e.strokeThickness && this.drawLetterSpacing(
          a[E],
          d + e.padding,
          f + e.padding - _,
          !0
        ), e.fill && this.drawLetterSpacing(
          a[E],
          d + e.padding,
          f + e.padding - _
        );
    }
    this.updateTexture();
  }
  /**
   * Render the text with letter-spacing.
   * @param text - The text to draw
   * @param x - Horizontal position to draw the text
   * @param y - Vertical position to draw the text
   * @param isStroke - Is this drawing for the outside stroke of the
   *  text? If not, it's for the inside fill
   */
  drawLetterSpacing(t, e, r, i = !1) {
    const s = this._style.letterSpacing;
    let o = !1;
    if (An.experimentalLetterSpacingSupported && (An.experimentalLetterSpacing ? (this.context.letterSpacing = `${s}px`, this.context.textLetterSpacing = `${s}px`, o = !0) : (this.context.letterSpacing = "0px", this.context.textLetterSpacing = "0px")), s === 0 || o) {
      i ? this.context.strokeText(t, e, r) : this.context.fillText(t, e, r);
      return;
    }
    let a = e;
    const h = An.graphemeSegmenter(t);
    let l = this.context.measureText(t).width, u = 0;
    for (let c = 0; c < h.length; ++c) {
      const d = h[c];
      i ? this.context.strokeText(d, a, r) : this.context.fillText(d, a, r);
      let f = "";
      for (let p = c + 1; p < h.length; ++p)
        f += h[p];
      u = this.context.measureText(f).width, a += l - u + s, l = u;
    }
  }
  /** Updates texture size based on canvas size. */
  updateTexture() {
    const t = this.canvas;
    if (this._style.trim) {
      const o = zx(t);
      o.data && (t.width = o.width, t.height = o.height, this.context.putImageData(o.data, 0, 0));
    }
    const e = this._texture, r = this._style, i = r.trim ? 0 : r.padding, s = e.baseTexture;
    e.trim.width = e._frame.width = t.width / this._resolution, e.trim.height = e._frame.height = t.height / this._resolution, e.trim.x = -i, e.trim.y = -i, e.orig.width = e._frame.width - i * 2, e.orig.height = e._frame.height - i * 2, this._onTextureUpdate(), s.setRealSize(t.width, t.height, this._resolution), e.updateUvs(), this.dirty = !1;
  }
  /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */
  _render(t) {
    this._autoResolution && this._resolution !== t.resolution && (this._resolution = t.resolution, this.dirty = !0), this.updateText(!0), super._render(t);
  }
  /** Updates the transform on all children of this container for rendering. */
  updateTransform() {
    this.updateText(!0), super.updateTransform();
  }
  getBounds(t, e) {
    return this.updateText(!0), this._textureID === -1 && (t = !1), super.getBounds(t, e);
  }
  /**
   * Gets the local bounds of the text object.
   * @param rect - The output rectangle.
   * @returns The bounds.
   */
  getLocalBounds(t) {
    return this.updateText(!0), super.getLocalBounds.call(this, t);
  }
  /** Calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account. */
  _calculateBounds() {
    this.calculateVertices(), this._bounds.addQuad(this.vertexData);
  }
  /**
   * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
   * @param style - The style.
   * @param lines - The lines of text.
   * @param metrics
   * @returns The fill style
   */
  _generateFillStyle(t, e, r) {
    const i = t.fill;
    if (Array.isArray(i)) {
      if (i.length === 1)
        return i[0];
    } else
      return i;
    let s;
    const o = t.dropShadow ? t.dropShadowDistance : 0, a = t.padding || 0, h = this.canvas.width / this._resolution - o - a * 2, l = this.canvas.height / this._resolution - o - a * 2, u = i.slice(), c = t.fillGradientStops.slice();
    if (!c.length) {
      const d = u.length + 1;
      for (let f = 1; f < d; ++f)
        c.push(f / d);
    }
    if (u.unshift(i[0]), c.unshift(0), u.push(i[i.length - 1]), c.push(1), t.fillGradientType === Oh.LINEAR_VERTICAL) {
      s = this.context.createLinearGradient(h / 2, a, h / 2, l + a);
      const d = r.fontProperties.fontSize + t.strokeThickness;
      for (let f = 0; f < e.length; f++) {
        const p = r.lineHeight * (f - 1) + d, m = r.lineHeight * f;
        let g = m;
        f > 0 && p > m && (g = (m + p) / 2);
        const _ = m + d, w = r.lineHeight * (f + 1);
        let v = _;
        f + 1 < e.length && w < _ && (v = (_ + w) / 2);
        const E = (v - g) / l;
        for (let x = 0; x < u.length; x++) {
          let b = 0;
          typeof c[x] == "number" ? b = c[x] : b = x / u.length;
          let y = Math.min(1, Math.max(
            0,
            g / l + b * E
          ));
          y = Number(y.toFixed(5)), s.addColorStop(y, u[x]);
        }
      }
    } else {
      s = this.context.createLinearGradient(a, l / 2, h + a, l / 2);
      const d = u.length + 1;
      let f = 1;
      for (let p = 0; p < u.length; p++) {
        let m;
        typeof c[p] == "number" ? m = c[p] : m = f / d, s.addColorStop(m, u[p]), f++;
      }
    }
    return s;
  }
  /**
   * Destroys this text object.
   *
   * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
   * the majority of the time the texture will not be shared with any other Sprites.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their
   *  destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
   * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
   */
  destroy(t) {
    typeof t == "boolean" && (t = { children: t }), t = Object.assign({}, wT, t), super.destroy(t), this._ownCanvas && (this.canvas.height = this.canvas.width = 0), this.context = null, this.canvas = null, this._style = null;
  }
  /** The width of the Text, setting this will actually modify the scale to achieve the value set. */
  get width() {
    return this.updateText(!0), Math.abs(this.scale.x) * this._texture.orig.width;
  }
  set width(t) {
    this.updateText(!0);
    const e = Cn(this.scale.x) || 1;
    this.scale.x = e * t / this._texture.orig.width, this._width = t;
  }
  /** The height of the Text, setting this will actually modify the scale to achieve the value set. */
  get height() {
    return this.updateText(!0), Math.abs(this.scale.y) * this._texture.orig.height;
  }
  set height(t) {
    this.updateText(!0);
    const e = Cn(this.scale.y) || 1;
    this.scale.y = e * t / this._texture.orig.height, this._height = t;
  }
  /**
   * Set the style of the text.
   *
   * Set up an event listener to listen for changes on the style object and mark the text as dirty.
   *
   * If setting the `style` can also be partial {@link PIXI.ITextStyle}.
   */
  get style() {
    return this._style;
  }
  set style(t) {
    t = t || {}, t instanceof Hn ? this._style = t : this._style = new Hn(t), this.localStyleID = -1, this.dirty = !0;
  }
  /** Set the copy for the text object. To split a line you can use '\n'. */
  get text() {
    return this._text;
  }
  set text(t) {
    t = String(t ?? ""), this._text !== t && (this._text = t, this.dirty = !0);
  }
  /**
   * The resolution / device pixel ratio of the canvas.
   *
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @default 1
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(t) {
    this._autoResolution = !1, this._resolution !== t && (this._resolution = t, this.dirty = !0);
  }
};
ty.defaultAutoResolution = !0;
let ey = ty;
class bT {
  /**
   * @param maxItemsPerFrame - The maximum number of items that can be prepared each frame.
   */
  constructor(t) {
    this.maxItemsPerFrame = t, this.itemsLeft = 0;
  }
  /** Resets any counting properties to start fresh on a new frame. */
  beginFrame() {
    this.itemsLeft = this.maxItemsPerFrame;
  }
  /**
   * Checks to see if another item can be uploaded. This should only be called once per item.
   * @returns If the item is allowed to be uploaded.
   */
  allowedToUpload() {
    return this.itemsLeft-- > 0;
  }
}
function TT(n, t) {
  let e = !1;
  if (n?._textures?.length) {
    for (let r = 0; r < n._textures.length; r++)
      if (n._textures[r] instanceof ct) {
        const i = n._textures[r].baseTexture;
        t.includes(i) || (t.push(i), e = !0);
      }
  }
  return e;
}
function AT(n, t) {
  if (n.baseTexture instanceof _t) {
    const e = n.baseTexture;
    return t.includes(e) || t.push(e), !0;
  }
  return !1;
}
function ET(n, t) {
  if (n._texture && n._texture instanceof ct) {
    const e = n._texture.baseTexture;
    return t.includes(e) || t.push(e), !0;
  }
  return !1;
}
function ST(n, t) {
  return t instanceof ey ? (t.updateText(!0), !0) : !1;
}
function CT(n, t) {
  if (t instanceof Hn) {
    const e = t.toFontString();
    return An.measureFont(e), !0;
  }
  return !1;
}
function MT(n, t) {
  if (n instanceof ey) {
    t.includes(n.style) || t.push(n.style), t.includes(n) || t.push(n);
    const e = n._texture.baseTexture;
    return t.includes(e) || t.push(e), !0;
  }
  return !1;
}
function IT(n, t) {
  return n instanceof Hn ? (t.includes(n) || t.push(n), !0) : !1;
}
const ry = class ny {
  /**
   * @param {PIXI.IRenderer} renderer - A reference to the current renderer
   */
  constructor(t) {
    this.limiter = new bT(ny.uploadsPerFrame), this.renderer = t, this.uploadHookHelper = null, this.queue = [], this.addHooks = [], this.uploadHooks = [], this.completes = [], this.ticking = !1, this.delayedTick = () => {
      this.queue && this.prepareItems();
    }, this.registerFindHook(MT), this.registerFindHook(IT), this.registerFindHook(TT), this.registerFindHook(AT), this.registerFindHook(ET), this.registerUploadHook(ST), this.registerUploadHook(CT);
  }
  /**
   * Upload all the textures and graphics to the GPU.
   * @method PIXI.BasePrepare#upload
   * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} [item] -
   *        Container or display object to search for items to upload or the items to upload themselves,
   *        or optionally ommitted, if items have been added using {@link PIXI.BasePrepare#add `prepare.add`}.
   */
  upload(t) {
    return new Promise((e) => {
      t && this.add(t), this.queue.length ? (this.completes.push(e), this.ticking || (this.ticking = !0, xe.system.addOnce(this.tick, this, Ai.UTILITY))) : e();
    });
  }
  /**
   * Handle tick update
   * @private
   */
  tick() {
    setTimeout(this.delayedTick, 0);
  }
  /**
   * Actually prepare items. This is handled outside of the tick because it will take a while
   * and we do NOT want to block the current animation frame from rendering.
   * @private
   */
  prepareItems() {
    for (this.limiter.beginFrame(); this.queue.length && this.limiter.allowedToUpload(); ) {
      const t = this.queue[0];
      let e = !1;
      if (t && !t._destroyed) {
        for (let r = 0, i = this.uploadHooks.length; r < i; r++)
          if (this.uploadHooks[r](this.uploadHookHelper, t)) {
            this.queue.shift(), e = !0;
            break;
          }
      }
      e || this.queue.shift();
    }
    if (this.queue.length)
      xe.system.addOnce(this.tick, this, Ai.UTILITY);
    else {
      this.ticking = !1;
      const t = this.completes.slice(0);
      this.completes.length = 0;
      for (let e = 0, r = t.length; e < r; e++)
        t[e]();
    }
  }
  /**
   * Adds hooks for finding items.
   * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
   *          function must return `true` if it was able to add item to the queue.
   * @returns Instance of plugin for chaining.
   */
  registerFindHook(t) {
    return t && this.addHooks.push(t), this;
  }
  /**
   * Adds hooks for uploading items.
   * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
   *          function must return `true` if it was able to handle upload of item.
   * @returns Instance of plugin for chaining.
   */
  registerUploadHook(t) {
    return t && this.uploadHooks.push(t), this;
  }
  /**
   * Manually add an item to the uploading queue.
   * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
   *        add to the queue
   * @returns Instance of plugin for chaining.
   */
  add(t) {
    for (let e = 0, r = this.addHooks.length; e < r && !this.addHooks[e](t, this.queue); e++)
      ;
    if (t instanceof bt)
      for (let e = t.children.length - 1; e >= 0; e--)
        this.add(t.children[e]);
    return this;
  }
  /** Destroys the plugin, don't use after this. */
  destroy() {
    this.ticking && xe.system.remove(this.tick, this), this.ticking = !1, this.addHooks = null, this.uploadHooks = null, this.renderer = null, this.completes = null, this.queue = null, this.limiter = null, this.uploadHookHelper = null;
  }
};
ry.uploadsPerFrame = 4;
let wc = ry;
Object.defineProperties(ht, {
  /**
   * Default number of uploads per frame using prepare plugin.
   * @static
   * @memberof PIXI.settings
   * @name UPLOADS_PER_FRAME
   * @deprecated since 7.1.0
   * @see PIXI.BasePrepare.uploadsPerFrame
   * @type {number}
   */
  UPLOADS_PER_FRAME: {
    get() {
      return wc.uploadsPerFrame;
    },
    set(n) {
      wt("7.1.0", "settings.UPLOADS_PER_FRAME is deprecated, use prepare.BasePrepare.uploadsPerFrame"), wc.uploadsPerFrame = n;
    }
  }
});
function iy(n, t) {
  return t instanceof _t ? (t._glTextures[n.CONTEXT_UID] || n.texture.bind(t), !0) : !1;
}
function PT(n, t) {
  if (!(t instanceof Un))
    return !1;
  const { geometry: e } = t;
  t.finishPoly(), e.updateBatches();
  const { batches: r } = e;
  for (let i = 0; i < r.length; i++) {
    const { texture: s } = r[i].style;
    s && iy(n, s.baseTexture);
  }
  return e.batchable || n.geometry.bind(e, t._resolveDirectShader(n)), !0;
}
function RT(n, t) {
  return n instanceof Un ? (t.push(n), !0) : !1;
}
class sy extends wc {
  /**
   * @param {PIXI.Renderer} renderer - A reference to the current renderer
   */
  constructor(t) {
    super(t), this.uploadHookHelper = this.renderer, this.registerFindHook(RT), this.registerUploadHook(iy), this.registerUploadHook(PT);
  }
}
sy.extension = {
  name: "prepare",
  type: st.RendererSystem
};
dt.add(sy);
var DT = `#version 300 es
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

in vec2 vTextureCoord;

out vec4 fragmentColor;

uniform sampler2D uSampler;
uniform vec4 uColor;
uniform mat3 uMapCoord;
uniform vec4 uClampFrame;
uniform vec2 uClampOffset;

void main(void)
{
    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);
    coord = (uMapCoord * vec3(coord, 1.0)).xy;
    vec2 unclamped = coord;
    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

    vec4 texSample = texture(uSampler, coord, unclamped == coord ? 0.0f : -32.0f);// lod-bias very negative to force lod 0

    fragmentColor = texSample * uColor;
}
`, FT = `#version 300 es
#define SHADER_NAME Tiling-Sprite-300

precision lowp float;

in vec2 aVertexPosition;
in vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTransform;

out vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;
}
`, OT = `#version 100
#ifdef GL_EXT_shader_texture_lod
    #extension GL_EXT_shader_texture_lod : enable
#endif
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 uColor;
uniform mat3 uMapCoord;
uniform vec4 uClampFrame;
uniform vec2 uClampOffset;

void main(void)
{
    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);
    coord = (uMapCoord * vec3(coord, 1.0)).xy;
    vec2 unclamped = coord;
    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

    #ifdef GL_EXT_shader_texture_lod
        vec4 texSample = unclamped == coord
            ? texture2D(uSampler, coord) 
            : texture2DLodEXT(uSampler, coord, 0);
    #else
        vec4 texSample = texture2D(uSampler, coord);
    #endif

    gl_FragColor = texSample * uColor;
}
`, lm = `#version 100
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTransform;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;
}
`, NT = `#version 100
#define SHADER_NAME Tiling-Sprite-Simple-100

precision lowp float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 uColor;

void main(void)
{
    vec4 texSample = texture2D(uSampler, vTextureCoord);
    gl_FragColor = texSample * uColor;
}
`;
const ma = new Nt();
class oy extends Rh {
  /**
   * constructor for renderer
   * @param {PIXI.Renderer} renderer - The renderer this tiling awesomeness works for.
   */
  constructor(t) {
    super(t), t.runners.contextChange.add(this), this.quad = new l0(), this.state = Hr.for2d();
  }
  /** Creates shaders when context is initialized. */
  contextChange() {
    const t = this.renderer, e = { globals: t.globalUniforms };
    this.simpleShader = Or.from(lm, NT, e), this.shader = t.context.webGLVersion > 1 ? Or.from(FT, DT, e) : Or.from(lm, OT, e);
  }
  /**
   * @param {PIXI.TilingSprite} ts - tilingSprite to be rendered
   */
  render(t) {
    const e = this.renderer, r = this.quad;
    let i = r.vertices;
    i[0] = i[6] = t._width * -t.anchor.x, i[1] = i[3] = t._height * -t.anchor.y, i[2] = i[4] = t._width * (1 - t.anchor.x), i[5] = i[7] = t._height * (1 - t.anchor.y);
    const s = t.uvRespectAnchor ? t.anchor.x : 0, o = t.uvRespectAnchor ? t.anchor.y : 0;
    i = r.uvs, i[0] = i[6] = -s, i[1] = i[3] = -o, i[2] = i[4] = 1 - s, i[5] = i[7] = 1 - o, r.invalidate();
    const a = t._texture, h = a.baseTexture, l = h.alphaMode > 0, u = t.tileTransform.localTransform, c = t.uvMatrix;
    let d = h.isPowerOfTwo && a.frame.width === h.width && a.frame.height === h.height;
    d && (h._glTextures[e.CONTEXT_UID] ? d = h.wrapMode !== Dr.CLAMP : h.wrapMode === Dr.CLAMP && (h.wrapMode = Dr.REPEAT));
    const f = d ? this.simpleShader : this.shader, p = a.width, m = a.height, g = t._width, _ = t._height;
    ma.set(
      u.a * p / g,
      u.b * p / _,
      u.c * m / g,
      u.d * m / _,
      u.tx / g,
      u.ty / _
    ), ma.invert(), d ? ma.prepend(c.mapCoord) : (f.uniforms.uMapCoord = c.mapCoord.toArray(!0), f.uniforms.uClampFrame = c.uClampFrame, f.uniforms.uClampOffset = c.uClampOffset), f.uniforms.uTransform = ma.toArray(!0), f.uniforms.uColor = Ot.shared.setValue(t.tint).premultiply(t.worldAlpha, l).toArray(f.uniforms.uColor), f.uniforms.translationMatrix = t.transform.worldTransform.toArray(!0), f.uniforms.uSampler = a, e.shader.bind(f), e.geometry.bind(r), this.state.blendMode = Zg(t.blendMode, l), e.state.set(this.state), e.geometry.draw(this.renderer.gl.TRIANGLES, 6, 0);
  }
}
oy.extension = {
  name: "tilingSprite",
  type: st.RendererPlugin
};
dt.add(oy);
const ay = class Js {
  /**
   * @param texture - Reference to the source BaseTexture object.
   * @param {object} data - Spritesheet image data.
   * @param resolutionFilename - The filename to consider when determining
   *        the resolution of the spritesheet. If not provided, the imageUrl will
   *        be used on the BaseTexture.
   */
  constructor(t, e, r = null) {
    this.linkedSheets = [], this._texture = t instanceof ct ? t : null, this.baseTexture = t instanceof _t ? t : this._texture.baseTexture, this.textures = {}, this.animations = {}, this.data = e;
    const i = this.baseTexture.resource;
    this.resolution = this._updateResolution(r || (i ? i.url : null)), this._frames = this.data.frames, this._frameKeys = Object.keys(this._frames), this._batchIndex = 0, this._callback = null;
  }
  /**
   * Generate the resolution from the filename or fallback
   * to the meta.scale field of the JSON data.
   * @param resolutionFilename - The filename to use for resolving
   *        the default resolution.
   * @returns Resolution to use for spritesheet.
   */
  _updateResolution(t = null) {
    const { scale: e } = this.data.meta;
    let r = sn(t, null);
    return r === null && (r = parseFloat(e ?? "1")), r !== 1 && this.baseTexture.setResolution(r), r;
  }
  /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   * @method PIXI.Spritesheet#parse
   */
  parse() {
    return new Promise((t) => {
      this._callback = t, this._batchIndex = 0, this._frameKeys.length <= Js.BATCH_SIZE ? (this._processFrames(0), this._processAnimations(), this._parseComplete()) : this._nextBatch();
    });
  }
  /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */
  _processFrames(t) {
    let e = t;
    const r = Js.BATCH_SIZE;
    for (; e - t < r && e < this._frameKeys.length; ) {
      const i = this._frameKeys[e], s = this._frames[i], o = s.frame;
      if (o) {
        let a = null, h = null;
        const l = s.trimmed !== !1 && s.sourceSize ? s.sourceSize : s.frame, u = new yt(
          0,
          0,
          Math.floor(l.w) / this.resolution,
          Math.floor(l.h) / this.resolution
        );
        s.rotated ? a = new yt(
          Math.floor(o.x) / this.resolution,
          Math.floor(o.y) / this.resolution,
          Math.floor(o.h) / this.resolution,
          Math.floor(o.w) / this.resolution
        ) : a = new yt(
          Math.floor(o.x) / this.resolution,
          Math.floor(o.y) / this.resolution,
          Math.floor(o.w) / this.resolution,
          Math.floor(o.h) / this.resolution
        ), s.trimmed !== !1 && s.spriteSourceSize && (h = new yt(
          Math.floor(s.spriteSourceSize.x) / this.resolution,
          Math.floor(s.spriteSourceSize.y) / this.resolution,
          Math.floor(o.w) / this.resolution,
          Math.floor(o.h) / this.resolution
        )), this.textures[i] = new ct(
          this.baseTexture,
          a,
          u,
          h,
          s.rotated ? 2 : 0,
          s.anchor,
          s.borders
        ), ct.addToCache(this.textures[i], i.toString());
      }
      e++;
    }
  }
  /** Parse animations config. */
  _processAnimations() {
    const t = this.data.animations || {};
    for (const e in t) {
      this.animations[e] = [];
      for (let r = 0; r < t[e].length; r++) {
        const i = t[e][r];
        this.animations[e].push(this.textures[i]);
      }
    }
  }
  /** The parse has completed. */
  _parseComplete() {
    const t = this._callback;
    this._callback = null, this._batchIndex = 0, t.call(this, this.textures);
  }
  /** Begin the next batch of textures. */
  _nextBatch() {
    this._processFrames(this._batchIndex * Js.BATCH_SIZE), this._batchIndex++, setTimeout(() => {
      this._batchIndex * Js.BATCH_SIZE < this._frameKeys.length ? this._nextBatch() : (this._processAnimations(), this._parseComplete());
    }, 0);
  }
  /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */
  destroy(t = !1) {
    for (const e in this.textures)
      this.textures[e].destroy();
    this._frames = null, this._frameKeys = null, this.data = null, this.textures = null, t && (this._texture?.destroy(), this.baseTexture.destroy()), this._texture = null, this.baseTexture = null, this.linkedSheets = [];
  }
};
ay.BATCH_SIZE = 1e3;
let um = ay;
const kT = ["jpg", "png", "jpeg", "avif", "webp"];
function hy(n, t, e) {
  const r = {};
  if (n.forEach((i) => {
    r[i] = t;
  }), Object.keys(t.textures).forEach((i) => {
    r[i] = t.textures[i];
  }), !e) {
    const i = ne.dirname(n[0]);
    t.linkedSheets.forEach((s, o) => {
      const a = hy([`${i}/${t.data.meta.related_multi_packs[o]}`], s, !0);
      Object.assign(r, a);
    });
  }
  return r;
}
const BT = {
  extension: st.Asset,
  /** Handle the caching of the related Spritesheet Textures */
  cache: {
    test: (n) => n instanceof um,
    getCacheableAssets: (n, t) => hy(n, t, !1)
  },
  /** Resolve the the resolution of the asset. */
  resolver: {
    test: (n) => {
      const t = n.split("?")[0].split("."), e = t.pop(), r = t.pop();
      return e === "json" && kT.includes(r);
    },
    parse: (n) => {
      const t = n.split(".");
      return {
        resolution: parseFloat(ht.RETINA_PREFIX.exec(n)?.[1] ?? "1"),
        format: t[t.length - 2],
        src: n
      };
    }
  },
  /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into PIXI.Spritesheet
   * All textures in the sprite sheet are then added to the cache
   * @ignore
   */
  loader: {
    name: "spritesheetLoader",
    extension: {
      type: st.LoadParser,
      priority: yr.Normal
    },
    async testParse(n, t) {
      return ne.extname(t.src).toLowerCase() === ".json" && !!n.frames;
    },
    async parse(n, t, e) {
      let r = ne.dirname(t.src);
      r && r.lastIndexOf("/") !== r.length - 1 && (r += "/");
      let i = r + n.meta.image;
      i = mc(i, t.src);
      const s = (await e.load([i]))[i], o = new um(
        s.baseTexture,
        n,
        t.src
      );
      await o.parse();
      const a = n?.meta?.related_multi_packs;
      if (Array.isArray(a)) {
        const h = [];
        for (const u of a) {
          if (typeof u != "string")
            continue;
          let c = r + u;
          t.data?.ignoreMultiPack || (c = mc(c, t.src), h.push(e.load({
            src: c,
            data: {
              ignoreMultiPack: !0
            }
          })));
        }
        const l = await Promise.all(h);
        o.linkedSheets = l, l.forEach((u) => {
          u.linkedSheets = [o].concat(o.linkedSheets.filter((c) => c !== u));
        });
      }
      return o;
    },
    unload(n) {
      n.destroy(!0);
    }
  }
};
dt.add(BT);
class rh {
  constructor() {
    this.info = [], this.common = [], this.page = [], this.char = [], this.kerning = [], this.distanceField = [];
  }
}
class Ia {
  /**
   * Check if resource refers to txt font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */
  static test(t) {
    return typeof t == "string" && t.startsWith("info face=");
  }
  /**
   * Convert text font data to a javascript object.
   * @param txt - Raw string data to be converted
   * @returns - Parsed font data
   */
  static parse(t) {
    const e = t.match(/^[a-z]+\s+.+$/gm), r = {
      info: [],
      common: [],
      page: [],
      char: [],
      chars: [],
      kerning: [],
      kernings: [],
      distanceField: []
    };
    for (const s in e) {
      const o = e[s].match(/^[a-z]+/gm)[0], a = e[s].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm), h = {};
      for (const l in a) {
        const u = a[l].split("="), c = u[0], d = u[1].replace(/"/gm, ""), f = parseFloat(d), p = isNaN(f) ? d : f;
        h[c] = p;
      }
      r[o].push(h);
    }
    const i = new rh();
    return r.info.forEach((s) => i.info.push({
      face: s.face,
      size: parseInt(s.size, 10)
    })), r.common.forEach((s) => i.common.push({
      lineHeight: parseInt(s.lineHeight, 10)
    })), r.page.forEach((s) => i.page.push({
      id: parseInt(s.id, 10),
      file: s.file
    })), r.char.forEach((s) => i.char.push({
      id: parseInt(s.id, 10),
      page: parseInt(s.page, 10),
      x: parseInt(s.x, 10),
      y: parseInt(s.y, 10),
      width: parseInt(s.width, 10),
      height: parseInt(s.height, 10),
      xoffset: parseInt(s.xoffset, 10),
      yoffset: parseInt(s.yoffset, 10),
      xadvance: parseInt(s.xadvance, 10)
    })), r.kerning.forEach((s) => i.kerning.push({
      first: parseInt(s.first, 10),
      second: parseInt(s.second, 10),
      amount: parseInt(s.amount, 10)
    })), r.distanceField.forEach((s) => i.distanceField.push({
      distanceRange: parseInt(s.distanceRange, 10),
      fieldType: s.fieldType
    })), i;
  }
}
class bc {
  /**
   * Check if resource refers to xml font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */
  static test(t) {
    const e = t;
    return typeof t != "string" && "getElementsByTagName" in t && e.getElementsByTagName("page").length && e.getElementsByTagName("info")[0].getAttribute("face") !== null;
  }
  /**
   * Convert the XML into BitmapFontData that we can use.
   * @param xml
   * @returns - Data to use for BitmapFont
   */
  static parse(t) {
    const e = new rh(), r = t.getElementsByTagName("info"), i = t.getElementsByTagName("common"), s = t.getElementsByTagName("page"), o = t.getElementsByTagName("char"), a = t.getElementsByTagName("kerning"), h = t.getElementsByTagName("distanceField");
    for (let l = 0; l < r.length; l++)
      e.info.push({
        face: r[l].getAttribute("face"),
        size: parseInt(r[l].getAttribute("size"), 10)
      });
    for (let l = 0; l < i.length; l++)
      e.common.push({
        lineHeight: parseInt(i[l].getAttribute("lineHeight"), 10)
      });
    for (let l = 0; l < s.length; l++)
      e.page.push({
        id: parseInt(s[l].getAttribute("id"), 10) || 0,
        file: s[l].getAttribute("file")
      });
    for (let l = 0; l < o.length; l++) {
      const u = o[l];
      e.char.push({
        id: parseInt(u.getAttribute("id"), 10),
        page: parseInt(u.getAttribute("page"), 10) || 0,
        x: parseInt(u.getAttribute("x"), 10),
        y: parseInt(u.getAttribute("y"), 10),
        width: parseInt(u.getAttribute("width"), 10),
        height: parseInt(u.getAttribute("height"), 10),
        xoffset: parseInt(u.getAttribute("xoffset"), 10),
        yoffset: parseInt(u.getAttribute("yoffset"), 10),
        xadvance: parseInt(u.getAttribute("xadvance"), 10)
      });
    }
    for (let l = 0; l < a.length; l++)
      e.kerning.push({
        first: parseInt(a[l].getAttribute("first"), 10),
        second: parseInt(a[l].getAttribute("second"), 10),
        amount: parseInt(a[l].getAttribute("amount"), 10)
      });
    for (let l = 0; l < h.length; l++)
      e.distanceField.push({
        fieldType: h[l].getAttribute("fieldType"),
        distanceRange: parseInt(h[l].getAttribute("distanceRange"), 10)
      });
    return e;
  }
}
class Tc {
  /**
   * Check if resource refers to text xml font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */
  static test(t) {
    return typeof t == "string" && t.includes("<font>") ? bc.test(ht.ADAPTER.parseXML(t)) : !1;
  }
  /**
   * Convert the text XML into BitmapFontData that we can use.
   * @param xmlTxt
   * @returns - Data to use for BitmapFont
   */
  static parse(t) {
    return bc.parse(ht.ADAPTER.parseXML(t));
  }
}
const yu = [
  Ia,
  bc,
  Tc
];
function LT(n) {
  for (let t = 0; t < yu.length; t++)
    if (yu[t].test(n))
      return yu[t];
  return null;
}
function UT(n, t, e, r, i, s) {
  const o = e.fill;
  if (Array.isArray(o)) {
    if (o.length === 1)
      return o[0];
  } else
    return o;
  let a;
  const h = e.dropShadow ? e.dropShadowDistance : 0, l = e.padding || 0, u = n.width / r - h - l * 2, c = n.height / r - h - l * 2, d = o.slice(), f = e.fillGradientStops.slice();
  if (!f.length) {
    const p = d.length + 1;
    for (let m = 1; m < p; ++m)
      f.push(m / p);
  }
  if (d.unshift(o[0]), f.unshift(0), d.push(o[o.length - 1]), f.push(1), e.fillGradientType === Oh.LINEAR_VERTICAL) {
    a = t.createLinearGradient(u / 2, l, u / 2, c + l);
    let p = 0;
    const m = (s.fontProperties.fontSize + e.strokeThickness) / c;
    for (let g = 0; g < i.length; g++) {
      const _ = s.lineHeight * g;
      for (let w = 0; w < d.length; w++) {
        let v = 0;
        typeof f[w] == "number" ? v = f[w] : v = w / d.length;
        const E = _ / c + v * m;
        let x = Math.max(p, E);
        x = Math.min(x, 1), a.addColorStop(x, d[w]), p = x;
      }
    }
  } else {
    a = t.createLinearGradient(l, c / 2, u + l, c / 2);
    const p = d.length + 1;
    let m = 1;
    for (let g = 0; g < d.length; g++) {
      let _;
      typeof f[g] == "number" ? _ = f[g] : _ = m / p, a.addColorStop(_, d[g]), m++;
    }
  }
  return a;
}
function HT(n, t, e, r, i, s, o) {
  const a = e.text, h = e.fontProperties;
  t.translate(r, i), t.scale(s, s);
  const l = o.strokeThickness / 2, u = -(o.strokeThickness / 2);
  if (t.font = o.toFontString(), t.lineWidth = o.strokeThickness, t.textBaseline = o.textBaseline, t.lineJoin = o.lineJoin, t.miterLimit = o.miterLimit, t.fillStyle = UT(n, t, o, s, [a], e), t.strokeStyle = o.stroke, o.dropShadow) {
    const c = o.dropShadowColor, d = o.dropShadowBlur * s, f = o.dropShadowDistance * s;
    t.shadowColor = Ot.shared.setValue(c).setAlpha(o.dropShadowAlpha).toRgbaString(), t.shadowBlur = d, t.shadowOffsetX = Math.cos(o.dropShadowAngle) * f, t.shadowOffsetY = Math.sin(o.dropShadowAngle) * f;
  } else
    t.shadowColor = "black", t.shadowBlur = 0, t.shadowOffsetX = 0, t.shadowOffsetY = 0;
  o.stroke && o.strokeThickness && t.strokeText(a, l, u + e.lineHeight - h.descent), o.fill && t.fillText(a, l, u + e.lineHeight - h.descent), t.setTransform(1, 0, 0, 1, 0, 0), t.fillStyle = "rgba(0, 0, 0, 0)";
}
function Pa(n) {
  return n.codePointAt ? n.codePointAt(0) : n.charCodeAt(0);
}
function ly(n) {
  return Array.from ? Array.from(n) : n.split("");
}
function GT(n) {
  typeof n == "string" && (n = [n]);
  const t = [];
  for (let e = 0, r = n.length; e < r; e++) {
    const i = n[e];
    if (Array.isArray(i)) {
      if (i.length !== 2)
        throw new Error(`[BitmapFont]: Invalid character range length, expecting 2 got ${i.length}.`);
      const s = i[0].charCodeAt(0), o = i[1].charCodeAt(0);
      if (o < s)
        throw new Error("[BitmapFont]: Invalid character range.");
      for (let a = s, h = o; a <= h; a++)
        t.push(String.fromCharCode(a));
    } else
      t.push(...ly(i));
  }
  if (t.length === 0)
    throw new Error("[BitmapFont]: Empty set when resolving characters.");
  return t;
}
const Tn = class Sr {
  /**
   * @param data
   * @param textures
   * @param ownsTextures - Setting to `true` will destroy page textures
   *        when the font is uninstalled.
   */
  constructor(t, e, r) {
    const [i] = t.info, [s] = t.common, [o] = t.page, [a] = t.distanceField, h = sn(o.file), l = {};
    this._ownsTextures = r, this.font = i.face, this.size = i.size, this.lineHeight = s.lineHeight / h, this.chars = {}, this.pageTextures = l;
    for (let u = 0; u < t.page.length; u++) {
      const { id: c, file: d } = t.page[u];
      l[c] = e instanceof Array ? e[u] : e[d], a?.fieldType && a.fieldType !== "none" && (l[c].baseTexture.alphaMode = Ae.NO_PREMULTIPLIED_ALPHA, l[c].baseTexture.mipmap = Lr.OFF);
    }
    for (let u = 0; u < t.char.length; u++) {
      const { id: c, page: d } = t.char[u];
      let { x: f, y: p, width: m, height: g, xoffset: _, yoffset: w, xadvance: v } = t.char[u];
      f /= h, p /= h, m /= h, g /= h, _ /= h, w /= h, v /= h;
      const E = new yt(
        f + l[d].frame.x / h,
        p + l[d].frame.y / h,
        m,
        g
      );
      this.chars[c] = {
        xOffset: _,
        yOffset: w,
        xAdvance: v,
        kerning: {},
        texture: new ct(
          l[d].baseTexture,
          E
        ),
        page: d
      };
    }
    for (let u = 0; u < t.kerning.length; u++) {
      let { first: c, second: d, amount: f } = t.kerning[u];
      c /= h, d /= h, f /= h, this.chars[d] && (this.chars[d].kerning[c] = f);
    }
    this.distanceFieldRange = a?.distanceRange, this.distanceFieldType = a?.fieldType?.toLowerCase() ?? "none";
  }
  /** Remove references to created glyph textures. */
  destroy() {
    for (const t in this.chars)
      this.chars[t].texture.destroy(), this.chars[t].texture = null;
    for (const t in this.pageTextures)
      this._ownsTextures && this.pageTextures[t].destroy(!0), this.pageTextures[t] = null;
    this.chars = null, this.pageTextures = null;
  }
  /**
   * Register a new bitmap font.
   * @param data - The
   *        characters map that could be provided as xml or raw string.
   * @param textures - List of textures for each page.
   * @param ownsTextures - Set to `true` to destroy page textures
   *        when the font is uninstalled. By default fonts created with
   *        `BitmapFont.from` or from the `BitmapFontLoader` are `true`.
   * @returns {PIXI.BitmapFont} Result font object with font, size, lineHeight
   *         and char fields.
   */
  static install(t, e, r) {
    let i;
    if (t instanceof rh)
      i = t;
    else {
      const o = LT(t);
      if (!o)
        throw new Error("Unrecognized data format for font.");
      i = o.parse(t);
    }
    e instanceof ct && (e = [e]);
    const s = new Sr(i, e, r);
    return Sr.available[s.font] = s, s;
  }
  /**
   * Remove bitmap font by name.
   * @param name - Name of the font to uninstall.
   */
  static uninstall(t) {
    const e = Sr.available[t];
    if (!e)
      throw new Error(`No font found named '${t}'`);
    e.destroy(), delete Sr.available[t];
  }
  /**
   * Generates a bitmap-font for the given style and character set. This does not support
   * kernings yet. With `style` properties, only the following non-layout properties are used:
   *
   * - {@link PIXI.TextStyle#dropShadow|dropShadow}
   * - {@link PIXI.TextStyle#dropShadowDistance|dropShadowDistance}
   * - {@link PIXI.TextStyle#dropShadowColor|dropShadowColor}
   * - {@link PIXI.TextStyle#dropShadowBlur|dropShadowBlur}
   * - {@link PIXI.TextStyle#dropShadowAngle|dropShadowAngle}
   * - {@link PIXI.TextStyle#fill|fill}
   * - {@link PIXI.TextStyle#fillGradientStops|fillGradientStops}
   * - {@link PIXI.TextStyle#fillGradientType|fillGradientType}
   * - {@link PIXI.TextStyle#fontFamily|fontFamily}
   * - {@link PIXI.TextStyle#fontSize|fontSize}
   * - {@link PIXI.TextStyle#fontVariant|fontVariant}
   * - {@link PIXI.TextStyle#fontWeight|fontWeight}
   * - {@link PIXI.TextStyle#lineJoin|lineJoin}
   * - {@link PIXI.TextStyle#miterLimit|miterLimit}
   * - {@link PIXI.TextStyle#stroke|stroke}
   * - {@link PIXI.TextStyle#strokeThickness|strokeThickness}
   * - {@link PIXI.TextStyle#textBaseline|textBaseline}
   * @param name - The name of the custom font to use with BitmapText.
   * @param textStyle - Style options to render with BitmapFont.
   * @param options - Setup options for font or name of the font.
   * @returns Font generated by style options.
   * @example
   * import { BitmapFont, BitmapText } from 'pixi.js';
   *
   * BitmapFont.from('TitleFont', {
   *     fontFamily: 'Arial',
   *     fontSize: 12,
   *     strokeThickness: 2,
   *     fill: 'purple',
   * });
   *
   * const title = new BitmapText('This is the title', { fontName: 'TitleFont' });
   */
  static from(t, e, r) {
    if (!t)
      throw new Error("[BitmapFont] Property `name` is required.");
    const {
      chars: i,
      padding: s,
      resolution: o,
      textureWidth: a,
      textureHeight: h,
      ...l
    } = Object.assign({}, Sr.defaultOptions, r), u = GT(i), c = e instanceof Hn ? e : new Hn(e), d = a, f = new rh();
    f.info[0] = {
      face: c.fontFamily,
      size: c.fontSize
    }, f.common[0] = {
      lineHeight: c.fontSize
    };
    let p = 0, m = 0, g, _, w, v = 0;
    const E = [];
    for (let b = 0; b < u.length; b++) {
      g || (g = ht.ADAPTER.createCanvas(), g.width = a, g.height = h, _ = g.getContext("2d"), w = new _t(g, { resolution: o, ...l }), E.push(new ct(w)), f.page.push({
        id: E.length - 1,
        file: ""
      }));
      const y = u[b], C = An.measureText(y, c, !1, g), M = C.width, U = Math.ceil(C.height), F = Math.ceil((c.fontStyle === "italic" ? 2 : 1) * M);
      if (m >= h - U * o) {
        if (m === 0)
          throw new Error(`[BitmapFont] textureHeight ${h}px is too small (fontFamily: '${c.fontFamily}', fontSize: ${c.fontSize}px, char: '${y}')`);
        --b, g = null, _ = null, w = null, m = 0, p = 0, v = 0;
        continue;
      }
      if (v = Math.max(U + C.fontProperties.descent, v), F * o + p >= d) {
        if (p === 0)
          throw new Error(`[BitmapFont] textureWidth ${a}px is too small (fontFamily: '${c.fontFamily}', fontSize: ${c.fontSize}px, char: '${y}')`);
        --b, m += v * o, m = Math.ceil(m), p = 0, v = 0;
        continue;
      }
      HT(g, _, C, p, m, o, c);
      const O = Pa(C.text);
      f.char.push({
        id: O,
        page: E.length - 1,
        x: p / o,
        y: m / o,
        width: F,
        height: U,
        xoffset: 0,
        yoffset: 0,
        xadvance: M - (c.dropShadow ? c.dropShadowDistance : 0) - (c.stroke ? c.strokeThickness : 0)
      }), p += (F + 2 * s) * o, p = Math.ceil(p);
    }
    if (!r?.skipKerning)
      for (let b = 0, y = u.length; b < y; b++) {
        const C = u[b];
        for (let M = 0; M < y; M++) {
          const U = u[M], F = _.measureText(C).width, O = _.measureText(U).width, R = _.measureText(C + U).width - (F + O);
          R && f.kerning.push({
            first: Pa(C),
            second: Pa(U),
            amount: R
          });
        }
      }
    const x = new Sr(f, E, !0);
    return Sr.available[t] !== void 0 && Sr.uninstall(t), Sr.available[t] = x, x;
  }
};
Tn.ALPHA = [["a", "z"], ["A", "Z"], " "], /**
* This character set includes all decimal digits (from 0 to 9).
* @type {string[][]}
* @example
* BitmapFont.from('ExampleFont', style, { chars: BitmapFont.NUMERIC })
*/
Tn.NUMERIC = [["0", "9"]], /**
* This character set is the union of `BitmapFont.ALPHA` and `BitmapFont.NUMERIC`.
* @type {string[][]}
*/
Tn.ALPHANUMERIC = [["a", "z"], ["A", "Z"], ["0", "9"], " "], /**
* This character set consists of all the ASCII table.
* @member {string[][]}
* @see http://www.asciitable.com/
*/
Tn.ASCII = [[" ", "~"]], /**
* Collection of default options when using `BitmapFont.from`.
* @property {number} [resolution=1] -
* @property {number} [textureWidth=512] -
* @property {number} [textureHeight=512] -
* @property {number} [padding=4] -
* @property {string|string[]|string[][]} chars = PIXI.BitmapFont.ALPHANUMERIC
*/
Tn.defaultOptions = {
  resolution: 1,
  textureWidth: 512,
  textureHeight: 512,
  padding: 4,
  chars: Tn.ALPHANUMERIC
}, /** Collection of available/installed fonts. */
Tn.available = {};
let je = Tn;
var zT = `// Pixi texture info\r
varying vec2 vTextureCoord;\r
uniform sampler2D uSampler;\r
\r
// Tint\r
uniform vec4 uColor;\r
\r
// on 2D applications fwidth is screenScale / glyphAtlasScale * distanceFieldRange\r
uniform float uFWidth;\r
\r
void main(void) {\r
\r
  // To stack MSDF and SDF we need a non-pre-multiplied-alpha texture.\r
  vec4 texColor = texture2D(uSampler, vTextureCoord);\r
\r
  // MSDF\r
  float median = texColor.r + texColor.g + texColor.b -\r
                  min(texColor.r, min(texColor.g, texColor.b)) -\r
                  max(texColor.r, max(texColor.g, texColor.b));\r
  // SDF\r
  median = min(median, texColor.a);\r
\r
  float screenPxDistance = uFWidth * (median - 0.5);\r
  float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);\r
  if (median < 0.01) {\r
    alpha = 0.0;\r
  } else if (median > 0.99) {\r
    alpha = 1.0;\r
  }\r
\r
  // Gamma correction for coverage-like alpha\r
  float luma = dot(uColor.rgb, vec3(0.299, 0.587, 0.114));\r
  float gamma = mix(1.0, 1.0 / 2.2, luma);\r
  float coverage = pow(uColor.a * alpha, gamma);  \r
\r
  // NPM Textures, NPM outputs\r
  gl_FragColor = vec4(uColor.rgb, coverage);\r
}\r
`, WT = `// Mesh material default fragment\r
attribute vec2 aVertexPosition;\r
attribute vec2 aTextureCoord;\r
\r
uniform mat3 projectionMatrix;\r
uniform mat3 translationMatrix;\r
uniform mat3 uTextureMatrix;\r
\r
varying vec2 vTextureCoord;\r
\r
void main(void)\r
{\r
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\r
\r
    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\r
}\r
`;
const cm = [], dm = [], fm = [], uy = class cy extends bt {
  /**
   * @param text - A string that you would like the text to display.
   * @param style - The style parameters.
   * @param {string} style.fontName - The installed BitmapFont name.
   * @param {number} [style.fontSize] - The size of the font in pixels, e.g. 24. If undefined,
   *.     this will default to the BitmapFont size.
   * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center', 'right' or 'justify'),
   *      does not affect single line text.
   * @param {PIXI.ColorSource} [style.tint=0xFFFFFF] - The tint color.
   * @param {number} [style.letterSpacing=0] - The amount of spacing between letters.
   * @param {number} [style.maxWidth=0] - The max width of the text before line wrapping.
   */
  constructor(t, e = {}) {
    super();
    const { align: r, tint: i, maxWidth: s, letterSpacing: o, fontName: a, fontSize: h } = Object.assign(
      {},
      cy.styleDefaults,
      e
    );
    if (!je.available[a])
      throw new Error(`Missing BitmapFont "${a}"`);
    this._activePagesMeshData = [], this._textWidth = 0, this._textHeight = 0, this._align = r, this._tintColor = new Ot(i), this._font = void 0, this._fontName = a, this._fontSize = h, this.text = t, this._maxWidth = s, this._maxLineHeight = 0, this._letterSpacing = o, this._anchor = new tn(() => {
      this.dirty = !0;
    }, this, 0, 0), this._roundPixels = ht.ROUND_PIXELS, this.dirty = !0, this._resolution = ht.RESOLUTION, this._autoResolution = !0, this._textureCache = {};
  }
  /** Renders text and updates it when needed. This should only be called if the BitmapFont is regenerated. */
  updateText() {
    const t = je.available[this._fontName], e = this.fontSize, r = e / t.size, i = new mt(), s = [], o = [], a = [], h = this._text.replace(/(?:\r\n|\r)/g, `
`) || " ", l = ly(h), u = this._maxWidth * t.size / e, c = t.distanceFieldType === "none" ? cm : dm;
    let d = null, f = 0, p = 0, m = 0, g = -1, _ = 0, w = 0, v = 0, E = 0;
    for (let F = 0; F < l.length; F++) {
      const O = l[F], R = Pa(O);
      if (/(?:\s)/.test(O) && (g = F, _ = f, E++), O === "\r" || O === `
`) {
        o.push(f), a.push(-1), p = Math.max(p, f), ++m, ++w, i.x = 0, i.y += t.lineHeight, d = null, E = 0;
        continue;
      }
      const k = t.chars[R];
      if (!k)
        continue;
      d && k.kerning[d] && (i.x += k.kerning[d]);
      const j = fm.pop() || {
        texture: ct.EMPTY,
        line: 0,
        charCode: 0,
        prevSpaces: 0,
        position: new mt()
      };
      j.texture = k.texture, j.line = m, j.charCode = R, j.position.x = Math.round(i.x + k.xOffset + this._letterSpacing / 2), j.position.y = Math.round(i.y + k.yOffset), j.prevSpaces = E, s.push(j), f = j.position.x + Math.max(k.xAdvance - k.xOffset, k.texture.orig.width), i.x += k.xAdvance + this._letterSpacing, v = Math.max(v, k.yOffset + k.texture.height), d = R, g !== -1 && u > 0 && i.x > u && (++w, es(s, 1 + g - w, 1 + F - g), F = g, g = -1, o.push(_), a.push(s.length > 0 ? s[s.length - 1].prevSpaces : 0), p = Math.max(p, _), m++, i.x = 0, i.y += t.lineHeight, d = null, E = 0);
    }
    const x = l[l.length - 1];
    x !== "\r" && x !== `
` && (/(?:\s)/.test(x) && (f = _), o.push(f), p = Math.max(p, f), a.push(-1));
    const b = [];
    for (let F = 0; F <= m; F++) {
      let O = 0;
      this._align === "right" ? O = p - o[F] : this._align === "center" ? O = (p - o[F]) / 2 : this._align === "justify" && (O = a[F] < 0 ? 0 : (p - o[F]) / a[F]), b.push(O);
    }
    const y = s.length, C = {}, M = [], U = this._activePagesMeshData;
    c.push(...U);
    for (let F = 0; F < y; F++) {
      const O = s[F].texture, R = O.baseTexture.uid;
      if (!C[R]) {
        let k = c.pop();
        if (!k) {
          const T = new K0();
          let S, A;
          t.distanceFieldType === "none" ? (S = new vc(ct.EMPTY), A = gt.NORMAL) : (S = new vc(
            ct.EMPTY,
            { program: en.from(WT, zT), uniforms: { uFWidth: 0 } }
          ), A = gt.NORMAL_NPM);
          const L = new _c(T, S);
          L.blendMode = A, k = {
            index: 0,
            indexCount: 0,
            vertexCount: 0,
            uvsCount: 0,
            total: 0,
            mesh: L,
            vertices: null,
            uvs: null,
            indices: null
          };
        }
        k.index = 0, k.indexCount = 0, k.vertexCount = 0, k.uvsCount = 0, k.total = 0;
        const { _textureCache: j } = this;
        j[R] = j[R] || new ct(O.baseTexture), k.mesh.texture = j[R], k.mesh.tint = this._tintColor.value, M.push(k), C[R] = k;
      }
      C[R].total++;
    }
    for (let F = 0; F < U.length; F++)
      M.includes(U[F]) || this.removeChild(U[F].mesh);
    for (let F = 0; F < M.length; F++)
      M[F].mesh.parent !== this && this.addChild(M[F].mesh);
    this._activePagesMeshData = M;
    for (const F in C) {
      const O = C[F], R = O.total;
      if (!(O.indices?.length > 6 * R) || O.vertices.length < _c.BATCHABLE_SIZE * 2)
        O.vertices = new Float32Array(8 * R), O.uvs = new Float32Array(8 * R), O.indices = new Uint16Array(6 * R);
      else {
        const k = O.total, j = O.vertices;
        for (let T = k * 4 * 2; T < j.length; T++)
          j[T] = 0;
      }
      O.mesh.size = 6 * R;
    }
    for (let F = 0; F < y; F++) {
      const O = s[F];
      let R = O.position.x + b[O.line] * (this._align === "justify" ? O.prevSpaces : 1);
      this._roundPixels && (R = Math.round(R));
      const k = R * r, j = O.position.y * r, T = O.texture, S = C[T.baseTexture.uid], A = T.frame, L = T._uvs, D = S.index++;
      S.indices[D * 6 + 0] = 0 + D * 4, S.indices[D * 6 + 1] = 1 + D * 4, S.indices[D * 6 + 2] = 2 + D * 4, S.indices[D * 6 + 3] = 0 + D * 4, S.indices[D * 6 + 4] = 2 + D * 4, S.indices[D * 6 + 5] = 3 + D * 4, S.vertices[D * 8 + 0] = k, S.vertices[D * 8 + 1] = j, S.vertices[D * 8 + 2] = k + A.width * r, S.vertices[D * 8 + 3] = j, S.vertices[D * 8 + 4] = k + A.width * r, S.vertices[D * 8 + 5] = j + A.height * r, S.vertices[D * 8 + 6] = k, S.vertices[D * 8 + 7] = j + A.height * r, S.uvs[D * 8 + 0] = L.x0, S.uvs[D * 8 + 1] = L.y0, S.uvs[D * 8 + 2] = L.x1, S.uvs[D * 8 + 3] = L.y1, S.uvs[D * 8 + 4] = L.x2, S.uvs[D * 8 + 5] = L.y2, S.uvs[D * 8 + 6] = L.x3, S.uvs[D * 8 + 7] = L.y3;
    }
    this._textWidth = p * r, this._textHeight = (i.y + t.lineHeight) * r;
    for (const F in C) {
      const O = C[F];
      if (this.anchor.x !== 0 || this.anchor.y !== 0) {
        let T = 0;
        const S = this._textWidth * this.anchor.x, A = this._textHeight * this.anchor.y;
        for (let L = 0; L < O.total; L++)
          O.vertices[T++] -= S, O.vertices[T++] -= A, O.vertices[T++] -= S, O.vertices[T++] -= A, O.vertices[T++] -= S, O.vertices[T++] -= A, O.vertices[T++] -= S, O.vertices[T++] -= A;
      }
      this._maxLineHeight = v * r;
      const R = O.mesh.geometry.getBuffer("aVertexPosition"), k = O.mesh.geometry.getBuffer("aTextureCoord"), j = O.mesh.geometry.getIndex();
      R.data = O.vertices, k.data = O.uvs, j.data = O.indices, R.update(), k.update(), j.update();
    }
    for (let F = 0; F < s.length; F++)
      fm.push(s[F]);
    this._font = t, this.dirty = !1;
  }
  updateTransform() {
    this.validate(), this.containerUpdateTransform();
  }
  _render(t) {
    this._autoResolution && this._resolution !== t.resolution && (this._resolution = t.resolution, this.dirty = !0);
    const { distanceFieldRange: e, distanceFieldType: r, size: i } = je.available[this._fontName];
    if (r !== "none") {
      const { a: s, b: o, c: a, d: h } = this.worldTransform, l = Math.sqrt(s * s + o * o), u = Math.sqrt(a * a + h * h), c = (Math.abs(l) + Math.abs(u)) / 2, d = this.fontSize / i, f = t._view.resolution;
      for (const p of this._activePagesMeshData)
        p.mesh.shader.uniforms.uFWidth = c * e * d * f;
    }
    super._render(t);
  }
  /**
   * Validates text before calling parent's getLocalBounds
   * @returns - The rectangular bounding area
   */
  getLocalBounds() {
    return this.validate(), super.getLocalBounds();
  }
  /**
   * Updates text when needed
   * @private
   */
  validate() {
    const t = je.available[this._fontName];
    if (!t)
      throw new Error(`Missing BitmapFont "${this._fontName}"`);
    this._font !== t && (this.dirty = !0), this.dirty && this.updateText();
  }
  /**
   * The tint of the BitmapText object.
   * @default 0xffffff
   */
  get tint() {
    return this._tintColor.value;
  }
  set tint(t) {
    if (this.tint !== t) {
      this._tintColor.setValue(t);
      for (let e = 0; e < this._activePagesMeshData.length; e++)
        this._activePagesMeshData[e].mesh.tint = t;
    }
  }
  /**
   * The alignment of the BitmapText object.
   * @member {string}
   * @default 'left'
   */
  get align() {
    return this._align;
  }
  set align(t) {
    this._align !== t && (this._align = t, this.dirty = !0);
  }
  /** The name of the BitmapFont. */
  get fontName() {
    return this._fontName;
  }
  set fontName(t) {
    if (!je.available[t])
      throw new Error(`Missing BitmapFont "${t}"`);
    this._fontName !== t && (this._fontName = t, this.dirty = !0);
  }
  /** The size of the font to display. */
  get fontSize() {
    return this._fontSize ?? je.available[this._fontName].size;
  }
  set fontSize(t) {
    this._fontSize !== t && (this._fontSize = t, this.dirty = !0);
  }
  /**
   * The anchor sets the origin point of the text.
   *
   * The default is `(0,0)`, this means the text's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the text's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the text's origin point will be the bottom right corner.
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(t) {
    typeof t == "number" ? this._anchor.set(t) : this._anchor.copyFrom(t);
  }
  /** The text of the BitmapText object. */
  get text() {
    return this._text;
  }
  set text(t) {
    t = String(t ?? ""), this._text !== t && (this._text = t, this.dirty = !0);
  }
  /**
   * The max width of this bitmap text in pixels. If the text provided is longer than the
   * value provided, line breaks will be automatically inserted in the last whitespace.
   * Disable by setting the value to 0.
   */
  get maxWidth() {
    return this._maxWidth;
  }
  set maxWidth(t) {
    this._maxWidth !== t && (this._maxWidth = t, this.dirty = !0);
  }
  /**
   * The max line height. This is useful when trying to use the total height of the Text,
   * i.e. when trying to vertically align.
   * @readonly
   */
  get maxLineHeight() {
    return this.validate(), this._maxLineHeight;
  }
  /**
   * The width of the overall text, different from fontSize,
   * which is defined in the style object.
   * @readonly
   */
  get textWidth() {
    return this.validate(), this._textWidth;
  }
  /** Additional space between characters. */
  get letterSpacing() {
    return this._letterSpacing;
  }
  set letterSpacing(t) {
    this._letterSpacing !== t && (this._letterSpacing = t, this.dirty = !0);
  }
  /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
   * @default PIXI.settings.ROUND_PIXELS
   */
  get roundPixels() {
    return this._roundPixels;
  }
  set roundPixels(t) {
    t !== this._roundPixels && (this._roundPixels = t, this.dirty = !0);
  }
  /**
   * The height of the overall text, different from fontSize,
   * which is defined in the style object.
   * @readonly
   */
  get textHeight() {
    return this.validate(), this._textHeight;
  }
  /**
   * The resolution / device pixel ratio of the canvas.
   *
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @default 1
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(t) {
    this._autoResolution = !1, this._resolution !== t && (this._resolution = t, this.dirty = !0);
  }
  destroy(t) {
    const { _textureCache: e } = this, r = je.available[this._fontName].distanceFieldType === "none" ? cm : dm;
    r.push(...this._activePagesMeshData);
    for (const i of this._activePagesMeshData)
      this.removeChild(i.mesh);
    this._activePagesMeshData = [], r.filter((i) => e[i.mesh.texture.baseTexture.uid]).forEach((i) => {
      i.mesh.texture = ct.EMPTY;
    });
    for (const i in e)
      e[i].destroy(), delete e[i];
    this._font = null, this._tintColor = null, this._textureCache = null, super.destroy(t);
  }
};
uy.styleDefaults = {
  align: "left",
  tint: 16777215,
  maxWidth: 0,
  letterSpacing: 0
};
let $T = uy;
const XT = [".xml", ".fnt"], VT = {
  extension: {
    type: st.LoadParser,
    priority: yr.Normal
  },
  name: "loadBitmapFont",
  test(n) {
    return XT.includes(ne.extname(n).toLowerCase());
  },
  async testParse(n) {
    return Ia.test(n) || Tc.test(n);
  },
  async parse(n, t, e) {
    const r = Ia.test(n) ? Ia.parse(n) : Tc.parse(n), { src: i } = t, { page: s } = r, o = [];
    for (let l = 0; l < s.length; ++l) {
      const u = s[l].file;
      let c = ne.join(ne.dirname(i), u);
      c = mc(c, i), o.push(c);
    }
    const a = await e.load(o), h = o.map((l) => a[l]);
    return je.install(r, h, !0);
  },
  async load(n, t) {
    return (await ht.ADAPTER.fetch(n)).text();
  },
  unload(n) {
    n.destroy();
  }
};
dt.add(VT);
const Ac = class Yi extends Hn {
  constructor() {
    super(...arguments), this._fonts = [], this._overrides = [], this._stylesheet = "", this.fontsDirty = !1;
  }
  /**
   * Convert a TextStyle to HTMLTextStyle
   * @param originalStyle
   * @example
   * import {TextStyle } from 'pixi.js';
   * import {HTMLTextStyle} from '@pixi/text-html';
   * const style = new TextStyle();
   * const htmlStyle = HTMLTextStyle.from(style);
   */
  static from(t) {
    return new Yi(
      Object.keys(Yi.defaultOptions).reduce((e, r) => ({ ...e, [r]: t[r] }), {})
    );
  }
  /** Clear the current font */
  cleanFonts() {
    this._fonts.length > 0 && (this._fonts.forEach((t) => {
      URL.revokeObjectURL(t.src), t.refs--, t.refs === 0 && (t.fontFace && document.fonts.delete(t.fontFace), delete Yi.availableFonts[t.originalUrl]);
    }), this.fontFamily = "Arial", this._fonts.length = 0, this.styleID++, this.fontsDirty = !0);
  }
  /**
   * Because of how HTMLText renders, fonts need to be imported
   * @param url
   * @param options
   */
  loadFont(t, e = {}) {
    const { availableFonts: r } = Yi;
    if (r[t]) {
      const i = r[t];
      return this._fonts.push(i), i.refs++, this.styleID++, this.fontsDirty = !0, Promise.resolve();
    }
    return ht.ADAPTER.fetch(t).then((i) => i.blob()).then(async (i) => new Promise((s, o) => {
      const a = URL.createObjectURL(i), h = new FileReader();
      h.onload = () => s([a, h.result]), h.onerror = o, h.readAsDataURL(i);
    })).then(async ([i, s]) => {
      const o = Object.assign({
        family: ne.basename(t, ne.extname(t)),
        weight: "normal",
        style: "normal",
        display: "auto",
        src: i,
        dataSrc: s,
        refs: 1,
        originalUrl: t,
        fontFace: null
      }, e);
      r[t] = o, this._fonts.push(o), this.styleID++;
      const a = new FontFace(o.family, `url(${o.src})`, {
        weight: o.weight,
        style: o.style,
        display: o.display
      });
      o.fontFace = a, await a.load(), document.fonts.add(a), await document.fonts.ready, this.styleID++, this.fontsDirty = !0;
    });
  }
  /**
   * Add a style override, this can be any CSS property
   * it will override any built-in style. This is the
   * property and the value as a string (e.g., `color: red`).
   * This will override any other internal style.
   * @param {string} value - CSS style(s) to add.
   * @example
   * style.addOverride('background-color: red');
   */
  addOverride(...t) {
    const e = t.filter((r) => !this._overrides.includes(r));
    e.length > 0 && (this._overrides.push(...e), this.styleID++);
  }
  /**
   * Remove any overrides that match the value.
   * @param {string} value - CSS style to remove.
   * @example
   * style.removeOverride('background-color: red');
   */
  removeOverride(...t) {
    const e = t.filter((r) => this._overrides.includes(r));
    e.length > 0 && (this._overrides = this._overrides.filter((r) => !e.includes(r)), this.styleID++);
  }
  /**
   * Internally converts all of the style properties into CSS equivalents.
   * @param scale
   * @returns The CSS style string, for setting `style` property of root HTMLElement.
   */
  toCSS(t) {
    return [
      `transform: scale(${t})`,
      "transform-origin: top left",
      "display: inline-block",
      `color: ${this.normalizeColor(this.fill)}`,
      `font-size: ${this.fontSize}px`,
      `font-family: ${this.fontFamily}`,
      `font-weight: ${this.fontWeight}`,
      `font-style: ${this.fontStyle}`,
      `font-variant: ${this.fontVariant}`,
      `letter-spacing: ${this.letterSpacing}px`,
      `text-align: ${this.align}`,
      `padding: ${this.padding}px`,
      `white-space: ${this.whiteSpace}`,
      ...this.lineHeight ? [`line-height: ${this.lineHeight}px`] : [],
      ...this.wordWrap ? [
        `word-wrap: ${this.breakWords ? "break-all" : "break-word"}`,
        `max-width: ${this.wordWrapWidth}px`
      ] : [],
      ...this.strokeThickness ? [
        `-webkit-text-stroke-width: ${this.strokeThickness}px`,
        `-webkit-text-stroke-color: ${this.normalizeColor(this.stroke)}`,
        `text-stroke-width: ${this.strokeThickness}px`,
        `text-stroke-color: ${this.normalizeColor(this.stroke)}`,
        "paint-order: stroke"
      ] : [],
      ...this.dropShadow ? [this.dropShadowToCSS()] : [],
      ...this._overrides
    ].join(";");
  }
  /** Get the font CSS styles from the loaded font, If available. */
  toGlobalCSS() {
    return this._fonts.reduce((t, e) => `${t}
            @font-face {
                font-family: "${e.family}";
                src: url('${e.dataSrc}');
                font-weight: ${e.weight};
                font-style: ${e.style};
                font-display: ${e.display};
            }`, this._stylesheet);
  }
  /** Internal stylesheet contents, useful for creating rules for rendering */
  get stylesheet() {
    return this._stylesheet;
  }
  set stylesheet(t) {
    this._stylesheet !== t && (this._stylesheet = t, this.styleID++);
  }
  /**
   * Convert numerical colors into hex-strings
   * @param color
   */
  normalizeColor(t) {
    return Array.isArray(t) && (t = kx(t)), typeof t == "number" ? Nx(t) : t;
  }
  /** Convert the internal drop-shadow settings to CSS text-shadow */
  dropShadowToCSS() {
    let t = this.normalizeColor(this.dropShadowColor);
    const e = this.dropShadowAlpha, r = Math.round(Math.cos(this.dropShadowAngle) * this.dropShadowDistance), i = Math.round(Math.sin(this.dropShadowAngle) * this.dropShadowDistance);
    t.startsWith("#") && e < 1 && (t += (e * 255 | 0).toString(16).padStart(2, "0"));
    const s = `${r}px ${i}px`;
    return this.dropShadowBlur > 0 ? `text-shadow: ${s} ${this.dropShadowBlur}px ${t}` : `text-shadow: ${s} ${t}`;
  }
  /** Resets all properties to the defaults specified in TextStyle.prototype._default */
  reset() {
    Object.assign(this, Yi.defaultOptions);
  }
  /**
   * Called after the image is loaded but before drawing to the canvas.
   * Mostly used to handle Safari's font loading bug.
   * @ignore
   */
  onBeforeDraw() {
    const { fontsDirty: t } = this;
    return this.fontsDirty = !1, this.isSafari && this._fonts.length > 0 && t ? new Promise((e) => setTimeout(e, 100)) : Promise.resolve();
  }
  /**
   * Proving that Safari is the new IE
   * @ignore
   */
  get isSafari() {
    const { userAgent: t } = ht.ADAPTER.getNavigator();
    return /^((?!chrome|android).)*safari/i.test(t);
  }
  set fillGradientStops(t) {
    console.warn("[HTMLTextStyle] fillGradientStops is not supported by HTMLText");
  }
  get fillGradientStops() {
    return super.fillGradientStops;
  }
  set fillGradientType(t) {
    console.warn("[HTMLTextStyle] fillGradientType is not supported by HTMLText");
  }
  get fillGradientType() {
    return super.fillGradientType;
  }
  set miterLimit(t) {
    console.warn("[HTMLTextStyle] miterLimit is not supported by HTMLText");
  }
  get miterLimit() {
    return super.miterLimit;
  }
  set trim(t) {
    console.warn("[HTMLTextStyle] trim is not supported by HTMLText");
  }
  get trim() {
    return super.trim;
  }
  set textBaseline(t) {
    console.warn("[HTMLTextStyle] textBaseline is not supported by HTMLText");
  }
  get textBaseline() {
    return super.textBaseline;
  }
  set leading(t) {
    console.warn("[HTMLTextStyle] leading is not supported by HTMLText");
  }
  get leading() {
    return super.leading;
  }
  set lineJoin(t) {
    console.warn("[HTMLTextStyle] lineJoin is not supported by HTMLText");
  }
  get lineJoin() {
    return super.lineJoin;
  }
};
Ac.availableFonts = {}, /**
* List of default options, these are largely the same as TextStyle,
* with the exception of whiteSpace, which is set to 'normal' by default.
*/
Ac.defaultOptions = {
  /** Align */
  align: "left",
  /** Break words */
  breakWords: !1,
  /** Drop shadow */
  dropShadow: !1,
  /** Drop shadow alpha */
  dropShadowAlpha: 1,
  /**
   * Drop shadow angle
   * @type {number}
   * @default Math.PI / 6
   */
  dropShadowAngle: Math.PI / 6,
  /** Drop shadow blur */
  dropShadowBlur: 0,
  /** Drop shadow color */
  dropShadowColor: "black",
  /** Drop shadow distance */
  dropShadowDistance: 5,
  /** Fill */
  fill: "black",
  /** Font family */
  fontFamily: "Arial",
  /** Font size */
  fontSize: 26,
  /** Font style */
  fontStyle: "normal",
  /** Font variant */
  fontVariant: "normal",
  /** Font weight */
  fontWeight: "normal",
  /** Letter spacing */
  letterSpacing: 0,
  /** Line height */
  lineHeight: 0,
  /** Padding */
  padding: 0,
  /** Stroke */
  stroke: "black",
  /** Stroke thickness */
  strokeThickness: 0,
  /** White space */
  whiteSpace: "normal",
  /** Word wrap */
  wordWrap: !1,
  /** Word wrap width */
  wordWrapWidth: 100
};
let _u = Ac;
const ga = class ji extends jt {
  /**
   * @param {string} [text] - Text contents
   * @param {PIXI.HTMLTextStyle|PIXI.TextStyle|PIXI.ITextStyle} [style] - Style setting to use.
   *        Strongly recommend using an HTMLTextStyle object. Providing a PIXI.TextStyle
   *        will convert the TextStyle to an HTMLTextStyle and will no longer be linked.
   */
  constructor(t = "", e = {}) {
    super(ct.EMPTY), this._text = null, this._style = null, this._autoResolution = !0, this.localStyleID = -1, this.dirty = !1, this._updateID = 0, this.ownsStyle = !1;
    const r = new Image(), i = ct.from(r, {
      scaleMode: ht.SCALE_MODE,
      resourceOptions: {
        autoLoad: !1
      }
    });
    i.orig = new yt(), i.trim = new yt(), this.texture = i;
    const s = "http://www.w3.org/2000/svg", o = "http://www.w3.org/1999/xhtml", a = document.createElementNS(s, "svg"), h = document.createElementNS(s, "foreignObject"), l = document.createElementNS(o, "div"), u = document.createElementNS(o, "style");
    h.setAttribute("width", "10000"), h.setAttribute("height", "10000"), h.style.overflow = "hidden", a.appendChild(h), this.maxWidth = ji.defaultMaxWidth, this.maxHeight = ji.defaultMaxHeight, this._domElement = l, this._styleElement = u, this._svgRoot = a, this._foreignObject = h, this._foreignObject.appendChild(u), this._foreignObject.appendChild(l), this._image = r, this._loadImage = new Image(), this._autoResolution = ji.defaultAutoResolution, this._resolution = ji.defaultResolution ?? ht.RESOLUTION, this.text = t, this.style = e;
  }
  /**
   * Calculate the size of the output text without actually drawing it.
   * This includes the `padding` in the `style` object.
   * This can be used as a fast-pass to do things like text-fitting.
   * @param {object} [overrides] - Overrides for the text, style, and resolution.
   * @param {string} [overrides.text] - The text to measure, if not specified, the current text is used.
   * @param {PIXI.HTMLTextStyle} [overrides.style] - The style to measure, if not specified, the current style is used.
   * @param {number} [overrides.resolution] - The resolution to measure, if not specified, the current resolution is used.
   * @returns {PIXI.ISize} Width and height of the measured text.
   */
  measureText(t) {
    const { text: e, style: r, resolution: i } = Object.assign({
      text: this._text,
      style: this._style,
      resolution: this._resolution
    }, t);
    Object.assign(this._domElement, {
      innerHTML: e,
      style: r.toCSS(i)
    }), this._styleElement.textContent = r.toGlobalCSS(), document.body.appendChild(this._svgRoot);
    const s = this._domElement.getBoundingClientRect();
    this._svgRoot.remove();
    const { width: o, height: a } = s;
    (o > this.maxWidth || a > this.maxHeight) && console.warn("[HTMLText] Large expanse of text, increase HTMLText.maxWidth or HTMLText.maxHeight property.");
    const h = Math.min(this.maxWidth, Math.ceil(o)), l = Math.min(this.maxHeight, Math.ceil(a));
    return this._svgRoot.setAttribute("width", h.toString()), this._svgRoot.setAttribute("height", l.toString()), e !== this._text && (this._domElement.innerHTML = this._text), r !== this._style && (Object.assign(this._domElement, { style: this._style?.toCSS(i) }), this._styleElement.textContent = this._style?.toGlobalCSS()), {
      width: h + r.padding * 2,
      height: l + r.padding * 2
    };
  }
  /**
   * Manually refresh the text.
   * @public
   * @param {boolean} respectDirty - Whether to abort updating the
   *        text if the Text isn't dirty and the function is called.
   */
  async updateText(t = !0) {
    const { style: e, _image: r, _loadImage: i } = this;
    if (this.localStyleID !== e.styleID && (this.dirty = !0, this.localStyleID = e.styleID), !this.dirty && t)
      return;
    const { width: s, height: o } = this.measureText();
    r.width = i.width = Math.ceil(Math.max(1, s)), r.height = i.height = Math.ceil(Math.max(1, o)), this._updateID++;
    const a = this._updateID;
    await new Promise((h) => {
      i.onload = async () => {
        if (a < this._updateID) {
          h();
          return;
        }
        await e.onBeforeDraw(), r.src = i.src, i.onload = null, i.src = "", this.updateTexture(), h();
      };
      const l = new XMLSerializer().serializeToString(this._svgRoot);
      i.src = `data:image/svg+xml;charset=utf8,${encodeURIComponent(l)}`;
    });
  }
  /** The raw image element that is rendered under-the-hood. */
  get source() {
    return this._image;
  }
  /**
   * Update the texture resource.
   * @private
   */
  updateTexture() {
    const { style: t, texture: e, _image: r, resolution: i } = this, { padding: s } = t, { baseTexture: o } = e;
    e.trim.width = e._frame.width = r.width / i, e.trim.height = e._frame.height = r.height / i, e.trim.x = -s, e.trim.y = -s, e.orig.width = e._frame.width - s * 2, e.orig.height = e._frame.height - s * 2, this._onTextureUpdate(), o.setRealSize(r.width, r.height, i), this.dirty = !1;
  }
  /**
   * Renders the object using the WebGL renderer
   * @param {PIXI.Renderer} renderer - The renderer
   * @private
   */
  _render(t) {
    this._autoResolution && this._resolution !== t.resolution && (this._resolution = t.resolution, this.dirty = !0), this.updateText(!0), super._render(t);
  }
  /**
   * Renders the object using the Canvas Renderer.
   * @private
   * @param {PIXI.CanvasRenderer} renderer - The renderer
   */
  _renderCanvas(t) {
    this._autoResolution && this._resolution !== t.resolution && (this._resolution = t.resolution, this.dirty = !0), this.updateText(!0), super._renderCanvas(t);
  }
  /**
   * Get the local bounds.
   * @param {PIXI.Rectangle} rect - Input rectangle.
   * @returns {PIXI.Rectangle} Local bounds
   */
  getLocalBounds(t) {
    return this.updateText(!0), super.getLocalBounds(t);
  }
  _calculateBounds() {
    this.updateText(!0), this.calculateVertices(), this._bounds.addQuad(this.vertexData);
  }
  /**
   * Handle dirty style changes
   * @private
   */
  _onStyleChange() {
    this.dirty = !0;
  }
  /**
   * Destroy this Text object. Don't use after calling.
   * @param {boolean|object} options - Same as Sprite destroy options.
   */
  destroy(t) {
    typeof t == "boolean" && (t = { children: t }), t = Object.assign({}, ji.defaultDestroyOptions, t), super.destroy(t);
    const e = null;
    this.ownsStyle && this._style?.cleanFonts(), this._style = e, this._svgRoot?.remove(), this._svgRoot = e, this._domElement?.remove(), this._domElement = e, this._foreignObject?.remove(), this._foreignObject = e, this._styleElement?.remove(), this._styleElement = e, this._loadImage.src = "", this._loadImage.onload = null, this._loadImage = e, this._image.src = "", this._image = e;
  }
  /**
   * Get the width in pixels.
   * @member {number}
   */
  get width() {
    return this.updateText(!0), Math.abs(this.scale.x) * this._image.width / this.resolution;
  }
  set width(t) {
    this.updateText(!0);
    const e = Cn(this.scale.x) || 1;
    this.scale.x = e * t / this._image.width / this.resolution, this._width = t;
  }
  /**
   * Get the height in pixels.
   * @member {number}
   */
  get height() {
    return this.updateText(!0), Math.abs(this.scale.y) * this._image.height / this.resolution;
  }
  set height(t) {
    this.updateText(!0);
    const e = Cn(this.scale.y) || 1;
    this.scale.y = e * t / this._image.height / this.resolution, this._height = t;
  }
  /** The base style to render with text. */
  get style() {
    return this._style;
  }
  set style(t) {
    this._style !== t && (t = t || {}, t instanceof _u ? (this.ownsStyle = !1, this._style = t) : t instanceof Hn ? (console.warn("[HTMLText] Cloning TextStyle, if this is not what you want, use HTMLTextStyle"), this.ownsStyle = !0, this._style = _u.from(t)) : (this.ownsStyle = !0, this._style = new _u(t)), this.localStyleID = -1, this.dirty = !0);
  }
  /**
   * Contents of text. This can be HTML text and include tags.
   * @example
   * const text = new HTMLText('This is a <em>styled</em> text!');
   * @member {string}
   */
  get text() {
    return this._text;
  }
  set text(t) {
    t = String(t === "" || t === null || t === void 0 ? " " : t), t = this.sanitiseText(t), this._text !== t && (this._text = t, this.dirty = !0);
  }
  /**
   * The resolution / device pixel ratio of the canvas.
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @member {number}
   * @default 1
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(t) {
    this._autoResolution = !1, this._resolution !== t && (this._resolution = t, this.dirty = !0);
  }
  /**
   * Sanitise text - replace `<br>` with `<br/>`, `&nbsp;` with `&#160;`
   * @param text
   * @see https://www.sitepoint.com/community/t/xhtml-1-0-transitional-xml-parsing-error-entity-nbsp-not-defined/3392/3
   */
  sanitiseText(t) {
    return t.replace(/<br>/gi, "<br/>").replace(/<hr>/gi, "<hr/>").replace(/&nbsp;/gi, "&#160;");
  }
};
ga.defaultDestroyOptions = {
  texture: !0,
  children: !1,
  baseTexture: !0
}, /** Default maxWidth, set at construction */
ga.defaultMaxWidth = 2024, /** Default maxHeight, set at construction */
ga.defaultMaxHeight = 2024, /** Default autoResolution for all HTMLText objects */
ga.defaultAutoResolution = !0;
function YT() {
  const n = /* @__PURE__ */ new Map();
  function t(o, a) {
    const h = n.get(o);
    return h ? h.add(a) : n.set(o, /* @__PURE__ */ new Set([a])), () => r(o, a);
  }
  function e(o, a) {
    const h = (l) => {
      r(o, h), a(l);
    };
    t(o, h);
  }
  function r(o, a) {
    n.get(o)?.delete(a);
  }
  function i(o, a) {
    n.get(o)?.forEach((h) => h(a));
  }
  function s() {
    n.clear();
  }
  return {
    on: t,
    off: r,
    once: e,
    emit: i,
    clear: s
  };
}
const it = YT();
function Re(n) {
  let t;
  return new Promise((e) => {
    t = e, it.on(n, t);
  }).then((e) => (it.off(n, t), e));
}
let Nr = null;
const dy = new ResizeObserver(() => {
  Nr && it.emit("stageUpdated", Nr);
});
function jT(n) {
  Nr = n, dy.observe(Nr), it.emit("stageCreated", Nr);
}
function qT() {
  Nr && dy.unobserve(Nr), Nr = null;
}
async function pd() {
  return Nr || await Re("stageCreated");
}
let be = null;
async function ZT() {
  const n = await pd();
  QT(n), it.on("stageUpdated", JT);
}
function KT() {
  be && (be.destroy(!0, {
    children: !0
  }), be = null);
}
function QT(n) {
  be || (be = new G0({
    backgroundAlpha: 0,
    resizeTo: n,
    antialias: !0,
    resolution: Math.ceil(window.devicePixelRatio)
  }), be.stage.sortableChildren = !0, n.appendChild(be.view), it.emit("applicationCreated", be), process.env.NODE_ENV === "development" && (globalThis.__PIXI_APP__ = be));
}
async function Qt() {
  return be || await Re("applicationCreated");
}
function JT(n) {
  be && (be.resizeTo = n, it.emit("applicationResized", be));
}
let Ra = /* @__PURE__ */ new Map();
function tA() {
  Ra = /* @__PURE__ */ new Map();
}
async function Po(n, t) {
  const e = `${n.toString()}-${JSON.stringify(t)}`;
  if (Ra.has(e))
    return Ra.get(e);
  const r = await n(...t);
  return Ra.set(e, r), r;
}
let is = null;
const eA = {
  animationDuration: 500,
  disableAnimationsThreshold: 500,
  disableEdgesThreshold: 500,
  fetchEvents: () => [],
  fetchEventsInterval: 3e4,
  theme: "dark"
};
function rA(n) {
  return {
    ...eA,
    ...n
  };
}
function nA(n) {
  iA(n);
}
function iA(n) {
  const t = rA(n);
  if (!is) {
    is = t, it.emit("configCreated", t);
    return;
  }
  Object.assign(is, t), it.emit("configUpdated", t);
}
function sA() {
  is = null;
}
async function He() {
  return is || await Re("configCreated");
}
const ei = new yt();
class oA {
  /**
   * @param options
   * @param [options.recursive] - whether culling should be recursive
   * @param [options.toggle='renderable'] - which property of display-object was be set to indicate
   *      its culling state. It should be one of `renderable`, `visible`.
   */
  constructor(t = {}) {
    this._recursive = typeof t.recursive == "boolean" ? t.recursive : !0, this._toggle = t.toggle || "visible", this._targetList = /* @__PURE__ */ new Set();
  }
  /**
   * Adds a display-object to the culling list
   *
   * @param target - the display-object to be culled
   * @return this
   */
  add(t) {
    return this._targetList.add(t), this;
  }
  /**
   * Adds all the display-objects to the culling list
   *
   * @param targets - the display-objects to be culled
   * @return this
   */
  addAll(t) {
    for (let e = 0, r = t.length; e < r; e++)
      this._targetList.add(t[e]);
    return this;
  }
  /**
   * Removes the display-object from the culling list
   *
   * @param target - the display-object to be removed
   * @return this
   */
  remove(t) {
    return this._targetList.delete(t), this;
  }
  /**
   * Removes all the passed display-objects from the culling list
   *
   * @param targets - the display-objects to be removed
   * @return this
   */
  removeAll(t) {
    for (let e = 0, r = t.length; e < r; e++)
      this._targetList.delete(t[e]);
    return this;
  }
  /**
   * Clears the culling list
   *
   * @return this
   */
  clear() {
    return this._targetList.clear(), this;
  }
  /**
   * @param rect - the rectangle outside of which display-objects should be culled
   * @param skipUpdate - whether to skip unculling, transform update, bounds calculation. It is
   *  highly recommended you enable this by calling _this.uncull()_ and _root.getBounds(false)_ manually
   *  before your render loop.
   * @return this
   */
  cull(t, e = !1) {
    return e || this.uncull(), this._targetList.forEach((r) => {
      e || r.getBounds(!1, ei), this._recursive ? this.cullRecursive(t, r, e) : (e && r._bounds.getRectangle(t), r[this._toggle] = ei.right > t.left && ei.left < t.right && ei.bottom > t.top && ei.top < t.bottom);
    }), this;
  }
  /**
   * Sets all display-objects to the unculled state.
   *
   * This happens regardless of whether the culling toggle was set by {@code this.cull} or manually. This
   * is why it is recommended to one of `visible` or `renderable` for normal use and the other for culling.
   *
   * @return this
   */
  uncull() {
    return this._targetList.forEach((t) => {
      this._recursive ? this.uncullRecursive(t) : t[this._toggle] = !1;
    }), this;
  }
  /**
   * Recursively culls the subtree of {@code displayObject}.
   *
   * @param rect - the visiblity rectangle
   * @param displayObject - the root of the subtree to cull
   * @param skipUpdate - whether to skip bounds calculation. However, transforms are expected to be updated by the caller.
   */
  cullRecursive(t, e, r) {
    const i = r ? e._bounds.getRectangle(ei) : e.getBounds(!0, ei);
    if (e[this._toggle] = i.right > t.left && i.left < t.right && i.bottom > t.top && i.top < t.bottom, !(i.left >= t.left && i.top >= t.top && i.right <= t.right && i.bottom <= t.bottom) && e[this._toggle] && e.children && e.children.length) {
      const o = e.children;
      for (let a = 0, h = o.length; a < h; a++)
        this.cullRecursive(t, o[a]);
    }
  }
  /**
   * Recursively unculls the subtree of {@code displayObject}.
   *
   * @param displayObject
   */
  uncullRecursive(t) {
    if (t[this._toggle] = !0, t.children && t.children.length) {
      const e = t.children;
      for (let r = 0, i = e.length; r < i; r++)
        this.uncullRecursive(e[r]);
    }
  }
}
var to = { exports: {} };
to.exports;
var pm;
function aA() {
  return pm || (pm = 1, (function(n, t) {
    var e = 200, r = "__lodash_hash_undefined__", i = 1, s = 2, o = 9007199254740991, a = "[object Arguments]", h = "[object Array]", l = "[object AsyncFunction]", u = "[object Boolean]", c = "[object Date]", d = "[object Error]", f = "[object Function]", p = "[object GeneratorFunction]", m = "[object Map]", g = "[object Number]", _ = "[object Null]", w = "[object Object]", v = "[object Promise]", E = "[object Proxy]", x = "[object RegExp]", b = "[object Set]", y = "[object String]", C = "[object Symbol]", M = "[object Undefined]", U = "[object WeakMap]", F = "[object ArrayBuffer]", O = "[object DataView]", R = "[object Float32Array]", k = "[object Float64Array]", j = "[object Int8Array]", T = "[object Int16Array]", S = "[object Int32Array]", A = "[object Uint8Array]", L = "[object Uint8ClampedArray]", D = "[object Uint16Array]", P = "[object Uint32Array]", N = /[\\^$.*+?()[\]{}|]/g, B = /^\[object .+?Constructor\]$/, X = /^(?:0|[1-9]\d*)$/, V = {};
    V[R] = V[k] = V[j] = V[T] = V[S] = V[A] = V[L] = V[D] = V[P] = !0, V[a] = V[h] = V[F] = V[u] = V[O] = V[c] = V[d] = V[f] = V[m] = V[g] = V[w] = V[x] = V[b] = V[y] = V[U] = !1;
    var J = typeof Ze == "object" && Ze && Ze.Object === Object && Ze, tt = typeof self == "object" && self && self.Object === Object && self, K = J || tt || Function("return this")(), G = t && !t.nodeType && t, W = G && !0 && n && !n.nodeType && n, q = W && W.exports === G, z = q && J.process, ot = (function() {
      try {
        return z && z.binding && z.binding("util");
      } catch {
      }
    })(), rt = ot && ot.isTypedArray;
    function et(I, H) {
      for (var Z = -1, lt = I == null ? 0 : I.length, Ft = 0, xt = []; ++Z < lt; ) {
        var $t = I[Z];
        H($t, Z, I) && (xt[Ft++] = $t);
      }
      return xt;
    }
    function nt(I, H) {
      for (var Z = -1, lt = H.length, Ft = I.length; ++Z < lt; )
        I[Ft + Z] = H[Z];
      return I;
    }
    function Et(I, H) {
      for (var Z = -1, lt = I == null ? 0 : I.length; ++Z < lt; )
        if (H(I[Z], Z, I))
          return !0;
      return !1;
    }
    function Dt(I, H) {
      for (var Z = -1, lt = Array(I); ++Z < I; )
        lt[Z] = H(Z);
      return lt;
    }
    function vr(I) {
      return function(H) {
        return I(H);
      };
    }
    function Ge(I, H) {
      return I.has(H);
    }
    function ye(I, H) {
      return I?.[H];
    }
    function Wr(I) {
      var H = -1, Z = Array(I.size);
      return I.forEach(function(lt, Ft) {
        Z[++H] = [Ft, lt];
      }), Z;
    }
    function pn(I, H) {
      return function(Z) {
        return I(H(Z));
      };
    }
    function mn(I) {
      var H = -1, Z = Array(I.size);
      return I.forEach(function(lt) {
        Z[++H] = lt;
      }), Z;
    }
    var Vh = Array.prototype, Yh = Function.prototype, Xn = Object.prototype, Ss = K["__core-js_shared__"], gn = Yh.toString, we = Xn.hasOwnProperty, Cs = (function() {
      var I = /[^.]+$/.exec(Ss && Ss.keys && Ss.keys.IE_PROTO || "");
      return I ? "Symbol(src)_1." + I : "";
    })(), ko = Xn.toString, jh = RegExp(
      "^" + gn.call(we).replace(N, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), ki = q ? K.Buffer : void 0, $r = K.Symbol, $ = K.Uint8Array, Y = Xn.propertyIsEnumerable, St = Vh.splice, At = $r ? $r.toStringTag : void 0, It = Object.getOwnPropertySymbols, vt = ki ? ki.isBuffer : void 0, xr = pn(Object.keys, Object), ir = Li(K, "DataView"), te = Li(K, "Map"), ze = Li(K, "Promise"), Vn = Li(K, "Set"), wr = Li(K, "WeakMap"), ue = Li(Object, "create"), Bo = Zn(ir), Lo = Zn(te), Uo = Zn(ze), Yn = Zn(Vn), Ms = Zn(wr), jn = $r ? $r.prototype : void 0, qn = jn ? jn.valueOf : void 0;
    function sr(I) {
      var H = -1, Z = I == null ? 0 : I.length;
      for (this.clear(); ++H < Z; ) {
        var lt = I[H];
        this.set(lt[0], lt[1]);
      }
    }
    function Ho() {
      this.__data__ = ue ? ue(null) : {}, this.size = 0;
    }
    function Go(I) {
      var H = this.has(I) && delete this.__data__[I];
      return this.size -= H ? 1 : 0, H;
    }
    function Is(I) {
      var H = this.__data__;
      if (ue) {
        var Z = H[I];
        return Z === r ? void 0 : Z;
      }
      return we.call(H, I) ? H[I] : void 0;
    }
    function zo(I) {
      var H = this.__data__;
      return ue ? H[I] !== void 0 : we.call(H, I);
    }
    function Ps(I, H) {
      var Z = this.__data__;
      return this.size += this.has(I) ? 0 : 1, Z[I] = ue && H === void 0 ? r : H, this;
    }
    sr.prototype.clear = Ho, sr.prototype.delete = Go, sr.prototype.get = Is, sr.prototype.has = zo, sr.prototype.set = Ps;
    function We(I) {
      var H = -1, Z = I == null ? 0 : I.length;
      for (this.clear(); ++H < Z; ) {
        var lt = I[H];
        this.set(lt[0], lt[1]);
      }
    }
    function qh() {
      this.__data__ = [], this.size = 0;
    }
    function Rs(I) {
      var H = this.__data__, Z = $o(H, I);
      if (Z < 0)
        return !1;
      var lt = H.length - 1;
      return Z == lt ? H.pop() : St.call(H, Z, 1), --this.size, !0;
    }
    function yn(I) {
      var H = this.__data__, Z = $o(H, I);
      return Z < 0 ? void 0 : H[Z][1];
    }
    function Bi(I) {
      return $o(this.__data__, I) > -1;
    }
    function Zh(I, H) {
      var Z = this.__data__, lt = $o(Z, I);
      return lt < 0 ? (++this.size, Z.push([I, H])) : Z[lt][1] = H, this;
    }
    We.prototype.clear = qh, We.prototype.delete = Rs, We.prototype.get = yn, We.prototype.has = Bi, We.prototype.set = Zh;
    function br(I) {
      var H = -1, Z = I == null ? 0 : I.length;
      for (this.clear(); ++H < Z; ) {
        var lt = I[H];
        this.set(lt[0], lt[1]);
      }
    }
    function Pv() {
      this.size = 0, this.__data__ = {
        hash: new sr(),
        map: new (te || We)(),
        string: new sr()
      };
    }
    function Rv(I) {
      var H = Xo(this, I).delete(I);
      return this.size -= H ? 1 : 0, H;
    }
    function Dv(I) {
      return Xo(this, I).get(I);
    }
    function Fv(I) {
      return Xo(this, I).has(I);
    }
    function Ov(I, H) {
      var Z = Xo(this, I), lt = Z.size;
      return Z.set(I, H), this.size += Z.size == lt ? 0 : 1, this;
    }
    br.prototype.clear = Pv, br.prototype.delete = Rv, br.prototype.get = Dv, br.prototype.has = Fv, br.prototype.set = Ov;
    function Wo(I) {
      var H = -1, Z = I == null ? 0 : I.length;
      for (this.__data__ = new br(); ++H < Z; )
        this.add(I[H]);
    }
    function Nv(I) {
      return this.__data__.set(I, r), this;
    }
    function kv(I) {
      return this.__data__.has(I);
    }
    Wo.prototype.add = Wo.prototype.push = Nv, Wo.prototype.has = kv;
    function _n(I) {
      var H = this.__data__ = new We(I);
      this.size = H.size;
    }
    function Bv() {
      this.__data__ = new We(), this.size = 0;
    }
    function Lv(I) {
      var H = this.__data__, Z = H.delete(I);
      return this.size = H.size, Z;
    }
    function Uv(I) {
      return this.__data__.get(I);
    }
    function Hv(I) {
      return this.__data__.has(I);
    }
    function Gv(I, H) {
      var Z = this.__data__;
      if (Z instanceof We) {
        var lt = Z.__data__;
        if (!te || lt.length < e - 1)
          return lt.push([I, H]), this.size = ++Z.size, this;
        Z = this.__data__ = new br(lt);
      }
      return Z.set(I, H), this.size = Z.size, this;
    }
    _n.prototype.clear = Bv, _n.prototype.delete = Lv, _n.prototype.get = Uv, _n.prototype.has = Hv, _n.prototype.set = Gv;
    function zv(I, H) {
      var Z = Vo(I), lt = !Z && n1(I), Ft = !Z && !lt && Kh(I), xt = !Z && !lt && !Ft && af(I), $t = Z || lt || Ft || xt, se = $t ? Dt(I.length, String) : [], ce = se.length;
      for (var Bt in I)
        we.call(I, Bt) && !($t && // Safari 9 has enumerable `arguments.length` in strict mode.
        (Bt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        Ft && (Bt == "offset" || Bt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        xt && (Bt == "buffer" || Bt == "byteLength" || Bt == "byteOffset") || // Skip index properties.
        Qv(Bt, ce))) && se.push(Bt);
      return se;
    }
    function $o(I, H) {
      for (var Z = I.length; Z--; )
        if (rf(I[Z][0], H))
          return Z;
      return -1;
    }
    function Wv(I, H, Z) {
      var lt = H(I);
      return Vo(I) ? lt : nt(lt, Z(I));
    }
    function Ds(I) {
      return I == null ? I === void 0 ? M : _ : At && At in Object(I) ? Zv(I) : r1(I);
    }
    function Qd(I) {
      return Fs(I) && Ds(I) == a;
    }
    function Jd(I, H, Z, lt, Ft) {
      return I === H ? !0 : I == null || H == null || !Fs(I) && !Fs(H) ? I !== I && H !== H : $v(I, H, Z, lt, Jd, Ft);
    }
    function $v(I, H, Z, lt, Ft, xt) {
      var $t = Vo(I), se = Vo(H), ce = $t ? h : vn(I), Bt = se ? h : vn(H);
      ce = ce == a ? w : ce, Bt = Bt == a ? w : Bt;
      var De = ce == w, or = Bt == w, fe = ce == Bt;
      if (fe && Kh(I)) {
        if (!Kh(H))
          return !1;
        $t = !0, De = !1;
      }
      if (fe && !De)
        return xt || (xt = new _n()), $t || af(I) ? tf(I, H, Z, lt, Ft, xt) : jv(I, H, ce, Z, lt, Ft, xt);
      if (!(Z & i)) {
        var $e = De && we.call(I, "__wrapped__"), Xe = or && we.call(H, "__wrapped__");
        if ($e || Xe) {
          var xn = $e ? I.value() : I, Xr = Xe ? H.value() : H;
          return xt || (xt = new _n()), Ft(xn, Xr, Z, lt, xt);
        }
      }
      return fe ? (xt || (xt = new _n()), qv(I, H, Z, lt, Ft, xt)) : !1;
    }
    function Xv(I) {
      if (!of(I) || t1(I))
        return !1;
      var H = nf(I) ? jh : B;
      return H.test(Zn(I));
    }
    function Vv(I) {
      return Fs(I) && sf(I.length) && !!V[Ds(I)];
    }
    function Yv(I) {
      if (!e1(I))
        return xr(I);
      var H = [];
      for (var Z in Object(I))
        we.call(I, Z) && Z != "constructor" && H.push(Z);
      return H;
    }
    function tf(I, H, Z, lt, Ft, xt) {
      var $t = Z & i, se = I.length, ce = H.length;
      if (se != ce && !($t && ce > se))
        return !1;
      var Bt = xt.get(I);
      if (Bt && xt.get(H))
        return Bt == H;
      var De = -1, or = !0, fe = Z & s ? new Wo() : void 0;
      for (xt.set(I, H), xt.set(H, I); ++De < se; ) {
        var $e = I[De], Xe = H[De];
        if (lt)
          var xn = $t ? lt(Xe, $e, De, H, I, xt) : lt($e, Xe, De, I, H, xt);
        if (xn !== void 0) {
          if (xn)
            continue;
          or = !1;
          break;
        }
        if (fe) {
          if (!Et(H, function(Xr, Kn) {
            if (!Ge(fe, Kn) && ($e === Xr || Ft($e, Xr, Z, lt, xt)))
              return fe.push(Kn);
          })) {
            or = !1;
            break;
          }
        } else if (!($e === Xe || Ft($e, Xe, Z, lt, xt))) {
          or = !1;
          break;
        }
      }
      return xt.delete(I), xt.delete(H), or;
    }
    function jv(I, H, Z, lt, Ft, xt, $t) {
      switch (Z) {
        case O:
          if (I.byteLength != H.byteLength || I.byteOffset != H.byteOffset)
            return !1;
          I = I.buffer, H = H.buffer;
        case F:
          return !(I.byteLength != H.byteLength || !xt(new $(I), new $(H)));
        case u:
        case c:
        case g:
          return rf(+I, +H);
        case d:
          return I.name == H.name && I.message == H.message;
        case x:
        case y:
          return I == H + "";
        case m:
          var se = Wr;
        case b:
          var ce = lt & i;
          if (se || (se = mn), I.size != H.size && !ce)
            return !1;
          var Bt = $t.get(I);
          if (Bt)
            return Bt == H;
          lt |= s, $t.set(I, H);
          var De = tf(se(I), se(H), lt, Ft, xt, $t);
          return $t.delete(I), De;
        case C:
          if (qn)
            return qn.call(I) == qn.call(H);
      }
      return !1;
    }
    function qv(I, H, Z, lt, Ft, xt) {
      var $t = Z & i, se = ef(I), ce = se.length, Bt = ef(H), De = Bt.length;
      if (ce != De && !$t)
        return !1;
      for (var or = ce; or--; ) {
        var fe = se[or];
        if (!($t ? fe in H : we.call(H, fe)))
          return !1;
      }
      var $e = xt.get(I);
      if ($e && xt.get(H))
        return $e == H;
      var Xe = !0;
      xt.set(I, H), xt.set(H, I);
      for (var xn = $t; ++or < ce; ) {
        fe = se[or];
        var Xr = I[fe], Kn = H[fe];
        if (lt)
          var hf = $t ? lt(Kn, Xr, fe, H, I, xt) : lt(Xr, Kn, fe, I, H, xt);
        if (!(hf === void 0 ? Xr === Kn || Ft(Xr, Kn, Z, lt, xt) : hf)) {
          Xe = !1;
          break;
        }
        xn || (xn = fe == "constructor");
      }
      if (Xe && !xn) {
        var Yo = I.constructor, jo = H.constructor;
        Yo != jo && "constructor" in I && "constructor" in H && !(typeof Yo == "function" && Yo instanceof Yo && typeof jo == "function" && jo instanceof jo) && (Xe = !1);
      }
      return xt.delete(I), xt.delete(H), Xe;
    }
    function ef(I) {
      return Wv(I, o1, Kv);
    }
    function Xo(I, H) {
      var Z = I.__data__;
      return Jv(H) ? Z[typeof H == "string" ? "string" : "hash"] : Z.map;
    }
    function Li(I, H) {
      var Z = ye(I, H);
      return Xv(Z) ? Z : void 0;
    }
    function Zv(I) {
      var H = we.call(I, At), Z = I[At];
      try {
        I[At] = void 0;
        var lt = !0;
      } catch {
      }
      var Ft = ko.call(I);
      return lt && (H ? I[At] = Z : delete I[At]), Ft;
    }
    var Kv = It ? function(I) {
      return I == null ? [] : (I = Object(I), et(It(I), function(H) {
        return Y.call(I, H);
      }));
    } : a1, vn = Ds;
    (ir && vn(new ir(new ArrayBuffer(1))) != O || te && vn(new te()) != m || ze && vn(ze.resolve()) != v || Vn && vn(new Vn()) != b || wr && vn(new wr()) != U) && (vn = function(I) {
      var H = Ds(I), Z = H == w ? I.constructor : void 0, lt = Z ? Zn(Z) : "";
      if (lt)
        switch (lt) {
          case Bo:
            return O;
          case Lo:
            return m;
          case Uo:
            return v;
          case Yn:
            return b;
          case Ms:
            return U;
        }
      return H;
    });
    function Qv(I, H) {
      return H = H ?? o, !!H && (typeof I == "number" || X.test(I)) && I > -1 && I % 1 == 0 && I < H;
    }
    function Jv(I) {
      var H = typeof I;
      return H == "string" || H == "number" || H == "symbol" || H == "boolean" ? I !== "__proto__" : I === null;
    }
    function t1(I) {
      return !!Cs && Cs in I;
    }
    function e1(I) {
      var H = I && I.constructor, Z = typeof H == "function" && H.prototype || Xn;
      return I === Z;
    }
    function r1(I) {
      return ko.call(I);
    }
    function Zn(I) {
      if (I != null) {
        try {
          return gn.call(I);
        } catch {
        }
        try {
          return I + "";
        } catch {
        }
      }
      return "";
    }
    function rf(I, H) {
      return I === H || I !== I && H !== H;
    }
    var n1 = Qd(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? Qd : function(I) {
      return Fs(I) && we.call(I, "callee") && !Y.call(I, "callee");
    }, Vo = Array.isArray;
    function i1(I) {
      return I != null && sf(I.length) && !nf(I);
    }
    var Kh = vt || h1;
    function s1(I, H) {
      return Jd(I, H);
    }
    function nf(I) {
      if (!of(I))
        return !1;
      var H = Ds(I);
      return H == f || H == p || H == l || H == E;
    }
    function sf(I) {
      return typeof I == "number" && I > -1 && I % 1 == 0 && I <= o;
    }
    function of(I) {
      var H = typeof I;
      return I != null && (H == "object" || H == "function");
    }
    function Fs(I) {
      return I != null && typeof I == "object";
    }
    var af = rt ? vr(rt) : Vv;
    function o1(I) {
      return i1(I) ? zv(I) : Yv(I);
    }
    function a1() {
      return [];
    }
    function h1() {
      return !1;
    }
    n.exports = s1;
  })(to, to.exports)), to.exports;
}
var hA = aA();
const fy = /* @__PURE__ */ So(hA);
class rr {
  /** @param {Viewport} parent */
  constructor(t) {
    this.parent = t, this.paused = !1;
  }
  /** Called when plugin is removed */
  destroy() {
  }
  /** Handler for pointerdown PIXI event */
  down(t) {
    return !1;
  }
  /** Handler for pointermove PIXI event */
  move(t) {
    return !1;
  }
  /** Handler for pointerup PIXI event */
  up(t) {
    return !1;
  }
  /** Handler for wheel event on div */
  wheel(t) {
    return !1;
  }
  /**
   * Called on each tick
   * @param {number} elapsed time in millisecond since last update
   */
  update(t) {
  }
  /** Called when the viewport is resized */
  resize() {
  }
  /** Called when the viewport is manually moved */
  reset() {
  }
  /** Pause the plugin */
  pause() {
    this.paused = !0;
  }
  /** Un-pause the plugin */
  resume() {
    this.paused = !1;
  }
}
var lA = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function uA(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var py = { exports: {} };
(function(n, t) {
  (function() {
    var e, r;
    r = function(i) {
      return n.exports = i;
    }, e = {
      linear: function(i, s, o, a) {
        return o * i / a + s;
      },
      easeInQuad: function(i, s, o, a) {
        return o * (i /= a) * i + s;
      },
      easeOutQuad: function(i, s, o, a) {
        return -o * (i /= a) * (i - 2) + s;
      },
      easeInOutQuad: function(i, s, o, a) {
        return (i /= a / 2) < 1 ? o / 2 * i * i + s : -o / 2 * (--i * (i - 2) - 1) + s;
      },
      easeInCubic: function(i, s, o, a) {
        return o * (i /= a) * i * i + s;
      },
      easeOutCubic: function(i, s, o, a) {
        return o * ((i = i / a - 1) * i * i + 1) + s;
      },
      easeInOutCubic: function(i, s, o, a) {
        return (i /= a / 2) < 1 ? o / 2 * i * i * i + s : o / 2 * ((i -= 2) * i * i + 2) + s;
      },
      easeInQuart: function(i, s, o, a) {
        return o * (i /= a) * i * i * i + s;
      },
      easeOutQuart: function(i, s, o, a) {
        return -o * ((i = i / a - 1) * i * i * i - 1) + s;
      },
      easeInOutQuart: function(i, s, o, a) {
        return (i /= a / 2) < 1 ? o / 2 * i * i * i * i + s : -o / 2 * ((i -= 2) * i * i * i - 2) + s;
      },
      easeInQuint: function(i, s, o, a) {
        return o * (i /= a) * i * i * i * i + s;
      },
      easeOutQuint: function(i, s, o, a) {
        return o * ((i = i / a - 1) * i * i * i * i + 1) + s;
      },
      easeInOutQuint: function(i, s, o, a) {
        return (i /= a / 2) < 1 ? o / 2 * i * i * i * i * i + s : o / 2 * ((i -= 2) * i * i * i * i + 2) + s;
      },
      easeInSine: function(i, s, o, a) {
        return -o * Math.cos(i / a * (Math.PI / 2)) + o + s;
      },
      easeOutSine: function(i, s, o, a) {
        return o * Math.sin(i / a * (Math.PI / 2)) + s;
      },
      easeInOutSine: function(i, s, o, a) {
        return -o / 2 * (Math.cos(Math.PI * i / a) - 1) + s;
      },
      easeInExpo: function(i, s, o, a) {
        return i === 0 ? s : o * Math.pow(2, 10 * (i / a - 1)) + s;
      },
      easeOutExpo: function(i, s, o, a) {
        return i === a ? s + o : o * (-Math.pow(2, -10 * i / a) + 1) + s;
      },
      easeInOutExpo: function(i, s, o, a) {
        return (i /= a / 2) < 1 ? o / 2 * Math.pow(2, 10 * (i - 1)) + s : o / 2 * (-Math.pow(2, -10 * --i) + 2) + s;
      },
      easeInCirc: function(i, s, o, a) {
        return -o * (Math.sqrt(1 - (i /= a) * i) - 1) + s;
      },
      easeOutCirc: function(i, s, o, a) {
        return o * Math.sqrt(1 - (i = i / a - 1) * i) + s;
      },
      easeInOutCirc: function(i, s, o, a) {
        return (i /= a / 2) < 1 ? -o / 2 * (Math.sqrt(1 - i * i) - 1) + s : o / 2 * (Math.sqrt(1 - (i -= 2) * i) + 1) + s;
      },
      easeInElastic: function(i, s, o, a) {
        var h, l, u;
        return u = 1.70158, l = 0, h = o, i === 0 || (i /= a), l || (l = a * 0.3), h < Math.abs(o) ? (h = o, u = l / 4) : u = l / (2 * Math.PI) * Math.asin(o / h), -(h * Math.pow(2, 10 * (i -= 1)) * Math.sin((i * a - u) * (2 * Math.PI) / l)) + s;
      },
      easeOutElastic: function(i, s, o, a) {
        var h, l, u;
        return u = 1.70158, l = 0, h = o, i === 0 || (i /= a), l || (l = a * 0.3), h < Math.abs(o) ? (h = o, u = l / 4) : u = l / (2 * Math.PI) * Math.asin(o / h), h * Math.pow(2, -10 * i) * Math.sin((i * a - u) * (2 * Math.PI) / l) + o + s;
      },
      easeInOutElastic: function(i, s, o, a) {
        var h, l, u;
        return u = 1.70158, l = 0, h = o, i === 0 || (i /= a / 2), l || (l = a * (0.3 * 1.5)), h < Math.abs(o) ? (h = o, u = l / 4) : u = l / (2 * Math.PI) * Math.asin(o / h), i < 1 ? -0.5 * (h * Math.pow(2, 10 * (i -= 1)) * Math.sin((i * a - u) * (2 * Math.PI) / l)) + s : h * Math.pow(2, -10 * (i -= 1)) * Math.sin((i * a - u) * (2 * Math.PI) / l) * 0.5 + o + s;
      },
      easeInBack: function(i, s, o, a, h) {
        return h === void 0 && (h = 1.70158), o * (i /= a) * i * ((h + 1) * i - h) + s;
      },
      easeOutBack: function(i, s, o, a, h) {
        return h === void 0 && (h = 1.70158), o * ((i = i / a - 1) * i * ((h + 1) * i + h) + 1) + s;
      },
      easeInOutBack: function(i, s, o, a, h) {
        return h === void 0 && (h = 1.70158), (i /= a / 2) < 1 ? o / 2 * (i * i * (((h *= 1.525) + 1) * i - h)) + s : o / 2 * ((i -= 2) * i * (((h *= 1.525) + 1) * i + h) + 2) + s;
      },
      easeInBounce: function(i, s, o, a) {
        var h;
        return h = e.easeOutBounce(a - i, 0, o, a), o - h + s;
      },
      easeOutBounce: function(i, s, o, a) {
        return (i /= a) < 1 / 2.75 ? o * (7.5625 * i * i) + s : i < 2 / 2.75 ? o * (7.5625 * (i -= 1.5 / 2.75) * i + 0.75) + s : i < 2.5 / 2.75 ? o * (7.5625 * (i -= 2.25 / 2.75) * i + 0.9375) + s : o * (7.5625 * (i -= 2.625 / 2.75) * i + 0.984375) + s;
      },
      easeInOutBounce: function(i, s, o, a) {
        var h;
        return i < a / 2 ? (h = e.easeInBounce(i * 2, 0, o, a), h * 0.5 + s) : (h = e.easeOutBounce(i * 2 - a, 0, o, a), h * 0.5 + o * 0.5 + s);
      }
    }, r(e);
  }).call(lA);
})(py);
var cA = py.exports;
const mm = /* @__PURE__ */ uA(cA);
function Nh(n, t) {
  if (n) {
    if (typeof n == "function")
      return n;
    if (typeof n == "string")
      return mm[n];
  } else
    return mm[t];
}
const dA = {
  removeOnInterrupt: !1,
  ease: "linear",
  time: 1e3
};
class fA extends rr {
  /**
   * This is called by {@link Viewport.animate}.
   *
   * @param parent
   * @param options
   */
  constructor(t, e = {}) {
    super(t), this.startWidth = null, this.startHeight = null, this.deltaWidth = null, this.deltaHeight = null, this.width = null, this.height = null, this.time = 0, this.options = Object.assign({}, dA, e), this.options.ease = Nh(this.options.ease), this.setupPosition(), this.setupZoom(), this.time = 0;
  }
  /**
   * Setup `startX`, `startY`, `deltaX`, `deltaY`, `keepCenter`.
   *
   * This is called during construction.
   */
  setupPosition() {
    typeof this.options.position < "u" ? (this.startX = this.parent.center.x, this.startY = this.parent.center.y, this.deltaX = this.options.position.x - this.parent.center.x, this.deltaY = this.options.position.y - this.parent.center.y, this.keepCenter = !1) : this.keepCenter = !0;
  }
  /**
   * Setup `startWidth, `startHeight`, `deltaWidth, `deltaHeight, `width`, `height`.
   *
   * This is called during construction.
   */
  setupZoom() {
    this.width = null, this.height = null, typeof this.options.scale < "u" ? this.width = this.parent.screenWidth / this.options.scale : typeof this.options.scaleX < "u" || typeof this.options.scaleY < "u" ? (typeof this.options.scaleX < "u" && (this.width = this.parent.screenWidth / this.options.scaleX), typeof this.options.scaleY < "u" && (this.height = this.parent.screenHeight / this.options.scaleY)) : (typeof this.options.width < "u" && (this.width = this.options.width), typeof this.options.height < "u" && (this.height = this.options.height)), this.width !== null && (this.startWidth = this.parent.screenWidthInWorldPixels, this.deltaWidth = this.width - this.startWidth), this.height !== null && (this.startHeight = this.parent.screenHeightInWorldPixels, this.deltaHeight = this.height - this.startHeight);
  }
  down() {
    return this.options.removeOnInterrupt && this.parent.plugins.remove("animate"), !1;
  }
  complete() {
    this.parent.plugins.remove("animate"), this.width !== null && this.parent.fitWidth(this.width, this.keepCenter, this.height === null), this.height !== null && this.parent.fitHeight(this.height, this.keepCenter, this.width === null), !this.keepCenter && this.options.position && this.parent.moveCenter(this.options.position), this.parent.emit("animate-end", this.parent), this.options.callbackOnComplete && this.options.callbackOnComplete(this.parent);
  }
  update(t) {
    if (this.paused)
      return;
    this.time += t;
    const e = new mt(this.parent.scale.x, this.parent.scale.y);
    if (this.time >= this.options.time) {
      const r = this.parent.width, i = this.parent.height;
      this.complete(), (r !== this.parent.width || i !== this.parent.height) && this.parent.emit("zoomed", { viewport: this.parent, original: e, type: "animate" });
    } else {
      const r = this.options.ease(this.time, 0, 1, this.options.time);
      if (this.width !== null) {
        const i = this.startWidth, s = this.deltaWidth;
        this.parent.fitWidth(
          i + s * r,
          this.keepCenter,
          this.height === null
        );
      }
      if (this.height !== null) {
        const i = this.startHeight, s = this.deltaHeight;
        this.parent.fitHeight(
          i + s * r,
          this.keepCenter,
          this.width === null
        );
      }
      if (this.width === null ? this.parent.scale.x = this.parent.scale.y : this.height === null && (this.parent.scale.y = this.parent.scale.x), !this.keepCenter) {
        const i = this.startX, s = this.startY, o = this.deltaX, a = this.deltaY, h = new mt(this.parent.x, this.parent.y);
        this.parent.moveCenter(i + o * r, s + a * r), this.parent.emit("moved", { viewport: this.parent, original: h, type: "animate" });
      }
      (this.width || this.height) && this.parent.emit("zoomed", { viewport: this.parent, original: e, type: "animate" });
    }
  }
}
const pA = {
  sides: "all",
  friction: 0.5,
  time: 150,
  ease: "easeInOutSine",
  underflow: "center",
  bounceBox: null
};
class mA extends rr {
  /**
   * This is called by {@link Viewport.bounce}.
   */
  constructor(t, e = {}) {
    super(t), this.options = Object.assign({}, pA, e), this.ease = Nh(this.options.ease, "easeInOutSine"), this.options.sides ? this.options.sides === "all" ? this.top = this.bottom = this.left = this.right = !0 : this.options.sides === "horizontal" ? (this.right = this.left = !0, this.top = this.bottom = !1) : this.options.sides === "vertical" ? (this.left = this.right = !1, this.top = this.bottom = !0) : (this.top = this.options.sides.indexOf("top") !== -1, this.bottom = this.options.sides.indexOf("bottom") !== -1, this.left = this.options.sides.indexOf("left") !== -1, this.right = this.options.sides.indexOf("right") !== -1) : this.left = this.top = this.right = this.bottom = !1;
    const r = this.options.underflow.toLowerCase();
    r === "center" ? (this.underflowX = 0, this.underflowY = 0) : (this.underflowX = r.indexOf("left") !== -1 ? -1 : r.indexOf("right") !== -1 ? 1 : 0, this.underflowY = r.indexOf("top") !== -1 ? -1 : r.indexOf("bottom") !== -1 ? 1 : 0), this.reset();
  }
  isActive() {
    return this.toX !== null || this.toY !== null;
  }
  down() {
    return this.toX = this.toY = null, !1;
  }
  up() {
    return this.bounce(), !1;
  }
  update(t) {
    if (!this.paused) {
      if (this.bounce(), this.toX) {
        const e = this.toX;
        e.time += t, this.parent.emit("moved", { viewport: this.parent, type: "bounce-x" }), e.time >= this.options.time ? (this.parent.x = e.end, this.toX = null, this.parent.emit("bounce-x-end", this.parent)) : this.parent.x = this.ease(e.time, e.start, e.delta, this.options.time);
      }
      if (this.toY) {
        const e = this.toY;
        e.time += t, this.parent.emit("moved", { viewport: this.parent, type: "bounce-y" }), e.time >= this.options.time ? (this.parent.y = e.end, this.toY = null, this.parent.emit("bounce-y-end", this.parent)) : this.parent.y = this.ease(e.time, e.start, e.delta, this.options.time);
      }
    }
  }
  /** @internal */
  calcUnderflowX() {
    let t;
    switch (this.underflowX) {
      case -1:
        t = 0;
        break;
      case 1:
        t = this.parent.screenWidth - this.parent.screenWorldWidth;
        break;
      default:
        t = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
    }
    return t;
  }
  /** @internal */
  calcUnderflowY() {
    let t;
    switch (this.underflowY) {
      case -1:
        t = 0;
        break;
      case 1:
        t = this.parent.screenHeight - this.parent.screenWorldHeight;
        break;
      default:
        t = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
    }
    return t;
  }
  oob() {
    const t = this.options.bounceBox;
    if (t) {
      const e = typeof t.x > "u" ? 0 : t.x, r = typeof t.y > "u" ? 0 : t.y, i = typeof t.width > "u" ? this.parent.worldWidth : t.width, s = typeof t.height > "u" ? this.parent.worldHeight : t.height;
      return {
        left: this.parent.left < e,
        right: this.parent.right > i,
        top: this.parent.top < r,
        bottom: this.parent.bottom > s,
        topLeft: new mt(
          e * this.parent.scale.x,
          r * this.parent.scale.y
        ),
        bottomRight: new mt(
          i * this.parent.scale.x - this.parent.screenWidth,
          s * this.parent.scale.y - this.parent.screenHeight
        )
      };
    }
    return {
      left: this.parent.left < 0,
      right: this.parent.right > this.parent.worldWidth,
      top: this.parent.top < 0,
      bottom: this.parent.bottom > this.parent.worldHeight,
      topLeft: new mt(0, 0),
      bottomRight: new mt(
        this.parent.worldWidth * this.parent.scale.x - this.parent.screenWidth,
        this.parent.worldHeight * this.parent.scale.y - this.parent.screenHeight
      )
    };
  }
  bounce() {
    var t, e;
    if (this.paused)
      return;
    let r, i = this.parent.plugins.get("decelerate", !0);
    i && (i.x || i.y) && (i.x && i.percentChangeX === ((t = i.options) == null ? void 0 : t.friction) || i.y && i.percentChangeY === ((e = i.options) == null ? void 0 : e.friction)) && (r = this.oob(), (r.left && this.left || r.right && this.right) && (i.percentChangeX = this.options.friction), (r.top && this.top || r.bottom && this.bottom) && (i.percentChangeY = this.options.friction));
    const s = this.parent.plugins.get("drag", !0) || {}, o = this.parent.plugins.get("pinch", !0) || {};
    if (i = i || {}, !(s != null && s.active) && !(o != null && o.active) && (!this.toX || !this.toY) && (!i.x || !i.y)) {
      r = r || this.oob();
      const a = r.topLeft, h = r.bottomRight;
      if (!this.toX && !i.x) {
        let l = null;
        r.left && this.left ? l = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -a.x : r.right && this.right && (l = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -h.x), l !== null && this.parent.x !== l && (this.toX = { time: 0, start: this.parent.x, delta: l - this.parent.x, end: l }, this.parent.emit("bounce-x-start", this.parent));
      }
      if (!this.toY && !i.y) {
        let l = null;
        r.top && this.top ? l = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -a.y : r.bottom && this.bottom && (l = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -h.y), l !== null && this.parent.y !== l && (this.toY = { time: 0, start: this.parent.y, delta: l - this.parent.y, end: l }, this.parent.emit("bounce-y-start", this.parent));
      }
    }
  }
  reset() {
    this.toX = this.toY = null, this.bounce();
  }
}
const gA = {
  left: !1,
  right: !1,
  top: !1,
  bottom: !1,
  direction: null,
  underflow: "center"
};
class yA extends rr {
  /**
   * This is called by {@link Viewport.clamp}.
   */
  constructor(t, e = {}) {
    super(t), this.options = Object.assign({}, gA, e), this.options.direction && (this.options.left = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.right = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.top = this.options.direction === "y" || this.options.direction === "all" ? !0 : null, this.options.bottom = this.options.direction === "y" || this.options.direction === "all" ? !0 : null), this.parseUnderflow(), this.last = { x: null, y: null, scaleX: null, scaleY: null }, this.update();
  }
  parseUnderflow() {
    const t = this.options.underflow.toLowerCase();
    t === "none" ? this.noUnderflow = !0 : t === "center" ? (this.underflowX = this.underflowY = 0, this.noUnderflow = !1) : (this.underflowX = t.indexOf("left") !== -1 ? -1 : t.indexOf("right") !== -1 ? 1 : 0, this.underflowY = t.indexOf("top") !== -1 ? -1 : t.indexOf("bottom") !== -1 ? 1 : 0, this.noUnderflow = !1);
  }
  move() {
    return this.update(), !1;
  }
  update() {
    if (this.paused || this.parent.x === this.last.x && this.parent.y === this.last.y && this.parent.scale.x === this.last.scaleX && this.parent.scale.y === this.last.scaleY)
      return;
    const t = new mt(this.parent.x, this.parent.y), e = this.parent.plugins.decelerate || {};
    if (this.options.left !== null || this.options.right !== null) {
      let r = !1;
      if (!this.noUnderflow && this.parent.screenWorldWidth < this.parent.screenWidth)
        switch (this.underflowX) {
          case -1:
            this.parent.x !== 0 && (this.parent.x = 0, r = !0);
            break;
          case 1:
            this.parent.x !== this.parent.screenWidth - this.parent.screenWorldWidth && (this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth, r = !0);
            break;
          default:
            this.parent.x !== (this.parent.screenWidth - this.parent.screenWorldWidth) / 2 && (this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2, r = !0);
        }
      else
        this.options.left !== null && this.parent.left < (this.options.left === !0 ? 0 : this.options.left) && (this.parent.x = -(this.options.left === !0 ? 0 : this.options.left) * this.parent.scale.x, e.x = 0, r = !0), this.options.right !== null && this.parent.right > (this.options.right === !0 ? this.parent.worldWidth : this.options.right) && (this.parent.x = -(this.options.right === !0 ? this.parent.worldWidth : this.options.right) * this.parent.scale.x + this.parent.screenWidth, e.x = 0, r = !0);
      r && this.parent.emit("moved", { viewport: this.parent, original: t, type: "clamp-x" });
    }
    if (this.options.top !== null || this.options.bottom !== null) {
      let r = !1;
      if (!this.noUnderflow && this.parent.screenWorldHeight < this.parent.screenHeight)
        switch (this.underflowY) {
          case -1:
            this.parent.y !== 0 && (this.parent.y = 0, r = !0);
            break;
          case 1:
            this.parent.y !== this.parent.screenHeight - this.parent.screenWorldHeight && (this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight, r = !0);
            break;
          default:
            this.parent.y !== (this.parent.screenHeight - this.parent.screenWorldHeight) / 2 && (this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2, r = !0);
        }
      else
        this.options.top !== null && this.parent.top < (this.options.top === !0 ? 0 : this.options.top) && (this.parent.y = -(this.options.top === !0 ? 0 : this.options.top) * this.parent.scale.y, e.y = 0, r = !0), this.options.bottom !== null && this.parent.bottom > (this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) && (this.parent.y = -(this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) * this.parent.scale.y + this.parent.screenHeight, e.y = 0, r = !0);
      r && this.parent.emit("moved", { viewport: this.parent, original: t, type: "clamp-y" });
    }
    this.last.x = this.parent.x, this.last.y = this.parent.y, this.last.scaleX = this.parent.scale.x, this.last.scaleY = this.parent.scale.y;
  }
  reset() {
    this.update();
  }
}
const _A = {
  minWidth: null,
  minHeight: null,
  maxWidth: null,
  maxHeight: null,
  minScale: null,
  maxScale: null
};
class vA extends rr {
  /**
   * This is called by {@link Viewport.clampZoom}.
   */
  constructor(t, e = {}) {
    super(t), this.options = Object.assign({}, _A, e), this.clamp();
  }
  resize() {
    this.clamp();
  }
  /** Clamp the viewport scale zoom) */
  clamp() {
    if (!this.paused) {
      if (this.options.minWidth || this.options.minHeight || this.options.maxWidth || this.options.maxHeight) {
        let t = this.parent.worldScreenWidth, e = this.parent.worldScreenHeight;
        if (this.options.minWidth !== null && t < this.options.minWidth) {
          const r = this.parent.scale.x;
          this.parent.fitWidth(this.options.minWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / r, t = this.parent.worldScreenWidth, e = this.parent.worldScreenHeight, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
        if (this.options.maxWidth !== null && t > this.options.maxWidth) {
          const r = this.parent.scale.x;
          this.parent.fitWidth(this.options.maxWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / r, t = this.parent.worldScreenWidth, e = this.parent.worldScreenHeight, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
        if (this.options.minHeight !== null && e < this.options.minHeight) {
          const r = this.parent.scale.y;
          this.parent.fitHeight(this.options.minHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / r, t = this.parent.worldScreenWidth, e = this.parent.worldScreenHeight, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
        if (this.options.maxHeight !== null && e > this.options.maxHeight) {
          const r = this.parent.scale.y;
          this.parent.fitHeight(this.options.maxHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / r, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
      } else if (this.options.minScale || this.options.maxScale) {
        const t = { x: null, y: null }, e = { x: null, y: null };
        if (typeof this.options.minScale == "number")
          t.x = this.options.minScale, t.y = this.options.minScale;
        else if (this.options.minScale !== null) {
          const s = this.options.minScale;
          t.x = typeof s.x > "u" ? null : s.x, t.y = typeof s.y > "u" ? null : s.y;
        }
        if (typeof this.options.maxScale == "number")
          e.x = this.options.maxScale, e.y = this.options.maxScale;
        else if (this.options.maxScale !== null) {
          const s = this.options.maxScale;
          e.x = typeof s.x > "u" ? null : s.x, e.y = typeof s.y > "u" ? null : s.y;
        }
        let r = this.parent.scale.x, i = this.parent.scale.y;
        t.x !== null && r < t.x && (r = t.x), e.x !== null && r > e.x && (r = e.x), t.y !== null && i < t.y && (i = t.y), e.y !== null && i > e.y && (i = e.y), (r !== this.parent.scale.x || i !== this.parent.scale.y) && (this.parent.scale.set(r, i), this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" }));
      }
    }
  }
  reset() {
    this.clamp();
  }
}
const xA = {
  friction: 0.98,
  bounce: 0.8,
  minSpeed: 0.01
}, bn = 16;
class wA extends rr {
  /**
   * This is called by {@link Viewport.decelerate}.
   */
  constructor(t, e = {}) {
    super(t), this.options = Object.assign({}, xA, e), this.saved = [], this.timeSinceRelease = 0, this.reset(), this.parent.on("moved", (r) => this.handleMoved(r));
  }
  down() {
    return this.saved = [], this.x = this.y = null, !1;
  }
  isActive() {
    return !!(this.x || this.y);
  }
  move() {
    if (this.paused)
      return !1;
    const t = this.parent.input.count();
    return (t === 1 || t > 1 && !this.parent.plugins.get("pinch", !0)) && (this.saved.push({ x: this.parent.x, y: this.parent.y, time: performance.now() }), this.saved.length > 60 && this.saved.splice(0, 30)), !1;
  }
  /** Listener to viewport's "moved" event. */
  handleMoved(t) {
    if (this.saved.length) {
      const e = this.saved[this.saved.length - 1];
      t.type === "clamp-x" && t.original ? e.x === t.original.x && (e.x = this.parent.x) : t.type === "clamp-y" && t.original && e.y === t.original.y && (e.y = this.parent.y);
    }
  }
  up() {
    if (this.parent.input.count() === 0 && this.saved.length) {
      const t = performance.now();
      for (const e of this.saved)
        if (e.time >= t - 100) {
          const r = t - e.time;
          this.x = (this.parent.x - e.x) / r, this.y = (this.parent.y - e.y) / r, this.percentChangeX = this.percentChangeY = this.options.friction, this.timeSinceRelease = 0;
          break;
        }
    }
    return !1;
  }
  /**
   * Manually activate deceleration, starting from the (x, y) velocity components passed in the options.
   *
   * @param {object} options
   * @param {number} [options.x] - Specify x-component of initial velocity.
   * @param {number} [options.y] - Specify y-component of initial velocity.
   */
  activate(t) {
    t = t || {}, typeof t.x < "u" && (this.x = t.x, this.percentChangeX = this.options.friction), typeof t.y < "u" && (this.y = t.y, this.percentChangeY = this.options.friction);
  }
  update(t) {
    if (this.paused)
      return;
    const e = this.x || this.y, r = this.timeSinceRelease, i = this.timeSinceRelease + t;
    if (this.x) {
      const s = this.percentChangeX, o = Math.log(s);
      this.parent.x += this.x * bn / o * (Math.pow(s, i / bn) - Math.pow(s, r / bn)), this.x *= Math.pow(this.percentChangeX, t / bn);
    }
    if (this.y) {
      const s = this.percentChangeY, o = Math.log(s);
      this.parent.y += this.y * bn / o * (Math.pow(s, i / bn) - Math.pow(s, r / bn)), this.y *= Math.pow(this.percentChangeY, t / bn);
    }
    this.timeSinceRelease += t, this.x && this.y ? Math.abs(this.x) < this.options.minSpeed && Math.abs(this.y) < this.options.minSpeed && (this.x = 0, this.y = 0) : (Math.abs(this.x || 0) < this.options.minSpeed && (this.x = 0), Math.abs(this.y || 0) < this.options.minSpeed && (this.y = 0)), e && this.parent.emit("moved", { viewport: this.parent, type: "decelerate" });
  }
  reset() {
    this.x = this.y = null;
  }
}
const bA = {
  direction: "all",
  pressDrag: !0,
  wheel: !0,
  wheelScroll: 1,
  reverse: !1,
  clampWheel: !1,
  underflow: "center",
  factor: 1,
  mouseButtons: "all",
  keyToPress: null,
  ignoreKeyToPressOnTouch: !1,
  lineHeight: 20,
  wheelSwapAxes: !1
};
class TA extends rr {
  /**
   * This is called by {@link Viewport.drag}.
   */
  constructor(t, e = {}) {
    super(t), this.windowEventHandlers = [], this.options = Object.assign({}, bA, e), this.moved = !1, this.reverse = this.options.reverse ? 1 : -1, this.xDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "x", this.yDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "y", this.keyIsPressed = !1, this.parseUnderflow(), this.mouseButtons(this.options.mouseButtons), this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
  }
  /**
   * Handles keypress events and set the keyIsPressed boolean accordingly
   *
   * @param {array} codes - key codes that can be used to trigger drag event
   */
  handleKeyPresses(t) {
    const e = (i) => {
      t.includes(i.code) && (this.keyIsPressed = !0);
    }, r = (i) => {
      t.includes(i.code) && (this.keyIsPressed = !1);
    };
    this.addWindowEventHandler("keyup", r), this.addWindowEventHandler("keydown", e);
  }
  addWindowEventHandler(t, e) {
    typeof window > "u" || (window.addEventListener(t, e), this.windowEventHandlers.push({ event: t, handler: e }));
  }
  destroy() {
    typeof window > "u" || this.windowEventHandlers.forEach(({ event: t, handler: e }) => {
      window.removeEventListener(t, e);
    });
  }
  /**
   * initialize mousebuttons array
   * @param {string} buttons
   */
  mouseButtons(t) {
    !t || t === "all" ? this.mouse = [!0, !0, !0] : this.mouse = [
      t.indexOf("left") !== -1,
      t.indexOf("middle") !== -1,
      t.indexOf("right") !== -1
    ];
  }
  parseUnderflow() {
    const t = this.options.underflow.toLowerCase();
    t === "center" ? (this.underflowX = 0, this.underflowY = 0) : (t.includes("left") ? this.underflowX = -1 : t.includes("right") ? this.underflowX = 1 : this.underflowX = 0, t.includes("top") ? this.underflowY = -1 : t.includes("bottom") ? this.underflowY = 1 : this.underflowY = 0);
  }
  /**
   * @param {PIXI.FederatedPointerEvent} event
   * @returns {boolean}
   */
  checkButtons(t) {
    const e = t.pointerType === "mouse", r = this.parent.input.count();
    return !!((r === 1 || r > 1 && !this.parent.plugins.get("pinch", !0)) && (!e || this.mouse[t.button]));
  }
  /**
   * @param {PIXI.FederatedPointerEvent} event
   * @returns {boolean}
   */
  checkKeyPress(t) {
    return !this.options.keyToPress || this.keyIsPressed || this.options.ignoreKeyToPressOnTouch && t.data.pointerType === "touch";
  }
  down(t) {
    return this.paused || !this.options.pressDrag ? !1 : this.checkButtons(t) && this.checkKeyPress(t) ? (this.last = { x: t.global.x, y: t.global.y }, this.current = t.pointerId, !0) : (this.last = null, !1);
  }
  get active() {
    return this.moved;
  }
  move(t) {
    if (this.paused || !this.options.pressDrag)
      return !1;
    if (this.last && this.current === t.data.pointerId) {
      const e = t.global.x, r = t.global.y, i = this.parent.input.count();
      if (i === 1 || i > 1 && !this.parent.plugins.get("pinch", !0)) {
        const s = e - this.last.x, o = r - this.last.y;
        if (this.moved || this.xDirection && this.parent.input.checkThreshold(s) || this.yDirection && this.parent.input.checkThreshold(o)) {
          const a = { x: e, y: r };
          return this.xDirection && (this.parent.x += (a.x - this.last.x) * this.options.factor), this.yDirection && (this.parent.y += (a.y - this.last.y) * this.options.factor), this.last = a, this.moved || this.parent.emit("drag-start", {
            event: t,
            screen: new mt(this.last.x, this.last.y),
            world: this.parent.toWorld(new mt(this.last.x, this.last.y)),
            viewport: this.parent
          }), this.moved = !0, this.parent.emit("moved", { viewport: this.parent, type: "drag" }), !0;
        }
      } else
        this.moved = !1;
    }
    return !1;
  }
  up(t) {
    if (this.paused)
      return !1;
    const e = this.parent.input.touches;
    if (e.length === 1) {
      const r = e[0];
      return r.last && (this.last = { x: r.last.x, y: r.last.y }, this.current = r.id), this.moved = !1, !0;
    } else if (this.last && this.moved) {
      const r = new mt(this.last.x, this.last.y);
      return this.parent.emit("drag-end", {
        event: t,
        screen: r,
        world: this.parent.toWorld(r),
        viewport: this.parent
      }), this.last = null, this.moved = !1, !0;
    }
    return !1;
  }
  wheel(t) {
    if (this.paused)
      return !1;
    if (this.options.wheel) {
      const e = this.parent.plugins.get("wheel", !0);
      if (!e || !e.options.wheelZoom && !t.ctrlKey) {
        const r = t.deltaMode ? this.options.lineHeight : 1, i = [t.deltaX, t.deltaY], [s, o] = this.options.wheelSwapAxes ? i.reverse() : i;
        return this.xDirection && (this.parent.x += s * r * this.options.wheelScroll * this.reverse), this.yDirection && (this.parent.y += o * r * this.options.wheelScroll * this.reverse), this.options.clampWheel && this.clamp(), this.parent.emit("wheel-scroll", this.parent), this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.parent.options.passiveWheel || t.preventDefault(), this.parent.options.stopPropagation && t.stopPropagation(), !0;
      }
    }
    return !1;
  }
  resume() {
    this.last = null, this.paused = !1;
  }
  clamp() {
    const t = this.parent.plugins.get("decelerate", !0) || {};
    if (this.options.clampWheel !== "y")
      if (this.parent.screenWorldWidth < this.parent.screenWidth)
        switch (this.underflowX) {
          case -1:
            this.parent.x = 0;
            break;
          case 1:
            this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth;
            break;
          default:
            this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
        }
      else
        this.parent.left < 0 ? (this.parent.x = 0, t.x = 0) : this.parent.right > this.parent.worldWidth && (this.parent.x = -this.parent.worldWidth * this.parent.scale.x + this.parent.screenWidth, t.x = 0);
    if (this.options.clampWheel !== "x")
      if (this.parent.screenWorldHeight < this.parent.screenHeight)
        switch (this.underflowY) {
          case -1:
            this.parent.y = 0;
            break;
          case 1:
            this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight;
            break;
          default:
            this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
        }
      else
        this.parent.top < 0 && (this.parent.y = 0, t.y = 0), this.parent.bottom > this.parent.worldHeight && (this.parent.y = -this.parent.worldHeight * this.parent.scale.y + this.parent.screenHeight, t.y = 0);
  }
}
const AA = {
  speed: 0,
  acceleration: null,
  radius: null
};
class EA extends rr {
  /**
   * This is called by {@link Viewport.follow}.
   *
   * @param parent
   * @param target - target to follow
   * @param options
   */
  constructor(t, e, r = {}) {
    super(t), this.target = e, this.options = Object.assign({}, AA, r), this.velocity = { x: 0, y: 0 };
  }
  update(t) {
    if (this.paused)
      return;
    const e = this.parent.center;
    let r = this.target.x, i = this.target.y;
    if (this.options.radius)
      if (Math.sqrt(Math.pow(this.target.y - e.y, 2) + Math.pow(this.target.x - e.x, 2)) > this.options.radius) {
        const a = Math.atan2(this.target.y - e.y, this.target.x - e.x);
        r = this.target.x - Math.cos(a) * this.options.radius, i = this.target.y - Math.sin(a) * this.options.radius;
      } else
        return;
    const s = r - e.x, o = i - e.y;
    if (s || o)
      if (this.options.speed)
        if (this.options.acceleration) {
          const a = Math.atan2(i - e.y, r - e.x), h = Math.sqrt(Math.pow(s, 2) + Math.pow(o, 2));
          if (h) {
            const l = (Math.pow(this.velocity.x, 2) + Math.pow(this.velocity.y, 2)) / (2 * this.options.acceleration);
            h > l ? this.velocity = {
              x: Math.min(this.velocity.x + (this.options.acceleration * t, this.options.speed)),
              y: Math.min(this.velocity.y + (this.options.acceleration * t, this.options.speed))
            } : this.velocity = {
              x: Math.max(this.velocity.x - this.options.acceleration * this.options.speed, 0),
              y: Math.max(this.velocity.y - this.options.acceleration * this.options.speed, 0)
            };
            const u = Math.cos(a) * this.velocity.x, c = Math.sin(a) * this.velocity.y, d = Math.abs(u) > Math.abs(s) ? r : e.x + u, f = Math.abs(c) > Math.abs(o) ? i : e.y + c;
            this.parent.moveCenter(d, f), this.parent.emit("moved", { viewport: this.parent, type: "follow" });
          }
        } else {
          const a = Math.atan2(i - e.y, r - e.x), h = Math.cos(a) * this.options.speed, l = Math.sin(a) * this.options.speed, u = Math.abs(h) > Math.abs(s) ? r : e.x + h, c = Math.abs(l) > Math.abs(o) ? i : e.y + l;
          this.parent.moveCenter(u, c), this.parent.emit("moved", { viewport: this.parent, type: "follow" });
        }
      else
        this.parent.moveCenter(r, i), this.parent.emit("moved", { viewport: this.parent, type: "follow" });
  }
}
const SA = {
  radius: null,
  distance: null,
  top: null,
  bottom: null,
  left: null,
  right: null,
  speed: 8,
  reverse: !1,
  noDecelerate: !1,
  linear: !1,
  allowButtons: !1
};
class CA extends rr {
  /**
   * This is called by {@link Viewport.mouseEdges}.
   */
  constructor(t, e = {}) {
    super(t), this.options = Object.assign({}, SA, e), this.reverse = this.options.reverse ? 1 : -1, this.radiusSquared = typeof this.options.radius == "number" ? Math.pow(this.options.radius, 2) : null, this.resize();
  }
  resize() {
    const t = this.options.distance;
    t !== null ? (this.left = t, this.top = t, this.right = this.parent.screenWidth - t, this.bottom = this.parent.screenHeight - t) : this.options.radius || (this.left = this.options.left, this.top = this.options.top, this.right = this.options.right === null ? null : this.parent.screenWidth - this.options.right, this.bottom = this.options.bottom === null ? null : this.parent.screenHeight - this.options.bottom);
  }
  down() {
    return this.paused || this.options.allowButtons || (this.horizontal = this.vertical = null), !1;
  }
  move(t) {
    if (this.paused || t.pointerType !== "mouse" && t.pointerId !== 1 || !this.options.allowButtons && t.buttons !== 0)
      return !1;
    const e = t.global.x, r = t.global.y;
    if (this.radiusSquared) {
      const i = this.parent.toScreen(this.parent.center);
      if (Math.pow(i.x - e, 2) + Math.pow(i.y - r, 2) >= this.radiusSquared) {
        const s = Math.atan2(i.y - r, i.x - e);
        this.options.linear ? (this.horizontal = Math.round(Math.cos(s)) * this.options.speed * this.reverse * (60 / 1e3), this.vertical = Math.round(Math.sin(s)) * this.options.speed * this.reverse * (60 / 1e3)) : (this.horizontal = Math.cos(s) * this.options.speed * this.reverse * (60 / 1e3), this.vertical = Math.sin(s) * this.options.speed * this.reverse * (60 / 1e3));
      } else
        this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = 0;
    } else
      this.left !== null && e < this.left ? this.horizontal = Number(this.reverse) * this.options.speed * (60 / 1e3) : this.right !== null && e > this.right ? this.horizontal = -1 * this.reverse * this.options.speed * (60 / 1e3) : (this.decelerateHorizontal(), this.horizontal = 0), this.top !== null && r < this.top ? this.vertical = Number(this.reverse) * this.options.speed * (60 / 1e3) : this.bottom !== null && r > this.bottom ? this.vertical = -1 * this.reverse * this.options.speed * (60 / 1e3) : (this.decelerateVertical(), this.vertical = 0);
    return !1;
  }
  decelerateHorizontal() {
    const t = this.parent.plugins.get("decelerate", !0);
    this.horizontal && t && !this.options.noDecelerate && t.activate({ x: this.horizontal * this.options.speed * this.reverse / (1e3 / 60) });
  }
  decelerateVertical() {
    const t = this.parent.plugins.get("decelerate", !0);
    this.vertical && t && !this.options.noDecelerate && t.activate({ y: this.vertical * this.options.speed * this.reverse / (1e3 / 60) });
  }
  up() {
    return this.paused || (this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = null), !1;
  }
  update() {
    if (!this.paused && (this.horizontal || this.vertical)) {
      const t = this.parent.center;
      this.horizontal && (t.x += this.horizontal * this.options.speed), this.vertical && (t.y += this.vertical * this.options.speed), this.parent.moveCenter(t), this.parent.emit("moved", { viewport: this.parent, type: "mouse-edges" });
    }
  }
}
const MA = {
  noDrag: !1,
  percent: 1,
  center: null,
  factor: 1,
  axis: "all"
};
class IA extends rr {
  /**
   * This is called by {@link Viewport.pinch}.
   */
  constructor(t, e = {}) {
    super(t), this.active = !1, this.pinching = !1, this.moved = !1, this.options = Object.assign({}, MA, e);
  }
  down() {
    return this.parent.input.count() >= 2 ? (this.active = !0, !0) : !1;
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  move(t) {
    if (this.paused || !this.active)
      return !1;
    const e = t.global.x, r = t.global.y, i = this.parent.input.touches;
    if (i.length >= 2) {
      const s = i[0], o = i[1], a = s.last && o.last ? Math.sqrt(Math.pow(o.last.x - s.last.x, 2) + Math.pow(o.last.y - s.last.y, 2)) : null;
      if (s.id === t.pointerId ? s.last = { x: e, y: r, data: t } : o.id === t.pointerId && (o.last = { x: e, y: r, data: t }), a) {
        let h;
        const l = new mt(
          s.last.x + (o.last.x - s.last.x) / 2,
          s.last.y + (o.last.y - s.last.y) / 2
        );
        this.options.center || (h = this.parent.toLocal(l));
        let u = Math.sqrt(Math.pow(
          o.last.x - s.last.x,
          2
        ) + Math.pow(o.last.y - s.last.y, 2));
        u = u === 0 ? u = 1e-10 : u;
        const c = (1 - a / u) * this.options.percent * (this.isAxisX() ? this.parent.scale.x : this.parent.scale.y);
        this.isAxisX() && (this.parent.scale.x += c), this.isAxisY() && (this.parent.scale.y += c), this.parent.emit("zoomed", { viewport: this.parent, type: "pinch", center: l });
        const d = this.parent.plugins.get("clamp-zoom", !0);
        if (d && d.clamp(), this.options.center)
          this.parent.moveCenter(this.options.center);
        else {
          const f = this.parent.toGlobal(h);
          this.parent.x += (l.x - f.x) * this.options.factor, this.parent.y += (l.y - f.y) * this.options.factor, this.parent.emit("moved", { viewport: this.parent, type: "pinch" });
        }
        !this.options.noDrag && this.lastCenter && (this.parent.x += (l.x - this.lastCenter.x) * this.options.factor, this.parent.y += (l.y - this.lastCenter.y) * this.options.factor, this.parent.emit("moved", { viewport: this.parent, type: "pinch" })), this.lastCenter = l, this.moved = !0;
      } else
        this.pinching || (this.parent.emit("pinch-start", this.parent), this.pinching = !0);
      return !0;
    }
    return !1;
  }
  up() {
    return this.pinching && this.parent.input.touches.length <= 1 ? (this.active = !1, this.lastCenter = null, this.pinching = !1, this.moved = !1, this.parent.emit("pinch-end", this.parent), !0) : !1;
  }
}
const PA = {
  topLeft: !1,
  friction: 0.8,
  time: 1e3,
  ease: "easeInOutSine",
  interrupt: !0,
  removeOnComplete: !1,
  removeOnInterrupt: !1,
  forceStart: !1
};
class RA extends rr {
  /**
   * This is called by {@link Viewport.snap}.
   */
  constructor(t, e, r, i = {}) {
    super(t), this.options = Object.assign({}, PA, i), this.ease = Nh(i.ease, "easeInOutSine"), this.x = e, this.y = r, this.options.forceStart && this.snapStart();
  }
  snapStart() {
    this.percent = 0, this.snapping = { time: 0 };
    const t = this.options.topLeft ? this.parent.corner : this.parent.center;
    this.deltaX = this.x - t.x, this.deltaY = this.y - t.y, this.startX = t.x, this.startY = t.y, this.parent.emit("snap-start", this.parent);
  }
  wheel() {
    return this.options.removeOnInterrupt && this.parent.plugins.remove("snap"), !1;
  }
  down() {
    return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap") : this.options.interrupt && (this.snapping = null), !1;
  }
  up() {
    if (this.parent.input.count() === 0) {
      const t = this.parent.plugins.get("decelerate", !0);
      t && (t.x || t.y) && (t.percentChangeX = t.percentChangeY = this.options.friction);
    }
    return !1;
  }
  update(t) {
    if (!this.paused && !(this.options.interrupt && this.parent.input.count() !== 0))
      if (this.snapping) {
        const e = this.snapping;
        e.time += t;
        let r, i, s;
        const o = this.startX, a = this.startY, h = this.deltaX, l = this.deltaY;
        if (e.time > this.options.time)
          r = !0, i = o + h, s = a + l;
        else {
          const u = this.ease(e.time, 0, 1, this.options.time);
          i = o + h * u, s = a + l * u;
        }
        this.options.topLeft ? this.parent.moveCorner(i, s) : this.parent.moveCenter(i, s), this.parent.emit("moved", { viewport: this.parent, type: "snap" }), r && (this.options.removeOnComplete && this.parent.plugins.remove("snap"), this.parent.emit("snap-end", this.parent), this.snapping = null);
      } else {
        const e = this.options.topLeft ? this.parent.corner : this.parent.center;
        (e.x !== this.x || e.y !== this.y) && this.snapStart();
      }
  }
}
const DA = {
  width: 0,
  height: 0,
  time: 1e3,
  ease: "easeInOutSine",
  center: null,
  interrupt: !0,
  removeOnComplete: !1,
  removeOnInterrupt: !1,
  forceStart: !1,
  noMove: !1
};
class FA extends rr {
  /**
   * This is called by {@link Viewport.snapZoom}.
   */
  constructor(t, e = {}) {
    super(t), this.options = Object.assign({}, DA, e), this.ease = Nh(this.options.ease), this.xIndependent = !1, this.yIndependent = !1, this.xScale = 0, this.yScale = 0, this.options.width > 0 && (this.xScale = t.screenWidth / this.options.width, this.xIndependent = !0), this.options.height > 0 && (this.yScale = t.screenHeight / this.options.height, this.yIndependent = !0), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale, this.options.time === 0 ? (t.container.scale.x = this.xScale, t.container.scale.y = this.yScale, this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom")) : e.forceStart && this.createSnapping();
  }
  createSnapping() {
    const t = this.parent.worldScreenWidth, e = this.parent.worldScreenHeight, r = this.parent.screenWidth / this.xScale, i = this.parent.screenHeight / this.yScale;
    this.snapping = {
      time: 0,
      startX: t,
      startY: e,
      deltaX: r - t,
      deltaY: i - e
    }, this.parent.emit("snap-zoom-start", this.parent);
  }
  resize() {
    this.snapping = null, this.options.width > 0 && (this.xScale = this.parent.screenWidth / this.options.width), this.options.height > 0 && (this.yScale = this.parent.screenHeight / this.options.height), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale;
  }
  wheel() {
    return this.options.removeOnInterrupt && this.parent.plugins.remove("snap-zoom"), !1;
  }
  down() {
    return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap-zoom") : this.options.interrupt && (this.snapping = null), !1;
  }
  update(t) {
    if (this.paused || this.options.interrupt && this.parent.input.count() !== 0)
      return;
    let e;
    if (!this.options.center && !this.options.noMove && (e = this.parent.center), !this.snapping)
      (this.parent.scale.x !== this.xScale || this.parent.scale.y !== this.yScale) && this.createSnapping();
    else if (this.snapping) {
      const r = this.snapping;
      if (r.time += t, r.time >= this.options.time)
        this.parent.scale.set(this.xScale, this.yScale), this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom"), this.parent.emit("snap-zoom-end", this.parent), this.snapping = null;
      else {
        const s = this.snapping, o = this.ease(s.time, s.startX, s.deltaX, this.options.time), a = this.ease(s.time, s.startY, s.deltaY, this.options.time);
        this.parent.scale.x = this.parent.screenWidth / o, this.parent.scale.y = this.parent.screenHeight / a;
      }
      const i = this.parent.plugins.get("clamp-zoom", !0);
      i && i.clamp(), this.options.noMove || (this.options.center ? this.parent.moveCenter(this.options.center) : this.parent.moveCenter(e));
    }
  }
  resume() {
    this.snapping = null, super.resume();
  }
}
const OA = {
  percent: 0.1,
  smooth: !1,
  interrupt: !0,
  reverse: !1,
  center: null,
  lineHeight: 20,
  axis: "all",
  keyToPress: null,
  trackpadPinch: !1,
  wheelZoom: !0
};
class NA extends rr {
  /**
   * This is called by {@link Viewport.wheel}.
   */
  constructor(t, e = {}) {
    super(t), this.options = Object.assign({}, OA, e), this.keyIsPressed = !1, this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
  }
  /**
   * Handles keypress events and set the keyIsPressed boolean accordingly
   *
   * @param {array} codes - key codes that can be used to trigger zoom event
   */
  handleKeyPresses(t) {
    typeof window > "u" || (window.addEventListener("keydown", (e) => {
      t.includes(e.code) && (this.keyIsPressed = !0);
    }), window.addEventListener("keyup", (e) => {
      t.includes(e.code) && (this.keyIsPressed = !1);
    }));
  }
  checkKeyPress() {
    return !this.options.keyToPress || this.keyIsPressed;
  }
  down() {
    return this.options.interrupt && (this.smoothing = null), !1;
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  update() {
    if (this.smoothing) {
      const t = this.smoothingCenter, e = this.smoothing;
      let r;
      this.options.center || (r = this.parent.toLocal(t)), this.isAxisX() && (this.parent.scale.x += e.x), this.isAxisY() && (this.parent.scale.y += e.y), this.parent.emit("zoomed", { viewport: this.parent, type: "wheel" });
      const i = this.parent.plugins.get("clamp-zoom", !0);
      if (i && i.clamp(), this.options.center)
        this.parent.moveCenter(this.options.center);
      else {
        const s = this.parent.toGlobal(r);
        this.parent.x += t.x - s.x, this.parent.y += t.y - s.y;
      }
      this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.smoothingCount++, this.smoothingCount >= this.options.smooth && (this.smoothing = null);
    }
  }
  pinch(t) {
    if (this.paused)
      return;
    const e = this.parent.input.getPointerPosition(t), r = -t.deltaY * (t.deltaMode ? this.options.lineHeight : 1) / 200, i = Math.pow(2, (1 + this.options.percent) * r);
    let s;
    this.options.center || (s = this.parent.toLocal(e)), this.isAxisX() && (this.parent.scale.x *= i), this.isAxisY() && (this.parent.scale.y *= i), this.parent.emit("zoomed", { viewport: this.parent, type: "wheel" });
    const o = this.parent.plugins.get("clamp-zoom", !0);
    if (o && o.clamp(), this.options.center)
      this.parent.moveCenter(this.options.center);
    else {
      const a = this.parent.toGlobal(s);
      this.parent.x += e.x - a.x, this.parent.y += e.y - a.y;
    }
    this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.parent.emit(
      "wheel-start",
      { event: t, viewport: this.parent }
    );
  }
  wheel(t) {
    if (this.paused || !this.checkKeyPress())
      return !1;
    if (t.ctrlKey && this.options.trackpadPinch)
      this.pinch(t);
    else if (this.options.wheelZoom) {
      const e = this.parent.input.getPointerPosition(t), r = (this.options.reverse ? -1 : 1) * -t.deltaY * (t.deltaMode ? this.options.lineHeight : 1) / 500, i = Math.pow(2, (1 + this.options.percent) * r);
      if (this.options.smooth) {
        const s = {
          x: this.smoothing ? this.smoothing.x * (this.options.smooth - this.smoothingCount) : 0,
          y: this.smoothing ? this.smoothing.y * (this.options.smooth - this.smoothingCount) : 0
        };
        this.smoothing = {
          x: ((this.parent.scale.x + s.x) * i - this.parent.scale.x) / this.options.smooth,
          y: ((this.parent.scale.y + s.y) * i - this.parent.scale.y) / this.options.smooth
        }, this.smoothingCount = 0, this.smoothingCenter = e;
      } else {
        let s;
        this.options.center || (s = this.parent.toLocal(e)), this.isAxisX() && (this.parent.scale.x *= i), this.isAxisY() && (this.parent.scale.y *= i), this.parent.emit("zoomed", { viewport: this.parent, type: "wheel" });
        const o = this.parent.plugins.get("clamp-zoom", !0);
        if (o && o.clamp(), this.options.center)
          this.parent.moveCenter(this.options.center);
        else {
          const a = this.parent.toGlobal(s);
          this.parent.x += e.x - a.x, this.parent.y += e.y - a.y;
        }
      }
      this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.parent.emit(
        "wheel-start",
        { event: t, viewport: this.parent }
      );
    }
    return !this.parent.options.passiveWheel;
  }
}
class kA {
  constructor(t) {
    this.viewport = t, this.touches = [], this.addListeners();
  }
  /** Add input listeners */
  addListeners() {
    this.viewport.eventMode = "static", this.viewport.forceHitArea || (this.viewport.hitArea = new yt(0, 0, this.viewport.worldWidth, this.viewport.worldHeight)), this.viewport.on("pointerdown", this.down, this), this.viewport.options.allowPreserveDragOutside ? this.viewport.on("globalpointermove", this.move, this) : this.viewport.on("pointermove", this.move, this), this.viewport.on("pointerup", this.up, this), this.viewport.on("pointerupoutside", this.up, this), this.viewport.on("pointercancel", this.up, this), this.viewport.options.allowPreserveDragOutside || this.viewport.on("pointerleave", this.up, this), this.wheelFunction = (t) => this.handleWheel(t), this.viewport.options.events.domElement.addEventListener(
      "wheel",
      this.wheelFunction,
      { passive: this.viewport.options.passiveWheel }
    ), this.isMouseDown = !1;
  }
  /**
   * Removes all event listeners from viewport
   * (useful for cleanup of wheel when removing viewport)
   */
  destroy() {
    var t;
    (t = this.viewport.options.events.domElement) == null || t.removeEventListener("wheel", this.wheelFunction);
  }
  /**
   * handle down events for viewport
   *
   * @param {PIXI.FederatedPointerEvent} event
   */
  down(t) {
    if (!(this.viewport.pause || !this.viewport.visible)) {
      if (t.pointerType === "mouse" ? this.isMouseDown = !0 : this.get(t.pointerId) || this.touches.push({ id: t.pointerId, last: null }), this.count() === 1) {
        this.last = t.global.clone();
        const e = this.viewport.plugins.get("decelerate", !0), r = this.viewport.plugins.get("bounce", !0);
        (!e || !e.isActive()) && (!r || !r.isActive()) ? this.clickedAvailable = !0 : this.clickedAvailable = !1;
      } else
        this.clickedAvailable = !1;
      this.viewport.plugins.down(t) && this.viewport.options.stopPropagation && t.stopPropagation();
    }
  }
  /** Clears all pointer events */
  clear() {
    this.isMouseDown = !1, this.touches = [], this.last = null;
  }
  /**
   * @param {number} change
   * @returns whether change exceeds threshold
   */
  checkThreshold(t) {
    return Math.abs(t) >= this.viewport.threshold;
  }
  /** Handle move events for viewport */
  move(t) {
    if (this.viewport.pause || !this.viewport.visible)
      return;
    const e = this.viewport.plugins.move(t);
    if (this.clickedAvailable && this.last) {
      const r = t.global.x - this.last.x, i = t.global.y - this.last.y;
      (this.checkThreshold(r) || this.checkThreshold(i)) && (this.clickedAvailable = !1);
    }
    e && this.viewport.options.stopPropagation && t.stopPropagation();
  }
  /** Handle up events for viewport */
  up(t) {
    if (this.viewport.pause || !this.viewport.visible)
      return;
    t.pointerType === "mouse" && (this.isMouseDown = !1), t.pointerType !== "mouse" && this.remove(t.pointerId);
    const e = this.viewport.plugins.up(t);
    this.clickedAvailable && this.count() === 0 && this.last && (this.viewport.emit("clicked", {
      event: t,
      screen: this.last,
      world: this.viewport.toWorld(this.last),
      viewport: this.viewport
    }), this.clickedAvailable = !1), e && this.viewport.options.stopPropagation && t.stopPropagation();
  }
  /** Gets pointer position if this.interaction is set */
  getPointerPosition(t) {
    const e = new mt();
    return this.viewport.options.events.mapPositionToPoint(e, t.clientX, t.clientY), e;
  }
  /** Handle wheel events */
  handleWheel(t) {
    if (this.viewport.pause || !this.viewport.visible)
      return;
    const e = this.viewport.toLocal(this.getPointerPosition(t));
    this.viewport.left <= e.x && e.x <= this.viewport.right && this.viewport.top <= e.y && e.y <= this.viewport.bottom && this.viewport.plugins.wheel(t) && !this.viewport.options.passiveWheel && t.preventDefault();
  }
  pause() {
    this.touches = [], this.isMouseDown = !1;
  }
  /** Get touch by id */
  get(t) {
    for (const e of this.touches)
      if (e.id === t)
        return e;
    return null;
  }
  /** Remove touch by number */
  remove(t) {
    for (let e = 0; e < this.touches.length; e++)
      if (this.touches[e].id === t) {
        this.touches.splice(e, 1);
        return;
      }
  }
  /**
   * @returns {number} count of mouse/touch pointers that are down on the viewport
   */
  count() {
    return (this.isMouseDown ? 1 : 0) + this.touches.length;
  }
}
const Ls = [
  "drag",
  "pinch",
  "wheel",
  "follow",
  "mouse-edges",
  "decelerate",
  "animate",
  "bounce",
  "snap-zoom",
  "clamp-zoom",
  "snap",
  "clamp"
];
class BA {
  /** This is called by {@link Viewport} to initialize the {@link Viewport.plugins plugins}. */
  constructor(t) {
    this.viewport = t, this.list = [], this.plugins = {};
  }
  /**
   * Inserts a named plugin or a user plugin into the viewport
   * default plugin order: 'drag', 'pinch', 'wheel', 'follow', 'mouse-edges', 'decelerate', 'bounce',
   * 'snap-zoom', 'clamp-zoom', 'snap', 'clamp'
   *
   * @param {string} name of plugin
   * @param {Plugin} plugin - instantiated Plugin class
   * @param {number} index to insert userPlugin (otherwise inserts it at the end)
   */
  add(t, e, r = Ls.length) {
    const i = this.plugins[t];
    i && i.destroy(), this.plugins[t] = e;
    const s = Ls.indexOf(t);
    s !== -1 && Ls.splice(s, 1), Ls.splice(r, 0, t), this.sort();
  }
  /**
   * Get plugin
   *
   * @param {string} name of plugin
   * @param {boolean} [ignorePaused] return null if plugin is paused
   */
  get(t, e) {
    var r;
    return e && (r = this.plugins[t]) != null && r.paused ? null : this.plugins[t];
  }
  /**
   * Update all active plugins
   *
   * @internal
   * @ignore
   * @param {number} elapsed type in milliseconds since last update
   */
  update(t) {
    for (const e of this.list)
      e.update(t);
  }
  /**
   * Resize all active plugins
   *
   * @internal
   * @ignore
   */
  resize() {
    for (const t of this.list)
      t.resize();
  }
  /** Clamps and resets bounce and decelerate (as needed) after manually moving viewport */
  reset() {
    for (const t of this.list)
      t.reset();
  }
  /** removes all installed plugins */
  removeAll() {
    this.list.forEach((t) => {
      t.destroy();
    }), this.plugins = {}, this.sort();
  }
  /**
   * Removes installed plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */
  remove(t) {
    var e;
    this.plugins[t] && ((e = this.plugins[t]) == null || e.destroy(), delete this.plugins[t], this.viewport.emit("plugin-remove", t), this.sort());
  }
  /**
   * Pause plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */
  pause(t) {
    var e;
    (e = this.plugins[t]) == null || e.pause();
  }
  /**
   * Resume plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */
  resume(t) {
    var e;
    (e = this.plugins[t]) == null || e.resume();
  }
  /**
   * Sort plugins according to PLUGIN_ORDER
   *
   * @internal
   * @ignore
   */
  sort() {
    this.list = [];
    for (const t of Ls)
      this.plugins[t] && this.list.push(this.plugins[t]);
  }
  /**
   * Handle down for all plugins
   *
   * @internal
   * @ignore
   */
  down(t) {
    let e = !1;
    for (const r of this.list)
      r.down(t) && (e = !0);
    return e;
  }
  /**
   * Handle move for all plugins
   *
   * @internal
   * @ignore
   */
  move(t) {
    let e = !1;
    for (const r of this.viewport.plugins.list)
      r.move(t) && (e = !0);
    return e;
  }
  /**
   * Handle up for all plugins
   *
   * @internal
   * @ignore
   */
  up(t) {
    let e = !1;
    for (const r of this.list)
      r.up(t) && (e = !0);
    return e;
  }
  /**
   * Handle wheel event for all plugins
   *
   * @internal
   * @ignore
   */
  wheel(t) {
    let e = !1;
    for (const r of this.list)
      r.wheel(t) && (e = !0);
    return e;
  }
}
const LA = {
  screenWidth: typeof window > "u" ? 0 : window.innerWidth,
  screenHeight: typeof window > "u" ? 0 : window.innerHeight,
  worldWidth: null,
  worldHeight: null,
  threshold: 5,
  passiveWheel: !0,
  stopPropagation: !1,
  forceHitArea: null,
  noTicker: !1,
  disableOnContextMenu: !1,
  ticker: xe.shared,
  allowPreserveDragOutside: !1
};
class UA extends bt {
  /**
   * @param {IViewportOptions} ViewportOptions
   * @param {number} [options.screenWidth=window.innerWidth]
   * @param {number} [options.screenHeight=window.innerHeight]
   * @param {number} [options.worldWidth=this.width]
   * @param {number} [options.worldHeight=this.height]
   * @param {number} [options.threshold=5] number of pixels to move to trigger an input event (e.g., drag, pinch)
   * or disable a clicked event
   * @param {boolean} [options.passiveWheel=true] whether the 'wheel' event is set to passive (note: if false,
   * e.preventDefault() will be called when wheel is used over the viewport)
   * @param {boolean} [options.stopPropagation=false] whether to stopPropagation of events that impact the viewport
   * (except wheel events, see options.passiveWheel)
   * @param {HitArea} [options.forceHitArea] change the default hitArea from world size to a new value
   * @param {boolean} [options.noTicker] set this if you want to manually call update() function on each frame
   * @param {PIXI.Ticker} [options.ticker=PIXI.Ticker.shared] use this PIXI.ticker for updates
   * @param {PIXI.EventSystem} [options.events] EventSystem available from app.events or added manually and passed here
   * location on screen
   * @param {boolean} [options.disableOnContextMenu] remove oncontextmenu=() => {} from the pixi's events.domElement
   */
  constructor(t) {
    super(), this._disableOnContextMenu = (e) => e.preventDefault(), this.options = {
      ...LA,
      ...t
    }, this.screenWidth = this.options.screenWidth, this.screenHeight = this.options.screenHeight, this._worldWidth = this.options.worldWidth, this._worldHeight = this.options.worldHeight, this.forceHitArea = this.options.forceHitArea, this.threshold = this.options.threshold, this.options.disableOnContextMenu && this.options.events.domElement.addEventListener("contextmenu", this._disableOnContextMenu), this.options.noTicker || (this.tickerFunction = () => this.update(this.options.ticker.elapsedMS), this.options.ticker.add(this.tickerFunction)), this.input = new kA(this), this.plugins = new BA(this);
  }
  /** Overrides PIXI.Container's destroy to also remove the 'wheel' and PIXI.Ticker listeners */
  destroy(t) {
    var e;
    !this.options.noTicker && this.tickerFunction && this.options.ticker.remove(this.tickerFunction), this.options.disableOnContextMenu && ((e = this.options.events.domElement) == null || e.removeEventListener("contextmenu", this._disableOnContextMenu)), this.input.destroy(), super.destroy(t);
  }
  /**
   * Update viewport on each frame.
   *
   * By default, you do not need to call this unless you set `options.noTicker=true`.
   *
   * @param {number} elapsed time in milliseconds since last update
   */
  update(t) {
    this.pause || (this.plugins.update(t), this.lastViewport && (this.lastViewport.x !== this.x || this.lastViewport.y !== this.y ? this.moving = !0 : this.moving && (this.emit("moved-end", this), this.moving = !1), this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y ? this.zooming = !0 : this.zooming && (this.emit("zoomed-end", this), this.zooming = !1)), this.forceHitArea || (this._hitAreaDefault = new yt(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight), this.hitArea = this._hitAreaDefault), this._dirty = this._dirty || !this.lastViewport || this.lastViewport.x !== this.x || this.lastViewport.y !== this.y || this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y, this.lastViewport = {
      x: this.x,
      y: this.y,
      scaleX: this.scale.x,
      scaleY: this.scale.y
    }, this.emit("frame-end", this));
  }
  /**
   * Use this to set screen and world sizes, needed for pinch/wheel/clamp/bounce.
   * @param {number} screenWidth=window.innerWidth
   * @param {number} screenHeight=window.innerHeight
   * @param {number} [worldWidth]
   * @param {number} [worldHeight]
   */
  resize(t = typeof window > "u" ? 0 : window.innerWidth, e = typeof window > "u" ? 0 : window.innerHeight, r, i) {
    this.screenWidth = t, this.screenHeight = e, typeof r < "u" && (this._worldWidth = r), typeof i < "u" && (this._worldHeight = i), this.plugins.resize(), this.dirty = !0;
  }
  /** World width, in pixels */
  get worldWidth() {
    return this._worldWidth ? this._worldWidth : this.width / this.scale.x;
  }
  set worldWidth(t) {
    this._worldWidth = t, this.plugins.resize();
  }
  /** World height, in pixels */
  get worldHeight() {
    return this._worldHeight ? this._worldHeight : this.height / this.scale.y;
  }
  set worldHeight(t) {
    this._worldHeight = t, this.plugins.resize();
  }
  /** Get visible world bounds of viewport */
  getVisibleBounds() {
    return new yt(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight);
  }
  /**
   * Changes coordinate from screen to world
   * @param {number|PIXI.Point} x
   * @param {number} y
   * @returns {PIXI.Point}
   */
  toWorld(t, e) {
    return arguments.length === 2 ? this.toLocal(new mt(t, e)) : this.toLocal(t);
  }
  /**
   * Changes coordinate from world to screen
   * @param {number|PIXI.Point} x
   * @param {number} y
   * @returns {PIXI.Point}
   */
  toScreen(t, e) {
    return arguments.length === 2 ? this.toGlobal(new mt(t, e)) : this.toGlobal(t);
  }
  /** Screen width in world coordinates */
  get worldScreenWidth() {
    return this.screenWidth / this.scale.x;
  }
  /** Screen height in world coordinates */
  get worldScreenHeight() {
    return this.screenHeight / this.scale.y;
  }
  /** World width in screen coordinates */
  get screenWorldWidth() {
    return this.worldWidth * this.scale.x;
  }
  /** World height in screen coordinates */
  get screenWorldHeight() {
    return this.worldHeight * this.scale.y;
  }
  /** Center of screen in world coordinates */
  get center() {
    return new mt(
      this.worldScreenWidth / 2 - this.x / this.scale.x,
      this.worldScreenHeight / 2 - this.y / this.scale.y
    );
  }
  set center(t) {
    this.moveCenter(t);
  }
  /**
   * Move center of viewport to (x, y)
   * @param {number|PIXI.Point} x
   * @param {number} [y]
   * @return {Viewport}
   */
  moveCenter(...t) {
    let e, r;
    typeof t[0] == "number" ? (e = t[0], r = t[1]) : (e = t[0].x, r = t[0].y);
    const i = (this.worldScreenWidth / 2 - e) * this.scale.x, s = (this.worldScreenHeight / 2 - r) * this.scale.y;
    return (this.x !== i || this.y !== s) && (this.position.set(i, s), this.plugins.reset(), this.dirty = !0), this;
  }
  /** Top-left corner of Viewport */
  get corner() {
    return new mt(-this.x / this.scale.x, -this.y / this.scale.y);
  }
  set corner(t) {
    this.moveCorner(t);
  }
  /**
   * MoveCorner
   * @param {number|PIXI.Point} x
   * @param {number} [y]
   * @returns {Viewport}
   */
  moveCorner(...t) {
    let e, r;
    return t.length === 1 ? (e = -t[0].x * this.scale.x, r = -t[0].y * this.scale.y) : (e = -t[0] * this.scale.x, r = -t[1] * this.scale.y), (e !== this.x || r !== this.y) && (this.position.set(e, r), this.plugins.reset(), this.dirty = !0), this;
  }
  /** Get how many world pixels fit in screen's width */
  get screenWidthInWorldPixels() {
    return this.screenWidth / this.scale.x;
  }
  /** Get how many world pixels fit on screen's height */
  get screenHeightInWorldPixels() {
    return this.screenHeight / this.scale.y;
  }
  /**
   * Find the scale value that fits a world width on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param width - Width in world pixels
   * @return - scale
   */
  findFitWidth(t) {
    return this.screenWidth / t;
  }
  /**
   * Finds the scale value that fits a world height on the screens
   * does not change the viewport (use fit... to change)
   *
   * @param height - Height in world pixels
   * @return - scale
   */
  findFitHeight(t) {
    return this.screenHeight / t;
  }
  /**
   * Finds the scale value that fits the smaller of a world width and world height on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param {number} width in world pixels
   * @param {number} height in world pixels
   * @returns {number} scale
   */
  findFit(t, e) {
    const r = this.screenWidth / t, i = this.screenHeight / e;
    return Math.min(r, i);
  }
  /**
   * Finds the scale value that fits the larger of a world width and world height on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param {number} width in world pixels
   * @param {number} height in world pixels
   * @returns {number} scale
   */
  findCover(t, e) {
    const r = this.screenWidth / t, i = this.screenHeight / e;
    return Math.max(r, i);
  }
  /**
   * Change zoom so the width fits in the viewport
   *
   * @param width - width in world coordinates
   * @param center - maintain the same center
   * @param scaleY - whether to set scaleY=scaleX
   * @param noClamp - whether to disable clamp-zoom
   * @returns {Viewport} this
   */
  fitWidth(t = this.worldWidth, e, r = !0, i) {
    let s;
    e && (s = this.center), this.scale.x = this.screenWidth / t, r && (this.scale.y = this.scale.x);
    const o = this.plugins.get("clamp-zoom", !0);
    return !i && o && o.clamp(), e && s && this.moveCenter(s), this;
  }
  /**
   * Change zoom so the height fits in the viewport
   *
   * @param {number} [height=this.worldHeight] in world coordinates
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @param {boolean} [scaleX=true] whether to set scaleX = scaleY
   * @param {boolean} [noClamp] whether to disable clamp-zoom
   * @returns {Viewport} this
   */
  fitHeight(t = this.worldHeight, e, r = !0, i) {
    let s;
    e && (s = this.center), this.scale.y = this.screenHeight / t, r && (this.scale.x = this.scale.y);
    const o = this.plugins.get("clamp-zoom", !0);
    return !i && o && o.clamp(), e && s && this.moveCenter(s), this;
  }
  /**
   * Change zoom so it fits the entire world in the viewport
   *
   * @param {boolean} center maintain the same center of the screen after zoom
   * @returns {Viewport} this
   */
  fitWorld(t) {
    let e;
    t && (e = this.center), this.scale.x = this.screenWidth / this.worldWidth, this.scale.y = this.screenHeight / this.worldHeight, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
    const r = this.plugins.get("clamp-zoom", !0);
    return r && r.clamp(), t && e && this.moveCenter(e), this;
  }
  /**
   * Change zoom so it fits the size or the entire world in the viewport
   *
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @param {number} [width=this.worldWidth] desired width
   * @param {number} [height=this.worldHeight] desired height
   * @returns {Viewport} this
   */
  fit(t, e = this.worldWidth, r = this.worldHeight) {
    let i;
    t && (i = this.center), this.scale.x = this.screenWidth / e, this.scale.y = this.screenHeight / r, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
    const s = this.plugins.get("clamp-zoom", !0);
    return s && s.clamp(), t && i && this.moveCenter(i), this;
  }
  /**
   * Zoom viewport to specific value.
   *
   * @param {number} scale value (e.g., 1 would be 100%, 0.25 would be 25%)
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */
  setZoom(t, e) {
    let r;
    e && (r = this.center), this.scale.set(t);
    const i = this.plugins.get("clamp-zoom", !0);
    return i && i.clamp(), e && r && this.moveCenter(r), this;
  }
  /**
   * Zoom viewport by a certain percent (in both x and y direction).
   *
   * @param {number} percent change (e.g., 0.25 would increase a starting scale of 1.0 to 1.25)
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */
  zoomPercent(t, e) {
    return this.setZoom(this.scale.x + this.scale.x * t, e);
  }
  /**
   * Zoom viewport by increasing/decreasing width by a certain number of pixels.
   *
   * @param {number} change in pixels
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */
  zoom(t, e) {
    return this.fitWidth(t + this.worldScreenWidth, e), this;
  }
  /** Changes scale of viewport and maintains center of viewport */
  get scaled() {
    return this.scale.x;
  }
  set scaled(t) {
    this.setZoom(t, !0);
  }
  /**
   * Returns zoom to the desired scale
   *
   * @param {ISnapZoomOptions} options
   * @param {number} [options.width=0] - the desired width to snap (to maintain aspect ratio, choose width or height)
   * @param {number} [options.height=0] - the desired height to snap (to maintain aspect ratio, choose width or height)
   * @param {number} [options.time=1000] - time for snapping in ms
   * @param {(string|function)} [options.ease=easeInOutSine] ease function or name (see http://easings.net/
   *   for supported names)
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of center of the viewport
   * @param {boolean} [options.interrupt=true] - pause snapping with any user input on the viewport
   * @param {boolean} [options.removeOnComplete] - removes this plugin after snapping is complete
   * @param {boolean} [options.removeOnInterrupt] - removes this plugin if interrupted by any user input
   * @param {boolean} [options.forceStart] - starts the snap immediately regardless of whether the viewport is at the
   *   desired zoom
   * @param {boolean} [options.noMove] - zoom but do not move
   */
  snapZoom(t) {
    return this.plugins.add("snap-zoom", new FA(this, t)), this;
  }
  /** Is container out of world bounds */
  OOB() {
    return {
      left: this.left < 0,
      right: this.right > this.worldWidth,
      top: this.top < 0,
      bottom: this.bottom > this.worldHeight,
      cornerPoint: new mt(
        this.worldWidth * this.scale.x - this.screenWidth,
        this.worldHeight * this.scale.y - this.screenHeight
      )
    };
  }
  /** World coordinates of the right edge of the screen */
  get right() {
    return -this.x / this.scale.x + this.worldScreenWidth;
  }
  set right(t) {
    this.x = -t * this.scale.x + this.screenWidth, this.plugins.reset();
  }
  /** World coordinates of the left edge of the screen */
  get left() {
    return -this.x / this.scale.x;
  }
  set left(t) {
    this.x = -t * this.scale.x, this.plugins.reset();
  }
  /** World coordinates of the top edge of the screen */
  get top() {
    return -this.y / this.scale.y;
  }
  set top(t) {
    this.y = -t * this.scale.y, this.plugins.reset();
  }
  /** World coordinates of the bottom edge of the screen */
  get bottom() {
    return -this.y / this.scale.y + this.worldScreenHeight;
  }
  set bottom(t) {
    this.y = -t * this.scale.y + this.screenHeight, this.plugins.reset();
  }
  /**
   * Determines whether the viewport is dirty (i.e., needs to be rendered to the screen because of a change)
   */
  get dirty() {
    return !!this._dirty;
  }
  set dirty(t) {
    this._dirty = t;
  }
  /**
   * Permanently changes the Viewport's hitArea
   *
   * NOTE: if not set then hitArea = PIXI.Rectangle(Viewport.left, Viewport.top, Viewport.worldScreenWidth,
   * Viewport.worldScreenHeight)
   */
  get forceHitArea() {
    return this._forceHitArea;
  }
  set forceHitArea(t) {
    t ? (this._forceHitArea = t, this.hitArea = t) : (this._forceHitArea = null, this.hitArea = new yt(0, 0, this.worldWidth, this.worldHeight));
  }
  /**
   * Enable one-finger touch to drag
   *
   * NOTE: if you expect users to use right-click dragging, you should enable `viewport.options.disableOnContextMenu`
   * to avoid the context menu popping up on each right-click drag.
   *
   * @param {IDragOptions} [options]
   * @param {string} [options.direction=all] direction to drag
   * @param {boolean} [options.pressDrag=true] whether click to drag is active
   * @param {boolean} [options.wheel=true] use wheel to scroll in direction (unless wheel plugin is active)
   * @param {number} [options.wheelScroll=1] number of pixels to scroll with each wheel spin
   * @param {boolean} [options.reverse] reverse the direction of the wheel scroll
   * @param {(boolean|string)} [options.clampWheel=false] clamp wheel(to avoid weird bounce with mouse wheel)
   * @param {string} [options.underflow=center] where to place world if too small for screen
   * @param {number} [options.factor=1] factor to multiply drag to increase the speed of movement
   * @param {string} [options.mouseButtons=all] changes which mouse buttons trigger drag, use: 'all', 'left',
   *  'right' 'middle', or some combination, like, 'middle-right'; you may want to set
   *   viewport.options.disableOnContextMenu if you want to use right-click dragging
   * @param {string[]} [options.keyToPress=null] - array containing
   *  {@link key|https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code} codes of keys that can be
   *  pressed for the drag to be triggered, e.g.: ['ShiftLeft', 'ShiftRight'}.
   * @param {boolean} [options.ignoreKeyToPressOnTouch=false] - ignore keyToPress for touch events
   * @param {number} [options.lineHeight=20] - scaling factor for non-DOM_DELTA_PIXEL scrolling events
   * @returns {Viewport} this
   */
  drag(t) {
    return this.plugins.add("drag", new TA(this, t)), this;
  }
  /**
   * Clamp to world boundaries or other provided boundaries
   * There are three ways to clamp:
   * 1. direction: 'all' = the world is clamped to its world boundaries, ie, you cannot drag any part of offscreen
   *    direction: 'x' | 'y' = only the x or y direction is clamped to its world boundary
   * 2. left, right, top, bottom = true | number = the world is clamped to the world's pixel location for each side;
   *    if any of these are set to true, then the location is set to the boundary
   *    [0, viewport.worldWidth/viewport.worldHeight], eg: to allow the world to be completely dragged offscreen,
   *    set [-viewport.worldWidth, -viewport.worldHeight, viewport.worldWidth * 2, viewport.worldHeight * 2]
   *
   * Underflow determines what happens when the world is smaller than the viewport
   * 1. none = the world is clamped but there is no special behavior
   * 2. center = the world is centered on the viewport
   * 3. combination of top/bottom/center and left/right/center (case insensitive) = the world is stuck to the
   *     appropriate boundaries
   *
   * NOTES:
   *   clamp is disabled if called with no options; use { direction: 'all' } for all edge clamping
   *   screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
   *
   * @param {object} [options]
   * @param {(number|boolean)} [options.left=false] - clamp left; true = 0
   * @param {(number|boolean)} [options.right=false] - clamp right; true = viewport.worldWidth
   * @param {(number|boolean)} [options.top=false] - clamp top; true = 0
   * @param {(number|boolean)} [options.bottom=false] - clamp bottom; true = viewport.worldHeight
   * @param {string} [direction] - (all, x, or y) using clamps of [0, viewport.worldWidth/viewport.worldHeight];
   *  replaces left/right/top/bottom if set
   * @param {string} [underflow=center] - where to place world if too small for screen (e.g., top-right, center,
   *  none, bottomLeft)     * @returns {Viewport} this
   */
  clamp(t) {
    return this.plugins.add("clamp", new yA(this, t)), this;
  }
  /**
   * Decelerate after a move
   *
   * NOTE: this fires 'moved' event during deceleration
   *
   * @param {IDecelerateOptions} [options]
   * @param {number} [options.friction=0.95] - percent to decelerate after movement
   * @param {number} [options.bounce=0.8] - percent to decelerate when past boundaries (only applicable when
   *   viewport.bounce() is active)
   * @param {number} [options.minSpeed=0.01] - minimum velocity before stopping/reversing acceleration
   * @return {Viewport} this
   */
  decelerate(t) {
    return this.plugins.add("decelerate", new wA(this, t)), this;
  }
  /**
   * Bounce on borders
   * NOTES:
   *    screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
   *    fires 'moved', 'bounce-x-start', 'bounce-y-start', 'bounce-x-end', and 'bounce-y-end' events
   * @param {object} [options]
   * @param {string} [options.sides=all] - all, horizontal, vertical, or combination of top, bottom, right, left
   *  (e.g., 'top-bottom-right')
   * @param {number} [options.friction=0.5] - friction to apply to decelerate if active
   * @param {number} [options.time=150] - time in ms to finish bounce
   * @param {object} [options.bounceBox] - use this bounceBox instead of (0, 0, viewport.worldWidth, viewport.worldHeight)
   * @param {number} [options.bounceBox.x=0]
   * @param {number} [options.bounceBox.y=0]
   * @param {number} [options.bounceBox.width=viewport.worldWidth]
   * @param {number} [options.bounceBox.height=viewport.worldHeight]
   * @param {string|function} [options.ease=easeInOutSine] - ease function or name
   *  (see http://easings.net/ for supported names)
   * @param {string} [options.underflow=center] - (top/bottom/center and left/right/center, or center)
   *  where to place world if too small for screen
   * @return {Viewport} this
   */
  bounce(t) {
    return this.plugins.add("bounce", new mA(this, t)), this;
  }
  /**
   * Enable pinch to zoom and two-finger touch to drag
   *
   * @param {PinchOptions} [options]
   * @param {boolean} [options.noDrag] - disable two-finger dragging
   * @param {number} [options.percent=1] - percent to modify pinch speed
   * @param {number} [options.factor=1] - factor to multiply two-finger drag to increase the speed of movement
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of center of two fingers
   * @param {('all'|'x'|'y')} [options.axis=all] - axis to zoom
   * @return {Viewport} this
   */
  pinch(t) {
    return this.plugins.add("pinch", new IA(this, t)), this;
  }
  /**
   * Snap to a point
   *
   * @param {number} x
   * @param {number} y
   * @param {ISnapOptions} [options]
   * @param {boolean} [options.topLeft] - snap to the top-left of viewport instead of center
   * @param {number} [options.friction=0.8] - friction/frame to apply if decelerate is active
   * @param {number} [options.time=1000] - time in ms to snap
   * @param {string|function} [options.ease=easeInOutSine] - ease function or name (see http://easings.net/
   *   for supported names)
   * @param {boolean} [options.interrupt=true] - pause snapping with any user input on the viewport
   * @param {boolean} [options.removeOnComplete] - removes this plugin after snapping is complete
   * @param {boolean} [options.removeOnInterrupt] - removes this plugin if interrupted by any user input
   * @param {boolean} [options.forceStart] - starts the snap immediately regardless of whether the viewport is at
   *   the desired location
   * @return {Viewport} this
   */
  snap(t, e, r) {
    return this.plugins.add("snap", new RA(this, t, e, r)), this;
  }
  /**
   * Follow a target
   *
   * NOTES:
   *    uses the (x, y) as the center to follow; for PIXI.Sprite to work properly, use sprite.anchor.set(0.5)
   *    options.acceleration is not perfect as it doesn't know the velocity of the target. It adds acceleration
   *    to the start of movement and deceleration to the end of movement when the target is stopped.
   *    To cancel the follow, use: `viewport.plugins.remove('follow')`
   *
   * @fires 'moved' event
   *
   * @param {PIXI.DisplayObject} target to follow
   * @param {IFollowOptions} [options]
   * @param {number} [options.speed=0] - to follow in pixels/frame (0=teleport to location)
   * @param {number} [options.acceleration] - set acceleration to accelerate and decelerate at this rate; speed
   *   cannot be 0 to use acceleration
   * @param {number} [options.radius] - radius (in world coordinates) of center circle where movement is allowed
   *   without moving the viewport     * @returns {Viewport} this
   * @returns {Viewport} this
   */
  follow(t, e) {
    return this.plugins.add("follow", new EA(this, t, e)), this;
  }
  /**
   * Zoom using mouse wheel
   *
   * NOTE: the default event listener for 'wheel' event is the options.events.domElement.
   *
   * @param {IWheelOptions} [options]
   * @param {number} [options.percent=0.1] - percent to scroll with each spin
   * @param {number} [options.smooth] - smooth the zooming by providing the number of frames to zoom between wheel spins
   * @param {boolean} [options.interrupt=true] - stop smoothing with any user input on the viewport
   * @param {boolean} [options.reverse] - reverse the direction of the scroll
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of current mouse position
   * @param {number} [options.lineHeight=20] - scaling factor for non-DOM_DELTA_PIXEL scrolling events
   * @param {('all'|'x'|'y')} [options.axis=all] - axis to zoom
   * @return {Viewport} this
   */
  wheel(t) {
    return this.plugins.add("wheel", new NA(this, t)), this;
  }
  /**
   * Animate the position and/or scale of the viewport
   * To set the zoom level, use: (1) scale, (2) scaleX and scaleY, or (3) width and/or height
   * @param {object} options
   * @param {number} [options.time=1000] - time to animate
   * @param {PIXI.Point} [options.position=viewport.center] - position to move viewport
   * @param {number} [options.width] - desired viewport width in world pixels (use instead of scale;
   *  aspect ratio is maintained if height is not provided)
   * @param {number} [options.height] - desired viewport height in world pixels (use instead of scale;
   *  aspect ratio is maintained if width is not provided)
   * @param {number} [options.scale] - scale to change zoom (scale.x = scale.y)
   * @param {number} [options.scaleX] - independently change zoom in x-direction
   * @param {number} [options.scaleY] - independently change zoom in y-direction
   * @param {(function|string)} [options.ease=linear] - easing function to use
   * @param {function} [options.callbackOnComplete]
   * @param {boolean} [options.removeOnInterrupt] removes this plugin if interrupted by any user input
   * @returns {Viewport} this
   */
  animate(t) {
    return this.plugins.add("animate", new fA(this, t)), this;
  }
  /**
   * Enable clamping of zoom to constraints
   *
   * The minWidth/Height settings are how small the world can get (as it would appear on the screen)
   * before clamping. The maxWidth/maxHeight is how larger the world can scale (as it would appear on
   * the screen) before clamping.
   *
   * For example, if you have a world size of 1000 x 1000 and a screen size of 100 x 100, if you set
   * minWidth/Height = 100 then the world will not be able to zoom smaller than the screen size (ie,
   * zooming out so it appears smaller than the screen). Similarly, if you set maxWidth/Height = 100
   * the world will not be able to zoom larger than the screen size (ie, zooming in so it appears
   * larger than the screen).
   *
   * @param {object} [options]
   * @param {number} [options.minWidth] - minimum width
   * @param {number} [options.minHeight] - minimum height
   * @param {number} [options.maxWidth] - maximum width
   * @param {number} [options.maxHeight] - maximum height
   * @param {number} [options.minScale] - minimum scale
   * @param {number} [options.maxScale] - minimum scale
   * @return {Viewport} this
   */
  clampZoom(t) {
    return this.plugins.add("clamp-zoom", new vA(this, t)), this;
  }
  /**
   * Scroll viewport when mouse hovers near one of the edges or radius-distance from center of screen.
   *
   * NOTES: fires 'moved' event; there's a known bug where the mouseEdges does not work properly with "windowed" viewports
   *
   * @param {IMouseEdgesOptions} [options]
   * @param {number} [options.radius] - distance from center of screen in screen pixels
   * @param {number} [options.distance] - distance from all sides in screen pixels
   * @param {number} [options.top] - alternatively, set top distance (leave unset for no top scroll)
   * @param {number} [options.bottom] - alternatively, set bottom distance (leave unset for no top scroll)
   * @param {number} [options.left] - alternatively, set left distance (leave unset for no top scroll)
   * @param {number} [options.right] - alternatively, set right distance (leave unset for no top scroll)
   * @param {number} [options.speed=8] - speed in pixels/frame to scroll viewport
   * @param {boolean} [options.reverse] - reverse direction of scroll
   * @param {boolean} [options.noDecelerate] - don't use decelerate plugin even if it's installed
   * @param {boolean} [options.linear] - if using radius, use linear movement (+/- 1, +/- 1) instead of angled
   *   movement (Math.cos(angle from center), Math.sin(angle from center))
   * @param {boolean} [options.allowButtons] allows plugin to continue working even when there's a mousedown event
   */
  mouseEdges(t) {
    return this.plugins.add("mouse-edges", new CA(this, t)), this;
  }
  /** Pause viewport (including animation updates such as decelerate) */
  get pause() {
    return !!this._pause;
  }
  set pause(t) {
    this._pause = t, this.lastViewport = null, this.moving = !1, this.zooming = !1, t && this.input.pause();
  }
  /**
   * Move the viewport so the bounding box is visible
   *
   * @param x - left
   * @param y - top
   * @param width
   * @param height
   * @param resizeToFit - Resize the viewport so the box fits within the viewport
   */
  ensureVisible(t, e, r, i, s) {
    s && (r > this.worldScreenWidth || i > this.worldScreenHeight) && (this.fit(!0, r, i), this.emit("zoomed", { viewport: this, type: "ensureVisible" }));
    let o = !1;
    t < this.left ? (this.left = t, o = !0) : t + r > this.right && (this.right = t + r, o = !0), e < this.top ? (this.top = e, o = !0) : e + i > this.bottom && (this.bottom = e + i, o = !0), o && this.emit("moved", { viewport: this, type: "ensureVisible" });
  }
}
const Da = 1e3, gm = /* @__PURE__ */ Symbol.for("constructDateFrom");
async function my(n, t) {
  const e = await He();
  let r, i = null;
  async function s() {
    try {
      i = await e.fetch(n), t(i);
    } catch (a) {
      console.error(a);
    }
    i && !i.end_time && (r = setTimeout(() => s(), HA(i)));
  }
  function o() {
    clearTimeout(r);
  }
  return {
    start: s,
    stop: o
  };
}
function HA(n) {
  const t = Math.floor(n.nodes.size / Da) * Da;
  return Math.max(Da, t);
}
function Zr(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function gy(n, t) {
  n.prototype = Object.create(t.prototype), n.prototype.constructor = n, n.__proto__ = t;
}
var Le = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, ds = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, md, me, kt, Qe = 1e8, Rt = 1 / Qe, Ec = Math.PI * 2, GA = Ec / 4, zA = 0, yy = Math.sqrt, WA = Math.cos, $A = Math.sin, he = function(t) {
  return typeof t == "string";
}, Xt = function(t) {
  return typeof t == "function";
}, on = function(t) {
  return typeof t == "number";
}, gd = function(t) {
  return typeof t > "u";
}, Ur = function(t) {
  return typeof t == "object";
}, Se = function(t) {
  return t !== !1;
}, yd = function() {
  return typeof window < "u";
}, ya = function(t) {
  return Xt(t) || he(t);
}, _y = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, ge = Array.isArray, Sc = /(?:-?\.?\d|\.)+/gi, vy = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, Zi = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, vu = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, xy = /[+-]=-?[.\d]+/, wy = /[^,'"\[\]\s]+/gi, XA = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, Ht, Cr, Cc, _d, Ue = {}, nh = {}, by, Ty = function(t) {
  return (nh = Ei(t, Ue)) && Pe;
}, vd = function(t, e) {
  return console.warn("Invalid property", t, "set to", e, "Missing plugin? gsap.registerPlugin()");
}, po = function(t, e) {
  return !e && console.warn(t);
}, Ay = function(t, e) {
  return t && (Ue[t] = e) && nh && (nh[t] = e) || Ue;
}, mo = function() {
  return 0;
}, VA = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, Fa = {
  suppressEvents: !0,
  kill: !1
}, YA = {
  suppressEvents: !0
}, xd = {}, On = [], Mc = {}, Ey, Ne = {}, xu = {}, ym = 30, Oa = [], wd = "", bd = function(t) {
  var e = t[0], r, i;
  if (Ur(e) || Xt(e) || (t = [t]), !(r = (e._gsap || {}).harness)) {
    for (i = Oa.length; i-- && !Oa[i].targetTest(e); )
      ;
    r = Oa[i];
  }
  for (i = t.length; i--; )
    t[i] && (t[i]._gsap || (t[i]._gsap = new qy(t[i], r))) || t.splice(i, 1);
  return t;
}, yi = function(t) {
  return t._gsap || bd(Je(t))[0]._gsap;
}, Sy = function(t, e, r) {
  return (r = t[e]) && Xt(r) ? t[e]() : gd(r) && t.getAttribute && t.getAttribute(e) || r;
}, Ce = function(t, e) {
  return (t = t.split(",")).forEach(e) || t;
}, Vt = function(t) {
  return Math.round(t * 1e5) / 1e5 || 0;
}, ae = function(t) {
  return Math.round(t * 1e7) / 1e7 || 0;
}, ss = function(t, e) {
  var r = e.charAt(0), i = parseFloat(e.substr(2));
  return t = parseFloat(t), r === "+" ? t + i : r === "-" ? t - i : r === "*" ? t * i : t / i;
}, jA = function(t, e) {
  for (var r = e.length, i = 0; t.indexOf(e[i]) < 0 && ++i < r; )
    ;
  return i < r;
}, ih = function() {
  var t = On.length, e = On.slice(0), r, i;
  for (Mc = {}, On.length = 0, r = 0; r < t; r++)
    i = e[r], i && i._lazy && (i.render(i._lazy[0], i._lazy[1], !0)._lazy = 0);
}, Cy = function(t, e, r, i) {
  On.length && !me && ih(), t.render(e, r, me && e < 0 && (t._initted || t._startAt)), On.length && !me && ih();
}, My = function(t) {
  var e = parseFloat(t);
  return (e || e === 0) && (t + "").match(wy).length < 2 ? e : he(t) ? t.trim() : t;
}, Iy = function(t) {
  return t;
}, er = function(t, e) {
  for (var r in e)
    r in t || (t[r] = e[r]);
  return t;
}, qA = function(t) {
  return function(e, r) {
    for (var i in r)
      i in e || i === "duration" && t || i === "ease" || (e[i] = r[i]);
  };
}, Ei = function(t, e) {
  for (var r in e)
    t[r] = e[r];
  return t;
}, _m = function n(t, e) {
  for (var r in e)
    r !== "__proto__" && r !== "constructor" && r !== "prototype" && (t[r] = Ur(e[r]) ? n(t[r] || (t[r] = {}), e[r]) : e[r]);
  return t;
}, sh = function(t, e) {
  var r = {}, i;
  for (i in t)
    i in e || (r[i] = t[i]);
  return r;
}, ho = function(t) {
  var e = t.parent || Ht, r = t.keyframes ? qA(ge(t.keyframes)) : er;
  if (Se(t.inherit))
    for (; e; )
      r(t, e.vars.defaults), e = e.parent || e._dp;
  return t;
}, ZA = function(t, e) {
  for (var r = t.length, i = r === e.length; i && r-- && t[r] === e[r]; )
    ;
  return r < 0;
}, Py = function(t, e, r, i, s) {
  var o = t[i], a;
  if (s)
    for (a = e[s]; o && o[s] > a; )
      o = o._prev;
  return o ? (e._next = o._next, o._next = e) : (e._next = t[r], t[r] = e), e._next ? e._next._prev = e : t[i] = e, e._prev = o, e.parent = e._dp = t, e;
}, kh = function(t, e, r, i) {
  r === void 0 && (r = "_first"), i === void 0 && (i = "_last");
  var s = e._prev, o = e._next;
  s ? s._next = o : t[r] === e && (t[r] = o), o ? o._prev = s : t[i] === e && (t[i] = s), e._next = e._prev = e.parent = null;
}, Gn = function(t, e) {
  t.parent && (!e || t.parent.autoRemoveChildren) && t.parent.remove && t.parent.remove(t), t._act = 0;
}, _i = function(t, e) {
  if (t && (!e || e._end > t._dur || e._start < 0))
    for (var r = t; r; )
      r._dirty = 1, r = r.parent;
  return t;
}, KA = function(t) {
  for (var e = t.parent; e && e.parent; )
    e._dirty = 1, e.totalDuration(), e = e.parent;
  return t;
}, Ic = function(t, e, r, i) {
  return t._startAt && (me ? t._startAt.revert(Fa) : t.vars.immediateRender && !t.vars.autoRevert || t._startAt.render(e, !0, i));
}, QA = function n(t) {
  return !t || t._ts && n(t.parent);
}, vm = function(t) {
  return t._repeat ? fs(t._tTime, t = t.duration() + t._rDelay) * t : 0;
}, fs = function(t, e) {
  var r = Math.floor(t /= e);
  return t && r === t ? r - 1 : r;
}, oh = function(t, e) {
  return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
}, Bh = function(t) {
  return t._end = ae(t._start + (t._tDur / Math.abs(t._ts || t._rts || Rt) || 0));
}, Lh = function(t, e) {
  var r = t._dp;
  return r && r.smoothChildTiming && t._ts && (t._start = ae(r._time - (t._ts > 0 ? e / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts)), Bh(t), r._dirty || _i(r, t)), t;
}, Ry = function(t, e) {
  var r;
  if ((e._time || !e._dur && e._initted || e._start < t._time && (e._dur || !e.add)) && (r = oh(t.rawTime(), e), (!e._dur || Ro(0, e.totalDuration(), r) - e._tTime > Rt) && e.render(r, !0)), _i(t, e)._dp && t._initted && t._time >= t._dur && t._ts) {
    if (t._dur < t.duration())
      for (r = t; r._dp; )
        r.rawTime() >= 0 && r.totalTime(r._tTime), r = r._dp;
    t._zTime = -Rt;
  }
}, Ir = function(t, e, r, i) {
  return e.parent && Gn(e), e._start = ae((on(r) ? r : r || t !== Ht ? Ve(t, r, e) : t._time) + e._delay), e._end = ae(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)), Py(t, e, "_first", "_last", t._sort ? "_start" : 0), Pc(e) || (t._recent = e), i || Ry(t, e), t._ts < 0 && Lh(t, t._tTime), t;
}, Dy = function(t, e) {
  return (Ue.ScrollTrigger || vd("scrollTrigger", e)) && Ue.ScrollTrigger.create(e, t);
}, Fy = function(t, e, r, i, s) {
  if (Ad(t, e, s), !t._initted)
    return 1;
  if (!r && t._pt && !me && (t._dur && t.vars.lazy !== !1 || !t._dur && t.vars.lazy) && Ey !== ke.frame)
    return On.push(t), t._lazy = [s, i], 1;
}, JA = function n(t) {
  var e = t.parent;
  return e && e._ts && e._initted && !e._lock && (e.rawTime() < 0 || n(e));
}, Pc = function(t) {
  var e = t.data;
  return e === "isFromStart" || e === "isStart";
}, tE = function(t, e, r, i) {
  var s = t.ratio, o = e < 0 || !e && (!t._start && JA(t) && !(!t._initted && Pc(t)) || (t._ts < 0 || t._dp._ts < 0) && !Pc(t)) ? 0 : 1, a = t._rDelay, h = 0, l, u, c;
  if (a && t._repeat && (h = Ro(0, t._tDur, e), u = fs(h, a), t._yoyo && u & 1 && (o = 1 - o), u !== fs(t._tTime, a) && (s = 1 - o, t.vars.repeatRefresh && t._initted && t.invalidate())), o !== s || me || i || t._zTime === Rt || !e && t._zTime) {
    if (!t._initted && Fy(t, e, i, r, h))
      return;
    for (c = t._zTime, t._zTime = e || (r ? Rt : 0), r || (r = e && !c), t.ratio = o, t._from && (o = 1 - o), t._time = 0, t._tTime = h, l = t._pt; l; )
      l.r(o, l.d), l = l._next;
    e < 0 && Ic(t, e, r, !0), t._onUpdate && !r && Be(t, "onUpdate"), h && t._repeat && !r && t.parent && Be(t, "onRepeat"), (e >= t._tDur || e < 0) && t.ratio === o && (o && Gn(t, 1), !r && !me && (Be(t, o ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()));
  } else t._zTime || (t._zTime = e);
}, eE = function(t, e, r) {
  var i;
  if (r > e)
    for (i = t._first; i && i._start <= r; ) {
      if (i.data === "isPause" && i._start > e)
        return i;
      i = i._next;
    }
  else
    for (i = t._last; i && i._start >= r; ) {
      if (i.data === "isPause" && i._start < e)
        return i;
      i = i._prev;
    }
}, ps = function(t, e, r, i) {
  var s = t._repeat, o = ae(e) || 0, a = t._tTime / t._tDur;
  return a && !i && (t._time *= o / t._dur), t._dur = o, t._tDur = s ? s < 0 ? 1e10 : ae(o * (s + 1) + t._rDelay * s) : o, a > 0 && !i && Lh(t, t._tTime = t._tDur * a), t.parent && Bh(t), r || _i(t.parent, t), t;
}, xm = function(t) {
  return t instanceof _e ? _i(t) : ps(t, t._dur);
}, rE = {
  _start: 0,
  endTime: mo,
  totalDuration: mo
}, Ve = function n(t, e, r) {
  var i = t.labels, s = t._recent || rE, o = t.duration() >= Qe ? s.endTime(!1) : t._dur, a, h, l;
  return he(e) && (isNaN(e) || e in i) ? (h = e.charAt(0), l = e.substr(-1) === "%", a = e.indexOf("="), h === "<" || h === ">" ? (a >= 0 && (e = e.replace(/=/, "")), (h === "<" ? s._start : s.endTime(s._repeat >= 0)) + (parseFloat(e.substr(1)) || 0) * (l ? (a < 0 ? s : r).totalDuration() / 100 : 1)) : a < 0 ? (e in i || (i[e] = o), i[e]) : (h = parseFloat(e.charAt(a - 1) + e.substr(a + 1)), l && r && (h = h / 100 * (ge(r) ? r[0] : r).totalDuration()), a > 1 ? n(t, e.substr(0, a - 1), r) + h : o + h)) : e == null ? o : +e;
}, lo = function(t, e, r) {
  var i = on(e[1]), s = (i ? 2 : 1) + (t < 2 ? 0 : 1), o = e[s], a, h;
  if (i && (o.duration = e[1]), o.parent = r, t) {
    for (a = o, h = r; h && !("immediateRender" in a); )
      a = h.vars.defaults || {}, h = Se(h.vars.inherit) && h.parent;
    o.immediateRender = Se(a.immediateRender), t < 2 ? o.runBackwards = 1 : o.startAt = e[s - 1];
  }
  return new qt(e[0], o, e[s + 1]);
}, $n = function(t, e) {
  return t || t === 0 ? e(t) : e;
}, Ro = function(t, e, r) {
  return r < t ? t : r > e ? e : r;
}, pe = function(t, e) {
  return !he(t) || !(e = XA.exec(t)) ? "" : e[1];
}, nE = function(t, e, r) {
  return $n(r, function(i) {
    return Ro(t, e, i);
  });
}, Rc = [].slice, Oy = function(t, e) {
  return t && Ur(t) && "length" in t && (!e && !t.length || t.length - 1 in t && Ur(t[0])) && !t.nodeType && t !== Cr;
}, iE = function(t, e, r) {
  return r === void 0 && (r = []), t.forEach(function(i) {
    var s;
    return he(i) && !e || Oy(i, 1) ? (s = r).push.apply(s, Je(i)) : r.push(i);
  }) || r;
}, Je = function(t, e, r) {
  return kt && !e && kt.selector ? kt.selector(t) : he(t) && !r && (Cc || !ms()) ? Rc.call((e || _d).querySelectorAll(t), 0) : ge(t) ? iE(t, r) : Oy(t) ? Rc.call(t, 0) : t ? [t] : [];
}, Dc = function(t) {
  return t = Je(t)[0] || po("Invalid scope") || {}, function(e) {
    var r = t.current || t.nativeElement || t;
    return Je(e, r.querySelectorAll ? r : r === t ? po("Invalid scope") || _d.createElement("div") : t);
  };
}, Ny = function(t) {
  return t.sort(function() {
    return 0.5 - Math.random();
  });
}, ky = function(t) {
  if (Xt(t))
    return t;
  var e = Ur(t) ? t : {
    each: t
  }, r = vi(e.ease), i = e.from || 0, s = parseFloat(e.base) || 0, o = {}, a = i > 0 && i < 1, h = isNaN(i) || a, l = e.axis, u = i, c = i;
  return he(i) ? u = c = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[i] || 0 : !a && h && (u = i[0], c = i[1]), function(d, f, p) {
    var m = (p || e).length, g = o[m], _, w, v, E, x, b, y, C, M;
    if (!g) {
      if (M = e.grid === "auto" ? 0 : (e.grid || [1, Qe])[1], !M) {
        for (y = -Qe; y < (y = p[M++].getBoundingClientRect().left) && M < m; )
          ;
        M < m && M--;
      }
      for (g = o[m] = [], _ = h ? Math.min(M, m) * u - 0.5 : i % M, w = M === Qe ? 0 : h ? m * c / M - 0.5 : i / M | 0, y = 0, C = Qe, b = 0; b < m; b++)
        v = b % M - _, E = w - (b / M | 0), g[b] = x = l ? Math.abs(l === "y" ? E : v) : yy(v * v + E * E), x > y && (y = x), x < C && (C = x);
      i === "random" && Ny(g), g.max = y - C, g.min = C, g.v = m = (parseFloat(e.amount) || parseFloat(e.each) * (M > m ? m - 1 : l ? l === "y" ? m / M : M : Math.max(M, m / M)) || 0) * (i === "edges" ? -1 : 1), g.b = m < 0 ? s - m : s, g.u = pe(e.amount || e.each) || 0, r = r && m < 0 ? Vy(r) : r;
    }
    return m = (g[d] - g.min) / g.max || 0, ae(g.b + (r ? r(m) : m) * g.v) + g.u;
  };
}, Fc = function(t) {
  var e = Math.pow(10, ((t + "").split(".")[1] || "").length);
  return function(r) {
    var i = ae(Math.round(parseFloat(r) / t) * t * e);
    return (i - i % 1) / e + (on(r) ? 0 : pe(r));
  };
}, By = function(t, e) {
  var r = ge(t), i, s;
  return !r && Ur(t) && (i = r = t.radius || Qe, t.values ? (t = Je(t.values), (s = !on(t[0])) && (i *= i)) : t = Fc(t.increment)), $n(e, r ? Xt(t) ? function(o) {
    return s = t(o), Math.abs(s - o) <= i ? s : o;
  } : function(o) {
    for (var a = parseFloat(s ? o.x : o), h = parseFloat(s ? o.y : 0), l = Qe, u = 0, c = t.length, d, f; c--; )
      s ? (d = t[c].x - a, f = t[c].y - h, d = d * d + f * f) : d = Math.abs(t[c] - a), d < l && (l = d, u = c);
    return u = !i || l <= i ? t[u] : o, s || u === o || on(o) ? u : u + pe(o);
  } : Fc(t));
}, Ly = function(t, e, r, i) {
  return $n(ge(t) ? !e : r === !0 ? !!(r = 0) : !i, function() {
    return ge(t) ? t[~~(Math.random() * t.length)] : (r = r || 1e-5) && (i = r < 1 ? Math.pow(10, (r + "").length - 2) : 1) && Math.floor(Math.round((t - r / 2 + Math.random() * (e - t + r * 0.99)) / r) * r * i) / i;
  });
}, sE = function() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return function(i) {
    return e.reduce(function(s, o) {
      return o(s);
    }, i);
  };
}, oE = function(t, e) {
  return function(r) {
    return t(parseFloat(r)) + (e || pe(r));
  };
}, aE = function(t, e, r) {
  return Hy(t, e, 0, 1, r);
}, Uy = function(t, e, r) {
  return $n(r, function(i) {
    return t[~~e(i)];
  });
}, hE = function n(t, e, r) {
  var i = e - t;
  return ge(t) ? Uy(t, n(0, t.length), e) : $n(r, function(s) {
    return (i + (s - t) % i) % i + t;
  });
}, lE = function n(t, e, r) {
  var i = e - t, s = i * 2;
  return ge(t) ? Uy(t, n(0, t.length - 1), e) : $n(r, function(o) {
    return o = (s + (o - t) % s) % s || 0, t + (o > i ? s - o : o);
  });
}, go = function(t) {
  for (var e = 0, r = "", i, s, o, a; ~(i = t.indexOf("random(", e)); )
    o = t.indexOf(")", i), a = t.charAt(i + 7) === "[", s = t.substr(i + 7, o - i - 7).match(a ? wy : Sc), r += t.substr(e, i - e) + Ly(a ? s : +s[0], a ? 0 : +s[1], +s[2] || 1e-5), e = o + 1;
  return r + t.substr(e, t.length - e);
}, Hy = function(t, e, r, i, s) {
  var o = e - t, a = i - r;
  return $n(s, function(h) {
    return r + ((h - t) / o * a || 0);
  });
}, uE = function n(t, e, r, i) {
  var s = isNaN(t + e) ? 0 : function(f) {
    return (1 - f) * t + f * e;
  };
  if (!s) {
    var o = he(t), a = {}, h, l, u, c, d;
    if (r === !0 && (i = 1) && (r = null), o)
      t = {
        p: t
      }, e = {
        p: e
      };
    else if (ge(t) && !ge(e)) {
      for (u = [], c = t.length, d = c - 2, l = 1; l < c; l++)
        u.push(n(t[l - 1], t[l]));
      c--, s = function(p) {
        p *= c;
        var m = Math.min(d, ~~p);
        return u[m](p - m);
      }, r = e;
    } else i || (t = Ei(ge(t) ? [] : {}, t));
    if (!u) {
      for (h in e)
        Td.call(a, t, h, "get", e[h]);
      s = function(p) {
        return Cd(p, a) || (o ? t.p : t);
      };
    }
  }
  return $n(r, s);
}, wm = function(t, e, r) {
  var i = t.labels, s = Qe, o, a, h;
  for (o in i)
    a = i[o] - e, a < 0 == !!r && a && s > (a = Math.abs(a)) && (h = o, s = a);
  return h;
}, Be = function(t, e, r) {
  var i = t.vars, s = i[e], o = kt, a = t._ctx, h, l, u;
  if (s)
    return h = i[e + "Params"], l = i.callbackScope || t, r && On.length && ih(), a && (kt = a), u = h ? s.apply(l, h) : s.call(l), kt = o, u;
}, eo = function(t) {
  return Gn(t), t.scrollTrigger && t.scrollTrigger.kill(!!me), t.progress() < 1 && Be(t, "onInterrupt"), t;
}, Ki, Gy = [], zy = function(t) {
  if (t)
    if (t = !t.name && t.default || t, yd() || t.headless) {
      var e = t.name, r = Xt(t), i = e && !r && t.init ? function() {
        this._props = [];
      } : t, s = {
        init: mo,
        render: Cd,
        add: Td,
        kill: SE,
        modifier: EE,
        rawVars: 0
      }, o = {
        targetTest: 0,
        get: 0,
        getSetter: Sd,
        aliases: {},
        register: 0
      };
      if (ms(), t !== i) {
        if (Ne[e])
          return;
        er(i, er(sh(t, s), o)), Ei(i.prototype, Ei(s, sh(t, o))), Ne[i.prop = e] = i, t.targetTest && (Oa.push(i), xd[e] = 1), e = (e === "css" ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin";
      }
      Ay(e, i), t.register && t.register(Pe, i, Me);
    } else
      Gy.push(t);
}, Pt = 255, ro = {
  aqua: [0, Pt, Pt],
  lime: [0, Pt, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, Pt],
  navy: [0, 0, 128],
  white: [Pt, Pt, Pt],
  olive: [128, 128, 0],
  yellow: [Pt, Pt, 0],
  orange: [Pt, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [Pt, 0, 0],
  pink: [Pt, 192, 203],
  cyan: [0, Pt, Pt],
  transparent: [Pt, Pt, Pt, 0]
}, wu = function(t, e, r) {
  return t += t < 0 ? 1 : t > 1 ? -1 : 0, (t * 6 < 1 ? e + (r - e) * t * 6 : t < 0.5 ? r : t * 3 < 2 ? e + (r - e) * (2 / 3 - t) * 6 : e) * Pt + 0.5 | 0;
}, Wy = function(t, e, r) {
  var i = t ? on(t) ? [t >> 16, t >> 8 & Pt, t & Pt] : 0 : ro.black, s, o, a, h, l, u, c, d, f, p;
  if (!i) {
    if (t.substr(-1) === "," && (t = t.substr(0, t.length - 1)), ro[t])
      i = ro[t];
    else if (t.charAt(0) === "#") {
      if (t.length < 6 && (s = t.charAt(1), o = t.charAt(2), a = t.charAt(3), t = "#" + s + s + o + o + a + a + (t.length === 5 ? t.charAt(4) + t.charAt(4) : "")), t.length === 9)
        return i = parseInt(t.substr(1, 6), 16), [i >> 16, i >> 8 & Pt, i & Pt, parseInt(t.substr(7), 16) / 255];
      t = parseInt(t.substr(1), 16), i = [t >> 16, t >> 8 & Pt, t & Pt];
    } else if (t.substr(0, 3) === "hsl") {
      if (i = p = t.match(Sc), !e)
        h = +i[0] % 360 / 360, l = +i[1] / 100, u = +i[2] / 100, o = u <= 0.5 ? u * (l + 1) : u + l - u * l, s = u * 2 - o, i.length > 3 && (i[3] *= 1), i[0] = wu(h + 1 / 3, s, o), i[1] = wu(h, s, o), i[2] = wu(h - 1 / 3, s, o);
      else if (~t.indexOf("="))
        return i = t.match(vy), r && i.length < 4 && (i[3] = 1), i;
    } else
      i = t.match(Sc) || ro.transparent;
    i = i.map(Number);
  }
  return e && !p && (s = i[0] / Pt, o = i[1] / Pt, a = i[2] / Pt, c = Math.max(s, o, a), d = Math.min(s, o, a), u = (c + d) / 2, c === d ? h = l = 0 : (f = c - d, l = u > 0.5 ? f / (2 - c - d) : f / (c + d), h = c === s ? (o - a) / f + (o < a ? 6 : 0) : c === o ? (a - s) / f + 2 : (s - o) / f + 4, h *= 60), i[0] = ~~(h + 0.5), i[1] = ~~(l * 100 + 0.5), i[2] = ~~(u * 100 + 0.5)), r && i.length < 4 && (i[3] = 1), i;
}, $y = function(t) {
  var e = [], r = [], i = -1;
  return t.split(Nn).forEach(function(s) {
    var o = s.match(Zi) || [];
    e.push.apply(e, o), r.push(i += o.length + 1);
  }), e.c = r, e;
}, bm = function(t, e, r) {
  var i = "", s = (t + i).match(Nn), o = e ? "hsla(" : "rgba(", a = 0, h, l, u, c;
  if (!s)
    return t;
  if (s = s.map(function(d) {
    return (d = Wy(d, e, 1)) && o + (e ? d[0] + "," + d[1] + "%," + d[2] + "%," + d[3] : d.join(",")) + ")";
  }), r && (u = $y(t), h = r.c, h.join(i) !== u.c.join(i)))
    for (l = t.replace(Nn, "1").split(Zi), c = l.length - 1; a < c; a++)
      i += l[a] + (~h.indexOf(a) ? s.shift() || o + "0,0,0,0)" : (u.length ? u : s.length ? s : r).shift());
  if (!l)
    for (l = t.split(Nn), c = l.length - 1; a < c; a++)
      i += l[a] + s[a];
  return i + l[c];
}, Nn = (function() {
  var n = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", t;
  for (t in ro)
    n += "|" + t + "\\b";
  return new RegExp(n + ")", "gi");
})(), cE = /hsl[a]?\(/, Xy = function(t) {
  var e = t.join(" "), r;
  if (Nn.lastIndex = 0, Nn.test(e))
    return r = cE.test(e), t[1] = bm(t[1], r), t[0] = bm(t[0], r, $y(t[1])), !0;
}, yo, ke = (function() {
  var n = Date.now, t = 500, e = 33, r = n(), i = r, s = 1e3 / 240, o = s, a = [], h, l, u, c, d, f, p = function m(g) {
    var _ = n() - i, w = g === !0, v, E, x, b;
    if ((_ > t || _ < 0) && (r += _ - e), i += _, x = i - r, v = x - o, (v > 0 || w) && (b = ++c.frame, d = x - c.time * 1e3, c.time = x = x / 1e3, o += v + (v >= s ? 4 : s - v), E = 1), w || (h = l(m)), E)
      for (f = 0; f < a.length; f++)
        a[f](x, d, b, g);
  };
  return c = {
    time: 0,
    frame: 0,
    tick: function() {
      p(!0);
    },
    deltaRatio: function(g) {
      return d / (1e3 / (g || 60));
    },
    wake: function() {
      by && (!Cc && yd() && (Cr = Cc = window, _d = Cr.document || {}, Ue.gsap = Pe, (Cr.gsapVersions || (Cr.gsapVersions = [])).push(Pe.version), Ty(nh || Cr.GreenSockGlobals || !Cr.gsap && Cr || {}), Gy.forEach(zy)), u = typeof requestAnimationFrame < "u" && requestAnimationFrame, h && c.sleep(), l = u || function(g) {
        return setTimeout(g, o - c.time * 1e3 + 1 | 0);
      }, yo = 1, p(2));
    },
    sleep: function() {
      (u ? cancelAnimationFrame : clearTimeout)(h), yo = 0, l = mo;
    },
    lagSmoothing: function(g, _) {
      t = g || 1 / 0, e = Math.min(_ || 33, t);
    },
    fps: function(g) {
      s = 1e3 / (g || 240), o = c.time * 1e3 + s;
    },
    add: function(g, _, w) {
      var v = _ ? function(E, x, b, y) {
        g(E, x, b, y), c.remove(v);
      } : g;
      return c.remove(g), a[w ? "unshift" : "push"](v), ms(), v;
    },
    remove: function(g, _) {
      ~(_ = a.indexOf(g)) && a.splice(_, 1) && f >= _ && f--;
    },
    _listeners: a
  }, c;
})(), ms = function() {
  return !yo && ke.wake();
}, Tt = {}, dE = /^[\d.\-M][\d.\-,\s]/, fE = /["']/g, pE = function(t) {
  for (var e = {}, r = t.substr(1, t.length - 3).split(":"), i = r[0], s = 1, o = r.length, a, h, l; s < o; s++)
    h = r[s], a = s !== o - 1 ? h.lastIndexOf(",") : h.length, l = h.substr(0, a), e[i] = isNaN(l) ? l.replace(fE, "").trim() : +l, i = h.substr(a + 1).trim();
  return e;
}, mE = function(t) {
  var e = t.indexOf("(") + 1, r = t.indexOf(")"), i = t.indexOf("(", e);
  return t.substring(e, ~i && i < r ? t.indexOf(")", r + 1) : r);
}, gE = function(t) {
  var e = (t + "").split("("), r = Tt[e[0]];
  return r && e.length > 1 && r.config ? r.config.apply(null, ~t.indexOf("{") ? [pE(e[1])] : mE(t).split(",").map(My)) : Tt._CE && dE.test(t) ? Tt._CE("", t) : r;
}, Vy = function(t) {
  return function(e) {
    return 1 - t(1 - e);
  };
}, Yy = function n(t, e) {
  for (var r = t._first, i; r; )
    r instanceof _e ? n(r, e) : r.vars.yoyoEase && (!r._yoyo || !r._repeat) && r._yoyo !== e && (r.timeline ? n(r.timeline, e) : (i = r._ease, r._ease = r._yEase, r._yEase = i, r._yoyo = e)), r = r._next;
}, vi = function(t, e) {
  return t && (Xt(t) ? t : Tt[t] || gE(t)) || e;
}, Fi = function(t, e, r, i) {
  r === void 0 && (r = function(h) {
    return 1 - e(1 - h);
  }), i === void 0 && (i = function(h) {
    return h < 0.5 ? e(h * 2) / 2 : 1 - e((1 - h) * 2) / 2;
  });
  var s = {
    easeIn: e,
    easeOut: r,
    easeInOut: i
  }, o;
  return Ce(t, function(a) {
    Tt[a] = Ue[a] = s, Tt[o = a.toLowerCase()] = r;
    for (var h in s)
      Tt[o + (h === "easeIn" ? ".in" : h === "easeOut" ? ".out" : ".inOut")] = Tt[a + "." + h] = s[h];
  }), s;
}, jy = function(t) {
  return function(e) {
    return e < 0.5 ? (1 - t(1 - e * 2)) / 2 : 0.5 + t((e - 0.5) * 2) / 2;
  };
}, bu = function n(t, e, r) {
  var i = e >= 1 ? e : 1, s = (r || (t ? 0.3 : 0.45)) / (e < 1 ? e : 1), o = s / Ec * (Math.asin(1 / i) || 0), a = function(u) {
    return u === 1 ? 1 : i * Math.pow(2, -10 * u) * $A((u - o) * s) + 1;
  }, h = t === "out" ? a : t === "in" ? function(l) {
    return 1 - a(1 - l);
  } : jy(a);
  return s = Ec / s, h.config = function(l, u) {
    return n(t, l, u);
  }, h;
}, Tu = function n(t, e) {
  e === void 0 && (e = 1.70158);
  var r = function(o) {
    return o ? --o * o * ((e + 1) * o + e) + 1 : 0;
  }, i = t === "out" ? r : t === "in" ? function(s) {
    return 1 - r(1 - s);
  } : jy(r);
  return i.config = function(s) {
    return n(t, s);
  }, i;
};
Ce("Linear,Quad,Cubic,Quart,Quint,Strong", function(n, t) {
  var e = t < 5 ? t + 1 : t;
  Fi(n + ",Power" + (e - 1), t ? function(r) {
    return Math.pow(r, e);
  } : function(r) {
    return r;
  }, function(r) {
    return 1 - Math.pow(1 - r, e);
  }, function(r) {
    return r < 0.5 ? Math.pow(r * 2, e) / 2 : 1 - Math.pow((1 - r) * 2, e) / 2;
  });
});
Tt.Linear.easeNone = Tt.none = Tt.Linear.easeIn;
Fi("Elastic", bu("in"), bu("out"), bu());
(function(n, t) {
  var e = 1 / t, r = 2 * e, i = 2.5 * e, s = function(a) {
    return a < e ? n * a * a : a < r ? n * Math.pow(a - 1.5 / t, 2) + 0.75 : a < i ? n * (a -= 2.25 / t) * a + 0.9375 : n * Math.pow(a - 2.625 / t, 2) + 0.984375;
  };
  Fi("Bounce", function(o) {
    return 1 - s(1 - o);
  }, s);
})(7.5625, 2.75);
Fi("Expo", function(n) {
  return n ? Math.pow(2, 10 * (n - 1)) : 0;
});
Fi("Circ", function(n) {
  return -(yy(1 - n * n) - 1);
});
Fi("Sine", function(n) {
  return n === 1 ? 1 : -WA(n * GA) + 1;
});
Fi("Back", Tu("in"), Tu("out"), Tu());
Tt.SteppedEase = Tt.steps = Ue.SteppedEase = {
  config: function(t, e) {
    t === void 0 && (t = 1);
    var r = 1 / t, i = t + (e ? 0 : 1), s = e ? 1 : 0, o = 1 - Rt;
    return function(a) {
      return ((i * Ro(0, o, a) | 0) + s) * r;
    };
  }
};
ds.ease = Tt["quad.out"];
Ce("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(n) {
  return wd += n + "," + n + "Params,";
});
var qy = function(t, e) {
  this.id = zA++, t._gsap = this, this.target = t, this.harness = e, this.get = e ? e.get : Sy, this.set = e ? e.getSetter : Sd;
}, _o = /* @__PURE__ */ (function() {
  function n(e) {
    this.vars = e, this._delay = +e.delay || 0, (this._repeat = e.repeat === 1 / 0 ? -2 : e.repeat || 0) && (this._rDelay = e.repeatDelay || 0, this._yoyo = !!e.yoyo || !!e.yoyoEase), this._ts = 1, ps(this, +e.duration, 1, 1), this.data = e.data, kt && (this._ctx = kt, kt.data.push(this)), yo || ke.wake();
  }
  var t = n.prototype;
  return t.delay = function(r) {
    return r || r === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + r - this._delay), this._delay = r, this) : this._delay;
  }, t.duration = function(r) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? r + (r + this._rDelay) * this._repeat : r) : this.totalDuration() && this._dur;
  }, t.totalDuration = function(r) {
    return arguments.length ? (this._dirty = 0, ps(this, this._repeat < 0 ? r : (r - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, t.totalTime = function(r, i) {
    if (ms(), !arguments.length)
      return this._tTime;
    var s = this._dp;
    if (s && s.smoothChildTiming && this._ts) {
      for (Lh(this, r), !s._dp || s.parent || Ry(s, this); s && s.parent; )
        s.parent._time !== s._start + (s._ts >= 0 ? s._tTime / s._ts : (s.totalDuration() - s._tTime) / -s._ts) && s.totalTime(s._tTime, !0), s = s.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && r < this._tDur || this._ts < 0 && r > 0 || !this._tDur && !r) && Ir(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== r || !this._dur && !i || this._initted && Math.abs(this._zTime) === Rt || !r && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = r), Cy(this, r, i)), this;
  }, t.time = function(r, i) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), r + vm(this)) % (this._dur + this._rDelay) || (r ? this._dur : 0), i) : this._time;
  }, t.totalProgress = function(r, i) {
    return arguments.length ? this.totalTime(this.totalDuration() * r, i) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
  }, t.progress = function(r, i) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - r : r) + vm(this), i) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, t.iteration = function(r, i) {
    var s = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (r - 1) * s, i) : this._repeat ? fs(this._tTime, s) + 1 : 1;
  }, t.timeScale = function(r, i) {
    if (!arguments.length)
      return this._rts === -Rt ? 0 : this._rts;
    if (this._rts === r)
      return this;
    var s = this.parent && this._ts ? oh(this.parent._time, this) : this._tTime;
    return this._rts = +r || 0, this._ts = this._ps || r === -Rt ? 0 : this._rts, this.totalTime(Ro(-Math.abs(this._delay), this._tDur, s), i !== !1), Bh(this), KA(this);
  }, t.paused = function(r) {
    return arguments.length ? (this._ps !== r && (this._ps = r, r ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (ms(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== Rt && (this._tTime -= Rt)))), this) : this._ps;
  }, t.startTime = function(r) {
    if (arguments.length) {
      this._start = r;
      var i = this.parent || this._dp;
      return i && (i._sort || !this.parent) && Ir(i, this, r - this._delay), this;
    }
    return this._start;
  }, t.endTime = function(r) {
    return this._start + (Se(r) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, t.rawTime = function(r) {
    var i = this.parent || this._dp;
    return i ? r && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? oh(i.rawTime(r), this) : this._tTime : this._tTime;
  }, t.revert = function(r) {
    r === void 0 && (r = YA);
    var i = me;
    return me = r, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(r), this.totalTime(-0.01, r.suppressEvents)), this.data !== "nested" && r.kill !== !1 && this.kill(), me = i, this;
  }, t.globalTime = function(r) {
    for (var i = this, s = arguments.length ? r : i.rawTime(); i; )
      s = i._start + s / (Math.abs(i._ts) || 1), i = i._dp;
    return !this.parent && this._sat ? this._sat.globalTime(r) : s;
  }, t.repeat = function(r) {
    return arguments.length ? (this._repeat = r === 1 / 0 ? -2 : r, xm(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, t.repeatDelay = function(r) {
    if (arguments.length) {
      var i = this._time;
      return this._rDelay = r, xm(this), i ? this.time(i) : this;
    }
    return this._rDelay;
  }, t.yoyo = function(r) {
    return arguments.length ? (this._yoyo = r, this) : this._yoyo;
  }, t.seek = function(r, i) {
    return this.totalTime(Ve(this, r), Se(i));
  }, t.restart = function(r, i) {
    return this.play().totalTime(r ? -this._delay : 0, Se(i));
  }, t.play = function(r, i) {
    return r != null && this.seek(r, i), this.reversed(!1).paused(!1);
  }, t.reverse = function(r, i) {
    return r != null && this.seek(r || this.totalDuration(), i), this.reversed(!0).paused(!1);
  }, t.pause = function(r, i) {
    return r != null && this.seek(r, i), this.paused(!0);
  }, t.resume = function() {
    return this.paused(!1);
  }, t.reversed = function(r) {
    return arguments.length ? (!!r !== this.reversed() && this.timeScale(-this._rts || (r ? -Rt : 0)), this) : this._rts < 0;
  }, t.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -Rt, this;
  }, t.isActive = function() {
    var r = this.parent || this._dp, i = this._start, s;
    return !!(!r || this._ts && this._initted && r.isActive() && (s = r.rawTime(!0)) >= i && s < this.endTime(!0) - Rt);
  }, t.eventCallback = function(r, i, s) {
    var o = this.vars;
    return arguments.length > 1 ? (i ? (o[r] = i, s && (o[r + "Params"] = s), r === "onUpdate" && (this._onUpdate = i)) : delete o[r], this) : o[r];
  }, t.then = function(r) {
    var i = this;
    return new Promise(function(s) {
      var o = Xt(r) ? r : Iy, a = function() {
        var l = i.then;
        i.then = null, Xt(o) && (o = o(i)) && (o.then || o === i) && (i.then = l), s(o), i.then = l;
      };
      i._initted && i.totalProgress() === 1 && i._ts >= 0 || !i._tTime && i._ts < 0 ? a() : i._prom = a;
    });
  }, t.kill = function() {
    eo(this);
  }, n;
})();
er(_o.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -Rt,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var _e = /* @__PURE__ */ (function(n) {
  gy(t, n);
  function t(r, i) {
    var s;
    return r === void 0 && (r = {}), s = n.call(this, r) || this, s.labels = {}, s.smoothChildTiming = !!r.smoothChildTiming, s.autoRemoveChildren = !!r.autoRemoveChildren, s._sort = Se(r.sortChildren), Ht && Ir(r.parent || Ht, Zr(s), i), r.reversed && s.reverse(), r.paused && s.paused(!0), r.scrollTrigger && Dy(Zr(s), r.scrollTrigger), s;
  }
  var e = t.prototype;
  return e.to = function(i, s, o) {
    return lo(0, arguments, this), this;
  }, e.from = function(i, s, o) {
    return lo(1, arguments, this), this;
  }, e.fromTo = function(i, s, o, a) {
    return lo(2, arguments, this), this;
  }, e.set = function(i, s, o) {
    return s.duration = 0, s.parent = this, ho(s).repeatDelay || (s.repeat = 0), s.immediateRender = !!s.immediateRender, new qt(i, s, Ve(this, o), 1), this;
  }, e.call = function(i, s, o) {
    return Ir(this, qt.delayedCall(0, i, s), o);
  }, e.staggerTo = function(i, s, o, a, h, l, u) {
    return o.duration = s, o.stagger = o.stagger || a, o.onComplete = l, o.onCompleteParams = u, o.parent = this, new qt(i, o, Ve(this, h)), this;
  }, e.staggerFrom = function(i, s, o, a, h, l, u) {
    return o.runBackwards = 1, ho(o).immediateRender = Se(o.immediateRender), this.staggerTo(i, s, o, a, h, l, u);
  }, e.staggerFromTo = function(i, s, o, a, h, l, u, c) {
    return a.startAt = o, ho(a).immediateRender = Se(a.immediateRender), this.staggerTo(i, s, a, h, l, u, c);
  }, e.render = function(i, s, o) {
    var a = this._time, h = this._dirty ? this.totalDuration() : this._tDur, l = this._dur, u = i <= 0 ? 0 : ae(i), c = this._zTime < 0 != i < 0 && (this._initted || !l), d, f, p, m, g, _, w, v, E, x, b, y;
    if (this !== Ht && u > h && i >= 0 && (u = h), u !== this._tTime || o || c) {
      if (a !== this._time && l && (u += this._time - a, i += this._time - a), d = u, E = this._start, v = this._ts, _ = !v, c && (l || (a = this._zTime), (i || !s) && (this._zTime = i)), this._repeat) {
        if (b = this._yoyo, g = l + this._rDelay, this._repeat < -1 && i < 0)
          return this.totalTime(g * 100 + i, s, o);
        if (d = ae(u % g), u === h ? (m = this._repeat, d = l) : (m = ~~(u / g), m && m === u / g && (d = l, m--), d > l && (d = l)), x = fs(this._tTime, g), !a && this._tTime && x !== m && this._tTime - x * g - this._dur <= 0 && (x = m), b && m & 1 && (d = l - d, y = 1), m !== x && !this._lock) {
          var C = b && x & 1, M = C === (b && m & 1);
          if (m < x && (C = !C), a = C ? 0 : u % l ? l : u, this._lock = 1, this.render(a || (y ? 0 : ae(m * g)), s, !l)._lock = 0, this._tTime = u, !s && this.parent && Be(this, "onRepeat"), this.vars.repeatRefresh && !y && (this.invalidate()._lock = 1), a && a !== this._time || _ !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (l = this._dur, h = this._tDur, M && (this._lock = 2, a = C ? l : -1e-4, this.render(a, !0), this.vars.repeatRefresh && !y && this.invalidate()), this._lock = 0, !this._ts && !_)
            return this;
          Yy(this, y);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (w = eE(this, ae(a), ae(d)), w && (u -= d - (d = w._start))), this._tTime = u, this._time = d, this._act = !v, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = i, a = 0), !a && d && !s && !m && (Be(this, "onStart"), this._tTime !== u))
        return this;
      if (d >= a && i >= 0)
        for (f = this._first; f; ) {
          if (p = f._next, (f._act || d >= f._start) && f._ts && w !== f) {
            if (f.parent !== this)
              return this.render(i, s, o);
            if (f.render(f._ts > 0 ? (d - f._start) * f._ts : (f._dirty ? f.totalDuration() : f._tDur) + (d - f._start) * f._ts, s, o), d !== this._time || !this._ts && !_) {
              w = 0, p && (u += this._zTime = -Rt);
              break;
            }
          }
          f = p;
        }
      else {
        f = this._last;
        for (var U = i < 0 ? i : d; f; ) {
          if (p = f._prev, (f._act || U <= f._end) && f._ts && w !== f) {
            if (f.parent !== this)
              return this.render(i, s, o);
            if (f.render(f._ts > 0 ? (U - f._start) * f._ts : (f._dirty ? f.totalDuration() : f._tDur) + (U - f._start) * f._ts, s, o || me && (f._initted || f._startAt)), d !== this._time || !this._ts && !_) {
              w = 0, p && (u += this._zTime = U ? -Rt : Rt);
              break;
            }
          }
          f = p;
        }
      }
      if (w && !s && (this.pause(), w.render(d >= a ? 0 : -Rt)._zTime = d >= a ? 1 : -1, this._ts))
        return this._start = E, Bh(this), this.render(i, s, o);
      this._onUpdate && !s && Be(this, "onUpdate", !0), (u === h && this._tTime >= this.totalDuration() || !u && a) && (E === this._start || Math.abs(v) !== Math.abs(this._ts)) && (this._lock || ((i || !l) && (u === h && this._ts > 0 || !u && this._ts < 0) && Gn(this, 1), !s && !(i < 0 && !a) && (u || a || !h) && (Be(this, u === h && i >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(u < h && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, e.add = function(i, s) {
    var o = this;
    if (on(s) || (s = Ve(this, s, i)), !(i instanceof _o)) {
      if (ge(i))
        return i.forEach(function(a) {
          return o.add(a, s);
        }), this;
      if (he(i))
        return this.addLabel(i, s);
      if (Xt(i))
        i = qt.delayedCall(0, i);
      else
        return this;
    }
    return this !== i ? Ir(this, i, s) : this;
  }, e.getChildren = function(i, s, o, a) {
    i === void 0 && (i = !0), s === void 0 && (s = !0), o === void 0 && (o = !0), a === void 0 && (a = -Qe);
    for (var h = [], l = this._first; l; )
      l._start >= a && (l instanceof qt ? s && h.push(l) : (o && h.push(l), i && h.push.apply(h, l.getChildren(!0, s, o)))), l = l._next;
    return h;
  }, e.getById = function(i) {
    for (var s = this.getChildren(1, 1, 1), o = s.length; o--; )
      if (s[o].vars.id === i)
        return s[o];
  }, e.remove = function(i) {
    return he(i) ? this.removeLabel(i) : Xt(i) ? this.killTweensOf(i) : (kh(this, i), i === this._recent && (this._recent = this._last), _i(this));
  }, e.totalTime = function(i, s) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = ae(ke.time - (this._ts > 0 ? i / this._ts : (this.totalDuration() - i) / -this._ts))), n.prototype.totalTime.call(this, i, s), this._forcing = 0, this) : this._tTime;
  }, e.addLabel = function(i, s) {
    return this.labels[i] = Ve(this, s), this;
  }, e.removeLabel = function(i) {
    return delete this.labels[i], this;
  }, e.addPause = function(i, s, o) {
    var a = qt.delayedCall(0, s || mo, o);
    return a.data = "isPause", this._hasPause = 1, Ir(this, a, Ve(this, i));
  }, e.removePause = function(i) {
    var s = this._first;
    for (i = Ve(this, i); s; )
      s._start === i && s.data === "isPause" && Gn(s), s = s._next;
  }, e.killTweensOf = function(i, s, o) {
    for (var a = this.getTweensOf(i, o), h = a.length; h--; )
      In !== a[h] && a[h].kill(i, s);
    return this;
  }, e.getTweensOf = function(i, s) {
    for (var o = [], a = Je(i), h = this._first, l = on(s), u; h; )
      h instanceof qt ? jA(h._targets, a) && (l ? (!In || h._initted && h._ts) && h.globalTime(0) <= s && h.globalTime(h.totalDuration()) > s : !s || h.isActive()) && o.push(h) : (u = h.getTweensOf(a, s)).length && o.push.apply(o, u), h = h._next;
    return o;
  }, e.tweenTo = function(i, s) {
    s = s || {};
    var o = this, a = Ve(o, i), h = s, l = h.startAt, u = h.onStart, c = h.onStartParams, d = h.immediateRender, f, p = qt.to(o, er({
      ease: s.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: a,
      overwrite: "auto",
      duration: s.duration || Math.abs((a - (l && "time" in l ? l.time : o._time)) / o.timeScale()) || Rt,
      onStart: function() {
        if (o.pause(), !f) {
          var g = s.duration || Math.abs((a - (l && "time" in l ? l.time : o._time)) / o.timeScale());
          p._dur !== g && ps(p, g, 0, 1).render(p._time, !0, !0), f = 1;
        }
        u && u.apply(p, c || []);
      }
    }, s));
    return d ? p.render(0) : p;
  }, e.tweenFromTo = function(i, s, o) {
    return this.tweenTo(s, er({
      startAt: {
        time: Ve(this, i)
      }
    }, o));
  }, e.recent = function() {
    return this._recent;
  }, e.nextLabel = function(i) {
    return i === void 0 && (i = this._time), wm(this, Ve(this, i));
  }, e.previousLabel = function(i) {
    return i === void 0 && (i = this._time), wm(this, Ve(this, i), 1);
  }, e.currentLabel = function(i) {
    return arguments.length ? this.seek(i, !0) : this.previousLabel(this._time + Rt);
  }, e.shiftChildren = function(i, s, o) {
    o === void 0 && (o = 0);
    for (var a = this._first, h = this.labels, l; a; )
      a._start >= o && (a._start += i, a._end += i), a = a._next;
    if (s)
      for (l in h)
        h[l] >= o && (h[l] += i);
    return _i(this);
  }, e.invalidate = function(i) {
    var s = this._first;
    for (this._lock = 0; s; )
      s.invalidate(i), s = s._next;
    return n.prototype.invalidate.call(this, i);
  }, e.clear = function(i) {
    i === void 0 && (i = !0);
    for (var s = this._first, o; s; )
      o = s._next, this.remove(s), s = o;
    return this._dp && (this._time = this._tTime = this._pTime = 0), i && (this.labels = {}), _i(this);
  }, e.totalDuration = function(i) {
    var s = 0, o = this, a = o._last, h = Qe, l, u, c;
    if (arguments.length)
      return o.timeScale((o._repeat < 0 ? o.duration() : o.totalDuration()) / (o.reversed() ? -i : i));
    if (o._dirty) {
      for (c = o.parent; a; )
        l = a._prev, a._dirty && a.totalDuration(), u = a._start, u > h && o._sort && a._ts && !o._lock ? (o._lock = 1, Ir(o, a, u - a._delay, 1)._lock = 0) : h = u, u < 0 && a._ts && (s -= u, (!c && !o._dp || c && c.smoothChildTiming) && (o._start += u / o._ts, o._time -= u, o._tTime -= u), o.shiftChildren(-u, !1, -1 / 0), h = 0), a._end > s && a._ts && (s = a._end), a = l;
      ps(o, o === Ht && o._time > s ? o._time : s, 1, 1), o._dirty = 0;
    }
    return o._tDur;
  }, t.updateRoot = function(i) {
    if (Ht._ts && (Cy(Ht, oh(i, Ht)), Ey = ke.frame), ke.frame >= ym) {
      ym += Le.autoSleep || 120;
      var s = Ht._first;
      if ((!s || !s._ts) && Le.autoSleep && ke._listeners.length < 2) {
        for (; s && !s._ts; )
          s = s._next;
        s || ke.sleep();
      }
    }
  }, t;
})(_o);
er(_e.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var yE = function(t, e, r, i, s, o, a) {
  var h = new Me(this._pt, t, e, 0, 1, e_, null, s), l = 0, u = 0, c, d, f, p, m, g, _, w;
  for (h.b = r, h.e = i, r += "", i += "", (_ = ~i.indexOf("random(")) && (i = go(i)), o && (w = [r, i], o(w, t, e), r = w[0], i = w[1]), d = r.match(vu) || []; c = vu.exec(i); )
    p = c[0], m = i.substring(l, c.index), f ? f = (f + 1) % 5 : m.substr(-5) === "rgba(" && (f = 1), p !== d[u++] && (g = parseFloat(d[u - 1]) || 0, h._pt = {
      _next: h._pt,
      p: m || u === 1 ? m : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: g,
      c: p.charAt(1) === "=" ? ss(g, p) - g : parseFloat(p) - g,
      m: f && f < 4 ? Math.round : 0
    }, l = vu.lastIndex);
  return h.c = l < i.length ? i.substring(l, i.length) : "", h.fp = a, (xy.test(i) || _) && (h.e = 0), this._pt = h, h;
}, Td = function(t, e, r, i, s, o, a, h, l, u) {
  Xt(i) && (i = i(s || 0, t, o));
  var c = t[e], d = r !== "get" ? r : Xt(c) ? l ? t[e.indexOf("set") || !Xt(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)](l) : t[e]() : c, f = Xt(c) ? l ? bE : Jy : Ed, p;
  if (he(i) && (~i.indexOf("random(") && (i = go(i)), i.charAt(1) === "=" && (p = ss(d, i) + (pe(d) || 0), (p || p === 0) && (i = p))), !u || d !== i || Oc)
    return !isNaN(d * i) && i !== "" ? (p = new Me(this._pt, t, e, +d || 0, i - (d || 0), typeof c == "boolean" ? AE : t_, 0, f), l && (p.fp = l), a && p.modifier(a, this, t), this._pt = p) : (!c && !(e in t) && vd(e, i), yE.call(this, t, e, d, i, f, h || Le.stringFilter, l));
}, _E = function(t, e, r, i, s) {
  if (Xt(t) && (t = uo(t, s, e, r, i)), !Ur(t) || t.style && t.nodeType || ge(t) || _y(t))
    return he(t) ? uo(t, s, e, r, i) : t;
  var o = {}, a;
  for (a in t)
    o[a] = uo(t[a], s, e, r, i);
  return o;
}, Zy = function(t, e, r, i, s, o) {
  var a, h, l, u;
  if (Ne[t] && (a = new Ne[t]()).init(s, a.rawVars ? e[t] : _E(e[t], i, s, o, r), r, i, o) !== !1 && (r._pt = h = new Me(r._pt, s, t, 0, 1, a.render, a, 0, a.priority), r !== Ki))
    for (l = r._ptLookup[r._targets.indexOf(s)], u = a._props.length; u--; )
      l[a._props[u]] = h;
  return a;
}, In, Oc, Ad = function n(t, e, r) {
  var i = t.vars, s = i.ease, o = i.startAt, a = i.immediateRender, h = i.lazy, l = i.onUpdate, u = i.runBackwards, c = i.yoyoEase, d = i.keyframes, f = i.autoRevert, p = t._dur, m = t._startAt, g = t._targets, _ = t.parent, w = _ && _.data === "nested" ? _.vars.targets : g, v = t._overwrite === "auto" && !md, E = t.timeline, x, b, y, C, M, U, F, O, R, k, j, T, S;
  if (E && (!d || !s) && (s = "none"), t._ease = vi(s, ds.ease), t._yEase = c ? Vy(vi(c === !0 ? s : c, ds.ease)) : 0, c && t._yoyo && !t._repeat && (c = t._yEase, t._yEase = t._ease, t._ease = c), t._from = !E && !!i.runBackwards, !E || d && !i.stagger) {
    if (O = g[0] ? yi(g[0]).harness : 0, T = O && i[O.prop], x = sh(i, xd), m && (m._zTime < 0 && m.progress(1), e < 0 && u && a && !f ? m.render(-1, !0) : m.revert(u && p ? Fa : VA), m._lazy = 0), o) {
      if (Gn(t._startAt = qt.set(g, er({
        data: "isStart",
        overwrite: !1,
        parent: _,
        immediateRender: !0,
        lazy: !m && Se(h),
        startAt: null,
        delay: 0,
        onUpdate: l && function() {
          return Be(t, "onUpdate");
        },
        stagger: 0
      }, o))), t._startAt._dp = 0, t._startAt._sat = t, e < 0 && (me || !a && !f) && t._startAt.revert(Fa), a && p && e <= 0 && r <= 0) {
        e && (t._zTime = e);
        return;
      }
    } else if (u && p && !m) {
      if (e && (a = !1), y = er({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: a && !m && Se(h),
        immediateRender: a,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: _
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, x), T && (y[O.prop] = T), Gn(t._startAt = qt.set(g, y)), t._startAt._dp = 0, t._startAt._sat = t, e < 0 && (me ? t._startAt.revert(Fa) : t._startAt.render(-1, !0)), t._zTime = e, !a)
        n(t._startAt, Rt, Rt);
      else if (!e)
        return;
    }
    for (t._pt = t._ptCache = 0, h = p && Se(h) || h && !p, b = 0; b < g.length; b++) {
      if (M = g[b], F = M._gsap || bd(g)[b]._gsap, t._ptLookup[b] = k = {}, Mc[F.id] && On.length && ih(), j = w === g ? b : w.indexOf(M), O && (R = new O()).init(M, T || x, t, j, w) !== !1 && (t._pt = C = new Me(t._pt, M, R.name, 0, 1, R.render, R, 0, R.priority), R._props.forEach(function(A) {
        k[A] = C;
      }), R.priority && (U = 1)), !O || T)
        for (y in x)
          Ne[y] && (R = Zy(y, x, t, j, M, w)) ? R.priority && (U = 1) : k[y] = C = Td.call(t, M, y, "get", x[y], j, w, 0, i.stringFilter);
      t._op && t._op[b] && t.kill(M, t._op[b]), v && t._pt && (In = t, Ht.killTweensOf(M, k, t.globalTime(e)), S = !t.parent, In = 0), t._pt && h && (Mc[F.id] = 1);
    }
    U && r_(t), t._onInit && t._onInit(t);
  }
  t._onUpdate = l, t._initted = (!t._op || t._pt) && !S, d && e <= 0 && E.render(Qe, !0, !0);
}, vE = function(t, e, r, i, s, o, a, h) {
  var l = (t._pt && t._ptCache || (t._ptCache = {}))[e], u, c, d, f;
  if (!l)
    for (l = t._ptCache[e] = [], d = t._ptLookup, f = t._targets.length; f--; ) {
      if (u = d[f][e], u && u.d && u.d._pt)
        for (u = u.d._pt; u && u.p !== e && u.fp !== e; )
          u = u._next;
      if (!u)
        return Oc = 1, t.vars[e] = "+=0", Ad(t, a), Oc = 0, h ? po(e + " not eligible for reset") : 1;
      l.push(u);
    }
  for (f = l.length; f--; )
    c = l[f], u = c._pt || c, u.s = (i || i === 0) && !s ? i : u.s + (i || 0) + o * u.c, u.c = r - u.s, c.e && (c.e = Vt(r) + pe(c.e)), c.b && (c.b = u.s + pe(c.b));
}, xE = function(t, e) {
  var r = t[0] ? yi(t[0]).harness : 0, i = r && r.aliases, s, o, a, h;
  if (!i)
    return e;
  s = Ei({}, e);
  for (o in i)
    if (o in s)
      for (h = i[o].split(","), a = h.length; a--; )
        s[h[a]] = s[o];
  return s;
}, wE = function(t, e, r, i) {
  var s = e.ease || i || "power1.inOut", o, a;
  if (ge(e))
    a = r[t] || (r[t] = []), e.forEach(function(h, l) {
      return a.push({
        t: l / (e.length - 1) * 100,
        v: h,
        e: s
      });
    });
  else
    for (o in e)
      a = r[o] || (r[o] = []), o === "ease" || a.push({
        t: parseFloat(t),
        v: e[o],
        e: s
      });
}, uo = function(t, e, r, i, s) {
  return Xt(t) ? t.call(e, r, i, s) : he(t) && ~t.indexOf("random(") ? go(t) : t;
}, Ky = wd + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", Qy = {};
Ce(Ky + ",id,stagger,delay,duration,paused,scrollTrigger", function(n) {
  return Qy[n] = 1;
});
var qt = /* @__PURE__ */ (function(n) {
  gy(t, n);
  function t(r, i, s, o) {
    var a;
    typeof i == "number" && (s.duration = i, i = s, s = null), a = n.call(this, o ? i : ho(i)) || this;
    var h = a.vars, l = h.duration, u = h.delay, c = h.immediateRender, d = h.stagger, f = h.overwrite, p = h.keyframes, m = h.defaults, g = h.scrollTrigger, _ = h.yoyoEase, w = i.parent || Ht, v = (ge(r) || _y(r) ? on(r[0]) : "length" in i) ? [r] : Je(r), E, x, b, y, C, M, U, F;
    if (a._targets = v.length ? bd(v) : po("GSAP target " + r + " not found. https://gsap.com", !Le.nullTargetWarn) || [], a._ptLookup = [], a._overwrite = f, p || d || ya(l) || ya(u)) {
      if (i = a.vars, E = a.timeline = new _e({
        data: "nested",
        defaults: m || {},
        targets: w && w.data === "nested" ? w.vars.targets : v
      }), E.kill(), E.parent = E._dp = Zr(a), E._start = 0, d || ya(l) || ya(u)) {
        if (y = v.length, U = d && ky(d), Ur(d))
          for (C in d)
            ~Ky.indexOf(C) && (F || (F = {}), F[C] = d[C]);
        for (x = 0; x < y; x++)
          b = sh(i, Qy), b.stagger = 0, _ && (b.yoyoEase = _), F && Ei(b, F), M = v[x], b.duration = +uo(l, Zr(a), x, M, v), b.delay = (+uo(u, Zr(a), x, M, v) || 0) - a._delay, !d && y === 1 && b.delay && (a._delay = u = b.delay, a._start += u, b.delay = 0), E.to(M, b, U ? U(x, M, v) : 0), E._ease = Tt.none;
        E.duration() ? l = u = 0 : a.timeline = 0;
      } else if (p) {
        ho(er(E.vars.defaults, {
          ease: "none"
        })), E._ease = vi(p.ease || i.ease || "none");
        var O = 0, R, k, j;
        if (ge(p))
          p.forEach(function(T) {
            return E.to(v, T, ">");
          }), E.duration();
        else {
          b = {};
          for (C in p)
            C === "ease" || C === "easeEach" || wE(C, p[C], b, p.easeEach);
          for (C in b)
            for (R = b[C].sort(function(T, S) {
              return T.t - S.t;
            }), O = 0, x = 0; x < R.length; x++)
              k = R[x], j = {
                ease: k.e,
                duration: (k.t - (x ? R[x - 1].t : 0)) / 100 * l
              }, j[C] = k.v, E.to(v, j, O), O += j.duration;
          E.duration() < l && E.to({}, {
            duration: l - E.duration()
          });
        }
      }
      l || a.duration(l = E.duration());
    } else
      a.timeline = 0;
    return f === !0 && !md && (In = Zr(a), Ht.killTweensOf(v), In = 0), Ir(w, Zr(a), s), i.reversed && a.reverse(), i.paused && a.paused(!0), (c || !l && !p && a._start === ae(w._time) && Se(c) && QA(Zr(a)) && w.data !== "nested") && (a._tTime = -Rt, a.render(Math.max(0, -u) || 0)), g && Dy(Zr(a), g), a;
  }
  var e = t.prototype;
  return e.render = function(i, s, o) {
    var a = this._time, h = this._tDur, l = this._dur, u = i < 0, c = i > h - Rt && !u ? h : i < Rt ? 0 : i, d, f, p, m, g, _, w, v, E;
    if (!l)
      tE(this, i, s, o);
    else if (c !== this._tTime || !i || o || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== u) {
      if (d = c, v = this.timeline, this._repeat) {
        if (m = l + this._rDelay, this._repeat < -1 && u)
          return this.totalTime(m * 100 + i, s, o);
        if (d = ae(c % m), c === h ? (p = this._repeat, d = l) : (p = ~~(c / m), p && p === ae(c / m) && (d = l, p--), d > l && (d = l)), _ = this._yoyo && p & 1, _ && (E = this._yEase, d = l - d), g = fs(this._tTime, m), d === a && !o && this._initted && p === g)
          return this._tTime = c, this;
        p !== g && (v && this._yEase && Yy(v, _), this.vars.repeatRefresh && !_ && !this._lock && this._time !== m && this._initted && (this._lock = o = 1, this.render(ae(m * p), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (Fy(this, u ? i : d, o, s, c))
          return this._tTime = 0, this;
        if (a !== this._time && !(o && this.vars.repeatRefresh && p !== g))
          return this;
        if (l !== this._dur)
          return this.render(i, s, o);
      }
      if (this._tTime = c, this._time = d, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = w = (E || this._ease)(d / l), this._from && (this.ratio = w = 1 - w), d && !a && !s && !p && (Be(this, "onStart"), this._tTime !== c))
        return this;
      for (f = this._pt; f; )
        f.r(w, f.d), f = f._next;
      v && v.render(i < 0 ? i : v._dur * v._ease(d / this._dur), s, o) || this._startAt && (this._zTime = i), this._onUpdate && !s && (u && Ic(this, i, s, o), Be(this, "onUpdate")), this._repeat && p !== g && this.vars.onRepeat && !s && this.parent && Be(this, "onRepeat"), (c === this._tDur || !c) && this._tTime === c && (u && !this._onUpdate && Ic(this, i, !0, !0), (i || !l) && (c === this._tDur && this._ts > 0 || !c && this._ts < 0) && Gn(this, 1), !s && !(u && !a) && (c || a || _) && (Be(this, c === h ? "onComplete" : "onReverseComplete", !0), this._prom && !(c < h && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, e.targets = function() {
    return this._targets;
  }, e.invalidate = function(i) {
    return (!i || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(i), n.prototype.invalidate.call(this, i);
  }, e.resetTo = function(i, s, o, a, h) {
    yo || ke.wake(), this._ts || this.play();
    var l = Math.min(this._dur, (this._dp._time - this._start) * this._ts), u;
    return this._initted || Ad(this, l), u = this._ease(l / this._dur), vE(this, i, s, o, a, u, l, h) ? this.resetTo(i, s, o, a, 1) : (Lh(this, 0), this.parent || Py(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, e.kill = function(i, s) {
    if (s === void 0 && (s = "all"), !i && (!s || s === "all"))
      return this._lazy = this._pt = 0, this.parent ? eo(this) : this;
    if (this.timeline) {
      var o = this.timeline.totalDuration();
      return this.timeline.killTweensOf(i, s, In && In.vars.overwrite !== !0)._first || eo(this), this.parent && o !== this.timeline.totalDuration() && ps(this, this._dur * this.timeline._tDur / o, 0, 1), this;
    }
    var a = this._targets, h = i ? Je(i) : a, l = this._ptLookup, u = this._pt, c, d, f, p, m, g, _;
    if ((!s || s === "all") && ZA(a, h))
      return s === "all" && (this._pt = 0), eo(this);
    for (c = this._op = this._op || [], s !== "all" && (he(s) && (m = {}, Ce(s, function(w) {
      return m[w] = 1;
    }), s = m), s = xE(a, s)), _ = a.length; _--; )
      if (~h.indexOf(a[_])) {
        d = l[_], s === "all" ? (c[_] = s, p = d, f = {}) : (f = c[_] = c[_] || {}, p = s);
        for (m in p)
          g = d && d[m], g && ((!("kill" in g.d) || g.d.kill(m) === !0) && kh(this, g, "_pt"), delete d[m]), f !== "all" && (f[m] = 1);
      }
    return this._initted && !this._pt && u && eo(this), this;
  }, t.to = function(i, s) {
    return new t(i, s, arguments[2]);
  }, t.from = function(i, s) {
    return lo(1, arguments);
  }, t.delayedCall = function(i, s, o, a) {
    return new t(s, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: i,
      onComplete: s,
      onReverseComplete: s,
      onCompleteParams: o,
      onReverseCompleteParams: o,
      callbackScope: a
    });
  }, t.fromTo = function(i, s, o) {
    return lo(2, arguments);
  }, t.set = function(i, s) {
    return s.duration = 0, s.repeatDelay || (s.repeat = 0), new t(i, s);
  }, t.killTweensOf = function(i, s, o) {
    return Ht.killTweensOf(i, s, o);
  }, t;
})(_o);
er(qt.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
Ce("staggerTo,staggerFrom,staggerFromTo", function(n) {
  qt[n] = function() {
    var t = new _e(), e = Rc.call(arguments, 0);
    return e.splice(n === "staggerFromTo" ? 5 : 4, 0, 0), t[n].apply(t, e);
  };
});
var Ed = function(t, e, r) {
  return t[e] = r;
}, Jy = function(t, e, r) {
  return t[e](r);
}, bE = function(t, e, r, i) {
  return t[e](i.fp, r);
}, TE = function(t, e, r) {
  return t.setAttribute(e, r);
}, Sd = function(t, e) {
  return Xt(t[e]) ? Jy : gd(t[e]) && t.setAttribute ? TE : Ed;
}, t_ = function(t, e) {
  return e.set(e.t, e.p, Math.round((e.s + e.c * t) * 1e6) / 1e6, e);
}, AE = function(t, e) {
  return e.set(e.t, e.p, !!(e.s + e.c * t), e);
}, e_ = function(t, e) {
  var r = e._pt, i = "";
  if (!t && e.b)
    i = e.b;
  else if (t === 1 && e.e)
    i = e.e;
  else {
    for (; r; )
      i = r.p + (r.m ? r.m(r.s + r.c * t) : Math.round((r.s + r.c * t) * 1e4) / 1e4) + i, r = r._next;
    i += e.c;
  }
  e.set(e.t, e.p, i, e);
}, Cd = function(t, e) {
  for (var r = e._pt; r; )
    r.r(t, r.d), r = r._next;
}, EE = function(t, e, r, i) {
  for (var s = this._pt, o; s; )
    o = s._next, s.p === i && s.modifier(t, e, r), s = o;
}, SE = function(t) {
  for (var e = this._pt, r, i; e; )
    i = e._next, e.p === t && !e.op || e.op === t ? kh(this, e, "_pt") : e.dep || (r = 1), e = i;
  return !r;
}, CE = function(t, e, r, i) {
  i.mSet(t, e, i.m.call(i.tween, r, i.mt), i);
}, r_ = function(t) {
  for (var e = t._pt, r, i, s, o; e; ) {
    for (r = e._next, i = s; i && i.pr > e.pr; )
      i = i._next;
    (e._prev = i ? i._prev : o) ? e._prev._next = e : s = e, (e._next = i) ? i._prev = e : o = e, e = r;
  }
  t._pt = s;
}, Me = /* @__PURE__ */ (function() {
  function n(e, r, i, s, o, a, h, l, u) {
    this.t = r, this.s = s, this.c = o, this.p = i, this.r = a || t_, this.d = h || this, this.set = l || Ed, this.pr = u || 0, this._next = e, e && (e._prev = this);
  }
  var t = n.prototype;
  return t.modifier = function(r, i, s) {
    this.mSet = this.mSet || this.set, this.set = CE, this.m = r, this.mt = s, this.tween = i;
  }, n;
})();
Ce(wd + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(n) {
  return xd[n] = 1;
});
Ue.TweenMax = Ue.TweenLite = qt;
Ue.TimelineLite = Ue.TimelineMax = _e;
Ht = new _e({
  sortChildren: !1,
  defaults: ds,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
Le.stringFilter = Xy;
var xi = [], Na = {}, ME = [], Tm = 0, IE = 0, Au = function(t) {
  return (Na[t] || ME).map(function(e) {
    return e();
  });
}, Nc = function() {
  var t = Date.now(), e = [];
  t - Tm > 2 && (Au("matchMediaInit"), xi.forEach(function(r) {
    var i = r.queries, s = r.conditions, o, a, h, l;
    for (a in i)
      o = Cr.matchMedia(i[a]).matches, o && (h = 1), o !== s[a] && (s[a] = o, l = 1);
    l && (r.revert(), h && e.push(r));
  }), Au("matchMediaRevert"), e.forEach(function(r) {
    return r.onMatch(r, function(i) {
      return r.add(null, i);
    });
  }), Tm = t, Au("matchMedia"));
}, n_ = /* @__PURE__ */ (function() {
  function n(e, r) {
    this.selector = r && Dc(r), this.data = [], this._r = [], this.isReverted = !1, this.id = IE++, e && this.add(e);
  }
  var t = n.prototype;
  return t.add = function(r, i, s) {
    Xt(r) && (s = i, i = r, r = Xt);
    var o = this, a = function() {
      var l = kt, u = o.selector, c;
      return l && l !== o && l.data.push(o), s && (o.selector = Dc(s)), kt = o, c = i.apply(o, arguments), Xt(c) && o._r.push(c), kt = l, o.selector = u, o.isReverted = !1, c;
    };
    return o.last = a, r === Xt ? a(o, function(h) {
      return o.add(null, h);
    }) : r ? o[r] = a : a;
  }, t.ignore = function(r) {
    var i = kt;
    kt = null, r(this), kt = i;
  }, t.getTweens = function() {
    var r = [];
    return this.data.forEach(function(i) {
      return i instanceof n ? r.push.apply(r, i.getTweens()) : i instanceof qt && !(i.parent && i.parent.data === "nested") && r.push(i);
    }), r;
  }, t.clear = function() {
    this._r.length = this.data.length = 0;
  }, t.kill = function(r, i) {
    var s = this;
    if (r ? (function() {
      for (var a = s.getTweens(), h = s.data.length, l; h--; )
        l = s.data[h], l.data === "isFlip" && (l.revert(), l.getChildren(!0, !0, !1).forEach(function(u) {
          return a.splice(a.indexOf(u), 1);
        }));
      for (a.map(function(u) {
        return {
          g: u._dur || u._delay || u._sat && !u._sat.vars.immediateRender ? u.globalTime(0) : -1 / 0,
          t: u
        };
      }).sort(function(u, c) {
        return c.g - u.g || -1 / 0;
      }).forEach(function(u) {
        return u.t.revert(r);
      }), h = s.data.length; h--; )
        l = s.data[h], l instanceof _e ? l.data !== "nested" && (l.scrollTrigger && l.scrollTrigger.revert(), l.kill()) : !(l instanceof qt) && l.revert && l.revert(r);
      s._r.forEach(function(u) {
        return u(r, s);
      }), s.isReverted = !0;
    })() : this.data.forEach(function(a) {
      return a.kill && a.kill();
    }), this.clear(), i)
      for (var o = xi.length; o--; )
        xi[o].id === this.id && xi.splice(o, 1);
  }, t.revert = function(r) {
    this.kill(r || {});
  }, n;
})(), PE = /* @__PURE__ */ (function() {
  function n(e) {
    this.contexts = [], this.scope = e, kt && kt.data.push(this);
  }
  var t = n.prototype;
  return t.add = function(r, i, s) {
    Ur(r) || (r = {
      matches: r
    });
    var o = new n_(0, s || this.scope), a = o.conditions = {}, h, l, u;
    kt && !o.selector && (o.selector = kt.selector), this.contexts.push(o), i = o.add("onMatch", i), o.queries = r;
    for (l in r)
      l === "all" ? u = 1 : (h = Cr.matchMedia(r[l]), h && (xi.indexOf(o) < 0 && xi.push(o), (a[l] = h.matches) && (u = 1), h.addListener ? h.addListener(Nc) : h.addEventListener("change", Nc)));
    return u && i(o, function(c) {
      return o.add(null, c);
    }), this;
  }, t.revert = function(r) {
    this.kill(r || {});
  }, t.kill = function(r) {
    this.contexts.forEach(function(i) {
      return i.kill(r, !0);
    });
  }, n;
})(), ah = {
  registerPlugin: function() {
    for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
      e[r] = arguments[r];
    e.forEach(function(i) {
      return zy(i);
    });
  },
  timeline: function(t) {
    return new _e(t);
  },
  getTweensOf: function(t, e) {
    return Ht.getTweensOf(t, e);
  },
  getProperty: function(t, e, r, i) {
    he(t) && (t = Je(t)[0]);
    var s = yi(t || {}).get, o = r ? Iy : My;
    return r === "native" && (r = ""), t && (e ? o((Ne[e] && Ne[e].get || s)(t, e, r, i)) : function(a, h, l) {
      return o((Ne[a] && Ne[a].get || s)(t, a, h, l));
    });
  },
  quickSetter: function(t, e, r) {
    if (t = Je(t), t.length > 1) {
      var i = t.map(function(u) {
        return Pe.quickSetter(u, e, r);
      }), s = i.length;
      return function(u) {
        for (var c = s; c--; )
          i[c](u);
      };
    }
    t = t[0] || {};
    var o = Ne[e], a = yi(t), h = a.harness && (a.harness.aliases || {})[e] || e, l = o ? function(u) {
      var c = new o();
      Ki._pt = 0, c.init(t, r ? u + r : u, Ki, 0, [t]), c.render(1, c), Ki._pt && Cd(1, Ki);
    } : a.set(t, h);
    return o ? l : function(u) {
      return l(t, h, r ? u + r : u, a, 1);
    };
  },
  quickTo: function(t, e, r) {
    var i, s = Pe.to(t, Ei((i = {}, i[e] = "+=0.1", i.paused = !0, i), r || {})), o = function(h, l, u) {
      return s.resetTo(e, h, l, u);
    };
    return o.tween = s, o;
  },
  isTweening: function(t) {
    return Ht.getTweensOf(t, !0).length > 0;
  },
  defaults: function(t) {
    return t && t.ease && (t.ease = vi(t.ease, ds.ease)), _m(ds, t || {});
  },
  config: function(t) {
    return _m(Le, t || {});
  },
  registerEffect: function(t) {
    var e = t.name, r = t.effect, i = t.plugins, s = t.defaults, o = t.extendTimeline;
    (i || "").split(",").forEach(function(a) {
      return a && !Ne[a] && !Ue[a] && po(e + " effect requires " + a + " plugin.");
    }), xu[e] = function(a, h, l) {
      return r(Je(a), er(h || {}, s), l);
    }, o && (_e.prototype[e] = function(a, h, l) {
      return this.add(xu[e](a, Ur(h) ? h : (l = h) && {}, this), l);
    });
  },
  registerEase: function(t, e) {
    Tt[t] = vi(e);
  },
  parseEase: function(t, e) {
    return arguments.length ? vi(t, e) : Tt;
  },
  getById: function(t) {
    return Ht.getById(t);
  },
  exportRoot: function(t, e) {
    t === void 0 && (t = {});
    var r = new _e(t), i, s;
    for (r.smoothChildTiming = Se(t.smoothChildTiming), Ht.remove(r), r._dp = 0, r._time = r._tTime = Ht._time, i = Ht._first; i; )
      s = i._next, (e || !(!i._dur && i instanceof qt && i.vars.onComplete === i._targets[0])) && Ir(r, i, i._start - i._delay), i = s;
    return Ir(Ht, r, 0), r;
  },
  context: function(t, e) {
    return t ? new n_(t, e) : kt;
  },
  matchMedia: function(t) {
    return new PE(t);
  },
  matchMediaRefresh: function() {
    return xi.forEach(function(t) {
      var e = t.conditions, r, i;
      for (i in e)
        e[i] && (e[i] = !1, r = 1);
      r && t.revert();
    }) || Nc();
  },
  addEventListener: function(t, e) {
    var r = Na[t] || (Na[t] = []);
    ~r.indexOf(e) || r.push(e);
  },
  removeEventListener: function(t, e) {
    var r = Na[t], i = r && r.indexOf(e);
    i >= 0 && r.splice(i, 1);
  },
  utils: {
    wrap: hE,
    wrapYoyo: lE,
    distribute: ky,
    random: Ly,
    snap: By,
    normalize: aE,
    getUnit: pe,
    clamp: nE,
    splitColor: Wy,
    toArray: Je,
    selector: Dc,
    mapRange: Hy,
    pipe: sE,
    unitize: oE,
    interpolate: uE,
    shuffle: Ny
  },
  install: Ty,
  effects: xu,
  ticker: ke,
  updateRoot: _e.updateRoot,
  plugins: Ne,
  globalTimeline: Ht,
  core: {
    PropTween: Me,
    globals: Ay,
    Tween: qt,
    Timeline: _e,
    Animation: _o,
    getCache: yi,
    _removeLinkedListItem: kh,
    reverting: function() {
      return me;
    },
    context: function(t) {
      return t && kt && (kt.data.push(t), t._ctx = kt), kt;
    },
    suppressOverwrites: function(t) {
      return md = t;
    }
  }
};
Ce("to,from,fromTo,delayedCall,set,killTweensOf", function(n) {
  return ah[n] = qt[n];
});
ke.add(_e.updateRoot);
Ki = ah.to({}, {
  duration: 0
});
var RE = function(t, e) {
  for (var r = t._pt; r && r.p !== e && r.op !== e && r.fp !== e; )
    r = r._next;
  return r;
}, DE = function(t, e) {
  var r = t._targets, i, s, o;
  for (i in e)
    for (s = r.length; s--; )
      o = t._ptLookup[s][i], o && (o = o.d) && (o._pt && (o = RE(o, i)), o && o.modifier && o.modifier(e[i], t, r[s], i));
}, Eu = function(t, e) {
  return {
    name: t,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(i, s, o) {
      o._onInit = function(a) {
        var h, l;
        if (he(s) && (h = {}, Ce(s, function(u) {
          return h[u] = 1;
        }), s = h), e) {
          h = {};
          for (l in s)
            h[l] = e(s[l]);
          s = h;
        }
        DE(a, s);
      };
    }
  };
}, Pe = ah.registerPlugin({
  name: "attr",
  init: function(t, e, r, i, s) {
    var o, a, h;
    this.tween = r;
    for (o in e)
      h = t.getAttribute(o) || "", a = this.add(t, "setAttribute", (h || 0) + "", e[o], i, s, 0, 0, o), a.op = o, a.b = h, this._props.push(o);
  },
  render: function(t, e) {
    for (var r = e._pt; r; )
      me ? r.set(r.t, r.p, r.b, r) : r.r(t, r.d), r = r._next;
  }
}, {
  name: "endArray",
  init: function(t, e) {
    for (var r = e.length; r--; )
      this.add(t, r, t[r] || 0, e[r], 0, 0, 0, 0, 0, 1);
  }
}, Eu("roundProps", Fc), Eu("modifiers"), Eu("snap", By)) || ah;
qt.version = _e.version = Pe.version = "3.12.5";
by = 1;
yd() && ms();
Tt.Power0;
Tt.Power1;
Tt.Power2;
Tt.Power3;
Tt.Power4;
Tt.Linear;
Tt.Quad;
Tt.Cubic;
Tt.Quart;
Tt.Quint;
Tt.Strong;
Tt.Elastic;
Tt.Back;
Tt.SteppedEase;
Tt.Bounce;
Tt.Sine;
Tt.Expo;
Tt.Circ;
var Am, Pn, os, Md, di, Em, Id, FE = function() {
  return typeof window < "u";
}, an = {}, ui = 180 / Math.PI, as = Math.PI / 180, Gi = Math.atan2, Sm = 1e8, Pd = /([A-Z])/g, OE = /(left|right|width|margin|padding|x)/i, NE = /[\s,\(]\S/, Rr = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, kc = function(t, e) {
  return e.set(e.t, e.p, Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u, e);
}, kE = function(t, e) {
  return e.set(e.t, e.p, t === 1 ? e.e : Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u, e);
}, BE = function(t, e) {
  return e.set(e.t, e.p, t ? Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u : e.b, e);
}, LE = function(t, e) {
  var r = e.s + e.c * t;
  e.set(e.t, e.p, ~~(r + (r < 0 ? -0.5 : 0.5)) + e.u, e);
}, i_ = function(t, e) {
  return e.set(e.t, e.p, t ? e.e : e.b, e);
}, s_ = function(t, e) {
  return e.set(e.t, e.p, t !== 1 ? e.b : e.e, e);
}, UE = function(t, e, r) {
  return t.style[e] = r;
}, HE = function(t, e, r) {
  return t.style.setProperty(e, r);
}, GE = function(t, e, r) {
  return t._gsap[e] = r;
}, zE = function(t, e, r) {
  return t._gsap.scaleX = t._gsap.scaleY = r;
}, WE = function(t, e, r, i, s) {
  var o = t._gsap;
  o.scaleX = o.scaleY = r, o.renderTransform(s, o);
}, $E = function(t, e, r, i, s) {
  var o = t._gsap;
  o[e] = r, o.renderTransform(s, o);
}, Gt = "transform", Ie = Gt + "Origin", XE = function n(t, e) {
  var r = this, i = this.target, s = i.style, o = i._gsap;
  if (t in an && s) {
    if (this.tfm = this.tfm || {}, t !== "transform")
      t = Rr[t] || t, ~t.indexOf(",") ? t.split(",").forEach(function(a) {
        return r.tfm[a] = Kr(i, a);
      }) : this.tfm[t] = o.x ? o[t] : Kr(i, t), t === Ie && (this.tfm.zOrigin = o.zOrigin);
    else
      return Rr.transform.split(",").forEach(function(a) {
        return n.call(r, a, e);
      });
    if (this.props.indexOf(Gt) >= 0)
      return;
    o.svg && (this.svgo = i.getAttribute("data-svg-origin"), this.props.push(Ie, e, "")), t = Gt;
  }
  (s || e) && this.props.push(t, e, s[t]);
}, o_ = function(t) {
  t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
}, VE = function() {
  var t = this.props, e = this.target, r = e.style, i = e._gsap, s, o;
  for (s = 0; s < t.length; s += 3)
    t[s + 1] ? e[t[s]] = t[s + 2] : t[s + 2] ? r[t[s]] = t[s + 2] : r.removeProperty(t[s].substr(0, 2) === "--" ? t[s] : t[s].replace(Pd, "-$1").toLowerCase());
  if (this.tfm) {
    for (o in this.tfm)
      i[o] = this.tfm[o];
    i.svg && (i.renderTransform(), e.setAttribute("data-svg-origin", this.svgo || "")), s = Id(), (!s || !s.isStart) && !r[Gt] && (o_(r), i.zOrigin && r[Ie] && (r[Ie] += " " + i.zOrigin + "px", i.zOrigin = 0, i.renderTransform()), i.uncache = 1);
  }
}, a_ = function(t, e) {
  var r = {
    target: t,
    props: [],
    revert: VE,
    save: XE
  };
  return t._gsap || Pe.core.getCache(t), e && e.split(",").forEach(function(i) {
    return r.save(i);
  }), r;
}, h_, Bc = function(t, e) {
  var r = Pn.createElementNS ? Pn.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : Pn.createElement(t);
  return r && r.style ? r : Pn.createElement(t);
}, kr = function n(t, e, r) {
  var i = getComputedStyle(t);
  return i[e] || i.getPropertyValue(e.replace(Pd, "-$1").toLowerCase()) || i.getPropertyValue(e) || !r && n(t, gs(e) || e, 1) || "";
}, Cm = "O,Moz,ms,Ms,Webkit".split(","), gs = function(t, e, r) {
  var i = e || di, s = i.style, o = 5;
  if (t in s && !r)
    return t;
  for (t = t.charAt(0).toUpperCase() + t.substr(1); o-- && !(Cm[o] + t in s); )
    ;
  return o < 0 ? null : (o === 3 ? "ms" : o >= 0 ? Cm[o] : "") + t;
}, Lc = function() {
  FE() && window.document && (Am = window, Pn = Am.document, os = Pn.documentElement, di = Bc("div") || {
    style: {}
  }, Bc("div"), Gt = gs(Gt), Ie = Gt + "Origin", di.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", h_ = !!gs("perspective"), Id = Pe.core.reverting, Md = 1);
}, Su = function n(t) {
  var e = Bc("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), r = this.parentNode, i = this.nextSibling, s = this.style.cssText, o;
  if (os.appendChild(e), e.appendChild(this), this.style.display = "block", t)
    try {
      o = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = n;
    } catch {
    }
  else this._gsapBBox && (o = this._gsapBBox());
  return r && (i ? r.insertBefore(this, i) : r.appendChild(this)), os.removeChild(e), this.style.cssText = s, o;
}, Mm = function(t, e) {
  for (var r = e.length; r--; )
    if (t.hasAttribute(e[r]))
      return t.getAttribute(e[r]);
}, l_ = function(t) {
  var e;
  try {
    e = t.getBBox();
  } catch {
    e = Su.call(t, !0);
  }
  return e && (e.width || e.height) || t.getBBox === Su || (e = Su.call(t, !0)), e && !e.width && !e.x && !e.y ? {
    x: +Mm(t, ["x", "cx", "x1"]) || 0,
    y: +Mm(t, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : e;
}, u_ = function(t) {
  return !!(t.getCTM && (!t.parentNode || t.ownerSVGElement) && l_(t));
}, Si = function(t, e) {
  if (e) {
    var r = t.style, i;
    e in an && e !== Ie && (e = Gt), r.removeProperty ? (i = e.substr(0, 2), (i === "ms" || e.substr(0, 6) === "webkit") && (e = "-" + e), r.removeProperty(i === "--" ? e : e.replace(Pd, "-$1").toLowerCase())) : r.removeAttribute(e);
  }
}, Rn = function(t, e, r, i, s, o) {
  var a = new Me(t._pt, e, r, 0, 1, o ? s_ : i_);
  return t._pt = a, a.b = i, a.e = s, t._props.push(r), a;
}, Im = {
  deg: 1,
  rad: 1,
  turn: 1
}, YE = {
  grid: 1,
  flex: 1
}, zn = function n(t, e, r, i) {
  var s = parseFloat(r) || 0, o = (r + "").trim().substr((s + "").length) || "px", a = di.style, h = OE.test(e), l = t.tagName.toLowerCase() === "svg", u = (l ? "client" : "offset") + (h ? "Width" : "Height"), c = 100, d = i === "px", f = i === "%", p, m, g, _;
  if (i === o || !s || Im[i] || Im[o])
    return s;
  if (o !== "px" && !d && (s = n(t, e, r, "px")), _ = t.getCTM && u_(t), (f || o === "%") && (an[e] || ~e.indexOf("adius")))
    return p = _ ? t.getBBox()[h ? "width" : "height"] : t[u], Vt(f ? s / p * c : s / 100 * p);
  if (a[h ? "width" : "height"] = c + (d ? o : i), m = ~e.indexOf("adius") || i === "em" && t.appendChild && !l ? t : t.parentNode, _ && (m = (t.ownerSVGElement || {}).parentNode), (!m || m === Pn || !m.appendChild) && (m = Pn.body), g = m._gsap, g && f && g.width && h && g.time === ke.time && !g.uncache)
    return Vt(s / g.width * c);
  if (f && (e === "height" || e === "width")) {
    var w = t.style[e];
    t.style[e] = c + i, p = t[u], w ? t.style[e] = w : Si(t, e);
  } else
    (f || o === "%") && !YE[kr(m, "display")] && (a.position = kr(t, "position")), m === t && (a.position = "static"), m.appendChild(di), p = di[u], m.removeChild(di), a.position = "absolute";
  return h && f && (g = yi(m), g.time = ke.time, g.width = m[u]), Vt(d ? p * s / c : p && s ? c / p * s : 0);
}, Kr = function(t, e, r, i) {
  var s;
  return Md || Lc(), e in Rr && e !== "transform" && (e = Rr[e], ~e.indexOf(",") && (e = e.split(",")[0])), an[e] && e !== "transform" ? (s = xo(t, i), s = e !== "transformOrigin" ? s[e] : s.svg ? s.origin : lh(kr(t, Ie)) + " " + s.zOrigin + "px") : (s = t.style[e], (!s || s === "auto" || i || ~(s + "").indexOf("calc(")) && (s = hh[e] && hh[e](t, e, r) || kr(t, e) || Sy(t, e) || (e === "opacity" ? 1 : 0))), r && !~(s + "").trim().indexOf(" ") ? zn(t, e, s, r) + r : s;
}, jE = function(t, e, r, i) {
  if (!r || r === "none") {
    var s = gs(e, t, 1), o = s && kr(t, s, 1);
    o && o !== r ? (e = s, r = o) : e === "borderColor" && (r = kr(t, "borderTopColor"));
  }
  var a = new Me(this._pt, t.style, e, 0, 1, e_), h = 0, l = 0, u, c, d, f, p, m, g, _, w, v, E, x;
  if (a.b = r, a.e = i, r += "", i += "", i === "auto" && (m = t.style[e], t.style[e] = i, i = kr(t, e) || i, m ? t.style[e] = m : Si(t, e)), u = [r, i], Xy(u), r = u[0], i = u[1], d = r.match(Zi) || [], x = i.match(Zi) || [], x.length) {
    for (; c = Zi.exec(i); )
      g = c[0], w = i.substring(h, c.index), p ? p = (p + 1) % 5 : (w.substr(-5) === "rgba(" || w.substr(-5) === "hsla(") && (p = 1), g !== (m = d[l++] || "") && (f = parseFloat(m) || 0, E = m.substr((f + "").length), g.charAt(1) === "=" && (g = ss(f, g) + E), _ = parseFloat(g), v = g.substr((_ + "").length), h = Zi.lastIndex - v.length, v || (v = v || Le.units[e] || E, h === i.length && (i += v, a.e += v)), E !== v && (f = zn(t, e, m, v) || 0), a._pt = {
        _next: a._pt,
        p: w || l === 1 ? w : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: f,
        c: _ - f,
        m: p && p < 4 || e === "zIndex" ? Math.round : 0
      });
    a.c = h < i.length ? i.substring(h, i.length) : "";
  } else
    a.r = e === "display" && i === "none" ? s_ : i_;
  return xy.test(i) && (a.e = 0), this._pt = a, a;
}, Pm = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, qE = function(t) {
  var e = t.split(" "), r = e[0], i = e[1] || "50%";
  return (r === "top" || r === "bottom" || i === "left" || i === "right") && (t = r, r = i, i = t), e[0] = Pm[r] || r, e[1] = Pm[i] || i, e.join(" ");
}, ZE = function(t, e) {
  if (e.tween && e.tween._time === e.tween._dur) {
    var r = e.t, i = r.style, s = e.u, o = r._gsap, a, h, l;
    if (s === "all" || s === !0)
      i.cssText = "", h = 1;
    else
      for (s = s.split(","), l = s.length; --l > -1; )
        a = s[l], an[a] && (h = 1, a = a === "transformOrigin" ? Ie : Gt), Si(r, a);
    h && (Si(r, Gt), o && (o.svg && r.removeAttribute("transform"), xo(r, 1), o.uncache = 1, o_(i)));
  }
}, hh = {
  clearProps: function(t, e, r, i, s) {
    if (s.data !== "isFromStart") {
      var o = t._pt = new Me(t._pt, e, r, 0, 0, ZE);
      return o.u = i, o.pr = -10, o.tween = s, t._props.push(r), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, vo = [1, 0, 0, 1, 0, 0], c_ = {}, d_ = function(t) {
  return t === "matrix(1, 0, 0, 1, 0, 0)" || t === "none" || !t;
}, Rm = function(t) {
  var e = kr(t, Gt);
  return d_(e) ? vo : e.substr(7).match(vy).map(Vt);
}, Rd = function(t, e) {
  var r = t._gsap || yi(t), i = t.style, s = Rm(t), o, a, h, l;
  return r.svg && t.getAttribute("transform") ? (h = t.transform.baseVal.consolidate().matrix, s = [h.a, h.b, h.c, h.d, h.e, h.f], s.join(",") === "1,0,0,1,0,0" ? vo : s) : (s === vo && !t.offsetParent && t !== os && !r.svg && (h = i.display, i.display = "block", o = t.parentNode, (!o || !t.offsetParent) && (l = 1, a = t.nextElementSibling, os.appendChild(t)), s = Rm(t), h ? i.display = h : Si(t, "display"), l && (a ? o.insertBefore(t, a) : o ? o.appendChild(t) : os.removeChild(t))), e && s.length > 6 ? [s[0], s[1], s[4], s[5], s[12], s[13]] : s);
}, Uc = function(t, e, r, i, s, o) {
  var a = t._gsap, h = s || Rd(t, !0), l = a.xOrigin || 0, u = a.yOrigin || 0, c = a.xOffset || 0, d = a.yOffset || 0, f = h[0], p = h[1], m = h[2], g = h[3], _ = h[4], w = h[5], v = e.split(" "), E = parseFloat(v[0]) || 0, x = parseFloat(v[1]) || 0, b, y, C, M;
  r ? h !== vo && (y = f * g - p * m) && (C = E * (g / y) + x * (-m / y) + (m * w - g * _) / y, M = E * (-p / y) + x * (f / y) - (f * w - p * _) / y, E = C, x = M) : (b = l_(t), E = b.x + (~v[0].indexOf("%") ? E / 100 * b.width : E), x = b.y + (~(v[1] || v[0]).indexOf("%") ? x / 100 * b.height : x)), i || i !== !1 && a.smooth ? (_ = E - l, w = x - u, a.xOffset = c + (_ * f + w * m) - _, a.yOffset = d + (_ * p + w * g) - w) : a.xOffset = a.yOffset = 0, a.xOrigin = E, a.yOrigin = x, a.smooth = !!i, a.origin = e, a.originIsAbsolute = !!r, t.style[Ie] = "0px 0px", o && (Rn(o, a, "xOrigin", l, E), Rn(o, a, "yOrigin", u, x), Rn(o, a, "xOffset", c, a.xOffset), Rn(o, a, "yOffset", d, a.yOffset)), t.setAttribute("data-svg-origin", E + " " + x);
}, xo = function(t, e) {
  var r = t._gsap || new qy(t);
  if ("x" in r && !e && !r.uncache)
    return r;
  var i = t.style, s = r.scaleX < 0, o = "px", a = "deg", h = getComputedStyle(t), l = kr(t, Ie) || "0", u, c, d, f, p, m, g, _, w, v, E, x, b, y, C, M, U, F, O, R, k, j, T, S, A, L, D, P, N, B, X, V;
  return u = c = d = m = g = _ = w = v = E = 0, f = p = 1, r.svg = !!(t.getCTM && u_(t)), h.translate && ((h.translate !== "none" || h.scale !== "none" || h.rotate !== "none") && (i[Gt] = (h.translate !== "none" ? "translate3d(" + (h.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (h.rotate !== "none" ? "rotate(" + h.rotate + ") " : "") + (h.scale !== "none" ? "scale(" + h.scale.split(" ").join(",") + ") " : "") + (h[Gt] !== "none" ? h[Gt] : "")), i.scale = i.rotate = i.translate = "none"), y = Rd(t, r.svg), r.svg && (r.uncache ? (A = t.getBBox(), l = r.xOrigin - A.x + "px " + (r.yOrigin - A.y) + "px", S = "") : S = !e && t.getAttribute("data-svg-origin"), Uc(t, S || l, !!S || r.originIsAbsolute, r.smooth !== !1, y)), x = r.xOrigin || 0, b = r.yOrigin || 0, y !== vo && (F = y[0], O = y[1], R = y[2], k = y[3], u = j = y[4], c = T = y[5], y.length === 6 ? (f = Math.sqrt(F * F + O * O), p = Math.sqrt(k * k + R * R), m = F || O ? Gi(O, F) * ui : 0, w = R || k ? Gi(R, k) * ui + m : 0, w && (p *= Math.abs(Math.cos(w * as))), r.svg && (u -= x - (x * F + b * R), c -= b - (x * O + b * k))) : (V = y[6], B = y[7], D = y[8], P = y[9], N = y[10], X = y[11], u = y[12], c = y[13], d = y[14], C = Gi(V, N), g = C * ui, C && (M = Math.cos(-C), U = Math.sin(-C), S = j * M + D * U, A = T * M + P * U, L = V * M + N * U, D = j * -U + D * M, P = T * -U + P * M, N = V * -U + N * M, X = B * -U + X * M, j = S, T = A, V = L), C = Gi(-R, N), _ = C * ui, C && (M = Math.cos(-C), U = Math.sin(-C), S = F * M - D * U, A = O * M - P * U, L = R * M - N * U, X = k * U + X * M, F = S, O = A, R = L), C = Gi(O, F), m = C * ui, C && (M = Math.cos(C), U = Math.sin(C), S = F * M + O * U, A = j * M + T * U, O = O * M - F * U, T = T * M - j * U, F = S, j = A), g && Math.abs(g) + Math.abs(m) > 359.9 && (g = m = 0, _ = 180 - _), f = Vt(Math.sqrt(F * F + O * O + R * R)), p = Vt(Math.sqrt(T * T + V * V)), C = Gi(j, T), w = Math.abs(C) > 2e-4 ? C * ui : 0, E = X ? 1 / (X < 0 ? -X : X) : 0), r.svg && (S = t.getAttribute("transform"), r.forceCSS = t.setAttribute("transform", "") || !d_(kr(t, Gt)), S && t.setAttribute("transform", S))), Math.abs(w) > 90 && Math.abs(w) < 270 && (s ? (f *= -1, w += m <= 0 ? 180 : -180, m += m <= 0 ? 180 : -180) : (p *= -1, w += w <= 0 ? 180 : -180)), e = e || r.uncache, r.x = u - ((r.xPercent = u && (!e && r.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-u) ? -50 : 0))) ? t.offsetWidth * r.xPercent / 100 : 0) + o, r.y = c - ((r.yPercent = c && (!e && r.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-c) ? -50 : 0))) ? t.offsetHeight * r.yPercent / 100 : 0) + o, r.z = d + o, r.scaleX = Vt(f), r.scaleY = Vt(p), r.rotation = Vt(m) + a, r.rotationX = Vt(g) + a, r.rotationY = Vt(_) + a, r.skewX = w + a, r.skewY = v + a, r.transformPerspective = E + o, (r.zOrigin = parseFloat(l.split(" ")[2]) || !e && r.zOrigin || 0) && (i[Ie] = lh(l)), r.xOffset = r.yOffset = 0, r.force3D = Le.force3D, r.renderTransform = r.svg ? QE : h_ ? f_ : KE, r.uncache = 0, r;
}, lh = function(t) {
  return (t = t.split(" "))[0] + " " + t[1];
}, Cu = function(t, e, r) {
  var i = pe(e);
  return Vt(parseFloat(e) + parseFloat(zn(t, "x", r + "px", i))) + i;
}, KE = function(t, e) {
  e.z = "0px", e.rotationY = e.rotationX = "0deg", e.force3D = 0, f_(t, e);
}, ri = "0deg", Us = "0px", ni = ") ", f_ = function(t, e) {
  var r = e || this, i = r.xPercent, s = r.yPercent, o = r.x, a = r.y, h = r.z, l = r.rotation, u = r.rotationY, c = r.rotationX, d = r.skewX, f = r.skewY, p = r.scaleX, m = r.scaleY, g = r.transformPerspective, _ = r.force3D, w = r.target, v = r.zOrigin, E = "", x = _ === "auto" && t && t !== 1 || _ === !0;
  if (v && (c !== ri || u !== ri)) {
    var b = parseFloat(u) * as, y = Math.sin(b), C = Math.cos(b), M;
    b = parseFloat(c) * as, M = Math.cos(b), o = Cu(w, o, y * M * -v), a = Cu(w, a, -Math.sin(b) * -v), h = Cu(w, h, C * M * -v + v);
  }
  g !== Us && (E += "perspective(" + g + ni), (i || s) && (E += "translate(" + i + "%, " + s + "%) "), (x || o !== Us || a !== Us || h !== Us) && (E += h !== Us || x ? "translate3d(" + o + ", " + a + ", " + h + ") " : "translate(" + o + ", " + a + ni), l !== ri && (E += "rotate(" + l + ni), u !== ri && (E += "rotateY(" + u + ni), c !== ri && (E += "rotateX(" + c + ni), (d !== ri || f !== ri) && (E += "skew(" + d + ", " + f + ni), (p !== 1 || m !== 1) && (E += "scale(" + p + ", " + m + ni), w.style[Gt] = E || "translate(0, 0)";
}, QE = function(t, e) {
  var r = e || this, i = r.xPercent, s = r.yPercent, o = r.x, a = r.y, h = r.rotation, l = r.skewX, u = r.skewY, c = r.scaleX, d = r.scaleY, f = r.target, p = r.xOrigin, m = r.yOrigin, g = r.xOffset, _ = r.yOffset, w = r.forceCSS, v = parseFloat(o), E = parseFloat(a), x, b, y, C, M;
  h = parseFloat(h), l = parseFloat(l), u = parseFloat(u), u && (u = parseFloat(u), l += u, h += u), h || l ? (h *= as, l *= as, x = Math.cos(h) * c, b = Math.sin(h) * c, y = Math.sin(h - l) * -d, C = Math.cos(h - l) * d, l && (u *= as, M = Math.tan(l - u), M = Math.sqrt(1 + M * M), y *= M, C *= M, u && (M = Math.tan(u), M = Math.sqrt(1 + M * M), x *= M, b *= M)), x = Vt(x), b = Vt(b), y = Vt(y), C = Vt(C)) : (x = c, C = d, b = y = 0), (v && !~(o + "").indexOf("px") || E && !~(a + "").indexOf("px")) && (v = zn(f, "x", o, "px"), E = zn(f, "y", a, "px")), (p || m || g || _) && (v = Vt(v + p - (p * x + m * y) + g), E = Vt(E + m - (p * b + m * C) + _)), (i || s) && (M = f.getBBox(), v = Vt(v + i / 100 * M.width), E = Vt(E + s / 100 * M.height)), M = "matrix(" + x + "," + b + "," + y + "," + C + "," + v + "," + E + ")", f.setAttribute("transform", M), w && (f.style[Gt] = M);
}, JE = function(t, e, r, i, s) {
  var o = 360, a = he(s), h = parseFloat(s) * (a && ~s.indexOf("rad") ? ui : 1), l = h - i, u = i + l + "deg", c, d;
  return a && (c = s.split("_")[1], c === "short" && (l %= o, l !== l % (o / 2) && (l += l < 0 ? o : -o)), c === "cw" && l < 0 ? l = (l + o * Sm) % o - ~~(l / o) * o : c === "ccw" && l > 0 && (l = (l - o * Sm) % o - ~~(l / o) * o)), t._pt = d = new Me(t._pt, e, r, i, l, kE), d.e = u, d.u = "deg", t._props.push(r), d;
}, Dm = function(t, e) {
  for (var r in e)
    t[r] = e[r];
  return t;
}, tS = function(t, e, r) {
  var i = Dm({}, r._gsap), s = "perspective,force3D,transformOrigin,svgOrigin", o = r.style, a, h, l, u, c, d, f, p;
  i.svg ? (l = r.getAttribute("transform"), r.setAttribute("transform", ""), o[Gt] = e, a = xo(r, 1), Si(r, Gt), r.setAttribute("transform", l)) : (l = getComputedStyle(r)[Gt], o[Gt] = e, a = xo(r, 1), o[Gt] = l);
  for (h in an)
    l = i[h], u = a[h], l !== u && s.indexOf(h) < 0 && (f = pe(l), p = pe(u), c = f !== p ? zn(r, h, l, p) : parseFloat(l), d = parseFloat(u), t._pt = new Me(t._pt, a, h, c, d - c, kc), t._pt.u = p || 0, t._props.push(h));
  Dm(a, i);
};
Ce("padding,margin,Width,Radius", function(n, t) {
  var e = "Top", r = "Right", i = "Bottom", s = "Left", o = (t < 3 ? [e, r, i, s] : [e + s, e + r, i + r, i + s]).map(function(a) {
    return t < 2 ? n + a : "border" + a + n;
  });
  hh[t > 1 ? "border" + n : n] = function(a, h, l, u, c) {
    var d, f;
    if (arguments.length < 4)
      return d = o.map(function(p) {
        return Kr(a, p, l);
      }), f = d.join(" "), f.split(d[0]).length === 5 ? d[0] : f;
    d = (u + "").split(" "), f = {}, o.forEach(function(p, m) {
      return f[p] = d[m] = d[m] || d[(m - 1) / 2 | 0];
    }), a.init(h, f, c);
  };
});
var p_ = {
  name: "css",
  register: Lc,
  targetTest: function(t) {
    return t.style && t.nodeType;
  },
  init: function(t, e, r, i, s) {
    var o = this._props, a = t.style, h = r.vars.startAt, l, u, c, d, f, p, m, g, _, w, v, E, x, b, y, C;
    Md || Lc(), this.styles = this.styles || a_(t), C = this.styles.props, this.tween = r;
    for (m in e)
      if (m !== "autoRound" && (u = e[m], !(Ne[m] && Zy(m, e, r, i, t, s)))) {
        if (f = typeof u, p = hh[m], f === "function" && (u = u.call(r, i, t, s), f = typeof u), f === "string" && ~u.indexOf("random(") && (u = go(u)), p)
          p(this, t, m, u, r) && (y = 1);
        else if (m.substr(0, 2) === "--")
          l = (getComputedStyle(t).getPropertyValue(m) + "").trim(), u += "", Nn.lastIndex = 0, Nn.test(l) || (g = pe(l), _ = pe(u)), _ ? g !== _ && (l = zn(t, m, l, _) + _) : g && (u += g), this.add(a, "setProperty", l, u, i, s, 0, 0, m), o.push(m), C.push(m, 0, a[m]);
        else if (f !== "undefined") {
          if (h && m in h ? (l = typeof h[m] == "function" ? h[m].call(r, i, t, s) : h[m], he(l) && ~l.indexOf("random(") && (l = go(l)), pe(l + "") || l === "auto" || (l += Le.units[m] || pe(Kr(t, m)) || ""), (l + "").charAt(1) === "=" && (l = Kr(t, m))) : l = Kr(t, m), d = parseFloat(l), w = f === "string" && u.charAt(1) === "=" && u.substr(0, 2), w && (u = u.substr(2)), c = parseFloat(u), m in Rr && (m === "autoAlpha" && (d === 1 && Kr(t, "visibility") === "hidden" && c && (d = 0), C.push("visibility", 0, a.visibility), Rn(this, a, "visibility", d ? "inherit" : "hidden", c ? "inherit" : "hidden", !c)), m !== "scale" && m !== "transform" && (m = Rr[m], ~m.indexOf(",") && (m = m.split(",")[0]))), v = m in an, v) {
            if (this.styles.save(m), E || (x = t._gsap, x.renderTransform && !e.parseTransform || xo(t, e.parseTransform), b = e.smoothOrigin !== !1 && x.smooth, E = this._pt = new Me(this._pt, a, Gt, 0, 1, x.renderTransform, x, 0, -1), E.dep = 1), m === "scale")
              this._pt = new Me(this._pt, x, "scaleY", x.scaleY, (w ? ss(x.scaleY, w + c) : c) - x.scaleY || 0, kc), this._pt.u = 0, o.push("scaleY", m), m += "X";
            else if (m === "transformOrigin") {
              C.push(Ie, 0, a[Ie]), u = qE(u), x.svg ? Uc(t, u, 0, b, 0, this) : (_ = parseFloat(u.split(" ")[2]) || 0, _ !== x.zOrigin && Rn(this, x, "zOrigin", x.zOrigin, _), Rn(this, a, m, lh(l), lh(u)));
              continue;
            } else if (m === "svgOrigin") {
              Uc(t, u, 1, b, 0, this);
              continue;
            } else if (m in c_) {
              JE(this, x, m, d, w ? ss(d, w + u) : u);
              continue;
            } else if (m === "smoothOrigin") {
              Rn(this, x, "smooth", x.smooth, u);
              continue;
            } else if (m === "force3D") {
              x[m] = u;
              continue;
            } else if (m === "transform") {
              tS(this, u, t);
              continue;
            }
          } else m in a || (m = gs(m) || m);
          if (v || (c || c === 0) && (d || d === 0) && !NE.test(u) && m in a)
            g = (l + "").substr((d + "").length), c || (c = 0), _ = pe(u) || (m in Le.units ? Le.units[m] : g), g !== _ && (d = zn(t, m, l, _)), this._pt = new Me(this._pt, v ? x : a, m, d, (w ? ss(d, w + c) : c) - d, !v && (_ === "px" || m === "zIndex") && e.autoRound !== !1 ? LE : kc), this._pt.u = _ || 0, g !== _ && _ !== "%" && (this._pt.b = l, this._pt.r = BE);
          else if (m in a)
            jE.call(this, t, m, l, w ? w + u : u);
          else if (m in t)
            this.add(t, m, l || t[m], w ? w + u : u, i, s);
          else if (m !== "parseTransform") {
            vd(m, u);
            continue;
          }
          v || (m in a ? C.push(m, 0, a[m]) : C.push(m, 1, l || t[m])), o.push(m);
        }
      }
    y && r_(this);
  },
  render: function(t, e) {
    if (e.tween._time || !Id())
      for (var r = e._pt; r; )
        r.r(t, r.d), r = r._next;
    else
      e.styles.revert();
  },
  get: Kr,
  aliases: Rr,
  getSetter: function(t, e, r) {
    var i = Rr[e];
    return i && i.indexOf(",") < 0 && (e = i), e in an && e !== Ie && (t._gsap.x || Kr(t, "x")) ? r && Em === r ? e === "scale" ? zE : GE : (Em = r || {}) && (e === "scale" ? WE : $E) : t.style && !gd(t.style[e]) ? UE : ~e.indexOf("-") ? HE : Sd(t, e);
  },
  core: {
    _removeProperty: Si,
    _getMatrix: Rd
  }
};
Pe.utils.checkPrefix = gs;
Pe.core.getStyleSaver = a_;
(function(n, t, e, r) {
  var i = Ce(n + "," + t + "," + e, function(s) {
    an[s] = 1;
  });
  Ce(t, function(s) {
    Le.units[s] = "deg", c_[s] = 1;
  }), Rr[i[13]] = n + "," + t, Ce(r, function(s) {
    var o = s.split(":");
    Rr[o[1]] = i[o[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
Ce("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(n) {
  Le.units[n] = "px";
});
Pe.registerPlugin(p_);
var m_ = Pe.registerPlugin(p_) || Pe;
m_.core.Tween;
function g_(n, t) {
  return typeof n == "function" ? n(t) : n && typeof n == "object" && gm in n ? n[gm](t) : n instanceof Date ? new n.constructor(t) : new Date(t);
}
function Hc(n, t) {
  return g_(n, n);
}
function eS(n, t, e) {
  return g_(n, +Hc(n) + t);
}
function rS(n, t, e) {
  return eS(n, t * 1e3);
}
function nS(n) {
  return (t) => {
    const e = Math.trunc, r = e(t);
    return r === 0 ? 0 : r;
  };
}
function y_(n, t) {
  return +Hc(n) - +Hc(t);
}
function iS(n, t, e) {
  const r = y_(n, t) / 1e3;
  return nS()(r);
}
const sS = (n) => ({
  font: { fontFamily: "ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'", type: "BitmapFont" },
  rowGap: 24,
  columnGap: 32,
  textDefault: n === "dark" ? "#ffffff" : "#161618",
  textInverse: n === "dark" ? "#161618" : "#ffffff",
  selectedBorderColor: n === "dark" ? "#3fa2c3" : "#297f9c",
  selectedBorderWidth: 2,
  selectedBorderOffset: 4,
  selectedBorderRadius: 9,
  nodesPadding: 16,
  nodeHeight: 32,
  nodePadding: 4,
  nodeRadius: 6,
  nodeBorderRadius: 9,
  nodeToggleSize: 28,
  nodeToggleBgColor: "#35363C",
  nodeToggleBorderRadius: 6,
  nodeToggleBorderColor: n === "dark" ? "#4d4f56" : "#bbbec9",
  nodeUnselectedAlpha: 0.2,
  artifactsGap: 4,
  artifactsNodeOverlap: 4,
  artifactPaddingLeft: 2,
  artifactPaddingRight: 4,
  artifactPaddingY: 2,
  artifactTextColor: "#ffffff",
  artifactBgColor: "#35363b",
  artifactBorderRadius: 4,
  artifactContentGap: 4,
  artifactIconSize: 16,
  artifactIconColor: "#ffffff",
  flowStateBarHeight: 8,
  flowStateSelectedBarHeight: 10,
  flowStateAreaAlpha: 0.1,
  eventTargetSize: 30,
  eventBottomMargin: 4,
  eventSelectedBorderInset: 8,
  eventRadiusDefault: 4,
  eventColor: "#A564F9",
  eventClusterRadiusDefault: 6,
  eventClusterColor: "#A564F9",
  edgeColor: n === "dark" ? "#adadad" : "#737682",
  guideLineWidth: 1,
  guideLineColor: n === "dark" ? "#4d4f56" : "#bbbec9",
  guideTextTopPadding: 8,
  guideTextLeftPadding: 8,
  guideTextSize: 12,
  guideTextColor: n === "dark" ? "#adadad" : "#737682",
  playheadWidth: 2,
  playheadColor: "#6272FF",
  node: () => ({
    background: "#ffffff"
  }),
  state: () => ({
    background: "#ffffff"
  })
});
let fi = null;
async function oS() {
  const n = await He();
  fi = Fm(n), it.emit("stylesCreated", fi), it.on("configUpdated", (t) => {
    fi = Fm(t), it.emit("stylesUpdated", fi);
  });
}
function aS() {
  fi = null;
}
async function Wt() {
  return fi || await Re("stylesCreated");
}
function Fm(n) {
  return {
    ...sS(n.theme),
    ...n.styles?.(n.theme)
  };
}
function hS(n) {
  let t = 0;
  for (const [, { children: e }] of n)
    t += e.length;
  return t;
}
function lS({ start_time: n, end_time: t, nodes: e }, r, i) {
  const s = Math.max(iS(t ?? /* @__PURE__ */ new Date(), n), 1), o = r.nodeHeight + r.rowGap;
  return (e.size > 0 ? e.size * o * 0.5 : o * 4) * i / (s * Cg);
}
async function uS() {
  const n = await zr(), t = await He(), e = await Wt(), r = await Qt(), i = r.view.width / r.view.height, s = lS(n, e, i);
  __(s, !0), n.nodes.size > t.disableAnimationsThreshold && (ut.disableAnimations = !0), hS(n.nodes) > t.disableEdgesThreshold && (ut.disableEdges = !0);
}
function cS() {
  ut.horizontal = "temporal", ut.vertical = "nearest-parent", ut.horizontalScaleMultiplierDefault = 0, ut.horizontalScaleMultiplier = 0, ut.disableAnimations = !1, ut.disableGuides = !1, ut.disableEdges = !1, ut.disableArtifacts = !1, ut.disableEvents = !1;
}
const ut = {
  horizontal: "temporal",
  vertical: "nearest-parent",
  horizontalScaleMultiplierDefault: 0,
  horizontalScaleMultiplier: 0,
  disableAnimations: !1,
  disableGuides: !1,
  disableEdges: !1,
  disableArtifacts: !1,
  disableEvents: !1,
  isTemporal() {
    return this.horizontal === "temporal";
  },
  isDependency() {
    return this.horizontal === "dependency";
  },
  isWaterfall() {
    return this.vertical === "waterfall";
  },
  isNearestParent() {
    return this.vertical === "nearest-parent";
  },
  isLeftAligned() {
    return this.horizontal === "left-aligned";
  }
};
async function Kt() {
  return Gc() ? ut : await Re("layoutSettingsCreated");
}
function Dd() {
  return ut.isDependency() ? _1 : Cg * ut.horizontalScaleMultiplier;
}
function dS() {
  return [0, Dd()];
}
function fS(n) {
  if (ut.isDependency())
    return [0, 1];
  const t = n, e = rS(t, y1);
  return [t, e];
}
function __(n, t = !1) {
  if (ut.horizontalScaleMultiplier === n)
    return;
  const e = Es();
  ut.horizontalScaleMultiplier = n, t && (ut.horizontalScaleMultiplierDefault = n), e();
}
function dD() {
  __(ut.horizontalScaleMultiplierDefault);
}
function fD(n) {
  if (ut.horizontal === n)
    return;
  const t = Es();
  ut.horizontal = n, ut.disableGuides = ut.isDependency() || ut.isLeftAligned(), t();
}
function pD(n) {
  if (ut.vertical === n)
    return;
  const t = Es();
  ut.vertical = n, t();
}
function mD(n) {
  if (ut.disableEdges === n)
    return;
  const t = Es();
  ut.disableEdges = n, t();
}
function gD(n) {
  if (ut.disableArtifacts === n)
    return;
  const t = Es();
  ut.disableArtifacts = n, t();
}
function yD(n) {
  if (ut.disableEvents === n)
    return;
  const t = Es();
  ut.disableEvents = n, t();
}
function Es() {
  const n = Gc() ? "layoutSettingsUpdated" : "layoutSettingsCreated", { horizontal: t, vertical: e } = ut;
  return () => {
    Gc() && it.emit(n, ut), (t !== ut.horizontal || e !== ut.vertical) && it.emit("layoutUpdated");
  };
}
function Gc() {
  return ut.horizontalScaleMultiplier !== 0;
}
async function v_() {
  const n = await Kt(), t = await He();
  function e(r, i, s) {
    const a = n.disableAnimations || s ? 0 : t.animationDuration / 1e3;
    return m_.to(r, {
      ...i,
      duration: a,
      ease: "power1.out",
      onUpdate: () => {
        No();
      }
    });
  }
  return {
    animate: e
  };
}
async function pS({ size: n, stroke: t = 1, radius: e = 0 }) {
  const r = await Qt(), i = new Un();
  return i.lineStyle(t, "#fff", 1, 0), i.drawRoundedRect(0, 0, n * 2, n * 2, e), r.renderer.generateTexture(i, {
    // drew a rounded rectangle and then just using one corner as the "arrow"
    region: new yt(0, 0, n, n),
    // manually bumping up the resolution to keep the border radius from being blurry
    resolution: 10
  });
}
async function no(n) {
  return await Po(pS, [n]);
}
var uh = /* @__PURE__ */ ((n) => (n[n.Up = 0] = "Up", n[n.Down = 180] = "Down", n[n.Left = 270] = "Left", n[n.Right = 90] = "Right", n))(uh || {});
function x_() {
  const n = new jt();
  async function t(e) {
    const { rotate: r = 0 } = e, i = {
      size: e.size,
      radius: e.radius,
      stroke: e.stroke
    }, s = await no(i);
    return n.texture = s, n.anchor.set(0.5, 0.5), n.angle = 45 + r, n;
  }
  return {
    element: n,
    render: t
  };
}
async function mS() {
  const n = await Qt(), t = new Un();
  return t.beginFill("#fff"), t.drawRect(0, 0, 1, 1), t.endFill(), n.renderer.generateTexture(t, {
    wrapMode: Dr.REPEAT
  });
}
async function Fd() {
  return await Po(mS, []);
}
function zc(n, t) {
  return Array.from({ length: n }, (e, r) => t(r));
}
const gS = 8, yS = 2;
async function _S() {
  const n = await Wt(), t = await Cv(), e = await VR(), { animate: r } = await v_(), i = new bt(), { element: s, render: o } = await x_(), a = await Fd(), h = zc(Pg, () => new mt()), l = new gT(a, h);
  let u = !1;
  i.name = g1, i.addChild(s), i.addChild(l), t.addAll([s, l]), e.add(i);
  async function c() {
    return await o({
      size: 10,
      rotate: uh.Right
    }), s.tint = n.edgeColor, l.tint = n.edgeColor, i;
  }
  async function d(p, m) {
    const g = f(m);
    u || await c();
    for (const [_, w] of h.entries()) {
      const { x: v, y: E } = g[_];
      r(w, {
        x: v,
        y: E
      }, !u);
    }
    r(i, {
      x: p.x,
      y: p.y
    }, !u), r(s, {
      x: m.x - gS,
      y: m.y
    }, !u), u = !0;
  }
  function f({ x: p, y: m }) {
    const g = [], _ = { x: 0, y: 0 }, w = { x: p - yS, y: m }, v = {
      x: Om(_.x, { source: _, target: w }),
      y: _.y
    }, E = {
      x: Om(w.x, { source: _, target: w }, !0),
      y: w.y
    };
    for (const [x] of h.entries()) {
      if (x === h.length - 1) {
        g[x] = w;
        continue;
      }
      const b = vS(x, {
        source: _,
        target: w,
        sourceBezier: v,
        targetBezier: E
      });
      g[x] = b;
    }
    return g;
  }
  return {
    element: i,
    render: c,
    setPosition: d
  };
}
function Om(n, { source: t, target: e }, r) {
  const i = (e.x - t.x) / 2;
  return n + (i > lf ? i : lf) * (r ? -1 : 1);
}
function vS(n, t) {
  const e = n / Pg, { source: r, target: i, sourceBezier: s, targetBezier: o } = t, a = r.x + (s.x - r.x) * e, h = r.y + (s.y - r.y) * e, l = s.x + (o.x - s.x) * e, u = s.y + (o.y - s.y) * e, c = o.x + (i.x - o.x) * e, d = o.y + (i.y - o.y) * e, f = a + (l - a) * e, p = h + (u - h) * e, m = l + (c - l) * e, g = u + (d - u) * e, _ = f + (m - f) * e, w = p + (g - p) * e;
  return { x: _, y: w };
}
async function xS({ height: n, radius: t }) {
  const e = await Qt(), r = new Un();
  return r.beginFill("#fff"), r.drawRoundedRect(0, 0, t * 2, n, t), r.endFill(), e.renderer.generateTexture(r, {
    // drew a rounded rectangle and then just using half of the graphic to get just the left "cap"
    region: new yt(0, 0, t, n),
    resolution: Mg
  });
}
async function wS(n) {
  return await Po(xS, [n]);
}
function bS() {
  const n = new jt(), t = new jt();
  async function e(r) {
    const i = await wS(r);
    return n.texture = i, t.texture = i, t.anchor.x = 1, t.scale.x = -1, {
      left: n,
      right: t
    };
  }
  return {
    left: n,
    right: t,
    render: e
  };
}
async function hn() {
  const n = await Fd();
  return new jt(n);
}
async function Od() {
  const n = new bt(), t = await hn(), { left: e, right: r, render: i } = await bS();
  n.addChild(t), n.addChild(e), n.addChild(r);
  async function s(h) {
    const { width: l, x: u, visible: c } = a(h);
    return await i({
      height: h.height,
      radius: h.radius
    }), t.visible = c, t.width = l, t.height = h.height, t.x = u, e.visible = o(h.capLeft, h.radius), r.visible = o(h.capRight, h.radius), r.x = h.radius + l, t.tint = h.background, e.tint = h.background, r.tint = h.background, n;
  }
  function o(h, l) {
    return l === 0 ? !1 : h ?? !0;
  }
  function a(h) {
    const l = o(h.capLeft, h.radius), u = o(h.capRight, h.radius);
    let c = 0;
    l && (c += h.radius), u && (c += h.radius);
    const d = Math.max(h.width - c, 0), f = d > 0, p = l ? h.radius : 0;
    return {
      width: d,
      visible: f,
      x: p
    };
  }
  return {
    element: n,
    render: s
  };
}
function Uh() {
  const n = new bt(), t = new jt(), e = new jt(), r = new jt(), i = new jt(), s = new jt(), o = new jt(), a = new jt(), h = new jt();
  t.name = "border-corner-top-left", e.name = "border-corner-top-right", r.name = "border-corner-bottom-left", i.name = "border-corner-bottom-right", s.name = "border-corner-left", o.name = "border-corner-right", a.name = "border-corner-top", h.name = "border-corner-bottom", e.anchor.x = 1, e.scale.x = -1, r.anchor.y = 1, r.scale.y = -1, i.anchor.x = 1, i.scale.x = -1, i.anchor.y = 1, i.scale.y = -1, n.addChild(t), n.addChild(e), n.addChild(r), n.addChild(i), n.addChild(s), n.addChild(o), n.addChild(a), n.addChild(h);
  async function l(p) {
    const { radius: m = 0, color: g = "#fff", stroke: _, width: w, height: v } = p, E = typeof m == "number", x = {
      topLeft: u(E ? m : m[0], w, v),
      topRight: u(E ? m : m[1], w, v),
      bottomLeft: u(E ? m : m[2], w, v),
      bottomRight: u(E ? m : m[3], w, v)
    };
    return await c({
      width: w,
      height: v,
      stroke: _,
      cornerSizes: x
    }), await d({
      width: w,
      height: v,
      stroke: _,
      cornerSizes: x
    }), f(g), n;
  }
  function u(p, m, g) {
    const _ = Math.min(m, g);
    return {
      size: p * 2 > _ ? _ / 2 : p,
      radius: p
    };
  }
  async function c({ width: p, height: m, stroke: g, cornerSizes: _ }) {
    const {
      topLeft: w,
      topRight: v,
      bottomLeft: E,
      bottomRight: x
    } = _, [b, y, C, M] = await Promise.all([
      no({ ...w, stroke: g }),
      no({ ...v, stroke: g }),
      no({ ...E, stroke: g }),
      no({ ...x, stroke: g })
    ]);
    t.texture = b, e.texture = y, r.texture = M, i.texture = C, t.position.set(0, 0), e.position.set(p - v.size, 0), r.position.set(0, m - E.size), i.position.set(p - x.size, m - x.size);
  }
  async function d({ width: p, height: m, stroke: g, cornerSizes: _ }) {
    const w = await Fd(), { topLeft: v, topRight: E, bottomLeft: x, bottomRight: b } = _;
    a.texture = w, s.texture = w, o.texture = w, h.texture = w, s.position.set(0, v.size), s.height = Math.max(m - v.size - x.size, 0), s.width = g, o.position.set(p - g, E.size), o.height = Math.max(m - E.size - b.size, 0), o.width = g, a.position.set(v.size, 0), a.width = Math.max(p - v.size - E.size, 0), a.height = g, h.position.set(x.size, m - g), h.width = Math.max(p - x.size - b.size, 0), h.height = g;
  }
  function f(p) {
    t.tint = p, e.tint = p, r.tint = p, i.tint = p, a.tint = p, s.tint = p, o.tint = p, h.tint = p;
  }
  return {
    element: n,
    render: l
  };
}
async function Hh() {
  const n = await Wt(), t = new bt(), { element: e, render: r } = await Uh();
  async function i({ selected: s, width: o, height: a }) {
    if (!s)
      return t.removeChild(e), t;
    const {
      selectedBorderColor: h,
      selectedBorderWidth: l,
      selectedBorderOffset: u,
      selectedBorderRadius: c
    } = n;
    return e.position.set(-u, -u), t.addChild(e), await r({
      stroke: l,
      radius: c,
      width: o + u * 2,
      height: a + u * 2,
      color: h
    }), t;
  }
  return {
    element: t,
    render: i
  };
}
async function TS() {
  const n = await Wt(), t = new bt(), { element: e, render: r } = await Od(), { element: i, render: s } = await Hh();
  t.addChild(e), t.addChild(i);
  async function o({ selected: a, width: h, height: l }) {
    const {
      artifactBgColor: u,
      artifactBorderRadius: c
    } = n, d = {
      width: h,
      height: l,
      background: u,
      radius: c,
      capLeft: !0,
      capRight: !0
    };
    return await Promise.all([
      r(d),
      s({ selected: a, width: h, height: l })
    ]), t;
  }
  return {
    element: t,
    render: o
  };
}
var AS = Object.defineProperty, ES = (n, t, e) => t in n ? AS(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, Hs = (n, t, e) => (ES(n, typeof t != "symbol" ? t + "" : t, e), e);
class SS extends bt {
  /**
   * Creates a Circular ProgressBar.
   * @param { number } options - Options object to use.
   * @param { number } options.backgroundColor - Background color.
   * @param { number } options.fillColor - Fill color.
   * @param { number } options.lineWidth - Line width.
   * @param { number } options.radius - Radius.
   * @param { number } options.value - Progress value.
   * @param { number } options.backgroundAlpha - Background alpha.
   * @param { number } options.fillAlpha - Fill alpha.
   * @param { 'butt' | 'round' | 'square' } options.cap - Line cap.
   */
  constructor(t) {
    super(), Hs(this, "_progress", 0), Hs(this, "options"), Hs(this, "bgCircle", new Un()), Hs(this, "fillCircle", new Un()), Hs(this, "innerView", new bt()), this.options = t, this.addChild(this.innerView), this.innerView.addChild(this.bgCircle, this.fillCircle), this.addBackground(), t.value && (this.progress = t.value);
  }
  addBackground() {
    const {
      backgroundColor: t,
      lineWidth: e,
      radius: r,
      backgroundAlpha: i
    } = this.options;
    let s = 1;
    i > 0 && (s = i), t === void 0 && (s = 1e-6), this.bgCircle.lineStyle({
      width: e,
      color: t,
      alpha: s
    }).drawCircle(0, 0, r);
  }
  /**
   * Set progress value.
   * @param { number } value - Progress value.
   */
  set progress(t) {
    t > 100 && (t = 100), t < 0 && (t = 0), this._progress = t;
    const {
      lineWidth: e,
      radius: r,
      fillColor: i,
      fillAlpha: s,
      cap: o
    } = this.options;
    if (t === 0 && s === 0) {
      this.fillCircle.clear();
      return;
    }
    const a = 0, h = 360 / 100 * t;
    this.fillCircle.clear().lineStyle({
      width: e,
      color: i,
      cap: o,
      alpha: s
    }).arc(0, 0, r, (-90 + a) * qu, (-90 + a + h) * qu);
  }
  /**
   * Current progress value.
   * @returns { number } - Progress value.
   */
  get progress() {
    return this._progress;
  }
}
async function CS(n = {}) {
  const t = await Iv(), e = new SS({
    fillColor: 16777215,
    cullAtZoomThreshold: !0,
    backgroundColor: 0,
    backgroundAlpha: 1,
    value: 50,
    cap: "round",
    fillAlpha: 1,
    lineWidth: 20,
    radius: 50,
    ...n
  });
  n.cullAtZoomThreshold && t.add(e);
  function r(i) {
    e.progress = i.value ?? 0;
    const s = (i.radius + i.lineWidth) * 2;
    return e.width = s, e.height = s, e.position.set(s / 2), e;
  }
  return {
    element: e,
    render: r
  };
}
const MS = "data:image/svg+xml,%3csvg%20viewBox='0%200%2020%2020'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7_19)'%3e%3cmask%20id='mask0_7_19'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='-1'%20y='-1'%20width='22'%20height='22'%3e%3cpath%20d='M20.9091%20-0.909058H-0.909088V20.9091H20.9091V-0.909058Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_7_19)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%2010C0%204.47715%204.47715%200%2010%200C15.5228%200%2020%204.47715%2020%2010C20%2015.5228%2015.5228%2020%2010%2020C4.47715%2020%200%2015.5228%200%2010ZM10%201.81818C5.4813%201.81818%201.81818%205.4813%201.81818%2010C1.81818%2014.5187%205.48131%2018.1818%2010%2018.1818C14.5187%2018.1818%2018.1818%2014.5187%2018.1818%2010C18.1818%205.48131%2014.5187%201.81818%2010%201.81818Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5.68182%205.63634C5.68182%205.15937%206.06849%204.77271%206.54546%204.77271H13.4546C13.9316%204.77271%2014.3182%205.15937%2014.3182%205.63634V14.2512C14.3182%2014.8932%2013.6426%2015.3108%2013.0683%2015.0237L11.8182%2014.3986L10.3863%2015.1146C10.1431%2015.2362%209.85691%2015.2362%209.61373%2015.1146L8.18182%2014.3986L6.93169%2015.0237C6.35746%2015.3108%205.68182%2014.8932%205.68182%2014.2512V5.63634ZM7.04546%206.13634V13.4423L7.7956%2013.0672C8.03873%2012.9456%208.32491%2012.9456%208.5681%2013.0672L10%2013.7832L11.4319%2013.0672C11.6751%2012.9456%2011.9613%2012.9456%2012.2045%2013.0672L12.9546%2013.4423V6.13634H7.04546Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.36365%208.63631C6.36365%208.38531%206.56716%208.18176%206.81819%208.18176H6.98566C7.23669%208.18176%207.4402%208.38531%207.4402%208.63631C7.4402%208.88731%207.23669%209.09085%206.98566%209.09085H6.81819C6.56716%209.09085%206.36365%208.88731%206.36365%208.63631ZM7.78709%208.63631C7.78709%208.38531%207.9906%208.18176%208.24165%208.18176H8.57656C8.82765%208.18176%209.0311%208.38531%209.0311%208.63631C9.0311%208.88731%208.82765%209.09085%208.57656%209.09085H8.24165C7.9906%209.09085%207.78709%208.88731%207.78709%208.63631ZM9.37801%208.63631C9.37801%208.38531%209.58147%208.18176%209.83256%208.18176H10.1675C10.4186%208.18176%2010.622%208.38531%2010.622%208.63631C10.622%208.88731%2010.4186%209.09085%2010.1675%209.09085H9.83256C9.58147%209.09085%209.37801%208.88731%209.37801%208.63631ZM10.9689%208.63631C10.9689%208.38531%2011.1724%208.18176%2011.4235%208.18176H11.7584C12.0095%208.18176%2012.2129%208.38531%2012.2129%208.63631C12.2129%208.88731%2012.0095%209.09085%2011.7584%209.09085H11.4235C11.1724%209.09085%2010.9689%208.88731%2010.9689%208.63631ZM12.5598%208.63631C12.5598%208.38531%2012.7633%208.18176%2013.0144%208.18176H13.1818C13.4328%208.18176%2013.6364%208.38531%2013.6364%208.63631C13.6364%208.88731%2013.4328%209.09085%2013.1818%209.09085H13.0144C12.7633%209.09085%2012.5598%208.88731%2012.5598%208.63631Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7_19'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", IS = "data:image/svg+xml,%3csvg%20viewBox='0%200%2020%2020'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7_27)'%3e%3cmask%20id='mask0_7_27'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='-1'%20y='-1'%20width='22'%20height='22'%3e%3cpath%20d='M20.9091%20-0.909058H-0.909088V20.9091H20.9091V-0.909058Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_7_27)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%2010C0%204.47715%204.47715%200%2010%200C15.5228%200%2020%204.47715%2020%2010C20%2015.5228%2015.5228%2020%2010%2020C4.47715%2020%200%2015.5228%200%2010ZM10%201.81818C5.4813%201.81818%201.81818%205.4813%201.81818%2010C1.81818%2014.5187%205.48131%2018.1818%2010%2018.1818C14.5187%2018.1818%2018.1818%2014.5187%2018.1818%2010C18.1818%205.48131%2014.5187%201.81818%2010%201.81818Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.36365%2010C6.36365%209.49794%206.77067%209.09094%207.27274%209.09094H12.7273C13.2294%209.09094%2013.6364%209.49794%2013.6364%2010C13.6364%2010.5021%2013.2294%2010.9091%2012.7273%2010.9091H7.27274C6.77067%2010.9091%206.36365%2010.5021%206.36365%2010Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.36365%2013.6364C6.36365%2013.1343%206.77067%2012.7273%207.27274%2012.7273H9.09092C9.59301%2012.7273%2010%2013.1343%2010%2013.6364C10%2014.1385%209.59301%2014.5455%209.09092%2014.5455H7.27274C6.77067%2014.5455%206.36365%2014.1385%206.36365%2013.6364Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.36365%206.36368C6.36365%205.86161%206.77067%205.45459%207.27274%205.45459H11.8182C12.3203%205.45459%2012.7273%205.86161%2012.7273%206.36368C12.7273%206.86575%2012.3203%207.27277%2011.8182%207.27277H7.27274C6.77067%207.27277%206.36365%206.86575%206.36365%206.36368Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7_27'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", PS = "data:image/svg+xml,%3csvg%20viewBox='0%200%2020%2020'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7_19)'%3e%3cmask%20id='mask0_7_19'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='-1'%20y='-1'%20width='22'%20height='22'%3e%3cpath%20d='M20.9091%20-0.909058H-0.909088V20.9091H20.9091V-0.909058Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_7_19)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%2010C0%204.47715%204.47715%200%2010%200C15.5228%200%2020%204.47715%2020%2010C20%2015.5228%2015.5228%2020%2010%2020C4.47715%2020%200%2015.5228%200%2010ZM10%201.81818C5.4813%201.81818%201.81818%205.4813%201.81818%2010C1.81818%2014.5187%205.48131%2018.1818%2010%2018.1818C14.5187%2018.1818%2018.1818%2014.5187%2018.1818%2010C18.1818%205.48131%2014.5187%201.81818%2010%201.81818Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5.68182%205.63634C5.68182%205.15937%206.06849%204.77271%206.54546%204.77271H13.4546C13.9316%204.77271%2014.3182%205.15937%2014.3182%205.63634V14.2512C14.3182%2014.8932%2013.6426%2015.3108%2013.0683%2015.0237L11.8182%2014.3986L10.3863%2015.1146C10.1431%2015.2362%209.85691%2015.2362%209.61373%2015.1146L8.18182%2014.3986L6.93169%2015.0237C6.35746%2015.3108%205.68182%2014.8932%205.68182%2014.2512V5.63634ZM7.04546%206.13634V13.4423L7.7956%2013.0672C8.03873%2012.9456%208.32491%2012.9456%208.5681%2013.0672L10%2013.7832L11.4319%2013.0672C11.6751%2012.9456%2011.9613%2012.9456%2012.2045%2013.0672L12.9546%2013.4423V6.13634H7.04546Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.36365%208.63631C6.36365%208.38531%206.56716%208.18176%206.81819%208.18176H6.98566C7.23669%208.18176%207.4402%208.38531%207.4402%208.63631C7.4402%208.88731%207.23669%209.09085%206.98566%209.09085H6.81819C6.56716%209.09085%206.36365%208.88731%206.36365%208.63631ZM7.78709%208.63631C7.78709%208.38531%207.9906%208.18176%208.24165%208.18176H8.57656C8.82765%208.18176%209.0311%208.38531%209.0311%208.63631C9.0311%208.88731%208.82765%209.09085%208.57656%209.09085H8.24165C7.9906%209.09085%207.78709%208.88731%207.78709%208.63631ZM9.37801%208.63631C9.37801%208.38531%209.58147%208.18176%209.83256%208.18176H10.1675C10.4186%208.18176%2010.622%208.38531%2010.622%208.63631C10.622%208.88731%2010.4186%209.09085%2010.1675%209.09085H9.83256C9.58147%209.09085%209.37801%208.88731%209.37801%208.63631ZM10.9689%208.63631C10.9689%208.38531%2011.1724%208.18176%2011.4235%208.18176H11.7584C12.0095%208.18176%2012.2129%208.38531%2012.2129%208.63631C12.2129%208.88731%2012.0095%209.09085%2011.7584%209.09085H11.4235C11.1724%209.09085%2010.9689%208.88731%2010.9689%208.63631ZM12.5598%208.63631C12.5598%208.38531%2012.7633%208.18176%2013.0144%208.18176H13.1818C13.4328%208.18176%2013.6364%208.38531%2013.6364%208.63631C13.6364%208.88731%2013.4328%209.09085%2013.1818%209.09085H13.0144C12.7633%209.09085%2012.5598%208.88731%2012.5598%208.63631Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7_19'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", RS = "data:image/svg+xml,%3csvg%20viewBox='0%200%2020%2020'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7_9)'%3e%3cmask%20id='mask0_7_9'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='-1'%20y='-1'%20width='22'%20height='22'%3e%3cpath%20d='M20.9091%20-0.909058H-0.909088V20.9091H20.9091V-0.909058Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_7_9)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%2010C0%204.47715%204.47715%200%2010%200C15.5228%200%2020%204.47715%2020%2010C20%2015.5228%2015.5228%2020%2010%2020C4.47715%2020%200%2015.5228%200%2010ZM10%201.81818C5.4813%201.81818%201.81818%205.4813%201.81818%2010C1.81818%2014.5187%205.48131%2018.1818%2010%2018.1818C14.5187%2018.1818%2018.1818%2014.5187%2018.1818%2010C18.1818%205.48131%2014.5187%201.81818%2010%201.81818Z'%20fill='white'/%3e%3cpath%20d='M8.18183%205.45459H6.36365C5.86157%205.45459%205.45456%205.8616%205.45456%206.36368V8.18186C5.45456%208.68394%205.86157%209.09095%206.36365%209.09095H8.18183C8.68391%209.09095%209.09092%208.68394%209.09092%208.18186V6.36368C9.09092%205.8616%208.68391%205.45459%208.18183%205.45459Z'%20fill='white'/%3e%3cpath%20d='M13.6364%205.45459H11.8182C11.3161%205.45459%2010.9091%205.8616%2010.9091%206.36368V8.18186C10.9091%208.68394%2011.3161%209.09095%2011.8182%209.09095H13.6364C14.1384%209.09095%2014.5455%208.68394%2014.5455%208.18186V6.36368C14.5455%205.8616%2014.1384%205.45459%2013.6364%205.45459Z'%20fill='white'/%3e%3cpath%20d='M13.6364%2010.9091H11.8182C11.3161%2010.9091%2010.9091%2011.3161%2010.9091%2011.8181V13.6363C10.9091%2014.1384%2011.3161%2014.5454%2011.8182%2014.5454H13.6364C14.1384%2014.5454%2014.5455%2014.1384%2014.5455%2013.6363V11.8181C14.5455%2011.3161%2014.1384%2010.9091%2013.6364%2010.9091Z'%20fill='white'/%3e%3cpath%20d='M8.18183%2010.9091H6.36365C5.86157%2010.9091%205.45456%2011.3161%205.45456%2011.8181V13.6363C5.45456%2014.1384%205.86157%2014.5454%206.36365%2014.5454H8.18183C8.68391%2014.5454%209.09092%2014.1384%209.09092%2013.6363V11.8181C9.09092%2011.3161%208.68391%2010.9091%208.18183%2010.9091Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7_9'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", DS = "data:image/svg+xml,%3csvg%20viewBox='0%200%2020%2020'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7_36)'%3e%3cmask%20id='mask0_7_36'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='-1'%20y='-1'%20width='22'%20height='22'%3e%3cpath%20d='M20.9091%20-0.909058H-0.909088V20.9091H20.9091V-0.909058Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_7_36)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%2010C0%204.47715%204.47715%200%2010%200C15.5228%200%2020%204.47715%2020%2010C20%2015.5228%2015.5228%2020%2010%2020C4.47715%2020%200%2015.5228%200%2010ZM10%201.81818C5.4813%201.81818%201.81818%205.4813%201.81818%2010C1.81818%2014.5187%205.48131%2018.1818%2010%2018.1818C14.5187%2018.1818%2018.1818%2014.5187%2018.1818%2010C18.1818%205.48131%2014.5187%201.81818%2010%201.81818Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M11.4718%2010.0244C11.2567%209.97354%2011.0304%2010.0028%2010.8353%2010.1067L2.29995%2014.6522C1.8568%2014.8882%201.68886%2015.4387%201.92486%2015.8818C2.16086%2016.325%202.71143%2016.4929%203.15458%2016.2569L11.3872%2011.8727L17.9726%2013.4302C18.4612%2013.5457%2018.951%2013.2433%2019.0665%2012.7546C19.1821%2012.2661%2018.8796%2011.7764%2018.3911%2011.6607L11.4718%2010.0244Z'%20fill='white'/%3e%3cpath%20d='M6.07329%209.09092C5.32016%209.09092%204.70966%208.48037%204.70966%207.72728C4.70966%206.97417%205.32016%206.36365%206.07329%206.36365C6.82643%206.36365%207.43693%206.97417%207.43693%207.72728C7.43693%208.48037%206.82643%209.09092%206.07329%209.09092Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7_36'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", FS = "data:image/svg+xml,%3csvg%20viewBox='0%200%2020%2020'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7_2)'%3e%3cmask%20id='mask0_7_2'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='-1'%20y='-1'%20width='22'%20height='22'%3e%3cpath%20d='M20.9091%20-0.909058H-0.909088V20.9091H20.9091V-0.909058Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_7_2)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8.04937%200.190318C8.681%200.0653727%209.33327%200%2010%200C10.6667%200%2011.319%200.0653727%2011.9506%200.190318L11.5978%201.97394C11.0817%201.87185%2010.5475%201.81818%2010%201.81818C9.45245%201.81818%208.91827%201.87185%208.40218%201.97394L8.04937%200.190318ZM15.5568%201.68489C16.6469%202.41471%2017.5853%203.35308%2018.3151%204.4432L16.8043%205.45469C16.2066%204.56206%2015.4379%203.79335%2014.5453%203.19574L15.5568%201.68489ZM1.68489%204.4432C2.41471%203.35308%203.35308%202.41471%204.4432%201.68489L5.45469%203.19574C4.56206%203.79335%203.79335%204.56206%203.19574%205.45469L1.68489%204.4432ZM19.8096%208.04937C19.9346%208.681%2020%209.33327%2020%2010C20%2010.6667%2019.9346%2011.319%2019.8096%2011.9506L18.0261%2011.5978C18.1282%2011.0817%2018.1818%2010.5475%2018.1818%2010C18.1818%209.45245%2018.1282%208.91827%2018.0261%208.40218L19.8096%208.04937ZM0%2010C0%209.33327%200.0653727%208.681%200.190318%208.04937L1.97394%208.40218C1.87185%208.91827%201.81818%209.45245%201.81818%2010C1.81818%2010.5475%201.87185%2011.0817%201.97394%2011.5978L0.190318%2011.9506C0.0653727%2011.319%200%2010.6667%200%2010ZM18.3151%2015.5568C17.5853%2016.6469%2016.6469%2017.5853%2015.5568%2018.3151L14.5453%2016.8043C15.4379%2016.2066%2016.2066%2015.4379%2016.8043%2014.5453L18.3151%2015.5568ZM4.4432%2018.3151C3.35308%2017.5853%202.41471%2016.6469%201.68489%2015.5568L3.19574%2014.5453C3.79335%2015.4379%204.56206%2016.2066%205.45469%2016.8043L4.4432%2018.3151ZM10%2020C9.33327%2020%208.681%2019.9346%208.04937%2019.8096L8.40218%2018.0261C8.91827%2018.1282%209.45245%2018.1818%2010%2018.1818C10.5475%2018.1818%2011.0817%2018.1282%2011.5978%2018.0261L11.9506%2019.8096C11.319%2019.9346%2010.6667%2020%2010%2020Z'%20fill='white'/%3e%3cpath%20d='M10%2011.8181C8.99582%2011.8181%208.18182%2011.0041%208.18182%209.99994C8.18182%208.99576%208.99582%208.18176%2010%208.18176C11.0042%208.18176%2011.8182%208.99576%2011.8182%209.99994C11.8182%2011.0041%2011.0042%2011.8181%2010%2011.8181Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7_2'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", OS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Artifact: MS,
  ArtifactImage: DS,
  ArtifactMarkdown: IS,
  ArtifactProgress: FS,
  ArtifactResult: PS,
  ArtifactTable: RS
}, Symbol.toStringTag, { value: "Module" }));
function NS(n) {
  const t = {
    resolution: Ig
  };
  return ct.from(OS[n], t);
}
async function kS(n) {
  return await Po(NS, [n]);
}
async function BS({ cullAtZoomThreshold: n = !0 } = {}) {
  const t = await Iv(), e = new jt();
  n && t.add(e);
  async function r(i) {
    const s = await kS(i);
    return e.texture = s, e;
  }
  return {
    element: e,
    render: r
  };
}
var Mu = { exports: {} }, Nm;
function LS() {
  return Nm || (Nm = 1, (function(n) {
    (function() {
      function t(m, g) {
        document.addEventListener ? m.addEventListener("scroll", g, !1) : m.attachEvent("scroll", g);
      }
      function e(m) {
        document.body ? m() : document.addEventListener ? document.addEventListener("DOMContentLoaded", function g() {
          document.removeEventListener("DOMContentLoaded", g), m();
        }) : document.attachEvent("onreadystatechange", function g() {
          (document.readyState == "interactive" || document.readyState == "complete") && (document.detachEvent("onreadystatechange", g), m());
        });
      }
      function r(m) {
        this.g = document.createElement("div"), this.g.setAttribute("aria-hidden", "true"), this.g.appendChild(document.createTextNode(m)), this.h = document.createElement("span"), this.i = document.createElement("span"), this.m = document.createElement("span"), this.j = document.createElement("span"), this.l = -1, this.h.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;", this.i.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;", this.j.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;", this.m.style.cssText = "display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;", this.h.appendChild(this.m), this.i.appendChild(this.j), this.g.appendChild(this.h), this.g.appendChild(this.i);
      }
      function i(m, g) {
        m.g.style.cssText = "max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:" + g + ";";
      }
      function s(m) {
        var g = m.g.offsetWidth, _ = g + 100;
        return m.j.style.width = _ + "px", m.i.scrollLeft = _, m.h.scrollLeft = m.h.scrollWidth + 100, m.l !== g ? (m.l = g, !0) : !1;
      }
      function o(m, g) {
        function _() {
          var v = w;
          s(v) && v.g.parentNode !== null && g(v.l);
        }
        var w = m;
        t(m.h, _), t(m.i, _), s(m);
      }
      function a(m, g, _) {
        g = g || {}, _ = _ || window, this.family = m, this.style = g.style || "normal", this.weight = g.weight || "normal", this.stretch = g.stretch || "normal", this.context = _;
      }
      var h = null, l = null, u = null, c = null;
      function d(m) {
        return l === null && (f(m) && /Apple/.test(window.navigator.vendor) ? (m = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent), l = !!m && 603 > parseInt(m[1], 10)) : l = !1), l;
      }
      function f(m) {
        return c === null && (c = !!m.document.fonts), c;
      }
      function p(m, g) {
        var _ = m.style, w = m.weight;
        if (u === null) {
          var v = document.createElement("div");
          try {
            v.style.font = "condensed 100px sans-serif";
          } catch {
          }
          u = v.style.font !== "";
        }
        return [_, w, u ? m.stretch : "", "100px", g].join(" ");
      }
      a.prototype.load = function(m, g) {
        var _ = this, w = m || "BESbswy", v = 0, E = g || 3e3, x = (/* @__PURE__ */ new Date()).getTime();
        return new Promise(function(b, y) {
          if (f(_.context) && !d(_.context)) {
            var C = new Promise(function(U, F) {
              function O() {
                (/* @__PURE__ */ new Date()).getTime() - x >= E ? F(Error("" + E + "ms timeout exceeded")) : _.context.document.fonts.load(p(_, '"' + _.family + '"'), w).then(function(R) {
                  1 <= R.length ? U() : setTimeout(O, 25);
                }, F);
              }
              O();
            }), M = new Promise(function(U, F) {
              v = setTimeout(function() {
                F(Error("" + E + "ms timeout exceeded"));
              }, E);
            });
            Promise.race([M, C]).then(function() {
              clearTimeout(v), b(_);
            }, y);
          } else e(function() {
            function U() {
              var N;
              (N = j != -1 && T != -1 || j != -1 && S != -1 || T != -1 && S != -1) && ((N = j != T && j != S && T != S) || (h === null && (N = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent), h = !!N && (536 > parseInt(N[1], 10) || parseInt(N[1], 10) === 536 && 11 >= parseInt(N[2], 10))), N = h && (j == A && T == A && S == A || j == L && T == L && S == L || j == D && T == D && S == D)), N = !N), N && (P.parentNode !== null && P.parentNode.removeChild(P), clearTimeout(v), b(_));
            }
            function F() {
              if ((/* @__PURE__ */ new Date()).getTime() - x >= E) P.parentNode !== null && P.parentNode.removeChild(P), y(Error("" + E + "ms timeout exceeded"));
              else {
                var N = _.context.document.hidden;
                (N === !0 || N === void 0) && (j = O.g.offsetWidth, T = R.g.offsetWidth, S = k.g.offsetWidth, U()), v = setTimeout(F, 50);
              }
            }
            var O = new r(w), R = new r(w), k = new r(w), j = -1, T = -1, S = -1, A = -1, L = -1, D = -1, P = document.createElement("div");
            P.dir = "ltr", i(O, p(_, "sans-serif")), i(R, p(_, "serif")), i(k, p(_, "monospace")), P.appendChild(O.g), P.appendChild(R.g), P.appendChild(k.g), _.context.document.body.appendChild(P), A = O.g.offsetWidth, L = R.g.offsetWidth, D = k.g.offsetWidth, F(), o(O, function(N) {
              j = N, U();
            }), i(O, p(_, '"' + _.family + '",sans-serif')), o(R, function(N) {
              T = N, U();
            }), i(R, p(_, '"' + _.family + '",serif')), o(k, function(N) {
              S = N, U();
            }), i(k, p(_, '"' + _.family + '",monospace'));
          });
        });
      }, n.exports = a;
    })();
  })(Mu)), Mu.exports;
}
var US = LS();
const HS = /* @__PURE__ */ So(US);
let wo = null;
const GS = {
  fontFamily: "Inter Variable",
  fontSize: 16,
  lineHeight: 20,
  fill: 16777215
}, Iu = {
  resolution: Ig,
  chars: je.ASCII
}, Pu = "sans-serif";
async function zS() {
  const { font: n } = await Wt(), t = {
    ...GS,
    fontFamily: n.fontFamily
  };
  await WS(t, n.type), wo = XS(t), it.emit("fontLoaded", wo);
}
async function WS(n, t) {
  const { fontFamily: e, ...r } = n;
  try {
    t === "WebFont" ? await new HS(e).load() : je.from(e, {
      fontFamily: Pu,
      ...r
    }, Iu);
  } catch (i) {
    console.error(i), console.warn(`fonts: font ${e} failed to load, falling back to ${Pu}`), je.from(e, {
      fontFamily: Pu,
      ...r
    }, Iu);
    return;
  }
  je.from(e, n, Iu);
}
function $S() {
  wo = null;
}
async function w_() {
  return wo || await Re("fontLoaded");
}
function XS(n) {
  const { fontFamily: t, ...e } = n, r = {
    fontName: t,
    ...e
  };
  return (i) => new $T(i, r);
}
async function Gh({ cullAtZoomThreshold: n = !0 } = {}) {
  const t = await w_(), e = await Mv(), r = t("");
  n && e.add(r);
  async function i(s) {
    return r.text = s, await r;
  }
  return {
    element: r,
    render: i
  };
}
async function b_({ cullAtZoomThreshold: n }) {
  const t = await Wt(), e = new bt(), r = new bt(), { element: i, render: s } = await BS({ cullAtZoomThreshold: n }), { element: o, render: a } = await CS(), { element: h, render: l } = await Gh({ cullAtZoomThreshold: n }), { element: u, render: c } = await TS();
  let d = !1, f = null, p;
  r.addChild(h), e.addChild(u), e.addChild(r);
  async function m(E) {
    const { selected: x, name: b, type: y } = E;
    return d = x ?? d, f = b ?? f, p = y, p === "progress" ? r.addChild(o) : r.addChild(i), E.type === "progress" ? await Promise.all([
      _(E.data),
      w()
    ]) : await Promise.all([
      g(),
      w()
    ]), await v(), e;
  }
  async function g() {
    if (p === "progress")
      return i;
    const E = l1[p], {
      artifactIconSize: x,
      artifactIconColor: b,
      artifactPaddingLeft: y,
      artifactPaddingY: C
    } = t, M = await s(E);
    return M.position = { x: y, y: C }, M.width = x, M.height = x, M.tint = b, M;
  }
  async function _(E) {
    const {
      artifactPaddingLeft: x,
      artifactPaddingRight: b,
      artifactPaddingY: y,
      artifactIconSize: C
    } = t, M = 20, U = (C - M * 2) / 2, F = a({
      value: E,
      radius: U,
      lineWidth: M
    });
    return f ? F.position.x += x : F.position.x += (x + b) / 2, F.position.y += y, o;
  }
  async function w() {
    if (!f)
      return h.visible = !1, h;
    await l(f);
    const {
      artifactPaddingLeft: E,
      artifactPaddingY: x,
      artifactTextColor: b,
      artifactIconSize: y,
      artifactContentGap: C
    } = t, M = f ? C : 0, U = E + y + M, F = x;
    return h.tint = b, h.scale.set(0.75), h.position = { x: U, y: F }, h.visible = !0, h;
  }
  async function v() {
    const {
      artifactPaddingLeft: E,
      artifactPaddingRight: x,
      artifactPaddingY: b
    } = t, y = {
      selected: d,
      width: r.width + E + x,
      height: r.height + b * 2
    };
    return await c(y);
  }
  return {
    element: e,
    render: m
  };
}
let Lt = null, ch = !1;
async function VS() {
  const n = await Jt();
  n.on("click", () => dn(null)), n.on("drag-start", () => {
    ch = !0;
  }), n.on("drag-end", () => {
    setTimeout(() => {
      ch = !1;
    });
  });
}
function YS() {
  Lt = null, ch = !1;
}
function dn(n) {
  if (!ch && !(!n && !Lt || n && fn(n))) {
    if (Lt = n, n === null) {
      it.emit("itemSelected", null);
      return;
    }
    it.emit("itemSelected", n);
  }
}
function fn(n) {
  if (Lt === null)
    return !1;
  const { kind: t } = n;
  switch (t) {
    case "task-run":
      return Uu(Lt) && Lt.id === n.id;
    case "flow-run":
      return Uu(Lt) && Lt.id === n.id;
    case "artifact":
      return u1(Lt) && Lt.id === n.id;
    case "artifacts":
      return c1(Lt) && Lt.ids.length === n.ids.length && Lt.ids.every((r) => n.ids.includes(r));
    case "state":
      return d1(Lt) && Lt.id === n.id;
    case "event":
      return f1(Lt) && Lt.id === n.id;
    case "events":
      return p1(Lt) && Lt.ids.length === n.ids.length && Lt.ids.every((r) => n.ids.includes(r));
    default:
      const e = t;
      throw new Error(`switch does not have case for value: ${e}`);
  }
}
function jS() {
  return Lt && Uu(Lt) ? Lt : null;
}
async function Nd(n, {
  cullAtZoomThreshold: t = !0,
  enableLocalClickHandling: e = !1
} = {}) {
  const { element: r, render: i } = await b_({ cullAtZoomThreshold: t });
  let s = !1, o = n;
  r.eventMode = "static", r.cursor = "pointer", e && r.on("click", (c) => {
    c.stopPropagation(), dn({ kind: "artifact", id: o.id });
  }), it.on("itemSelected", () => {
    const c = fn({ kind: "artifact", id: o.id });
    c !== s && (s = c, a(o));
  });
  async function a(c) {
    o = c, await i({ selected: s, name: o.key, ...o });
  }
  function h() {
    return s;
  }
  function l() {
    return o.created;
  }
  function u() {
    return o.id;
  }
  return {
    isArtifact: !0,
    element: r,
    render: a,
    getSelected: h,
    getDate: l,
    getId: u
  };
}
function T_(n) {
  return n.isArtifact === !0;
}
function qS(n) {
  return typeof n == "function";
}
function ka(n) {
  return qS(n) ? n() : n;
}
async function A_(n, t) {
  const e = await zr(), r = await He();
  let i, s = null;
  async function o() {
    try {
      s = await r.fetchEvents(ka(n)), t(s);
    } catch (h) {
      console.error(h);
    }
    e.end_time || (i = setTimeout(() => o(), r.fetchEventsInterval));
  }
  function a() {
    clearTimeout(i);
  }
  return {
    start: o,
    stop: a
  };
}
async function E_() {
  const n = await Wt(), t = await Mv(), e = new bt(), { element: r, render: i } = await x_(), { element: s, render: o } = await Od(), { element: a, render: h } = await Uh();
  t.add(e);
  let l = !1;
  e.eventMode = "static", e.cursor = "pointer", e.addChild(s), e.addChild(r), e.addChild(a), e.on("mouseover", c), e.on("mouseout", d);
  async function u({ inside: f, isOpen: p }) {
    l = f;
    const m = {
      size: 10,
      stroke: 2,
      rotate: p ? uh.Up : uh.Down
    }, g = await i(m), _ = {
      width: n.nodeToggleSize,
      height: n.nodeToggleSize,
      background: n.nodeToggleBgColor,
      radius: n.nodeToggleBorderRadius
    }, w = await o(_);
    w.alpha = f ? 0 : 0.5;
    const v = await h({
      width: _.width,
      height: _.height,
      radius: _.radius,
      stroke: 1,
      color: n.nodeToggleBorderColor
    });
    v.alpha = f ? 0 : 1;
    const E = {
      y: w.height / 2,
      x: w.width / 2
    }, x = m.size / 4;
    return g.x = E.x, g.y = p ? E.y + x : E.y - x, e;
  }
  function c() {
    s.alpha = l ? 0.5 : 1;
  }
  function d() {
    s.alpha = l ? 0 : 0.5;
  }
  return {
    element: e,
    render: u
  };
}
async function S_() {
  const n = await Wt(), t = await Kt(), e = new bt(), { element: r, render: i } = await Od(), { element: s, render: o } = await Hh();
  e.addChild(r), e.addChild(s);
  async function a(l) {
    const { background: u = "#fff" } = n.node(l), { nodeHeight: c, nodeRadius: d } = n, f = fn({ kind: l.kind, id: l.id }), p = h(l, d), m = l.state_type !== "RUNNING" || t.isDependency();
    return await Promise.all([
      i({
        width: p,
        height: c,
        radius: d,
        background: u,
        capRight: m
      }),
      o({ selected: f, width: p, height: c })
    ]), r;
  }
  function h(l, u) {
    const c = Dd();
    if (ut.isTemporal() || ut.isLeftAligned()) {
      const d = l.start_time, f = l.end_time ?? /* @__PURE__ */ new Date(), m = y_(f, d) / Da * c;
      return Math.max(m, u * 2);
    }
    return c;
  }
  return {
    element: e,
    render: a
  };
}
var Ru, km;
function ZS() {
  if (km) return Ru;
  km = 1;
  var n = "Expected a function", t = NaN, e = "[object Symbol]", r = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, o = /^0o[0-7]+$/i, a = parseInt, h = typeof Ze == "object" && Ze && Ze.Object === Object && Ze, l = typeof self == "object" && self && self.Object === Object && self, u = h || l || Function("return this")(), c = Object.prototype, d = c.toString, f = Math.max, p = Math.min, m = function() {
    return u.Date.now();
  };
  function g(b, y, C) {
    var M, U, F, O, R, k, j = 0, T = !1, S = !1, A = !0;
    if (typeof b != "function")
      throw new TypeError(n);
    y = x(y) || 0, w(C) && (T = !!C.leading, S = "maxWait" in C, F = S ? f(x(C.maxWait) || 0, y) : F, A = "trailing" in C ? !!C.trailing : A);
    function L(K) {
      var G = M, W = U;
      return M = U = void 0, j = K, O = b.apply(W, G), O;
    }
    function D(K) {
      return j = K, R = setTimeout(B, y), T ? L(K) : O;
    }
    function P(K) {
      var G = K - k, W = K - j, q = y - G;
      return S ? p(q, F - W) : q;
    }
    function N(K) {
      var G = K - k, W = K - j;
      return k === void 0 || G >= y || G < 0 || S && W >= F;
    }
    function B() {
      var K = m();
      if (N(K))
        return X(K);
      R = setTimeout(B, P(K));
    }
    function X(K) {
      return R = void 0, A && M ? L(K) : (M = U = void 0, O);
    }
    function V() {
      R !== void 0 && clearTimeout(R), j = 0, M = k = U = R = void 0;
    }
    function J() {
      return R === void 0 ? O : X(m());
    }
    function tt() {
      var K = m(), G = N(K);
      if (M = arguments, U = this, k = K, G) {
        if (R === void 0)
          return D(k);
        if (S)
          return R = setTimeout(B, y), L(k);
      }
      return R === void 0 && (R = setTimeout(B, y)), O;
    }
    return tt.cancel = V, tt.flush = J, tt;
  }
  function _(b, y, C) {
    var M = !0, U = !0;
    if (typeof b != "function")
      throw new TypeError(n);
    return w(C) && (M = "leading" in C ? !!C.leading : M, U = "trailing" in C ? !!C.trailing : U), g(b, y, {
      leading: M,
      maxWait: y,
      trailing: U
    });
  }
  function w(b) {
    var y = typeof b;
    return !!b && (y == "object" || y == "function");
  }
  function v(b) {
    return !!b && typeof b == "object";
  }
  function E(b) {
    return typeof b == "symbol" || v(b) && d.call(b) == e;
  }
  function x(b) {
    if (typeof b == "number")
      return b;
    if (E(b))
      return t;
    if (w(b)) {
      var y = typeof b.valueOf == "function" ? b.valueOf() : b;
      b = w(y) ? y + "" : y;
    }
    if (typeof b != "string")
      return b === 0 ? b : +b;
    b = b.replace(r, "");
    var C = s.test(b);
    return C || o.test(b) ? a(b.slice(2), C ? 2 : 8) : i.test(b) ? t : +b;
  }
  return Ru = _, Ru;
}
var KS = ZS();
const C_ = /* @__PURE__ */ So(KS);
async function M_() {
  const { element: n, render: t } = await b_({ cullAtZoomThreshold: !1 });
  let e = null, r = [], i = !1;
  n.eventMode = "static", n.cursor = "pointer", it.on("itemSelected", () => {
    const l = fn({ kind: "artifacts", ids: r });
    l !== i && e && (i = l, s({ ids: r, date: e }));
  });
  async function s(l) {
    if (!l) {
      e = null, r = [], n.visible = !1;
      return;
    }
    const { ids: u, date: c } = l;
    e = c, r = u, await t({ selected: i, type: "unknown", name: u.length.toString() }), n.visible = !0;
  }
  function o() {
    return i;
  }
  function a() {
    return e;
  }
  function h() {
    return r;
  }
  return {
    isArtifactCluster: !0,
    element: n,
    render: s,
    getSelected: o,
    getDate: a,
    getIds: h,
    isCluster: !0
  };
}
async function QS({ radius: n }) {
  const t = await Qt(), e = new Un();
  return e.beginFill("#fff"), e.drawCircle(0, 0, n), e.endFill(), t.renderer.generateTexture(e, {
    resolution: Mg
  });
}
async function JS(n) {
  return await Po(QS, [n]);
}
async function I_(n) {
  const t = await JS(n);
  return new jt(t);
}
async function P_(n) {
  const t = new bt(), e = await Wt(), r = await hn(), i = await I_({ radius: e.eventRadiusDefault }), { element: s, render: o } = await Hh();
  let a = !1;
  t.addChild(r), t.addChild(i), t.addChild(s), t.eventMode = "static", t.cursor = "pointer", t.on("mouseenter", () => {
    a || i.scale.set(1.5);
  }), t.on("mouseleave", () => {
    a || i.scale.set(1);
  }), it.on("itemSelected", () => {
    const c = fn({ kind: "event", id: n.id, occurred: n.occurred });
    c !== a && (a = c, i.scale.set(c ? 1.5 : 1), h());
  });
  function h() {
    const { eventColor: c, eventTargetSize: d, eventSelectedBorderInset: f } = e;
    r.alpha = 0, r.width = d, r.height = d, i.tint = c, i.anchor.set(0.5), i.position.set(d / 2, d / 2), s.position.set(f, f), o({
      selected: a,
      width: d - f * 2,
      height: d - f * 2
    });
  }
  function l() {
    return n.id;
  }
  function u() {
    return n.occurred;
  }
  return {
    element: t,
    render: h,
    getId: l,
    getDate: u
  };
}
async function R_() {
  const n = new bt(), t = await Wt(), e = await hn(), r = await I_({ radius: t.eventClusterRadiusDefault }), { element: i, render: s } = await Hh(), { element: o, render: a } = await Gh({ cullAtZoomThreshold: !1 });
  let h = null, l = [], u = !1;
  n.addChild(e), n.addChild(r), n.addChild(o), n.addChild(i), n.eventMode = "static", n.cursor = "pointer", n.on("mouseenter", () => {
    u || r.scale.set(1.5);
  }), n.on("mouseleave", () => {
    u || r.scale.set(1);
  }), it.on("itemSelected", () => {
    const w = fn({ kind: "events", ids: l });
    w !== u && (u = w, r.scale.set(w ? 1.5 : 1), h && c({ ids: l, date: h }));
  });
  async function c(w) {
    if (!w) {
      h = null, l = [], n.visible = !1;
      return;
    }
    const { ids: v, date: E } = w;
    h = E, l = v, d(), f(), m(), await p(v.length.toString()), n.visible = !0;
  }
  function d() {
    const { eventTargetSize: w } = t;
    e.alpha = 0, e.width = w, e.height = w;
  }
  function f() {
    const { eventClusterColor: w, eventTargetSize: v } = t;
    r.tint = w, r.anchor.set(0.5), r.position.set(v / 2, v / 2);
  }
  async function p(w) {
    if (l.length < 2)
      return;
    const { eventTargetSize: v } = t, E = -1;
    o.scale.set(0.6), o.anchor.set(0.5), o.position.set(
      v / 2,
      v / 2 + E
    ), await a(w);
  }
  function m() {
    const { eventSelectedBorderInset: w, eventTargetSize: v } = t;
    i.position.set(w, w), s({
      selected: u,
      width: v - w * 2,
      height: v - w * 2
    });
  }
  function g() {
    return l;
  }
  function _() {
    return h;
  }
  return {
    element: n,
    render: c,
    getIds: g,
    getDate: _
  };
}
function Ba(n, t) {
  return n == null || t == null ? NaN : n < t ? -1 : n > t ? 1 : n >= t ? 0 : NaN;
}
function tC(n, t) {
  return n == null || t == null ? NaN : t < n ? -1 : t > n ? 1 : t >= n ? 0 : NaN;
}
function kd(n) {
  let t, e, r;
  n.length !== 2 ? (t = Ba, e = (a, h) => Ba(n(a), h), r = (a, h) => n(a) - h) : (t = n === Ba || n === tC ? n : eC, e = n, r = n);
  function i(a, h, l = 0, u = a.length) {
    if (l < u) {
      if (t(h, h) !== 0) return u;
      do {
        const c = l + u >>> 1;
        e(a[c], h) < 0 ? l = c + 1 : u = c;
      } while (l < u);
    }
    return l;
  }
  function s(a, h, l = 0, u = a.length) {
    if (l < u) {
      if (t(h, h) !== 0) return u;
      do {
        const c = l + u >>> 1;
        e(a[c], h) <= 0 ? l = c + 1 : u = c;
      } while (l < u);
    }
    return l;
  }
  function o(a, h, l = 0, u = a.length) {
    const c = i(a, h, l, u - 1);
    return c > l && r(a[c - 1], h) > -r(a[c], h) ? c - 1 : c;
  }
  return { left: i, center: o, right: s };
}
function eC() {
  return 0;
}
function rC(n) {
  return n === null ? NaN : +n;
}
const nC = kd(Ba), iC = nC.right;
kd(rC).center;
const sC = Math.sqrt(50), oC = Math.sqrt(10), aC = Math.sqrt(2);
function dh(n, t, e) {
  const r = (t - n) / Math.max(0, e), i = Math.floor(Math.log10(r)), s = r / Math.pow(10, i), o = s >= sC ? 10 : s >= oC ? 5 : s >= aC ? 2 : 1;
  let a, h, l;
  return i < 0 ? (l = Math.pow(10, -i) / o, a = Math.round(n * l), h = Math.round(t * l), a / l < n && ++a, h / l > t && --h, l = -l) : (l = Math.pow(10, i) * o, a = Math.round(n / l), h = Math.round(t / l), a * l < n && ++a, h * l > t && --h), h < a && 0.5 <= e && e < 2 ? dh(n, t, e * 2) : [a, h, l];
}
function hC(n, t, e) {
  if (t = +t, n = +n, e = +e, !(e > 0)) return [];
  if (n === t) return [n];
  const r = t < n, [i, s, o] = r ? dh(t, n, e) : dh(n, t, e);
  if (!(s >= i)) return [];
  const a = s - i + 1, h = new Array(a);
  if (r)
    if (o < 0) for (let l = 0; l < a; ++l) h[l] = (s - l) / -o;
    else for (let l = 0; l < a; ++l) h[l] = (s - l) * o;
  else if (o < 0) for (let l = 0; l < a; ++l) h[l] = (i + l) / -o;
  else for (let l = 0; l < a; ++l) h[l] = (i + l) * o;
  return h;
}
function Wc(n, t, e) {
  return t = +t, n = +n, e = +e, dh(n, t, e)[2];
}
function $c(n, t, e) {
  t = +t, n = +n, e = +e;
  const r = t < n, i = r ? Wc(t, n, e) : Wc(n, t, e);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
var lC = { value: () => {
} };
function D_() {
  for (var n = 0, t = arguments.length, e = {}, r; n < t; ++n) {
    if (!(r = arguments[n] + "") || r in e || /[\s.]/.test(r)) throw new Error("illegal type: " + r);
    e[r] = [];
  }
  return new La(e);
}
function La(n) {
  this._ = n;
}
function uC(n, t) {
  return n.trim().split(/^|\s+/).map(function(e) {
    var r = "", i = e.indexOf(".");
    if (i >= 0 && (r = e.slice(i + 1), e = e.slice(0, i)), e && !t.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    return { type: e, name: r };
  });
}
La.prototype = D_.prototype = {
  constructor: La,
  on: function(n, t) {
    var e = this._, r = uC(n + "", e), i, s = -1, o = r.length;
    if (arguments.length < 2) {
      for (; ++s < o; ) if ((i = (n = r[s]).type) && (i = cC(e[i], n.name))) return i;
      return;
    }
    if (t != null && typeof t != "function") throw new Error("invalid callback: " + t);
    for (; ++s < o; )
      if (i = (n = r[s]).type) e[i] = Bm(e[i], n.name, t);
      else if (t == null) for (i in e) e[i] = Bm(e[i], n.name, null);
    return this;
  },
  copy: function() {
    var n = {}, t = this._;
    for (var e in t) n[e] = t[e].slice();
    return new La(n);
  },
  call: function(n, t) {
    if ((i = arguments.length - 2) > 0) for (var e = new Array(i), r = 0, i, s; r < i; ++r) e[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    for (s = this._[n], r = 0, i = s.length; r < i; ++r) s[r].value.apply(t, e);
  },
  apply: function(n, t, e) {
    if (!this._.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    for (var r = this._[n], i = 0, s = r.length; i < s; ++i) r[i].value.apply(t, e);
  }
};
function cC(n, t) {
  for (var e = 0, r = n.length, i; e < r; ++e)
    if ((i = n[e]).name === t)
      return i.value;
}
function Bm(n, t, e) {
  for (var r = 0, i = n.length; r < i; ++r)
    if (n[r].name === t) {
      n[r] = lC, n = n.slice(0, r).concat(n.slice(r + 1));
      break;
    }
  return e != null && n.push({ name: t, value: e }), n;
}
var Xc = "http://www.w3.org/1999/xhtml";
const Lm = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: Xc,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function zh(n) {
  var t = n += "", e = t.indexOf(":");
  return e >= 0 && (t = n.slice(0, e)) !== "xmlns" && (n = n.slice(e + 1)), Lm.hasOwnProperty(t) ? { space: Lm[t], local: n } : n;
}
function dC(n) {
  return function() {
    var t = this.ownerDocument, e = this.namespaceURI;
    return e === Xc && t.documentElement.namespaceURI === Xc ? t.createElement(n) : t.createElementNS(e, n);
  };
}
function fC(n) {
  return function() {
    return this.ownerDocument.createElementNS(n.space, n.local);
  };
}
function F_(n) {
  var t = zh(n);
  return (t.local ? fC : dC)(t);
}
function pC() {
}
function Bd(n) {
  return n == null ? pC : function() {
    return this.querySelector(n);
  };
}
function mC(n) {
  typeof n != "function" && (n = Bd(n));
  for (var t = this._groups, e = t.length, r = new Array(e), i = 0; i < e; ++i)
    for (var s = t[i], o = s.length, a = r[i] = new Array(o), h, l, u = 0; u < o; ++u)
      (h = s[u]) && (l = n.call(h, h.__data__, u, s)) && ("__data__" in h && (l.__data__ = h.__data__), a[u] = l);
  return new gr(r, this._parents);
}
function gC(n) {
  return n == null ? [] : Array.isArray(n) ? n : Array.from(n);
}
function yC() {
  return [];
}
function O_(n) {
  return n == null ? yC : function() {
    return this.querySelectorAll(n);
  };
}
function _C(n) {
  return function() {
    return gC(n.apply(this, arguments));
  };
}
function vC(n) {
  typeof n == "function" ? n = _C(n) : n = O_(n);
  for (var t = this._groups, e = t.length, r = [], i = [], s = 0; s < e; ++s)
    for (var o = t[s], a = o.length, h, l = 0; l < a; ++l)
      (h = o[l]) && (r.push(n.call(h, h.__data__, l, o)), i.push(h));
  return new gr(r, i);
}
function N_(n) {
  return function() {
    return this.matches(n);
  };
}
function k_(n) {
  return function(t) {
    return t.matches(n);
  };
}
var xC = Array.prototype.find;
function wC(n) {
  return function() {
    return xC.call(this.children, n);
  };
}
function bC() {
  return this.firstElementChild;
}
function TC(n) {
  return this.select(n == null ? bC : wC(typeof n == "function" ? n : k_(n)));
}
var AC = Array.prototype.filter;
function EC() {
  return Array.from(this.children);
}
function SC(n) {
  return function() {
    return AC.call(this.children, n);
  };
}
function CC(n) {
  return this.selectAll(n == null ? EC : SC(typeof n == "function" ? n : k_(n)));
}
function MC(n) {
  typeof n != "function" && (n = N_(n));
  for (var t = this._groups, e = t.length, r = new Array(e), i = 0; i < e; ++i)
    for (var s = t[i], o = s.length, a = r[i] = [], h, l = 0; l < o; ++l)
      (h = s[l]) && n.call(h, h.__data__, l, s) && a.push(h);
  return new gr(r, this._parents);
}
function B_(n) {
  return new Array(n.length);
}
function IC() {
  return new gr(this._enter || this._groups.map(B_), this._parents);
}
function fh(n, t) {
  this.ownerDocument = n.ownerDocument, this.namespaceURI = n.namespaceURI, this._next = null, this._parent = n, this.__data__ = t;
}
fh.prototype = {
  constructor: fh,
  appendChild: function(n) {
    return this._parent.insertBefore(n, this._next);
  },
  insertBefore: function(n, t) {
    return this._parent.insertBefore(n, t);
  },
  querySelector: function(n) {
    return this._parent.querySelector(n);
  },
  querySelectorAll: function(n) {
    return this._parent.querySelectorAll(n);
  }
};
function PC(n) {
  return function() {
    return n;
  };
}
function RC(n, t, e, r, i, s) {
  for (var o = 0, a, h = t.length, l = s.length; o < l; ++o)
    (a = t[o]) ? (a.__data__ = s[o], r[o] = a) : e[o] = new fh(n, s[o]);
  for (; o < h; ++o)
    (a = t[o]) && (i[o] = a);
}
function DC(n, t, e, r, i, s, o) {
  var a, h, l = /* @__PURE__ */ new Map(), u = t.length, c = s.length, d = new Array(u), f;
  for (a = 0; a < u; ++a)
    (h = t[a]) && (d[a] = f = o.call(h, h.__data__, a, t) + "", l.has(f) ? i[a] = h : l.set(f, h));
  for (a = 0; a < c; ++a)
    f = o.call(n, s[a], a, s) + "", (h = l.get(f)) ? (r[a] = h, h.__data__ = s[a], l.delete(f)) : e[a] = new fh(n, s[a]);
  for (a = 0; a < u; ++a)
    (h = t[a]) && l.get(d[a]) === h && (i[a] = h);
}
function FC(n) {
  return n.__data__;
}
function OC(n, t) {
  if (!arguments.length) return Array.from(this, FC);
  var e = t ? DC : RC, r = this._parents, i = this._groups;
  typeof n != "function" && (n = PC(n));
  for (var s = i.length, o = new Array(s), a = new Array(s), h = new Array(s), l = 0; l < s; ++l) {
    var u = r[l], c = i[l], d = c.length, f = NC(n.call(u, u && u.__data__, l, r)), p = f.length, m = a[l] = new Array(p), g = o[l] = new Array(p), _ = h[l] = new Array(d);
    e(u, c, m, g, _, f, t);
    for (var w = 0, v = 0, E, x; w < p; ++w)
      if (E = m[w]) {
        for (w >= v && (v = w + 1); !(x = g[v]) && ++v < p; ) ;
        E._next = x || null;
      }
  }
  return o = new gr(o, r), o._enter = a, o._exit = h, o;
}
function NC(n) {
  return typeof n == "object" && "length" in n ? n : Array.from(n);
}
function kC() {
  return new gr(this._exit || this._groups.map(B_), this._parents);
}
function BC(n, t, e) {
  var r = this.enter(), i = this, s = this.exit();
  return typeof n == "function" ? (r = n(r), r && (r = r.selection())) : r = r.append(n + ""), t != null && (i = t(i), i && (i = i.selection())), e == null ? s.remove() : e(s), r && i ? r.merge(i).order() : i;
}
function LC(n) {
  for (var t = n.selection ? n.selection() : n, e = this._groups, r = t._groups, i = e.length, s = r.length, o = Math.min(i, s), a = new Array(i), h = 0; h < o; ++h)
    for (var l = e[h], u = r[h], c = l.length, d = a[h] = new Array(c), f, p = 0; p < c; ++p)
      (f = l[p] || u[p]) && (d[p] = f);
  for (; h < i; ++h)
    a[h] = e[h];
  return new gr(a, this._parents);
}
function UC() {
  for (var n = this._groups, t = -1, e = n.length; ++t < e; )
    for (var r = n[t], i = r.length - 1, s = r[i], o; --i >= 0; )
      (o = r[i]) && (s && o.compareDocumentPosition(s) ^ 4 && s.parentNode.insertBefore(o, s), s = o);
  return this;
}
function HC(n) {
  n || (n = GC);
  function t(c, d) {
    return c && d ? n(c.__data__, d.__data__) : !c - !d;
  }
  for (var e = this._groups, r = e.length, i = new Array(r), s = 0; s < r; ++s) {
    for (var o = e[s], a = o.length, h = i[s] = new Array(a), l, u = 0; u < a; ++u)
      (l = o[u]) && (h[u] = l);
    h.sort(t);
  }
  return new gr(i, this._parents).order();
}
function GC(n, t) {
  return n < t ? -1 : n > t ? 1 : n >= t ? 0 : NaN;
}
function zC() {
  var n = arguments[0];
  return arguments[0] = this, n.apply(null, arguments), this;
}
function WC() {
  return Array.from(this);
}
function $C() {
  for (var n = this._groups, t = 0, e = n.length; t < e; ++t)
    for (var r = n[t], i = 0, s = r.length; i < s; ++i) {
      var o = r[i];
      if (o) return o;
    }
  return null;
}
function XC() {
  let n = 0;
  for (const t of this) ++n;
  return n;
}
function VC() {
  return !this.node();
}
function YC(n) {
  for (var t = this._groups, e = 0, r = t.length; e < r; ++e)
    for (var i = t[e], s = 0, o = i.length, a; s < o; ++s)
      (a = i[s]) && n.call(a, a.__data__, s, i);
  return this;
}
function jC(n) {
  return function() {
    this.removeAttribute(n);
  };
}
function qC(n) {
  return function() {
    this.removeAttributeNS(n.space, n.local);
  };
}
function ZC(n, t) {
  return function() {
    this.setAttribute(n, t);
  };
}
function KC(n, t) {
  return function() {
    this.setAttributeNS(n.space, n.local, t);
  };
}
function QC(n, t) {
  return function() {
    var e = t.apply(this, arguments);
    e == null ? this.removeAttribute(n) : this.setAttribute(n, e);
  };
}
function JC(n, t) {
  return function() {
    var e = t.apply(this, arguments);
    e == null ? this.removeAttributeNS(n.space, n.local) : this.setAttributeNS(n.space, n.local, e);
  };
}
function tM(n, t) {
  var e = zh(n);
  if (arguments.length < 2) {
    var r = this.node();
    return e.local ? r.getAttributeNS(e.space, e.local) : r.getAttribute(e);
  }
  return this.each((t == null ? e.local ? qC : jC : typeof t == "function" ? e.local ? JC : QC : e.local ? KC : ZC)(e, t));
}
function L_(n) {
  return n.ownerDocument && n.ownerDocument.defaultView || n.document && n || n.defaultView;
}
function eM(n) {
  return function() {
    this.style.removeProperty(n);
  };
}
function rM(n, t, e) {
  return function() {
    this.style.setProperty(n, t, e);
  };
}
function nM(n, t, e) {
  return function() {
    var r = t.apply(this, arguments);
    r == null ? this.style.removeProperty(n) : this.style.setProperty(n, r, e);
  };
}
function iM(n, t, e) {
  return arguments.length > 1 ? this.each((t == null ? eM : typeof t == "function" ? nM : rM)(n, t, e ?? "")) : ys(this.node(), n);
}
function ys(n, t) {
  return n.style.getPropertyValue(t) || L_(n).getComputedStyle(n, null).getPropertyValue(t);
}
function sM(n) {
  return function() {
    delete this[n];
  };
}
function oM(n, t) {
  return function() {
    this[n] = t;
  };
}
function aM(n, t) {
  return function() {
    var e = t.apply(this, arguments);
    e == null ? delete this[n] : this[n] = e;
  };
}
function hM(n, t) {
  return arguments.length > 1 ? this.each((t == null ? sM : typeof t == "function" ? aM : oM)(n, t)) : this.node()[n];
}
function U_(n) {
  return n.trim().split(/^|\s+/);
}
function Ld(n) {
  return n.classList || new H_(n);
}
function H_(n) {
  this._node = n, this._names = U_(n.getAttribute("class") || "");
}
H_.prototype = {
  add: function(n) {
    var t = this._names.indexOf(n);
    t < 0 && (this._names.push(n), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(n) {
    var t = this._names.indexOf(n);
    t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(n) {
    return this._names.indexOf(n) >= 0;
  }
};
function G_(n, t) {
  for (var e = Ld(n), r = -1, i = t.length; ++r < i; ) e.add(t[r]);
}
function z_(n, t) {
  for (var e = Ld(n), r = -1, i = t.length; ++r < i; ) e.remove(t[r]);
}
function lM(n) {
  return function() {
    G_(this, n);
  };
}
function uM(n) {
  return function() {
    z_(this, n);
  };
}
function cM(n, t) {
  return function() {
    (t.apply(this, arguments) ? G_ : z_)(this, n);
  };
}
function dM(n, t) {
  var e = U_(n + "");
  if (arguments.length < 2) {
    for (var r = Ld(this.node()), i = -1, s = e.length; ++i < s; ) if (!r.contains(e[i])) return !1;
    return !0;
  }
  return this.each((typeof t == "function" ? cM : t ? lM : uM)(e, t));
}
function fM() {
  this.textContent = "";
}
function pM(n) {
  return function() {
    this.textContent = n;
  };
}
function mM(n) {
  return function() {
    var t = n.apply(this, arguments);
    this.textContent = t ?? "";
  };
}
function gM(n) {
  return arguments.length ? this.each(n == null ? fM : (typeof n == "function" ? mM : pM)(n)) : this.node().textContent;
}
function yM() {
  this.innerHTML = "";
}
function _M(n) {
  return function() {
    this.innerHTML = n;
  };
}
function vM(n) {
  return function() {
    var t = n.apply(this, arguments);
    this.innerHTML = t ?? "";
  };
}
function xM(n) {
  return arguments.length ? this.each(n == null ? yM : (typeof n == "function" ? vM : _M)(n)) : this.node().innerHTML;
}
function wM() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function bM() {
  return this.each(wM);
}
function TM() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function AM() {
  return this.each(TM);
}
function EM(n) {
  var t = typeof n == "function" ? n : F_(n);
  return this.select(function() {
    return this.appendChild(t.apply(this, arguments));
  });
}
function SM() {
  return null;
}
function CM(n, t) {
  var e = typeof n == "function" ? n : F_(n), r = t == null ? SM : typeof t == "function" ? t : Bd(t);
  return this.select(function() {
    return this.insertBefore(e.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function MM() {
  var n = this.parentNode;
  n && n.removeChild(this);
}
function IM() {
  return this.each(MM);
}
function PM() {
  var n = this.cloneNode(!1), t = this.parentNode;
  return t ? t.insertBefore(n, this.nextSibling) : n;
}
function RM() {
  var n = this.cloneNode(!0), t = this.parentNode;
  return t ? t.insertBefore(n, this.nextSibling) : n;
}
function DM(n) {
  return this.select(n ? RM : PM);
}
function FM(n) {
  return arguments.length ? this.property("__data__", n) : this.node().__data__;
}
function OM(n) {
  return function(t) {
    n.call(this, t, this.__data__);
  };
}
function NM(n) {
  return n.trim().split(/^|\s+/).map(function(t) {
    var e = "", r = t.indexOf(".");
    return r >= 0 && (e = t.slice(r + 1), t = t.slice(0, r)), { type: t, name: e };
  });
}
function kM(n) {
  return function() {
    var t = this.__on;
    if (t) {
      for (var e = 0, r = -1, i = t.length, s; e < i; ++e)
        s = t[e], (!n.type || s.type === n.type) && s.name === n.name ? this.removeEventListener(s.type, s.listener, s.options) : t[++r] = s;
      ++r ? t.length = r : delete this.__on;
    }
  };
}
function BM(n, t, e) {
  return function() {
    var r = this.__on, i, s = OM(t);
    if (r) {
      for (var o = 0, a = r.length; o < a; ++o)
        if ((i = r[o]).type === n.type && i.name === n.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = s, i.options = e), i.value = t;
          return;
        }
    }
    this.addEventListener(n.type, s, e), i = { type: n.type, name: n.name, value: t, listener: s, options: e }, r ? r.push(i) : this.__on = [i];
  };
}
function LM(n, t, e) {
  var r = NM(n + ""), i, s = r.length, o;
  if (arguments.length < 2) {
    var a = this.node().__on;
    if (a) {
      for (var h = 0, l = a.length, u; h < l; ++h)
        for (i = 0, u = a[h]; i < s; ++i)
          if ((o = r[i]).type === u.type && o.name === u.name)
            return u.value;
    }
    return;
  }
  for (a = t ? BM : kM, i = 0; i < s; ++i) this.each(a(r[i], t, e));
  return this;
}
function W_(n, t, e) {
  var r = L_(n), i = r.CustomEvent;
  typeof i == "function" ? i = new i(t, e) : (i = r.document.createEvent("Event"), e ? (i.initEvent(t, e.bubbles, e.cancelable), i.detail = e.detail) : i.initEvent(t, !1, !1)), n.dispatchEvent(i);
}
function UM(n, t) {
  return function() {
    return W_(this, n, t);
  };
}
function HM(n, t) {
  return function() {
    return W_(this, n, t.apply(this, arguments));
  };
}
function GM(n, t) {
  return this.each((typeof t == "function" ? HM : UM)(n, t));
}
function* zM() {
  for (var n = this._groups, t = 0, e = n.length; t < e; ++t)
    for (var r = n[t], i = 0, s = r.length, o; i < s; ++i)
      (o = r[i]) && (yield o);
}
var WM = [null];
function gr(n, t) {
  this._groups = n, this._parents = t;
}
function Do() {
  return new gr([[document.documentElement]], WM);
}
function $M() {
  return this;
}
gr.prototype = Do.prototype = {
  constructor: gr,
  select: mC,
  selectAll: vC,
  selectChild: TC,
  selectChildren: CC,
  filter: MC,
  data: OC,
  enter: IC,
  exit: kC,
  join: BC,
  merge: LC,
  selection: $M,
  order: UC,
  sort: HC,
  call: zC,
  nodes: WC,
  node: $C,
  size: XC,
  empty: VC,
  each: YC,
  attr: tM,
  style: iM,
  property: hM,
  classed: dM,
  text: gM,
  html: xM,
  raise: bM,
  lower: AM,
  append: EM,
  insert: CM,
  remove: IM,
  clone: DM,
  datum: FM,
  on: LM,
  dispatch: GM,
  [Symbol.iterator]: zM
};
function Ud(n, t, e) {
  n.prototype = t.prototype = e, e.constructor = n;
}
function $_(n, t) {
  var e = Object.create(n.prototype);
  for (var r in t) e[r] = t[r];
  return e;
}
function Fo() {
}
var bo = 0.7, ph = 1 / bo, hs = "\\s*([+-]?\\d+)\\s*", To = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Br = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", XM = /^#([0-9a-f]{3,8})$/, VM = new RegExp(`^rgb\\(${hs},${hs},${hs}\\)$`), YM = new RegExp(`^rgb\\(${Br},${Br},${Br}\\)$`), jM = new RegExp(`^rgba\\(${hs},${hs},${hs},${To}\\)$`), qM = new RegExp(`^rgba\\(${Br},${Br},${Br},${To}\\)$`), ZM = new RegExp(`^hsl\\(${To},${Br},${Br}\\)$`), KM = new RegExp(`^hsla\\(${To},${Br},${Br},${To}\\)$`), Um = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Ud(Fo, Ci, {
  copy(n) {
    return Object.assign(new this.constructor(), this, n);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Hm,
  // Deprecated! Use color.formatHex.
  formatHex: Hm,
  formatHex8: QM,
  formatHsl: JM,
  formatRgb: Gm,
  toString: Gm
});
function Hm() {
  return this.rgb().formatHex();
}
function QM() {
  return this.rgb().formatHex8();
}
function JM() {
  return X_(this).formatHsl();
}
function Gm() {
  return this.rgb().formatRgb();
}
function Ci(n) {
  var t, e;
  return n = (n + "").trim().toLowerCase(), (t = XM.exec(n)) ? (e = t[1].length, t = parseInt(t[1], 16), e === 6 ? zm(t) : e === 3 ? new Ee(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : e === 8 ? _a(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : e === 4 ? _a(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = VM.exec(n)) ? new Ee(t[1], t[2], t[3], 1) : (t = YM.exec(n)) ? new Ee(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = jM.exec(n)) ? _a(t[1], t[2], t[3], t[4]) : (t = qM.exec(n)) ? _a(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = ZM.exec(n)) ? Xm(t[1], t[2] / 100, t[3] / 100, 1) : (t = KM.exec(n)) ? Xm(t[1], t[2] / 100, t[3] / 100, t[4]) : Um.hasOwnProperty(n) ? zm(Um[n]) : n === "transparent" ? new Ee(NaN, NaN, NaN, 0) : null;
}
function zm(n) {
  return new Ee(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function _a(n, t, e, r) {
  return r <= 0 && (n = t = e = NaN), new Ee(n, t, e, r);
}
function tI(n) {
  return n instanceof Fo || (n = Ci(n)), n ? (n = n.rgb(), new Ee(n.r, n.g, n.b, n.opacity)) : new Ee();
}
function Vc(n, t, e, r) {
  return arguments.length === 1 ? tI(n) : new Ee(n, t, e, r ?? 1);
}
function Ee(n, t, e, r) {
  this.r = +n, this.g = +t, this.b = +e, this.opacity = +r;
}
Ud(Ee, Vc, $_(Fo, {
  brighter(n) {
    return n = n == null ? ph : Math.pow(ph, n), new Ee(this.r * n, this.g * n, this.b * n, this.opacity);
  },
  darker(n) {
    return n = n == null ? bo : Math.pow(bo, n), new Ee(this.r * n, this.g * n, this.b * n, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Ee(wi(this.r), wi(this.g), wi(this.b), mh(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Wm,
  // Deprecated! Use color.formatHex.
  formatHex: Wm,
  formatHex8: eI,
  formatRgb: $m,
  toString: $m
}));
function Wm() {
  return `#${pi(this.r)}${pi(this.g)}${pi(this.b)}`;
}
function eI() {
  return `#${pi(this.r)}${pi(this.g)}${pi(this.b)}${pi((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function $m() {
  const n = mh(this.opacity);
  return `${n === 1 ? "rgb(" : "rgba("}${wi(this.r)}, ${wi(this.g)}, ${wi(this.b)}${n === 1 ? ")" : `, ${n})`}`;
}
function mh(n) {
  return isNaN(n) ? 1 : Math.max(0, Math.min(1, n));
}
function wi(n) {
  return Math.max(0, Math.min(255, Math.round(n) || 0));
}
function pi(n) {
  return n = wi(n), (n < 16 ? "0" : "") + n.toString(16);
}
function Xm(n, t, e, r) {
  return r <= 0 ? n = t = e = NaN : e <= 0 || e >= 1 ? n = t = NaN : t <= 0 && (n = NaN), new fr(n, t, e, r);
}
function X_(n) {
  if (n instanceof fr) return new fr(n.h, n.s, n.l, n.opacity);
  if (n instanceof Fo || (n = Ci(n)), !n) return new fr();
  if (n instanceof fr) return n;
  n = n.rgb();
  var t = n.r / 255, e = n.g / 255, r = n.b / 255, i = Math.min(t, e, r), s = Math.max(t, e, r), o = NaN, a = s - i, h = (s + i) / 2;
  return a ? (t === s ? o = (e - r) / a + (e < r) * 6 : e === s ? o = (r - t) / a + 2 : o = (t - e) / a + 4, a /= h < 0.5 ? s + i : 2 - s - i, o *= 60) : a = h > 0 && h < 1 ? 0 : o, new fr(o, a, h, n.opacity);
}
function rI(n, t, e, r) {
  return arguments.length === 1 ? X_(n) : new fr(n, t, e, r ?? 1);
}
function fr(n, t, e, r) {
  this.h = +n, this.s = +t, this.l = +e, this.opacity = +r;
}
Ud(fr, rI, $_(Fo, {
  brighter(n) {
    return n = n == null ? ph : Math.pow(ph, n), new fr(this.h, this.s, this.l * n, this.opacity);
  },
  darker(n) {
    return n = n == null ? bo : Math.pow(bo, n), new fr(this.h, this.s, this.l * n, this.opacity);
  },
  rgb() {
    var n = this.h % 360 + (this.h < 0) * 360, t = isNaN(n) || isNaN(this.s) ? 0 : this.s, e = this.l, r = e + (e < 0.5 ? e : 1 - e) * t, i = 2 * e - r;
    return new Ee(
      Du(n >= 240 ? n - 240 : n + 120, i, r),
      Du(n, i, r),
      Du(n < 120 ? n + 240 : n - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new fr(Vm(this.h), va(this.s), va(this.l), mh(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const n = mh(this.opacity);
    return `${n === 1 ? "hsl(" : "hsla("}${Vm(this.h)}, ${va(this.s) * 100}%, ${va(this.l) * 100}%${n === 1 ? ")" : `, ${n})`}`;
  }
}));
function Vm(n) {
  return n = (n || 0) % 360, n < 0 ? n + 360 : n;
}
function va(n) {
  return Math.max(0, Math.min(1, n || 0));
}
function Du(n, t, e) {
  return (n < 60 ? t + (e - t) * n / 60 : n < 180 ? e : n < 240 ? t + (e - t) * (240 - n) / 60 : t) * 255;
}
const Hd = (n) => () => n;
function nI(n, t) {
  return function(e) {
    return n + e * t;
  };
}
function iI(n, t, e) {
  return n = Math.pow(n, e), t = Math.pow(t, e) - n, e = 1 / e, function(r) {
    return Math.pow(n + r * t, e);
  };
}
function sI(n) {
  return (n = +n) == 1 ? V_ : function(t, e) {
    return e - t ? iI(t, e, n) : Hd(isNaN(t) ? e : t);
  };
}
function V_(n, t) {
  var e = t - n;
  return e ? nI(n, e) : Hd(isNaN(n) ? t : n);
}
const gh = (function n(t) {
  var e = sI(t);
  function r(i, s) {
    var o = e((i = Vc(i)).r, (s = Vc(s)).r), a = e(i.g, s.g), h = e(i.b, s.b), l = V_(i.opacity, s.opacity);
    return function(u) {
      return i.r = o(u), i.g = a(u), i.b = h(u), i.opacity = l(u), i + "";
    };
  }
  return r.gamma = n, r;
})(1);
function oI(n, t) {
  t || (t = []);
  var e = n ? Math.min(t.length, n.length) : 0, r = t.slice(), i;
  return function(s) {
    for (i = 0; i < e; ++i) r[i] = n[i] * (1 - s) + t[i] * s;
    return r;
  };
}
function aI(n) {
  return ArrayBuffer.isView(n) && !(n instanceof DataView);
}
function hI(n, t) {
  var e = t ? t.length : 0, r = n ? Math.min(e, n.length) : 0, i = new Array(r), s = new Array(e), o;
  for (o = 0; o < r; ++o) i[o] = Gd(n[o], t[o]);
  for (; o < e; ++o) s[o] = t[o];
  return function(a) {
    for (o = 0; o < r; ++o) s[o] = i[o](a);
    return s;
  };
}
function lI(n, t) {
  var e = /* @__PURE__ */ new Date();
  return n = +n, t = +t, function(r) {
    return e.setTime(n * (1 - r) + t * r), e;
  };
}
function cr(n, t) {
  return n = +n, t = +t, function(e) {
    return n * (1 - e) + t * e;
  };
}
function uI(n, t) {
  var e = {}, r = {}, i;
  (n === null || typeof n != "object") && (n = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in n ? e[i] = Gd(n[i], t[i]) : r[i] = t[i];
  return function(s) {
    for (i in e) r[i] = e[i](s);
    return r;
  };
}
var Yc = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Fu = new RegExp(Yc.source, "g");
function cI(n) {
  return function() {
    return n;
  };
}
function dI(n) {
  return function(t) {
    return n(t) + "";
  };
}
function Y_(n, t) {
  var e = Yc.lastIndex = Fu.lastIndex = 0, r, i, s, o = -1, a = [], h = [];
  for (n = n + "", t = t + ""; (r = Yc.exec(n)) && (i = Fu.exec(t)); )
    (s = i.index) > e && (s = t.slice(e, s), a[o] ? a[o] += s : a[++o] = s), (r = r[0]) === (i = i[0]) ? a[o] ? a[o] += i : a[++o] = i : (a[++o] = null, h.push({ i: o, x: cr(r, i) })), e = Fu.lastIndex;
  return e < t.length && (s = t.slice(e), a[o] ? a[o] += s : a[++o] = s), a.length < 2 ? h[0] ? dI(h[0].x) : cI(t) : (t = h.length, function(l) {
    for (var u = 0, c; u < t; ++u) a[(c = h[u]).i] = c.x(l);
    return a.join("");
  });
}
function Gd(n, t) {
  var e = typeof t, r;
  return t == null || e === "boolean" ? Hd(t) : (e === "number" ? cr : e === "string" ? (r = Ci(t)) ? (t = r, gh) : Y_ : t instanceof Ci ? gh : t instanceof Date ? lI : aI(t) ? oI : Array.isArray(t) ? hI : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? uI : cr)(n, t);
}
function fI(n, t) {
  return n = +n, t = +t, function(e) {
    return Math.round(n * (1 - e) + t * e);
  };
}
var Ym = 180 / Math.PI, jc = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function j_(n, t, e, r, i, s) {
  var o, a, h;
  return (o = Math.sqrt(n * n + t * t)) && (n /= o, t /= o), (h = n * e + t * r) && (e -= n * h, r -= t * h), (a = Math.sqrt(e * e + r * r)) && (e /= a, r /= a, h /= a), n * r < t * e && (n = -n, t = -t, h = -h, o = -o), {
    translateX: i,
    translateY: s,
    rotate: Math.atan2(t, n) * Ym,
    skewX: Math.atan(h) * Ym,
    scaleX: o,
    scaleY: a
  };
}
var xa;
function pI(n) {
  const t = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(n + "");
  return t.isIdentity ? jc : j_(t.a, t.b, t.c, t.d, t.e, t.f);
}
function mI(n) {
  return n == null || (xa || (xa = document.createElementNS("http://www.w3.org/2000/svg", "g")), xa.setAttribute("transform", n), !(n = xa.transform.baseVal.consolidate())) ? jc : (n = n.matrix, j_(n.a, n.b, n.c, n.d, n.e, n.f));
}
function q_(n, t, e, r) {
  function i(l) {
    return l.length ? l.pop() + " " : "";
  }
  function s(l, u, c, d, f, p) {
    if (l !== c || u !== d) {
      var m = f.push("translate(", null, t, null, e);
      p.push({ i: m - 4, x: cr(l, c) }, { i: m - 2, x: cr(u, d) });
    } else (c || d) && f.push("translate(" + c + t + d + e);
  }
  function o(l, u, c, d) {
    l !== u ? (l - u > 180 ? u += 360 : u - l > 180 && (l += 360), d.push({ i: c.push(i(c) + "rotate(", null, r) - 2, x: cr(l, u) })) : u && c.push(i(c) + "rotate(" + u + r);
  }
  function a(l, u, c, d) {
    l !== u ? d.push({ i: c.push(i(c) + "skewX(", null, r) - 2, x: cr(l, u) }) : u && c.push(i(c) + "skewX(" + u + r);
  }
  function h(l, u, c, d, f, p) {
    if (l !== c || u !== d) {
      var m = f.push(i(f) + "scale(", null, ",", null, ")");
      p.push({ i: m - 4, x: cr(l, c) }, { i: m - 2, x: cr(u, d) });
    } else (c !== 1 || d !== 1) && f.push(i(f) + "scale(" + c + "," + d + ")");
  }
  return function(l, u) {
    var c = [], d = [];
    return l = n(l), u = n(u), s(l.translateX, l.translateY, u.translateX, u.translateY, c, d), o(l.rotate, u.rotate, c, d), a(l.skewX, u.skewX, c, d), h(l.scaleX, l.scaleY, u.scaleX, u.scaleY, c, d), l = u = null, function(f) {
      for (var p = -1, m = d.length, g; ++p < m; ) c[(g = d[p]).i] = g.x(f);
      return c.join("");
    };
  };
}
var gI = q_(pI, "px, ", "px)", "deg)"), yI = q_(mI, ", ", ")", ")"), _s = 0, io = 0, Gs = 0, Z_ = 1e3, yh, so, _h = 0, Mi = 0, Wh = 0, Ao = typeof performance == "object" && performance.now ? performance : Date, K_ = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(n) {
  setTimeout(n, 17);
};
function zd() {
  return Mi || (K_(_I), Mi = Ao.now() + Wh);
}
function _I() {
  Mi = 0;
}
function vh() {
  this._call = this._time = this._next = null;
}
vh.prototype = Q_.prototype = {
  constructor: vh,
  restart: function(n, t, e) {
    if (typeof n != "function") throw new TypeError("callback is not a function");
    e = (e == null ? zd() : +e) + (t == null ? 0 : +t), !this._next && so !== this && (so ? so._next = this : yh = this, so = this), this._call = n, this._time = e, qc();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, qc());
  }
};
function Q_(n, t, e) {
  var r = new vh();
  return r.restart(n, t, e), r;
}
function vI() {
  zd(), ++_s;
  for (var n = yh, t; n; )
    (t = Mi - n._time) >= 0 && n._call.call(void 0, t), n = n._next;
  --_s;
}
function jm() {
  Mi = (_h = Ao.now()) + Wh, _s = io = 0;
  try {
    vI();
  } finally {
    _s = 0, wI(), Mi = 0;
  }
}
function xI() {
  var n = Ao.now(), t = n - _h;
  t > Z_ && (Wh -= t, _h = n);
}
function wI() {
  for (var n, t = yh, e, r = 1 / 0; t; )
    t._call ? (r > t._time && (r = t._time), n = t, t = t._next) : (e = t._next, t._next = null, t = n ? n._next = e : yh = e);
  so = n, qc(r);
}
function qc(n) {
  if (!_s) {
    io && (io = clearTimeout(io));
    var t = n - Mi;
    t > 24 ? (n < 1 / 0 && (io = setTimeout(jm, n - Ao.now() - Wh)), Gs && (Gs = clearInterval(Gs))) : (Gs || (_h = Ao.now(), Gs = setInterval(xI, Z_)), _s = 1, K_(jm));
  }
}
function qm(n, t, e) {
  var r = new vh();
  return t = t == null ? 0 : +t, r.restart((i) => {
    r.stop(), n(i + t);
  }, t, e), r;
}
var bI = D_("start", "end", "cancel", "interrupt"), TI = [], J_ = 0, Zm = 1, Zc = 2, Ua = 3, Km = 4, Kc = 5, Ha = 6;
function $h(n, t, e, r, i, s) {
  var o = n.__transition;
  if (!o) n.__transition = {};
  else if (e in o) return;
  AI(n, e, {
    name: t,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: bI,
    tween: TI,
    time: s.time,
    delay: s.delay,
    duration: s.duration,
    ease: s.ease,
    timer: null,
    state: J_
  });
}
function Wd(n, t) {
  var e = _r(n, t);
  if (e.state > J_) throw new Error("too late; already scheduled");
  return e;
}
function Gr(n, t) {
  var e = _r(n, t);
  if (e.state > Ua) throw new Error("too late; already running");
  return e;
}
function _r(n, t) {
  var e = n.__transition;
  if (!e || !(e = e[t])) throw new Error("transition not found");
  return e;
}
function AI(n, t, e) {
  var r = n.__transition, i;
  r[t] = e, e.timer = Q_(s, 0, e.time);
  function s(l) {
    e.state = Zm, e.timer.restart(o, e.delay, e.time), e.delay <= l && o(l - e.delay);
  }
  function o(l) {
    var u, c, d, f;
    if (e.state !== Zm) return h();
    for (u in r)
      if (f = r[u], f.name === e.name) {
        if (f.state === Ua) return qm(o);
        f.state === Km ? (f.state = Ha, f.timer.stop(), f.on.call("interrupt", n, n.__data__, f.index, f.group), delete r[u]) : +u < t && (f.state = Ha, f.timer.stop(), f.on.call("cancel", n, n.__data__, f.index, f.group), delete r[u]);
      }
    if (qm(function() {
      e.state === Ua && (e.state = Km, e.timer.restart(a, e.delay, e.time), a(l));
    }), e.state = Zc, e.on.call("start", n, n.__data__, e.index, e.group), e.state === Zc) {
      for (e.state = Ua, i = new Array(d = e.tween.length), u = 0, c = -1; u < d; ++u)
        (f = e.tween[u].value.call(n, n.__data__, e.index, e.group)) && (i[++c] = f);
      i.length = c + 1;
    }
  }
  function a(l) {
    for (var u = l < e.duration ? e.ease.call(null, l / e.duration) : (e.timer.restart(h), e.state = Kc, 1), c = -1, d = i.length; ++c < d; )
      i[c].call(n, u);
    e.state === Kc && (e.on.call("end", n, n.__data__, e.index, e.group), h());
  }
  function h() {
    e.state = Ha, e.timer.stop(), delete r[t];
    for (var l in r) return;
    delete n.__transition;
  }
}
function EI(n, t) {
  var e = n.__transition, r, i, s = !0, o;
  if (e) {
    t = t == null ? null : t + "";
    for (o in e) {
      if ((r = e[o]).name !== t) {
        s = !1;
        continue;
      }
      i = r.state > Zc && r.state < Kc, r.state = Ha, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", n, n.__data__, r.index, r.group), delete e[o];
    }
    s && delete n.__transition;
  }
}
function SI(n) {
  return this.each(function() {
    EI(this, n);
  });
}
function CI(n, t) {
  var e, r;
  return function() {
    var i = Gr(this, n), s = i.tween;
    if (s !== e) {
      r = e = s;
      for (var o = 0, a = r.length; o < a; ++o)
        if (r[o].name === t) {
          r = r.slice(), r.splice(o, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function MI(n, t, e) {
  var r, i;
  if (typeof e != "function") throw new Error();
  return function() {
    var s = Gr(this, n), o = s.tween;
    if (o !== r) {
      i = (r = o).slice();
      for (var a = { name: t, value: e }, h = 0, l = i.length; h < l; ++h)
        if (i[h].name === t) {
          i[h] = a;
          break;
        }
      h === l && i.push(a);
    }
    s.tween = i;
  };
}
function II(n, t) {
  var e = this._id;
  if (n += "", arguments.length < 2) {
    for (var r = _r(this.node(), e).tween, i = 0, s = r.length, o; i < s; ++i)
      if ((o = r[i]).name === n)
        return o.value;
    return null;
  }
  return this.each((t == null ? CI : MI)(e, n, t));
}
function $d(n, t, e) {
  var r = n._id;
  return n.each(function() {
    var i = Gr(this, r);
    (i.value || (i.value = {}))[t] = e.apply(this, arguments);
  }), function(i) {
    return _r(i, r).value[t];
  };
}
function tv(n, t) {
  var e;
  return (typeof t == "number" ? cr : t instanceof Ci ? gh : (e = Ci(t)) ? (t = e, gh) : Y_)(n, t);
}
function PI(n) {
  return function() {
    this.removeAttribute(n);
  };
}
function RI(n) {
  return function() {
    this.removeAttributeNS(n.space, n.local);
  };
}
function DI(n, t, e) {
  var r, i = e + "", s;
  return function() {
    var o = this.getAttribute(n);
    return o === i ? null : o === r ? s : s = t(r = o, e);
  };
}
function FI(n, t, e) {
  var r, i = e + "", s;
  return function() {
    var o = this.getAttributeNS(n.space, n.local);
    return o === i ? null : o === r ? s : s = t(r = o, e);
  };
}
function OI(n, t, e) {
  var r, i, s;
  return function() {
    var o, a = e(this), h;
    return a == null ? void this.removeAttribute(n) : (o = this.getAttribute(n), h = a + "", o === h ? null : o === r && h === i ? s : (i = h, s = t(r = o, a)));
  };
}
function NI(n, t, e) {
  var r, i, s;
  return function() {
    var o, a = e(this), h;
    return a == null ? void this.removeAttributeNS(n.space, n.local) : (o = this.getAttributeNS(n.space, n.local), h = a + "", o === h ? null : o === r && h === i ? s : (i = h, s = t(r = o, a)));
  };
}
function kI(n, t) {
  var e = zh(n), r = e === "transform" ? yI : tv;
  return this.attrTween(n, typeof t == "function" ? (e.local ? NI : OI)(e, r, $d(this, "attr." + n, t)) : t == null ? (e.local ? RI : PI)(e) : (e.local ? FI : DI)(e, r, t));
}
function BI(n, t) {
  return function(e) {
    this.setAttribute(n, t.call(this, e));
  };
}
function LI(n, t) {
  return function(e) {
    this.setAttributeNS(n.space, n.local, t.call(this, e));
  };
}
function UI(n, t) {
  var e, r;
  function i() {
    var s = t.apply(this, arguments);
    return s !== r && (e = (r = s) && LI(n, s)), e;
  }
  return i._value = t, i;
}
function HI(n, t) {
  var e, r;
  function i() {
    var s = t.apply(this, arguments);
    return s !== r && (e = (r = s) && BI(n, s)), e;
  }
  return i._value = t, i;
}
function GI(n, t) {
  var e = "attr." + n;
  if (arguments.length < 2) return (e = this.tween(e)) && e._value;
  if (t == null) return this.tween(e, null);
  if (typeof t != "function") throw new Error();
  var r = zh(n);
  return this.tween(e, (r.local ? UI : HI)(r, t));
}
function zI(n, t) {
  return function() {
    Wd(this, n).delay = +t.apply(this, arguments);
  };
}
function WI(n, t) {
  return t = +t, function() {
    Wd(this, n).delay = t;
  };
}
function $I(n) {
  var t = this._id;
  return arguments.length ? this.each((typeof n == "function" ? zI : WI)(t, n)) : _r(this.node(), t).delay;
}
function XI(n, t) {
  return function() {
    Gr(this, n).duration = +t.apply(this, arguments);
  };
}
function VI(n, t) {
  return t = +t, function() {
    Gr(this, n).duration = t;
  };
}
function YI(n) {
  var t = this._id;
  return arguments.length ? this.each((typeof n == "function" ? XI : VI)(t, n)) : _r(this.node(), t).duration;
}
function jI(n, t) {
  if (typeof t != "function") throw new Error();
  return function() {
    Gr(this, n).ease = t;
  };
}
function qI(n) {
  var t = this._id;
  return arguments.length ? this.each(jI(t, n)) : _r(this.node(), t).ease;
}
function ZI(n, t) {
  return function() {
    var e = t.apply(this, arguments);
    if (typeof e != "function") throw new Error();
    Gr(this, n).ease = e;
  };
}
function KI(n) {
  if (typeof n != "function") throw new Error();
  return this.each(ZI(this._id, n));
}
function QI(n) {
  typeof n != "function" && (n = N_(n));
  for (var t = this._groups, e = t.length, r = new Array(e), i = 0; i < e; ++i)
    for (var s = t[i], o = s.length, a = r[i] = [], h, l = 0; l < o; ++l)
      (h = s[l]) && n.call(h, h.__data__, l, s) && a.push(h);
  return new ln(r, this._parents, this._name, this._id);
}
function JI(n) {
  if (n._id !== this._id) throw new Error();
  for (var t = this._groups, e = n._groups, r = t.length, i = e.length, s = Math.min(r, i), o = new Array(r), a = 0; a < s; ++a)
    for (var h = t[a], l = e[a], u = h.length, c = o[a] = new Array(u), d, f = 0; f < u; ++f)
      (d = h[f] || l[f]) && (c[f] = d);
  for (; a < r; ++a)
    o[a] = t[a];
  return new ln(o, this._parents, this._name, this._id);
}
function tP(n) {
  return (n + "").trim().split(/^|\s+/).every(function(t) {
    var e = t.indexOf(".");
    return e >= 0 && (t = t.slice(0, e)), !t || t === "start";
  });
}
function eP(n, t, e) {
  var r, i, s = tP(t) ? Wd : Gr;
  return function() {
    var o = s(this, n), a = o.on;
    a !== r && (i = (r = a).copy()).on(t, e), o.on = i;
  };
}
function rP(n, t) {
  var e = this._id;
  return arguments.length < 2 ? _r(this.node(), e).on.on(n) : this.each(eP(e, n, t));
}
function nP(n) {
  return function() {
    var t = this.parentNode;
    for (var e in this.__transition) if (+e !== n) return;
    t && t.removeChild(this);
  };
}
function iP() {
  return this.on("end.remove", nP(this._id));
}
function sP(n) {
  var t = this._name, e = this._id;
  typeof n != "function" && (n = Bd(n));
  for (var r = this._groups, i = r.length, s = new Array(i), o = 0; o < i; ++o)
    for (var a = r[o], h = a.length, l = s[o] = new Array(h), u, c, d = 0; d < h; ++d)
      (u = a[d]) && (c = n.call(u, u.__data__, d, a)) && ("__data__" in u && (c.__data__ = u.__data__), l[d] = c, $h(l[d], t, e, d, l, _r(u, e)));
  return new ln(s, this._parents, t, e);
}
function oP(n) {
  var t = this._name, e = this._id;
  typeof n != "function" && (n = O_(n));
  for (var r = this._groups, i = r.length, s = [], o = [], a = 0; a < i; ++a)
    for (var h = r[a], l = h.length, u, c = 0; c < l; ++c)
      if (u = h[c]) {
        for (var d = n.call(u, u.__data__, c, h), f, p = _r(u, e), m = 0, g = d.length; m < g; ++m)
          (f = d[m]) && $h(f, t, e, m, d, p);
        s.push(d), o.push(u);
      }
  return new ln(s, o, t, e);
}
var aP = Do.prototype.constructor;
function hP() {
  return new aP(this._groups, this._parents);
}
function lP(n, t) {
  var e, r, i;
  return function() {
    var s = ys(this, n), o = (this.style.removeProperty(n), ys(this, n));
    return s === o ? null : s === e && o === r ? i : i = t(e = s, r = o);
  };
}
function ev(n) {
  return function() {
    this.style.removeProperty(n);
  };
}
function uP(n, t, e) {
  var r, i = e + "", s;
  return function() {
    var o = ys(this, n);
    return o === i ? null : o === r ? s : s = t(r = o, e);
  };
}
function cP(n, t, e) {
  var r, i, s;
  return function() {
    var o = ys(this, n), a = e(this), h = a + "";
    return a == null && (h = a = (this.style.removeProperty(n), ys(this, n))), o === h ? null : o === r && h === i ? s : (i = h, s = t(r = o, a));
  };
}
function dP(n, t) {
  var e, r, i, s = "style." + t, o = "end." + s, a;
  return function() {
    var h = Gr(this, n), l = h.on, u = h.value[s] == null ? a || (a = ev(t)) : void 0;
    (l !== e || i !== u) && (r = (e = l).copy()).on(o, i = u), h.on = r;
  };
}
function fP(n, t, e) {
  var r = (n += "") == "transform" ? gI : tv;
  return t == null ? this.styleTween(n, lP(n, r)).on("end.style." + n, ev(n)) : typeof t == "function" ? this.styleTween(n, cP(n, r, $d(this, "style." + n, t))).each(dP(this._id, n)) : this.styleTween(n, uP(n, r, t), e).on("end.style." + n, null);
}
function pP(n, t, e) {
  return function(r) {
    this.style.setProperty(n, t.call(this, r), e);
  };
}
function mP(n, t, e) {
  var r, i;
  function s() {
    var o = t.apply(this, arguments);
    return o !== i && (r = (i = o) && pP(n, o, e)), r;
  }
  return s._value = t, s;
}
function gP(n, t, e) {
  var r = "style." + (n += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (t == null) return this.tween(r, null);
  if (typeof t != "function") throw new Error();
  return this.tween(r, mP(n, t, e ?? ""));
}
function yP(n) {
  return function() {
    this.textContent = n;
  };
}
function _P(n) {
  return function() {
    var t = n(this);
    this.textContent = t ?? "";
  };
}
function vP(n) {
  return this.tween("text", typeof n == "function" ? _P($d(this, "text", n)) : yP(n == null ? "" : n + ""));
}
function xP(n) {
  return function(t) {
    this.textContent = n.call(this, t);
  };
}
function wP(n) {
  var t, e;
  function r() {
    var i = n.apply(this, arguments);
    return i !== e && (t = (e = i) && xP(i)), t;
  }
  return r._value = n, r;
}
function bP(n) {
  var t = "text";
  if (arguments.length < 1) return (t = this.tween(t)) && t._value;
  if (n == null) return this.tween(t, null);
  if (typeof n != "function") throw new Error();
  return this.tween(t, wP(n));
}
function TP() {
  for (var n = this._name, t = this._id, e = rv(), r = this._groups, i = r.length, s = 0; s < i; ++s)
    for (var o = r[s], a = o.length, h, l = 0; l < a; ++l)
      if (h = o[l]) {
        var u = _r(h, t);
        $h(h, n, e, l, o, {
          time: u.time + u.delay + u.duration,
          delay: 0,
          duration: u.duration,
          ease: u.ease
        });
      }
  return new ln(r, this._parents, n, e);
}
function AP() {
  var n, t, e = this, r = e._id, i = e.size();
  return new Promise(function(s, o) {
    var a = { value: o }, h = { value: function() {
      --i === 0 && s();
    } };
    e.each(function() {
      var l = Gr(this, r), u = l.on;
      u !== n && (t = (n = u).copy(), t._.cancel.push(a), t._.interrupt.push(a), t._.end.push(h)), l.on = t;
    }), i === 0 && s();
  });
}
var EP = 0;
function ln(n, t, e, r) {
  this._groups = n, this._parents = t, this._name = e, this._id = r;
}
function rv() {
  return ++EP;
}
var jr = Do.prototype;
ln.prototype = {
  constructor: ln,
  select: sP,
  selectAll: oP,
  selectChild: jr.selectChild,
  selectChildren: jr.selectChildren,
  filter: QI,
  merge: JI,
  selection: hP,
  transition: TP,
  call: jr.call,
  nodes: jr.nodes,
  node: jr.node,
  size: jr.size,
  empty: jr.empty,
  each: jr.each,
  on: rP,
  attr: kI,
  attrTween: GI,
  style: fP,
  styleTween: gP,
  text: vP,
  textTween: bP,
  remove: iP,
  tween: II,
  delay: $I,
  duration: YI,
  ease: qI,
  easeVarying: KI,
  end: AP,
  [Symbol.iterator]: jr[Symbol.iterator]
};
function SP(n) {
  return ((n *= 2) <= 1 ? n * n * n : (n -= 2) * n * n + 2) / 2;
}
var CP = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: SP
};
function MP(n, t) {
  for (var e; !(e = n.__transition) || !(e = e[t]); )
    if (!(n = n.parentNode))
      throw new Error(`transition ${t} not found`);
  return e;
}
function IP(n) {
  var t, e;
  n instanceof ln ? (t = n._id, n = n._name) : (t = rv(), (e = CP).time = zd(), n = n == null ? null : n + "");
  for (var r = this._groups, i = r.length, s = 0; s < i; ++s)
    for (var o = r[s], a = o.length, h, l = 0; l < a; ++l)
      (h = o[l]) && $h(h, n, t, l, o, e || MP(h, t));
  return new ln(r, this._parents, n, t);
}
Do.prototype.interrupt = SI;
Do.prototype.transition = IP;
function PP(n) {
  return Math.abs(n = Math.round(n)) >= 1e21 ? n.toLocaleString("en").replace(/,/g, "") : n.toString(10);
}
function xh(n, t) {
  if ((e = (n = t ? n.toExponential(t - 1) : n.toExponential()).indexOf("e")) < 0) return null;
  var e, r = n.slice(0, e);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +n.slice(e + 1)
  ];
}
function vs(n) {
  return n = xh(Math.abs(n)), n ? n[1] : NaN;
}
function RP(n, t) {
  return function(e, r) {
    for (var i = e.length, s = [], o = 0, a = n[0], h = 0; i > 0 && a > 0 && (h + a + 1 > r && (a = Math.max(1, r - h)), s.push(e.substring(i -= a, i + a)), !((h += a + 1) > r)); )
      a = n[o = (o + 1) % n.length];
    return s.reverse().join(t);
  };
}
function DP(n) {
  return function(t) {
    return t.replace(/[0-9]/g, function(e) {
      return n[+e];
    });
  };
}
var FP = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function wh(n) {
  if (!(t = FP.exec(n))) throw new Error("invalid format: " + n);
  var t;
  return new Xd({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
wh.prototype = Xd.prototype;
function Xd(n) {
  this.fill = n.fill === void 0 ? " " : n.fill + "", this.align = n.align === void 0 ? ">" : n.align + "", this.sign = n.sign === void 0 ? "-" : n.sign + "", this.symbol = n.symbol === void 0 ? "" : n.symbol + "", this.zero = !!n.zero, this.width = n.width === void 0 ? void 0 : +n.width, this.comma = !!n.comma, this.precision = n.precision === void 0 ? void 0 : +n.precision, this.trim = !!n.trim, this.type = n.type === void 0 ? "" : n.type + "";
}
Xd.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function OP(n) {
  t: for (var t = n.length, e = 1, r = -1, i; e < t; ++e)
    switch (n[e]) {
      case ".":
        r = i = e;
        break;
      case "0":
        r === 0 && (r = e), i = e;
        break;
      default:
        if (!+n[e]) break t;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? n.slice(0, r) + n.slice(i + 1) : n;
}
var nv;
function NP(n, t) {
  var e = xh(n, t);
  if (!e) return n + "";
  var r = e[0], i = e[1], s = i - (nv = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
  return s === o ? r : s > o ? r + new Array(s - o + 1).join("0") : s > 0 ? r.slice(0, s) + "." + r.slice(s) : "0." + new Array(1 - s).join("0") + xh(n, Math.max(0, t + s - 1))[0];
}
function Qm(n, t) {
  var e = xh(n, t);
  if (!e) return n + "";
  var r = e[0], i = e[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const Jm = {
  "%": (n, t) => (n * 100).toFixed(t),
  b: (n) => Math.round(n).toString(2),
  c: (n) => n + "",
  d: PP,
  e: (n, t) => n.toExponential(t),
  f: (n, t) => n.toFixed(t),
  g: (n, t) => n.toPrecision(t),
  o: (n) => Math.round(n).toString(8),
  p: (n, t) => Qm(n * 100, t),
  r: Qm,
  s: NP,
  X: (n) => Math.round(n).toString(16).toUpperCase(),
  x: (n) => Math.round(n).toString(16)
};
function tg(n) {
  return n;
}
var eg = Array.prototype.map, rg = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function kP(n) {
  var t = n.grouping === void 0 || n.thousands === void 0 ? tg : RP(eg.call(n.grouping, Number), n.thousands + ""), e = n.currency === void 0 ? "" : n.currency[0] + "", r = n.currency === void 0 ? "" : n.currency[1] + "", i = n.decimal === void 0 ? "." : n.decimal + "", s = n.numerals === void 0 ? tg : DP(eg.call(n.numerals, String)), o = n.percent === void 0 ? "%" : n.percent + "", a = n.minus === void 0 ? "−" : n.minus + "", h = n.nan === void 0 ? "NaN" : n.nan + "";
  function l(c) {
    c = wh(c);
    var d = c.fill, f = c.align, p = c.sign, m = c.symbol, g = c.zero, _ = c.width, w = c.comma, v = c.precision, E = c.trim, x = c.type;
    x === "n" ? (w = !0, x = "g") : Jm[x] || (v === void 0 && (v = 12), E = !0, x = "g"), (g || d === "0" && f === "=") && (g = !0, d = "0", f = "=");
    var b = m === "$" ? e : m === "#" && /[boxX]/.test(x) ? "0" + x.toLowerCase() : "", y = m === "$" ? r : /[%p]/.test(x) ? o : "", C = Jm[x], M = /[defgprs%]/.test(x);
    v = v === void 0 ? 6 : /[gprs]/.test(x) ? Math.max(1, Math.min(21, v)) : Math.max(0, Math.min(20, v));
    function U(F) {
      var O = b, R = y, k, j, T;
      if (x === "c")
        R = C(F) + R, F = "";
      else {
        F = +F;
        var S = F < 0 || 1 / F < 0;
        if (F = isNaN(F) ? h : C(Math.abs(F), v), E && (F = OP(F)), S && +F == 0 && p !== "+" && (S = !1), O = (S ? p === "(" ? p : a : p === "-" || p === "(" ? "" : p) + O, R = (x === "s" ? rg[8 + nv / 3] : "") + R + (S && p === "(" ? ")" : ""), M) {
          for (k = -1, j = F.length; ++k < j; )
            if (T = F.charCodeAt(k), 48 > T || T > 57) {
              R = (T === 46 ? i + F.slice(k + 1) : F.slice(k)) + R, F = F.slice(0, k);
              break;
            }
        }
      }
      w && !g && (F = t(F, 1 / 0));
      var A = O.length + F.length + R.length, L = A < _ ? new Array(_ - A + 1).join(d) : "";
      switch (w && g && (F = t(L + F, L.length ? _ - R.length : 1 / 0), L = ""), f) {
        case "<":
          F = O + F + R + L;
          break;
        case "=":
          F = O + L + F + R;
          break;
        case "^":
          F = L.slice(0, A = L.length >> 1) + O + F + R + L.slice(A);
          break;
        default:
          F = L + O + F + R;
          break;
      }
      return s(F);
    }
    return U.toString = function() {
      return c + "";
    }, U;
  }
  function u(c, d) {
    var f = l((c = wh(c), c.type = "f", c)), p = Math.max(-8, Math.min(8, Math.floor(vs(d) / 3))) * 3, m = Math.pow(10, -p), g = rg[8 + p / 3];
    return function(_) {
      return f(m * _) + g;
    };
  }
  return {
    format: l,
    formatPrefix: u
  };
}
var wa, iv, sv;
BP({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function BP(n) {
  return wa = kP(n), iv = wa.format, sv = wa.formatPrefix, wa;
}
function LP(n) {
  return Math.max(0, -vs(Math.abs(n)));
}
function UP(n, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(vs(t) / 3))) * 3 - vs(Math.abs(n)));
}
function HP(n, t) {
  return n = Math.abs(n), t = Math.abs(t) - n, Math.max(0, vs(t) - vs(n)) + 1;
}
function ov(n, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(n);
      break;
    default:
      this.range(t).domain(n);
      break;
  }
  return this;
}
function GP(n) {
  return function() {
    return n;
  };
}
function zP(n) {
  return +n;
}
var ng = [0, 1];
function Qi(n) {
  return n;
}
function Qc(n, t) {
  return (t -= n = +n) ? function(e) {
    return (e - n) / t;
  } : GP(isNaN(t) ? NaN : 0.5);
}
function WP(n, t) {
  var e;
  return n > t && (e = n, n = t, t = e), function(r) {
    return Math.max(n, Math.min(t, r));
  };
}
function $P(n, t, e) {
  var r = n[0], i = n[1], s = t[0], o = t[1];
  return i < r ? (r = Qc(i, r), s = e(o, s)) : (r = Qc(r, i), s = e(s, o)), function(a) {
    return s(r(a));
  };
}
function XP(n, t, e) {
  var r = Math.min(n.length, t.length) - 1, i = new Array(r), s = new Array(r), o = -1;
  for (n[r] < n[0] && (n = n.slice().reverse(), t = t.slice().reverse()); ++o < r; )
    i[o] = Qc(n[o], n[o + 1]), s[o] = e(t[o], t[o + 1]);
  return function(a) {
    var h = iC(n, a, 1, r) - 1;
    return s[h](i[h](a));
  };
}
function av(n, t) {
  return t.domain(n.domain()).range(n.range()).interpolate(n.interpolate()).clamp(n.clamp()).unknown(n.unknown());
}
function VP() {
  var n = ng, t = ng, e = Gd, r, i, s, o = Qi, a, h, l;
  function u() {
    var d = Math.min(n.length, t.length);
    return o !== Qi && (o = WP(n[0], n[d - 1])), a = d > 2 ? XP : $P, h = l = null, c;
  }
  function c(d) {
    return d == null || isNaN(d = +d) ? s : (h || (h = a(n.map(r), t, e)))(r(o(d)));
  }
  return c.invert = function(d) {
    return o(i((l || (l = a(t, n.map(r), cr)))(d)));
  }, c.domain = function(d) {
    return arguments.length ? (n = Array.from(d, zP), u()) : n.slice();
  }, c.range = function(d) {
    return arguments.length ? (t = Array.from(d), u()) : t.slice();
  }, c.rangeRound = function(d) {
    return t = Array.from(d), e = fI, u();
  }, c.clamp = function(d) {
    return arguments.length ? (o = d ? !0 : Qi, u()) : o !== Qi;
  }, c.interpolate = function(d) {
    return arguments.length ? (e = d, u()) : e;
  }, c.unknown = function(d) {
    return arguments.length ? (s = d, c) : s;
  }, function(d, f) {
    return r = d, i = f, u();
  };
}
function hv() {
  return VP()(Qi, Qi);
}
function YP(n, t, e, r) {
  var i = $c(n, t, e), s;
  switch (r = wh(r ?? ",f"), r.type) {
    case "s": {
      var o = Math.max(Math.abs(n), Math.abs(t));
      return r.precision == null && !isNaN(s = UP(i, o)) && (r.precision = s), sv(r, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(s = HP(i, Math.max(Math.abs(n), Math.abs(t)))) && (r.precision = s - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(s = LP(i)) && (r.precision = s - (r.type === "%") * 2);
      break;
    }
  }
  return iv(r);
}
function jP(n) {
  var t = n.domain;
  return n.ticks = function(e) {
    var r = t();
    return hC(r[0], r[r.length - 1], e ?? 10);
  }, n.tickFormat = function(e, r) {
    var i = t();
    return YP(i[0], i[i.length - 1], e ?? 10, r);
  }, n.nice = function(e) {
    e == null && (e = 10);
    var r = t(), i = 0, s = r.length - 1, o = r[i], a = r[s], h, l, u = 10;
    for (a < o && (l = o, o = a, a = l, l = i, i = s, s = l); u-- > 0; ) {
      if (l = Wc(o, a, e), l === h)
        return r[i] = o, r[s] = a, t(r);
      if (l > 0)
        o = Math.floor(o / l) * l, a = Math.ceil(a / l) * l;
      else if (l < 0)
        o = Math.ceil(o * l) / l, a = Math.floor(a * l) / l;
      else
        break;
      h = l;
    }
    return n;
  }, n;
}
function lv() {
  var n = hv();
  return n.copy = function() {
    return av(n, lv());
  }, ov.apply(n, arguments), jP(n);
}
function qP(n, t) {
  n = n.slice();
  var e = 0, r = n.length - 1, i = n[e], s = n[r], o;
  return s < i && (o = e, e = r, r = o, o = i, i = s, s = o), n[e] = t.floor(i), n[r] = t.ceil(s), n;
}
const Ou = /* @__PURE__ */ new Date(), Nu = /* @__PURE__ */ new Date();
function ie(n, t, e, r) {
  function i(s) {
    return n(s = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+s)), s;
  }
  return i.floor = (s) => (n(s = /* @__PURE__ */ new Date(+s)), s), i.ceil = (s) => (n(s = new Date(s - 1)), t(s, 1), n(s), s), i.round = (s) => {
    const o = i(s), a = i.ceil(s);
    return s - o < a - s ? o : a;
  }, i.offset = (s, o) => (t(s = /* @__PURE__ */ new Date(+s), o == null ? 1 : Math.floor(o)), s), i.range = (s, o, a) => {
    const h = [];
    if (s = i.ceil(s), a = a == null ? 1 : Math.floor(a), !(s < o) || !(a > 0)) return h;
    let l;
    do
      h.push(l = /* @__PURE__ */ new Date(+s)), t(s, a), n(s);
    while (l < s && s < o);
    return h;
  }, i.filter = (s) => ie((o) => {
    if (o >= o) for (; n(o), !s(o); ) o.setTime(o - 1);
  }, (o, a) => {
    if (o >= o)
      if (a < 0) for (; ++a <= 0; )
        for (; t(o, -1), !s(o); )
          ;
      else for (; --a >= 0; )
        for (; t(o, 1), !s(o); )
          ;
  }), e && (i.count = (s, o) => (Ou.setTime(+s), Nu.setTime(+o), n(Ou), n(Nu), Math.floor(e(Ou, Nu))), i.every = (s) => (s = Math.floor(s), !isFinite(s) || !(s > 0) ? null : s > 1 ? i.filter(r ? (o) => r(o) % s === 0 : (o) => i.count(0, o) % s === 0) : i)), i;
}
const bh = ie(() => {
}, (n, t) => {
  n.setTime(+n + t);
}, (n, t) => t - n);
bh.every = (n) => (n = Math.floor(n), !isFinite(n) || !(n > 0) ? null : n > 1 ? ie((t) => {
  t.setTime(Math.floor(t / n) * n);
}, (t, e) => {
  t.setTime(+t + e * n);
}, (t, e) => (e - t) / n) : bh);
bh.range;
const rn = 1e3, tr = rn * 60, nn = tr * 60, un = nn * 24, Vd = un * 7, ig = un * 30, ku = un * 365, Ji = ie((n) => {
  n.setTime(n - n.getMilliseconds());
}, (n, t) => {
  n.setTime(+n + t * rn);
}, (n, t) => (t - n) / rn, (n) => n.getUTCSeconds());
Ji.range;
const Yd = ie((n) => {
  n.setTime(n - n.getMilliseconds() - n.getSeconds() * rn);
}, (n, t) => {
  n.setTime(+n + t * tr);
}, (n, t) => (t - n) / tr, (n) => n.getMinutes());
Yd.range;
const ZP = ie((n) => {
  n.setUTCSeconds(0, 0);
}, (n, t) => {
  n.setTime(+n + t * tr);
}, (n, t) => (t - n) / tr, (n) => n.getUTCMinutes());
ZP.range;
const jd = ie((n) => {
  n.setTime(n - n.getMilliseconds() - n.getSeconds() * rn - n.getMinutes() * tr);
}, (n, t) => {
  n.setTime(+n + t * nn);
}, (n, t) => (t - n) / nn, (n) => n.getHours());
jd.range;
const KP = ie((n) => {
  n.setUTCMinutes(0, 0, 0);
}, (n, t) => {
  n.setTime(+n + t * nn);
}, (n, t) => (t - n) / nn, (n) => n.getUTCHours());
KP.range;
const Oo = ie(
  (n) => n.setHours(0, 0, 0, 0),
  (n, t) => n.setDate(n.getDate() + t),
  (n, t) => (t - n - (t.getTimezoneOffset() - n.getTimezoneOffset()) * tr) / un,
  (n) => n.getDate() - 1
);
Oo.range;
const qd = ie((n) => {
  n.setUTCHours(0, 0, 0, 0);
}, (n, t) => {
  n.setUTCDate(n.getUTCDate() + t);
}, (n, t) => (t - n) / un, (n) => n.getUTCDate() - 1);
qd.range;
const QP = ie((n) => {
  n.setUTCHours(0, 0, 0, 0);
}, (n, t) => {
  n.setUTCDate(n.getUTCDate() + t);
}, (n, t) => (t - n) / un, (n) => Math.floor(n / un));
QP.range;
function Oi(n) {
  return ie((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - n) % 7), t.setHours(0, 0, 0, 0);
  }, (t, e) => {
    t.setDate(t.getDate() + e * 7);
  }, (t, e) => (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * tr) / Vd);
}
const Xh = Oi(0), Th = Oi(1), JP = Oi(2), t3 = Oi(3), xs = Oi(4), e3 = Oi(5), r3 = Oi(6);
Xh.range;
Th.range;
JP.range;
t3.range;
xs.range;
e3.range;
r3.range;
function Ni(n) {
  return ie((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - n) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, e) => {
    t.setUTCDate(t.getUTCDate() + e * 7);
  }, (t, e) => (e - t) / Vd);
}
const uv = Ni(0), Ah = Ni(1), n3 = Ni(2), i3 = Ni(3), ws = Ni(4), s3 = Ni(5), o3 = Ni(6);
uv.range;
Ah.range;
n3.range;
i3.range;
ws.range;
s3.range;
o3.range;
const Zd = ie((n) => {
  n.setDate(1), n.setHours(0, 0, 0, 0);
}, (n, t) => {
  n.setMonth(n.getMonth() + t);
}, (n, t) => t.getMonth() - n.getMonth() + (t.getFullYear() - n.getFullYear()) * 12, (n) => n.getMonth());
Zd.range;
const a3 = ie((n) => {
  n.setUTCDate(1), n.setUTCHours(0, 0, 0, 0);
}, (n, t) => {
  n.setUTCMonth(n.getUTCMonth() + t);
}, (n, t) => t.getUTCMonth() - n.getUTCMonth() + (t.getUTCFullYear() - n.getUTCFullYear()) * 12, (n) => n.getUTCMonth());
a3.range;
const cn = ie((n) => {
  n.setMonth(0, 1), n.setHours(0, 0, 0, 0);
}, (n, t) => {
  n.setFullYear(n.getFullYear() + t);
}, (n, t) => t.getFullYear() - n.getFullYear(), (n) => n.getFullYear());
cn.every = (n) => !isFinite(n = Math.floor(n)) || !(n > 0) ? null : ie((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / n) * n), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, e) => {
  t.setFullYear(t.getFullYear() + e * n);
});
cn.range;
const Ii = ie((n) => {
  n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
}, (n, t) => {
  n.setUTCFullYear(n.getUTCFullYear() + t);
}, (n, t) => t.getUTCFullYear() - n.getUTCFullYear(), (n) => n.getUTCFullYear());
Ii.every = (n) => !isFinite(n = Math.floor(n)) || !(n > 0) ? null : ie((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / n) * n), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCFullYear(t.getUTCFullYear() + e * n);
});
Ii.range;
function h3(n, t, e, r, i, s) {
  const o = [
    [Ji, 1, rn],
    [Ji, 5, 5 * rn],
    [Ji, 15, 15 * rn],
    [Ji, 30, 30 * rn],
    [s, 1, tr],
    [s, 5, 5 * tr],
    [s, 15, 15 * tr],
    [s, 30, 30 * tr],
    [i, 1, nn],
    [i, 3, 3 * nn],
    [i, 6, 6 * nn],
    [i, 12, 12 * nn],
    [r, 1, un],
    [r, 2, 2 * un],
    [e, 1, Vd],
    [t, 1, ig],
    [t, 3, 3 * ig],
    [n, 1, ku]
  ];
  function a(l, u, c) {
    const d = u < l;
    d && ([l, u] = [u, l]);
    const f = c && typeof c.range == "function" ? c : h(l, u, c), p = f ? f.range(l, +u + 1) : [];
    return d ? p.reverse() : p;
  }
  function h(l, u, c) {
    const d = Math.abs(u - l) / c, f = kd(([, , g]) => g).right(o, d);
    if (f === o.length) return n.every($c(l / ku, u / ku, c));
    if (f === 0) return bh.every(Math.max($c(l, u, c), 1));
    const [p, m] = o[d / o[f - 1][2] < o[f][2] / d ? f - 1 : f];
    return p.every(m);
  }
  return [a, h];
}
const [l3, u3] = h3(cn, Zd, Xh, Oo, jd, Yd);
function Bu(n) {
  if (0 <= n.y && n.y < 100) {
    var t = new Date(-1, n.m, n.d, n.H, n.M, n.S, n.L);
    return t.setFullYear(n.y), t;
  }
  return new Date(n.y, n.m, n.d, n.H, n.M, n.S, n.L);
}
function Lu(n) {
  if (0 <= n.y && n.y < 100) {
    var t = new Date(Date.UTC(-1, n.m, n.d, n.H, n.M, n.S, n.L));
    return t.setUTCFullYear(n.y), t;
  }
  return new Date(Date.UTC(n.y, n.m, n.d, n.H, n.M, n.S, n.L));
}
function zs(n, t, e) {
  return { y: n, m: t, d: e, H: 0, M: 0, S: 0, L: 0 };
}
function c3(n) {
  var t = n.dateTime, e = n.date, r = n.time, i = n.periods, s = n.days, o = n.shortDays, a = n.months, h = n.shortMonths, l = Ws(i), u = $s(i), c = Ws(s), d = $s(s), f = Ws(o), p = $s(o), m = Ws(a), g = $s(a), _ = Ws(h), w = $s(h), v = {
    a: S,
    A,
    b: L,
    B: D,
    c: null,
    d: ug,
    e: ug,
    f: O3,
    g: $3,
    G: V3,
    H: R3,
    I: D3,
    j: F3,
    L: cv,
    m: N3,
    M: k3,
    p: P,
    q: N,
    Q: fg,
    s: pg,
    S: B3,
    u: L3,
    U: U3,
    V: H3,
    w: G3,
    W: z3,
    x: null,
    X: null,
    y: W3,
    Y: X3,
    Z: Y3,
    "%": dg
  }, E = {
    a: B,
    A: X,
    b: V,
    B: J,
    c: null,
    d: cg,
    e: cg,
    f: K3,
    g: aR,
    G: lR,
    H: j3,
    I: q3,
    j: Z3,
    L: fv,
    m: Q3,
    M: J3,
    p: tt,
    q: K,
    Q: fg,
    s: pg,
    S: tR,
    u: eR,
    U: rR,
    V: nR,
    w: iR,
    W: sR,
    x: null,
    X: null,
    y: oR,
    Y: hR,
    Z: uR,
    "%": dg
  }, x = {
    a: U,
    A: F,
    b: O,
    B: R,
    c: k,
    d: hg,
    e: hg,
    f: C3,
    g: ag,
    G: og,
    H: lg,
    I: lg,
    j: T3,
    L: S3,
    m: b3,
    M: A3,
    p: M,
    q: w3,
    Q: I3,
    s: P3,
    S: E3,
    u: g3,
    U: y3,
    V: _3,
    w: m3,
    W: v3,
    x: j,
    X: T,
    y: ag,
    Y: og,
    Z: x3,
    "%": M3
  };
  v.x = b(e, v), v.X = b(r, v), v.c = b(t, v), E.x = b(e, E), E.X = b(r, E), E.c = b(t, E);
  function b(G, W) {
    return function(q) {
      var z = [], ot = -1, rt = 0, et = G.length, nt, Et, Dt;
      for (q instanceof Date || (q = /* @__PURE__ */ new Date(+q)); ++ot < et; )
        G.charCodeAt(ot) === 37 && (z.push(G.slice(rt, ot)), (Et = sg[nt = G.charAt(++ot)]) != null ? nt = G.charAt(++ot) : Et = nt === "e" ? " " : "0", (Dt = W[nt]) && (nt = Dt(q, Et)), z.push(nt), rt = ot + 1);
      return z.push(G.slice(rt, ot)), z.join("");
    };
  }
  function y(G, W) {
    return function(q) {
      var z = zs(1900, void 0, 1), ot = C(z, G, q += "", 0), rt, et;
      if (ot != q.length) return null;
      if ("Q" in z) return new Date(z.Q);
      if ("s" in z) return new Date(z.s * 1e3 + ("L" in z ? z.L : 0));
      if (W && !("Z" in z) && (z.Z = 0), "p" in z && (z.H = z.H % 12 + z.p * 12), z.m === void 0 && (z.m = "q" in z ? z.q : 0), "V" in z) {
        if (z.V < 1 || z.V > 53) return null;
        "w" in z || (z.w = 1), "Z" in z ? (rt = Lu(zs(z.y, 0, 1)), et = rt.getUTCDay(), rt = et > 4 || et === 0 ? Ah.ceil(rt) : Ah(rt), rt = qd.offset(rt, (z.V - 1) * 7), z.y = rt.getUTCFullYear(), z.m = rt.getUTCMonth(), z.d = rt.getUTCDate() + (z.w + 6) % 7) : (rt = Bu(zs(z.y, 0, 1)), et = rt.getDay(), rt = et > 4 || et === 0 ? Th.ceil(rt) : Th(rt), rt = Oo.offset(rt, (z.V - 1) * 7), z.y = rt.getFullYear(), z.m = rt.getMonth(), z.d = rt.getDate() + (z.w + 6) % 7);
      } else ("W" in z || "U" in z) && ("w" in z || (z.w = "u" in z ? z.u % 7 : "W" in z ? 1 : 0), et = "Z" in z ? Lu(zs(z.y, 0, 1)).getUTCDay() : Bu(zs(z.y, 0, 1)).getDay(), z.m = 0, z.d = "W" in z ? (z.w + 6) % 7 + z.W * 7 - (et + 5) % 7 : z.w + z.U * 7 - (et + 6) % 7);
      return "Z" in z ? (z.H += z.Z / 100 | 0, z.M += z.Z % 100, Lu(z)) : Bu(z);
    };
  }
  function C(G, W, q, z) {
    for (var ot = 0, rt = W.length, et = q.length, nt, Et; ot < rt; ) {
      if (z >= et) return -1;
      if (nt = W.charCodeAt(ot++), nt === 37) {
        if (nt = W.charAt(ot++), Et = x[nt in sg ? W.charAt(ot++) : nt], !Et || (z = Et(G, q, z)) < 0) return -1;
      } else if (nt != q.charCodeAt(z++))
        return -1;
    }
    return z;
  }
  function M(G, W, q) {
    var z = l.exec(W.slice(q));
    return z ? (G.p = u.get(z[0].toLowerCase()), q + z[0].length) : -1;
  }
  function U(G, W, q) {
    var z = f.exec(W.slice(q));
    return z ? (G.w = p.get(z[0].toLowerCase()), q + z[0].length) : -1;
  }
  function F(G, W, q) {
    var z = c.exec(W.slice(q));
    return z ? (G.w = d.get(z[0].toLowerCase()), q + z[0].length) : -1;
  }
  function O(G, W, q) {
    var z = _.exec(W.slice(q));
    return z ? (G.m = w.get(z[0].toLowerCase()), q + z[0].length) : -1;
  }
  function R(G, W, q) {
    var z = m.exec(W.slice(q));
    return z ? (G.m = g.get(z[0].toLowerCase()), q + z[0].length) : -1;
  }
  function k(G, W, q) {
    return C(G, t, W, q);
  }
  function j(G, W, q) {
    return C(G, e, W, q);
  }
  function T(G, W, q) {
    return C(G, r, W, q);
  }
  function S(G) {
    return o[G.getDay()];
  }
  function A(G) {
    return s[G.getDay()];
  }
  function L(G) {
    return h[G.getMonth()];
  }
  function D(G) {
    return a[G.getMonth()];
  }
  function P(G) {
    return i[+(G.getHours() >= 12)];
  }
  function N(G) {
    return 1 + ~~(G.getMonth() / 3);
  }
  function B(G) {
    return o[G.getUTCDay()];
  }
  function X(G) {
    return s[G.getUTCDay()];
  }
  function V(G) {
    return h[G.getUTCMonth()];
  }
  function J(G) {
    return a[G.getUTCMonth()];
  }
  function tt(G) {
    return i[+(G.getUTCHours() >= 12)];
  }
  function K(G) {
    return 1 + ~~(G.getUTCMonth() / 3);
  }
  return {
    format: function(G) {
      var W = b(G += "", v);
      return W.toString = function() {
        return G;
      }, W;
    },
    parse: function(G) {
      var W = y(G += "", !1);
      return W.toString = function() {
        return G;
      }, W;
    },
    utcFormat: function(G) {
      var W = b(G += "", E);
      return W.toString = function() {
        return G;
      }, W;
    },
    utcParse: function(G) {
      var W = y(G += "", !0);
      return W.toString = function() {
        return G;
      }, W;
    }
  };
}
var sg = { "-": "", _: " ", 0: "0" }, le = /^\s*\d+/, d3 = /^%/, f3 = /[\\^$*+?|[\]().{}]/g;
function Mt(n, t, e) {
  var r = n < 0 ? "-" : "", i = (r ? -n : n) + "", s = i.length;
  return r + (s < e ? new Array(e - s + 1).join(t) + i : i);
}
function p3(n) {
  return n.replace(f3, "\\$&");
}
function Ws(n) {
  return new RegExp("^(?:" + n.map(p3).join("|") + ")", "i");
}
function $s(n) {
  return new Map(n.map((t, e) => [t.toLowerCase(), e]));
}
function m3(n, t, e) {
  var r = le.exec(t.slice(e, e + 1));
  return r ? (n.w = +r[0], e + r[0].length) : -1;
}
function g3(n, t, e) {
  var r = le.exec(t.slice(e, e + 1));
  return r ? (n.u = +r[0], e + r[0].length) : -1;
}
function y3(n, t, e) {
  var r = le.exec(t.slice(e, e + 2));
  return r ? (n.U = +r[0], e + r[0].length) : -1;
}
function _3(n, t, e) {
  var r = le.exec(t.slice(e, e + 2));
  return r ? (n.V = +r[0], e + r[0].length) : -1;
}
function v3(n, t, e) {
  var r = le.exec(t.slice(e, e + 2));
  return r ? (n.W = +r[0], e + r[0].length) : -1;
}
function og(n, t, e) {
  var r = le.exec(t.slice(e, e + 4));
  return r ? (n.y = +r[0], e + r[0].length) : -1;
}
function ag(n, t, e) {
  var r = le.exec(t.slice(e, e + 2));
  return r ? (n.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), e + r[0].length) : -1;
}
function x3(n, t, e) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(e, e + 6));
  return r ? (n.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), e + r[0].length) : -1;
}
function w3(n, t, e) {
  var r = le.exec(t.slice(e, e + 1));
  return r ? (n.q = r[0] * 3 - 3, e + r[0].length) : -1;
}
function b3(n, t, e) {
  var r = le.exec(t.slice(e, e + 2));
  return r ? (n.m = r[0] - 1, e + r[0].length) : -1;
}
function hg(n, t, e) {
  var r = le.exec(t.slice(e, e + 2));
  return r ? (n.d = +r[0], e + r[0].length) : -1;
}
function T3(n, t, e) {
  var r = le.exec(t.slice(e, e + 3));
  return r ? (n.m = 0, n.d = +r[0], e + r[0].length) : -1;
}
function lg(n, t, e) {
  var r = le.exec(t.slice(e, e + 2));
  return r ? (n.H = +r[0], e + r[0].length) : -1;
}
function A3(n, t, e) {
  var r = le.exec(t.slice(e, e + 2));
  return r ? (n.M = +r[0], e + r[0].length) : -1;
}
function E3(n, t, e) {
  var r = le.exec(t.slice(e, e + 2));
  return r ? (n.S = +r[0], e + r[0].length) : -1;
}
function S3(n, t, e) {
  var r = le.exec(t.slice(e, e + 3));
  return r ? (n.L = +r[0], e + r[0].length) : -1;
}
function C3(n, t, e) {
  var r = le.exec(t.slice(e, e + 6));
  return r ? (n.L = Math.floor(r[0] / 1e3), e + r[0].length) : -1;
}
function M3(n, t, e) {
  var r = d3.exec(t.slice(e, e + 1));
  return r ? e + r[0].length : -1;
}
function I3(n, t, e) {
  var r = le.exec(t.slice(e));
  return r ? (n.Q = +r[0], e + r[0].length) : -1;
}
function P3(n, t, e) {
  var r = le.exec(t.slice(e));
  return r ? (n.s = +r[0], e + r[0].length) : -1;
}
function ug(n, t) {
  return Mt(n.getDate(), t, 2);
}
function R3(n, t) {
  return Mt(n.getHours(), t, 2);
}
function D3(n, t) {
  return Mt(n.getHours() % 12 || 12, t, 2);
}
function F3(n, t) {
  return Mt(1 + Oo.count(cn(n), n), t, 3);
}
function cv(n, t) {
  return Mt(n.getMilliseconds(), t, 3);
}
function O3(n, t) {
  return cv(n, t) + "000";
}
function N3(n, t) {
  return Mt(n.getMonth() + 1, t, 2);
}
function k3(n, t) {
  return Mt(n.getMinutes(), t, 2);
}
function B3(n, t) {
  return Mt(n.getSeconds(), t, 2);
}
function L3(n) {
  var t = n.getDay();
  return t === 0 ? 7 : t;
}
function U3(n, t) {
  return Mt(Xh.count(cn(n) - 1, n), t, 2);
}
function dv(n) {
  var t = n.getDay();
  return t >= 4 || t === 0 ? xs(n) : xs.ceil(n);
}
function H3(n, t) {
  return n = dv(n), Mt(xs.count(cn(n), n) + (cn(n).getDay() === 4), t, 2);
}
function G3(n) {
  return n.getDay();
}
function z3(n, t) {
  return Mt(Th.count(cn(n) - 1, n), t, 2);
}
function W3(n, t) {
  return Mt(n.getFullYear() % 100, t, 2);
}
function $3(n, t) {
  return n = dv(n), Mt(n.getFullYear() % 100, t, 2);
}
function X3(n, t) {
  return Mt(n.getFullYear() % 1e4, t, 4);
}
function V3(n, t) {
  var e = n.getDay();
  return n = e >= 4 || e === 0 ? xs(n) : xs.ceil(n), Mt(n.getFullYear() % 1e4, t, 4);
}
function Y3(n) {
  var t = n.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Mt(t / 60 | 0, "0", 2) + Mt(t % 60, "0", 2);
}
function cg(n, t) {
  return Mt(n.getUTCDate(), t, 2);
}
function j3(n, t) {
  return Mt(n.getUTCHours(), t, 2);
}
function q3(n, t) {
  return Mt(n.getUTCHours() % 12 || 12, t, 2);
}
function Z3(n, t) {
  return Mt(1 + qd.count(Ii(n), n), t, 3);
}
function fv(n, t) {
  return Mt(n.getUTCMilliseconds(), t, 3);
}
function K3(n, t) {
  return fv(n, t) + "000";
}
function Q3(n, t) {
  return Mt(n.getUTCMonth() + 1, t, 2);
}
function J3(n, t) {
  return Mt(n.getUTCMinutes(), t, 2);
}
function tR(n, t) {
  return Mt(n.getUTCSeconds(), t, 2);
}
function eR(n) {
  var t = n.getUTCDay();
  return t === 0 ? 7 : t;
}
function rR(n, t) {
  return Mt(uv.count(Ii(n) - 1, n), t, 2);
}
function pv(n) {
  var t = n.getUTCDay();
  return t >= 4 || t === 0 ? ws(n) : ws.ceil(n);
}
function nR(n, t) {
  return n = pv(n), Mt(ws.count(Ii(n), n) + (Ii(n).getUTCDay() === 4), t, 2);
}
function iR(n) {
  return n.getUTCDay();
}
function sR(n, t) {
  return Mt(Ah.count(Ii(n) - 1, n), t, 2);
}
function oR(n, t) {
  return Mt(n.getUTCFullYear() % 100, t, 2);
}
function aR(n, t) {
  return n = pv(n), Mt(n.getUTCFullYear() % 100, t, 2);
}
function hR(n, t) {
  return Mt(n.getUTCFullYear() % 1e4, t, 4);
}
function lR(n, t) {
  var e = n.getUTCDay();
  return n = e >= 4 || e === 0 ? ws(n) : ws.ceil(n), Mt(n.getUTCFullYear() % 1e4, t, 4);
}
function uR() {
  return "+0000";
}
function dg() {
  return "%";
}
function fg(n) {
  return +n;
}
function pg(n) {
  return Math.floor(+n / 1e3);
}
var zi, mv;
cR({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function cR(n) {
  return zi = c3(n), mv = zi.format, zi.parse, zi.utcFormat, zi.utcParse, zi;
}
function dR(n) {
  return new Date(n);
}
function fR(n) {
  return n instanceof Date ? +n : +/* @__PURE__ */ new Date(+n);
}
function gv(n, t, e, r, i, s, o, a, h, l) {
  var u = hv(), c = u.invert, d = u.domain, f = l(".%L"), p = l(":%S"), m = l("%I:%M"), g = l("%I %p"), _ = l("%a %d"), w = l("%b %d"), v = l("%B"), E = l("%Y");
  function x(b) {
    return (h(b) < b ? f : a(b) < b ? p : o(b) < b ? m : s(b) < b ? g : r(b) < b ? i(b) < b ? _ : w : e(b) < b ? v : E)(b);
  }
  return u.invert = function(b) {
    return new Date(c(b));
  }, u.domain = function(b) {
    return arguments.length ? d(Array.from(b, fR)) : d().map(dR);
  }, u.ticks = function(b) {
    var y = d();
    return n(y[0], y[y.length - 1], b ?? 10);
  }, u.tickFormat = function(b, y) {
    return y == null ? x : l(y);
  }, u.nice = function(b) {
    var y = d();
    return (!b || typeof b.range != "function") && (b = t(y[0], y[y.length - 1], b ?? 10)), b ? d(qP(y, b)) : u;
  }, u.copy = function() {
    return av(u, gv(n, t, e, r, i, s, o, a, h, l));
  }, u;
}
function pR() {
  return ov.apply(gv(l3, u3, cn, Zd, Xh, Oo, jd, Yd, Ji, mv).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function oo(n, t, e) {
  this.k = n, this.x = t, this.y = e;
}
oo.prototype = {
  constructor: oo,
  scale: function(n) {
    return n === 1 ? this : new oo(this.k * n, this.x, this.y);
  },
  translate: function(n, t) {
    return n === 0 & t === 0 ? this : new oo(this.k, this.x + this.k * n, this.y + this.k * t);
  },
  apply: function(n) {
    return [n[0] * this.k + this.x, n[1] * this.k + this.y];
  },
  applyX: function(n) {
    return n * this.k + this.x;
  },
  applyY: function(n) {
    return n * this.k + this.y;
  },
  invert: function(n) {
    return [(n[0] - this.x) / this.k, (n[1] - this.y) / this.k];
  },
  invertX: function(n) {
    return (n - this.x) / this.k;
  },
  invertY: function(n) {
    return (n - this.y) / this.k;
  },
  rescaleX: function(n) {
    return n.copy().domain(n.range().map(this.invertX, this).map(n.invert, n));
  },
  rescaleY: function(n) {
    return n.copy().domain(n.range().map(this.invertY, this).map(n.invert, n));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
oo.prototype;
function yv(n) {
  return n.mode === "temporal" || n.mode === "left-aligned" ? mR(n) : gR(n);
}
function mR({ domain: n, range: t }) {
  return pR().domain(n).range(t);
}
function gR({ domain: n, range: t }) {
  return lv().domain(n).range(t);
}
function Jc(n) {
  return {
    mode: ut.horizontal,
    range: dS(),
    domain: fS(n)
  };
}
function yR() {
  return {
    mode: ut.vertical
  };
}
let ls = null;
async function _R() {
  const n = await zr();
  mg(n.start_time), it.on("layoutSettingsUpdated", () => mg(n.start_time));
}
function vR() {
  ls = null;
}
async function nr() {
  return ls || await Re("scaleCreated");
}
async function mg(n) {
  await Kt();
  const t = ls ? "scaleUpdated" : "scaleCreated", e = Jc(n);
  ls = yv(e), it.emit(t, ls);
}
function Dn(n) {
  return "getIds" in n;
}
async function _v({ items: n, createCluster: t }) {
  const e = [...n.values()].sort((o, a) => o.element.x - a.element.x);
  async function r(o) {
    let a, h = null, l = null;
    for (let u = o ?? 0; u < e.length; u++) {
      const c = e[u], d = c.element.x;
      if (c.element.visible = !0, h !== null && a && d < a) {
        l = u;
        break;
      }
      h = u, a = d + c.element.width;
    }
    if (l !== null && h !== null) {
      const u = e[h], c = e[l];
      u.element.visible = !1, c.element.visible = !1;
      const d = await i(u, c);
      d && (e.splice(h, 1, d), e.splice(l, 1)), r(h);
    }
  }
  async function i(o, a) {
    const h = o.getDate(), l = a.getDate(), u = Dn(o) ? o.getIds() : [o.getId()], c = Dn(a) ? a.getIds() : [a.getId()];
    if (!h || !l)
      return console.error("flowRunArtifacts: visible item is missing date"), null;
    let d;
    Dn(o) ? d = o : Dn(a) ? d = a : d = await t();
    const f = [...u, ...c], p = s(f);
    return await d.render({ ids: f, date: p }), d;
  }
  function s(o) {
    const a = o.reduce((u, c) => {
      const f = n.get(c)?.getDate();
      return f && u.push(f.getTime()), u;
    }, []), h = Math.min(...a), l = Math.max(...a);
    return new Date((h + l) / 2);
  }
  await r();
}
async function gg(n) {
  const t = await Qt(), e = await Jt(), r = await Wt(), i = await Kt();
  let s = await nr();
  const o = await h();
  o.element.on("click", (u) => {
    u.stopPropagation();
    const { element: c } = o, d = {
      x: c.position.x,
      y: c.position.y,
      width: c.width,
      height: c.height
    }, f = Dn(o) ? { kind: "events", ids: o.getIds(), occurred: o.getDate(), position: d } : { kind: "event", id: o.getId(), occurred: o.getDate(), position: d };
    dn(f);
  }), it.on("scaleUpdated", (u) => {
    s = u, l();
  }), it.on("viewportMoved", () => l());
  async function a(u) {
    await o.render(u), l();
  }
  async function h() {
    return n.type === "event" ? await P_(n.event) : await R_();
  }
  function l() {
    const u = o.getDate();
    if (!u || i.disableEvents || !ut.isTemporal())
      return;
    const { element: c } = o, f = s(u) * e.scale._x + e.worldTransform.tx - c.width / 2, p = t.screen.height - c.height - r.eventBottomMargin;
    c.position.set(f, p);
  }
  return {
    ...o,
    render: a
  };
}
async function yg(n) {
  const t = await Jt(), e = await Kt();
  let r = await nr();
  const i = await o();
  i.element.on("click", (h) => {
    h.stopPropagation();
    const { element: l } = i, u = l.getGlobalPosition(), c = {
      x: u.x,
      y: u.y,
      width: l.width * t.scale.x,
      height: l.height * t.scale.y
    }, d = Dn(i) ? { kind: "events", ids: i.getIds(), occurred: i.getDate(), position: c } : { kind: "event", id: i.getId(), occurred: i.getDate(), position: c };
    dn(d);
  }), it.on("scaleUpdated", (h) => {
    r = h, a();
  });
  async function s(h) {
    await i.render(h), a();
  }
  async function o() {
    return n.type === "event" ? await P_(n.event) : await R_();
  }
  function a() {
    const h = i.getDate(), { parentStartDate: l } = n;
    if (!h || e.disableEvents || !ut.isTemporal() || !l)
      return;
    const { element: u } = i, d = r(h) - r(l) - u.width / 2, f = -u.height;
    u.position.set(d, f);
  }
  return {
    ...i,
    render: s
  };
}
async function vv({ isRoot: n, parentStartDate: t } = {}) {
  const e = await Kt(), r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), s = [];
  let o = [];
  const a = new bt();
  let h = null;
  it.on("scaleUpdated", () => c());
  async function l(p) {
    if (p && (h = p), !h)
      return;
    const m = [];
    for (const g of h)
      m.push(u(g));
    await Promise.all(m), c();
  }
  async function u(p) {
    if (r.has(p.id))
      return r.get(p.id).render();
    if (i.has(p.id))
      return await i.get(p.id);
    const m = (async () => {
      const g = n ? await gg({ type: "event", event: p }) : await yg({ type: "event", event: p, parentStartDate: t });
      r.set(p.id, g), a.addChild(g.element);
    })();
    return i.set(p.id, m), await m, i.delete(p.id), r.get(p.id).render();
  }
  function c() {
    e.disableEvents || !ut.isTemporal() || d();
  }
  const d = C_(async () => {
    o = [...s], await _v({
      items: r,
      createCluster: f
    });
    for (const p of o)
      p.render();
  }, Rg);
  async function f() {
    if (o.length > 0)
      return o.pop();
    const p = n ? await gg({ type: "cluster" }) : await yg({ type: "cluster", parentStartDate: t });
    return a.addChild(p.element), s.push(p), p;
  }
  return {
    element: a,
    render: l,
    update: c
  };
}
let td = null, us = null;
async function xR() {
  const n = await Qt(), t = await He(), e = await Kt(), r = await zr(), { element: i, render: s, update: o } = await vv({ isRoot: !0 });
  i.zIndex = E1;
  async function a(l) {
    if (!ut.isTemporal() || e.disableEvents) {
      n.stage.removeChild(i);
      return;
    }
    n.stage.addChild(i), await s(l);
  }
  const h = await A_(() => ({
    nodeId: t.runId,
    since: r.start_time,
    until: r.end_time ?? /* @__PURE__ */ new Date()
  }), (l) => {
    const u = us ? "eventDataUpdated" : "eventDataCreated";
    us = l, it.emit(u, us), a(l);
  });
  it.on("configUpdated", () => a()), it.on("viewportMoved", () => o()), it.on("layoutSettingsUpdated", () => a()), td = h.stop, h.start();
}
function wR() {
  td?.(), td = null, us = null;
}
async function bR() {
  return us || await Re("eventDataCreated");
}
async function _g(n) {
  const t = await Qt(), e = await Jt(), r = await Wt(), i = await Kt(), s = await bR();
  let o = await nr(), a = s && s.length > 0;
  const h = await u();
  h.element.on("click", (d) => {
    d.stopPropagation();
    const { element: f } = h, p = f.getGlobalPosition(), m = {
      x: p.x,
      y: p.y,
      width: f.width,
      height: f.height
    }, g = Dn(h) ? { kind: "artifacts", ids: h.getIds(), position: m } : { kind: "artifact", id: h.getId() };
    dn(g);
  }), it.on("scaleUpdated", (d) => {
    o = d, c();
  }), it.on("viewportMoved", () => c()), it.on("eventDataCreated", (d) => {
    a = d.length > 0, c();
  }), it.on("eventDataUpdated", (d) => {
    a = d.length > 0, c();
  });
  async function l(d) {
    if (T_(h)) {
      if (n.type !== "artifact")
        throw new Error(`ArtifactFactory attempted to render a ${n.type}`);
      await h.render(n.artifact);
    } else
      await h.render(d);
    c();
  }
  async function u() {
    return n.type === "artifact" ? await Nd(n.artifact, { cullAtZoomThreshold: !1 }) : await M_();
  }
  function c() {
    const d = h.getDate();
    if (!d || !ut.isTemporal() || i.disableArtifacts)
      return;
    const f = h.getSelected(), { element: p } = h, { eventTargetSize: m, flowStateSelectedBarHeight: g } = r;
    let _ = 0;
    if (f) {
      const { selectedBorderOffset: b, selectedBorderWidth: y } = r;
      _ = b + y * 2;
    }
    const v = o(d) * e.scale._x + e.worldTransform.tx - (p.width - _) / 2, E = a && !i.disableEvents ? m : g, x = t.screen.height - (p.height - _) - E;
    p.position.set(v, x);
  }
  return {
    ...h,
    render: l
  };
}
async function vg(n) {
  const t = await Jt(), e = await Wt(), r = await Kt();
  let i = await nr();
  const s = await a();
  s.element.on("click", (l) => {
    l.stopPropagation();
    const { element: u } = s, c = u.getGlobalPosition(), d = {
      x: c.x,
      y: c.y,
      width: u.width * t.scale.x,
      height: u.height * t.scale.y
    }, f = Dn(s) ? { kind: "artifacts", ids: s.getIds(), position: d } : { kind: "artifact", id: s.getId() };
    dn(f);
  }), it.on("scaleUpdated", (l) => {
    i = l, h();
  });
  async function o(l) {
    if (T_(s)) {
      if (n.type !== "artifact")
        throw new Error(`ArtifactFactory attempted to render a ${n.type}`);
      await s.render(n.artifact);
    } else
      await s.render(l);
    h();
  }
  async function a() {
    return n.type === "artifact" ? await Nd(n.artifact) : await M_();
  }
  function h() {
    const l = s.getDate(), { parentStartDate: u } = n;
    if (!l || !ut.isTemporal() || r.disableArtifacts || !u)
      return;
    const c = s.getSelected(), { element: d } = s;
    let f = 0;
    if (c) {
      const { selectedBorderOffset: _, selectedBorderWidth: w } = e;
      f = _ + w * 2;
    }
    const m = i(l) - i(u) - (d.width - f) / 2, g = -(d.height - f);
    d.position.set(m, g);
  }
  return {
    ...s,
    render: o
  };
}
async function xv({ isRoot: n, parentStartDate: t } = {}) {
  const e = await Kt(), r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), s = [];
  let o = [];
  const a = new bt();
  let h = null;
  async function l(p) {
    if (p && (h = p), !h)
      return;
    const m = [];
    for (const g of h)
      m.push(u(g));
    await Promise.all(m), c();
  }
  async function u(p) {
    if (r.has(p.id))
      return r.get(p.id).render(p);
    i.has(p.id) && await i.get(p.id);
    const m = (async () => {
      const g = n ? await _g({ type: "artifact", artifact: p }) : await vg({ type: "artifact", artifact: p, parentStartDate: t });
      r.set(p.id, g), a.addChild(g.element);
    })();
    return i.set(p.id, m), await m, i.delete(p.id), r.get(p.id).render(p);
  }
  function c() {
    if (!(e.disableArtifacts || !ut.isTemporal())) {
      if (!ut.isTemporal()) {
        a.visible = !1;
        return;
      }
      a.visible = !0, a.position.x = 0, d();
    }
  }
  const d = C_(async () => {
    o = [...s], await _v({
      items: r,
      createCluster: f
    });
    for (const p of o)
      p.render();
  }, Rg);
  async function f() {
    if (o.length > 0)
      return o.pop();
    const p = n ? await _g({ type: "cluster" }) : await vg({ type: "cluster", parentStartDate: t });
    return a.addChild(p.element), s.push(p), p;
  }
  return {
    element: a,
    render: l,
    update: c
  };
}
async function TR(n) {
  const t = await Qt(), e = await Jt(), r = await Wt(), i = await zr();
  let s = await nr();
  const o = new bt(), a = await hn(), h = await hn();
  let l = null, u = !1, c = !1;
  t.stage.addChild(h), o.addChild(a), a.eventMode = "static", a.cursor = "pointer", a.on("mouseover", () => {
    u = !0, d();
  }), a.on("mouseleave", () => {
    u = !1, d();
  }), a.on("click", () => {
    const v = {
      x: a.position.x,
      y: a.position.y,
      width: a.width,
      height: a.height
    };
    dn({ ...n, kind: "state", position: v });
  }), it.on("viewportMoved", () => d()), it.on("scaleUpdated", (v) => {
    s = v, d();
  }), it.on("itemSelected", () => {
    const v = fn({ kind: "state", ...n });
    v !== c && (c = v, u = !1, d());
  }), n.type === "RUNNING" && !i.end_time && g();
  function d(v) {
    const { end: E } = v ?? {};
    if (E && (l = E), i.end_time && _(), !ut.isTemporal()) {
      h.visible = !1, o.visible = !1;
      return;
    }
    const x = f();
    p(x), m(x), h.visible = !0, o.visible = !0;
  }
  function f() {
    const { background: v = "#fff" } = r.state(n), E = Math.max(s(n.timestamp) * e.scale._x + e.worldTransform.tx, 0);
    let x = 0;
    return n.type === "RUNNING" && !i.end_time ? x = s(/* @__PURE__ */ new Date()) * e.scale._x + e.worldTransform.tx - E : l ? x = s(l) * e.scale._x + e.worldTransform.tx - E : x = t.screen.width - E, {
      x: E,
      width: Math.max(x, 0),
      background: v
    };
  }
  function p({ x: v, width: E, background: x }) {
    const { flowStateBarHeight: b, flowStateSelectedBarHeight: y } = r, C = u || c ? y : b;
    a.x = v, a.y = t.screen.height - C, a.width = E, a.height = C, a.tint = x;
  }
  function m({ x: v, width: E, background: x }) {
    if (n.type === "RUNNING") {
      h.visible = !1;
      return;
    }
    const { flowStateBarHeight: b, flowStateAreaAlpha: y } = r;
    h.x = v, h.y = 0, h.width = E, h.height = t.screen.height - b, h.tint = x, h.alpha = y;
  }
  function g() {
    t.ticker.add(w);
  }
  function _() {
    t.ticker.remove(w);
  }
  function w() {
    d();
  }
  return {
    element: o,
    render: d
  };
}
function AR(n) {
  return "isNodesFlowRunStateFactory" in n;
}
async function ER(n) {
  const t = await Qt(), e = await Jt(), r = await Wt(), i = await zr();
  let s = await nr();
  const o = new bt(), a = await hn(), h = await hn();
  let l = null, u = null, c = 0, d = 0, f = !1, p = !1;
  o.visible = !1, o.addChild(h), o.addChild(a), a.eventMode = "static", a.cursor = "pointer", a.on("mouseover", () => {
    f = !0, m();
  }), a.on("mouseleave", () => {
    f = !1, m();
  }), a.on("click", (b) => {
    b.stopPropagation();
    const y = a.getGlobalPosition(), C = {
      x: y.x,
      y: y.y,
      width: a.width * e.scale.x,
      height: a.height * e.scale.y
    };
    dn({ ...n, kind: "state", position: C });
  }), h.eventMode = "none", h.cursor = "default", it.on("scaleUpdated", (b) => {
    s = b, m();
  }), it.on("itemSelected", () => {
    const b = fn({ kind: "state", ...n });
    b !== p && (p = b, f = !1, m());
  }), n.type === "RUNNING" && !i.end_time && v();
  function m(b) {
    const { end: y, parentStartDate: C, width: M, height: U } = b ?? {};
    if (y && (l = y), C && (u = C), M && (c = M), U && (d = U), i.end_time && E(), !ut.isTemporal()) {
      o.visible = !1;
      return;
    }
    if (!u || c <= 0) {
      o.visible = !1;
      return;
    }
    const F = g();
    if (F.width <= 0) {
      o.visible = !1;
      return;
    }
    _(F), w(F), o.visible = !0;
  }
  function g() {
    const { background: b = "#fff" } = r.state(n);
    if (!u)
      return {
        x: 0,
        width: 0,
        background: b
      };
    const y = s(u);
    let C = s(n.timestamp) - y;
    if (C >= c)
      return {
        x: c,
        width: 0,
        background: b
      };
    C < 0 && (C = 0);
    let M = s(l ?? /* @__PURE__ */ new Date()) - y;
    M > c && (M = c);
    const U = Math.max(M - C, 0);
    return {
      x: C,
      width: U,
      background: b
    };
  }
  function _({ x: b, width: y, background: C }) {
    const { flowStateBarHeight: M, flowStateSelectedBarHeight: U } = r, F = f || p ? U : M;
    a.x = b, a.y = d - F, a.width = y, a.height = F, a.tint = C;
  }
  function w({ x: b, width: y, background: C }) {
    const { flowStateBarHeight: M, flowStateAreaAlpha: U, nodeHeight: F } = r, O = F / 2;
    h.x = b, h.y = O, h.width = y, h.height = d - M - O, h.tint = C, h.alpha = U;
  }
  function v() {
    t.ticker.add(x);
  }
  function E() {
    t.ticker.remove(x);
  }
  function x() {
    m();
  }
  return {
    element: o,
    render: m,
    isNodesFlowRunStateFactory: !0
  };
}
function wv({ isRoot: n } = {}) {
  const t = new bt(), e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  let i = null;
  async function s(a, h) {
    if (a && (i = a), !i)
      return;
    const l = [];
    for (let u = 0; u < i.length; u++)
      l.push(o(i[u], u, h));
    await Promise.all(l);
  }
  async function o(a, h, l) {
    const u = i && i.length >= h + 1 && i[h + 1], c = u ? u.timestamp : void 0;
    let d;
    if (r.has(a.id) && await r.get(a.id), e.has(a.id))
      d = e.get(a.id);
    else {
      const f = (async () => {
        const p = n ? await TR(a) : await ER(a);
        e.set(a.id, p), t.addChild(p.element);
      })();
      r.set(a.id, f), await f, r.delete(a.id), d = e.get(a.id);
    }
    AR(d) ? await d.render({ end: c, ...l }) : await d.render(c ? { end: c } : void 0);
  }
  return {
    element: t,
    render: s
  };
}
class bv extends bt {
  updateTransform() {
    this.sortableChildren && this.sortDirty && this.sortChildren(), this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
    for (let t = 0, e = this.children.length; t < e; ++t)
      this.children[t].updateTransform();
  }
  calculateBounds() {
    this._bounds.clear(), this._calculateBounds();
    for (const t of this.children)
      if (t.calculateBounds(), t._mask) {
        const e = t._mask.isMaskData ? t._mask.maskObject : t._mask;
        e ? (e.calculateBounds(), this._bounds.addBoundsMask(t._bounds, e._bounds)) : this._bounds.addBounds(t._bounds);
      } else t.filterArea ? this._bounds.addBoundsArea(t._bounds, t.filterArea) : this._bounds.addBounds(t._bounds);
    this._bounds.updateID = this._boundsID;
  }
}
async function SR(n) {
  const t = new bv(), e = await He(), r = await Wt(), i = await Kt(), { element: s, render: o } = await S_(), { element: a, render: h } = await Gh(), { element: l, render: u } = await E_(), { element: c, render: d } = await Uh(), { element: f, render: p, getSize: m, stopWorker: g } = await Kd(), { element: _, render: w } = await wv(), { element: v, render: E, update: x } = await vv({ parentStartDate: n.start_time }), { element: b, render: y, update: C } = await xv({ parentStartDate: n.start_time });
  let M = !1, U = !1, F = n, O = !1;
  t.sortableChildren = !0, c.zIndex = Dg, s.zIndex = Og, a.zIndex = za, l.zIndex = za, f.zIndex = Fg, v.zIndex = M1, _.zIndex = I1, b.zIndex = P1, c.eventMode = "none", c.cursor = "default";
  const { start: R, stop: k } = await my(F.id, (G) => {
    U = !!G.artifacts && G.artifacts.length > 0, p(G), D(G.states), N(G.artifacts), L();
  }), { start: j, stop: T } = await A_(() => ({
    nodeId: F.id,
    since: F.start_time,
    until: F.end_time ?? /* @__PURE__ */ new Date()
  }), (G) => {
    M = G.length > 0, P(G);
  });
  t.addChild(s), t.addChild(a), t.addChild(l), l.on("click", (G) => {
    G.stopPropagation(), A();
  }), f.position = { x: 0, y: r.nodeHeight + r.nodesPadding }, f.on("rendered", () => {
    No(), tt();
  });
  async function S(G) {
    return F = G, await o(G), await V(), await J(), O && (await D(), await P(), await N(), await L()), t;
  }
  async function A() {
    O ? await X() : await B();
  }
  async function L() {
    const { background: G = "#fff" } = r.node(F), { width: W, height: q } = m(), { height: z } = K(), { nodeBorderRadius: ot } = r, rt = 2;
    c.position = { x: -rt, y: -rt };
    const et = ut.isTemporal() ? z + rt * 2 : q + rt * 2;
    await d({
      width: W + rt * 2,
      height: et,
      stroke: rt,
      radius: [ot, ot, 0, 0],
      color: G
    });
  }
  async function D(G) {
    const { height: W } = K(), { width: q } = s;
    await w(G ?? void 0, {
      parentStartDate: F.start_time,
      width: q,
      height: W
    });
  }
  async function P(G) {
    if (!O || !ut.isTemporal() || i.disableEvents) {
      t.removeChild(v);
      return;
    }
    t.addChild(v);
    const { height: W } = K();
    if (v.position = { x: 0, y: W - r.eventBottomMargin }, G) {
      await E(G);
      return;
    }
    await x();
  }
  async function N(G) {
    if (!O || !ut.isTemporal() || i.disableArtifacts) {
      t.removeChild(b);
      return;
    }
    t.addChild(b);
    const { eventTargetSize: W, flowStateSelectedBarHeight: q } = r, { height: z } = K(), ot = z - (M && !i.disableEvents ? W : q);
    if (b.position = { x: 0, y: ot }, G) {
      await y(G);
      return;
    }
    await C();
  }
  async function B() {
    O = !0, t.addChild(_), t.addChild(f), t.addChild(c), await Promise.all([
      R(),
      j(),
      S(F)
    ]), tt();
  }
  async function X() {
    O = !1, t.removeChild(_), t.removeChild(f), t.removeChild(c), t.removeChild(v), t.removeChild(b), g(), await Promise.all([
      k(),
      T(),
      S(F)
    ]), tt();
  }
  async function V() {
    const G = r.nodeToggleSize, W = r.nodeHeight - G, q = s.width > G, z = await u({
      inside: q,
      isOpen: O
    });
    return z.x = q ? W / 2 : s.width + r.nodePadding, z.y = W / 2, z;
  }
  async function J() {
    const G = await h(F.label), W = e.theme === "dark" ? r.textDefault : r.textInverse, q = r.nodePadding, z = l.x + l.width + q, ot = s.width + q, rt = s.width > z + G.width + q, et = r.nodeHeight / 2 - G.height / 2, nt = rt ? z : Math.max(ot, z);
    return G.position = { x: nt, y: et }, G.tint = rt ? W : r.textDefault, G;
  }
  function tt() {
    O && (D(), P(), N(), L());
    const G = K();
    t.emit("resized", G);
  }
  function K() {
    const G = m(), {
      nodeHeight: W,
      nodesPadding: q,
      eventTargetSize: z,
      eventBottomMargin: ot,
      artifactPaddingY: rt,
      artifactIconSize: et
    } = r, Et = U && ut.isTemporal() && !i.disableArtifacts ? et + rt * 2 : 0, vr = M && ut.isTemporal() && !i.disableEvents ? z + ot : 0, Ge = O ? G.height + Et + vr + q * 2 : 0, ye = O ? G.width : 0;
    return {
      height: W + Ge,
      width: Math.max(ye, t.width)
    };
  }
  return {
    kind: "flow-run",
    element: t,
    bar: s,
    render: S
  };
}
async function CR(n, t) {
  const e = await He(), r = await Wt(), i = new bv(), { element: s, render: o } = await Gh(), { element: a, render: h } = await Uh(), { element: l, render: u } = await S_(), { element: c, render: d } = await E_(), { element: f, render: p, getSize: m, stopWorker: g } = await Kd();
  i.addChild(l), i.addChild(s);
  let _ = !1, w = n, v = t;
  i.sortableChildren = !0, a.zIndex = Dg, l.zIndex = Og, s.zIndex = za, c.zIndex = za, f.zIndex = Fg, a.eventMode = "none", a.cursor = "default", f.position = { x: 0, y: r.nodeHeight + r.nodesPadding }, f.on("rendered", () => {
    No(), O();
  }), c.on("click", (R) => {
    R.stopPropagation(), C();
  });
  async function E(R, k) {
    return w = R, v = k, k && i.addChild(c), await u(R), k && await x(), _ && (k && p(k), await y()), await b(), i;
  }
  async function x() {
    const R = r.nodeToggleSize, k = r.nodeHeight - R, j = l.width > R, T = await d({
      inside: j,
      isOpen: _
    });
    return T.x = j ? k / 2 : l.width + r.nodePadding, T.y = k / 2, T;
  }
  async function b() {
    const R = await o(w.label), k = e.theme === "dark" ? r.textDefault : r.textInverse, j = r.nodePadding, T = c.x + c.width + j, S = l.width + j, A = l.width > T + R.width + j, L = r.nodeHeight / 2 - R.height / 2, D = A ? T : Math.max(S, T);
    return R.position = { x: D, y: L }, R.tint = A ? k : r.textDefault, R;
  }
  async function y() {
    const { background: R = "#fff" } = r.node(w), { width: k, height: j } = m(), { height: T } = F(), { nodeBorderRadius: S } = r, A = 2;
    a.position = { x: -A, y: -A };
    const L = ut.isTemporal() ? T + A * 2 : j + A * 2;
    await h({
      width: k + A * 2,
      height: L,
      stroke: A,
      radius: [S, S, 0, 0],
      color: R
    });
  }
  async function C() {
    _ ? await U() : await M();
  }
  async function M() {
    if (_ = !0, i.addChild(f), i.addChild(a), !v)
      throw new Error("Attempted to open without nested graph data");
    await Promise.all([
      p(v),
      E(w, v)
    ]), O();
  }
  async function U() {
    _ = !1, i.removeChild(f), i.removeChild(a), g(), await E(w, v), O();
  }
  function F() {
    const R = m(), {
      nodeHeight: k,
      nodesPadding: j
    } = r, T = _ ? R.height + j * 2 : 0, S = _ ? R.width : 0;
    return {
      height: k + T,
      width: Math.max(S, i.width)
    };
  }
  function O() {
    _ && y();
    const R = F();
    i.emit("resized", R);
  }
  return {
    kind: "task-run",
    element: i,
    render: E,
    bar: l
  };
}
async function MR(n, t) {
  const e = await He(), r = await Wt(), i = await Qt(), s = await Cv(), o = await Kt();
  let a = null;
  const h = /* @__PURE__ */ new Map(), { animate: l } = await v_(), { element: u, render: c, bar: d } = await U(n, t);
  let f = n, p = t, m = null, g = !1, _ = !1;
  s.add(u), u.eventMode = "static", u.cursor = "pointer", u.name = m1, u.on("click", (R) => {
    R.stopPropagation(), dn({ kind: f.kind, id: f.id });
  }), f.end_time || y(), it.on("itemSelected", () => {
    const R = fn({ kind: f.kind, id: f.id });
    R !== g && (g = R, c(f, p));
  });
  async function w(R, k) {
    f = R, p = k;
    const j = F(R);
    return j === m || (m = j, await Promise.all([
      c(R, k),
      v(R.artifacts)
    ]), R.end_time && C()), u;
  }
  async function v(R) {
    if (!R || (x(), o.disableArtifacts || !ut.isTemporal()))
      return;
    const k = [];
    for (const j of R)
      k.push(E(j));
    await Promise.all(k), b();
  }
  async function E(R) {
    if (h.has(R.id))
      return h.get(R.id).render(R);
    const k = await Nd(R, { enableLocalClickHandling: !0 });
    return h.set(R.id, k), a.addChild(k.element), k.render(R);
  }
  function x() {
    if (ut.isTemporal() && !o.disableArtifacts) {
      a || (a = new bt()), u.addChild(a);
      return;
    }
    a && u.removeChild(a);
  }
  function b() {
    if (!a)
      return;
    const { artifactsGap: R, artifactsNodeOverlap: k } = r;
    let j = 0;
    for (const T of h.values())
      T.element.position.x = j, j += T.element.width + R;
    a.position.y = -a.height + k, a.width < d.width && (a.position.x = d.width - a.width);
  }
  function y() {
    i.ticker.add(M);
  }
  function C() {
    i.ticker.remove(M);
  }
  function M() {
    w(f, p);
  }
  async function U(R, k) {
    const { kind: j } = R;
    switch (j) {
      case "task-run":
        return await CR(R, k);
      case "flow-run":
        return await SR(R);
      default:
        const T = j;
        throw new Error(`switch does not have case for value: ${T}`);
    }
  }
  function F(R) {
    const k = R.end_time ?? /* @__PURE__ */ new Date(), j = R.artifacts?.map((A) => A.type === "progress" ? `${A.id}-${A.data}` : A.id).join("|"), T = !!p;
    return [
      R.state_type,
      k.getTime(),
      ut.horizontal,
      ut.horizontalScaleMultiplier,
      e.theme,
      o.disableArtifacts || j,
      T
    ].join("-");
  }
  function O({ x: R, y: k }) {
    l(u, {
      x: R,
      y: k
    }, !_), _ = !0;
  }
  return {
    element: u,
    render: w,
    bar: d,
    setPosition: O
  };
}
function xg({ gap: n = 0, minimum: t = 0 } = {}) {
  const e = /* @__PURE__ */ new Map();
  function r(u) {
    const c = e.get(u) ?? [];
    return Math.max(...c.values(), ka(t)) + ka(n);
  }
  function i(u) {
    let c = 0;
    for (let d = 0; d < u; d++)
      c += r(d);
    return c;
  }
  function s(u) {
    return i(u + 1) - ka(n);
  }
  function o({ axis: u, nodeId: c, offset: d }) {
    const f = e.get(u) ?? /* @__PURE__ */ new Map();
    f.set(c, d), e.set(u, f);
  }
  function a({ axis: u, nodeId: c }) {
    let d, f;
    for (const [p, m] of e.entries())
      if (m.has(c)) {
        d = p, f = m.get(c);
        break;
      }
    d === u || d === void 0 || f === void 0 || (h({ axis: d, nodeId: c }), o({ axis: u, nodeId: c, offset: f }));
  }
  function h({ axis: u, nodeId: c }) {
    e.get(u)?.delete(c);
  }
  function l() {
    e.clear();
  }
  return {
    getOffset: r,
    getTotalOffset: i,
    getTotalValue: s,
    setOffset: o,
    updateNodeAxis: a,
    removeOffset: h,
    clear: l
  };
}
function IR(n) {
  throw new Error(`switch does not have case for value: ${n}`);
}
const Tv = '(function(){"use strict";function sr(t){throw new Error(`switch does not have case for value: ${t}`)}function Ht(t,n){return t==null||n==null?NaN:t<n?-1:t>n?1:t>=n?0:NaN}function cr(t,n){return t==null||n==null?NaN:n<t?-1:n>t?1:n>=t?0:NaN}function cn(t){let n,e,r;t.length!==2?(n=Ht,e=(u,c)=>Ht(t(u),c),r=(u,c)=>t(u)-c):(n=t===Ht||t===cr?t:fr,e=t,r=t);function i(u,c,s=0,f=u.length){if(s<f){if(n(c,c)!==0)return f;do{const l=s+f>>>1;e(u[l],c)<0?s=l+1:f=l}while(s<f)}return s}function o(u,c,s=0,f=u.length){if(s<f){if(n(c,c)!==0)return f;do{const l=s+f>>>1;e(u[l],c)<=0?s=l+1:f=l}while(s<f)}return s}function a(u,c,s=0,f=u.length){const l=i(u,c,s,f-1);return l>s&&r(u[l-1],c)>-r(u[l],c)?l-1:l}return{left:i,center:a,right:o}}function fr(){return 0}function lr(t){return t===null?NaN:+t}const hr=cn(Ht).right;cn(lr).center;const gr=Math.sqrt(50),dr=Math.sqrt(10),mr=Math.sqrt(2);function Yt(t,n,e){const r=(n-t)/Math.max(0,e),i=Math.floor(Math.log10(r)),o=r/Math.pow(10,i),a=o>=gr?10:o>=dr?5:o>=mr?2:1;let u,c,s;return i<0?(s=Math.pow(10,-i)/a,u=Math.round(t*s),c=Math.round(n*s),u/s<t&&++u,c/s>n&&--c,s=-s):(s=Math.pow(10,i)*a,u=Math.round(t/s),c=Math.round(n/s),u*s<t&&++u,c*s>n&&--c),c<u&&.5<=e&&e<2?Yt(t,n,e*2):[u,c,s]}function pr(t,n,e){if(n=+n,t=+t,e=+e,!(e>0))return[];if(t===n)return[t];const r=n<t,[i,o,a]=r?Yt(n,t,e):Yt(t,n,e);if(!(o>=i))return[];const u=o-i+1,c=new Array(u);if(r)if(a<0)for(let s=0;s<u;++s)c[s]=(o-s)/-a;else for(let s=0;s<u;++s)c[s]=(o-s)*a;else if(a<0)for(let s=0;s<u;++s)c[s]=(i+s)/-a;else for(let s=0;s<u;++s)c[s]=(i+s)*a;return c}function fn(t,n,e){return n=+n,t=+t,e=+e,Yt(t,n,e)[2]}function ln(t,n,e){n=+n,t=+t,e=+e;const r=n<t,i=r?fn(n,t,e):fn(t,n,e);return(r?-1:1)*(i<0?1/-i:i)}var yr={value:()=>{}};function zn(){for(var t=0,n=arguments.length,e={},r;t<n;++t){if(!(r=arguments[t]+"")||r in e||/[\\s.]/.test(r))throw new Error("illegal type: "+r);e[r]=[]}return new Rt(e)}function Rt(t){this._=t}function wr(t,n){return t.trim().split(/^|\\s+/).map(function(e){var r="",i=e.indexOf(".");if(i>=0&&(r=e.slice(i+1),e=e.slice(0,i)),e&&!n.hasOwnProperty(e))throw new Error("unknown type: "+e);return{type:e,name:r}})}Rt.prototype=zn.prototype={constructor:Rt,on:function(t,n){var e=this._,r=wr(t+"",e),i,o=-1,a=r.length;if(arguments.length<2){for(;++o<a;)if((i=(t=r[o]).type)&&(i=vr(e[i],t.name)))return i;return}if(n!=null&&typeof n!="function")throw new Error("invalid callback: "+n);for(;++o<a;)if(i=(t=r[o]).type)e[i]=Xn(e[i],t.name,n);else if(n==null)for(i in e)e[i]=Xn(e[i],t.name,null);return this},copy:function(){var t={},n=this._;for(var e in n)t[e]=n[e].slice();return new Rt(t)},call:function(t,n){if((i=arguments.length-2)>0)for(var e=new Array(i),r=0,i,o;r<i;++r)e[r]=arguments[r+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(o=this._[t],r=0,i=o.length;r<i;++r)o[r].value.apply(n,e)},apply:function(t,n,e){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],i=0,o=r.length;i<o;++i)r[i].value.apply(n,e)}};function vr(t,n){for(var e=0,r=t.length,i;e<r;++e)if((i=t[e]).name===n)return i.value}function Xn(t,n,e){for(var r=0,i=t.length;r<i;++r)if(t[r].name===n){t[r]=yr,t=t.slice(0,r).concat(t.slice(r+1));break}return e!=null&&t.push({name:n,value:e}),t}var hn="http://www.w3.org/1999/xhtml",qn={svg:"http://www.w3.org/2000/svg",xhtml:hn,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"};function It(t){var n=t+="",e=n.indexOf(":");return e>=0&&(n=t.slice(0,e))!=="xmlns"&&(t=t.slice(e+1)),qn.hasOwnProperty(n)?{space:qn[n],local:t}:t}function xr(t){return function(){var n=this.ownerDocument,e=this.namespaceURI;return e===hn&&n.documentElement.namespaceURI===hn?n.createElement(t):n.createElementNS(e,t)}}function _r(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}function Vn(t){var n=It(t);return(n.local?_r:xr)(n)}function Mr(){}function gn(t){return t==null?Mr:function(){return this.querySelector(t)}}function Tr(t){typeof t!="function"&&(t=gn(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var o=n[i],a=o.length,u=r[i]=new Array(a),c,s,f=0;f<a;++f)(c=o[f])&&(s=t.call(c,c.__data__,f,o))&&("__data__"in c&&(s.__data__=c.__data__),u[f]=s);return new X(r,this._parents)}function Nr(t){return t==null?[]:Array.isArray(t)?t:Array.from(t)}function Cr(){return[]}function Bn(t){return t==null?Cr:function(){return this.querySelectorAll(t)}}function br(t){return function(){return Nr(t.apply(this,arguments))}}function Sr(t){typeof t=="function"?t=br(t):t=Bn(t);for(var n=this._groups,e=n.length,r=[],i=[],o=0;o<e;++o)for(var a=n[o],u=a.length,c,s=0;s<u;++s)(c=a[s])&&(r.push(t.call(c,c.__data__,s,a)),i.push(c));return new X(r,i)}function Zn(t){return function(){return this.matches(t)}}function Gn(t){return function(n){return n.matches(t)}}var Dr=Array.prototype.find;function kr(t){return function(){return Dr.call(this.children,t)}}function Ar(){return this.firstElementChild}function Ur(t){return this.select(t==null?Ar:kr(typeof t=="function"?t:Gn(t)))}var Fr=Array.prototype.filter;function $r(){return Array.from(this.children)}function Lr(t){return function(){return Fr.call(this.children,t)}}function Pr(t){return this.selectAll(t==null?$r:Lr(typeof t=="function"?t:Gn(t)))}function Er(t){typeof t!="function"&&(t=Zn(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var o=n[i],a=o.length,u=r[i]=[],c,s=0;s<a;++s)(c=o[s])&&t.call(c,c.__data__,s,o)&&u.push(c);return new X(r,this._parents)}function Qn(t){return new Array(t.length)}function Hr(){return new X(this._enter||this._groups.map(Qn),this._parents)}function Ot(t,n){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=n}Ot.prototype={constructor:Ot,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,n){return this._parent.insertBefore(t,n)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}};function Yr(t){return function(){return t}}function Rr(t,n,e,r,i,o){for(var a=0,u,c=n.length,s=o.length;a<s;++a)(u=n[a])?(u.__data__=o[a],r[a]=u):e[a]=new Ot(t,o[a]);for(;a<c;++a)(u=n[a])&&(i[a]=u)}function Ir(t,n,e,r,i,o,a){var u,c,s=new Map,f=n.length,l=o.length,h=new Array(f),p;for(u=0;u<f;++u)(c=n[u])&&(h[u]=p=a.call(c,c.__data__,u,n)+"",s.has(p)?i[u]=c:s.set(p,c));for(u=0;u<l;++u)p=a.call(t,o[u],u,o)+"",(c=s.get(p))?(r[u]=c,c.__data__=o[u],s.delete(p)):e[u]=new Ot(t,o[u]);for(u=0;u<f;++u)(c=n[u])&&s.get(h[u])===c&&(i[u]=c)}function Or(t){return t.__data__}function Wr(t,n){if(!arguments.length)return Array.from(this,Or);var e=n?Ir:Rr,r=this._parents,i=this._groups;typeof t!="function"&&(t=Yr(t));for(var o=i.length,a=new Array(o),u=new Array(o),c=new Array(o),s=0;s<o;++s){var f=r[s],l=i[s],h=l.length,p=zr(t.call(f,f&&f.__data__,s,r)),x=p.length,b=u[s]=new Array(x),U=a[s]=new Array(x),I=c[s]=new Array(h);e(f,l,b,U,I,p,n);for(var E=0,k=0,H,m;E<x;++E)if(H=b[E]){for(E>=k&&(k=E+1);!(m=U[k])&&++k<x;);H._next=m||null}}return a=new X(a,r),a._enter=u,a._exit=c,a}function zr(t){return typeof t=="object"&&"length"in t?t:Array.from(t)}function Xr(){return new X(this._exit||this._groups.map(Qn),this._parents)}function qr(t,n,e){var r=this.enter(),i=this,o=this.exit();return typeof t=="function"?(r=t(r),r&&(r=r.selection())):r=r.append(t+""),n!=null&&(i=n(i),i&&(i=i.selection())),e==null?o.remove():e(o),r&&i?r.merge(i).order():i}function Vr(t){for(var n=t.selection?t.selection():t,e=this._groups,r=n._groups,i=e.length,o=r.length,a=Math.min(i,o),u=new Array(i),c=0;c<a;++c)for(var s=e[c],f=r[c],l=s.length,h=u[c]=new Array(l),p,x=0;x<l;++x)(p=s[x]||f[x])&&(h[x]=p);for(;c<i;++c)u[c]=e[c];return new X(u,this._parents)}function Br(){for(var t=this._groups,n=-1,e=t.length;++n<e;)for(var r=t[n],i=r.length-1,o=r[i],a;--i>=0;)(a=r[i])&&(o&&a.compareDocumentPosition(o)^4&&o.parentNode.insertBefore(a,o),o=a);return this}function Zr(t){t||(t=Gr);function n(l,h){return l&&h?t(l.__data__,h.__data__):!l-!h}for(var e=this._groups,r=e.length,i=new Array(r),o=0;o<r;++o){for(var a=e[o],u=a.length,c=i[o]=new Array(u),s,f=0;f<u;++f)(s=a[f])&&(c[f]=s);c.sort(n)}return new X(i,this._parents).order()}function Gr(t,n){return t<n?-1:t>n?1:t>=n?0:NaN}function Qr(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this}function Jr(){return Array.from(this)}function Kr(){for(var t=this._groups,n=0,e=t.length;n<e;++n)for(var r=t[n],i=0,o=r.length;i<o;++i){var a=r[i];if(a)return a}return null}function jr(){let t=0;for(const n of this)++t;return t}function ti(){return!this.node()}function ni(t){for(var n=this._groups,e=0,r=n.length;e<r;++e)for(var i=n[e],o=0,a=i.length,u;o<a;++o)(u=i[o])&&t.call(u,u.__data__,o,i);return this}function ei(t){return function(){this.removeAttribute(t)}}function ri(t){return function(){this.removeAttributeNS(t.space,t.local)}}function ii(t,n){return function(){this.setAttribute(t,n)}}function oi(t,n){return function(){this.setAttributeNS(t.space,t.local,n)}}function ai(t,n){return function(){var e=n.apply(this,arguments);e==null?this.removeAttribute(t):this.setAttribute(t,e)}}function ui(t,n){return function(){var e=n.apply(this,arguments);e==null?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,e)}}function si(t,n){var e=It(t);if(arguments.length<2){var r=this.node();return e.local?r.getAttributeNS(e.space,e.local):r.getAttribute(e)}return this.each((n==null?e.local?ri:ei:typeof n=="function"?e.local?ui:ai:e.local?oi:ii)(e,n))}function Jn(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}function ci(t){return function(){this.style.removeProperty(t)}}function fi(t,n,e){return function(){this.style.setProperty(t,n,e)}}function li(t,n,e){return function(){var r=n.apply(this,arguments);r==null?this.style.removeProperty(t):this.style.setProperty(t,r,e)}}function hi(t,n,e){return arguments.length>1?this.each((n==null?ci:typeof n=="function"?li:fi)(t,n,e??"")):lt(this.node(),t)}function lt(t,n){return t.style.getPropertyValue(n)||Jn(t).getComputedStyle(t,null).getPropertyValue(n)}function gi(t){return function(){delete this[t]}}function di(t,n){return function(){this[t]=n}}function mi(t,n){return function(){var e=n.apply(this,arguments);e==null?delete this[t]:this[t]=e}}function pi(t,n){return arguments.length>1?this.each((n==null?gi:typeof n=="function"?mi:di)(t,n)):this.node()[t]}function Kn(t){return t.trim().split(/^|\\s+/)}function dn(t){return t.classList||new jn(t)}function jn(t){this._node=t,this._names=Kn(t.getAttribute("class")||"")}jn.prototype={add:function(t){var n=this._names.indexOf(t);n<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var n=this._names.indexOf(t);n>=0&&(this._names.splice(n,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}};function te(t,n){for(var e=dn(t),r=-1,i=n.length;++r<i;)e.add(n[r])}function ne(t,n){for(var e=dn(t),r=-1,i=n.length;++r<i;)e.remove(n[r])}function yi(t){return function(){te(this,t)}}function wi(t){return function(){ne(this,t)}}function vi(t,n){return function(){(n.apply(this,arguments)?te:ne)(this,t)}}function xi(t,n){var e=Kn(t+"");if(arguments.length<2){for(var r=dn(this.node()),i=-1,o=e.length;++i<o;)if(!r.contains(e[i]))return!1;return!0}return this.each((typeof n=="function"?vi:n?yi:wi)(e,n))}function _i(){this.textContent=""}function Mi(t){return function(){this.textContent=t}}function Ti(t){return function(){var n=t.apply(this,arguments);this.textContent=n??""}}function Ni(t){return arguments.length?this.each(t==null?_i:(typeof t=="function"?Ti:Mi)(t)):this.node().textContent}function Ci(){this.innerHTML=""}function bi(t){return function(){this.innerHTML=t}}function Si(t){return function(){var n=t.apply(this,arguments);this.innerHTML=n??""}}function Di(t){return arguments.length?this.each(t==null?Ci:(typeof t=="function"?Si:bi)(t)):this.node().innerHTML}function ki(){this.nextSibling&&this.parentNode.appendChild(this)}function Ai(){return this.each(ki)}function Ui(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}function Fi(){return this.each(Ui)}function $i(t){var n=typeof t=="function"?t:Vn(t);return this.select(function(){return this.appendChild(n.apply(this,arguments))})}function Li(){return null}function Pi(t,n){var e=typeof t=="function"?t:Vn(t),r=n==null?Li:typeof n=="function"?n:gn(n);return this.select(function(){return this.insertBefore(e.apply(this,arguments),r.apply(this,arguments)||null)})}function Ei(){var t=this.parentNode;t&&t.removeChild(this)}function Hi(){return this.each(Ei)}function Yi(){var t=this.cloneNode(!1),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}function Ri(){var t=this.cloneNode(!0),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}function Ii(t){return this.select(t?Ri:Yi)}function Oi(t){return arguments.length?this.property("__data__",t):this.node().__data__}function Wi(t){return function(n){t.call(this,n,this.__data__)}}function zi(t){return t.trim().split(/^|\\s+/).map(function(n){var e="",r=n.indexOf(".");return r>=0&&(e=n.slice(r+1),n=n.slice(0,r)),{type:n,name:e}})}function Xi(t){return function(){var n=this.__on;if(n){for(var e=0,r=-1,i=n.length,o;e<i;++e)o=n[e],(!t.type||o.type===t.type)&&o.name===t.name?this.removeEventListener(o.type,o.listener,o.options):n[++r]=o;++r?n.length=r:delete this.__on}}}function qi(t,n,e){return function(){var r=this.__on,i,o=Wi(n);if(r){for(var a=0,u=r.length;a<u;++a)if((i=r[a]).type===t.type&&i.name===t.name){this.removeEventListener(i.type,i.listener,i.options),this.addEventListener(i.type,i.listener=o,i.options=e),i.value=n;return}}this.addEventListener(t.type,o,e),i={type:t.type,name:t.name,value:n,listener:o,options:e},r?r.push(i):this.__on=[i]}}function Vi(t,n,e){var r=zi(t+""),i,o=r.length,a;if(arguments.length<2){var u=this.node().__on;if(u){for(var c=0,s=u.length,f;c<s;++c)for(i=0,f=u[c];i<o;++i)if((a=r[i]).type===f.type&&a.name===f.name)return f.value}return}for(u=n?qi:Xi,i=0;i<o;++i)this.each(u(r[i],n,e));return this}function ee(t,n,e){var r=Jn(t),i=r.CustomEvent;typeof i=="function"?i=new i(n,e):(i=r.document.createEvent("Event"),e?(i.initEvent(n,e.bubbles,e.cancelable),i.detail=e.detail):i.initEvent(n,!1,!1)),t.dispatchEvent(i)}function Bi(t,n){return function(){return ee(this,t,n)}}function Zi(t,n){return function(){return ee(this,t,n.apply(this,arguments))}}function Gi(t,n){return this.each((typeof n=="function"?Zi:Bi)(t,n))}function*Qi(){for(var t=this._groups,n=0,e=t.length;n<e;++n)for(var r=t[n],i=0,o=r.length,a;i<o;++i)(a=r[i])&&(yield a)}var Ji=[null];function X(t,n){this._groups=t,this._parents=n}function Nt(){return new X([[document.documentElement]],Ji)}function Ki(){return this}X.prototype=Nt.prototype={constructor:X,select:Tr,selectAll:Sr,selectChild:Ur,selectChildren:Pr,filter:Er,data:Wr,enter:Hr,exit:Xr,join:qr,merge:Vr,selection:Ki,order:Br,sort:Zr,call:Qr,nodes:Jr,node:Kr,size:jr,empty:ti,each:ni,attr:si,style:hi,property:pi,classed:xi,text:Ni,html:Di,raise:Ai,lower:Fi,append:$i,insert:Pi,remove:Hi,clone:Ii,datum:Oi,on:Vi,dispatch:Gi,[Symbol.iterator]:Qi};function mn(t,n,e){t.prototype=n.prototype=e,e.constructor=t}function re(t,n){var e=Object.create(t.prototype);for(var r in n)e[r]=n[r];return e}function Ct(){}var bt=.7,Wt=1/bt,ht="\\\\s*([+-]?\\\\d+)\\\\s*",St="\\\\s*([+-]?(?:\\\\d*\\\\.)?\\\\d+(?:[eE][+-]?\\\\d+)?)\\\\s*",G="\\\\s*([+-]?(?:\\\\d*\\\\.)?\\\\d+(?:[eE][+-]?\\\\d+)?)%\\\\s*",ji=/^#([0-9a-f]{3,8})$/,to=new RegExp(`^rgb\\\\(${ht},${ht},${ht}\\\\)$`),no=new RegExp(`^rgb\\\\(${G},${G},${G}\\\\)$`),eo=new RegExp(`^rgba\\\\(${ht},${ht},${ht},${St}\\\\)$`),ro=new RegExp(`^rgba\\\\(${G},${G},${G},${St}\\\\)$`),io=new RegExp(`^hsl\\\\(${St},${G},${G}\\\\)$`),oo=new RegExp(`^hsla\\\\(${St},${G},${G},${St}\\\\)$`),ie={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};mn(Ct,rt,{copy(t){return Object.assign(new this.constructor,this,t)},displayable(){return this.rgb().displayable()},hex:oe,formatHex:oe,formatHex8:ao,formatHsl:uo,formatRgb:ae,toString:ae});function oe(){return this.rgb().formatHex()}function ao(){return this.rgb().formatHex8()}function uo(){return le(this).formatHsl()}function ae(){return this.rgb().formatRgb()}function rt(t){var n,e;return t=(t+"").trim().toLowerCase(),(n=ji.exec(t))?(e=n[1].length,n=parseInt(n[1],16),e===6?ue(n):e===3?new Y(n>>8&15|n>>4&240,n>>4&15|n&240,(n&15)<<4|n&15,1):e===8?zt(n>>24&255,n>>16&255,n>>8&255,(n&255)/255):e===4?zt(n>>12&15|n>>8&240,n>>8&15|n>>4&240,n>>4&15|n&240,((n&15)<<4|n&15)/255):null):(n=to.exec(t))?new Y(n[1],n[2],n[3],1):(n=no.exec(t))?new Y(n[1]*255/100,n[2]*255/100,n[3]*255/100,1):(n=eo.exec(t))?zt(n[1],n[2],n[3],n[4]):(n=ro.exec(t))?zt(n[1]*255/100,n[2]*255/100,n[3]*255/100,n[4]):(n=io.exec(t))?fe(n[1],n[2]/100,n[3]/100,1):(n=oo.exec(t))?fe(n[1],n[2]/100,n[3]/100,n[4]):ie.hasOwnProperty(t)?ue(ie[t]):t==="transparent"?new Y(NaN,NaN,NaN,0):null}function ue(t){return new Y(t>>16&255,t>>8&255,t&255,1)}function zt(t,n,e,r){return r<=0&&(t=n=e=NaN),new Y(t,n,e,r)}function so(t){return t instanceof Ct||(t=rt(t)),t?(t=t.rgb(),new Y(t.r,t.g,t.b,t.opacity)):new Y}function pn(t,n,e,r){return arguments.length===1?so(t):new Y(t,n,e,r??1)}function Y(t,n,e,r){this.r=+t,this.g=+n,this.b=+e,this.opacity=+r}mn(Y,pn,re(Ct,{brighter(t){return t=t==null?Wt:Math.pow(Wt,t),new Y(this.r*t,this.g*t,this.b*t,this.opacity)},darker(t){return t=t==null?bt:Math.pow(bt,t),new Y(this.r*t,this.g*t,this.b*t,this.opacity)},rgb(){return this},clamp(){return new Y(it(this.r),it(this.g),it(this.b),Xt(this.opacity))},displayable(){return-.5<=this.r&&this.r<255.5&&-.5<=this.g&&this.g<255.5&&-.5<=this.b&&this.b<255.5&&0<=this.opacity&&this.opacity<=1},hex:se,formatHex:se,formatHex8:co,formatRgb:ce,toString:ce}));function se(){return`#${ot(this.r)}${ot(this.g)}${ot(this.b)}`}function co(){return`#${ot(this.r)}${ot(this.g)}${ot(this.b)}${ot((isNaN(this.opacity)?1:this.opacity)*255)}`}function ce(){const t=Xt(this.opacity);return`${t===1?"rgb(":"rgba("}${it(this.r)}, ${it(this.g)}, ${it(this.b)}${t===1?")":`, ${t})`}`}function Xt(t){return isNaN(t)?1:Math.max(0,Math.min(1,t))}function it(t){return Math.max(0,Math.min(255,Math.round(t)||0))}function ot(t){return t=it(t),(t<16?"0":"")+t.toString(16)}function fe(t,n,e,r){return r<=0?t=n=e=NaN:e<=0||e>=1?t=n=NaN:n<=0&&(t=NaN),new q(t,n,e,r)}function le(t){if(t instanceof q)return new q(t.h,t.s,t.l,t.opacity);if(t instanceof Ct||(t=rt(t)),!t)return new q;if(t instanceof q)return t;t=t.rgb();var n=t.r/255,e=t.g/255,r=t.b/255,i=Math.min(n,e,r),o=Math.max(n,e,r),a=NaN,u=o-i,c=(o+i)/2;return u?(n===o?a=(e-r)/u+(e<r)*6:e===o?a=(r-n)/u+2:a=(n-e)/u+4,u/=c<.5?o+i:2-o-i,a*=60):u=c>0&&c<1?0:a,new q(a,u,c,t.opacity)}function fo(t,n,e,r){return arguments.length===1?le(t):new q(t,n,e,r??1)}function q(t,n,e,r){this.h=+t,this.s=+n,this.l=+e,this.opacity=+r}mn(q,fo,re(Ct,{brighter(t){return t=t==null?Wt:Math.pow(Wt,t),new q(this.h,this.s,this.l*t,this.opacity)},darker(t){return t=t==null?bt:Math.pow(bt,t),new q(this.h,this.s,this.l*t,this.opacity)},rgb(){var t=this.h%360+(this.h<0)*360,n=isNaN(t)||isNaN(this.s)?0:this.s,e=this.l,r=e+(e<.5?e:1-e)*n,i=2*e-r;return new Y(yn(t>=240?t-240:t+120,i,r),yn(t,i,r),yn(t<120?t+240:t-120,i,r),this.opacity)},clamp(){return new q(he(this.h),qt(this.s),qt(this.l),Xt(this.opacity))},displayable(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1},formatHsl(){const t=Xt(this.opacity);return`${t===1?"hsl(":"hsla("}${he(this.h)}, ${qt(this.s)*100}%, ${qt(this.l)*100}%${t===1?")":`, ${t})`}`}}));function he(t){return t=(t||0)%360,t<0?t+360:t}function qt(t){return Math.max(0,Math.min(1,t||0))}function yn(t,n,e){return(t<60?n+(e-n)*t/60:t<180?e:t<240?n+(e-n)*(240-t)/60:n)*255}var wn=t=>()=>t;function lo(t,n){return function(e){return t+e*n}}function ho(t,n,e){return t=Math.pow(t,e),n=Math.pow(n,e)-t,e=1/e,function(r){return Math.pow(t+r*n,e)}}function go(t){return(t=+t)==1?ge:function(n,e){return e-n?ho(n,e,t):wn(isNaN(n)?e:n)}}function ge(t,n){var e=n-t;return e?lo(t,e):wn(isNaN(t)?n:t)}var Vt=(function t(n){var e=go(n);function r(i,o){var a=e((i=pn(i)).r,(o=pn(o)).r),u=e(i.g,o.g),c=e(i.b,o.b),s=ge(i.opacity,o.opacity);return function(f){return i.r=a(f),i.g=u(f),i.b=c(f),i.opacity=s(f),i+""}}return r.gamma=t,r})(1);function mo(t,n){n||(n=[]);var e=t?Math.min(n.length,t.length):0,r=n.slice(),i;return function(o){for(i=0;i<e;++i)r[i]=t[i]*(1-o)+n[i]*o;return r}}function po(t){return ArrayBuffer.isView(t)&&!(t instanceof DataView)}function yo(t,n){var e=n?n.length:0,r=t?Math.min(e,t.length):0,i=new Array(r),o=new Array(e),a;for(a=0;a<r;++a)i[a]=_n(t[a],n[a]);for(;a<e;++a)o[a]=n[a];return function(u){for(a=0;a<r;++a)o[a]=i[a](u);return o}}function wo(t,n){var e=new Date;return t=+t,n=+n,function(r){return e.setTime(t*(1-r)+n*r),e}}function V(t,n){return t=+t,n=+n,function(e){return t*(1-e)+n*e}}function vo(t,n){var e={},r={},i;(t===null||typeof t!="object")&&(t={}),(n===null||typeof n!="object")&&(n={});for(i in n)i in t?e[i]=_n(t[i],n[i]):r[i]=n[i];return function(o){for(i in e)r[i]=e[i](o);return r}}var vn=/[-+]?(?:\\d+\\.?\\d*|\\.?\\d+)(?:[eE][-+]?\\d+)?/g,xn=new RegExp(vn.source,"g");function xo(t){return function(){return t}}function _o(t){return function(n){return t(n)+""}}function de(t,n){var e=vn.lastIndex=xn.lastIndex=0,r,i,o,a=-1,u=[],c=[];for(t=t+"",n=n+"";(r=vn.exec(t))&&(i=xn.exec(n));)(o=i.index)>e&&(o=n.slice(e,o),u[a]?u[a]+=o:u[++a]=o),(r=r[0])===(i=i[0])?u[a]?u[a]+=i:u[++a]=i:(u[++a]=null,c.push({i:a,x:V(r,i)})),e=xn.lastIndex;return e<n.length&&(o=n.slice(e),u[a]?u[a]+=o:u[++a]=o),u.length<2?c[0]?_o(c[0].x):xo(n):(n=c.length,function(s){for(var f=0,l;f<n;++f)u[(l=c[f]).i]=l.x(s);return u.join("")})}function _n(t,n){var e=typeof n,r;return n==null||e==="boolean"?wn(n):(e==="number"?V:e==="string"?(r=rt(n))?(n=r,Vt):de:n instanceof rt?Vt:n instanceof Date?wo:po(n)?mo:Array.isArray(n)?yo:typeof n.valueOf!="function"&&typeof n.toString!="function"||isNaN(n)?vo:V)(t,n)}function Mo(t,n){return t=+t,n=+n,function(e){return Math.round(t*(1-e)+n*e)}}var me=180/Math.PI,Mn={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1};function pe(t,n,e,r,i,o){var a,u,c;return(a=Math.sqrt(t*t+n*n))&&(t/=a,n/=a),(c=t*e+n*r)&&(e-=t*c,r-=n*c),(u=Math.sqrt(e*e+r*r))&&(e/=u,r/=u,c/=u),t*r<n*e&&(t=-t,n=-n,c=-c,a=-a),{translateX:i,translateY:o,rotate:Math.atan2(n,t)*me,skewX:Math.atan(c)*me,scaleX:a,scaleY:u}}var Bt;function To(t){const n=new(typeof DOMMatrix=="function"?DOMMatrix:WebKitCSSMatrix)(t+"");return n.isIdentity?Mn:pe(n.a,n.b,n.c,n.d,n.e,n.f)}function No(t){return t==null||(Bt||(Bt=document.createElementNS("http://www.w3.org/2000/svg","g")),Bt.setAttribute("transform",t),!(t=Bt.transform.baseVal.consolidate()))?Mn:(t=t.matrix,pe(t.a,t.b,t.c,t.d,t.e,t.f))}function ye(t,n,e,r){function i(s){return s.length?s.pop()+" ":""}function o(s,f,l,h,p,x){if(s!==l||f!==h){var b=p.push("translate(",null,n,null,e);x.push({i:b-4,x:V(s,l)},{i:b-2,x:V(f,h)})}else(l||h)&&p.push("translate("+l+n+h+e)}function a(s,f,l,h){s!==f?(s-f>180?f+=360:f-s>180&&(s+=360),h.push({i:l.push(i(l)+"rotate(",null,r)-2,x:V(s,f)})):f&&l.push(i(l)+"rotate("+f+r)}function u(s,f,l,h){s!==f?h.push({i:l.push(i(l)+"skewX(",null,r)-2,x:V(s,f)}):f&&l.push(i(l)+"skewX("+f+r)}function c(s,f,l,h,p,x){if(s!==l||f!==h){var b=p.push(i(p)+"scale(",null,",",null,")");x.push({i:b-4,x:V(s,l)},{i:b-2,x:V(f,h)})}else(l!==1||h!==1)&&p.push(i(p)+"scale("+l+","+h+")")}return function(s,f){var l=[],h=[];return s=t(s),f=t(f),o(s.translateX,s.translateY,f.translateX,f.translateY,l,h),a(s.rotate,f.rotate,l,h),u(s.skewX,f.skewX,l,h),c(s.scaleX,s.scaleY,f.scaleX,f.scaleY,l,h),s=f=null,function(p){for(var x=-1,b=h.length,U;++x<b;)l[(U=h[x]).i]=U.x(p);return l.join("")}}}var Co=ye(To,"px, ","px)","deg)"),bo=ye(No,", ",")",")"),gt=0,Dt=0,kt=0,we=1e3,Zt,At,Gt=0,at=0,Qt=0,Ut=typeof performance=="object"&&performance.now?performance:Date,ve=typeof window=="object"&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};function Tn(){return at||(ve(So),at=Ut.now()+Qt)}function So(){at=0}function Jt(){this._call=this._time=this._next=null}Jt.prototype=xe.prototype={constructor:Jt,restart:function(t,n,e){if(typeof t!="function")throw new TypeError("callback is not a function");e=(e==null?Tn():+e)+(n==null?0:+n),!this._next&&At!==this&&(At?At._next=this:Zt=this,At=this),this._call=t,this._time=e,Nn()},stop:function(){this._call&&(this._call=null,this._time=1/0,Nn())}};function xe(t,n,e){var r=new Jt;return r.restart(t,n,e),r}function Do(){Tn(),++gt;for(var t=Zt,n;t;)(n=at-t._time)>=0&&t._call.call(void 0,n),t=t._next;--gt}function _e(){at=(Gt=Ut.now())+Qt,gt=Dt=0;try{Do()}finally{gt=0,Ao(),at=0}}function ko(){var t=Ut.now(),n=t-Gt;n>we&&(Qt-=n,Gt=t)}function Ao(){for(var t,n=Zt,e,r=1/0;n;)n._call?(r>n._time&&(r=n._time),t=n,n=n._next):(e=n._next,n._next=null,n=t?t._next=e:Zt=e);At=t,Nn(r)}function Nn(t){if(!gt){Dt&&(Dt=clearTimeout(Dt));var n=t-at;n>24?(t<1/0&&(Dt=setTimeout(_e,t-Ut.now()-Qt)),kt&&(kt=clearInterval(kt))):(kt||(Gt=Ut.now(),kt=setInterval(ko,we)),gt=1,ve(_e))}}function Me(t,n,e){var r=new Jt;return n=n==null?0:+n,r.restart(i=>{r.stop(),t(i+n)},n,e),r}var Uo=zn("start","end","cancel","interrupt"),Fo=[],Te=0,Ne=1,Cn=2,Kt=3,Ce=4,bn=5,jt=6;function tn(t,n,e,r,i,o){var a=t.__transition;if(!a)t.__transition={};else if(e in a)return;$o(t,e,{name:n,index:r,group:i,on:Uo,tween:Fo,time:o.time,delay:o.delay,duration:o.duration,ease:o.ease,timer:null,state:Te})}function Sn(t,n){var e=B(t,n);if(e.state>Te)throw new Error("too late; already scheduled");return e}function Q(t,n){var e=B(t,n);if(e.state>Kt)throw new Error("too late; already running");return e}function B(t,n){var e=t.__transition;if(!e||!(e=e[n]))throw new Error("transition not found");return e}function $o(t,n,e){var r=t.__transition,i;r[n]=e,e.timer=xe(o,0,e.time);function o(s){e.state=Ne,e.timer.restart(a,e.delay,e.time),e.delay<=s&&a(s-e.delay)}function a(s){var f,l,h,p;if(e.state!==Ne)return c();for(f in r)if(p=r[f],p.name===e.name){if(p.state===Kt)return Me(a);p.state===Ce?(p.state=jt,p.timer.stop(),p.on.call("interrupt",t,t.__data__,p.index,p.group),delete r[f]):+f<n&&(p.state=jt,p.timer.stop(),p.on.call("cancel",t,t.__data__,p.index,p.group),delete r[f])}if(Me(function(){e.state===Kt&&(e.state=Ce,e.timer.restart(u,e.delay,e.time),u(s))}),e.state=Cn,e.on.call("start",t,t.__data__,e.index,e.group),e.state===Cn){for(e.state=Kt,i=new Array(h=e.tween.length),f=0,l=-1;f<h;++f)(p=e.tween[f].value.call(t,t.__data__,e.index,e.group))&&(i[++l]=p);i.length=l+1}}function u(s){for(var f=s<e.duration?e.ease.call(null,s/e.duration):(e.timer.restart(c),e.state=bn,1),l=-1,h=i.length;++l<h;)i[l].call(t,f);e.state===bn&&(e.on.call("end",t,t.__data__,e.index,e.group),c())}function c(){e.state=jt,e.timer.stop(),delete r[n];for(var s in r)return;delete t.__transition}}function Lo(t,n){var e=t.__transition,r,i,o=!0,a;if(e){n=n==null?null:n+"";for(a in e){if((r=e[a]).name!==n){o=!1;continue}i=r.state>Cn&&r.state<bn,r.state=jt,r.timer.stop(),r.on.call(i?"interrupt":"cancel",t,t.__data__,r.index,r.group),delete e[a]}o&&delete t.__transition}}function Po(t){return this.each(function(){Lo(this,t)})}function Eo(t,n){var e,r;return function(){var i=Q(this,t),o=i.tween;if(o!==e){r=e=o;for(var a=0,u=r.length;a<u;++a)if(r[a].name===n){r=r.slice(),r.splice(a,1);break}}i.tween=r}}function Ho(t,n,e){var r,i;if(typeof e!="function")throw new Error;return function(){var o=Q(this,t),a=o.tween;if(a!==r){i=(r=a).slice();for(var u={name:n,value:e},c=0,s=i.length;c<s;++c)if(i[c].name===n){i[c]=u;break}c===s&&i.push(u)}o.tween=i}}function Yo(t,n){var e=this._id;if(t+="",arguments.length<2){for(var r=B(this.node(),e).tween,i=0,o=r.length,a;i<o;++i)if((a=r[i]).name===t)return a.value;return null}return this.each((n==null?Eo:Ho)(e,t,n))}function Dn(t,n,e){var r=t._id;return t.each(function(){var i=Q(this,r);(i.value||(i.value={}))[n]=e.apply(this,arguments)}),function(i){return B(i,r).value[n]}}function be(t,n){var e;return(typeof n=="number"?V:n instanceof rt?Vt:(e=rt(n))?(n=e,Vt):de)(t,n)}function Ro(t){return function(){this.removeAttribute(t)}}function Io(t){return function(){this.removeAttributeNS(t.space,t.local)}}function Oo(t,n,e){var r,i=e+"",o;return function(){var a=this.getAttribute(t);return a===i?null:a===r?o:o=n(r=a,e)}}function Wo(t,n,e){var r,i=e+"",o;return function(){var a=this.getAttributeNS(t.space,t.local);return a===i?null:a===r?o:o=n(r=a,e)}}function zo(t,n,e){var r,i,o;return function(){var a,u=e(this),c;return u==null?void this.removeAttribute(t):(a=this.getAttribute(t),c=u+"",a===c?null:a===r&&c===i?o:(i=c,o=n(r=a,u)))}}function Xo(t,n,e){var r,i,o;return function(){var a,u=e(this),c;return u==null?void this.removeAttributeNS(t.space,t.local):(a=this.getAttributeNS(t.space,t.local),c=u+"",a===c?null:a===r&&c===i?o:(i=c,o=n(r=a,u)))}}function qo(t,n){var e=It(t),r=e==="transform"?bo:be;return this.attrTween(t,typeof n=="function"?(e.local?Xo:zo)(e,r,Dn(this,"attr."+t,n)):n==null?(e.local?Io:Ro)(e):(e.local?Wo:Oo)(e,r,n))}function Vo(t,n){return function(e){this.setAttribute(t,n.call(this,e))}}function Bo(t,n){return function(e){this.setAttributeNS(t.space,t.local,n.call(this,e))}}function Zo(t,n){var e,r;function i(){var o=n.apply(this,arguments);return o!==r&&(e=(r=o)&&Bo(t,o)),e}return i._value=n,i}function Go(t,n){var e,r;function i(){var o=n.apply(this,arguments);return o!==r&&(e=(r=o)&&Vo(t,o)),e}return i._value=n,i}function Qo(t,n){var e="attr."+t;if(arguments.length<2)return(e=this.tween(e))&&e._value;if(n==null)return this.tween(e,null);if(typeof n!="function")throw new Error;var r=It(t);return this.tween(e,(r.local?Zo:Go)(r,n))}function Jo(t,n){return function(){Sn(this,t).delay=+n.apply(this,arguments)}}function Ko(t,n){return n=+n,function(){Sn(this,t).delay=n}}function jo(t){var n=this._id;return arguments.length?this.each((typeof t=="function"?Jo:Ko)(n,t)):B(this.node(),n).delay}function ta(t,n){return function(){Q(this,t).duration=+n.apply(this,arguments)}}function na(t,n){return n=+n,function(){Q(this,t).duration=n}}function ea(t){var n=this._id;return arguments.length?this.each((typeof t=="function"?ta:na)(n,t)):B(this.node(),n).duration}function ra(t,n){if(typeof n!="function")throw new Error;return function(){Q(this,t).ease=n}}function ia(t){var n=this._id;return arguments.length?this.each(ra(n,t)):B(this.node(),n).ease}function oa(t,n){return function(){var e=n.apply(this,arguments);if(typeof e!="function")throw new Error;Q(this,t).ease=e}}function aa(t){if(typeof t!="function")throw new Error;return this.each(oa(this._id,t))}function ua(t){typeof t!="function"&&(t=Zn(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var o=n[i],a=o.length,u=r[i]=[],c,s=0;s<a;++s)(c=o[s])&&t.call(c,c.__data__,s,o)&&u.push(c);return new J(r,this._parents,this._name,this._id)}function sa(t){if(t._id!==this._id)throw new Error;for(var n=this._groups,e=t._groups,r=n.length,i=e.length,o=Math.min(r,i),a=new Array(r),u=0;u<o;++u)for(var c=n[u],s=e[u],f=c.length,l=a[u]=new Array(f),h,p=0;p<f;++p)(h=c[p]||s[p])&&(l[p]=h);for(;u<r;++u)a[u]=n[u];return new J(a,this._parents,this._name,this._id)}function ca(t){return(t+"").trim().split(/^|\\s+/).every(function(n){var e=n.indexOf(".");return e>=0&&(n=n.slice(0,e)),!n||n==="start"})}function fa(t,n,e){var r,i,o=ca(n)?Sn:Q;return function(){var a=o(this,t),u=a.on;u!==r&&(i=(r=u).copy()).on(n,e),a.on=i}}function la(t,n){var e=this._id;return arguments.length<2?B(this.node(),e).on.on(t):this.each(fa(e,t,n))}function ha(t){return function(){var n=this.parentNode;for(var e in this.__transition)if(+e!==t)return;n&&n.removeChild(this)}}function ga(){return this.on("end.remove",ha(this._id))}function da(t){var n=this._name,e=this._id;typeof t!="function"&&(t=gn(t));for(var r=this._groups,i=r.length,o=new Array(i),a=0;a<i;++a)for(var u=r[a],c=u.length,s=o[a]=new Array(c),f,l,h=0;h<c;++h)(f=u[h])&&(l=t.call(f,f.__data__,h,u))&&("__data__"in f&&(l.__data__=f.__data__),s[h]=l,tn(s[h],n,e,h,s,B(f,e)));return new J(o,this._parents,n,e)}function ma(t){var n=this._name,e=this._id;typeof t!="function"&&(t=Bn(t));for(var r=this._groups,i=r.length,o=[],a=[],u=0;u<i;++u)for(var c=r[u],s=c.length,f,l=0;l<s;++l)if(f=c[l]){for(var h=t.call(f,f.__data__,l,c),p,x=B(f,e),b=0,U=h.length;b<U;++b)(p=h[b])&&tn(p,n,e,b,h,x);o.push(h),a.push(f)}return new J(o,a,n,e)}var pa=Nt.prototype.constructor;function ya(){return new pa(this._groups,this._parents)}function wa(t,n){var e,r,i;return function(){var o=lt(this,t),a=(this.style.removeProperty(t),lt(this,t));return o===a?null:o===e&&a===r?i:i=n(e=o,r=a)}}function Se(t){return function(){this.style.removeProperty(t)}}function va(t,n,e){var r,i=e+"",o;return function(){var a=lt(this,t);return a===i?null:a===r?o:o=n(r=a,e)}}function xa(t,n,e){var r,i,o;return function(){var a=lt(this,t),u=e(this),c=u+"";return u==null&&(c=u=(this.style.removeProperty(t),lt(this,t))),a===c?null:a===r&&c===i?o:(i=c,o=n(r=a,u))}}function _a(t,n){var e,r,i,o="style."+n,a="end."+o,u;return function(){var c=Q(this,t),s=c.on,f=c.value[o]==null?u||(u=Se(n)):void 0;(s!==e||i!==f)&&(r=(e=s).copy()).on(a,i=f),c.on=r}}function Ma(t,n,e){var r=(t+="")=="transform"?Co:be;return n==null?this.styleTween(t,wa(t,r)).on("end.style."+t,Se(t)):typeof n=="function"?this.styleTween(t,xa(t,r,Dn(this,"style."+t,n))).each(_a(this._id,t)):this.styleTween(t,va(t,r,n),e).on("end.style."+t,null)}function Ta(t,n,e){return function(r){this.style.setProperty(t,n.call(this,r),e)}}function Na(t,n,e){var r,i;function o(){var a=n.apply(this,arguments);return a!==i&&(r=(i=a)&&Ta(t,a,e)),r}return o._value=n,o}function Ca(t,n,e){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(n==null)return this.tween(r,null);if(typeof n!="function")throw new Error;return this.tween(r,Na(t,n,e??""))}function ba(t){return function(){this.textContent=t}}function Sa(t){return function(){var n=t(this);this.textContent=n??""}}function Da(t){return this.tween("text",typeof t=="function"?Sa(Dn(this,"text",t)):ba(t==null?"":t+""))}function ka(t){return function(n){this.textContent=t.call(this,n)}}function Aa(t){var n,e;function r(){var i=t.apply(this,arguments);return i!==e&&(n=(e=i)&&ka(i)),n}return r._value=t,r}function Ua(t){var n="text";if(arguments.length<1)return(n=this.tween(n))&&n._value;if(t==null)return this.tween(n,null);if(typeof t!="function")throw new Error;return this.tween(n,Aa(t))}function Fa(){for(var t=this._name,n=this._id,e=De(),r=this._groups,i=r.length,o=0;o<i;++o)for(var a=r[o],u=a.length,c,s=0;s<u;++s)if(c=a[s]){var f=B(c,n);tn(c,t,e,s,a,{time:f.time+f.delay+f.duration,delay:0,duration:f.duration,ease:f.ease})}return new J(r,this._parents,t,e)}function $a(){var t,n,e=this,r=e._id,i=e.size();return new Promise(function(o,a){var u={value:a},c={value:function(){--i===0&&o()}};e.each(function(){var s=Q(this,r),f=s.on;f!==t&&(n=(t=f).copy(),n._.cancel.push(u),n._.interrupt.push(u),n._.end.push(c)),s.on=n}),i===0&&o()})}var La=0;function J(t,n,e,r){this._groups=t,this._parents=n,this._name=e,this._id=r}function De(){return++La}var K=Nt.prototype;J.prototype={constructor:J,select:da,selectAll:ma,selectChild:K.selectChild,selectChildren:K.selectChildren,filter:ua,merge:sa,selection:ya,transition:Fa,call:K.call,nodes:K.nodes,node:K.node,size:K.size,empty:K.empty,each:K.each,on:la,attr:qo,attrTween:Qo,style:Ma,styleTween:Ca,text:Da,textTween:Ua,remove:ga,tween:Yo,delay:jo,duration:ea,ease:ia,easeVarying:aa,end:$a,[Symbol.iterator]:K[Symbol.iterator]};function Pa(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}var Ea={time:null,delay:0,duration:250,ease:Pa};function Ha(t,n){for(var e;!(e=t.__transition)||!(e=e[n]);)if(!(t=t.parentNode))throw new Error(`transition ${n} not found`);return e}function Ya(t){var n,e;t instanceof J?(n=t._id,t=t._name):(n=De(),(e=Ea).time=Tn(),t=t==null?null:t+"");for(var r=this._groups,i=r.length,o=0;o<i;++o)for(var a=r[o],u=a.length,c,s=0;s<u;++s)(c=a[s])&&tn(c,t,n,s,a,e||Ha(c,n));return new J(r,this._parents,t,n)}Nt.prototype.interrupt=Po,Nt.prototype.transition=Ya;function Ra(t){return Math.abs(t=Math.round(t))>=1e21?t.toLocaleString("en").replace(/,/g,""):t.toString(10)}function nn(t,n){if((e=(t=n?t.toExponential(n-1):t.toExponential()).indexOf("e"))<0)return null;var e,r=t.slice(0,e);return[r.length>1?r[0]+r.slice(2):r,+t.slice(e+1)]}function dt(t){return t=nn(Math.abs(t)),t?t[1]:NaN}function Ia(t,n){return function(e,r){for(var i=e.length,o=[],a=0,u=t[0],c=0;i>0&&u>0&&(c+u+1>r&&(u=Math.max(1,r-c)),o.push(e.substring(i-=u,i+u)),!((c+=u+1)>r));)u=t[a=(a+1)%t.length];return o.reverse().join(n)}}function Oa(t){return function(n){return n.replace(/[0-9]/g,function(e){return t[+e]})}}var Wa=/^(?:(.)?([<>=^]))?([+\\-( ])?([$#])?(0)?(\\d+)?(,)?(\\.\\d+)?(~)?([a-z%])?$/i;function en(t){if(!(n=Wa.exec(t)))throw new Error("invalid format: "+t);var n;return new kn({fill:n[1],align:n[2],sign:n[3],symbol:n[4],zero:n[5],width:n[6],comma:n[7],precision:n[8]&&n[8].slice(1),trim:n[9],type:n[10]})}en.prototype=kn.prototype;function kn(t){this.fill=t.fill===void 0?" ":t.fill+"",this.align=t.align===void 0?">":t.align+"",this.sign=t.sign===void 0?"-":t.sign+"",this.symbol=t.symbol===void 0?"":t.symbol+"",this.zero=!!t.zero,this.width=t.width===void 0?void 0:+t.width,this.comma=!!t.comma,this.precision=t.precision===void 0?void 0:+t.precision,this.trim=!!t.trim,this.type=t.type===void 0?"":t.type+""}kn.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(this.width===void 0?"":Math.max(1,this.width|0))+(this.comma?",":"")+(this.precision===void 0?"":"."+Math.max(0,this.precision|0))+(this.trim?"~":"")+this.type};function za(t){t:for(var n=t.length,e=1,r=-1,i;e<n;++e)switch(t[e]){case".":r=i=e;break;case"0":r===0&&(r=e),i=e;break;default:if(!+t[e])break t;r>0&&(r=0);break}return r>0?t.slice(0,r)+t.slice(i+1):t}var ke;function Xa(t,n){var e=nn(t,n);if(!e)return t+"";var r=e[0],i=e[1],o=i-(ke=Math.max(-8,Math.min(8,Math.floor(i/3)))*3)+1,a=r.length;return o===a?r:o>a?r+new Array(o-a+1).join("0"):o>0?r.slice(0,o)+"."+r.slice(o):"0."+new Array(1-o).join("0")+nn(t,Math.max(0,n+o-1))[0]}function Ae(t,n){var e=nn(t,n);if(!e)return t+"";var r=e[0],i=e[1];return i<0?"0."+new Array(-i).join("0")+r:r.length>i+1?r.slice(0,i+1)+"."+r.slice(i+1):r+new Array(i-r.length+2).join("0")}var Ue={"%":(t,n)=>(t*100).toFixed(n),b:t=>Math.round(t).toString(2),c:t=>t+"",d:Ra,e:(t,n)=>t.toExponential(n),f:(t,n)=>t.toFixed(n),g:(t,n)=>t.toPrecision(n),o:t=>Math.round(t).toString(8),p:(t,n)=>Ae(t*100,n),r:Ae,s:Xa,X:t=>Math.round(t).toString(16).toUpperCase(),x:t=>Math.round(t).toString(16)};function Fe(t){return t}var $e=Array.prototype.map,Le=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];function qa(t){var n=t.grouping===void 0||t.thousands===void 0?Fe:Ia($e.call(t.grouping,Number),t.thousands+""),e=t.currency===void 0?"":t.currency[0]+"",r=t.currency===void 0?"":t.currency[1]+"",i=t.decimal===void 0?".":t.decimal+"",o=t.numerals===void 0?Fe:Oa($e.call(t.numerals,String)),a=t.percent===void 0?"%":t.percent+"",u=t.minus===void 0?"−":t.minus+"",c=t.nan===void 0?"NaN":t.nan+"";function s(l){l=en(l);var h=l.fill,p=l.align,x=l.sign,b=l.symbol,U=l.zero,I=l.width,E=l.comma,k=l.precision,H=l.trim,m=l.type;m==="n"?(E=!0,m="g"):Ue[m]||(k===void 0&&(k=12),H=!0,m="g"),(U||h==="0"&&p==="=")&&(U=!0,h="0",p="=");var g=b==="$"?e:b==="#"&&/[boxX]/.test(m)?"0"+m.toLowerCase():"",v=b==="$"?r:/[%p]/.test(m)?a:"",_=Ue[m],A=/[defgprs%]/.test(m);k=k===void 0?6:/[gprs]/.test(m)?Math.max(1,Math.min(21,k)):Math.max(0,Math.min(20,k));function N(w){var S=g,F=v,$,xt,_t;if(m==="c")F=_(w)+F,w="";else{w=+w;var Mt=w<0||1/w<0;if(w=isNaN(w)?c:_(Math.abs(w),k),H&&(w=za(w)),Mt&&+w==0&&x!=="+"&&(Mt=!1),S=(Mt?x==="("?x:u:x==="-"||x==="("?"":x)+S,F=(m==="s"?Le[8+ke/3]:"")+F+(Mt&&x==="("?")":""),A){for($=-1,xt=w.length;++$<xt;)if(_t=w.charCodeAt($),48>_t||_t>57){F=(_t===46?i+w.slice($+1):w.slice($))+F,w=w.slice(0,$);break}}}E&&!U&&(w=n(w,1/0));var Tt=S.length+w.length+F.length,Z=Tt<I?new Array(I-Tt+1).join(h):"";switch(E&&U&&(w=n(Z+w,Z.length?I-F.length:1/0),Z=""),p){case"<":w=S+w+F+Z;break;case"=":w=S+Z+w+F;break;case"^":w=Z.slice(0,Tt=Z.length>>1)+S+w+F+Z.slice(Tt);break;default:w=Z+S+w+F;break}return o(w)}return N.toString=function(){return l+""},N}function f(l,h){var p=s((l=en(l),l.type="f",l)),x=Math.max(-8,Math.min(8,Math.floor(dt(h)/3)))*3,b=Math.pow(10,-x),U=Le[8+x/3];return function(I){return p(b*I)+U}}return{format:s,formatPrefix:f}}var rn,Pe,Ee;Va({thousands:",",grouping:[3],currency:["$",""]});function Va(t){return rn=qa(t),Pe=rn.format,Ee=rn.formatPrefix,rn}function Ba(t){return Math.max(0,-dt(Math.abs(t)))}function Za(t,n){return Math.max(0,Math.max(-8,Math.min(8,Math.floor(dt(n)/3)))*3-dt(Math.abs(t)))}function Ga(t,n){return t=Math.abs(t),n=Math.abs(n)-t,Math.max(0,dt(n)-dt(t))+1}function He(t,n){switch(arguments.length){case 0:break;case 1:this.range(t);break;default:this.range(n).domain(t);break}return this}function Qa(t){return function(){return t}}function Ja(t){return+t}var Ye=[0,1];function mt(t){return t}function An(t,n){return(n-=t=+t)?function(e){return(e-t)/n}:Qa(isNaN(n)?NaN:.5)}function Ka(t,n){var e;return t>n&&(e=t,t=n,n=e),function(r){return Math.max(t,Math.min(n,r))}}function ja(t,n,e){var r=t[0],i=t[1],o=n[0],a=n[1];return i<r?(r=An(i,r),o=e(a,o)):(r=An(r,i),o=e(o,a)),function(u){return o(r(u))}}function tu(t,n,e){var r=Math.min(t.length,n.length)-1,i=new Array(r),o=new Array(r),a=-1;for(t[r]<t[0]&&(t=t.slice().reverse(),n=n.slice().reverse());++a<r;)i[a]=An(t[a],t[a+1]),o[a]=e(n[a],n[a+1]);return function(u){var c=hr(t,u,1,r)-1;return o[c](i[c](u))}}function Re(t,n){return n.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown())}function nu(){var t=Ye,n=Ye,e=_n,r,i,o,a=mt,u,c,s;function f(){var h=Math.min(t.length,n.length);return a!==mt&&(a=Ka(t[0],t[h-1])),u=h>2?tu:ja,c=s=null,l}function l(h){return h==null||isNaN(h=+h)?o:(c||(c=u(t.map(r),n,e)))(r(a(h)))}return l.invert=function(h){return a(i((s||(s=u(n,t.map(r),V)))(h)))},l.domain=function(h){return arguments.length?(t=Array.from(h,Ja),f()):t.slice()},l.range=function(h){return arguments.length?(n=Array.from(h),f()):n.slice()},l.rangeRound=function(h){return n=Array.from(h),e=Mo,f()},l.clamp=function(h){return arguments.length?(a=h?!0:mt,f()):a!==mt},l.interpolate=function(h){return arguments.length?(e=h,f()):e},l.unknown=function(h){return arguments.length?(o=h,l):o},function(h,p){return r=h,i=p,f()}}function Ie(){return nu()(mt,mt)}function eu(t,n,e,r){var i=ln(t,n,e),o;switch(r=en(r??",f"),r.type){case"s":{var a=Math.max(Math.abs(t),Math.abs(n));return r.precision==null&&!isNaN(o=Za(i,a))&&(r.precision=o),Ee(r,a)}case"":case"e":case"g":case"p":case"r":{r.precision==null&&!isNaN(o=Ga(i,Math.max(Math.abs(t),Math.abs(n))))&&(r.precision=o-(r.type==="e"));break}case"f":case"%":{r.precision==null&&!isNaN(o=Ba(i))&&(r.precision=o-(r.type==="%")*2);break}}return Pe(r)}function ru(t){var n=t.domain;return t.ticks=function(e){var r=n();return pr(r[0],r[r.length-1],e??10)},t.tickFormat=function(e,r){var i=n();return eu(i[0],i[i.length-1],e??10,r)},t.nice=function(e){e==null&&(e=10);var r=n(),i=0,o=r.length-1,a=r[i],u=r[o],c,s,f=10;for(u<a&&(s=a,a=u,u=s,s=i,i=o,o=s);f-- >0;){if(s=fn(a,u,e),s===c)return r[i]=a,r[o]=u,n(r);if(s>0)a=Math.floor(a/s)*s,u=Math.ceil(u/s)*s;else if(s<0)a=Math.ceil(a*s)/s,u=Math.floor(u*s)/s;else break;c=s}return t},t}function Oe(){var t=Ie();return t.copy=function(){return Re(t,Oe())},He.apply(t,arguments),ru(t)}function iu(t,n){t=t.slice();var e=0,r=t.length-1,i=t[e],o=t[r],a;return o<i&&(a=e,e=r,r=a,a=i,i=o,o=a),t[e]=n.floor(i),t[r]=n.ceil(o),t}const Un=new Date,Fn=new Date;function L(t,n,e,r){function i(o){return t(o=arguments.length===0?new Date:new Date(+o)),o}return i.floor=o=>(t(o=new Date(+o)),o),i.ceil=o=>(t(o=new Date(o-1)),n(o,1),t(o),o),i.round=o=>{const a=i(o),u=i.ceil(o);return o-a<u-o?a:u},i.offset=(o,a)=>(n(o=new Date(+o),a==null?1:Math.floor(a)),o),i.range=(o,a,u)=>{const c=[];if(o=i.ceil(o),u=u==null?1:Math.floor(u),!(o<a)||!(u>0))return c;let s;do c.push(s=new Date(+o)),n(o,u),t(o);while(s<o&&o<a);return c},i.filter=o=>L(a=>{if(a>=a)for(;t(a),!o(a);)a.setTime(a-1)},(a,u)=>{if(a>=a)if(u<0)for(;++u<=0;)for(;n(a,-1),!o(a););else for(;--u>=0;)for(;n(a,1),!o(a););}),e&&(i.count=(o,a)=>(Un.setTime(+o),Fn.setTime(+a),t(Un),t(Fn),Math.floor(e(Un,Fn))),i.every=o=>(o=Math.floor(o),!isFinite(o)||!(o>0)?null:o>1?i.filter(r?a=>r(a)%o===0:a=>i.count(0,a)%o===0):i)),i}const on=L(()=>{},(t,n)=>{t.setTime(+t+n)},(t,n)=>n-t);on.every=t=>(t=Math.floor(t),!isFinite(t)||!(t>0)?null:t>1?L(n=>{n.setTime(Math.floor(n/t)*t)},(n,e)=>{n.setTime(+n+e*t)},(n,e)=>(e-n)/t):on),on.range;const j=1e3,z=j*60,tt=z*60,nt=tt*24,$n=nt*7,We=nt*30,Ln=nt*365,pt=L(t=>{t.setTime(t-t.getMilliseconds())},(t,n)=>{t.setTime(+t+n*j)},(t,n)=>(n-t)/j,t=>t.getUTCSeconds());pt.range;const Pn=L(t=>{t.setTime(t-t.getMilliseconds()-t.getSeconds()*j)},(t,n)=>{t.setTime(+t+n*z)},(t,n)=>(n-t)/z,t=>t.getMinutes());Pn.range,L(t=>{t.setUTCSeconds(0,0)},(t,n)=>{t.setTime(+t+n*z)},(t,n)=>(n-t)/z,t=>t.getUTCMinutes()).range;const En=L(t=>{t.setTime(t-t.getMilliseconds()-t.getSeconds()*j-t.getMinutes()*z)},(t,n)=>{t.setTime(+t+n*tt)},(t,n)=>(n-t)/tt,t=>t.getHours());En.range,L(t=>{t.setUTCMinutes(0,0,0)},(t,n)=>{t.setTime(+t+n*tt)},(t,n)=>(n-t)/tt,t=>t.getUTCHours()).range;const Ft=L(t=>t.setHours(0,0,0,0),(t,n)=>t.setDate(t.getDate()+n),(t,n)=>(n-t-(n.getTimezoneOffset()-t.getTimezoneOffset())*z)/nt,t=>t.getDate()-1);Ft.range;const Hn=L(t=>{t.setUTCHours(0,0,0,0)},(t,n)=>{t.setUTCDate(t.getUTCDate()+n)},(t,n)=>(n-t)/nt,t=>t.getUTCDate()-1);Hn.range,L(t=>{t.setUTCHours(0,0,0,0)},(t,n)=>{t.setUTCDate(t.getUTCDate()+n)},(t,n)=>(n-t)/nt,t=>Math.floor(t/nt)).range;function ut(t){return L(n=>{n.setDate(n.getDate()-(n.getDay()+7-t)%7),n.setHours(0,0,0,0)},(n,e)=>{n.setDate(n.getDate()+e*7)},(n,e)=>(e-n-(e.getTimezoneOffset()-n.getTimezoneOffset())*z)/$n)}const an=ut(0),un=ut(1),ou=ut(2),au=ut(3),yt=ut(4),uu=ut(5),su=ut(6);an.range,un.range,ou.range,au.range,yt.range,uu.range,su.range;function st(t){return L(n=>{n.setUTCDate(n.getUTCDate()-(n.getUTCDay()+7-t)%7),n.setUTCHours(0,0,0,0)},(n,e)=>{n.setUTCDate(n.getUTCDate()+e*7)},(n,e)=>(e-n)/$n)}const ze=st(0),sn=st(1),cu=st(2),fu=st(3),wt=st(4),lu=st(5),hu=st(6);ze.range,sn.range,cu.range,fu.range,wt.range,lu.range,hu.range;const Yn=L(t=>{t.setDate(1),t.setHours(0,0,0,0)},(t,n)=>{t.setMonth(t.getMonth()+n)},(t,n)=>n.getMonth()-t.getMonth()+(n.getFullYear()-t.getFullYear())*12,t=>t.getMonth());Yn.range,L(t=>{t.setUTCDate(1),t.setUTCHours(0,0,0,0)},(t,n)=>{t.setUTCMonth(t.getUTCMonth()+n)},(t,n)=>n.getUTCMonth()-t.getUTCMonth()+(n.getUTCFullYear()-t.getUTCFullYear())*12,t=>t.getUTCMonth()).range;const et=L(t=>{t.setMonth(0,1),t.setHours(0,0,0,0)},(t,n)=>{t.setFullYear(t.getFullYear()+n)},(t,n)=>n.getFullYear()-t.getFullYear(),t=>t.getFullYear());et.every=t=>!isFinite(t=Math.floor(t))||!(t>0)?null:L(n=>{n.setFullYear(Math.floor(n.getFullYear()/t)*t),n.setMonth(0,1),n.setHours(0,0,0,0)},(n,e)=>{n.setFullYear(n.getFullYear()+e*t)}),et.range;const ct=L(t=>{t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)},(t,n)=>{t.setUTCFullYear(t.getUTCFullYear()+n)},(t,n)=>n.getUTCFullYear()-t.getUTCFullYear(),t=>t.getUTCFullYear());ct.every=t=>!isFinite(t=Math.floor(t))||!(t>0)?null:L(n=>{n.setUTCFullYear(Math.floor(n.getUTCFullYear()/t)*t),n.setUTCMonth(0,1),n.setUTCHours(0,0,0,0)},(n,e)=>{n.setUTCFullYear(n.getUTCFullYear()+e*t)}),ct.range;function gu(t,n,e,r,i,o){const a=[[pt,1,j],[pt,5,5*j],[pt,15,15*j],[pt,30,30*j],[o,1,z],[o,5,5*z],[o,15,15*z],[o,30,30*z],[i,1,tt],[i,3,3*tt],[i,6,6*tt],[i,12,12*tt],[r,1,nt],[r,2,2*nt],[e,1,$n],[n,1,We],[n,3,3*We],[t,1,Ln]];function u(s,f,l){const h=f<s;h&&([s,f]=[f,s]);const p=l&&typeof l.range=="function"?l:c(s,f,l),x=p?p.range(s,+f+1):[];return h?x.reverse():x}function c(s,f,l){const h=Math.abs(f-s)/l,p=cn(([,,U])=>U).right(a,h);if(p===a.length)return t.every(ln(s/Ln,f/Ln,l));if(p===0)return on.every(Math.max(ln(s,f,l),1));const[x,b]=a[h/a[p-1][2]<a[p][2]/h?p-1:p];return x.every(b)}return[u,c]}const[du,mu]=gu(et,Yn,an,Ft,En,Pn);function Rn(t){if(0<=t.y&&t.y<100){var n=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return n.setFullYear(t.y),n}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function In(t){if(0<=t.y&&t.y<100){var n=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return n.setUTCFullYear(t.y),n}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function $t(t,n,e){return{y:t,m:n,d:e,H:0,M:0,S:0,L:0}}function pu(t){var n=t.dateTime,e=t.date,r=t.time,i=t.periods,o=t.days,a=t.shortDays,u=t.months,c=t.shortMonths,s=Lt(i),f=Pt(i),l=Lt(o),h=Pt(o),p=Lt(a),x=Pt(a),b=Lt(u),U=Pt(u),I=Lt(c),E=Pt(c),k={a:Mt,A:Tt,b:Z,B:Ps,c:null,d:Ge,e:Ge,f:Ru,g:Gu,G:Ju,H:Eu,I:Hu,j:Yu,L:Qe,m:Iu,M:Ou,p:Es,q:Hs,Q:er,s:rr,S:Wu,u:zu,U:Xu,V:qu,w:Vu,W:Bu,x:null,X:null,y:Zu,Y:Qu,Z:Ku,"%":nr},H={a:Ys,A:Rs,b:Is,B:Os,c:null,d:Ke,e:Ke,f:es,g:hs,G:ds,H:ju,I:ts,j:ns,L:je,m:rs,M:is,p:Ws,q:zs,Q:er,s:rr,S:os,u:as,U:us,V:ss,w:cs,W:fs,x:null,X:null,y:ls,Y:gs,Z:ms,"%":nr},m={a:N,A:w,b:S,B:F,c:$,d:Be,e:Be,f:Fu,g:Ve,G:qe,H:Ze,I:Ze,j:Du,L:Uu,m:Su,M:ku,p:A,q:bu,Q:Lu,s:Pu,S:Au,u:_u,U:Mu,V:Tu,w:xu,W:Nu,x:xt,X:_t,y:Ve,Y:qe,Z:Cu,"%":$u};k.x=g(e,k),k.X=g(r,k),k.c=g(n,k),H.x=g(e,H),H.X=g(r,H),H.c=g(n,H);function g(y,M){return function(C){var d=[],R=-1,D=0,O=y.length,W,ft,ur;for(C instanceof Date||(C=new Date(+C));++R<O;)y.charCodeAt(R)===37&&(d.push(y.slice(D,R)),(ft=Xe[W=y.charAt(++R)])!=null?W=y.charAt(++R):ft=W==="e"?" ":"0",(ur=M[W])&&(W=ur(C,ft)),d.push(W),D=R+1);return d.push(y.slice(D,R)),d.join("")}}function v(y,M){return function(C){var d=$t(1900,void 0,1),R=_(d,y,C+="",0),D,O;if(R!=C.length)return null;if("Q"in d)return new Date(d.Q);if("s"in d)return new Date(d.s*1e3+("L"in d?d.L:0));if(M&&!("Z"in d)&&(d.Z=0),"p"in d&&(d.H=d.H%12+d.p*12),d.m===void 0&&(d.m="q"in d?d.q:0),"V"in d){if(d.V<1||d.V>53)return null;"w"in d||(d.w=1),"Z"in d?(D=In($t(d.y,0,1)),O=D.getUTCDay(),D=O>4||O===0?sn.ceil(D):sn(D),D=Hn.offset(D,(d.V-1)*7),d.y=D.getUTCFullYear(),d.m=D.getUTCMonth(),d.d=D.getUTCDate()+(d.w+6)%7):(D=Rn($t(d.y,0,1)),O=D.getDay(),D=O>4||O===0?un.ceil(D):un(D),D=Ft.offset(D,(d.V-1)*7),d.y=D.getFullYear(),d.m=D.getMonth(),d.d=D.getDate()+(d.w+6)%7)}else("W"in d||"U"in d)&&("w"in d||(d.w="u"in d?d.u%7:"W"in d?1:0),O="Z"in d?In($t(d.y,0,1)).getUTCDay():Rn($t(d.y,0,1)).getDay(),d.m=0,d.d="W"in d?(d.w+6)%7+d.W*7-(O+5)%7:d.w+d.U*7-(O+6)%7);return"Z"in d?(d.H+=d.Z/100|0,d.M+=d.Z%100,In(d)):Rn(d)}}function _(y,M,C,d){for(var R=0,D=M.length,O=C.length,W,ft;R<D;){if(d>=O)return-1;if(W=M.charCodeAt(R++),W===37){if(W=M.charAt(R++),ft=m[W in Xe?M.charAt(R++):W],!ft||(d=ft(y,C,d))<0)return-1}else if(W!=C.charCodeAt(d++))return-1}return d}function A(y,M,C){var d=s.exec(M.slice(C));return d?(y.p=f.get(d[0].toLowerCase()),C+d[0].length):-1}function N(y,M,C){var d=p.exec(M.slice(C));return d?(y.w=x.get(d[0].toLowerCase()),C+d[0].length):-1}function w(y,M,C){var d=l.exec(M.slice(C));return d?(y.w=h.get(d[0].toLowerCase()),C+d[0].length):-1}function S(y,M,C){var d=I.exec(M.slice(C));return d?(y.m=E.get(d[0].toLowerCase()),C+d[0].length):-1}function F(y,M,C){var d=b.exec(M.slice(C));return d?(y.m=U.get(d[0].toLowerCase()),C+d[0].length):-1}function $(y,M,C){return _(y,n,M,C)}function xt(y,M,C){return _(y,e,M,C)}function _t(y,M,C){return _(y,r,M,C)}function Mt(y){return a[y.getDay()]}function Tt(y){return o[y.getDay()]}function Z(y){return c[y.getMonth()]}function Ps(y){return u[y.getMonth()]}function Es(y){return i[+(y.getHours()>=12)]}function Hs(y){return 1+~~(y.getMonth()/3)}function Ys(y){return a[y.getUTCDay()]}function Rs(y){return o[y.getUTCDay()]}function Is(y){return c[y.getUTCMonth()]}function Os(y){return u[y.getUTCMonth()]}function Ws(y){return i[+(y.getUTCHours()>=12)]}function zs(y){return 1+~~(y.getUTCMonth()/3)}return{format:function(y){var M=g(y+="",k);return M.toString=function(){return y},M},parse:function(y){var M=v(y+="",!1);return M.toString=function(){return y},M},utcFormat:function(y){var M=g(y+="",H);return M.toString=function(){return y},M},utcParse:function(y){var M=v(y+="",!0);return M.toString=function(){return y},M}}}var Xe={"-":"",_:" ",0:"0"},P=/^\\s*\\d+/,yu=/^%/,wu=/[\\\\^$*+?|[\\]().{}]/g;function T(t,n,e){var r=t<0?"-":"",i=(r?-t:t)+"",o=i.length;return r+(o<e?new Array(e-o+1).join(n)+i:i)}function vu(t){return t.replace(wu,"\\\\$&")}function Lt(t){return new RegExp("^(?:"+t.map(vu).join("|")+")","i")}function Pt(t){return new Map(t.map((n,e)=>[n.toLowerCase(),e]))}function xu(t,n,e){var r=P.exec(n.slice(e,e+1));return r?(t.w=+r[0],e+r[0].length):-1}function _u(t,n,e){var r=P.exec(n.slice(e,e+1));return r?(t.u=+r[0],e+r[0].length):-1}function Mu(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.U=+r[0],e+r[0].length):-1}function Tu(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.V=+r[0],e+r[0].length):-1}function Nu(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.W=+r[0],e+r[0].length):-1}function qe(t,n,e){var r=P.exec(n.slice(e,e+4));return r?(t.y=+r[0],e+r[0].length):-1}function Ve(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),e+r[0].length):-1}function Cu(t,n,e){var r=/^(Z)|([+-]\\d\\d)(?::?(\\d\\d))?/.exec(n.slice(e,e+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),e+r[0].length):-1}function bu(t,n,e){var r=P.exec(n.slice(e,e+1));return r?(t.q=r[0]*3-3,e+r[0].length):-1}function Su(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.m=r[0]-1,e+r[0].length):-1}function Be(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.d=+r[0],e+r[0].length):-1}function Du(t,n,e){var r=P.exec(n.slice(e,e+3));return r?(t.m=0,t.d=+r[0],e+r[0].length):-1}function Ze(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.H=+r[0],e+r[0].length):-1}function ku(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.M=+r[0],e+r[0].length):-1}function Au(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.S=+r[0],e+r[0].length):-1}function Uu(t,n,e){var r=P.exec(n.slice(e,e+3));return r?(t.L=+r[0],e+r[0].length):-1}function Fu(t,n,e){var r=P.exec(n.slice(e,e+6));return r?(t.L=Math.floor(r[0]/1e3),e+r[0].length):-1}function $u(t,n,e){var r=yu.exec(n.slice(e,e+1));return r?e+r[0].length:-1}function Lu(t,n,e){var r=P.exec(n.slice(e));return r?(t.Q=+r[0],e+r[0].length):-1}function Pu(t,n,e){var r=P.exec(n.slice(e));return r?(t.s=+r[0],e+r[0].length):-1}function Ge(t,n){return T(t.getDate(),n,2)}function Eu(t,n){return T(t.getHours(),n,2)}function Hu(t,n){return T(t.getHours()%12||12,n,2)}function Yu(t,n){return T(1+Ft.count(et(t),t),n,3)}function Qe(t,n){return T(t.getMilliseconds(),n,3)}function Ru(t,n){return Qe(t,n)+"000"}function Iu(t,n){return T(t.getMonth()+1,n,2)}function Ou(t,n){return T(t.getMinutes(),n,2)}function Wu(t,n){return T(t.getSeconds(),n,2)}function zu(t){var n=t.getDay();return n===0?7:n}function Xu(t,n){return T(an.count(et(t)-1,t),n,2)}function Je(t){var n=t.getDay();return n>=4||n===0?yt(t):yt.ceil(t)}function qu(t,n){return t=Je(t),T(yt.count(et(t),t)+(et(t).getDay()===4),n,2)}function Vu(t){return t.getDay()}function Bu(t,n){return T(un.count(et(t)-1,t),n,2)}function Zu(t,n){return T(t.getFullYear()%100,n,2)}function Gu(t,n){return t=Je(t),T(t.getFullYear()%100,n,2)}function Qu(t,n){return T(t.getFullYear()%1e4,n,4)}function Ju(t,n){var e=t.getDay();return t=e>=4||e===0?yt(t):yt.ceil(t),T(t.getFullYear()%1e4,n,4)}function Ku(t){var n=t.getTimezoneOffset();return(n>0?"-":(n*=-1,"+"))+T(n/60|0,"0",2)+T(n%60,"0",2)}function Ke(t,n){return T(t.getUTCDate(),n,2)}function ju(t,n){return T(t.getUTCHours(),n,2)}function ts(t,n){return T(t.getUTCHours()%12||12,n,2)}function ns(t,n){return T(1+Hn.count(ct(t),t),n,3)}function je(t,n){return T(t.getUTCMilliseconds(),n,3)}function es(t,n){return je(t,n)+"000"}function rs(t,n){return T(t.getUTCMonth()+1,n,2)}function is(t,n){return T(t.getUTCMinutes(),n,2)}function os(t,n){return T(t.getUTCSeconds(),n,2)}function as(t){var n=t.getUTCDay();return n===0?7:n}function us(t,n){return T(ze.count(ct(t)-1,t),n,2)}function tr(t){var n=t.getUTCDay();return n>=4||n===0?wt(t):wt.ceil(t)}function ss(t,n){return t=tr(t),T(wt.count(ct(t),t)+(ct(t).getUTCDay()===4),n,2)}function cs(t){return t.getUTCDay()}function fs(t,n){return T(sn.count(ct(t)-1,t),n,2)}function ls(t,n){return T(t.getUTCFullYear()%100,n,2)}function hs(t,n){return t=tr(t),T(t.getUTCFullYear()%100,n,2)}function gs(t,n){return T(t.getUTCFullYear()%1e4,n,4)}function ds(t,n){var e=t.getUTCDay();return t=e>=4||e===0?wt(t):wt.ceil(t),T(t.getUTCFullYear()%1e4,n,4)}function ms(){return"+0000"}function nr(){return"%"}function er(t){return+t}function rr(t){return Math.floor(+t/1e3)}var vt,ir;ps({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]});function ps(t){return vt=pu(t),ir=vt.format,vt.parse,vt.utcFormat,vt.utcParse,vt}function ys(t){return new Date(t)}function ws(t){return t instanceof Date?+t:+new Date(+t)}function or(t,n,e,r,i,o,a,u,c,s){var f=Ie(),l=f.invert,h=f.domain,p=s(".%L"),x=s(":%S"),b=s("%I:%M"),U=s("%I %p"),I=s("%a %d"),E=s("%b %d"),k=s("%B"),H=s("%Y");function m(g){return(c(g)<g?p:u(g)<g?x:a(g)<g?b:o(g)<g?U:r(g)<g?i(g)<g?I:E:e(g)<g?k:H)(g)}return f.invert=function(g){return new Date(l(g))},f.domain=function(g){return arguments.length?h(Array.from(g,ws)):h().map(ys)},f.ticks=function(g){var v=h();return t(v[0],v[v.length-1],g??10)},f.tickFormat=function(g,v){return v==null?m:s(v)},f.nice=function(g){var v=h();return(!g||typeof g.range!="function")&&(g=n(v[0],v[v.length-1],g??10)),g?h(iu(v,g)):f},f.copy=function(){return Re(f,or(t,n,e,r,i,o,a,u,c,s))},f}function vs(){return He.apply(or(du,mu,et,Yn,an,Ft,En,Pn,pt,ir).domain([new Date(2e3,0,1),new Date(2e3,0,2)]),arguments)}function Et(t,n,e){this.k=t,this.x=n,this.y=e}Et.prototype={constructor:Et,scale:function(t){return t===1?this:new Et(this.k*t,this.x,this.y)},translate:function(t,n){return t===0&n===0?this:new Et(this.k,this.x+this.k*t,this.y+this.k*n)},apply:function(t){return[t[0]*this.k+this.x,t[1]*this.k+this.y]},applyX:function(t){return t*this.k+this.x},applyY:function(t){return t*this.k+this.y},invert:function(t){return[(t[0]-this.x)/this.k,(t[1]-this.y)/this.k]},invertX:function(t){return(t-this.x)/this.k},invertY:function(t){return(t-this.y)/this.k},rescaleX:function(t){return t.copy().domain(t.range().map(this.invertX,this).map(t.invert,t))},rescaleY:function(t){return t.copy().domain(t.range().map(this.invertY,this).map(t.invert,t))},toString:function(){return"translate("+this.x+","+this.y+") scale("+this.k+")"}},Et.prototype;function On(t){return t.mode==="temporal"||t.mode==="left-aligned"?xs(t):_s(t)}function xs({domain:t,range:n}){return vs().domain(t).range(n)}function _s({domain:t,range:n}){return Oe().domain(t).range(n)}function Ms({root_node_ids:t,nodes:n}){try{return Ts(t,n)}catch(e){return console.error(e),ar(t,n)}}function Ts(t,n){const e=new Map,r=[];for(const i of t){e.set(i,0);const o=n.get(i);for(const{id:a}of o.children)r.push(a)}return Wn(r,n,e)}function Wn(t,n,e){for(const r of t){if(e.has(r))continue;const i=n.get(r);if(!i)throw new Error("Node id not found in nodes");const o=[];for(const c of i.parents){const s=e.get(c.id);if(s!==void 0){o.push(s);continue}Wn([c.id],n,e);const f=e.get(c.id);if(f===void 0)throw new Error("Could not determine parent column");o.push(f)}const a=Math.max(...o);e.set(r,a+1);const u=i.children.map(({id:c})=>c);u.length&&Wn(u,n,e)}return e}function ar(t,n,e=0,r=new Map){for(const i of t){const o=r.get(i);(!o||o<e)&&r.set(i,e);const a=n.get(i);for(const{id:u}of a.children)ar([u],n,e+1,r)}return r}function Ns(t){return t.horizontalSettings.mode==="dependency"?Cs(t):t.horizontalSettings.mode==="left-aligned"?Ss(t):bs(t)}function Cs({data:t,horizontalSettings:n}){const e=Ms(t),r=On(n),i=new Map;for(const[o]of t.nodes){const a=e.get(o);if(a===void 0){console.warn(`Node not found in columns: Skipping ${o}`);continue}i.set(o,{x:r(a),column:a})}return i}function bs({data:t,horizontalSettings:n}){const e=On(n),r=new Map;for(const[i,o]of t.nodes){const a=e(o.start_time);r.set(i,{column:a,x:a})}return r}function Ss({data:t,horizontalSettings:n}){const e=On(n),r=new Map;for(const[i]of t.nodes)r.set(i,{column:0,x:e(t.start_time)});return r}async function Ds(t,n){const i=new Map,o=new Map;let a=0;const u=new Map;for await(const[m]of t.data.nodes){const g=t.data.nodes.get(m);if(!g){console.warn("NearestParentLayout: Node was not found in the data",m);continue}const v=await c(g);k(m,v)}return H(),u;async function c(m){const{x:g}=n.get(m.id)??{};if(g===void 0)return console.warn("NearestParentLayout: Node was not found in the horizontal layout",m.id),0;if(m.parents.length===1)return u.has(m.parents[0].id)?await f(m.parents[0].id,g):(console.warn("NearestParentLayout: Parent node not found in layout",m.parents[0].id),0);if(m.parents.length>0){const v=m.parents.map(({id:w})=>{const S=u.get(w);return S===void 0?(console.warn("NearestParentLayout: Parent node not found in layout",w),0):S}),A=v.reduce((w,S)=>w+S,0)/v.length,N=Math.round(A);if(l(g,N)){const w=x(g,N),S=m.parents.map(({id:$})=>$),F=w.filter($=>S.includes($));if(F.length>0||w.length>1){const[$]=F.length>0?F:w,xt=b(v,N,i.get($));return i.set($,xt),await f($,g)}return await U({competingNodeId:w[0],upstreamRows:v,nodeStartX:g,desiredRow:N})}}return s(g,0)}function s(m,g){return l(m,g)?s(m,g+1):g}async function f(m,g){const v=u.get(m);if(v===void 0)return console.warn("NearestParentLayout: Upstream node not found in layout",m),0;i.get(m)||i.set(m,1);const _=i.get(m);return l(g,v)?_===1&&!l(g,v+1)?(i.set(m,-1),v+1):l(g,v-1)?(await h({direction:_,nodeStartX:g,desiredRow:v+_}),i.set(m,_===1?-1:1),v+_):(i.set(m,1),v-1):v}function l(m,g){if(u.size===0)return!1;let v=!1;const _=o.get(g)??[];for(const A of _){const N=u.get(A),w=E(A);if(p({firstNodeEndX:w,firstNodeRow:N,lastNodeStartX:m,lastNodeRow:g})){v=!0;break}}return v}async function h({direction:m,nodeStartX:g,desiredRow:v}){const _=x(g,v);if(_)for await(const A of _){const N=u.get(A),{x:w}=n.get(A)??{};if(N===void 0||w===void 0){console.warn("NearestParentLayout - shove: Node was not found in the vertical or horizontal layout",A);continue}const S=N+m;await h({direction:m,nodeStartX:w,desiredRow:S}),k(A,S)}}function p({firstNodeEndX:m,firstNodeRow:g,lastNodeStartX:v,lastNodeRow:_}){return g===_&&m+16>=v}function x(m,g){const v=[],_=o.get(g)??[];for(const A of _){const N=E(A),w=u.get(A);if(w===void 0){console.warn("NearestParentLayout - getOverlappingNodeIds: Node was not found in the layout",A);continue}p({firstNodeEndX:N,firstNodeRow:w,lastNodeStartX:m,lastNodeRow:g})&&v.push(A)}if(v.length!==0)return v.sort((A,N)=>{const w=E(A),S=E(N);return w<S?1:w>S?-1:0}),v}function b(m,g,v){const _=m.filter(N=>N<g).length,A=m.filter(N=>N>g).length;return _>A?-1:v??1}async function U({desiredRow:m,nodeStartX:g,upstreamRows:v,competingNodeId:_}){if(u.get(_)===void 0)return console.warn("NearestParentLayout - argueWithCompetingUpstreamPlacement: Competitor node was not found in the layout",_),m;const[N,w]=I(_),S=v.filter($=>$<m).length,F=v.filter($=>$>m).length;if(S>F){if(N>w&&N>S)return await h({direction:-1,nodeStartX:g,desiredRow:m}),m;if(w>N)return await h({direction:1,nodeStartX:g,desiredRow:m}),m;i.set(_,-1)}if(F>S){if(w>N&&w>F)return await h({direction:1,nodeStartX:g,desiredRow:m}),m;if(N>w)return await h({direction:-1,nodeStartX:g,desiredRow:m}),m;i.set(_,1)}return await f(_,g)}function I(m){const g=t.data.nodes.get(m),v=u.get(m);return!g||v===void 0?(console.warn("NearestParentLayout: Node was not found in either the data or layout",m),[0,0]):g.parents.reduce((_,A)=>{const N=u.get(A.id);return N===void 0?(console.warn("NearestParentLayout - getNodeParentDirectionCounts: Parent node not found on layout data",m),_):(N<v&&(_[0]+=1),N>v&&(_[1]+=1),_)},[0,0])}function E(m){const{x:g}=n.get(m)??{},v=t.widths.get(m);return g===void 0||v===void 0?(console.warn("NearestParentLayout: Node was not found in the horizontal layout and/or widths",m),0):g+v}function k(m,g){if(g<a&&(a=g),u.has(m)){const v=u.get(m);o.get(v)?.delete(m)}o.has(g)||o.set(g,new Set),o.get(g)?.add(m),u.set(m,g)}function H(){if(a<0)for(const[m]of u){const g=u.get(m);u.set(m,g+Math.abs(a))}}}async function ks(t,n){return t.verticalSettings.mode==="nearest-parent"?await Ds(t,n):t.verticalSettings.mode==="duration-sorted"?Us(t):As(t)}function As(t){const n=new Map;let e=0;for(const[r]of t.data.nodes)n.set(r,e++);return n}function Us(t){const n=new Map,e=[...t.data.nodes.values()].sort((i,o)=>{const a=(i.end_time?i.end_time.getTime():new Date().getTime())-i.start_time.getTime();return(o.end_time?o.end_time.getTime():new Date().getTime())-o.start_time.getTime()-a});let r=0;for(const i of e)n.set(i.id,r++);return n}onmessage=Fs;function Fs({data:t}){const{type:n}=t;if(n==="layout"){Ls(t);return}else sr(n)}function $s(t){postMessage(t)}async function Ls(t){const{data:n}=t,e=Ns(t),r=await ks(t,e),i=new Map;let o=0,a=0;for(const[u,c]of n.nodes){const s=e.get(u),f=r.get(u);if(s===void 0){console.warn(`NodeId not found in horizontal layout: Skipping ${c.label}`);continue}if(f===void 0){console.warn(`NodeId not found in vertical layout: Skipping ${c.label}`);continue}o=Math.max(o,f),a=Math.max(a,s.column),i.set(u,{...s,y:f,row:f})}$s({type:"layout",layout:{maxRow:o,maxColumn:a,positions:i}})}})();\n//# sourceMappingURL=runGraph.worker-ChmCiswU.js.map\n', wg = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", Tv], { type: "text/javascript;charset=utf-8" });
function PR(n) {
  let t;
  try {
    if (t = wg && (self.URL || self.webkitURL).createObjectURL(wg), !t) throw "";
    const e = new Worker(t, {
      name: n?.name
    });
    return e.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(t);
    }), e;
  } catch {
    return new Worker(
      "data:text/javascript;charset=utf-8," + encodeURIComponent(Tv),
      {
        name: n?.name
      }
    );
  }
}
function RR(n) {
  const t = new PR();
  return t.onmessage = n, t;
}
async function Kd() {
  const n = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), r = new bt(), i = new bt(), s = await Wt();
  let o = null;
  const a = xg({
    gap: () => s.rowGap,
    minimum: () => s.nodeHeight
  }), h = xg({
    gap: () => s.columnGap,
    minimum: () => Dd()
  });
  let l = null, u = null;
  r.name = Sg, it.on("layoutUpdated", () => {
    a.clear(), h.clear();
  }), it.on("layoutSettingsUpdated", () => {
    u && r.parent && c(u), j();
  }), it.on("itemSelected", () => {
    j();
  });
  async function c(P) {
    d(), u = P, l = null, await Promise.all([
      p(P),
      g(P)
    ]), w(P);
  }
  function d() {
    o || (o = RR(R));
  }
  function f() {
    o && (o.terminate(), o = null);
  }
  async function p(P) {
    const N = [];
    for (const B of P.nodes.values())
      N.push(m(B));
    await Promise.all(N);
  }
  async function m(P) {
    const { render: N } = await x(P), B = y(P.id);
    return await N(P, B);
  }
  async function g(P) {
    if ((await Kt()).disableEdges) {
      r.removeChild(i);
      return;
    }
    r.addChildAt(i, 0);
    const B = [];
    for (const [X, { children: V }] of P.nodes)
      for (const { id: J } of V)
        B.push(_(X, J));
    await Promise.all(B);
  }
  async function _(P, N) {
    const B = `${P}_${N}`;
    if (e.has(B))
      return;
    const X = await _S();
    e.has(B) || (e.set(B, X), i.addChild(X.element));
  }
  function w(P) {
    if (!o)
      throw new Error("Layout worker not initialized");
    const N = /* @__PURE__ */ new Map();
    for (const [B, { element: X }] of t)
      N.set(B, X.width);
    o.postMessage({
      type: "layout",
      data: P,
      widths: N,
      horizontalSettings: Jc(P.start_time),
      verticalSettings: yR()
    });
  }
  function v() {
    if (l)
      for (const [P, N] of e) {
        const [B, X] = P.split("_"), V = l.positions.get(B), J = l.positions.get(X), tt = t.get(B);
        if (!V || !J) {
          console.warn(`Could not find edge in layout: Skipping ${P}`);
          continue;
        }
        if (!tt) {
          console.warn(`Could not find parent node in nodes: Skipping ${B}`);
          continue;
        }
        const K = tt.bar.width, G = C(V), W = {
          x: G.x + K,
          y: G.y + s.nodeHeight / 2
        }, q = C(J), z = {
          x: q.x - W.x,
          y: q.y - W.y + s.nodeHeight / 2
        };
        N.setPosition(W, z);
      }
  }
  function E() {
    if (l) {
      for (const [P, N] of t) {
        const B = l.positions.get(P);
        if (!B) {
          console.warn(`Could not find node in layout: Skipping ${P}`);
          continue;
        }
        const X = C(B);
        N.setPosition(X), a.updateNodeAxis({ nodeId: P, axis: B.y }), h.updateNodeAxis({ nodeId: P, axis: B.column });
      }
      v(), r.emit("rendered"), r.emit("resized", O());
    }
  }
  async function x(P) {
    const N = n.get(P.id);
    if (N)
      return N;
    const B = y(P.id), X = MR(P, B);
    n.set(P.id, X);
    const V = await X;
    return V.element.on("resized", (J) => b(P.id, J)), r.addChild(V.element), t.set(P.id, V), V;
  }
  function b(P, N) {
    if (!l)
      return;
    const B = t.get(P), X = l.positions.get(P);
    !B || !X || (a.setOffset({ nodeId: P, axis: X.y, offset: N.height }), h.setOffset({ nodeId: P, axis: X.column, offset: N.width }), E());
  }
  function y(P) {
    return u?.nested_task_run_graphs?.get(P);
  }
  function C(P) {
    const N = a.getTotalOffset(P.y);
    return {
      x: M(P),
      y: N
    };
  }
  function M(P) {
    return ut.isDependency() ? h.getTotalOffset(P.column) : P.x;
  }
  function U() {
    return l ? a.getTotalValue(l.maxRow) : 0;
  }
  function F() {
    if (!l || !u)
      return 0;
    if (ut.isDependency())
      return h.getTotalValue(l.maxColumn);
    const P = Jc(u.start_time), N = yv(P), B = N(u.end_time ?? /* @__PURE__ */ new Date()), X = N(u.start_time);
    return B - X;
  }
  function O() {
    return {
      width: F(),
      height: U()
    };
  }
  function R({ data: P }) {
    const { type: N } = P;
    if (N === "layout") {
      k(P);
      return;
    } else
      IR(N);
  }
  function k(P) {
    l = P.layout, E();
  }
  async function j() {
    const P = await Kt(), N = jS();
    if (P.disableEdges || !N || !u?.nodes.has(N.id)) {
      T([]);
      return;
    }
    const B = L(N.id);
    T(B);
  }
  function T(P) {
    S(P), A(P);
  }
  function S(P) {
    for (const [N, { element: B }] of t) {
      if (P.length === 0 || P.includes(N)) {
        B.alpha = 1;
        continue;
      }
      B.alpha = s.nodeUnselectedAlpha;
    }
  }
  function A(P) {
    for (const [N, { element: B }] of e) {
      const [X, V] = N.split("_");
      if (P.length === 0 || P.includes(X) && P.includes(V)) {
        B.alpha = 1;
        continue;
      }
      B.alpha = s.nodeUnselectedAlpha;
    }
  }
  function L(P) {
    const N = D(P, "parents"), B = D(P, "children");
    return [P, ...N, ...B];
  }
  function D(P, N) {
    const B = u?.nodes.get(P);
    if (!B)
      return [];
    const X = [];
    for (const { id: V } of B[N])
      X.push(V), X.push(...D(V, N));
    return X;
  }
  return {
    element: r,
    stopWorker: f,
    getSize: O,
    render: c
  };
}
let ed = null, Sn = null, Pi = null;
async function DR() {
  const n = await Jt(), t = await He(), { element: e, render: r } = await Kd();
  n.addChild(e), e.alpha = 0;
  const i = await my(t.runId, async (s) => {
    const o = Sn ? "runDataUpdated" : "runDataCreated";
    Sn = s, it.emit(o, Sn), await Kt(), r(s);
  });
  it.on("configUpdated", () => {
    Sn && r(Sn);
  }), Pi = e, ed = i.stop, Pi.once("rendered", () => OR()), it.on("layoutUpdated", () => NR()), i.start();
}
function FR() {
  ed?.(), ed = null, Pi = null, Sn = null;
}
async function zr() {
  return Sn || await Re("runDataCreated");
}
function OR() {
  Av(), xe.shared.addOnce(() => {
    Pi && (Pi.alpha = 1);
  });
}
async function NR() {
  if (!Pi)
    return;
  const n = await He();
  Pi.once("rendered", () => {
    setTimeout(() => {
      Av({ animate: !0 });
    }, n.animationDuration);
  });
}
let Te = null, rd = null;
async function kR() {
  const n = await Qt(), t = await pd();
  Te = new UA({
    screenHeight: t.clientHeight,
    screenWidth: t.clientWidth,
    events: n.renderer.events,
    passiveWheel: !1
  }), Te.zIndex = A1, Te.drag().pinch().wheel({
    trackpadPinch: !0
  }).decelerate({
    friction: 0.9
  }).clampZoom({
    minWidth: t.clientWidth / 2
  }), Te.on("moved", () => {
    it.emit("viewportMoved", null);
  }).on("moved-end", () => {
    it.emit("viewportMoved", null);
  }), n.stage.addChild(Te), it.emit("viewportCreated", Te), it.on("applicationResized", zR), it.on("scaleUpdated", () => Eo()), GR();
}
function BR() {
  Te = null, rd = null;
}
async function Av({ animate: n } = {}) {
  const e = (await Jt()).getChildByName(Sg);
  if (!e)
    throw new Error("Nodes container not found");
  XR();
  const { x: r, y: i, width: s, height: o } = e.getLocalBounds();
  if (!s || !o) {
    UR({ animate: n });
    return;
  }
  LR({ x: r, y: i, width: s, height: o, animate: n });
}
async function LR({ x: n, y: t, width: e, height: r, animate: i }) {
  const s = await He(), o = await Wt(), a = await Jt(), {
    guideTextSize: h,
    guideTextTopPadding: l,
    columnGap: u,
    rowGap: c,
    eventTargetSize: d
  } = o, f = h + l, p = e + u * 2, m = r + c * 4 + f + d, g = a.findFit(p, m);
  a.animate({
    position: {
      x: n + e / 2,
      y: t + r / 2 + f
    },
    scale: Math.min(g, 1),
    time: i ? s.animationDuration : 0,
    ease: "easeInOutQuad",
    removeOnInterrupt: !0,
    callbackOnComplete: () => {
      No(), Eo();
    }
  });
}
async function UR({ animate: n }) {
  const t = await zr(), e = await He(), r = await Wt(), i = await Jt(), s = await nr();
  let o = s(t.start_time) - r.columnGap, a = s(t.end_time ?? /* @__PURE__ */ new Date()) + r.columnGap;
  if (o > a) {
    const c = o;
    o = a, a = c;
  }
  const h = a - o, l = o + h / 2, u = i.findFit(h, 0);
  i.animate({
    position: {
      x: l,
      y: 0
    },
    scale: u,
    time: n ? e.animationDuration : 0,
    ease: "easeInOutQuad",
    removeOnInterrupt: !0,
    callbackOnComplete: () => {
      No(), Eo();
    }
  });
}
async function Jt() {
  return Te || await Re("viewportCreated");
}
function Ev(n) {
  fy(rd, n) || (rd = n, it.emit("viewportDateRangeUpdated", n));
}
function HR({ xOffset: n, yOffset: t }) {
  if (!Te)
    return;
  const { x: e, y: r } = Te.transform.position;
  Te.setTransform(
    e + n,
    r + t,
    Te.transform.scale.x,
    Te.transform.scale.y
  );
}
async function GR() {
  const n = await Jt();
  Eo(), n.on("moved", () => Eo());
}
async function Eo() {
  const n = await Sv();
  n && Ev(n);
}
async function Sv() {
  const n = await Jt(), t = await nr(), e = t.invert(n.left), r = t.invert(n.right);
  return e instanceof Date && r instanceof Date ? [e, r] : null;
}
async function _D(n) {
  const t = await Sv(), e = await Kt();
  if (n === void 0 || e.isDependency() || fy(n, t))
    return;
  const r = await Jt(), i = await nr(), [s, o] = n, a = i(s), h = i(o), l = a + (h - a) / 2;
  Ev(n), r.fitWidth(h - a, !0), r.moveCenter(l, r.center.y);
}
async function zR() {
  const n = await Qt(), t = await Jt(), e = await pd(), r = t.screenWidth, i = t.screenHeight, s = e.clientWidth, o = e.clientHeight, a = (s - r) / 2, h = (o - i) / 2;
  t.resize(n.screen.width, n.screen.height), HR({
    xOffset: a,
    yOffset: h
  });
}
class ba {
  status = "visible";
  labels = /* @__PURE__ */ new Set();
  get visible() {
    return this.status === "visible";
  }
  get hidden() {
    return this.status === "hidden";
  }
  show() {
    if (this.status !== "visible") {
      for (const t of this.labels)
        t.visible = !0;
      this.status = "visible";
    }
  }
  hide() {
    if (this.status !== "hidden") {
      for (const t of this.labels)
        t.visible = !1;
      this.status = "hidden";
    }
  }
  toggle(t) {
    t ? this.show() : this.hide();
  }
  add(t) {
    this.labels.add(t), t.visible = this.visible;
  }
  clear() {
    this.labels.clear();
  }
}
let kn = null, Fn = null, bs = null, co = null, bi = null;
async function WR() {
  const n = await Jt(), t = await Qt();
  kn = new oA({
    toggle: "renderable"
  }), Fn = new ba(), bs = new ba(), bi = new ba(), co = new ba(), t.ticker.add(() => {
    if (n.dirty) {
      const e = n.scale.x > b1, r = n.scale.x > v1, i = n.scale.x > x1, s = n.scale.x > w1;
      bi?.toggle(e), Fn?.toggle(r), bs?.toggle(i), co?.toggle(s), kn?.cull(t.renderer.screen), n.dirty = !1;
    }
  }), it.emit("cullCreated", kn), it.emit("labelCullCreated", Fn), it.emit("iconCullCreated", Fn), it.emit("edgeCullCreated", bi), it.emit("toggleCullCreated", co);
}
function $R() {
  kn = null, Fn?.clear(), Fn = null, bs?.clear(), bs = null, bi?.clear(), bi = null, co?.clear(), co = null;
}
async function No() {
  const n = await Jt();
  n.dirty = !0;
}
function XR() {
  kn && kn.uncull();
}
async function Cv() {
  return kn || await Re("cullCreated");
}
async function VR() {
  return bi || await Re("edgeCullCreated");
}
async function Mv() {
  return Fn || await Re("labelCullCreated");
}
async function Iv() {
  return bs || await Re("iconCullCreated");
}
async function YR() {
  const n = await Qt(), t = await zr(), e = await Kt(), { element: r, render: i, update: s } = await xv({ isRoot: !0 });
  r.zIndex = C1;
  function o(a) {
    if (ut.isTemporal() && !e.disableArtifacts) {
      n.stage.addChild(r), i(a?.artifacts);
      return;
    }
    n.stage.removeChild(r);
  }
  t.artifacts && o(t), it.on("viewportMoved", () => s()), it.on("runDataCreated", (a) => o(a)), it.on("runDataUpdated", (a) => o(a)), it.on("configUpdated", () => o()), it.on("layoutSettingsUpdated", () => o());
}
async function jR() {
  const n = await Qt(), t = await zr(), { element: e, render: r } = await wv({ isRoot: !0 });
  e.zIndex = S1, n.stage.addChild(e);
  function i(s) {
    r(s?.states);
  }
  t.states && i(t), it.on("runDataUpdated", (s) => i(s)), it.on("configUpdated", () => i()), it.on("layoutSettingsUpdated", () => i());
}
async function qR() {
  const n = await Qt(), t = await Jt(), e = await Kt(), r = await Wt(), i = await w_(), s = new bt(), o = await hn();
  s.addChild(o);
  const a = i("");
  s.addChild(a);
  let h = await nr(), l, u;
  it.on("scaleUpdated", (m) => {
    h = m, p();
  }), it.on("viewportMoved", () => {
    e.disableGuides || (p(), s.height !== n.screen.height && d());
  });
  function c(m, g) {
    l = m, u = g, d(), f(m);
  }
  function d() {
    o.width = r.guideLineWidth, o.height = n.screen.height, o.tint = r.guideLineColor;
  }
  function f(m) {
    a.text = u(m), a.fontSize = r.guideTextSize, a.tint = r.guideTextColor, a.position.set(r.guideTextLeftPadding, r.guideTextTopPadding);
  }
  function p() {
    l !== void 0 && (s.position.x = h(l) * t.scale._x + t.worldTransform.tx);
  }
  return {
    element: s,
    render: c
  };
}
class bg extends Error {
  constructor() {
    super("Layout is not temporal");
  }
}
function ZR(n) {
  return n.toLocaleTimeString();
}
function Tg(n) {
  const t = navigator.language;
  return new Intl.DateTimeFormat(t, { timeStyle: "short" }).format(n);
}
function KR(n) {
  const t = navigator.language;
  return new Intl.DateTimeFormat(t, { dateStyle: "short" }).format(n);
}
function QR(n) {
  return n.getHours() === 0 && n.getMinutes() === 0 ? `${Ga.date(n)}
${Tg(n)}` : Tg(n);
}
const Ga = {
  timeBySeconds: ZR,
  timeByMinutesWithDates: QR,
  date: KR
}, ee = {
  seconds: "seconds",
  minutes: "minutes",
  date: "date"
}, Xs = {
  day: (n) => {
    const t = new Date(n.getTime());
    return t.setHours(0, 0, 0, 0), t.getTime();
  },
  week: (n) => {
    const t = new Date(n.getTime());
    return t.setHours(0, 0, 0, 0), t.setDate(n.getDate() - n.getDay() + 1), t.getTime();
  }
}, Ct = {
  second: 1e3,
  minute: 1e3 * 60,
  hour: 1e3 * 60 * 60,
  day: 1e3 * 60 * 60 * 24,
  week: 1e3 * 60 * 60 * 24 * 7
}, Ag = [
  {
    ceiling: Ct.second * 4,
    increment: Ct.second,
    labelFormat: ee.seconds
  },
  {
    ceiling: Ct.second * 8,
    increment: Ct.second * 5,
    labelFormat: ee.seconds
  },
  {
    ceiling: Ct.second * 13,
    increment: Ct.second * 10,
    labelFormat: ee.seconds
  },
  {
    ceiling: Ct.second * 20,
    increment: Ct.second * 15,
    labelFormat: ee.seconds
  },
  {
    ceiling: Ct.second * 45,
    increment: Ct.second * 30,
    labelFormat: ee.seconds
  },
  {
    ceiling: Ct.minute * 4,
    increment: Ct.minute,
    labelFormat: ee.minutes
  },
  {
    ceiling: Ct.minute * 8,
    increment: Ct.minute * 5,
    labelFormat: ee.minutes
  },
  {
    ceiling: Ct.minute * 13,
    increment: Ct.minute * 10,
    labelFormat: ee.minutes
  },
  {
    ceiling: Ct.minute * 28,
    increment: Ct.minute * 15,
    labelFormat: ee.minutes
  },
  {
    ceiling: Ct.hour * 1.24,
    increment: Ct.minute * 30,
    labelFormat: ee.minutes
  },
  {
    ceiling: Ct.hour * 3,
    increment: Ct.hour,
    labelFormat: ee.minutes
  },
  {
    ceiling: Ct.hour * 8,
    increment: Ct.hour * 2,
    getAnchor: Xs.day,
    labelFormat: ee.minutes
  },
  {
    ceiling: Ct.hour * 13,
    increment: Ct.hour * 6,
    getAnchor: Xs.day,
    labelFormat: ee.minutes
  },
  {
    ceiling: Ct.hour * 22,
    increment: Ct.hour * 12,
    getAnchor: Xs.day,
    labelFormat: ee.minutes
  },
  {
    ceiling: Ct.day * 4,
    increment: Ct.day,
    getAnchor: Xs.day,
    labelFormat: ee.date
  },
  {
    ceiling: Ct.week * 2,
    increment: Ct.week,
    getAnchor: Xs.week,
    labelFormat: ee.date
  },
  {
    ceiling: 1 / 0,
    increment: Ct.week * 4,
    labelFormat: ee.date
  }
], JR = 300;
async function tD() {
  const n = await Jt(), t = await Kt(), e = new bt(), r = /* @__PURE__ */ new Map();
  let i = await nr();
  it.on("scaleUpdated", (d) => i = d), await o();
  function s() {
    if (e.visible = !t.disableGuides, !t.disableGuides)
      try {
        const { anchor: d, increment: f, labelFormat: p } = a(), m = c(d, f);
        u(m, p);
      } catch (d) {
        if (d instanceof bg)
          return;
        console.error(d);
      }
  }
  async function o() {
    const d = [];
    zc(uf, async (f) => {
      const p = qR();
      d.push(p);
      const m = await p;
      e.addChild(m.element), r.set(f, m);
    }), await Promise.all(d);
  }
  function a() {
    const d = n.left - JR, f = i.invert(d), p = i.invert(d + T1 / n.scale.x);
    if (!(f instanceof Date) || !(p instanceof Date))
      throw new bg();
    const m = p.getTime() - f.getTime(), { increment: g, getAnchor: _, labelFormat: w } = h(m);
    return {
      anchor: _(f),
      increment: g,
      labelFormat: l(w)
    };
  }
  function h(d) {
    const f = Ag.find((p) => p.ceiling > d) ?? Ag[0];
    return f.getAnchor || (f.getAnchor = (p) => Math.floor(p.getTime() / f.increment) * f.increment), f;
  }
  function l(d) {
    switch (d) {
      case ee.minutes:
        return Ga.timeByMinutesWithDates;
      case ee.date:
        return Ga.date;
      default:
        return Ga.timeBySeconds;
    }
  }
  function u(d, f) {
    const p = new Map(r.entries()), m = Array.from(p.keys()).filter((g) => !d.includes(g));
    r.clear();
    for (const g of d) {
      if (p.has(g)) {
        const w = p.get(g);
        r.set(g, w), w.render(new Date(g), f);
        continue;
      }
      const _ = p.get(m.pop() ?? -1);
      if (_ === void 0) {
        console.warn("Guides: No unused guides available to render.");
        continue;
      }
      _.render(new Date(g), f), r.set(g, _);
    }
  }
  function c(d, f) {
    return zc(uf, (p) => d + f * p);
  }
  return {
    element: e,
    render: s
  };
}
async function eD() {
  const n = await Qt(), { element: t, render: e } = await tD();
  n.stage.addChild(t), e(), it.on("viewportDateRangeUpdated", () => e()), it.on("layoutSettingsUpdated", () => e()), it.on("configUpdated", () => e());
}
const rD = 80;
async function nD() {
  const n = await Qt(), t = await Jt(), e = await Kt(), r = await Wt(), i = await hn();
  let s = await nr();
  it.on("scaleUpdated", (h) => s = h);
  function o() {
    if (!e.isTemporal()) {
      i.visible = !1;
      return;
    }
    i.width = r.playheadWidth, i.height = n.stage.height, i.tint = r.playheadColor, i.position.x = s(/* @__PURE__ */ new Date()) * t.scale.x + t.worldTransform.tx, a();
  }
  function a() {
    if (t.moving || !(i.position.x > 0 && i.position.x < n.screen.width) || !(i.position.x > n.screen.width - rD))
      return;
    const u = t.left;
    t.zoomPercent(-0.1, !0), t.left = u;
  }
  return {
    element: i,
    render: o
  };
}
async function iD() {
  const n = await Qt(), t = await zr(), { element: e, render: r } = await nD();
  t.end_time || (n.stage.addChild(e), n.ticker.add(r)), it.on("runDataUpdated", ({ end_time: i }) => {
    i && (n.ticker.remove(r), n.stage.removeChild(e));
  });
}
function vD({ stage: n, config: t }) {
  ZT(), kR(), _R(), eD(), DR(), YR(), xR(), jR(), iD(), zS(), jT(n), nA(t), oS(), WR(), uS(), VS();
}
function xD() {
  it.clear();
  try {
    KT(), BR(), vR(), qT(), FR(), wR(), sA(), aS(), $S(), $R(), cS(), YS(), tA();
  } catch (n) {
    console.error(n);
  }
}
export {
  g1 as DEFAULT_EDGE_CONTAINER_NAME,
  b1 as DEFAULT_EDGE_CULLING_THRESHOLD,
  lf as DEFAULT_EDGE_MINIMUM_BEZIER,
  Pg as DEFAULT_EDGE_POINTS,
  uf as DEFAULT_GUIDES_COUNT,
  T1 as DEFAULT_GUIDES_MIN_GAP,
  cD as DEFAULT_HORIZONTAL_SCALE,
  uD as DEFAULT_HORIZONTAL_SCALE_MULTIPLIER,
  x1 as DEFAULT_ICON_CULLING_THRESHOLD,
  v1 as DEFAULT_LABEL_CULLING_THRESHOLD,
  _1 as DEFAULT_LINEAR_COLUMN_SIZE_PIXELS,
  Dg as DEFAULT_NESTED_GRAPH_BORDER_Z_INDEX,
  Fg as DEFAULT_NESTED_GRAPH_NODES_Z_INDEX,
  Og as DEFAULT_NESTED_GRAPH_NODE_Z_INDEX,
  Sg as DEFAULT_NODES_CONTAINER_NAME,
  m1 as DEFAULT_NODE_CONTAINER_NAME,
  za as DEFAULT_NODE_LABEL_Z_INDEX,
  C1 as DEFAULT_ROOT_ARTIFACT_Z_INDEX,
  Rg as DEFAULT_ROOT_COLLISION_THROTTLE,
  E1 as DEFAULT_ROOT_EVENT_Z_INDEX,
  S1 as DEFAULT_ROOT_FLOW_STATE_Z_INDEX,
  P1 as DEFAULT_SUBFLOW_ARTIFACT_Z_INDEX,
  M1 as DEFAULT_SUBFLOW_EVENT_Z_INDEX,
  I1 as DEFAULT_SUBFLOW_STATE_Z_INDEX,
  Mg as DEFAULT_TEXTURE_RESOLUTION,
  Ig as DEFAULT_TEXT_RESOLUTION,
  Cg as DEFAULT_TIME_COLUMN_SIZE_PIXELS,
  y1 as DEFAULT_TIME_COLUMN_SPAN_SECONDS,
  w1 as DEFAULT_TOGGLE_CULLING_THRESHOLD,
  A1 as DEFAULT_VIEWPORT_Z_INDEX,
  l1 as artifactTypeIconMap,
  sD as artifactTypes,
  Av as centerViewport,
  it as emitter,
  u1 as isArtifactSelection,
  c1 as isArtifactsSelection,
  f1 as isEventSelection,
  p1 as isEventsSelection,
  lD as isHorizontalMode,
  Uu as isNodeSelection,
  oD as isRunGraphNodeType,
  d1 as isStateSelection,
  hD as isVerticalMode,
  ut as layout,
  dD as resetHorizontalScaleMultiplier,
  Eg as runGraphNodeKinds,
  dn as selectItem,
  iA as setConfig,
  gD as setDisabledArtifacts,
  mD as setDisabledEdges,
  yD as setDisabledEvents,
  fD as setHorizontalMode,
  __ as setHorizontalScaleMultiplier,
  pD as setVerticalMode,
  vD as start,
  aD as stateType,
  xD as stop,
  _D as updateViewportFromDateRange
};
//# sourceMappingURL=graphs.mjs.map
